_N_E =
(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[93],{

/***/ "/FsK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export API_AVAILABLE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_CLOSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return API_EXCLUSIVITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return API_FULL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return API_NO_FLIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return API_NO_DEPARTURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return API_NOT_BOOKABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return API_OPEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return API_SIBLING_SUMMER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return API_SIBLING_WINTER; });
var API_AVAILABLE = 'available';
var API_CLOSED = 'closed';
var API_EXCLUSIVITY = 'exclusivity';
var API_FULL = 'full';
var API_NO_FLIGHT = 'noFlight';
var API_NO_DEPARTURE = 'noDeparture';
var API_OPEN = 'open';
var API_SIBLING_SUMMER = 'siblingSummer';
var API_SIBLING_WINTER = 'siblingWinter';
var API_NOT_BOOKABLE = [API_CLOSED, API_EXCLUSIVITY, API_FULL, API_NO_DEPARTURE, API_SIBLING_SUMMER, API_SIBLING_WINTER];


/***/ }),

/***/ "04nu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_ADDITIONAL_TRANSPORTS; });
/* unused harmony export SEARCH_CRITERIA_TRANSPORTS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchAdditionalTransports; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("b0q8");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("70jX");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("rJ95");
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("NLwV");







var FETCH_ADDITIONAL_TRANSPORTS = 'FETCH_ADDITIONAL_TRANSPORTS';
var SEARCH_CRITERIA_TRANSPORTS = 'SEARCH_CRITERIA_TRANSPORTS';

function _runAdditionalTransportsQuery(_ref) {
  var proposalId = _ref.proposalId,
      appContext = _ref.appContext,
      searchCriterias = _ref.searchCriterias;
  var query = "\n    {\n      additionalTransports(proposalId : \"".concat(proposalId, "\" ").concat(searchCriterias ? ", searchCriteria: ".concat(Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_6__[/* graphqlify */ "d"])(searchCriterias)) : '', ") {\n        id\n        price {\n          ...priceDetails\n        }\n        totalDifferentialPrice {\n          ...priceDetails\n        }\n        inbound {\n          ...transportsDetails\n        }\n        outbound {\n          ...transportsDetails\n        }\n      }\n    }\n    ").concat(_utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_2__[/* transportDetailsFragment */ "q"], "\n    ").concat(Object(_utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_2__[/* getPriceDetailFragment */ "h"])(appContext.locale), "\n  ");
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].runNoCacheQuery(query, appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_4__[/* PROPOSAL_GET_ADDITIONAL_TRANSPORT */ "Nc"]
  });
}

function fetchAdditionalTransports(_ref2) {
  var proposal = _ref2.proposal,
      transportSearchCriteria = _ref2.transportSearchCriteria,
      appContext = _ref2.appContext;
  return function (dispatch) {
    dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_5__[/* default */ "b"])(FETCH_ADDITIONAL_TRANSPORTS));
    var defaultTransport = proposal.transports;
    return _runAdditionalTransportsQuery({
      proposalId: proposal.id,
      appContext: appContext,
      searchCriterias: transportSearchCriteria
    }).then(function (_ref3) {
      var additionalTransports = _ref3.additionalTransports;
      return dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_5__[/* default */ "b"])(Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_1__["resolve"])(FETCH_ADDITIONAL_TRANSPORTS), {
        additionalTransports: additionalTransports,
        selectedTransport: defaultTransport
      }));
    }, function (error) {
      dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_5__[/* default */ "b"])(Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_1__["reject"])(FETCH_ADDITIONAL_TRANSPORTS), error));
    });
  };
}



/***/ }),

/***/ "06Jt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "m", function() { return /* binding */ additionalAccommodations_action_fetchBookingMoreAccommodations; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ CLEAR_ADDITIONAL_ACCOMMODATIONS; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ FETCH_ADDITIONAL_ACCOMMODATIONS; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ GET_ALTERNATIVES_ACCOMMODATIONS_BY_COMFORT; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* binding */ TOGGLE_ACCOMMODATIONS_FILTER; });
__webpack_require__.d(__webpack_exports__, "h", function() { return /* binding */ UNSELECT_ADDITIONAL_ACCOMMODATIONS_FILTER_CATEGORY; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ CREATE_ADDITIONAL_ACCOMMODATIONS_FILTERS; });
__webpack_require__.d(__webpack_exports__, "i", function() { return /* binding */ UPDATE_ADDITIONAL_ACCOMMODATIONS_FILTERS; });
__webpack_require__.d(__webpack_exports__, "j", function() { return /* binding */ UPDATE_FILTERED_ACCOMMODATIONS_RESULTS; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* binding */ TOGGLE_EXTRA_FEATURES; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* binding */ TOGGLE_PMR_CHECKBOX; });
__webpack_require__.d(__webpack_exports__, "k", function() { return /* binding */ clearAdditionalAccommodations; });
__webpack_require__.d(__webpack_exports__, "l", function() { return /* binding */ fetchAdditionalAccommodations; });
__webpack_require__.d(__webpack_exports__, "n", function() { return /* binding */ getAlternativeFilteredAccommodations; });
__webpack_require__.d(__webpack_exports__, "o", function() { return /* binding */ toggleAdditionalAccommodationFilter; });
__webpack_require__.d(__webpack_exports__, "r", function() { return /* binding */ unselectAdditionalAccommodationsFilterCategory; });
__webpack_require__.d(__webpack_exports__, "p", function() { return /* binding */ toggleAdditionalAccommodationReducedMobilityFilter; });
__webpack_require__.d(__webpack_exports__, "q", function() { return /* binding */ togglePMRChecbox; });

// UNUSED EXPORTS: SET_FILTERED_ADDITIONAL_ACCOMMODATIONS

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("5BYb");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("QsI/");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/find.js
var find = __webpack_require__("6R5o");
var find_default = /*#__PURE__*/__webpack_require__.n(find);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("VtSi");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: /opt/webapp/node_modules/redux-optimist-promise/build/index.js
var build = __webpack_require__("b0q8");

// EXTERNAL MODULE: ./src/utils/graphql-query-helper/booking/proposal/proposalQuery.js
var proposalQuery = __webpack_require__("70jX");

// EXTERNAL MODULE: ./src/utils/proposal/proposalUtils.js
var proposalUtils = __webpack_require__("oL6k");

// EXTERNAL MODULE: ./logger/index.js
var logger = __webpack_require__("m0zD");
var logger_default = /*#__PURE__*/__webpack_require__.n(logger);

// EXTERNAL MODULE: /opt/webapp/node_modules/stringify-object/index.js
var stringify_object = __webpack_require__("pPFN");
var stringify_object_default = /*#__PURE__*/__webpack_require__.n(stringify_object);

// CONCATENATED MODULE: ./src/client/components/utils/booking/bookingAccommodationsMore.queries.js



var bookingAccommodationsMore_queries_getBookingAccommodationsSearch = function getBookingAccommodationsSearch(appContext, id, options) {
  var body = [{
    attendees: options.attendees
  }];
  return "query {\n  bookingAdditionalAccommodations(bookingId: \"".concat(id, "\", body: ").concat(stringify_object_default()(body, {
    singleQuotes: false
  }), "\n  ) {\n    totalDifferentialPrice(selectedRate: \"").concat(options.selectedRate, "\") {\n      ...priceDetails\n      currency\n    }\n    differentialPriceByNight(\n      nightsNumber: ").concat(options.duration, ", \n      selectedRate: \"").concat(options.selectedRate, "\"\n    ) {\n      formattedValue(precision: 0)\n      value\n    }\n    isUpgradableOnline\n    accommodations {\n      attendeesDistribution {\n        attendees {\n          birthdate\n          customerId\n          id\n          type\n        }\n        id\n        quantity\n      }\n      bathroomEquipments {\n        id\n        label\n      }\n      categories {\n        id\n        label\n      }\n      category\n      categoryId\n      comfortType\n      connectingRoom\n      description\n      equipments {\n        id\n        label\n      }\n      exclusiveCollection\n      floorPlans\n      id\n      label\n\n      maxCapacity\n      media {\n        photos {\n          url\n        }\n      }\n      minCapacity\n      occupancies {\n        baby_count\n      }\n      occupation\n      outsideFacilities {\n        id\n        label\n      }\n      quantity\n      reducedMobilityAccess\n      roomType\n      services {\n        id\n        label\n      }\n      strengths {\n        id\n        label\n      }\n      surface\n      view {\n        id\n        label\n      }\n    }\n    id\n    remainingStock\n  }\n}\n").concat(Object(proposalQuery["h" /* getPriceDetailFragment */])(appContext === null || appContext === void 0 ? void 0 : appContext.locale), "\n");
};
// EXTERNAL MODULE: ./src/client/store/booking/booking.selector.js
var booking_selector = __webpack_require__("uL19");

// EXTERNAL MODULE: ./src/client/store/utils/createAction.js
var createAction = __webpack_require__("rJ95");

// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// CONCATENATED MODULE: ./src/client/store/booking/additional-accommodations/additionalAccommodations.action.js
















var CLEAR_ADDITIONAL_ACCOMMODATIONS = 'CLEAR_ADDITIONAL_ACCOMMODATIONS';
var GET_ALTERNATIVES_ACCOMMODATIONS_BY_COMFORT = 'GET_ALTERNATIVES_ACCOMMODATIONS_BY_COMFORT';
var FETCH_ADDITIONAL_ACCOMMODATIONS = 'FETCH_ADDITIONAL_ACCOMMODATIONS';
var CREATE_ADDITIONAL_ACCOMMODATIONS_FILTERS = 'CREATE_ADDITIONAL_ACCOMMODATIONS_FILTERS';
var UPDATE_ADDITIONAL_ACCOMMODATIONS_FILTERS = 'UPDATE_ADDITIONAL_ACCOMMODATIONS_FILTERS';
var SET_FILTERED_ADDITIONAL_ACCOMMODATIONS = 'SET_FILTERED_ADDITIONAL_ACCOMMODATIONS';
var TOGGLE_ACCOMMODATIONS_FILTER = 'TOGGLE_ACCOMMODATIONS_FILTER';
var UNSELECT_ADDITIONAL_ACCOMMODATIONS_FILTER_CATEGORY = 'UNSELECT_ADDITIONAL_ACCOMMODATIONS_FILTER_CATEGORY';
var UPDATE_FILTERED_ACCOMMODATIONS_RESULTS = 'UPDATE_FILTERED_ACCOMMODATIONS_RESULTS';
var TOGGLE_EXTRA_FEATURES = 'TOGGLE_EXTRA_FEATURES';
var TOGGLE_PMR_CHECKBOX = 'TOGGLE_PMR_CHECKBOX';

function _getSelectedProposal(state) {
  if (!state) {
    return null;
  }

  var proposals = Object(booking_selector["t" /* getProposals */])(state) || [];
  var resort = Object(booking_selector["j" /* getCurrentResort */])(state);
  var selectedProposal = find_default()(proposals, {
    id: Object(booking_selector["v" /* getSelectedProposalId */])(state)
  }) || Object(proposalUtils["d" /* getDefaultProposal */])(proposals, resort);
  return selectedProposal;
}

function _createAdditionalAccommodationsFilters(_ref) {
  var getState = _ref.getState,
      i18n = _ref.i18n,
      product = _ref.product,
      proposal = _ref.proposal,
      shouldPreselectFilters = _ref.shouldPreselectFilters;
  return Object(createAction["b" /* default */])(CREATE_ADDITIONAL_ACCOMMODATIONS_FILTERS, {
    additionalAccommodations: Object(booking_selector["a" /* getAdditionalAccommodations */])(getState()),
    i18n: i18n,
    product: product,
    reducedMobilityVisibility: Object(booking_selector["d" /* getAdditionalAccommodationsPmrChecked */])(getState()),
    selectedProposal: proposal,
    shouldPreselectFilters: shouldPreselectFilters
  });
}

function _updateAdditionalAccommodationsFilters(isPmrChecked, getState) {
  return Object(createAction["b" /* default */])(UPDATE_ADDITIONAL_ACCOMMODATIONS_FILTERS, {
    additionalAccommodations: Object(booking_selector["a" /* getAdditionalAccommodations */])(getState()),
    selectedProposal: _getSelectedProposal(getState()),
    filters: Object(booking_selector["c" /* getAdditionalAccommodationsFilters */])(getState()),
    reducedMobilityVisibility: isPmrChecked !== null && isPmrChecked !== void 0 ? isPmrChecked : Object(booking_selector["d" /* getAdditionalAccommodationsPmrChecked */])(getState())
  });
}

function _toggleFilter(filter, getState) {
  return Object(createAction["b" /* default */])(TOGGLE_ACCOMMODATIONS_FILTER, {
    additionalAccommodations: Object(booking_selector["a" /* getAdditionalAccommodations */])(getState()),
    selectedProposal: _getSelectedProposal(getState()),
    reducedMobilityVisibility: Object(booking_selector["d" /* getAdditionalAccommodationsPmrChecked */])(getState()),
    filter: filter
  });
}

function _unselectFiltersCategory(category, getState) {
  return Object(createAction["b" /* default */])(UNSELECT_ADDITIONAL_ACCOMMODATIONS_FILTER_CATEGORY, {
    additionalAccommodations: Object(booking_selector["a" /* getAdditionalAccommodations */])(getState()),
    selectedProposal: _getSelectedProposal(getState()),
    reducedMobilityVisibility: Object(booking_selector["d" /* getAdditionalAccommodationsPmrChecked */])(getState()),
    category: category
  });
}

function _updateFilterAccommodations(getState) {
  return Object(createAction["b" /* default */])(UPDATE_FILTERED_ACCOMMODATIONS_RESULTS, {
    additionalAccommodations: Object(booking_selector["a" /* getAdditionalAccommodations */])(getState()),
    selectedProposal: _getSelectedProposal(getState()),
    filters: Object(booking_selector["c" /* getAdditionalAccommodationsFilters */])(getState()),
    reducedMobilityVisibility: Object(booking_selector["d" /* getAdditionalAccommodationsPmrChecked */])(getState())
  });
}

function _runAdditionalAccommodationsQuery(_ref2) {
  var proposalId = _ref2.proposalId,
      appContext = _ref2.appContext,
      duration = _ref2.duration,
      _ref2$selectedRate = _ref2.selectedRate,
      selectedRate = _ref2$selectedRate === void 0 ? '' : _ref2$selectedRate;
  var query = "\n    {\n      additionalAccommodations(proposalId: \"".concat(proposalId, "\") {\n        id\n        isUpgradableOnline\n        totalDifferentialPrice(selectedRate: \"").concat(selectedRate, "\") {\n          ...priceDetails\n        }\n        differentialPriceByNight(nightsNumber: ").concat(duration, ", selectedRate: \"").concat(selectedRate, "\") {\n          formattedValue(precision: 0)\n          value\n        }\n        remainingStock\n        accommodations {\n          id\n          categories { id label }\n          category\n          categoryId\n          comfortType\n          exclusiveCollection\n          connectingRoom\n          floorPlans\n          description\n          label\n          maxCapacity\n          roomType\n          media {\n            photos {\n              url\n            }\n          }\n          minCapacity\n          occupation\n          quantity\n          occupancies {\n            baby_count\n          }\n          outsideFacilities {\n            id\n            label\n          }\n          bathroomEquipments {\n            id\n            label\n          }\n          equipments {\n            id\n            label\n          }\n          services { id label }\n          strengths { id label }\n          surface\n          view { id label }\n          reducedMobilityAccess\n          attendeesDistribution {\n            id\n            quantity\n            attendees {\n              id\n              type\n              birthdate\n              customerId\n            }\n          }\n        }\n      }\n      config {\n        filters {\n          configuration {\n            categoryTitle\n            simpleRoom\n            simpleRooms\n            separatedRooms\n            separatedRooms3\n          }\n          comfort {\n            categoryTitle\n          }\n          extraFeatures {\n            categoryTitle\n          }\n          reducedMobility\n        }\n      }\n    }\n    ").concat(Object(proposalQuery["h" /* getPriceDetailFragment */])(get_default()(appContext, 'locale')), "\n  ");
  return graphqlClient["a" /* default */].runNoCacheQuery(query, appContext, {
    requestName: requestDictionary["Mc" /* PROPOSAL_GET_ADDITIONAL_ACCOMMODATIONS */]
  });
}

function clearAdditionalAccommodations() {
  return Object(createAction["b" /* default */])(CLEAR_ADDITIONAL_ACCOMMODATIONS);
}

function getAvailableFilteredAccommodationsByComfort(_ref3) {
  var additionalAccommodations = _ref3.additionalAccommodations;
  return Object(createAction["b" /* default */])(GET_ALTERNATIVES_ACCOMMODATIONS_BY_COMFORT, {
    additionalAccommodations: additionalAccommodations
  });
}

function getAlternativeFilteredAccommodations(_ref4) {
  var proposal = _ref4.proposal,
      appContext = _ref4.appContext;
  var id = proposal.id,
      duration = proposal.duration,
      selectedRate = proposal.price.selectedRate;
  return function (dispatch) {
    dispatch(Object(createAction["b" /* default */])(FETCH_ADDITIONAL_ACCOMMODATIONS));
    return _runAdditionalAccommodationsQuery({
      proposalId: id,
      appContext: appContext,
      duration: duration,
      selectedRate: selectedRate
    }).then(function (_ref5) {
      var additionalAccommodations = _ref5.additionalAccommodations;
      dispatch(Object(createAction["b" /* default */])(Object(build["resolve"])(FETCH_ADDITIONAL_ACCOMMODATIONS), {
        additionalAccommodations: additionalAccommodations
      }));
      dispatch(getAvailableFilteredAccommodationsByComfort({
        additionalAccommodations: additionalAccommodations
      }));
      dispatch(Object(createAction["b" /* default */])(Object(build["resolve"])(GET_ALTERNATIVES_ACCOMMODATIONS_BY_COMFORT)));
    })["catch"](function (error) {
      logger_default.a.error('error', error);
    });
  };
}

function fetchAdditionalAccommodations(_ref6) {
  var appContext = _ref6.appContext,
      product = _ref6.product,
      proposal = _ref6.proposal,
      _ref6$roomsArrangemen = _ref6.roomsArrangement,
      roomsArrangement = _ref6$roomsArrangemen === void 0 ? [] : _ref6$roomsArrangemen,
      _ref6$shouldPreselect = _ref6.shouldPreselectFilters,
      shouldPreselectFilters = _ref6$shouldPreselect === void 0 ? true : _ref6$shouldPreselect;
  var id = proposal.id,
      duration = proposal.duration,
      selectedRate = proposal.price.selectedRate;
  return function (dispatch, getState) {
    dispatch(Object(createAction["b" /* default */])(FETCH_ADDITIONAL_ACCOMMODATIONS));
    return _runAdditionalAccommodationsQuery({
      proposalId: id,
      appContext: appContext,
      duration: duration,
      selectedRate: selectedRate,
      roomsArrangement: roomsArrangement
    }).then(function (_ref7) {
      var additionalAccommodations = _ref7.additionalAccommodations,
          i18n = _ref7.config;
      dispatch(Object(createAction["b" /* default */])(Object(build["resolve"])(FETCH_ADDITIONAL_ACCOMMODATIONS), {
        additionalAccommodations: additionalAccommodations
      }));
      dispatch(_createAdditionalAccommodationsFilters({
        getState: getState,
        i18n: i18n,
        product: product,
        proposal: proposal,
        shouldPreselectFilters: shouldPreselectFilters
      }));
      dispatch(_updateFilterAccommodations(getState));
    })["catch"](function (error) {
      dispatch(Object(createAction["b" /* default */])(Object(build["reject"])(FETCH_ADDITIONAL_ACCOMMODATIONS), error));
    });
  };
}

function toggleAdditionalAccommodationFilter(filter) {
  return function (dispatch, getState) {
    dispatch(_toggleFilter(filter, getState));
    dispatch(_updateFilterAccommodations(getState));
  };
}

function unselectAdditionalAccommodationsFilterCategory(category) {
  return function (dispatch, getState) {
    dispatch(_unselectFiltersCategory(category, getState));
    dispatch(_updateFilterAccommodations(getState));
  };
}

function togglePMRChecbox(isChecked, filterValues) {
  return function (dispatch, getState) {
    dispatch(Object(createAction["b" /* default */])(TOGGLE_PMR_CHECKBOX, {
      isChecked: isChecked,
      filterValues: filterValues
    }));
    dispatch(_updateAdditionalAccommodationsFilters(isChecked, getState));
  };
}

function toggleAdditionalAccommodationReducedMobilityFilter(accommodationsSets, visibility) {
  return function (dispatch) {
    Object(createAction["b" /* default */])(Object(build["resolve"])(FETCH_ADDITIONAL_ACCOMMODATIONS), {
      additionalAccommodations: accommodationsSets
    });
    dispatch(Object(createAction["b" /* default */])(TOGGLE_EXTRA_FEATURES, {
      accommodationsSets: accommodationsSets,
      reducedMobilityVisibility: visibility
    }));
  };
}

var additionalAccommodations_action_runMoreAccommodationsQuery = function _runMoreAccommodationsQuery(_ref8) {
  var appContext = _ref8.appContext,
      _ref8$attendees = _ref8.attendees,
      attendees = _ref8$attendees === void 0 ? [] : _ref8$attendees,
      bookingId = _ref8.bookingId,
      duration = _ref8.duration,
      _ref8$selectedRate = _ref8.selectedRate,
      selectedRate = _ref8$selectedRate === void 0 ? '' : _ref8$selectedRate;
  var query = bookingAccommodationsMore_queries_getBookingAccommodationsSearch(appContext, bookingId, {
    attendees: attendees,
    duration: duration,
    selectedRate: selectedRate
  });
  return graphqlClient["a" /* default */].runNoCacheQuery(query, appContext, {
    requestName: requestDictionary["P" /* CUSTOMER_BOOKING_GET_MORE_ACCOMMODATIONS_DATA */],
    cacheFront: {
      key: "".concat(requestDictionary["P" /* CUSTOMER_BOOKING_GET_MORE_ACCOMMODATIONS_DATA */], "_").concat(bookingId)
    }
  });
};

var isNotSelected = function isNotSelected(set, selectedAccommodation) {
  return set.accommodations[0].id !== selectedAccommodation.id && set.totalDifferentialPrice.value !== selectedAccommodation.differentialPrice.amount;
};

var additionalAccommodations_action_fetchBookingMoreAccommodations = function fetchBookingMoreAccommodations(args) {
  var appContext = args.appContext,
      attendees = args.attendees,
      bookingId = args.bookingId,
      duration = args.duration,
      _args$ignoreReducedMo = args.ignoreReducedMobility,
      ignoreReducedMobility = _args$ignoreReducedMo === void 0 ? false : _args$ignoreReducedMo,
      product = args.product,
      _args$selectedAccommo = args.selectedAccommodation,
      selectedAccommodation = _args$selectedAccommo === void 0 ? {} : _args$selectedAccommo,
      _args$selectedRate = args.selectedRate,
      selectedRate = _args$selectedRate === void 0 ? '' : _args$selectedRate,
      _args$shouldPreselect = args.shouldPreselectFilters,
      shouldPreselectFilters = _args$shouldPreselect === void 0 ? false : _args$shouldPreselect;
  return /*#__PURE__*/function () {
    var _ref9 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(dispatch, getState) {
      var _yield$_runMoreAccomm, bookingAdditionalAccommodations;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch(Object(createAction["b" /* default */])(FETCH_ADDITIONAL_ACCOMMODATIONS));
              _context.prev = 1;
              _context.next = 4;
              return additionalAccommodations_action_runMoreAccommodationsQuery({
                appContext: appContext,
                attendees: attendees,
                bookingId: bookingId,
                duration: duration,
                selectedRate: selectedRate
              });

            case 4:
              _yield$_runMoreAccomm = _context.sent;
              bookingAdditionalAccommodations = _yield$_runMoreAccomm.bookingAdditionalAccommodations;
              dispatch(Object(createAction["b" /* default */])(Object(build["resolve"])(FETCH_ADDITIONAL_ACCOMMODATIONS), {
                additionalAccommodations: bookingAdditionalAccommodations.filter(function (set) {
                  return set.remainingStock > 0 && set.totalDifferentialPrice.value > 0 && // only more expensive accommodation
                  Boolean(set.accommodations.length) && isNotSelected(set, selectedAccommodation) && (ignoreReducedMobility ? !set.accommodations.some(function (_ref10) {
                    var reducedMobilityAccess = _ref10.reducedMobilityAccess;
                    return Boolean(reducedMobilityAccess);
                  }) : true);
                })
              }));
              dispatch(_createAdditionalAccommodationsFilters({
                getState: getState,
                i18n: {},
                product: product,
                proposal: {},
                shouldPreselectFilters: shouldPreselectFilters
              }));
              dispatch(_updateFilterAccommodations(getState));
              _context.next = 14;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](1);
              dispatch(Object(createAction["b" /* default */])(Object(build["reject"])(FETCH_ADDITIONAL_ACCOMMODATIONS), _context.t0));

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 11]]);
    }));

    return function (_x, _x2) {
      return _ref9.apply(this, arguments);
    };
  }();
};


/***/ }),

/***/ "1Ll7":
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__("gAMm"),
    func = convert('get', __webpack_require__("2srY"));

func.placeholder = __webpack_require__("VDAD");
module.exports = func;


/***/ }),

/***/ "1tzK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isChineseLocale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isLocaleToDisplayDidomi; });
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("kiXb");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("qFX+");



var isChineseLocale = function isChineseLocale(locale) {
  return locale === _constants__WEBPACK_IMPORTED_MODULE_1__[/* LOCALES */ "a"].EN_CN || locale === _constants__WEBPACK_IMPORTED_MODULE_1__[/* LOCALES */ "a"].ZH_CN;
};

var isLocaleToDisplayDidomi = function isLocaleToDisplayDidomi() {
  return Object(_i18n__WEBPACK_IMPORTED_MODULE_0__[/* getKeyValue */ "d"])('common.activateDidomi');
};



/***/ }),

/***/ "2Lg3":
/***/ (function(module, exports) {

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

module.exports = isNil;


/***/ }),

/***/ "2dnA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FailedPaymentModal; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("kiXb");
/* harmony import */ var _components_utils_color_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("UCZK");
/* harmony import */ var _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("SPKZ");
/* harmony import */ var _components_frameworks_modal_Modal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("EvYw");
/* harmony import */ var _components_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("qBqs");
/* harmony import */ var _components_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("e0Ti");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;







var FailedPaymentModal = function FailedPaymentModal(_ref) {
  var onClose = _ref.onClose;
  return __jsx(_components_frameworks_modal_Modal__WEBPACK_IMPORTED_MODULE_4__[/* Modal */ "a"], {
    closeLabel: Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('common.close'),
    onClose: onClose,
    size: "small"
  }, __jsx("div", {
    className: "flex flex-col items-center justify-center p-25"
  }, __jsx("div", {
    className: "flex flex-col items-center text-orange"
  }, __jsx(_components_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_5__[/* Icon */ "a"], {
    name: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__[/* ICONS */ "a"].CREDIT_CARD,
    width: "5.25rem",
    className: "w-full pb-95"
  }), __jsx("span", {
    className: "text-24"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.banking.error.paymentFailed.popinInfo1'))), __jsx("span", {
    className: "pb-20 text-14"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.banking.error.paymentFailed.popinInfo2')), __jsx("span", {
    className: "text-14"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.banking.error.paymentFailed.popinInfo3')), __jsx("span", {
    className: "flex items-center text-18 text-saffron"
  }, __jsx(_components_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_5__[/* Icon */ "a"], {
    name: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__[/* ICONS */ "a"].PHONE
  }), " ", Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.counterProposalPopIn.callCenterNumber')), __jsx("span", {
    className: "pb-30 text-12"
  }, "(", Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('navigationBar.contact.toll'), ")"), __jsx(_components_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_6__[/* Button */ "a"], {
    colorBg: _components_utils_color_colors__WEBPACK_IMPORTED_MODULE_2__[/* COLORS */ "a"].TURQUOISE,
    onClick: onClose
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.priceCalendar.closePopin'))));
};

/***/ }),

/***/ "2z5K":
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__("YpBQ"),
    baseIteratee = __webpack_require__("S3pA"),
    baseRest = __webpack_require__("R3TX"),
    baseUniq = __webpack_require__("s+R0"),
    isArrayLikeObject = __webpack_require__("Ndl3"),
    last = __webpack_require__("p1C/");

/**
 * This method is like `_.union` except that it accepts `iteratee` which is
 * invoked for each element of each `arrays` to generate the criterion by
 * which uniqueness is computed. Result values are chosen from the first
 * array in which the value occurs. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.unionBy([2.1], [1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
var unionBy = baseRest(function(arrays) {
  var iteratee = last(arrays);
  if (isArrayLikeObject(iteratee)) {
    iteratee = undefined;
  }
  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), baseIteratee(iteratee, 2));
});

module.exports = unionBy;


/***/ }),

/***/ "34at":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return goToHash; });
/* harmony import */ var _widgets_navigation_Navigation_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1cDg");
/* eslint-env browser */

function goToHash(hash) {
  var scrollUnderNav = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var behavior = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'auto';
  /* In mobile context, navBar is on top of the content of the page so hash scroll goes under the nav */

  function scrollUnderNavBar() {
    var navBar = document.querySelector(_widgets_navigation_Navigation_constants__WEBPACK_IMPORTED_MODULE_0__[/* NAVIGATION_OFFSET_SELECTOR */ "a"]);

    if (navBar) {
      document.documentElement.scrollTop -= navBar.clientHeight;
    }
  }

  if (hash) {
    setTimeout(function () {
      var element = document.querySelector(hash);

      if (element) {
        element.scrollIntoView({
          behavior: behavior
        });

        if (scrollUnderNav) {
          scrollUnderNavBar();
        }
      }
    }, 100);
  }
}

/***/ }),

/***/ "3B0E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("OZaJ");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("MvUL");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("HbGN");
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("sRHE");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("Bkb1");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _logger_logger__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("zytj");
/* harmony import */ var _utils_context_contextUtils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("igjW");









var __jsx = react__WEBPACK_IMPORTED_MODULE_9___default.a.createElement;

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}






var HocErrorBoundary = function HocErrorBoundary(ChildComponent) {
  var ErrorBoundary = /*#__PURE__*/function (_Component) {
    Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(ErrorBoundary, _Component);

    var _super = _createSuper(ErrorBoundary);

    function ErrorBoundary(props) {
      var _this;

      Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(this, ErrorBoundary);

      _this = _super.call(this, props);
      _this.state = {
        hasError: false
      };
      return _this;
    }

    Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(ErrorBoundary, [{
      key: "componentDidCatch",
      // eslint-disable-next-line class-methods-use-this
      value: function componentDidCatch(err, info) {
        _logger_logger__WEBPACK_IMPORTED_MODULE_11__["default"].error({
          err: err,
          info: info
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
            router = _this$props.router,
            props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_this$props, ["router"]);

        if (this.state.hasError) {
          if (Object(_utils_context_contextUtils__WEBPACK_IMPORTED_MODULE_12__[/* isStrictlyProductionEnv */ "f"])()) {
            var locale = router.query.locale;
            router.replace({
              pathname: '/500',
              query: Boolean(locale) && {
                locale: locale
              }
            });
            this.setState({
              hasError: false
            });
          }

          return null;
        }

        return __jsx(ChildComponent, props);
      }
    }], [{
      key: "getDerivedStateFromError",
      value: function getDerivedStateFromError() {
        return {
          hasError: true
        };
      }
    }]);

    return ErrorBoundary;
  }(react__WEBPACK_IMPORTED_MODULE_9__["Component"]);

  return Object(next_router__WEBPACK_IMPORTED_MODULE_10__["withRouter"])(ErrorBoundary);
};

/* harmony default export */ __webpack_exports__["a"] = (HocErrorBoundary);

/***/ }),

/***/ "4KA2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ TeaserCard_TeaserCard; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/utils/ratios/ratios.utils.js
var ratios_utils = __webpack_require__("u/u4");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./src/client/components/frameworks/image-slideshow/ImageSlideShow.jsx
var ImageSlideShow = __webpack_require__("DQFb");

// CONCATENATED MODULE: ./src/client/components/frameworks/teaser-card/TeaserCard.themes.js
var themes = {
  "default": {
    thRoot: 'flex flex-col',
    thImage: 'bg-grey isolate order-first overflow-hidden rounded-12 transition-all duration-250 ease-in',
    thImageActive: 'opacity-75 scale-095'
  },
  "short": {
    thRoot: 'flex flex-col h-full isolate overflow-hidden relative rounded-12 shadow-sm transition-all duration-250 ease-in',
    thChildren: 'p-15 md:p-20 h-full',
    thRootActive: 'shadow-md',
    thImage: 'bg-grey order-first overflow-hidden rounded-t-12 shrink-0 duration-250 ease-in transition-all'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/teaser-card/TeaserCard.jsx

var __jsx = react_default.a.createElement;






var TeaserCard_TeaserCard = function TeaserCard(_ref) {
  var children = _ref.children,
      className = _ref.className,
      isActive = _ref.isActive,
      _ref$media = _ref.media,
      media = _ref$media === void 0 ? [] : _ref$media,
      nextLabel = _ref.nextLabel,
      previousLabel = _ref.previousLabel,
      _ref$ratio = _ref.ratio,
      ratio = _ref$ratio === void 0 ? ratios_utils["c" /* default */].R_38_BY_28 : _ref$ratio,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var defaultPicture = media[0] || {};
  var _themes$theme = themes[theme],
      thRoot = _themes$theme.thRoot,
      thRootActive = _themes$theme.thRootActive,
      thChildren = _themes$theme.thChildren,
      thImage = _themes$theme.thImage,
      thImageActive = _themes$theme.thImageActive;
  return __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(thRoot, Object(defineProperty["a" /* default */])({
      'h-full': media.length <= 1
    }, thRootActive, isActive), className)
  }, __jsx("div", {
    className: thChildren
  }, children), __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(thImage, Object(defineProperty["a" /* default */])({}, thImageActive, isActive))
  }, media.length > 1 ? __jsx(ImageSlideShow["a" /* ImageSlideShow */], {
    hasLazyLoading: true,
    media: media,
    nextLabel: nextLabel,
    previousLabel: previousLabel,
    ratio: ratio
  }) : __jsx(Image["b" /* default */], {
    altMsg: defaultPicture.alt,
    groupKey: "thumbnails",
    hasLazyLoading: true,
    imageUrl: defaultPicture.src,
    key: defaultPicture.src,
    ratioKey: ratio,
    ratioDisplay: 1 / 4
  })));
};

/***/ }),

/***/ "4tGX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useExtendedConnect; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_graphql_client_use_gql_useGQL__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("0JpG");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("CcNa");



var query = "\n  query {\n    facebookConnect {\n      isAvailable\n    }\n    wechatConnect {\n      isAvailable\n    }\n  }\n";
var useExtendedConnect = function useExtendedConnect() {
  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(false),
      isFacebookConnectAvailable = _useState[0],
      setIsFacebookConnectAvailable = _useState[1];

  var _useState2 = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(false),
      isWechatConnectAvailable = _useState2[0],
      setIsWechatConnectAvailable = _useState2[1];

  var _useGQL = Object(_utils_graphql_client_use_gql_useGQL__WEBPACK_IMPORTED_MODULE_1__[/* useGQL */ "a"])({
    query: query,
    queryOptions: {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* CORE_GET_FACEBOOK_CONNECT_CONFIG */ "d"]
    },
    cache: true
  }),
      data = _useGQL.data,
      isLoading = _useGQL.isLoading;

  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    var _data$facebookConnect, _data$wechatConnect;

    setIsFacebookConnectAvailable(!!(data === null || data === void 0 ? void 0 : (_data$facebookConnect = data.facebookConnect) === null || _data$facebookConnect === void 0 ? void 0 : _data$facebookConnect.isAvailable));
    setIsWechatConnectAvailable(!!(data === null || data === void 0 ? void 0 : (_data$wechatConnect = data.wechatConnect) === null || _data$wechatConnect === void 0 ? void 0 : _data$wechatConnect.isAvailable));
  }, [isLoading]);
  return {
    isFacebookConnectAvailable: isFacebookConnectAvailable,
    isWechatConnectAvailable: isWechatConnectAvailable
  };
};

/***/ }),

/***/ "5WMi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:!0});var e=__webpack_require__("VDhN");exports.default=e.default;


/***/ }),

/***/ "5svr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ productAccommodations_utils_getAllAvailableItems; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ withExclusiveCollectionTag; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ groupAccommodationsByCategory; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ getTabsItemsAndPropsFromAccommodations; });

// UNUSED EXPORTS: getSurfaceIconItem, getCapacityIconItem, getViewIconItem, getOutsideFacilitiesIconItems, aggregateIconList, mapAccommodationServices

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("jQ/y");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.every.js
var es_array_every = __webpack_require__("DfhM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find-index.js
var es_array_find_index = __webpack_require__("vfdX");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("M+/F");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.sort.js
var es_array_sort = __webpack_require__("tQbP");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.values.js
var es_object_values = __webpack_require__("1IsZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__("JtPf");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/unionBy.js
var unionBy = __webpack_require__("2z5K");
var unionBy_default = /*#__PURE__*/__webpack_require__.n(unionBy);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/sortBy.js
var sortBy = __webpack_require__("u6DZ");
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/intersectionBy.js
var intersectionBy = __webpack_require__("wyfB");
var intersectionBy_default = /*#__PURE__*/__webpack_require__.n(intersectionBy);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/compact.js
var compact = __webpack_require__("3dHC");
var compact_default = /*#__PURE__*/__webpack_require__.n(compact);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/camelCase.js
var camelCase = __webpack_require__("S0cN");
var camelCase_default = /*#__PURE__*/__webpack_require__.n(camelCase);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/i18n.js
var src_i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/widgets/product-information-slider/ProductInformationSlider.container.jsx + 2 modules
var ProductInformationSlider_container = __webpack_require__("JjZN");

// EXTERNAL MODULE: ./src/client/components/widgets/product-rooms-comparator/ProductRoomsComparatorLauncher.jsx + 3 modules
var ProductRoomsComparatorLauncher = __webpack_require__("9tk8");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.link.js
var es_string_link = __webpack_require__("hBvt");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/utils/markup/markup.js
var markup = __webpack_require__("Iz3O");

// EXTERNAL MODULE: ./src/client/components/utils/ratios/ratios.utils.js
var ratios_utils = __webpack_require__("u/u4");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/components/frameworks/teaser-card/TeaserCard.jsx + 1 modules
var TeaserCard = __webpack_require__("4KA2");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// CONCATENATED MODULE: ./src/client/components/widgets/product-room-card/ProductRoomCard.jsx












var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









var ProductRoomCard_ProductRoomCard = function ProductRoomCard(_ref) {
  var className = _ref.className,
      isHidden = _ref.isHidden,
      isLarge = _ref.isLarge,
      _ref$labeledIconsList = _ref.labeledIconsList,
      labeledIconsList = _ref$labeledIconsList === void 0 ? [] : _ref$labeledIconsList,
      _ref$link = _ref.link,
      link = _ref$link === void 0 ? {} : _ref$link,
      _ref$media = _ref.media,
      media = _ref$media === void 0 ? [] : _ref$media,
      seeMoreLabel = _ref.seeMoreLabel,
      title = _ref.title;

  var _useState = Object(react["useState"])(false),
      isHovering = _useState[0],
      setHovering = _useState[1];

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop,
      isTablet = _useResponsive.isTablet;

  var TagName = Object(markup["b" /* getLinkTagName */])(link);
  var linkProps = Object(markup["a" /* getLinkProps */])(link);

  var content = __jsx(react["Fragment"], null, __jsx(Title["a" /* Title */], {
    hasEllipsis: true,
    theme: "title-brand-n3"
  }, title), __jsx("ul", {
    className: "space-y-5"
  }, labeledIconsList.map(function (_ref2, index) {
    var labels = _ref2.labels;
    return !!labels && __jsx("li", {
      className: "inline-flex min-h-20 w-full items-center justify-between gap-5 overflow-hidden text-14",
      key: index
    }, labels.map(function (label, labelIndex) {
      return __jsx("span", {
        className: Object(classnames_utils["a" /* classnames */])({
          'text-mediumGrey': labelIndex === 0,
          'text-end font-bold text-black': labelIndex !== 0
        }),
        key: label
      }, label, "\xA0");
    }));
  })), !!seeMoreLabel && __jsx("p", {
    className: "mt-auto text-center text-12 text-black underline"
  }, seeMoreLabel));

  var props = _objectSpread(_objectSpread({}, linkProps), {}, {
    onClick: function onClick() {
      var _linkProps$onClick;

      (_linkProps$onClick = linkProps.onClick) === null || _linkProps$onClick === void 0 ? void 0 : _linkProps$onClick.call(linkProps);
    }
  });

  var ratio = isLarge && isTablet ? ratios_utils["c" /* default */].R_38_BY_58 : ratios_utils["c" /* default */].XL;
  return isDesktop ? __jsx(TeaserCard["a" /* TeaserCard */], {
    "aria-hidden": isHidden,
    className: Object(classnames_utils["a" /* classnames */])('tap-highlight-color-transparent transition-transform w-full duration-250 ease-in', className),
    isActive: isHovering,
    media: media,
    nextLabel: Object(src_i18n["h" /* t */])('common.next'),
    previousLabel: Object(src_i18n["h" /* t */])('common.previous'),
    ratio: ratio,
    theme: "short"
  }, __jsx(TagName, Object(esm_extends["a" /* default */])({}, props, {
    className: "text-initial flex w-full flex-col items-stretch gap-10",
    onMouseEnter: function onMouseEnter() {
      return setHovering(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHovering(false);
    },
    tabIndex: isHidden ? -1 : 0
  }), content)) : __jsx(TagName, Object(esm_extends["a" /* default */])({}, props, {
    "aria-hidden": isHidden,
    className: Object(classnames_utils["a" /* classnames */])('tap-highlight-color-transparent text-initial block h-full w-full', className),
    tabIndex: isHidden ? -1 : 0
  }), __jsx(TeaserCard["a" /* TeaserCard */], {
    media: media.slice(0, 1),
    ratio: ratio,
    theme: "short"
  }, content));
};
// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/frameworks/labeled-icons-list/LabeledIconsList.jsx + 1 modules
var LabeledIconsList = __webpack_require__("LR4h");

// EXTERNAL MODULE: ./src/client/components/frameworks/sheet/Sheet.jsx + 1 modules
var Sheet = __webpack_require__("RHTr");

// EXTERNAL MODULE: ./src/client/components/frameworks/zoom/Zoom.jsx
var Zoom = __webpack_require__("7x6O");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: ./src/client/components/frameworks/tooltip/Tooltip.jsx
var Tooltip = __webpack_require__("i3Ve");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./src/client/components/frameworks/tabs/Tabs.jsx + 1 modules
var Tabs = __webpack_require__("4/4b");

// EXTERNAL MODULE: /opt/webapp/node_modules/next/dynamic.js
var dynamic = __webpack_require__("hNT8");
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);

// EXTERNAL MODULE: ./src/client/components/widgets/loading/async-loader/AsyncLoader.jsx + 1 modules
var AsyncLoader = __webpack_require__("4A3Y");

// EXTERNAL MODULE: ./src/utils/graphql-client/use-gql/useGQL.js
var useGQL = __webpack_require__("0JpG");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// EXTERNAL MODULE: ./src/client/components/widgets/resort-district/resortDistrict.utils.js
var resortDistrict_utils = __webpack_require__("dAFS");

// CONCATENATED MODULE: ./src/client/components/widgets/resort-district/ResortDistrictContainer.jsx



var ResortDistrictContainer_jsx = react_default.a.createElement;






var ResortDistrict = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(0), __webpack_require__.e(3), __webpack_require__.e(966)]).then(__webpack_require__.bind(null, "V163")).then(function (mod) {
    return mod.ResortDistrict;
  });
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("V163")];
    },
    modules: ["./ResortDistrict"]
  }
});
var ResortDistrictContainer_ResortDistrictContainer = function ResortDistrictContainer(props) {
  var _data$resortAreas, _data$resortAreas2;

  var resortId = props.resortId;

  var _useGQL = Object(useGQL["a" /* useGQL */])({
    query: Object(resortDistrict_utils["a" /* getResortDistrictQuery */])(resortId),
    queryOptions: {
      requestName: requestDictionary["W" /* CUSTOMER_BOOKING_RD_GET_RESORT_SETTINGS */],
      cacheFront: {
        key: requestDictionary["W" /* CUSTOMER_BOOKING_RD_GET_RESORT_SETTINGS */] + resortId
      }
    },
    ignore: !resortId
  }),
      data = _useGQL.data,
      isLoading = _useGQL.isLoading;

  if (isLoading) {
    return ResortDistrictContainer_jsx("div", {
      className: "flex h-full w-full items-center justify-center"
    }, ResortDistrictContainer_jsx(AsyncLoader["a" /* AsyncLoader */], null));
  }

  if (!(data === null || data === void 0 ? void 0 : (_data$resortAreas = data.resortAreas) === null || _data$resortAreas === void 0 ? void 0 : _data$resortAreas.areas) || !(data === null || data === void 0 ? void 0 : (_data$resortAreas2 = data.resortAreas) === null || _data$resortAreas2 === void 0 ? void 0 : _data$resortAreas2.geoData)) {
    return null;
  }

  return ResortDistrictContainer_jsx(ResortDistrict, Object(esm_extends["a" /* default */])({}, data, props));
};
// EXTERNAL MODULE: ./src/client/components/utils/scroll/scrollToHash.js
var scrollToHash = __webpack_require__("34at");

// CONCATENATED MODULE: ./src/client/components/widgets/product-room-detail/ProductRoomDetail.jsx













var ProductRoomDetail_jsx = react_default.a.createElement;

function ProductRoomDetail_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ProductRoomDetail_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ProductRoomDetail_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ProductRoomDetail_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


















var DIMENSIONS = {
  w: 'auto',
  h: 'auto'
};
var ProductRoomDetail_ProductRoomDetail = function ProductRoomDetail(_ref) {
  var _ref$areas = _ref.areas,
      areas = _ref$areas === void 0 ? [] : _ref$areas,
      description = _ref.description,
      immersive = _ref.immersive,
      _ref$isExclusiveColle = _ref.isExclusiveCollection,
      isExclusiveCollection = _ref$isExclusiveColle === void 0 ? false : _ref$isExclusiveColle,
      _ref$overviewCompact = _ref.overviewCompact,
      overviewCompact = _ref$overviewCompact === void 0 ? [] : _ref$overviewCompact,
      _ref$overviewAlternat = _ref.overviewAlternate,
      overviewAlternate = _ref$overviewAlternat === void 0 ? [] : _ref$overviewAlternat,
      strengthsLabel = _ref.strengthsLabel,
      amenitiesLabel = _ref.amenitiesLabel,
      _ref$services = _ref.services,
      services = _ref$services === void 0 ? [] : _ref$services,
      _ref$slideshow = _ref.slideshow,
      slideshow = _ref$slideshow === void 0 ? {} : _ref$slideshow,
      _ref$multimedia = _ref.multimedia,
      multimedia = _ref$multimedia === void 0 ? {} : _ref$multimedia,
      _ref$floorPlans = _ref.floorPlans,
      floorPlans = _ref$floorPlans === void 0 ? [] : _ref$floorPlans,
      productId = _ref.productId,
      title = _ref.title,
      subtitle = _ref.subtitle;

  var slideshowProps = ProductRoomDetail_objectSpread(ProductRoomDetail_objectSpread({}, slideshow), {}, {
    groupKey: 'roomDetail',
    hasInfiniteScroll: true,
    media: slideshow.media,
    nextLabel: Object(src_i18n["h" /* t */])('common.next'),
    previousLabel: Object(src_i18n["h" /* t */])('common.previous'),
    ratioDisplay: 0.8
  });

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var numberOfPhotos = multimedia && multimedia.photos ? multimedia.photos.length : 0;
  var multimediaProps = {
    closeLabel: Object(src_i18n["h" /* t */])('common.close'),
    descriptionLabels: {
      photos: '',
      streetViews: Object(src_i18n["h" /* t */])('common.view360Disclaimer')
    },
    galleryLabel: title ? Object(src_i18n["h" /* t */])('common.galleries.productGallery', {
      productName: title
    }) : Object(src_i18n["h" /* t */])('common.galleries.gallery'),
    isOverlay: true,
    labels: {
      photos: Object(src_i18n["h" /* t */])('common.photoTitle')
    },
    medias: multimedia,
    nextLabel: title ? Object(src_i18n["h" /* t */])('common.galleries.productNextPicture', {
      productName: title
    }) : Object(src_i18n["h" /* t */])('common.next'),
    previousLabel: title ? Object(src_i18n["h" /* t */])('common.galleries.productPreviousPicture', {
      productName: title
    }) : Object(src_i18n["h" /* t */])('common.previous'),
    pictureAltLabel: Object(src_i18n["h" /* t */])('common.galleries.productPictureItem', {
      total: numberOfPhotos,
      productName: title
    })
  };

  var getHeader = function getHeader(floorPlansLength, index) {
    return floorPlansLength > 1 ? {
      header: {
        title: "".concat(index === 0 ? '' : '+').concat(index)
      }
    } : null;
  };

  var getFloorplansTabs = function getFloorplansTabs() {
    return floorPlans.map(function (floorPlan, index) {
      return ProductRoomDetail_objectSpread(ProductRoomDetail_objectSpread({}, getHeader(floorPlans.length, index)), {}, {
        content: ProductRoomDetail_jsx("div", {
          className: "mx-auto w-full max-w-site-small",
          key: index
        }, ProductRoomDetail_jsx("div", {
          className: "flex flex-col"
        }, !isTablet && ProductRoomDetail_jsx(Tooltip["a" /* Tooltip */], {
          trackingData: {
            actionGA: 'layer',
            labelGA: 'floorPlans'
          },
          renderTrigger: function renderTrigger(toggle) {
            return ProductRoomDetail_jsx("button", {
              onClick: function onClick() {
                toggle();
              },
              className: "mb-15 ms-auto rounded-2 bg-white p-5 leading-0 text-black shadow-sm transition-colors duration-250 ease-in hocus:bg-black/60 hocus:text-white",
              type: "button"
            }, ProductRoomDetail_jsx(Icon["a" /* Icon */], {
              name: icons["a" /* ICONS */].EXPAND,
              width: "1.25rem"
            }));
          },
          modalProps: {
            addendum: ProductRoomDetail_jsx(Text["a" /* Text */], {
              className: "px-10 py-20 text-center text-12 leading-tight text-white",
              text: Object(src_i18n["h" /* t */])('common.roomPlan.disclaimer'),
              theme: "none"
            }),
            children: ''
          }
        }, ProductRoomDetail_jsx(Zoom["a" /* Zoom */], {
          alt: "".concat(Object(src_i18n["h" /* t */])('common.roomPlan.title'), " ").concat(title),
          hint: Object(src_i18n["h" /* t */])('common.roomPlan.swipeInstruction'),
          imageUrl: floorPlan
        })), ProductRoomDetail_jsx("div", {
          className: "relative isolate h-0 w-full pb-[60%] md:pb-[50%]"
        }, ProductRoomDetail_jsx(Image["a" /* Image */], {
          altMsg: "".concat(Object(src_i18n["h" /* t */])('common.roomPlan.title'), " ").concat(title),
          className: "absolute flex h-full w-full items-center justify-center",
          dimensions: DIMENSIONS,
          imageUrl: floorPlan,
          transformation: "resize"
        })), ProductRoomDetail_jsx(Text["a" /* Text */], {
          className: "pb-40 pt-30 leading-tight md:pb-80 md:pt-25 md:text-center",
          text: Object(src_i18n["h" /* t */])('common.roomPlan.disclaimer')
        })))
      });
    });
  };

  var color = isExclusiveCollection ? colors["a" /* COLORS */].ULTRAMARINE : colors["a" /* COLORS */].BLACK;
  var hasResortDistrict = Object(src_i18n["e" /* getListValue */])('common.resortDistrict.productIds', 15).includes(productId) && !!(areas === null || areas === void 0 ? void 0 : areas.length);

  var header = ProductRoomDetail_jsx("section", {
    className: "p-20 md:pt-80"
  }, ProductRoomDetail_jsx("p", {
    className: "mb-5 text-16 md:text-20"
  }, subtitle), ProductRoomDetail_jsx(Title["a" /* Title */], {
    className: "text-".concat(color),
    theme: "title-brand-n44"
  }, title), ProductRoomDetail_jsx("ul", {
    className: "mb-25 mt-20 flex gap-5 text-14 md:mb-50"
  }, overviewCompact.map(function (item, index) {
    return ProductRoomDetail_jsx("li", {
      className: Object(classnames_utils["a" /* classnames */])('md:basis-1/5', {
        'basis-1/2': !(hasResortDistrict && !!productId && areas.length > 0),
        'basis-1/3': hasResortDistrict && !!productId && areas.length > 0
      }),
      key: index
    }, item.map(function (line, idx) {
      return ProductRoomDetail_jsx("span", {
        className: Object(classnames_utils["a" /* classnames */])('block', {
          'font-bold': idx === 0
        }),
        key: "".concat(index, "-").concat(idx)
      }, line);
    }));
  }), hasResortDistrict && !!productId && areas.length > 0 && ProductRoomDetail_jsx("li", {
    className: "basis-1/3 md:basis-1/5"
  }, ProductRoomDetail_jsx("span", {
    className: "block font-bold"
  }, Object(src_i18n["h" /* t */])('common.resortDistrict.layerDistrictLabel')), areas.map(function (area) {
    return ProductRoomDetail_jsx("div", {
      className: "flex items-center gap-5",
      key: area.id
    }, ProductRoomDetail_jsx(Icon["a" /* Icon */], {
      name: icons["a" /* ICONS */].ADDRESS
    }), ProductRoomDetail_jsx("button", {
      className: "text-initial underline",
      onClick: function onClick() {
        return Object(scrollToHash["a" /* goToHash */])('#room-location', true, 'smooth');
      },
      type: "button"
    }, area.label));
  }))), ProductRoomDetail_jsx(Text["a" /* Text */], {
    className: "mx-auto w-full max-w-site-small md:text-20",
    text: description,
    theme: "text-sans-n3"
  }));

  return ProductRoomDetail_jsx(Sheet["a" /* Sheet */], {
    fullWidthContent: true,
    header: header,
    immersive: immersive,
    isExclusiveCollection: isExclusiveCollection,
    multimedia: multimediaProps,
    slideshow: slideshowProps
  }, !!overviewAlternate.length && ProductRoomDetail_jsx("section", {
    className: "mx-auto max-w-site-medium px-20 pb-20"
  }, ProductRoomDetail_jsx(Title["a" /* Title */], {
    className: "mb-15 md:text-32 text-".concat(color),
    hLevel: 3,
    theme: "title-brand-n3"
  }, strengthsLabel), ProductRoomDetail_jsx("div", {
    className: "mx-auto w-full max-w-site-small"
  }, ProductRoomDetail_jsx(LabeledIconsList["a" /* LabeledIconsList */], {
    color: color,
    items: overviewAlternate
  }))), floorPlans.length > 0 && ProductRoomDetail_jsx("section", {
    className: "mx-auto max-w-site-medium px-20 pb-20"
  }, ProductRoomDetail_jsx(Title["a" /* Title */], {
    className: "mb-40 md:text-32 text-".concat(color),
    hLevel: 3,
    theme: "title-brand-n3"
  }, Object(src_i18n["h" /* t */])('common.roomPlan.title')), ProductRoomDetail_jsx(Tabs["a" /* Tabs */], {
    id: "product-accommodations-line-tabs",
    isContainerWide: true,
    isContentUnmountedOnCollapse: true,
    items: getFloorplansTabs()
  })), hasResortDistrict && !!productId && ProductRoomDetail_jsx("section", {
    className: "relative pb-20"
  }, ProductRoomDetail_jsx("div", {
    className: "absolute top-0 -mt-60 h-0 w-0",
    id: "room-location"
  }), ProductRoomDetail_jsx(Title["a" /* Title */], {
    className: "mx-auto mb-40 max-w-site-medium px-20 md:text-32 text-".concat(color),
    hLevel: 3,
    theme: "title-brand-n3"
  }, Object(src_i18n["h" /* t */])('common.resortDistrict.layerDistrictLabel')), ProductRoomDetail_jsx("div", {
    className: "pb-15 pt-60"
  }, ProductRoomDetail_jsx(ResortDistrictContainer_ResortDistrictContainer, {
    access: Object(src_i18n["h" /* t */])('common.resortDistrict.access'),
    resortId: productId,
    roomAreas: areas,
    roomLabel: title,
    trackingData: {
      actionGA: "layer_".concat(subtitle)
    }
  }))), ProductRoomDetail_jsx("section", {
    className: "mx-auto max-w-site-medium px-20"
  }, ProductRoomDetail_jsx(Title["a" /* Title */], {
    className: "mb-15 md:text-32 text-".concat(color),
    hLevel: 3,
    theme: "title-brand-n3"
  }, amenitiesLabel), services.map(function (_ref2) {
    var label = _ref2.label,
        items = _ref2.items;
    return ProductRoomDetail_jsx("section", {
      className: "mx-auto w-full max-w-site-small py-15 md:py-30",
      key: label
    }, ProductRoomDetail_jsx(Title["a" /* Title */], {
      className: "mb-30 border-b-1 border-ultramarine pb-10 md:text-20 text-".concat(color),
      hLevel: 4,
      theme: "title-brand-n4"
    }, label), ProductRoomDetail_jsx(LabeledIconsList["a" /* LabeledIconsList */], {
      color: color,
      items: items,
      theme: "list"
    }));
  })));
};
// EXTERNAL MODULE: ./src/utils/proposal/constants.js
var constants = __webpack_require__("tI+f");

// CONCATENATED MODULE: ./src/client/components/lines/product-accommodations-line/productAccommodations.utils.js






























var productAccommodations_utils_jsx = react_default.a.createElement;

function productAccommodations_utils_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function productAccommodations_utils_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? productAccommodations_utils_ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : productAccommodations_utils_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}










var PRODUCT_TYPES = dist["constants"].PRODUCT_TYPES,
    RANKINGS = dist["constants"].RANKINGS;
var DEFAULT_RANKING = RANKINGS.LOW;
function getSurfaceIconItem(i18n, surface, roomType) {
  return {
    icon: icons["a" /* ICONS */][roomType] || null,
    labels: [get_default()(i18n, camelCase_default()(roomType)), surface || roomType && ' ' || '']
  };
}
function getCapacityIconItem(i18n, capacity) {
  var peopleLabel = get_default()(i18n, 'numberOfPeopleLabel');

  if (!capacity || !peopleLabel) {
    return null;
  }

  return {
    icon: icons["a" /* ICONS */].PEOPLE,
    labels: [get_default()(i18n, 'capacityOfPeopleLabel'), Object(dist["messageFormat"])(peopleLabel).format({
      count: capacity
    })]
  };
}
function getViewIconItem(view) {
  return view ? {
    icon: icons["a" /* ICONS */][get_default()(view, 'id')] || icons["a" /* ICONS */].TRIDENT1,
    labels: [view.label]
  } : null;
}
function getOutsideFacilitiesIconItems(outsideFacilities) {
  if (isEmpty_default()(outsideFacilities)) {
    return null;
  }

  return outsideFacilities.map(function (item) {
    return {
      icon: icons["a" /* ICONS */][get_default()(item, 'id')],
      labels: [item.label]
    };
  });
}

function getServiceIconItem(service) {
  return service ? {
    icon: icons["a" /* ICONS */][get_default()(service, 'id')] || icons["a" /* ICONS */].TRIDENT1,
    labels: [service.label]
  } : null;
}

function aggregateIconList(_ref) {
  var surfaceItem = _ref.surfaceItem,
      capacityItem = _ref.capacityItem,
      outsideFacilitiesItems = _ref.outsideFacilitiesItems,
      strengths = _ref.strengths,
      viewItem = _ref.viewItem;
  var maxAccomodationsToDisplay = 4;
  var accomodationsWithoutStrengthsCount = [capacityItem].concat(Object(toConsumableArray["a" /* default */])(outsideFacilitiesItems || []), [viewItem]).filter(function (item) {
    return get_default()(item, 'labels.0');
  }).length;
  var availableSpacesForStrengths = maxAccomodationsToDisplay - accomodationsWithoutStrengthsCount;
  var strengthsItems = (strengths || []).slice(0, availableSpacesForStrengths).map(function (strength) {
    return {
      icon: icons["a" /* ICONS */][get_default()(strength, 'id')] || icons["a" /* ICONS */].TRIDENT1,
      labels: [get_default()(strength, 'label') || '']
    };
  }); // $FlowFixMe

  return compact_default()([surfaceItem, capacityItem].concat(Object(toConsumableArray["a" /* default */])(outsideFacilitiesItems || []), [viewItem], Object(toConsumableArray["a" /* default */])(strengthsItems))).filter(function (_ref2) {
    var _ref2$labels = _ref2.labels,
        labels = _ref2$labels === void 0 ? [] : _ref2$labels;
    return labels.length && labels[0];
  }).slice(0, 4);
}

function mapAccommodationStrengths(i18n, accommodation) {
  var maxCapacity = accommodation.maxCapacity,
      roomType = accommodation.roomType,
      strengths = accommodation.strengths,
      surface = accommodation.surface,
      view = accommodation.view,
      outsideFacilities = accommodation.outsideFacilities;
  var surfaceItem = getSurfaceIconItem(i18n, surface, roomType);
  var capacityItem = getCapacityIconItem(i18n, maxCapacity);
  var viewItem = getViewIconItem(view);
  var outsideFacilitiesItems = getOutsideFacilitiesIconItems(outsideFacilities);
  return {
    strengths: aggregateIconList({
      surfaceItem: surfaceItem,
      capacityItem: capacityItem
    }),
    strengthsCompact: [surfaceItem === null || surfaceItem === void 0 ? void 0 : surfaceItem.labels, capacityItem === null || capacityItem === void 0 ? void 0 : capacityItem.labels].filter(Boolean),
    strengthsAlternate: aggregateIconList({
      outsideFacilitiesItems: outsideFacilitiesItems,
      viewItem: viewItem,
      strengths: strengths
    })
  };
}

function mapAccommodationServices(i18n, accommodation, isExclusiveCollection) {
  var _accommodation$bathro = accommodation.bathroomEquipments,
      bathroomEquipments = _accommodation$bathro === void 0 ? [] : _accommodation$bathro,
      _accommodation$equipm = accommodation.equipments,
      equipments = _accommodation$equipm === void 0 ? [] : _accommodation$equipm,
      _accommodation$servic = accommodation.services,
      services = _accommodation$servic === void 0 ? [] : _accommodation$servic;
  var isSuiteAccommodation = (accommodation === null || accommodation === void 0 ? void 0 : accommodation.comfortId) === constants["c" /* COMFORT_TYPE_SUITE */];
  return [{
    label: isExclusiveCollection || isSuiteAccommodation ? get_default()(i18n, 'servicesLabel', '') : null,
    items: Array.isArray(services) && services.map(function (service) {
      return getServiceIconItem(service);
    })
  }, {
    label: get_default()(i18n, 'equipmentLabel', ''),
    items: equipments.map(function (equipment) {
      return getServiceIconItem(equipment);
    })
  }, {
    label: get_default()(i18n, 'bathroomLabel', ''),
    items: bathroomEquipments.map(function (equipment) {
      return getServiceIconItem(equipment);
    })
  }, {
    label: !(isExclusiveCollection || isSuiteAccommodation) ? get_default()(i18n, 'servicesLabel', '') : null,
    items: Array.isArray(services) && services.map(function (service) {
      return getServiceIconItem(service);
    })
  }].filter(function (service) {
    return service.label;
  });
}

function getRankingIndex(ranking) {
  return Object.values(RANKINGS).findIndex(function (r) {
    return r === ranking;
  });
}

function isProductExclusiveCollection(comfort) {
  return comfort > 4;
} // eslint-disable-next-line clubmed/no-fake-component


function getAccommodation(_ref3) {
  var accommodation = _ref3.accommodation,
      categoryLabel = _ref3.categoryLabel,
      resortComfort = _ref3.resortComfort,
      streetView = _ref3.streetView,
      i18n = _ref3.i18n;
  var areas = accommodation.areas,
      categoryId = accommodation.categoryId,
      comfortId = accommodation.comfortId,
      comfortType = accommodation.comfortType,
      description = accommodation.description,
      floorPlans = accommodation.floorPlans,
      id = accommodation.id,
      label = accommodation.label,
      photos = accommodation.media.photos,
      productId = accommodation.productId;

  var _mapAccommodationStre = mapAccommodationStrengths(i18n, accommodation),
      strengths = _mapAccommodationStre.strengths,
      strengthsCompact = _mapAccommodationStre.strengthsCompact,
      strengthsAlternate = _mapAccommodationStre.strengthsAlternate;

  var isDisplayable = [comfortType, label].every(function (item) {
    return !!item;
  });
  var isExclusiveCollection = isProductExclusiveCollection(resortComfort) || accommodation.exclusiveCollection;
  var images = photos.map(function (_ref4) {
    var url = _ref4.url;
    return {
      src: url
    };
  });
  var streetViews = !isEmpty_default()(streetView) && !!streetView.streetView ? [streetView.streetView] : undefined;
  var details = {
    areas: areas,
    categoryId: categoryId,
    comfort: resortComfort,
    comfortType: comfortType,
    comfortId: comfortId,
    description: description,
    floorPlans: floorPlans,
    immersive: {
      url: get_default()(photos, '[0].url')
    },
    isExclusiveCollection: isExclusiveCollection,
    label: label,
    categoryLabel: categoryLabel,
    overview: strengths,
    overviewCompact: strengthsCompact,
    overviewAlternate: strengthsAlternate,
    strengthsLabel: i18n.strengthsLabel,
    amenitiesLabel: i18n.amenitiesLabel,
    services: mapAccommodationServices(i18n, accommodation, isExclusiveCollection),
    slideshow: {
      groupeKey: 'roomCard',
      media: images
    },
    multimedia: {
      photos: photos,
      streetViews: streetViews
    },
    productId: productId
  };
  return isDisplayable && productAccommodations_utils_jsx(ProductRoomCard_ProductRoomCard, {
    fetchDetail: function fetchDetail() {
      return Promise.resolve(details);
    },
    isExclusiveCollection: isExclusiveCollection,
    key: id,
    labeledIconsList: strengths,
    media: images,
    seeMoreLabel: i18n.seeMore,
    title: label
  });
}

function renderDetail() {
  return function (_ref5) {
    var areas = _ref5.areas,
        comfort = _ref5.comfort,
        comfortType = _ref5.comfortType,
        description = _ref5.description,
        floorPlans = _ref5.floorPlans,
        isExclusiveCollection = _ref5.isExclusiveCollection,
        immersive = _ref5.immersive,
        label = _ref5.label,
        categoryLabel = _ref5.categoryLabel,
        overview = _ref5.overview,
        overviewCompact = _ref5.overviewCompact,
        overviewAlternate = _ref5.overviewAlternate,
        strengthsLabel = _ref5.strengthsLabel,
        amenitiesLabel = _ref5.amenitiesLabel,
        services = _ref5.services,
        slideshow = _ref5.slideshow,
        multimedia = _ref5.multimedia,
        productId = _ref5.productId;
    var customProps = {
      areas: areas,
      description: description,
      title: label,
      subtitle: categoryLabel,
      diamond: {
        label: comfortType
      },
      floorPlans: floorPlans,
      immersive: immersive,
      isExclusiveCollection: isProductExclusiveCollection(comfort) || isExclusiveCollection,
      overview: overview,
      overviewCompact: overviewCompact,
      overviewAlternate: overviewAlternate,
      strengthsLabel: strengthsLabel,
      amenitiesLabel: amenitiesLabel,
      services: services,
      slideshow: slideshow,
      multimedia: multimedia,
      productId: productId
    };
    return productAccommodations_utils_jsx(ProductRoomDetail_ProductRoomDetail, customProps);
  };
}

var productAccommodations_utils_getAllAvailableItems = function getAllAvailableItems(accommodationCategories, itemType) {
  return Object(dist["sortByRanking"])(accommodationCategories.reduce(function (items, accommodationCategory) {
    return unionBy_default()(items, accommodationCategory[itemType], 'id');
  }, []));
};

var isHighOrVeryHighRanking = function isHighOrVeryHighRanking(_ref6) {
  var ranking = _ref6.ranking;
  return [RANKINGS.VERY_HIGH, RANKINGS.HIGH].includes(ranking);
};

var withExclusiveCollectionTag = function withExclusiveCollectionTag(_ref7) {
  var _ref7$categoryId = _ref7.categoryId,
      categoryId = _ref7$categoryId === void 0 ? '' : _ref7$categoryId,
      isExclusiveCollection = _ref7.isExclusiveCollection;
  return ['typeoflodging_comfort_type_deluxe', 'typeoflodging_comfort_type_suite'].includes(categoryId) && isExclusiveCollection ? "".concat(categoryId, "_EC") : categoryId;
};
function groupAccommodationsByCategory(props) {
  var _props$accommodationC = props.accommodationCategory;
  _props$accommodationC = _props$accommodationC === void 0 ? {} : _props$accommodationC;
  var _props$accommodationC2 = _props$accommodationC.rankedCategories,
      rankedCategories = _props$accommodationC2 === void 0 ? [] : _props$accommodationC2,
      bathroomLabel = props.bathroomLabel,
      capacityOfPeopleLabel = props.capacityOfPeopleLabel,
      strengthsLabel = props.strengthsLabel,
      amenitiesLabel = props.amenitiesLabel,
      equipmentLabel = props.equipmentLabel,
      numberOfPeopleLabel = props.numberOfPeopleLabel,
      _props$resort = props.resort,
      _props$resort$accommo = _props$resort.accommodations,
      accommodations = _props$resort$accommo === void 0 ? [] : _props$resort$accommo,
      _props$resort$areas = _props$resort.areas,
      resortAreas = _props$resort$areas === void 0 ? [] : _props$resort$areas,
      _props$resort$comfort = _props$resort.comfort,
      resortComfort = _props$resort$comfort === void 0 ? 3 : _props$resort$comfort,
      type = _props$resort.type,
      productId = _props$resort.id,
      _props$roomConfigurat = props.roomConfiguration;
  _props$roomConfigurat = _props$roomConfigurat === void 0 ? {} : _props$roomConfigurat;
  var singleRoom = _props$roomConfigurat.singleRoom,
      connectingRooms = _props$roomConfigurat.connectingRooms,
      separatedRooms = _props$roomConfigurat.separatedRooms,
      seeMore = props.seeMore,
      servicesLabel = props.servicesLabel,
      streetViews = props.streetViews;
  var i18n = {
    bathroomLabel: bathroomLabel,
    capacityOfPeopleLabel: capacityOfPeopleLabel,
    strengthsLabel: strengthsLabel,
    amenitiesLabel: amenitiesLabel,
    connectingRooms: connectingRooms,
    equipmentLabel: equipmentLabel,
    numberOfPeopleLabel: numberOfPeopleLabel,
    seeMore: seeMore,
    separatedRooms: separatedRooms,
    servicesLabel: servicesLabel,
    singleRoom: singleRoom,
    surfaceLabel: Object(src_i18n["h" /* t */])('accommodations.surfaceLabel')
  }; // $FlowFixMe

  return Object.values( // $FlowFixMe
  accommodations.reduce(function (categories, accommodation) {
    // Ranking index to sort categories and accommodations within a category
    var rankedCategory = rankedCategories.find(function (c) {
      return c.id === accommodation.categoryId;
    });
    var categoryRanking = rankedCategory ? rankedCategory.ranking : DEFAULT_RANKING;
    var categoryIndex = getRankingIndex(categoryRanking);
    var streetView = streetViews && (streetViews === null || streetViews === void 0 ? void 0 : streetViews.length) > 0 ? streetViews.find(function (sv) {
      return sv.accommodationCategoryId === accommodation.categoryId;
    }) : []; // Accommodation tabs are now based on accommodation comfort, not category...

    var categoryId = accommodation.comfortId;
    var categoryLabel = accommodation.comfortType; // ...except for VILLA products

    if (type === PRODUCT_TYPES.VILLA) {
      // eslint-disable-next-line prefer-destructuring
      categoryId = accommodation.categoryId;
      categoryLabel = accommodation.category;
    }

    if (!categoryId) {
      return categories;
    } // Ranking index to sort accommodations within a category


    var accommodationIndex = getRankingIndex(accommodation.ranking);
    var accommodationProps = {
      accommodation: productAccommodations_utils_objectSpread(productAccommodations_utils_objectSpread({}, accommodation), {}, {
        areas: (accommodation.areas || []).map(function (area) {
          var _resortAreas$find;

          return {
            id: area.id,
            label: ((_resortAreas$find = resortAreas.find(function (_ref8) {
              var resortAreaId = _ref8.id;
              return resortAreaId === area.id;
            })) === null || _resortAreas$find === void 0 ? void 0 : _resortAreas$find.label) || ''
          };
        }),
        productId: productId
      }),
      accommodationIndex: accommodationIndex,
      categoryLabel: categoryLabel,
      categoryIndex: categoryIndex,
      colorId: accommodation.categoryId,
      resortComfort: resortComfort,
      streetView: streetView,
      i18n: i18n
    };
    categoryId = withExclusiveCollectionTag({
      categoryId: categoryId,
      isExclusiveCollection: accommodation.exclusiveCollection
    });

    if (categories[categoryId]) {
      var _accommodation$area, _categories$categoryI, _accommodation$area2, _accommodation$area3, _categories$categoryI2; // Add accommodation to category if it exists


      categories[categoryId].categoryAccommodations.push(accommodationProps);

      if (!categories[categoryId].minCapacity || accommodation.minCapacity && categories[categoryId].minCapacity > accommodation.minCapacity) {
        categories[categoryId].minCapacity = accommodation.minCapacity;
      }

      if (!categories[categoryId].maxCapacity || accommodation.maxCapacity && categories[categoryId].maxCapacity < accommodation.maxCapacity) {
        categories[categoryId].maxCapacity = accommodation.maxCapacity;
      }

      if (((_accommodation$area = accommodation.area) === null || _accommodation$area === void 0 ? void 0 : _accommodation$area.min) && accommodation.area.min < ((_categories$categoryI = categories[categoryId].area) === null || _categories$categoryI === void 0 ? void 0 : _categories$categoryI.min)) {
        categories[categoryId].area.min = accommodation.area.min;
      }

      if (((_accommodation$area2 = accommodation.area) === null || _accommodation$area2 === void 0 ? void 0 : _accommodation$area2.max) && ((_accommodation$area3 = accommodation.area) === null || _accommodation$area3 === void 0 ? void 0 : _accommodation$area3.max) > ((_categories$categoryI2 = categories[categoryId].area) === null || _categories$categoryI2 === void 0 ? void 0 : _categories$categoryI2.max)) {
        var _accommodation$area4;

        categories[categoryId].area.max = (_accommodation$area4 = accommodation.area) === null || _accommodation$area4 === void 0 ? void 0 : _accommodation$area4.max;
      }

      categories[categoryId].exclusiveCollection = accommodation.exclusiveCollection && categories[categoryId].exclusiveCollection;
      categories[categoryId].equipments = intersectionBy_default()(categories[categoryId].equipments, accommodation.equipments.filter(isHighOrVeryHighRanking), 'id');
      categories[categoryId].services = intersectionBy_default()(categories[categoryId].services, accommodation.services.filter(isHighOrVeryHighRanking), 'id');
      categories[categoryId].strengths = unionBy_default()(categories[categoryId].strengths, [].concat(Object(toConsumableArray["a" /* default */])((accommodation.view ? [accommodation.view] : []).map(function (v) {
        return productAccommodations_utils_objectSpread(productAccommodations_utils_objectSpread({}, v), {}, {
          ranking: 1
        });
      })), Object(toConsumableArray["a" /* default */])((accommodation.strengths || []).map(function (strength) {
        return productAccommodations_utils_objectSpread(productAccommodations_utils_objectSpread({}, strength), {}, {
          ranking: 2
        });
      })), Object(toConsumableArray["a" /* default */])((accommodation.outsideFacilities || []).map(function (outsideFacility) {
        return productAccommodations_utils_objectSpread(productAccommodations_utils_objectSpread({}, outsideFacility), {}, {
          ranking: 3
        });
      }))), 'id').sort(function (sA, sB) {
        return sA.ranking - sB.ranking;
      });
      categories[categoryId].bathroomEquipments = intersectionBy_default()(categories[categoryId].bathroomEquipments, accommodation.bathroomEquipments, 'id');
    } else {
      // Create category if it doesn't exist
      categories[categoryId] = {
        area: accommodation.area,
        bathroomEquipments: accommodation.bathroomEquipments,
        categoryAccommodations: [accommodationProps],
        categoryId: categoryId,
        categoryIndex: categoryIndex,
        categoryLabel: categoryLabel,
        equipments: accommodation.equipments.filter(isHighOrVeryHighRanking),
        exclusiveCollection: accommodation.exclusiveCollection,
        media: accommodation.media,
        maxCapacity: accommodation.maxCapacity,
        minCapacity: accommodation.minCapacity,
        productId: productId,
        services: accommodation.services.filter(isHighOrVeryHighRanking),
        strengths: [].concat(Object(toConsumableArray["a" /* default */])((accommodation.view ? [accommodation.view] : []).map(function (v) {
          return productAccommodations_utils_objectSpread(productAccommodations_utils_objectSpread({}, v), {}, {
            ranking: 1
          });
        })), Object(toConsumableArray["a" /* default */])((accommodation.strengths || []).map(function (strength) {
          return productAccommodations_utils_objectSpread(productAccommodations_utils_objectSpread({}, strength), {}, {
            ranking: 2
          });
        })), Object(toConsumableArray["a" /* default */])((accommodation.outsideFacilities || []).map(function (outsideFacility) {
          return productAccommodations_utils_objectSpread(productAccommodations_utils_objectSpread({}, outsideFacility), {}, {
            ranking: 3
          });
        })))
      };
    }

    return categories;
  }, {}) // $FlowFixMe
  ).sort(function (a, b) {
    return b.categoryIndex - a.categoryIndex;
  });
}
function getTabsItemsAndPropsFromAccommodations(props, accommodationCategories) {
  var isLineExclusiveCollection = props.isLineExclusiveCollection,
      resortIsExclusiveCollection = props.resort.isExclusiveCollection;
  var hiddenItemsCount = 0;
  var items = // I have no idea what's going on there and to be honest I don't care enough
  // sorry to the person who'll be reading that in the future but I give up
  // $FlowFixMe
  accommodationCategories.map(function (accommodationCategory, index) {
    // $FlowFixMe
    var categoryAccommodations = accommodationCategory.categoryAccommodations,
        categoryLabel = accommodationCategory.categoryLabel; // We need to sort with the upper index first. Since Array.sort is broken client side (why??),
    // we use the lodash function which only sorts from the lower to the upper. We knows that the
    // accomodations are already sorted by accomodationIdex so we have to sort by categoryIndex.
    // The tricky part is here: we cannot reverse the output of lodash.sortBy, so we sort with a
    // negative categoryIndex.

    var categoryAccommodationsProps = sortBy_default()(Object(toConsumableArray["a" /* default */])(categoryAccommodations), function (_ref9) {
      var categoryIndex = _ref9.categoryIndex;
      return -1 * categoryIndex;
    });

    var content = categoryAccommodationsProps.map(getAccommodation).filter(Boolean);

    if (content.length === 0) {
      return null;
    } // $FlowFixMe


    var isLarge = content.every(function (item) {
      return item.props.isExclusiveCollection;
    });
    var shouldDisplayAsExclusiveCollection = isLarge && !resortIsExclusiveCollection || resortIsExclusiveCollection;

    if (isLineExclusiveCollection && isLarge || !isLineExclusiveCollection) {
      return {
        header: {
          title: "".concat(categoryLabel, " ").concat(isLarge && !resortIsExclusiveCollection ? Object(src_i18n["h" /* t */])('common.exclusiveCollectionLabel') : ''),
          trackingData: {
            categoryGA: 'resort',
            actionGA: 'blockInfos',
            labelGA: "".concat(isLineExclusiveCollection ? 'eCollection' : 'accommodations', "_").concat(categoryLabel)
          },
          headerClassNames: shouldDisplayAsExclusiveCollection ? {
            active: 'font-sans text-ultramarine',
            inactive: 'font-sans'
          } : {}
        },
        content: [productAccommodations_utils_jsx(ProductInformationSlider_container["a" /* ProductInformationSliderContainer */], {
          backNavigationLabel: Object(src_i18n["h" /* t */])('common.backNavigation'),
          theme: "short",
          errorMessage: "error",
          isLarge: isLarge,
          key: "ProductAccommodationsSlider_".concat(categoryLabel),
          queryLayer: isLineExclusiveCollection ? 'accommodationLayerEC' : 'accommodationLayer',
          renderDetail: renderDetail(),
          scrollBackwardLabel: Object(src_i18n["h" /* t */])('common.scrollBackward'),
          scrollForwardLabel: Object(src_i18n["h" /* t */])('common.scrollForward'),
          sliderIndex: index - hiddenItemsCount
        }, content)]
      };
    }

    hiddenItemsCount++;
    return null;
  }).filter(function (item) {
    return item !== null;
  });

  var slot = function slot(activeIndexes) {
    return productAccommodations_utils_jsx(ProductRoomsComparatorLauncher["a" /* ProductRoomsComparatorLauncher */], {
      accommodationCategories: accommodationCategories,
      activeIndex: activeIndexes[0],
      exclusiveCollectionLabel: Object(src_i18n["h" /* t */])('common.exclusiveCollectionLabel'),
      resortIsExclusiveCollection: resortIsExclusiveCollection
    });
  };

  return {
    items: items,
    slot: slot
  };
}

/***/ }),

/***/ "695J":
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _setPrototypeOf(o, p);
}
module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "7Z8V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLOSE_TOAST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return OPEN_TOAST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return closeToast; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return openToast; });
/* unused harmony export showTemporaryToast */
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("JtPf");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("rJ95");



var CLOSE_TOAST = 'CLOSE_TOAST';
var OPEN_TOAST = 'OPEN_TOAST';

function openToast(toastLabel, className, style) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_2__[/* default */ "b"])(OPEN_TOAST, {
    className: className,
    toastLabel: toastLabel,
    style: style
  });
}

function closeToast() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_2__[/* default */ "b"])(CLOSE_TOAST);
}

var showTemporaryToast = function showTemporaryToast(_ref) {
  var className = _ref.className,
      style = _ref.style,
      _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === void 0 ? 2000 : _ref$timeout,
      toastLabel = _ref.toastLabel;
  return function (dispatch) {
    return Promise.resolve(dispatch(openToast(toastLabel, className, style))).then(function () {
      setTimeout(function () {
        return dispatch(closeToast());
      }, timeout);
    });
  };
};



/***/ }),

/***/ "8soX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isSymbol2 = __webpack_require__("a88S");

var _isSymbol3 = _interopRequireDefault(_isSymbol2);

var _isString2 = __webpack_require__("nDih");

var _isString3 = _interopRequireDefault(_isString2);

var _isPlainObject2 = __webpack_require__("Kkar");

var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);

exports.isFSA = isFSA;
exports.isError = isError;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isFSA(action) {
  return (0, _isPlainObject3.default)(action) && ((0, _isString3.default)(action.type) || (0, _isSymbol3.default)(action.type)) && Object.keys(action).every(isValidKey);
}

function isError(action) {
  return action.error === true;
}

function isValidKey(key) {
  return ['type', 'payload', 'error', 'meta'].indexOf(key) > -1;
}

/***/ }),

/***/ "9BmX":
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__("dw5g");

/**
 * Converts `string`, as a whole, to upper case just like
 * [String#toUpperCase](https://mdn.io/toUpperCase).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the upper cased string.
 * @example
 *
 * _.toUpper('--foo-bar--');
 * // => '--FOO-BAR--'
 *
 * _.toUpper('fooBar');
 * // => 'FOOBAR'
 *
 * _.toUpper('__foo_bar__');
 * // => '__FOO_BAR__'
 */
function toUpper(value) {
  return toString(value).toUpperCase();
}

module.exports = toUpper;


/***/ }),

/***/ "9tk8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ProductRoomsComparatorLauncher_ProductRoomsComparatorLauncher; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__("vrRf");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("lTEL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("M+/F");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.sort.js
var es_array_sort = __webpack_require__("tQbP");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.set.js
var es_set = __webpack_require__("LqLs");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__("87if");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("kYxP");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/lines/product-accommodations-line/productAccommodations.utils.js + 3 modules
var productAccommodations_utils = __webpack_require__("5svr");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTrackEvent.js
var useTrackEvent = __webpack_require__("DqI1");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/layer/Layer.jsx + 4 modules
var Layer = __webpack_require__("U2fG");

// EXTERNAL MODULE: ./src/client/components/frameworks/template-string/TemplateString.jsx
var TemplateString = __webpack_require__("Ohju");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// CONCATENATED MODULE: ./src/client/components/widgets/product-rooms-comparator/ProductRoomsComparator.utils.js
var ITEMS_ORDER = ['services', 'equipments', 'bathroomEquipments'];
var SECTION_LABELS = {
  equipments: 'common.accommodations.equipments',
  services: 'common.accommodations.services',
  bathroomEquipments: 'common.accommodations.bathroomEquipments'
};
var sortCategoriesItems = function sortCategoriesItems(_ref, _ref2) {
  var rankingA = _ref.ranking;
  var rankingB = _ref2.ranking;

  if (rankingB < rankingA) {
    return 1;
  }

  if (rankingB > rankingA) {
    return -1;
  }
};
// EXTERNAL MODULE: ./src/client/components/utils/ratios/ratios.utils.js
var ratios_utils = __webpack_require__("u/u4");

// EXTERNAL MODULE: ./src/client/components/frameworks/labeled-icons-list/LabeledIconsList.jsx + 1 modules
var LabeledIconsList = __webpack_require__("LR4h");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/widgets/product-rooms-comparator/ProductRoomsComparatorLarge.jsx



var __jsx = react_default.a.createElement;









var ProductRoomsComparatorLarge_ProductRoomsComparatorLarge = function ProductRoomsComparatorLarge(_ref) {
  var allCategoriesItems = _ref.allCategoriesItems,
      availabilityBoards = _ref.availabilityBoards,
      columns = _ref.columns;
  var _thTitle$thInfoTitle$ = {
    thTitle: 'font-brand text-20 text-black text-center',
    thInfoTitle: 'text-mediumGrey flex gap-15 items-center py-10',
    thInfo: 'font-bold text-16 flex items-center justify-center',
    thStrength: 'py-10 flex items-center justify-center',
    thSectionHeader: 'flex mb-20',
    thSectionTitle: 'font-bold text-22 text-black',
    thSectionHeaderItem: 'flex items-center justify-center',
    thIcon: 'text-black me-15 shrink-0',
    thTableCell: 'px-10',
    thCheck: 'flex items-center justify-center'
  },
      thTitle = _thTitle$thInfoTitle$.thTitle,
      thInfoTitle = _thTitle$thInfoTitle$.thInfoTitle,
      thInfo = _thTitle$thInfoTitle$.thInfo,
      thStrength = _thTitle$thInfoTitle$.thStrength,
      thSectionHeader = _thTitle$thInfoTitle$.thSectionHeader,
      thSectionTitle = _thTitle$thInfoTitle$.thSectionTitle,
      thSectionHeaderItem = _thTitle$thInfoTitle$.thSectionHeaderItem,
      thIcon = _thTitle$thInfoTitle$.thIcon,
      thTableCell = _thTitle$thInfoTitle$.thTableCell,
      thCheck = _thTitle$thInfoTitle$.thCheck;
  var columnWidth = "".concat(100 / (columns.length + 1), "%");

  var getHorizontalAvailabilityLinesFromItemType = function getHorizontalAvailabilityLinesFromItemType(itemType) {
    return allCategoriesItems[ITEMS_ORDER.indexOf(itemType)].sort(sortCategoriesItems).map(function (item, index) {
      return __jsx("div", {
        className: "flex",
        key: index
      }, __jsx("div", {
        className: "flex items-center py-10 text-16",
        style: {
          width: columnWidth
        }
      }, __jsx(Icon["a" /* Icon */], {
        alt: "",
        className: thIcon,
        name: icons["a" /* ICONS */][item.id] || icons["a" /* ICONS */].TRIDENT1,
        width: "1.25rem"
      }), item.label), availabilityBoards.map(function (board, boardIndex) {
        return __jsx("div", {
          key: boardIndex,
          className: Object(classnames_utils["a" /* classnames */])(thTableCell, thCheck),
          style: {
            width: columnWidth
          }
        }, __jsx(Icon["a" /* Icon */], {
          className: board[itemType][index] ? 'text-green' : 'text-grey',
          name: board[itemType][index] ? icons["a" /* ICONS */].CHECK : icons["a" /* ICONS */].CROSS,
          width: "1rem"
        }));
      }));
    });
  };

  return __jsx("div", {
    className: "mx-auto max-w-site px-20 pt-60"
  }, __jsx("div", {
    className: "flex justify-end"
  }, columns.map(function (column, index) {
    var _column$picture;

    return __jsx("div", {
      className: Object(classnames_utils["a" /* classnames */])('text-center', thTableCell),
      key: index,
      style: {
        width: columnWidth
      }
    }, __jsx("div", {
      className: "mb-30 max-h-30"
    }, __jsx("div", {
      className: thTitle
    }, column.title), column.price && __jsx("div", {
      className: "font-sans font-bold text-black"
    }, column.price)), __jsx("div", {
      className: "overflow-hidden rounded-12"
    }, __jsx(Image["a" /* Image */], {
      altMsg: column.title,
      hasLazyLoading: true,
      imageUrl: (_column$picture = column.picture) === null || _column$picture === void 0 ? void 0 : _column$picture.url,
      ratioKey: ratios_utils["c" /* default */].XL
    })));
  })), __jsx("div", {
    className: "flex"
  }, __jsx("div", {
    className: thInfoTitle,
    style: {
      width: columnWidth
    }
  }, __jsx(Icon["a" /* Icon */], {
    className: "text-black",
    name: icons["a" /* ICONS */].SINGLE_ROOM,
    width: "1.875rem"
  }), Object(i18n["h" /* t */])('common.accommodations.size')), columns.map(function (column, index) {
    return __jsx("div", {
      key: index,
      className: Object(classnames_utils["a" /* classnames */])(thTableCell, thInfo),
      style: {
        width: columnWidth
      }
    }, column.surface);
  })), __jsx("div", {
    className: "flex"
  }, __jsx("div", {
    className: thInfoTitle,
    style: {
      width: columnWidth
    }
  }, __jsx(Icon["a" /* Icon */], {
    className: "text-black",
    name: icons["a" /* ICONS */].PEOPLE_DOUBLE,
    width: "1.875rem"
  }), Object(i18n["h" /* t */])('common.accommodations.capacity')), columns.map(function (column, index) {
    return __jsx("div", {
      key: index,
      className: Object(classnames_utils["a" /* classnames */])(thTableCell, thInfo),
      style: {
        width: columnWidth
      }
    }, column.capacity);
  })), __jsx("div", {
    className: "flex"
  }, __jsx("div", {
    className: thInfoTitle,
    style: {
      width: columnWidth
    }
  }, Object(i18n["h" /* t */])('common.accommodations.strengths')), columns.map(function (column, index) {
    return __jsx("div", {
      key: index,
      className: Object(classnames_utils["a" /* classnames */])(thTableCell, thStrength),
      style: {
        width: columnWidth
      }
    }, __jsx(LabeledIconsList["a" /* LabeledIconsList */], {
      items: column.strengths.map(function (strength) {
        return {
          icon: icons["a" /* ICONS */][strength.id] || icons["a" /* ICONS */].TRIDENT1,
          labels: [strength.label]
        };
      }),
      theme: "comparator"
    }));
  })), ITEMS_ORDER.map(function (itemType) {
    return !!allCategoriesItems[ITEMS_ORDER.indexOf(itemType)].length && __jsx("div", {
      key: itemType,
      className: "border-t-1 border-lightGrey py-30"
    }, __jsx("div", {
      className: thSectionHeader
    }, __jsx("div", {
      className: thSectionTitle,
      style: {
        width: columnWidth
      }
    }, Object(i18n["h" /* t */])(SECTION_LABELS[itemType])), columns.map(function (column, index) {
      return __jsx("div", {
        key: index,
        className: Object(classnames_utils["a" /* classnames */])(thTitle, thSectionHeaderItem, thTableCell),
        style: {
          width: columnWidth
        }
      }, column.title);
    })), getHorizontalAvailabilityLinesFromItemType(itemType));
  }));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/slider/Slider.jsx + 1 modules
var Slider = __webpack_require__("ZFcn");

// CONCATENATED MODULE: ./src/client/components/widgets/product-rooms-comparator/ProductRoomsComparatorNarrow.jsx



var ProductRoomsComparatorNarrow_jsx = react_default.a.createElement;









var ProductRoomsComparatorNarrow_ProductRoomsComparatorNarrow = function ProductRoomsComparatorNarrow(_ref) {
  var allCategoriesItems = _ref.allCategoriesItems,
      availabilityBoards = _ref.availabilityBoards,
      columns = _ref.columns;
  var _thColumn$thTitle$thI = {
    thColumn: 'bg-white border-1 border-lightGrey rounded-12 shadow-diffuse',
    thTitle: 'p-15 leading-tight font-brand text-20 text-black',
    thInfoTitle: 'flex items-center pt-10 text-mediumGrey text-14',
    thInfo: 'ms-auto font-bold text-16',
    thSectionHeader: 'flex',
    thSectionTitle: 'font-bold text-18 text-black',
    thIcon: 'text-black shrink-0',
    thCheck: 'flex items-center justify-center'
  },
      thColumn = _thColumn$thTitle$thI.thColumn,
      thTitle = _thColumn$thTitle$thI.thTitle,
      thInfoTitle = _thColumn$thTitle$thI.thInfoTitle,
      thInfo = _thColumn$thTitle$thI.thInfo,
      thSectionHeader = _thColumn$thTitle$thI.thSectionHeader,
      thSectionTitle = _thColumn$thTitle$thI.thSectionTitle,
      thIcon = _thColumn$thTitle$thI.thIcon,
      thCheck = _thColumn$thTitle$thI.thCheck;

  var getItemsAvailability = function getItemsAvailability(itemType, columnIndex) {
    return allCategoriesItems[ITEMS_ORDER.indexOf(itemType)].sort(sortCategoriesItems).map(function (item, index) {
      return ProductRoomsComparatorNarrow_jsx("div", {
        key: index,
        className: "flex items-baseline justify-between"
      }, ProductRoomsComparatorNarrow_jsx("div", {
        className: "flex items-center gap-15 pt-20 text-16"
      }, ProductRoomsComparatorNarrow_jsx(Icon["a" /* Icon */], {
        alt: "",
        className: thIcon,
        name: icons["a" /* ICONS */][item.id] || icons["a" /* ICONS */].TRIDENT1,
        width: "1.25rem"
      }), item.label), ProductRoomsComparatorNarrow_jsx("div", {
        className: Object(classnames_utils["a" /* classnames */])(thCheck)
      }, ProductRoomsComparatorNarrow_jsx(Icon["a" /* Icon */], {
        className: availabilityBoards[columnIndex][itemType][index] ? 'text-green' : 'text-grey',
        name: availabilityBoards[columnIndex][itemType][index] ? icons["a" /* ICONS */].CHECK : icons["a" /* ICONS */].CROSS,
        width: "1rem"
      })));
    });
  };

  return ProductRoomsComparatorNarrow_jsx("div", {
    className: "mx-auto max-w-site px-20 pt-30"
  }, ProductRoomsComparatorNarrow_jsx(Slider["a" /* Slider */], {
    cols: 0,
    navPosition: "center",
    nbItemsToScroll: 1,
    scrollAreaClassName: "overflow-hidden -mx-10",
    scrollAreaContainerClassName: "overflow-auto scroll-x scrollbar-hidden snap-x snap-mandatory",
    scrollItemClassName: "overflow-hidden px-10 pb-20 flex-none max-w-full"
  }, columns.map(function (column, columnIndex) {
    var _column$picture;

    return ProductRoomsComparatorNarrow_jsx("div", {
      key: columnIndex,
      className: Object(classnames_utils["a" /* classnames */])(thColumn, 'w-[80vw]')
    }, ProductRoomsComparatorNarrow_jsx("div", {
      className: thTitle
    }, column.title, column.price && ProductRoomsComparatorNarrow_jsx("div", {
      className: "font-sans"
    }, column.price)), ProductRoomsComparatorNarrow_jsx(Image["a" /* Image */], {
      altMsg: column.title,
      hasLazyLoading: true,
      imageUrl: (_column$picture = column.picture) === null || _column$picture === void 0 ? void 0 : _column$picture.url,
      ratioKey: ratios_utils["c" /* default */].XL
    }), ProductRoomsComparatorNarrow_jsx("p", {
      className: "flex items-baseline gap-5 px-15"
    }, ProductRoomsComparatorNarrow_jsx("span", {
      className: thInfoTitle
    }, Object(i18n["h" /* t */])('common.accommodations.size')), ProductRoomsComparatorNarrow_jsx("span", {
      className: thInfo
    }, column.surface)), ProductRoomsComparatorNarrow_jsx("p", {
      className: "flex items-baseline gap-5 px-15"
    }, ProductRoomsComparatorNarrow_jsx("span", {
      className: thInfoTitle
    }, Object(i18n["h" /* t */])('common.accommodations.capacity')), ProductRoomsComparatorNarrow_jsx("span", {
      className: thInfo
    }, column.capacity)), column.strengths.length > 0 && ProductRoomsComparatorNarrow_jsx("div", {
      className: "px-15 pb-15 pt-10"
    }, ProductRoomsComparatorNarrow_jsx("div", {
      className: thInfoTitle
    }, Object(i18n["h" /* t */])('common.accommodations.strengths')), column.strengths.map(function (strength) {
      return ProductRoomsComparatorNarrow_jsx("div", {
        key: strength.id,
        className: "flex items-center gap-5 pt-5"
      }, ProductRoomsComparatorNarrow_jsx(Icon["a" /* Icon */], {
        className: "text-black",
        name: icons["a" /* ICONS */][strength.id],
        width: "1rem"
      }), strength.label);
    })), ITEMS_ORDER.map(function (itemType, itemIndex) {
      return !!allCategoriesItems[ITEMS_ORDER.indexOf(itemType)].length && ProductRoomsComparatorNarrow_jsx("div", {
        key: itemIndex,
        className: Object(classnames_utils["a" /* classnames */])('border-t-1 border-lightGrey px-15 pb-30 pt-20', {
          'mt-10': itemIndex === 0
        })
      }, ProductRoomsComparatorNarrow_jsx("div", {
        className: thSectionHeader
      }, ProductRoomsComparatorNarrow_jsx("div", {
        className: thSectionTitle
      }, Object(i18n["h" /* t */])(SECTION_LABELS[itemType]))), getItemsAvailability(itemType, columnIndex));
    }));
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-rooms-comparator/ProductRoomsComparatorLauncher.jsx










var ProductRoomsComparatorLauncher_jsx = react_default.a.createElement;

















var PriceBlock = function PriceBlock(_ref) {
  var _category$price6;

  var category = _ref.category,
      forceDiffPrice = _ref.forceDiffPrice,
      _ref$isActive = _ref.isActive,
      isActive = _ref$isActive === void 0 ? false : _ref$isActive;

  if (isActive && !forceDiffPrice) {
    var _category$price, _category$price2, _category$price2$init, _category$price3, _category$price3$best, _category$price4, _category$price4$init, _category$price5, _category$price5$best;

    return ProductRoomsComparatorLauncher_jsx("div", {
      className: "text-18 font-bold"
    }, ((_category$price = category.price) === null || _category$price === void 0 ? void 0 : _category$price.initialPrice) && ((_category$price2 = category.price) === null || _category$price2 === void 0 ? void 0 : (_category$price2$init = _category$price2.initialPrice) === null || _category$price2$init === void 0 ? void 0 : _category$price2$init.value) !== ((_category$price3 = category.price) === null || _category$price3 === void 0 ? void 0 : (_category$price3$best = _category$price3.bestPrice) === null || _category$price3$best === void 0 ? void 0 : _category$price3$best.value) ? ProductRoomsComparatorLauncher_jsx("span", {
      className: "text-14 line-through text-sienna font-normal pe-5"
    }, (_category$price4 = category.price) === null || _category$price4 === void 0 ? void 0 : (_category$price4$init = _category$price4.initialPrice) === null || _category$price4$init === void 0 ? void 0 : _category$price4$init.formattedValue) : null, (_category$price5 = category.price) === null || _category$price5 === void 0 ? void 0 : (_category$price5$best = _category$price5.bestPrice) === null || _category$price5$best === void 0 ? void 0 : _category$price5$best.formattedValue);
  }

  return ProductRoomsComparatorLauncher_jsx("div", {
    className: "text-18 font-bold"
  }, (_category$price6 = category.price) === null || _category$price6 === void 0 ? void 0 : _category$price6.diffPrice);
};

var ProductRoomsComparatorLauncher_ProductRoomsComparatorLauncher = function ProductRoomsComparatorLauncher(_ref2) {
  var accommodationCategories = _ref2.accommodationCategories,
      activeIndex = _ref2.activeIndex,
      className = _ref2.className,
      exclusiveCollectionLabel = _ref2.exclusiveCollectionLabel,
      _ref2$forceDiffPrice = _ref2.forceDiffPrice,
      forceDiffPrice = _ref2$forceDiffPrice === void 0 ? false : _ref2$forceDiffPrice,
      _ref2$resortIsExclusi = _ref2.resortIsExclusiveCollection,
      resortIsExclusiveCollection = _ref2$resortIsExclusi === void 0 ? false : _ref2$resortIsExclusi;

  var _useState = Object(react["useState"])(false),
      isLayerOpened = _useState[0],
      setIsLayerOpened = _useState[1];

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var allCategoriesItems = ITEMS_ORDER.map(function (itemType) {
    return Object(productAccommodations_utils["a" /* getAllAvailableItems */])(accommodationCategories, itemType);
  });
  var columns = accommodationCategories.map(function (category, index) {
    var _category$price7, _category$area, _category$area2, _category$area3, _category$area4;

    var hasPrice = ((_category$price7 = category.price) === null || _category$price7 === void 0 ? void 0 : _category$price7.bestPrice) || forceDiffPrice;
    return {
      title: "".concat(category.categoryLabel, " ").concat(category.exclusiveCollection && !resortIsExclusiveCollection ? ' ' + exclusiveCollectionLabel : ''),
      picture: category.media.photos[0],
      price: hasPrice ? ProductRoomsComparatorLauncher_jsx(PriceBlock, {
        category: category,
        forceDiffPrice: forceDiffPrice,
        isActive: index === activeIndex
      }) : null,
      isExclusiveCollection: category.exclusiveCollection || resortIsExclusiveCollection,
      isExclusiveCollectionSpace: category.exclusiveCollection && !resortIsExclusiveCollection,
      surface: ((_category$area = category.area) === null || _category$area === void 0 ? void 0 : _category$area.min) !== ((_category$area2 = category.area) === null || _category$area2 === void 0 ? void 0 : _category$area2.max) ? ProductRoomsComparatorLauncher_jsx(TemplateString["a" /* TemplateString */], {
        template: Object(i18n["h" /* t */])('common.accommodations.sizeFrom'),
        values: {
          min_area: "".concat(category.area.min).concat(category.area.unit),
          max_area: "".concat(category.area.max).concat(category.area.unit)
        }
      }) : "".concat((_category$area3 = category.area) === null || _category$area3 === void 0 ? void 0 : _category$area3.max).concat((_category$area4 = category.area) === null || _category$area4 === void 0 ? void 0 : _category$area4.unit),
      capacity: ProductRoomsComparatorLauncher_jsx(TemplateString["a" /* TemplateString */], {
        template: Object(i18n["h" /* t */])('common.accommodations.capacityFrom'),
        values: {
          min_capacity: "".concat(category.minCapacity),
          max_capacity: "".concat(category.maxCapacity)
        }
      }),
      strengths: Object(productAccommodations_utils["a" /* getAllAvailableItems */])([category], 'strengths').slice(0, 4)
    };
  });

  var getAvailabilityBoard = function getAvailabilityBoard(set, itemType) {
    var availableInCategory = new Set(set.map(function (_ref3) {
      var id = _ref3.id;
      return id;
    }));
    return allCategoriesItems[ITEMS_ORDER.indexOf(itemType)].sort(sortCategoriesItems).map(function (_ref4) {
      var id = _ref4.id;
      return availableInCategory.has(id);
    });
  };

  var availabilityBoards = accommodationCategories.map(function (category) {
    var availableEquipments = category.equipments;
    var availableServices = category.services;
    var availableBathroomEquipments = category.bathroomEquipments;
    var equipmentsAvailability = getAvailabilityBoard(availableEquipments, 'equipments');
    var servicesAvailability = getAvailabilityBoard(availableServices, 'services');
    var bathroomEquipmentsAvailability = getAvailabilityBoard(availableBathroomEquipments, 'bathroomEquipments');
    return {
      equipments: equipmentsAvailability,
      services: servicesAvailability,
      bathroomEquipments: bathroomEquipmentsAvailability
    };
  });
  return ProductRoomsComparatorLauncher_jsx(react["Fragment"], null, ProductRoomsComparatorLauncher_jsx(Button["a" /* Button */], {
    className: Object(classnames_utils["a" /* classnames */])('w-full', className),
    iconLeft: {
      name: icons["a" /* ICONS */].COMPARE
    },
    onClick: function onClick() {
      setIsLayerOpened(true);
      trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_ACCOMMODATION, {
        detail_click: 'compare_rooms'
      });
    }
  }, Object(i18n["h" /* t */])('common.accommodations.compareRooms')), isLayerOpened && ProductRoomsComparatorLauncher_jsx(Layer["b" /* Layer */], {
    ariaLabel: Object(i18n["h" /* t */])('common.accommodations.compareRooms'),
    bgColor: colors["a" /* COLORS */].WHITE,
    buttonLeft: {
      iconName: icons["a" /* ICONS */].ARROW_TAIL_LEFT,
      label: Object(i18n["h" /* t */])('common.backNavigation'),
      onClick: function onClick() {
        setIsLayerOpened(false);
      }
    },
    closeLabel: Object(i18n["h" /* t */])('common.close'),
    hasAnimateEnter: true,
    hasContainerHeader: true,
    header: ProductRoomsComparatorLauncher_jsx(Title["a" /* Title */], {
      className: "justify-center",
      theme: "title-brand-n3"
    }, Object(i18n["h" /* t */])('common.accommodations.compareRooms')),
    onClose: function onClose() {
      setIsLayerOpened(false);
    }
  }, isDesktop ? ProductRoomsComparatorLauncher_jsx(ProductRoomsComparatorLarge_ProductRoomsComparatorLarge, {
    columns: columns,
    availabilityBoards: availabilityBoards,
    allCategoriesItems: allCategoriesItems,
    accommodationCategories: accommodationCategories
  }) : ProductRoomsComparatorLauncher_jsx(ProductRoomsComparatorNarrow_ProductRoomsComparatorNarrow, {
    columns: columns,
    availabilityBoards: availabilityBoards,
    allCategoriesItems: allCategoriesItems,
    accommodationCategories: accommodationCategories
  })));
};

/***/ }),

/***/ "CYED":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DiscountsLine; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jQ/y");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("qBqs");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("SPKZ");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("kiXb");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_7__);



var __jsx = react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement;





var OFFERS = _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["constants"].OFFERS;
var DiscountsLine = function DiscountsLine(_ref) {
  var discounts = _ref.discounts;

  if (!(discounts === null || discounts === void 0 ? void 0 : discounts.length)) {
    return null;
  }

  return __jsx("div", {
    className: "my-10"
  }, discounts.map(function (discount) {
    var _discount$currentProp, _discount$currentProp2, _discount$currentProp3;

    return __jsx("div", {
      className: "mb-20 rounded-12 border-1 border-success bg-white p-20",
      key: discount.offerId
    }, __jsx("div", {
      className: "flex w-full justify-between"
    }, __jsx("div", {
      className: "flex w-2/3 md:gap-10"
    }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_4__[/* Icon */ "a"], {
      name: discount.offerId !== OFFERS.PROMO_CODE ? _utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].PROMOTION : _utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].PROMO_CODE,
      width: "1.875rem"
    }), __jsx("div", {
      className: "flex flex-col"
    }, __jsx("p", {
      className: "mb-0 font-bold leading-normal",
      style: {
        color: discount.offerColor
      }
    }, discount.offerId !== 'AVA' ? Object(_i18n__WEBPACK_IMPORTED_MODULE_6__[/* t */ "h"])('booking.summary.discount.discountLabel') : Object(_i18n__WEBPACK_IMPORTED_MODULE_6__[/* t */ "h"])('booking.summary.discount.discountCodeLabel')), __jsx("p", {
      className: "mb-0 leading-tight"
    }, ((_discount$currentProp = discount.currentProposalCode) === null || _discount$currentProp === void 0 ? void 0 : _discount$currentProp.label) || discount.offerLabel), ((_discount$currentProp2 = discount.currentProposalCode) === null || _discount$currentProp2 === void 0 ? void 0 : _discount$currentProp2.description) || discount.offerDescription && __jsx("p", {
      className: "mb-0 leading-tight"
    }, ((_discount$currentProp3 = discount.currentProposalCode) === null || _discount$currentProp3 === void 0 ? void 0 : _discount$currentProp3.description) || discount.offerDescription))), __jsx("div", null, __jsx("p", {
      className: "text-14 font-bold text-success",
      style: {
        color: discount.offerColor
      }
    }, "- ", discount.amount.formattedValue))));
  }));
};

/***/ }),

/***/ "CwJu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return filterAccommodations; });
/* unused harmony export sortAccommodations */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return filterReducedMobilityAccomodation; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("vrRf");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_reject__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("OOYD");
/* harmony import */ var lodash_reject__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(lodash_reject__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var lodash_sortBy__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("u6DZ");
/* harmony import */ var lodash_sortBy__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(lodash_sortBy__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("nnRT");
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(lodash_isEqual__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _utils_accommodation_accommodation_constants__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("lZ21");

















function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}



function sortAccommodations(accommodationsSets) {
  return lodash_sortBy__WEBPACK_IMPORTED_MODULE_13___default()(accommodationsSets, function (set) {
    // sort accommodations by comfort level: Standard, Deluxe, Suite
    return _utils_accommodation_accommodation_constants__WEBPACK_IMPORTED_MODULE_16__[/* ACCOMMODATION_COMFORT_ORDER */ "a"].indexOf(lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(set, 'accommodations[0].categoryId'));
  }).map(function (set, index) {
    // accommodationSetNumber was set to index + 1 in accommodationsSetsReducer
    // need to be updated after filtering & sorting
    return _objectSpread(_objectSpread({}, set), {}, {
      accommodationSetNumber: index + 1
    });
  });
}

function filterAccommodations(proposal, accommodationsSets) {
  var proposalAccommodations = lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(proposal, 'accommodations', []); // remove additional accommodation if already exists in selected proposal


  var filteredAccommodations = lodash_reject__WEBPACK_IMPORTED_MODULE_12___default()(accommodationsSets, function (_ref) {
    var accommodations = _ref.accommodations;
    return lodash_isEqual__WEBPACK_IMPORTED_MODULE_14___default()(accommodations, proposalAccommodations);
  }); // sort additional accommodations by comfort level: Standard, Deluxe, Suite


  return sortAccommodations(filteredAccommodations);
}

function filterReducedMobilityAccomodation(visibility, filteredAccommodations) {
  if (visibility) {
    return filteredAccommodations;
  }

  var pmr = filteredAccommodations.reduce(function (acc, filteredAccommodation) {
    var accommodations = filteredAccommodation.accommodations;

    if (accommodations.filter(function (_ref2) {
      var reducedMobilityAccess = _ref2.reducedMobilityAccess;
      return reducedMobilityAccess === true;
    }).length === 0) {
      return acc.concat(filteredAccommodation);
    }

    return acc;
  }, []);
  return pmr;
}



/***/ }),

/***/ "F5c/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setOptionValidity; });
/* unused harmony export unsetOptionValidity */
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("QsI/");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_option_validity_OptionValidityUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("nT1c");
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("rJ95");
/* harmony import */ var _optionValidity_reducer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("O7yO");





var setOptionValidity = function setOptionValidity(appContext) {
  return /*#__PURE__*/function () {
    var _ref = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.mark(function _callee(dispatch) {
      var data;
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Object(_utils_option_validity_OptionValidityUtils__WEBPACK_IMPORTED_MODULE_2__[/* loadDurationValidity */ "d"])(appContext);

            case 2:
              data = _context.sent;
              return _context.abrupt("return", dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_3__[/* default */ "b"])(_optionValidity_reducer__WEBPACK_IMPORTED_MODULE_4__[/* SET_OPTION_VALIDITY */ "a"], data)));

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
var unsetOptionValidity = function unsetOptionValidity() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_3__[/* default */ "b"])(_optionValidity_reducer__WEBPACK_IMPORTED_MODULE_4__[/* UNSET_OPTION_VALIDITY */ "b"]);
};

/***/ }),

/***/ "Fmrk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Confirmation; });
/* harmony import */ var core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("hBvt");
/* harmony import */ var core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("cxan");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("C/y5");
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("SPKZ");
/* harmony import */ var _frameworks_button_Button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("e0Ti");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("qBqs");
/* harmony import */ var _frameworks_text_Text__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("qqKu");
/* harmony import */ var _frameworks_text_link_TextLink__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("jD8k");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;









var getDefaultIcon = function getDefaultIcon(status) {
  return status === 'success' ? _utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].CHECK_OUTLINE : _utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].WARNING;
};

var Confirmation = function Confirmation(_ref) {
  var _ref$button = _ref.button,
      button = _ref$button === void 0 ? {} : _ref$button,
      className = _ref.className,
      icon = _ref.icon,
      link = _ref.link,
      status = _ref.status,
      text = _ref.text,
      title = _ref.title;

  if (!status || !title) {
    return null;
  }

  var colors = {
    error: _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].RED,
    neutral: _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].BLACK,
    success: _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].GREEN
  };
  var iconName = icon ? icon : getDefaultIcon(status);
  return __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_3__[/* classnames */ "a"])('flex gap-20 items-start sm:items-center text-12 sm:text-20', "text-".concat(colors[status]), className)
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_7__[/* Icon */ "a"], {
    className: "shrink-0",
    name: iconName,
    width: "4em"
  }), __jsx("div", {
    className: "flex-auto"
  }, __jsx("p", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_3__[/* classnames */ "a"])('font-bold text-16 sm:text-20', "text-".concat(colors[status]))
  }, title), __jsx(_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_8__[/* Text */ "a"], {
    text: text
  }), __jsx("p", null, __jsx(_frameworks_text_link_TextLink__WEBPACK_IMPORTED_MODULE_9__[/* TextLink */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])({}, link, {
    className: "mt-10 underline"
  }))), button && button.children && __jsx(_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_6__[/* Button */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])({}, button, {
    className: "mt-10"
  }), button.children)));
};

/***/ }),

/***/ "Gh9m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TRACK_CLICK_EVENT_UPSELL_RENTALS_DETAIL; });
var TRACK_CLICK_EVENT_UPSELL_RENTALS_DETAIL = {
  actionGA: 'activities',
  labelGA: 'chooseSkiEquipment',
  versionBooking: 'responsive'
};

/***/ }),

/***/ "Gqxm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("OZaJ");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("HbGN");
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("sRHE");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _ResponsiveContext__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("1JJ2");










var __jsx = react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }




function Responsiveness(WrappedComponent) {
  var Responsive = /*#__PURE__*/function (_Component) {
    Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(Responsive, _Component);

    var _super = _createSuper(Responsive);

    function Responsive() {
      Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(this, Responsive);

      return _super.apply(this, arguments);
    }

    Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(Responsive, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            ref = _this$props.forwardRef,
            props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(_this$props, ["forwardRef"]);

        return __jsx(_ResponsiveContext__WEBPACK_IMPORTED_MODULE_11__[/* ResponsiveContext */ "a"].Consumer, null, function (responsive) {
          return __jsx(WrappedComponent, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])({
            ref: ref
          }, props, {
            responsive: responsive
          }));
        });
      }
    }]);

    return Responsive;
  }(react__WEBPACK_IMPORTED_MODULE_10__["Component"]);

  return /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_10__["forwardRef"])(function (props, ref) {
    return __jsx(Responsive, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])({}, props, {
      forwardRef: ref
    }));
  });
}

/* harmony default export */ __webpack_exports__["a"] = (Responsiveness);

/***/ }),

/***/ "Hv+8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return trackDelCredereBanking; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return trackNavigation; });
/* unused harmony export trackSaveCriteria */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return trackShareContextDesktopPopin; });
/* unused harmony export trackShareContext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return trackShareContextMobilePopin; });
/* unused harmony export trackPage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return resetTrackingStorageBE; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("5BYb");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("uZih");
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(lodash_omit__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("rOcY");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _tracking_constants__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("829J");
/* harmony import */ var _tracking_tracking_storage_api__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("K0Lv");
/* harmony import */ var _tracking_tracking_api__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("d1HQ");
/* harmony import */ var _utils_booking_engine_pages_BookingPagesUtils__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("rcxx");
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("ldK3");
/* harmony import */ var _utils_tracking_resort__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("zCbR");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("taV1");













function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}











function storeTracking(params) {
  var resortTrackingProps = _tracking_tracking_storage_api__WEBPACK_IMPORTED_MODULE_15__[/* get */ "b"](_tracking_constants__WEBPACK_IMPORTED_MODULE_14__[/* BE_TRACKING */ "c"]);

  var bookingCriteriaProps = _objectSpread(_objectSpread({}, lodash_omit__WEBPACK_IMPORTED_MODULE_10___default()(resortTrackingProps, 'children')), params);

  _tracking_tracking_storage_api__WEBPACK_IMPORTED_MODULE_15__[/* set */ "c"](bookingCriteriaProps);
}

function trackDelCredereBanking(dataObject, appContext) {
  _tracking_tracking_api__WEBPACK_IMPORTED_MODULE_16__[/* setDataLayer */ "b"](_objectSpread(_objectSpread({}, _constants__WEBPACK_IMPORTED_MODULE_20__[/* BE_GA_DEFAULT_PAYLOAD */ "c"]), {}, {
    versionBooking: 'responsive',
    actionGA: 'banking',
    agenceType: 'Ducroire'
  }, dataObject), appContext);
}
function trackNavigation(actionGA, labelGA, appContext) {
  var addAgencyType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  _tracking_tracking_api__WEBPACK_IMPORTED_MODULE_16__[/* setDataLayer */ "b"](_objectSpread(_objectSpread({}, _constants__WEBPACK_IMPORTED_MODULE_20__[/* BE_GA_DEFAULT_PAYLOAD */ "c"]), {}, {
    versionBooking: 'responsive',
    actionGA: actionGA,
    labelGA: labelGA
  }, addAgencyType && {
    agenceType: appContext.cmta.isDelCredere ? 'Ducroire' : 'NonDucroire'
  }), appContext);
}
function trackSaveCriteria(actionGA, labelGA, appContext) {
  _tracking_tracking_api__WEBPACK_IMPORTED_MODULE_16__[/* setDataLayer */ "b"](_objectSpread(_objectSpread({}, _constants__WEBPACK_IMPORTED_MODULE_20__[/* BE_GA_DEFAULT_PAYLOAD */ "c"]), {}, {
    versionBooking: 'responsive',
    categoryGA: 'saveMyCriteria',
    actionGA: actionGA,
    labelGA: labelGA
  }), appContext);
}
function trackShareContextDesktopPopin(actionGA, appContext) {
  _tracking_tracking_api__WEBPACK_IMPORTED_MODULE_16__[/* setDataLayer */ "b"](_objectSpread(_objectSpread({}, _constants__WEBPACK_IMPORTED_MODULE_20__[/* BE_GA_DEFAULT_PAYLOAD */ "c"]), {}, {
    versionBooking: 'responsive',
    labelGA: 'shareValidate',
    actionGA: actionGA
  }), appContext);
}
function trackShareContext(actionGA, appContext) {
  _tracking_tracking_api__WEBPACK_IMPORTED_MODULE_16__[/* setDataLayer */ "b"](_objectSpread(_objectSpread({}, _constants__WEBPACK_IMPORTED_MODULE_20__[/* BE_GA_DEFAULT_PAYLOAD */ "c"]), {}, {
    versionBooking: 'responsive',
    labelGA: 'shareClick',
    actionGA: actionGA
  }), appContext);
}
function trackShareContextMobilePopin(actionGA, socialNetworkName, appContext) {
  _tracking_tracking_api__WEBPACK_IMPORTED_MODULE_16__[/* setDataLayer */ "b"](_objectSpread(_objectSpread({}, _constants__WEBPACK_IMPORTED_MODULE_20__[/* BE_GA_DEFAULT_PAYLOAD */ "c"]), {}, {
    versionBooking: 'responsive',
    labelGA: "shareValidate_".concat(socialNetworkName),
    actionGA: actionGA
  }), appContext);
}
function trackPage(trackingParams, appContext) {
  var _objectSpread2, _userInfo$loyaltyProg;

  var basePriceLabel = trackingParams.basePriceLabel,
      pageName = trackingParams.pageName,
      resort = trackingParams.resort,
      userInfo = trackingParams.userInfo,
      selectedProposal = trackingParams.selectedProposal,
      leadScore = trackingParams.leadScore,
      _trackingParams$custo = trackingParams.customEventName,
      customEventName = _trackingParams$custo === void 0 ? null : _trackingParams$custo;

  var transportDeparture = lodash_get__WEBPACK_IMPORTED_MODULE_11___default()(selectedProposal.transports, 'inbound.travelSections[0].departure', {});

  var storedTracking = _tracking_tracking_storage_api__WEBPACK_IMPORTED_MODULE_15__[/* get */ "b"](_tracking_constants__WEBPACK_IMPORTED_MODULE_14__[/* BE_TRACKING */ "c"]);

  var departureDate = lodash_get__WEBPACK_IMPORTED_MODULE_11___default()(selectedProposal, 'departureDate', null);

  var departureDateTimestamp = Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_18__[/* apiDateToTimestamp */ "e"])(departureDate);
  var computedPageName = pageName === _utils_booking_engine_pages_BookingPagesUtils__WEBPACK_IMPORTED_MODULE_17__[/* PAGE_BE_SERVICES */ "d"] && resort.isJoyview ? _utils_booking_engine_pages_BookingPagesUtils__WEBPACK_IMPORTED_MODULE_17__[/* PAGE_BE_SERVICES_ALL_INCLUSIVE */ "e"] : pageName;

  var trackingDataToStore = _objectSpread((_objectSpread2 = {
    resortCode: resort.id,
    resortName: resort.name,
    resortTrident: resort.comfort,
    resortCountry: resort.destination.country,
    resortRegion: resort.destination.area,
    resortAdult: selectedProposal.attendees.adults.length,
    resortChildren: selectedProposal.attendees.children.length,
    resortDefaultPrice: lodash_get__WEBPACK_IMPORTED_MODULE_11___default()(resort, 'price.initialPrice.value'),
    resortDepartureCityCode: transportDeparture.cityId || 'WITHOUT TRANSPORT',
    resortDepartureCityName: transportDeparture.label,
    resortDepartureDate: selectedProposal.arrivalDate,
    resortNightNumber: selectedProposal.duration,
    resortOldPrice: lodash_get__WEBPACK_IMPORTED_MODULE_11___default()(resort, 'price.initialPrice.value'),
    resortSeasonType: lodash_get__WEBPACK_IMPORTED_MODULE_11___default()(resort, 'seasonName'),
    resortTotalParticipant: selectedProposal.attendees.list.length,
    resortTransport: selectedProposal.transports ? 'with Transport' : 'without Transport',
    resortUrlImage: resort.image,
    versionBooking: 'responsive',
    resortSeason: departureDateTimestamp && Object(_utils_tracking_resort__WEBPACK_IMPORTED_MODULE_19__[/* isSummer */ "f"])(new Date(departureDateTimestamp)) ? 'Summer' : 'Winter',
    resortYearSeason: moment__WEBPACK_IMPORTED_MODULE_12___default()(departureDate, 'YYYYMMDD').format('YYYY')
  }, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(_objectSpread2, basePriceLabel, selectedProposal.price.total.value), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(_objectSpread2, "contextNumber", selectedProposal.id), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(_objectSpread2, "currencyCode", selectedProposal.price.currency), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(_objectSpread2, "daysBeforeDeparture", moment__WEBPACK_IMPORTED_MODULE_12___default()(selectedProposal.arrivalDate).diff(moment__WEBPACK_IMPORTED_MODULE_12___default()(), 'days')), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(_objectSpread2, "upsellExcursion", selectedProposal.additionalServices.activities.some(function (_ref) {
    var pricingInfo = _ref.pricingInfo;
    return pricingInfo.isPartiallyRented;
  }) ? 'yes' : 'no'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(_objectSpread2, "BE_customerStatus", storedTracking.BE_customerStatus), _objectSpread2), leadScore ? {
    leadScore: leadScore
  } : null);

  storeTracking(trackingDataToStore);
  _tracking_tracking_api__WEBPACK_IMPORTED_MODULE_16__[/* setDataLayer */ "b"](_objectSpread(_objectSpread({
    categoryGA: _constants__WEBPACK_IMPORTED_MODULE_20__[/* BE_CATEGORY_GA */ "b"],
    locale: appContext.locale,
    event: customEventName || computedPageName,
    fidelityStatus: (userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$loyaltyProg = userInfo.loyaltyProgram) === null || _userInfo$loyaltyProg === void 0 ? void 0 : _userInfo$loyaltyProg.status) || '',
    valueGA: 0,
    environment: _config__WEBPACK_IMPORTED_MODULE_13___default.a.get('tracking.environment')
  }, appContext.isCmta && {
    agenceType: appContext.cmta.isDelCredere ? 'Ducroire' : 'NonDucroire'
  }), {}, {
    nonInteraction: 0,
    pageName: "BE_".concat(computedPageName),
    siteSection: 'Booking Engine'
  }, trackingDataToStore), appContext);
}
var resetTrackingStorageBE = function resetTrackingStorageBE() {
  storeTracking({
    BE_customerStatus: null
  });
};

/***/ }),

/***/ "IGVP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccommodationOptionCurrent; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("C/y5");
/* harmony import */ var _frameworks_button_Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("e0Ti");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;




var AccommodationOptionCurrent = function AccommodationOptionCurrent(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$isUpgradableOnli = _ref.isUpgradableOnline,
      isUpgradableOnline = _ref$isUpgradableOnli === void 0 ? true : _ref$isUpgradableOnli,
      onSelect = _ref.onSelect,
      rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["children", "className", "isUpgradableOnline", "onSelect"]);

  return __jsx("div", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, rest, {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_4__[/* classnames */ "a"])('bg-white border-1 border-lightGrey flex flex-col isolate relative rounded-12', className),
    "data-testid": "AccommodationOptionCurrent"
  }), __jsx("div", {
    className: "flex-1 overflow-y-auto"
  }, children), __jsx("div", {
    className: "border-t-1 border-lightGrey flex gap-10 items-center justify-center p-20"
  }, __jsx(_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_5__[/* Button */ "a"], {
    className: "w-auto",
    onClick: onSelect
  }, isUpgradableOnline ? Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('common.confirm') : Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('booking.accommodation.upgradeRoom.contactATED'))));
};

/***/ }),

/***/ "Iz3O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getLinkTagName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getLinkProps; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("MwrP");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("i5Mr");










function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}


var getLinkTagName = function getLinkTagName(link) {
  if (lodash_isEmpty__WEBPACK_IMPORTED_MODULE_8___default()(link)) {
    return 'div';
  }

  return link.url ? _frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"] : 'button';
};
var getLinkProps = function getLinkProps(link) {
  return (link === null || link === void 0 ? void 0 : link.url) ? _objectSpread({}, link) : _objectSpread(_objectSpread({}, link), {}, {
    type: 'button'
  });
};

/***/ }),

/***/ "JjZN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ProductInformationSlider_container_ProductInformationSliderContainer; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("6U7i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("KqXw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("MvUL");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/next/router.js
var next_router = __webpack_require__("Bkb1");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: ./src/utils/uri/uriUtils.js
var uriUtils = __webpack_require__("nv//");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/frameworks/backdrop/Backdrop.jsx + 1 modules
var Backdrop = __webpack_require__("NZxu");

// EXTERNAL MODULE: ./src/client/components/widgets/confirmation/Confirmation.jsx
var Confirmation = __webpack_require__("Fmrk");

// EXTERNAL MODULE: ./src/client/components/frameworks/layer/Layer.jsx + 4 modules
var Layer = __webpack_require__("U2fG");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/Spinner.jsx
var Spinner = __webpack_require__("7amT");

// CONCATENATED MODULE: ./src/client/components/widgets/product-information-slider/ProductInformationLayer.jsx








var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









var ProductInformationLayer_ProductInformationLayer = function ProductInformationLayer(_ref) {
  var activeItem = _ref.activeItem,
      backNavigationLabel = _ref.backNavigationLabel,
      children = _ref.children,
      errorMessage = _ref.errorMessage,
      renderDetail = _ref.renderDetail,
      toggleLayer = _ref.toggleLayer;

  var _useState = Object(react["useState"])({
    activeItem: activeItem,
    isLoading: false,
    isOpen: false
  }),
      state = _useState[0],
      setState = _useState[1];

  Object(react["useEffect"])(function () {
    loadDetails();
  }, [activeItem]);

  var closeLayer = function closeLayer() {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      isLoading: false,
      isOpen: false
    })); // -1 to indicate that no product has been selected

    toggleLayer(-1, false);
  };

  var updateDetail = function updateDetail(active, detailInfo) {
    setState({
      activeItem: active,
      detail: detailInfo,
      isLoading: false,
      isOpen: true
    });
  };

  var getItem = function getItem(index) {
    return react["Children"].toArray(children)[index];
  };

  var loadDetails = function loadDetails() {
    var item = getItem(activeItem) || {};
    var props = item.props;

    if (props && props.fetchDetail) {
      setState(_objectSpread(_objectSpread({}, state), {}, {
        isLoading: true
      }));
      props.fetchDetail().then(function (data) {
        updateDetail(activeItem, data);
      }).catch(function () {
        updateDetail(activeItem, null);
      });
    }
  };

  var renderActiveDetail = function renderActiveDetail() {
    var item = getItem(activeItem);

    if (!item) {
      return null;
    }

    var leftButton = {
      iconName: icons["a" /* ICONS */].ARROW_TAIL_LEFT,
      onClick: closeLayer,
      label: backNavigationLabel
    };
    var ariaLabel = state.detail ? state.detail.label || state.detail.title : '';
    return __jsx(Layer["b" /* Layer */], {
      ariaLabel: ariaLabel,
      bgColor: colors["a" /* COLORS */].WHITE,
      buttonLeft: leftButton,
      closeLabel: Object(i18n["h" /* t */])('common.close'),
      hasAnimateEnter: true,
      hasContainerHeader: true,
      onClose: closeLayer
    }, state.detail ? renderDetail(state.detail) : __jsx("div", {
      "data-testid": "error",
      className: "p-20"
    }, __jsx("div", {
      className: "mx-auto flex max-w-site justify-center"
    }, __jsx(Confirmation["a" /* Confirmation */], {
      status: "error",
      title: errorMessage
    }))));
  };

  return state.isOpen && !state.isLoading ? renderActiveDetail() : state.isLoading && __jsx("div", {
    id: "loading",
    className: "relative z-4"
  }, __jsx(Backdrop["a" /* Backdrop */], {
    className: "bg-white opacity-90"
  }, __jsx("div", {
    "aria-live": "polite",
    className: "absolute left-1/2 top-1/2 w-[208px] -translate-x-1/2 -translate-y-1/2 transform text-center"
  }, __jsx("span", {
    className: "sr-only"
  }, "Loading"), __jsx(Spinner["a" /* Spinner */], {
    "data-testid": "Spinner",
    iconName: icons["a" /* ICONS */].TRIDENT1
  }))));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("OZaJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.link.js
var es_string_link = __webpack_require__("hBvt");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/components/frameworks/slider/Slider.jsx + 1 modules
var Slider = __webpack_require__("ZFcn");

// CONCATENATED MODULE: ./src/client/components/widgets/product-information-slider/ProductInformationSlider.jsx




















var ProductInformationSlider_jsx = react_default.a.createElement;

function ProductInformationSlider_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ProductInformationSlider_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ProductInformationSlider_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ProductInformationSlider_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }




var themes = {
  default: {
    largeCols: 2,
    desktopCols: 4,
    tabletCols: 3,
    navPosition: ''
  },
  short: {
    largeCols: 2,
    desktopCols: 3,
    tabletCols: 3,
    navPosition: 'center'
  }
};
var ProductInformationSlider_ProductInformationSlider = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(ProductInformationSlider, _Component);

  var _super = _createSuper(ProductInformationSlider);

  function ProductInformationSlider() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, ProductInformationSlider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "openLayer", function (activeItem) {
      return _this.props.toggleLayer ? _this.props.toggleLayer(activeItem, true) : null;
    });

    return _this;
  }

  Object(createClass["a" /* default */])(ProductInformationSlider, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          isLarge = _this$props.isLarge,
          _this$props$theme = _this$props.theme,
          theme = _this$props$theme === void 0 ? 'default' : _this$props$theme,
          queryLayer = _this$props.queryLayer,
          scrollBackwardLabel = _this$props.scrollBackwardLabel,
          scrollForwardLabel = _this$props.scrollForwardLabel;

      if (!react["Children"].count(children)) {
        return null;
      }

      var _this$context = this.context,
          isDesktop = _this$context.isDesktop,
          isTablet = _this$context.isTablet;
      var _themes$theme = themes[theme],
          largeCols = _themes$theme.largeCols,
          desktopCols = _themes$theme.desktopCols,
          tabletCols = _themes$theme.tabletCols,
          navPosition = _themes$theme.navPosition;

      var renderItem = function renderItem(element, index) {
        var _element$props$link = element.props.link,
            link = _element$props$link === void 0 ? {} : _element$props$link;

        if (!link.url) {
          link = ProductInformationSlider_objectSpread(ProductInformationSlider_objectSpread({}, link), {}, {
            onClick: function onClick() {
              return _this2.openLayer && _this2.openLayer(index);
            }
          });
        }

        return /*#__PURE__*/react_default.a.createElement('div', {
          className: 'h-full w-280 md:w-auto'
        }, /*#__PURE__*/react_default.a.cloneElement(element, {
          link: link,
          isLarge: isLarge
        }));
      };

      var getCols = function getCols() {
        if (isTablet) {
          if (isLarge) {
            return largeCols;
          }

          if (isDesktop) {
            return desktopCols;
          }

          return tabletCols;
        }

        return 0;
      };

      var clonedChildren = react["Children"].map(children, renderItem);
      return ProductInformationSlider_jsx("section", null, ProductInformationSlider_jsx(Slider["a" /* Slider */], {
        cols: getCols(),
        hasControls: isTablet,
        id: queryLayer,
        navPosition: navPosition || (isTablet ? 'top' : 'center'),
        nbItemsToScroll: isTablet ? 2 : 1,
        nextLabel: scrollForwardLabel,
        previousLabel: scrollBackwardLabel,
        scrollAreaClassName: "overflow-hidden -mx-10",
        scrollAreaContainerClassName: "overflow-auto scroll-x scrollbar-hidden snap-x snap-mandatory",
        scrollItemClassName: "overflow-hidden px-10 pb-10 flex-none max-w-full"
      }, clonedChildren));
    }
  }]);

  return ProductInformationSlider;
}(react["Component"]);

Object(defineProperty["a" /* default */])(ProductInformationSlider_ProductInformationSlider, "contextType", ResponsiveContext["a" /* ResponsiveContext */]);
// CONCATENATED MODULE: ./src/client/components/widgets/product-information-slider/ProductInformationSlider.container.jsx








var ProductInformationSlider_container_jsx = react_default.a.createElement;






var ProductInformationSlider_container_ProductInformationSliderContainer = function ProductInformationSliderContainer(props) {
  // -1 to init activeItem (it means no item has been selected yet), 0 is the index of first element
  var _useState = Object(react["useState"])(-1),
      activeItem = _useState[0],
      setActiveItem = _useState[1];

  var router = Object(next_router["useRouter"])();
  var queryLayer = props.queryLayer,
      sliderIndex = props.sliderIndex;
  var asPath = router.asPath;

  var _getOpenLayersFromLoc = Object(uriUtils["h" /* getOpenLayersFromLocation */])(asPath, queryLayer),
      _getOpenLayersFromLoc2 = Object(slicedToArray["a" /* default */])(_getOpenLayersFromLoc, 2),
      uriSliderIndex = _getOpenLayersFromLoc2[0],
      uriActiveItem = _getOpenLayersFromLoc2[1];

  var uri = new URI_default.a(asPath);
  Object(react["useEffect"])(function () {
    if (uri.hasQuery(queryLayer) && Number(uriSliderIndex) === sliderIndex) {
      setActiveItem(uriActiveItem);
    }
  }, [asPath]);
  /**
   * Close the layer from back navigation button
   */

  var closeLayer = function closeLayer() {
    setActiveItem(-1);
  };

  Object(react["useEffect"])(function () {
    window.addEventListener('popstate', closeLayer);
    return function () {
      window.removeEventListener('popstate', closeLayer);
    };
  }, []);

  var toggleLayer = function toggleLayer(item, layer) {
    var newUrl = uri.clone();

    if (layer) {
      newUrl = newUrl.hash('').addQuery(queryLayer, "".concat(sliderIndex, "_").concat(item));
      router.push(newUrl.toString(), undefined, {
        shallow: true
      });
    } else {
      newUrl = newUrl.removeQuery(queryLayer);
      router.replace(newUrl.toString(), undefined, {
        shallow: true
      });
    }

    setActiveItem(item);
  };

  return ProductInformationSlider_container_jsx(react["Fragment"], null, ProductInformationSlider_container_jsx(ProductInformationSlider_ProductInformationSlider, Object(esm_extends["a" /* default */])({}, props, {
    toggleLayer: toggleLayer
  })), ProductInformationSlider_container_jsx(ProductInformationLayer_ProductInformationLayer, Object(esm_extends["a" /* default */])({}, props, {
    activeItem: activeItem,
    toggleLayer: toggleLayer
  })));
};

/***/ }),

/***/ "Jzv7":
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__("gAMm"),
    func = convert('map', __webpack_require__("mbB6"));

func.placeholder = __webpack_require__("VDAD");
module.exports = func;


/***/ }),

/***/ "KxdP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ filterUtils_getFilters; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* binding */ filterUtils_updateFilters; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ createFilters; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ unselectCategory; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ handleReducedMobilityFilter; });

// UNUSED EXPORTS: COMFORT_CATEGORY, EXTRA_FEATURES_CATEGORY, CONFIGURATION_CATEGORY, REDUCED_MOBILITY_CATEGORY, REDUCED_MOBILITY_FILTER_ID, matchConfiguration, matchComfort, matchExtraFeatures, createConfigurationFilters, createComfortFilters, createExtraFeaturesFilters, matchExtraFeaturesReducedMobility

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.every.js
var es_array_every = __webpack_require__("DfhM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("5BYb");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/fp/uniqBy.js
var uniqBy = __webpack_require__("z+NW");
var uniqBy_default = /*#__PURE__*/__webpack_require__.n(uniqBy);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/fp/compact.js
var compact = __webpack_require__("LVnT");
var compact_default = /*#__PURE__*/__webpack_require__.n(compact);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/fp/flatten.js
var flatten = __webpack_require__("Z/bG");
var flatten_default = /*#__PURE__*/__webpack_require__.n(flatten);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/fp/path.js
var path = __webpack_require__("Z0Tt");
var path_default = /*#__PURE__*/__webpack_require__.n(path);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/fp/map.js
var map = __webpack_require__("Jzv7");
var map_default = /*#__PURE__*/__webpack_require__.n(map);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/fp/pipe.js
var pipe = __webpack_require__("eYK6");
var pipe_default = /*#__PURE__*/__webpack_require__.n(pipe);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/shortid/index.js
var shortid = __webpack_require__("MIfU");
var shortid_default = /*#__PURE__*/__webpack_require__.n(shortid);

// EXTERNAL MODULE: ./src/client/components/utils/booking/bookingUtils.js + 1 modules
var bookingUtils = __webpack_require__("aWOT");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/store/booking/additional-accommodations/additionalAccommodations.action.js + 1 modules
var additionalAccommodations_action = __webpack_require__("06Jt");

// EXTERNAL MODULE: ./src/utils/accommodation/accommodation.constants.js
var accommodation_constants = __webpack_require__("lZ21");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTrackEvent.js
var useTrackEvent = __webpack_require__("DqI1");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-inputs/input-switch/InputSwitch.jsx + 1 modules
var InputSwitch = __webpack_require__("YjXp");

// CONCATENATED MODULE: ./src/client/components/widgets/filter-mobility/FilterMobility.jsx
var __jsx = react_default.a.createElement;






var FilterMobility_FilterMobility = function FilterMobility(_ref) {
  var className = _ref.className,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      onChange = _ref.onChange,
      _ref$selectedOptions = _ref.selectedOptions,
      selectedOptions = _ref$selectedOptions === void 0 ? [] : _ref$selectedOptions;
  var result = Object(es["e" /* useSelector */])(function (state) {
    return state.booking.additionalAccommodations;
  });
  var isActive = Boolean(result === null || result === void 0 ? void 0 : result.isPmrChecked);

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var handleCheck = function handleCheck() {
    onChange('reducedMobilityVisibility', selectedOptions, null);
    trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_ACCOMMODATION_LAYER, {
      detail_click: 'filter_mobility'
    });
  };

  return __jsx(InputSwitch["a" /* InputSwitch */], {
    checked: isActive,
    className: className,
    isDisabled: isDisabled,
    label: Object(i18n["h" /* t */])('filters.reducedMobilityCheckbox'),
    name: "filters.reducedMobility",
    onChange: handleCheck,
    size: "small"
  });
};
// CONCATENATED MODULE: ./src/client/store/booking/additional-accommodations/filters/filterUtils.js























var filterUtils_jsx = react_default.a.createElement;

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}









var COMFORT_CATEGORY = 'accommodations';
var EXTRA_FEATURES_CATEGORY = 'extra';
var CONFIGURATION_CATEGORY = 'configuration';
var REDUCED_MOBILITY_CATEGORY = 'reduced_mobility';
var REDUCED_MOBILITY_FILTER_ID = 'reduced_mobility_access';

var getOptions = function getOptions(v, c) {
  return v.filter(function (_ref) {
    var category = _ref.category;
    return category === c;
  }).map(function (o) {
    var _o$meta, _o$meta2;

    return {
      iconName: (_o$meta = o.meta) === null || _o$meta === void 0 ? void 0 : _o$meta.icon,
      id: o.id,
      isDisabled: !o.matchedOccurrences,
      isSelected: o.selected,
      label: (_o$meta2 = o.meta) === null || _o$meta2 === void 0 ? void 0 : _o$meta2.label,
      matched: o.matchedOccurrences || 0,
      value: o.value
    };
  });
};

var filterUtils_getFilters = function getFilters(product) {
  var filterValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var options = arguments.length > 2 ? arguments[2] : undefined;
  return [{
    id: COMFORT_CATEGORY,
    label: Object(i18n["h" /* t */])('filters.comfort.categoryTitle'),
    options: getOptions(filterValues, COMFORT_CATEGORY)
  }, {
    id: CONFIGURATION_CATEGORY,
    label: Object(bookingUtils["u" /* tAlt */])({
      cruiseKeyPath: 'filters.configuration.categoryTitleCruise',
      product: product,
      resortKeyPath: 'filters.configuration.categoryTitle'
    }),
    options: getOptions(filterValues, CONFIGURATION_CATEGORY)
  }, {
    id: EXTRA_FEATURES_CATEGORY,
    label: Object(i18n["h" /* t */])('filters.extraFeatures.categoryTitle'),
    options: getOptions(filterValues, EXTRA_FEATURES_CATEGORY)
  }, (options === null || options === void 0 ? void 0 : options.ignoreReducedMobility) ? null : {
    id: REDUCED_MOBILITY_CATEGORY,
    label: '',
    options: getOptions(filterValues, EXTRA_FEATURES_CATEGORY),
    // eslint-disable-next-line clubmed/no-fake-component
    customRenderParent: function customRenderParent(selectedOptions, onChange, isDisabled) {
      return filterUtils_jsx(FilterMobility_FilterMobility, {
        isDisabled: isDisabled,
        onChange: onChange,
        selectedOptions: selectedOptions
      });
    }
  }].filter(Boolean);
};

var matchConfiguration = function matchConfiguration(accommodations, roomType) {
  var SINGLE_ROOM = 'SINGLE_ROOM',
      SEPARATE_ROOMS = 'SEPARATE_ROOMS',
      SEPARATE_ROOMS_3 = 'SEPARATE_ROOMS_3',
      CONNECTING_ROOMS = 'CONNECTING_ROOMS';
  var matchSingleConfiguration = roomType === SINGLE_ROOM;
  var matchSeparatedConfiguration = roomType === SEPARATE_ROOMS;
  var matchSeparated3Configuration = roomType === SEPARATE_ROOMS_3;
  var matchCommunicatingConfiguration = roomType === CONNECTING_ROOMS;

  if (matchSingleConfiguration) {
    return accommodations.length === 1 && accommodations[0].roomType === SINGLE_ROOM;
  }

  if (matchSeparatedConfiguration) {
    var separateConfigurations = accommodations.length === 2 && accommodations.every(function (accommodation) {
      return accommodation.roomType === SEPARATE_ROOMS || accommodation.roomType === SINGLE_ROOM;
    }) || // some combinations of two or more rooms come in one accommodation with ex : C4+C4 but roomtype is SEPARATE_ROOMS
    accommodations.length === 1 && accommodations[0].roomType === SEPARATE_ROOMS;
    return separateConfigurations;
  }

  if (matchSeparated3Configuration) {
    var _separateConfigurations = accommodations.length >= 3 && accommodations.every(function (accommodation) {
      return accommodation.roomType === SEPARATE_ROOMS || accommodation.roomType === SEPARATE_ROOMS_3 || accommodation.roomType === SINGLE_ROOM;
    }) || accommodations.length === 1 && accommodations[0].roomType === SEPARATE_ROOMS_3;

    return _separateConfigurations;
  }

  if (matchCommunicatingConfiguration) {
    var communicatingConfigurations = accommodations.length >= 1 && accommodations.some(function (accommodation) {
      return accommodation.roomType === CONNECTING_ROOMS;
    });
    return communicatingConfigurations;
  } // default case for all other room types ( we never know what to expect )


  return accommodations.some(function (accommodation) {
    return accommodation.roomType === roomType;
  });
};

var filterUtils_matchComfort = function matchComfort(accommodations, categoryId) {
  return accommodations.some(function (accommodation) {
    return get_default()(accommodation, 'categories').find(function (category) {
      return get_default()(category, 'id') === categoryId;
    });
  });
};

var filterUtils_matchExtraFeatures = function matchExtraFeatures(accommodations, strengthId) {
  return accommodations.some(function (accommodation) {
    return get_default()(accommodation, 'view.id', null) === strengthId || get_default()(accommodation, 'strengths', []).find(function (strength) {
      return get_default()(strength, 'id') === strengthId;
    });
  });
};

var matchExtraFeaturesReducedMobility = function matchExtraFeaturesReducedMobility(accommodations) {
  return accommodations.some(function (accommodation) {
    return accommodation.reducedMobilityAccess;
  });
};

function createConfigurationFilters(accommodationsSets, product) {
  var accommodations = pipe_default()([map_default()(path_default()('accommodations')), flatten_default.a, uniqBy_default()('roomType')])(accommodationsSets);

  var roomTypes = accommodations.map(function (_ref2) {
    var roomType = _ref2.roomType;
    return roomType;
  }); // even we dont have the SEPARATE_ROOMS in the roomTypes, we need to show the filter
  // because two or more with SINGLE_ROOM can be combined to form SEPARATE_ROOMS
  // same for SEPARATE_ROOMS_3

  var roomTypesSR = roomTypes.includes('SEPARATE_ROOMS') ? roomTypes : [].concat(Object(toConsumableArray["a" /* default */])(roomTypes), ['SEPARATE_ROOMS']);
  var completeRoomTypes = roomTypes.includes('SEPARATE_ROOMS_3') ? roomTypesSR : [].concat(Object(toConsumableArray["a" /* default */])(roomTypesSR), ['SEPARATE_ROOMS_3']);
  return completeRoomTypes.map(function (roomType) {
    return {
      id: shortid_default.a.generate(),
      category: CONFIGURATION_CATEGORY,
      match: matchConfiguration,
      meta: {
        label: Object(bookingUtils["u" /* tAlt */])({
          cruiseKeyPath: "filters.configuration.".concat(accommodation_constants["b" /* CABIN_TYPE */][roomType]),
          product: product,
          resortKeyPath: "filters.configuration.".concat(accommodation_constants["e" /* ROOM_TYPE */][roomType])
        }),
        icon: icons["a" /* ICONS */][roomType]
      },
      path: 'accommodations',
      selected: false,
      value: roomType
    };
  });
}

function createComfortFilters(accommodationsSets) {
  var accommodations = pipe_default()([map_default()(path_default()('accommodations')), flatten_default.a, compact_default.a, uniqBy_default()('categoryId')])(accommodationsSets);

  var comfortSeen = [];
  return accommodations.map(function (accommodation) {
    /**
     * in some cases we have differents categories with same comfort type
     * it causes a duplicate filter
     * Concat comfort type & category, as label for teh second one
     */
    var comfortType = accommodation.comfortType,
        category = accommodation.category;
    var label = comfortSeen.includes(comfortType) ? "".concat(comfortType, " ").concat(category) : comfortType || category;
    comfortSeen.push(accommodation.comfortType);
    return {
      id: shortid_default.a.generate(),
      category: COMFORT_CATEGORY,
      match: filterUtils_matchComfort,
      meta: {
        label: label
      },
      path: 'accommodations',
      selected: false,
      value: accommodation.categoryId
    };
  });
}

function createExtraFeaturesFilters(accommodationsSets) {
  var accommodations = pipe_default()([map_default()(path_default()('accommodations')), flatten_default.a, uniqBy_default()('id')])(accommodationsSets);

  var strengths = pipe_default()([map_default()(path_default()('strengths')), flatten_default.a, compact_default.a, uniqBy_default()('id')])(accommodations);

  var views = pipe_default()([map_default()(path_default()('view')), compact_default.a, uniqBy_default()('id')])(accommodations);

  var features = [].concat(Object(toConsumableArray["a" /* default */])(strengths), Object(toConsumableArray["a" /* default */])(views));
  return features.map(function (feature) {
    return {
      id: shortid_default.a.generate(),
      category: EXTRA_FEATURES_CATEGORY,
      match: feature.id === REDUCED_MOBILITY_FILTER_ID ? matchExtraFeaturesReducedMobility : filterUtils_matchExtraFeatures,
      meta: {
        label: feature.label,
        icon: icons["a" /* ICONS */][feature.id],
        iconClassName: "icon--".concat(feature.id),
        iconInheritColor: true
      },
      path: 'accommodations',
      selected: false,
      value: feature.id
    };
  });
}

function handleReducedMobilityFilter(accommodationsSets, reducedMobilityVisibility, state) {
  var accommodations = pipe_default()([map_default()(path_default()('accommodations')), flatten_default.a, uniqBy_default()('id')])(accommodationsSets);

  var isReducedMobility = accommodations.some(function (accommodation) {
    return accommodation.reducedMobilityAccess;
  });
  var matchedReducedMobility = isReducedMobility ? accommodationsSets.filter(function (filteredAccomodation) {
    return filteredAccomodation.accommodations.filter(function (acc) {
      return acc.reducedMobilityAccess === true;
    }).length > 0;
  }).length : 0;
  var newItem = {
    id: shortid_default.a.generate(),
    category: EXTRA_FEATURES_CATEGORY,
    match: matchExtraFeaturesReducedMobility,
    matchedOccurrences: matchedReducedMobility,
    meta: {
      label: Object(i18n["h" /* t */])('filters.reducedMobility'),
      icon: icons["a" /* ICONS */].reduced_mobility_access,
      iconClassName: 'icon--reduced_mobility_access',
      iconInheritColor: true
    },
    path: 'accommodations',
    selected: false,
    value: 'reduced_mobility_access'
  };
  return !reducedMobilityVisibility ? [].concat(Object(toConsumableArray["a" /* default */])(state), [newItem]) : state.filter(function (feature) {
    return feature.value !== 'reduced_mobility_access';
  });
}

function createFilters(accommodationsSets, product) {
  return [].concat(Object(toConsumableArray["a" /* default */])(createExtraFeaturesFilters(accommodationsSets)), Object(toConsumableArray["a" /* default */])(createConfigurationFilters(accommodationsSets, product)), Object(toConsumableArray["a" /* default */])(createComfortFilters(accommodationsSets)));
}

function unselectCategory(filters) {
  return function (category) {
    return filters.map(function (filter) {
      return _objectSpread(_objectSpread({}, filter), {}, {
        selected: filter.category === category ? false : filter.selected
      });
    });
  };
}

var filterUtils_updateFilters = function updateFilters(_ref3, dispatch, setVisibility) {
  var accommodationsSets = _ref3.accommodationsSets,
      filterValues = _ref3.filterValues,
      visibility = _ref3.visibility;
  return function (name, opts, updatedValue) {
    if (filterValues && updatedValue) {
      var f = filterValues.find(function (v) {
        return v.value === updatedValue;
      });

      if (f) {
        dispatch(Object(additionalAccommodations_action["o" /* toggleAdditionalAccommodationFilter */])(f));
      }
    } else {
      setVisibility(function (shown) {
        return !shown;
      });
      dispatch(Object(additionalAccommodations_action["q" /* togglePMRChecbox */])(!visibility, filterValues));

      if (opts.length === 1 && opts[0] === 'reduced_mobility_access' && visibility) {
        var _f = filterValues.find(function (v) {
          return v.value === 'reduced_mobility_access';
        });

        dispatch(Object(additionalAccommodations_action["p" /* toggleAdditionalAccommodationReducedMobilityFilter */])(accommodationsSets, visibility));

        if (_f) {
          dispatch(Object(additionalAccommodations_action["o" /* toggleAdditionalAccommodationFilter */])(_f));
        }
      } else {
        dispatch(Object(additionalAccommodations_action["p" /* toggleAdditionalAccommodationReducedMobilityFilter */])(accommodationsSets, visibility));
      }
    }
  };
};


/***/ }),

/***/ "LVnT":
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__("gAMm"),
    func = convert('compact', __webpack_require__("3dHC"), __webpack_require__("zUlE"));

func.placeholder = __webpack_require__("VDAD");
module.exports = func;


/***/ }),

/***/ "M/0w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getInfoBannerQuery; });
var getInfoBannerQuery = function getInfoBannerQuery(productId) {
  return "query {\n    productInformationBanners(productId:\"".concat(productId, "\") {\n        productId\n        salesChannel {\n          context\n          tags\n        }\n        countdown {\n          dateTimeEnd\n          daysLabel\n          hoursLabel\n          minutesLabel\n          secondsLabel\n        }\n        popin {\n          title\n          subtitle\n          text: description\n          buttonLabel\n          url\n          image\n          color\n        }\n        startDate\n        endDate\n        toaster {\n          title\n          subtitle: description\n          iconName\n          illustration: picto\n          color\n        }\n    }\n  }");
};

/***/ }),

/***/ "M3jp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FilterTransport; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("C/y5");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("SPKZ");
/* harmony import */ var _utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("1JJ2");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("kiXb");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("qBqs");
/* harmony import */ var _frameworks_spinner_Spinner__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("7amT");





var __jsx = react__WEBPACK_IMPORTED_MODULE_6___default.a.createElement;

/* eslint-disable clubmed/no-fake-component */








var NO_TRANSPORT_VALUE = _clubmed_utils__WEBPACK_IMPORTED_MODULE_7__["constants"].NO_TRANSPORT_VALUE;
var FilterTransport = function FilterTransport(_ref) {
  var changeDepartureCity = _ref.changeDepartureCity,
      className = _ref.className,
      _ref$dataTestId = _ref.dataTestId,
      dataTestId = _ref$dataTestId === void 0 ? 'FilterTransport' : _ref$dataTestId,
      departureCity = _ref.departureCity,
      isDisabled = _ref.isDisabled,
      isLoading = _ref.isLoading,
      optionsDepartureCities = _ref.optionsDepartureCities,
      toggleCriteriaExpansion = _ref.toggleCriteriaExpansion,
      validateDepartureCity = _ref.validateDepartureCity,
      withNoTransport = _ref.withNoTransport,
      _ref$shouldShowNoTran = _ref.shouldShowNoTransportButtonMobile,
      shouldShowNoTransportButtonMobile = _ref$shouldShowNoTran === void 0 ? true : _ref$shouldShowNoTran;

  var _useResponsive = Object(_utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_9__[/* useResponsive */ "b"])(),
      isDesktop = _useResponsive.isDesktop;

  var value = departureCity || '';
  var loading = isLoading || optionsDepartureCities.length === 0;
  var otherDepartureCities = withNoTransport ? optionsDepartureCities : optionsDepartureCities.filter(function (_ref2) {
    var departureCityCode = _ref2.value;
    return departureCityCode !== NO_TRANSPORT_VALUE;
  });
  var mainCities = Object(_i18n__WEBPACK_IMPORTED_MODULE_10__[/* getListValue */ "e"])('faceting.transport.departureCities.mainCitiesList') || [];
  var optionsMainDepartureCities = optionsDepartureCities.filter(function (_ref3) {
    var cityCode = _ref3.value;
    return mainCities.includes(cityCode);
  });

  var renderTitle = function renderTitle(shouldShowNoTransportButton) {
    if (!isDesktop) {
      return __jsx("div", {
        className: "flex flex-col"
      }, shouldShowNoTransportButton && __jsx("div", {
        className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_5__[/* classnames */ "a"])('px-20 py-15', {
          'font-bold text-success': value === NO_TRANSPORT_VALUE
        })
      }, __jsx("label", {
        className: "flex cursor-pointer items-baseline justify-between rounded-2 hocus:bg-lightGrey",
        htmlFor: NO_TRANSPORT_VALUE
      }, __jsx("input", {
        checked: value === NO_TRANSPORT_VALUE,
        className: "hidden",
        "data-testid": "".concat(dataTestId, "-").concat(NO_TRANSPORT_VALUE),
        disabled: isDisabled,
        id: NO_TRANSPORT_VALUE,
        name: "TransportSelectFilter",
        onChange: function onChange(e) {
          return changeDepartureCity(e.target.value, toggleCriteriaExpansion);
        },
        onClick: function onClick(e) {
          return validateDepartureCity(e.target.value);
        },
        type: "radio",
        value: NO_TRANSPORT_VALUE
      }), Object(_i18n__WEBPACK_IMPORTED_MODULE_10__[/* t */ "h"])('faceting.transport.noTransportNeededMobile'), value === NO_TRANSPORT_VALUE && __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_11__[/* Icon */ "a"], {
        name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_8__[/* ICONS */ "a"].CHECK,
        width: "0.625rem"
      }))), __jsx("div", {
        className: "border-b-1 border-lightGrey p-20 py-15"
      }, __jsx("p", {
        className: "text-16 font-bold"
      }, Object(_i18n__WEBPACK_IMPORTED_MODULE_10__[/* t */ "h"])('faceting.transport.transportNeededMobile'))));
    }

    return __jsx("div", {
      className: "border-b-1 border-lightGrey p-20 py-15"
    }, __jsx("p", {
      className: "text-16 font-bold"
    }, Object(_i18n__WEBPACK_IMPORTED_MODULE_10__[/* t */ "h"])('faceting.when.from')));
  };

  var renderDepartureCitiesOptions = function renderDepartureCitiesOptions(departureCities) {
    return departureCities.map(function (o) {
      return __jsx("li", {
        className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_5__[/* classnames */ "a"])({
          'font-bold text-success': o.value === value
        }),
        key: o.value,
        "data-testid": "filterTransport-city"
      }, __jsx("label", {
        className: "-mx-20 flex cursor-pointer items-baseline justify-between rounded-2 px-20 py-5 hocus:bg-lightGrey",
        htmlFor: o.value
      }, __jsx("input", {
        checked: o.value === value,
        className: "hidden",
        "data-testid": "".concat(dataTestId, "-").concat(o.value),
        disabled: o.isDisabled || isDisabled,
        id: o.value,
        name: "TransportSelectFilter",
        onChange: function onChange(e) {
          return changeDepartureCity(e.target.value, toggleCriteriaExpansion);
        },
        type: "radio",
        value: o.value
      }), o.label, o.value === value && __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_11__[/* Icon */ "a"], {
        name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_8__[/* ICONS */ "a"].CHECK,
        width: "0.625rem"
      })));
    });
  };

  return __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_5__[/* classnames */ "a"])('flex flex-col', className),
    "data-testid": "FilterTransport"
  }, renderTitle(shouldShowNoTransportButtonMobile), loading ? __jsx("div", {
    className: "flex flex-1 items-center justify-center p-20 leading-0"
  }, __jsx(_frameworks_spinner_Spinner__WEBPACK_IMPORTED_MODULE_12__[/* Spinner */ "a"], {
    size: "small"
  })) : __jsx("div", {
    className: "max-h-none overflow-y-auto px-20 text-14 lg:max-h-240"
  }, optionsMainDepartureCities.length > 0 && __jsx(react__WEBPACK_IMPORTED_MODULE_6__["Fragment"], null, __jsx("p", {
    className: "border-b-1 border-dashed border-grey py-5 text-mediumGrey"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_10__[/* t */ "h"])('faceting.transport.departureCities.mainCities')), __jsx("ul", {
    className: "mb-10 flex-1 pb-5 lg:flex-none"
  }, renderDepartureCitiesOptions(optionsMainDepartureCities)), __jsx("p", {
    className: "border-b-1 border-dashed border-grey py-5 text-mediumGrey"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_10__[/* t */ "h"])('faceting.transport.departureCities.allCities'))), __jsx("ul", {
    className: "flex-1 lg:flex-none"
  }, renderDepartureCitiesOptions(otherDepartureCities))));
};

/***/ }),

/***/ "O7yO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_OPTION_VALIDITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UNSET_OPTION_VALIDITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return optionValidityReducer; });
var SET_OPTION_VALIDITY = 'SET_OPTION_VALIDITY';
var UNSET_OPTION_VALIDITY = 'UNSET_OPTION_VALIDITY';
var initialState = null;
var optionValidityReducer = function optionValidityReducer() {
  var _action$payload$local, _action$payload;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SET_OPTION_VALIDITY:
      /**
       * TODO: fix async tests with payload missing
       * broke:
       * - src/client/components/widgets/price-remote/PriceRemote.spec.js
       * - src/client/views/booking/booking-confirmation/BookingConfirmationView.spec.js
       */
      return (_action$payload$local = action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.locale.optionValidity) !== null && _action$payload$local !== void 0 ? _action$payload$local : null;

    case UNSET_OPTION_VALIDITY:
      return initialState;

    default:
      return state;
  }
};

/***/ }),

/***/ "PwcU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ATTENDEES_ROLES; });
/* unused harmony export getAttendeeValidationSchema */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getAttendeeValidationSchemaByRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAddressValidationSchema; });
/* unused harmony export getAttendeesValidationSchema */
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ZVkB");
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("zygG");


var ATTENDEES_ROLES = {
  MAIN: 'MAIN',
  OTHER_ADULT: 'OTHER_ADULT',
  KID: 'KID'
};

var getAttendeeValidationSchema = function getAttendeeValidationSchema(role) {
  return function (_ref) {
    var validationSchema = _ref.validationSchema;

    if (Object(ATTENDEES_ROLES).hasOwnProperty(role)) {
      return validationSchema[role];
    }

    throw new Error('USER ROLE DOES NOT EXIST');
  };
};

var getAttendeeValidationSchemaByRole = function getAttendeeValidationSchemaByRole(isMain, isChild) {
  var role = ATTENDEES_ROLES.OTHER_ADULT;

  if (isChild) {
    role = ATTENDEES_ROLES.KID;
  } else if (isMain) {
    role = ATTENDEES_ROLES.MAIN;
  }

  return getAttendeeValidationSchema(role);
};

var getAddressValidationSchema = function getAddressValidationSchema(_ref2) {
  var validationSchema = _ref2.validationSchema;
  return validationSchema.address;
};

var getAttendeesValidationSchema = function getAttendeesValidationSchema(_ref3) {
  var validationSchema = _ref3.validationSchema;
  var schemaByType = {};

  for (var _i = 0, _Object$entries = Object.entries(validationSchema); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        schema = _Object$entries$_i[1];

    if (Object(ATTENDEES_ROLES).hasOwnProperty(key)) {
      schemaByType[key] = schema;
    }
  }

  return schemaByType;
};



/***/ }),

/***/ "Q10v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ AccommodationOption_AccommodationOption; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/strip-button/StripButton.jsx + 1 modules
var StripButton = __webpack_require__("ZpYc");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/utils/proposal/proposalUtils.js
var proposalUtils = __webpack_require__("oL6k");

// EXTERNAL MODULE: ./src/utils/seller/sellerUtils.js + 1 modules
var sellerUtils = __webpack_require__("KL6I");

// CONCATENATED MODULE: ./src/client/components/widgets/accommodation-option/AccommodationOptionPrice.jsx
var __jsx = react_default.a.createElement;






var AccommodationOptionPrice_AccommodationOptionPrice = function AccommodationOptionPrice(_ref) {
  var className = _ref.className,
      currency = _ref.currency,
      nigthly = _ref.nigthly,
      total = _ref.total,
      _ref$isUpgradableOnli = _ref.isUpgradableOnline,
      isUpgradableOnline = _ref$isUpgradableOnli === void 0 ? true : _ref$isUpgradableOnli;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var locale = appContext.locale;
  var displayPricePerNightB2C = Object(i18n["d" /* getKeyValue */])('booking.accommodation.moreRooms.displayPricePerNight_B2C');
  var displayPricePerNightB2B = Object(i18n["d" /* getKeyValue */])('booking.accommodation.moreRooms.displayPricePerNight_B2B');
  var displayPricePerNight = !Object(sellerUtils["f" /* isSeller */])(appContext) && displayPricePerNightB2C || Object(sellerUtils["f" /* isSeller */])(appContext) && displayPricePerNightB2B;
  var testId;
  var labelText;

  if (!isUpgradableOnline) {
    testId = 'AccommodationOptionPrice-notUpgradable';
    labelText = Object(i18n["h" /* t */])('booking.accommodation.upgradeRoom.villaPricing');
  } else if (displayPricePerNight && nigthly !== 0) {
    testId = 'AccommodationOptionPrice-perNight';
    labelText = Object(i18n["h" /* t */])('booking.accommodation.moreRooms.perNight');
  } else if (total === 0) {
    testId = 'AccommodationOptionPrice-mention';
    labelText = Object(i18n["h" /* t */])('booking.accommodation.moreRooms.includedRoom');
  }

  var label = labelText ? __jsx("span", {
    "data-testid": testId
  }, labelText) : '';
  return __jsx("p", {
    className: Object(classnames_utils["a" /* classnames */])('flex font-bold gap-5 text-18 text-sienna', className),
    "data-testid": "AccommodationOptionPrice"
  }, isUpgradableOnline && Object(proposalUtils["e" /* getFormatedPriceByLocale */])(displayPricePerNight ? nigthly : total, locale, currency), label);
};
// CONCATENATED MODULE: ./src/client/components/widgets/accommodation-option/AccommodationOption.jsx
var AccommodationOption_jsx = react_default.a.createElement;






var AccommodationOption_AccommodationOption = function AccommodationOption(_ref) {
  var children = _ref.children,
      className = _ref.className,
      id = _ref.id,
      _ref$index = _ref.index,
      index = _ref$index === void 0 ? 0 : _ref$index,
      onSelect = _ref.onSelect,
      price = _ref.price;
  return AccommodationOption_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('relative isolate rounded-12 border-1 border-lightGrey bg-white', className),
    "data-testid": "AccommodationOption",
    id: id
  }, AccommodationOption_jsx("div", {
    className: "absolute bottom-full z-1 mx-10"
  }, AccommodationOption_jsx(StripButton["a" /* StripButton */], {
    className: "font-sans text-10",
    height: 20
  }, Object(i18n["h" /* t */])('common.proposalLabel'), "\xA0", index)), children, AccommodationOption_jsx("div", {
    className: "flex items-center justify-end gap-10 border-t-1 border-lightGrey p-20",
    "data-testid": "AccommodationOption-footer"
  }, AccommodationOption_jsx(AccommodationOptionPrice_AccommodationOptionPrice, price), AccommodationOption_jsx(Button["a" /* Button */], {
    className: "w-auto",
    "data-testid": "AccommodationOption-select",
    onClick: onSelect
  }, (price === null || price === void 0 ? void 0 : price.isUpgradableOnline) ? Object(i18n["h" /* t */])('booking.accommodation.moreRooms.selectNewRoom') : Object(i18n["h" /* t */])('booking.accommodation.upgradeRoom.contactATED'))));
};

/***/ }),

/***/ "Q8Qh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return themes; });
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("C/y5");

var themes = function themes(_ref) {
  var _ref$hasArrow = _ref.hasArrow,
      hasArrow = _ref$hasArrow === void 0 ? true : _ref$hasArrow;
  return {
    "default": {
      thBody: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_0__[/* classnames */ "a"])('bg-white border-1 border-lightGrey mt-15 p-10 shadow-lg', {
        'arrow-up arrow-white arrow-bg arrow-bg-grey': hasArrow
      })
    },
    hollow: {
      thBody: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_0__[/* classnames */ "a"])('bg-white border-1 border-lightGrey rounded-12 shadow-lg', {
        'arrow-up arrow-white arrow-bg arrow-bg-lightGrey': hasArrow
      })
    }
  };
};

/***/ }),

/***/ "QkOM":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("9JhN");
var trim = __webpack_require__("Ya2h").trim;
var whitespaces = __webpack_require__("+/eK");

var $parseInt = global.parseInt;
var hex = /^[+-]?0[Xx]/;
var FORCED = $parseInt(whitespaces + '08') !== 8 || $parseInt(whitespaces + '0x16') !== 22;

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
module.exports = FORCED ? function parseInt(string, radix) {
  var S = trim(String(string));
  return $parseInt(S, (radix >>> 0) || (hex.test(S) ? 16 : 10));
} : $parseInt;


/***/ }),

/***/ "RHTr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Sheet; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/components/utils/ratios/ratios.utils.js
var ratios_utils = __webpack_require__("u/u4");

// EXTERNAL MODULE: ./src/client/components/frameworks/badge/Badge.jsx + 1 modules
var Badge = __webpack_require__("VHif");

// EXTERNAL MODULE: ./src/client/components/widgets/hero/Hero.jsx
var Hero = __webpack_require__("2B1m");

// EXTERNAL MODULE: ./src/client/components/widgets/multimedia/Multimedia.jsx + 7 modules
var Multimedia = __webpack_require__("h3D+");

// EXTERNAL MODULE: ./src/client/components/frameworks/image-slideshow/ImageSlideShow.jsx
var ImageSlideShow = __webpack_require__("DQFb");

// CONCATENATED MODULE: ./src/client/components/frameworks/sheet/Sheet.themes.js

var themes = {
  "default": function _default(_ref) {
    var hasDiamond = _ref.hasDiamond,
        hasSlideshow = _ref.hasSlideshow,
        isExclusiveCollection = _ref.isExclusiveCollection,
        fullWidthContent = _ref.fullWidthContent;
    return {
      thRoot: 'bg-white',
      thHeader: '',
      thHeaderContainer: 'mx-auto w-full max-w-site-medium',
      thTop: Object(classnames_utils["a" /* classnames */])('relative', {
        'mb-35 lg:mb-55': hasDiamond,
        'md:mb-[11px] md:mt-54': !hasDiamond
      }),
      thHero: hasSlideshow ? 'absolute overflow-hidden inset-0' : '',
      thHeroImmersive: hasSlideshow ? 'min-h-[102%] filter-[blur(10px)] opacity-25' : '',
      thSlideshow: "my-0 mx-auto w-full ".concat(isExclusiveCollection ? 'bg-ultramarine' : 'bg-darkGrey'),
      thMultimediaOverlay: 'absolute inset-0 mb-10',
      thDiamond: 'absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2 -mb-2',
      thDiamondClassName: 'font-bold uppercase text-10 sm:text-12 size-60 lg:size-75',
      thBody: "".concat(fullWidthContent ? '' : 'px-20', " py-20 lg:py-15"),
      thContent: "".concat(fullWidthContent ? '' : 'max-w-site-medium', " mx-auto w-full"),
      thFooter: 'bg-pearl overflow-hidden px-20'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/sheet/Sheet.jsx



var __jsx = react_default.a.createElement;









function Sheet(_ref) {
  var children = _ref.children,
      header = _ref.header,
      className = _ref.className,
      diamond = _ref.diamond,
      immersive = _ref.immersive,
      isExclusiveCollection = _ref.isExclusiveCollection,
      footer = _ref.footer,
      fullWidthContent = _ref.fullWidthContent,
      multimedia = _ref.multimedia,
      _ref$slideshow = _ref.slideshow,
      slideshow = _ref$slideshow === void 0 ? {} : _ref$slideshow,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var _useState = Object(react["useState"])(0),
      imageIndex = _useState[0],
      setImageIndex = _useState[1];

  if (!react["Children"].count(children)) {
    return null;
  }

  var hasSlideshow = !isEmpty_default()(slideshow.media);
  var hasDiamond = !isEmpty_default()(diamond);

  var _themes$theme = themes[theme]({
    hasDiamond: hasDiamond,
    hasSlideshow: hasSlideshow,
    isExclusiveCollection: isExclusiveCollection,
    fullWidthContent: fullWidthContent
  }),
      thBody = _themes$theme.thBody,
      thContent = _themes$theme.thContent,
      thDiamond = _themes$theme.thDiamond,
      thDiamondClassName = _themes$theme.thDiamondClassName,
      thFooter = _themes$theme.thFooter,
      thHeader = _themes$theme.thHeader,
      thHeaderContainer = _themes$theme.thHeaderContainer,
      thHero = _themes$theme.thHero,
      thHeroImmersive = _themes$theme.thHeroImmersive,
      thMultimediaOverlay = _themes$theme.thMultimediaOverlay,
      thRoot = _themes$theme.thRoot,
      thSlideshow = _themes$theme.thSlideshow,
      thTop = _themes$theme.thTop;

  return __jsx("section", {
    className: Object(classnames_utils["a" /* classnames */])(thRoot, className)
  }, header && __jsx("div", {
    className: thHeaderContainer,
    "data-testid": "Sheet-header"
  }, __jsx("div", {
    className: thHeader
  }, header)), (!isEmpty_default()(immersive) || hasSlideshow) && __jsx("div", {
    className: thTop
  }, !isEmpty_default()(immersive) && !hasSlideshow && __jsx("div", {
    className: thHero
  }, __jsx(Hero["a" /* Hero */], Object(esm_extends["a" /* default */])({}, immersive, {
    className: Object(classnames_utils["a" /* classnames */])(thHeroImmersive, immersive.className),
    size: "medium"
  }))), hasSlideshow && __jsx(react_default.a.Fragment, null, __jsx("div", {
    className: thSlideshow
  }, __jsx(ImageSlideShow["a" /* ImageSlideShow */], Object(esm_extends["a" /* default */])({
    media: slideshow.media,
    nbItemsToShow: 1,
    centerPadding: isTablet ? 0.25 : 0,
    fadeUnseenItems: isTablet,
    spacerWidth: isTablet ? 5 : 0,
    ratio: ratios_utils["c" /* default */].XL,
    onChangeIndex: setImageIndex
  }, slideshow)), __jsx("div", {
    className: "absolute start-0 top-0 mx-10 my-10 rounded-4 bg-darkGrey/80 px-15 py-10 text-14 text-white shadow-sm md:bottom-0 md:top-auto md:mx-20"
  }, "".concat(imageIndex + 1, "/").concat(slideshow.media.length))), !isEmpty_default()(multimedia) && __jsx("div", {
    className: thMultimediaOverlay
  }, __jsx(Multimedia["a" /* Multimedia */], Object(esm_extends["a" /* default */])({}, multimedia, {
    className: "flex h-full flex-col",
    hasFullScreenButton: true,
    initialIndex: imageIndex
  })))), hasDiamond && __jsx("div", {
    className: thDiamond
  }, __jsx(Badge["a" /* Badge */], Object(esm_extends["a" /* default */])({}, diamond, {
    className: Object(classnames_utils["a" /* classnames */])(thDiamondClassName, diamond === null || diamond === void 0 ? void 0 : diamond.className),
    variant: "diamond"
  })))), __jsx("div", {
    className: thBody,
    "data-testid": "Sheet-body"
  }, __jsx("div", {
    className: thContent
  }, children)), !!footer && __jsx("footer", {
    className: thFooter
  }, __jsx("div", {
    className: thContent
  }, footer)));
}

/***/ }),

/***/ "RmUC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserInfoSummary; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("SPKZ");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_string_stringUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("E8Xq");
/* harmony import */ var _frameworks_capsule_Capsule__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("jldR");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("qBqs");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;






var UserInfoSummary = function UserInfoSummary(_ref) {
  var className = _ref.className,
      onClickEdit = _ref.onClickEdit,
      user = _ref.user;

  if (!user) {
    return null;
  }

  var _user$address = user.address,
      address = _user$address === void 0 ? {} : _user$address,
      civility = user.civility,
      email = user.email,
      firstName = user.firstName,
      lastName = user.lastName,
      mobilePhoneNumber = user.mobilePhoneNumber,
      unicodeFirstName = user.unicodeFirstName,
      unicodeLastName = user.unicodeLastName;
  var city = address.city,
      stateOrDistrict = address.stateOrDistrict,
      streetName = address.streetName,
      streetNumber = address.streetNumber,
      zipCode = address.zipCode;
  var hasUnicode = !!unicodeFirstName && !!unicodeLastName;
  var formatedCivility = civility ? "".concat(civility, ". ") : '';
  var names = hasUnicode ? [unicodeFirstName, unicodeLastName] : [Object(_utils_string_stringUtils__WEBPACK_IMPORTED_MODULE_5__[/* capitalizeWordFirstCaracter */ "c"])(firstName), Object(_utils_string_stringUtils__WEBPACK_IMPORTED_MODULE_5__[/* capitalizeWordFirstCaracter */ "c"])(lastName)];
  var name = [formatedCivility].concat(names).join(' ');
  return __jsx("div", {
    className: className
  }, __jsx(_frameworks_capsule_Capsule__WEBPACK_IMPORTED_MODULE_6__[/* Capsule */ "a"], {
    header: "none",
    dataTestId: "PreCompletedForm"
  }, __jsx("div", {
    className: "air360-replay-ignore flex px-10 md:px-5",
    "data-cs-mask": true
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_7__[/* Icon */ "a"], {
    className: "m-20 hidden text-sienna md:block",
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__[/* ICONS */ "a"].ICON_45,
    width: "2.375rem"
  }), __jsx("div", {
    className: "pb-15 pt-10"
  }, __jsx("div", {
    className: "flex flex-col"
  }, __jsx("strong", null, name), __jsx("span", {
    className: "me-30"
  }, email || ''), __jsx("span", null, mobilePhoneNumber || ''), __jsx("span", {
    className: "me-25"
  }, "".concat(streetNumber || '', " ").concat(streetName || '')), __jsx("span", null, "".concat(zipCode || '', " ").concat(stateOrDistrict || '', " ").concat(city || '')))))), onClickEdit && __jsx("div", {
    className: "mt-10 flex justify-end"
  }, __jsx("button", {
    className: "cursor-pointer text-14 underline",
    onClick: onClickEdit,
    type: "button"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "h"])('common.edit'))));
};

/***/ }),

/***/ "RqHf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PRICE_COLOR_CLASS_NAMES; });
/* unused harmony export mixedToMoment */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return dateToInt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return dateDiff; });
/* unused harmony export stringToDateFormatted */
/* unused harmony export momentToInt */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return maxDatepickerDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return minDatepickerDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return closedDaysFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return firstSiblingOpenDayOfSelectedMonthFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return siblingOpenDaysFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getDisabledDays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getPriceColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return flattenPrices; });
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("6U7i");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_number_parse_int__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("dLd+");
/* harmony import */ var core_js_modules_es_number_parse_int__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_parse_int__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("fGyu");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("MwrP");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _store_calendar_calendar_helper__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("VtPb");
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("ldK3");
/* harmony import */ var _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("sW3P");
















var PRICE_COLOR_CLASS_NAMES = {
  DARK_GREY: 'text-black hocus:text-black-active',
  GREEN: 'text-green',
  GREEN_OPACITY_45: 'text-green bestPrice',
  GREY: 'text-grey hocus:text-black-active',
  ORANGE: 'text-orange',
  ORANGE_OPACITY_45: 'text-orange lastAvailability',
  WHITE: 'text-white',
  TURQUOISE: 'text-turquoise'
};
var mixedToMoment = function mixedToMoment(mixedDate) {
  return moment__WEBPACK_IMPORTED_MODULE_12___default()(mixedDate);
};
var dateToInt = function dateToInt(d) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_14__[/* API_DATE_FORMAT */ "a"];
  return parseInt(mixedToMoment(d).format(format), 10);
};
var dateDiff = function dateDiff(day1, day2) {
  return Math.abs(moment__WEBPACK_IMPORTED_MODULE_12___default()(day2).diff(moment__WEBPACK_IMPORTED_MODULE_12___default()(day1), 'days'));
};
var stringToDateFormatted = function stringToDateFormatted(date, format) {
  return moment__WEBPACK_IMPORTED_MODULE_12___default()(date).format(format);
};
var momentToInt = function momentToInt(date) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_14__[/* API_DATE_FORMAT */ "a"];
  return parseInt(date.format(format), 10);
};
var maxDatepickerDate = function maxDatepickerDate() {
  return moment__WEBPACK_IMPORTED_MODULE_12___default()().add(_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_15__[/* DEPARTURE_DATE_MAX_DATE */ "t"]).toDate();
};
var minDatepickerDate = function minDatepickerDate() {
  var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return moment__WEBPACK_IMPORTED_MODULE_12___default()().add({
    days: offset
  }).toDate();
};

function daysWithoutDepartureFactory(resolver, fromDate, toDate) {
  return function (day) {
    var _resolver = resolver(dateToInt(day)),
        _resolver$exclusivity = _resolver.exclusivity,
        exclusivity = _resolver$exclusivity === void 0 ? false : _resolver$exclusivity,
        _resolver$noFlight = _resolver.noFlight,
        noFlight = _resolver$noFlight === void 0 ? false : _resolver$noFlight,
        _resolver$full = _resolver.full,
        full = _resolver$full === void 0 ? false : _resolver$full;

    var available = !exclusivity && !noFlight && !full;

    if (!fromDate && !toDate) {
      return !available;
    }

    if (fromDate && !toDate) {
      return false;
    }

    var dayIsSelected = fromDate && toDate && dateToInt(day) >= dateToInt(fromDate) && dateToInt(day) <= dateToInt(toDate);
    return !dayIsSelected && !available;
  };
}

var daysWithNoAvailabilityFactory = function daysWithNoAvailabilityFactory(resolver) {
  return function (day) {
    var data = resolver(dateToInt(day));
    return lodash_isEmpty__WEBPACK_IMPORTED_MODULE_11___default()(data) || data.noAvailability;
  };
};

var closedDaysFactory = function closedDaysFactory(resolver, fromDate, toDate, shouldAllowSelectingSiblingOpenDays) {
  return function (day) {
    var _resolver2 = resolver(dateToInt(day)),
        _resolver2$closed = _resolver2.closed,
        closed = _resolver2$closed === void 0 ? false : _resolver2$closed,
        _resolver2$siblingOpe = _resolver2.siblingOpen,
        siblingOpen = _resolver2$siblingOpe === void 0 ? false : _resolver2$siblingOpe;

    if (!fromDate && !toDate) {
      return closed || siblingOpen && !shouldAllowSelectingSiblingOpenDays;
    }

    if (fromDate && !toDate) {
      return false;
    }

    var dayIsSelected = fromDate && toDate && dateToInt(day) >= dateToInt(fromDate) && dateToInt(day) <= dateToInt(toDate);
    return !dayIsSelected && (closed || siblingOpen && !shouldAllowSelectingSiblingOpenDays);
  };
};
var firstSiblingOpenDayOfSelectedMonthFactory = function firstSiblingOpenDayOfSelectedMonthFactory(resolver, selectedMonth) {
  var firstSiblingOpenDayFound;
  return function (day) {
    var _resolver3;

    if (!selectedMonth) {
      return false;
    }

    var firstDayOfSelectedMonth = "".concat(selectedMonth.toString(), "01");
    var firstDayOfSelectedMonthAsDate = moment__WEBPACK_IMPORTED_MODULE_12___default()(firstDayOfSelectedMonth, _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_14__[/* API_DATE_FORMAT */ "a"]);
    var firstDisplayedDayOfSelectedMonthAsInt = firstDayOfSelectedMonthAsDate.weekday() > 0 ? momentToInt(firstDayOfSelectedMonthAsDate.subtract(firstDayOfSelectedMonthAsDate.weekday(), 'days')) : momentToInt(firstDayOfSelectedMonthAsDate);
    var lastDisplayedDayOfSelectedMonthAsInt = momentToInt(moment__WEBPACK_IMPORTED_MODULE_12___default()(firstDayOfSelectedMonthAsDate).add(41, 'days'));
    var currentDayDateAsInt = dateToInt(day);

    if (firstSiblingOpenDayFound && firstSiblingOpenDayFound !== dateToInt(day) || currentDayDateAsInt < firstDisplayedDayOfSelectedMonthAsInt || currentDayDateAsInt > lastDisplayedDayOfSelectedMonthAsInt) {
      return false;
    }

    var hasSiblingOpen = ((_resolver3 = resolver(currentDayDateAsInt)) === null || _resolver3 === void 0 ? void 0 : _resolver3.siblingOpen) || false;

    if (hasSiblingOpen) {
      firstSiblingOpenDayFound = dateToInt(day);
    }

    return hasSiblingOpen;
  };
};
var siblingOpenDaysFactory = function siblingOpenDaysFactory(resolver) {
  return function (day) {
    var _resolver4;

    return ((_resolver4 = resolver(dateToInt(day))) === null || _resolver4 === void 0 ? void 0 : _resolver4.siblingOpen) || false;
  };
};

var unavailableReturnDaysFactory = function unavailableReturnDaysFactory(fromDate) {
  var durations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return function (day) {
    if (day < fromDate) {
      return false;
    }

    var duration = dateDiff(day, fromDate); // rule of max 30 days of reservation

    if (duration > 30) {
      return true;
    }

    return !!duration && !durations.includes(duration);
  };
};

function getDisabledDays(_ref) {
  var from = _ref.from,
      isSeller = _ref.isSeller,
      optionsDuration = _ref.optionsDuration,
      openingDates = _ref.openingDates,
      prices = _ref.prices,
      resolvePrice = _ref.resolvePrice,
      shouldAllowSelectingSiblingOpenDays = _ref.shouldAllowSelectingSiblingOpenDays,
      to = _ref.to;
  var disabledDays = [];
  var pricesIds = Object.keys(prices || {});
  var hasPrices = pricesIds.length > 0;
  var allClosedDays = pricesIds.filter(function (priceKey) {
    return prices && (prices[priceKey].closed || prices[priceKey].siblingOpen && !shouldAllowSelectingSiblingOpenDays);
  }).map(function (priceKey) {
    return parseInt(priceKey, 10);
  });

  if (hasPrices) {
    var dayIsWithoutDeparture = daysWithoutDepartureFactory(resolvePrice, from, to);
    var dayIsClosed = closedDaysFactory(resolvePrice, from, to, shouldAllowSelectingSiblingOpenDays);
    var dayIsSiblingOpen = siblingOpenDaysFactory(resolvePrice);
    var dayIsWithoutData = daysWithNoAvailabilityFactory(resolvePrice);
    disabledDays.push(dayIsWithoutDeparture);
    disabledDays.push(dayIsClosed);

    if (!shouldAllowSelectingSiblingOpenDays) {
      disabledDays.push(dayIsSiblingOpen);
    }

    disabledDays.push(dayIsWithoutData);
  }

  if (from && !to) {
    var fromDay = dateToInt(from);
    var closedDaysAfterFromDay = allClosedDays.filter(function (closedDay) {
      return closedDay > fromDay;
    });
    var firstClosedDay = hasPrices && closedDaysAfterFromDay.length > 0 && Math.min.apply(null, closedDaysAfterFromDay);
    disabledDays.push({
      before: moment__WEBPACK_IMPORTED_MODULE_12___default()(from).toDate(),
      after: firstClosedDay ? moment__WEBPACK_IMPORTED_MODULE_12___default()(firstClosedDay.toString()).toDate() : moment__WEBPACK_IMPORTED_MODULE_12___default()(from).add(30, 'days').toDate()
    });
  }

  if (from && !to && !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_11___default()(optionsDuration) && !isSeller) {
    disabledDays.push(unavailableReturnDaysFactory(from, optionsDuration));
  }

  if (openingDates === null || openingDates === void 0 ? void 0 : openingDates.length) {
    disabledDays.push.apply(disabledDays, Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])(Object(_store_calendar_calendar_helper__WEBPACK_IMPORTED_MODULE_13__[/* getClosingDatesRanges */ "b"])(openingDates)));
  }

  return disabledDays;
}
function getPriceColor(_ref2) {
  var classColor = _ref2.classColor,
      from = _ref2.from,
      hasPrices = _ref2.hasPrices,
      resolvePrice = _ref2.resolvePrice,
      selectedMonth = _ref2.selectedMonth,
      to = _ref2.to;
  return function (day) {
    var dayAsInt = dateToInt(day);

    if (selectedMonth) {
      var firstDayOfCurrentMonth = Number.parseInt("".concat(selectedMonth, "01"), 10);
      var lastDayOfCurrentMonth = Number.parseInt("".concat(selectedMonth, "31"), 10); // Handle dates outside current month & without prices

      var isDayBeforeSelectedMonth = Boolean(dayAsInt < firstDayOfCurrentMonth);
      var isDayAfterSelectedMonth = Boolean(dayAsInt > lastDayOfCurrentMonth);

      if (isDayBeforeSelectedMonth || !from && isDayAfterSelectedMonth || !hasPrices) {
        return classColor === PRICE_COLOR_CLASS_NAMES.GREY;
      }
    }

    if (from) {
      var fromDateAsInt = dateToInt(from);

      if (to) {
        var toDateAsInt = dateToInt(to); // Handle dates between from and to dates

        if (dayAsInt >= fromDateAsInt && dayAsInt <= toDateAsInt) {
          return classColor === PRICE_COLOR_CLASS_NAMES.WHITE;
        }
      } else {
        if (dayAsInt === fromDateAsInt) {
          return classColor === PRICE_COLOR_CLASS_NAMES.WHITE;
        } // Handle dates before and after from date


        switch (classColor) {
          case PRICE_COLOR_CLASS_NAMES.WHITE:
            return false;

          case PRICE_COLOR_CLASS_NAMES.GREEN_OPACITY_45:
          case PRICE_COLOR_CLASS_NAMES.GREY:
          case PRICE_COLOR_CLASS_NAMES.ORANGE_OPACITY_45:
            if (dayAsInt >= fromDateAsInt) {
              return false;
            }

            break;

          default:
            if (dayAsInt < fromDateAsInt) {
              return false;
            }

            break;
        }
      }
    } // Get the correct color based on price


    if (resolvePrice) {
      var dayWithPrice = resolvePrice(dateToInt(day)) || {
        isBestPrice: false,
        lastAvailability: false,
        price: ''
      };
      var isBestPrice = dayWithPrice.isBestPrice,
          lastAvailability = dayWithPrice.lastAvailability,
          price = dayWithPrice.price,
          siblingOpen = dayWithPrice.siblingOpen;

      if (siblingOpen) {
        return from ? classColor === PRICE_COLOR_CLASS_NAMES.TURQUOISE || classColor === PRICE_COLOR_CLASS_NAMES.TURQUOISE : classColor === PRICE_COLOR_CLASS_NAMES.TURQUOISE;
      }

      if (lastAvailability) {
        return from ? classColor === PRICE_COLOR_CLASS_NAMES.ORANGE || classColor === PRICE_COLOR_CLASS_NAMES.ORANGE_OPACITY_45 : classColor === PRICE_COLOR_CLASS_NAMES.ORANGE;
      }

      if (isBestPrice) {
        return from ? classColor === PRICE_COLOR_CLASS_NAMES.GREEN || classColor === PRICE_COLOR_CLASS_NAMES.GREEN_OPACITY_45 : classColor === PRICE_COLOR_CLASS_NAMES.GREEN;
      }

      if (price) {
        return from ? classColor === PRICE_COLOR_CLASS_NAMES.DARK_GREY || classColor === PRICE_COLOR_CLASS_NAMES.GREY : classColor === PRICE_COLOR_CLASS_NAMES.DARK_GREY;
      }
    }

    return false;
  };
}
function flattenPrices(prices) {
  var pricesIds = Object.keys(prices);
  return pricesIds.map(function (priceId) {
    return prices[priceId].oldPrice;
  }).join();
}

/***/ }),

/***/ "S4CH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PaidBankingFormContent; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("qBqs");
/* harmony import */ var _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("SPKZ");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("kiXb");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;




var PaidBankingFormContent = function PaidBankingFormContent() {
  return __jsx("div", {
    className: "flex items-center"
  }, __jsx(_components_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_1__[/* Icon */ "a"], {
    className: "mr-10 text-green",
    name: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__[/* ICONS */ "a"].SMALL_CIRCLE_CHECK,
    width: "2em"
  }), __jsx("div", {
    className: "text-3xl mt-0 font-brand text-saffron"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('booking.partners.participants.multiGM.bookingConfirmed')));
};

/***/ }),

/***/ "Tz41":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/find.js
var find = __webpack_require__("6R5o");
var find_default = /*#__PURE__*/__webpack_require__.n(find);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: ./src/client/store/toast/toast.actions.js
var toast_actions = __webpack_require__("7Z8V");

// EXTERNAL MODULE: ./src/client/store/global-loader/globalLoader.action.js
var globalLoader_action = __webpack_require__("R2jv");

// EXTERNAL MODULE: ./src/client/store/booking/proposals/proposals.action.js + 2 modules
var proposals_action = __webpack_require__("AnR0");

// EXTERNAL MODULE: ./src/client/store/booking/selected-proposal-id/selectedProposalId.action.js
var selectedProposalId_action = __webpack_require__("uGNg");

// EXTERNAL MODULE: ./src/client/store/booking/booking.selector.js
var booking_selector = __webpack_require__("uL19");

// EXTERNAL MODULE: ./src/client/store/cms/cms.actions.js
var cms_actions = __webpack_require__("pP7N");

// EXTERNAL MODULE: ./src/client/store/lead-info/leadInfo.selector.js
var leadInfo_selector = __webpack_require__("8fx4");

// EXTERNAL MODULE: ./src/client/views/booking/BookingEngine.query.js
var BookingEngine_query = __webpack_require__("MAH5");

// EXTERNAL MODULE: ./src/client/store/utils/createAction.js
var createAction = __webpack_require__("rJ95");

// EXTERNAL MODULE: ./src/client/store/streetViews/constants.js
var constants = __webpack_require__("Xvk6");

// CONCATENATED MODULE: ./src/client/store/streetViews/streetViews.action.js



function fetchStreetViewsByAccommodationCategoryId(_ref) {
  var productId = _ref.productId,
      accommodationCategoryIds = _ref.accommodationCategoryIds,
      appContext = _ref.appContext;
  return function (dispatch) {
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(constants["a" /* FETCH_STREET_VIEWS_BY_ACCOMMODATION_CATEGORY_ID */], {}, {
      optimist: true,
      promise: Object(BookingEngine_query["f" /* streetViewsByAccommodationCategoryId */])({
        productId: productId,
        accommodationCategoryIds: accommodationCategoryIds
      }, appContext)
    }));
  };
}
// EXTERNAL MODULE: ./src/client/tracking/constants.js
var tracking_constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/components/hoc/errorBoundary/errorBoundary.js
var errorBoundary = __webpack_require__("3B0E");

// EXTERNAL MODULE: ./src/utils/proposal/proposalUtils.js
var proposalUtils = __webpack_require__("oL6k");

// EXTERNAL MODULE: ./src/routes/constants.js
var routes_constants = __webpack_require__("dNxv");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.every.js
var es_array_every = __webpack_require__("DfhM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find-index.js
var es_array_find_index = __webpack_require__("vfdX");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__("vrRf");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("lTEL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("7xRU");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reverse.js
var es_array_reverse = __webpack_require__("wFPu");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("5BYb");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.sort.js
var es_array_sort = __webpack_require__("tQbP");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.values.js
var es_object_values = __webpack_require__("1IsZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__("JtPf");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.promise.finally.js
var es_promise_finally = __webpack_require__("Qavd");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("OZaJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("KqXw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.set.js
var es_set = __webpack_require__("LqLs");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__("87if");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("MvUL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__("Ysgh");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("kYxP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("3yYM");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("QsI/");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/omit.js
var omit = __webpack_require__("uZih");
var omit_default = /*#__PURE__*/__webpack_require__.n(omit);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isNil.js
var isNil = __webpack_require__("2Lg3");
var isNil_default = /*#__PURE__*/__webpack_require__.n(isNil);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("VtSi");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: /opt/webapp/node_modules/next/router.js
var next_router = __webpack_require__("Bkb1");

// EXTERNAL MODULE: /opt/webapp/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// EXTERNAL MODULE: ./logger/logger.js
var logger = __webpack_require__("zytj");

// EXTERNAL MODULE: ./src/utils/context/contextUtils.js
var contextUtils = __webpack_require__("igjW");

// EXTERNAL MODULE: ./src/routes/routeBuilder.js + 1 modules
var routeBuilder = __webpack_require__("U2CP");

// EXTERNAL MODULE: ./src/utils/invariant/invariant.js
var invariant = __webpack_require__("UQkB");

// EXTERNAL MODULE: ./src/errors/errors.js + 4 modules
var errors_errors = __webpack_require__("wNDy");

// EXTERNAL MODULE: ./src/client/local-storage-api/index.js
var local_storage_api = __webpack_require__("1RIK");

// EXTERNAL MODULE: /opt/webapp/node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__("fYnN");
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// EXTERNAL MODULE: ./src/client/components/widgets/header-lite/HeaderLite.jsx + 1 modules
var HeaderLite = __webpack_require__("W5pp");

// EXTERNAL MODULE: /opt/webapp/node_modules/next/head.js
var head = __webpack_require__("vpUC");
var head_default = /*#__PURE__*/__webpack_require__.n(head);

// EXTERNAL MODULE: ./src/client/components/frameworks/portal/Portal.constants.js
var Portal_constants = __webpack_require__("Yd/I");

// EXTERNAL MODULE: ./src/client/components/frameworks/portal/Portal.jsx
var Portal = __webpack_require__("3uBn");

// CONCATENATED MODULE: ./src/client/components/widgets/booking-accessible-title/BookingAccessibleTitle.jsx
var __jsx = react_default.a.createElement;




var BookingAccessibleTitle_BookingAccessibleTitle = function BookingAccessibleTitle(_ref) {
  var title = _ref.title;
  var titleRef = Object(react["useRef"])(null);
  Object(react["useEffect"])(function () {
    if (titleRef.current) {
      titleRef.current.focus();
    }
  }, [title]);
  return __jsx(Portal["a" /* default */], {
    name: Portal_constants["a" /* ACCESSIBLE_TITLE */]
  }, __jsx(head_default.a, null, __jsx("title", {
    key: "title"
  }, title)), __jsx("p", {
    ref: titleRef,
    className: "sr-only",
    tabIndex: "-1"
  }, title));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/Responsive.jsx
var Responsive = __webpack_require__("Gqxm");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/client/views/booking/BookingEngine.utils.js
var BookingEngine_utils = __webpack_require__("47Eh");

// EXTERNAL MODULE: ./src/client/components/widgets/loading/async-loader/AsyncLoader.jsx + 1 modules
var AsyncLoader = __webpack_require__("4A3Y");

// EXTERNAL MODULE: ./src/client/components/widgets/booking-breadcrumb/BookingBreadcrumb.jsx + 16 modules
var BookingBreadcrumb = __webpack_require__("oMl1");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// EXTERNAL MODULE: ./src/client/views/booking/BookingEngineContext.js
var BookingEngineContext = __webpack_require__("EEyx");

// EXTERNAL MODULE: ./src/client/views/booking/BookingEngineTrackingContext.js
var BookingEngineTrackingContext = __webpack_require__("v+bK");

// EXTERNAL MODULE: ./src/client/views/quick-search/QuickSearchUnavailability.jsx
var QuickSearchUnavailability = __webpack_require__("jEE5");

// EXTERNAL MODULE: ../domains-service/dist/index.js
var domains_service_dist = __webpack_require__("g/E1");
var domains_service_dist_default = /*#__PURE__*/__webpack_require__.n(domains_service_dist);

// EXTERNAL MODULE: ./src/i18n.js
var src_i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/frameworks/modal/Modal.jsx + 1 modules
var Modal = __webpack_require__("EvYw");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// EXTERNAL MODULE: ./src/client/components/utils/identifiers/constants.js
var identifiers_constants = __webpack_require__("YZTm");

// EXTERNAL MODULE: ./src/utils/uri/constants.js
var uri_constants = __webpack_require__("Sj1w");

// CONCATENATED MODULE: ./src/client/views/booking/BlockMismatchProposalCountry.jsx





var BlockMismatchProposalCountry_jsx = react_default.a.createElement;













var BlockMismatchProposalCountry_BlockMismatchProposalCountry = function BlockMismatchProposalCountry(_ref) {
  var _URI$addQuery;

  var selectedProposal = _ref.selectedProposal,
      resort = _ref.resort;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  if (!selectedProposal.originalLocale || selectedProposal.originalLocale.split('-')[1] === appContext.country) {
    return null;
  }

  return BlockMismatchProposalCountry_jsx(Modal["a" /* Modal */], {
    ariaLabelledby: identifiers_constants["s" /* ID_MODAL_HEADER__BE__MISMATCH_COUNTRY */],
    ariaLabel: Object(src_i18n["h" /* t */])('booking.participants.mismatchLocalePLE.title'),
    closeLabel: Object(src_i18n["h" /* t */])('common.close'),
    onClose: function onClose() {
      var redirectUrl = new URI_default.a(window.location.href).setQuery({
        locale: selectedProposal.originalLocale
      });

      if (Object(contextUtils["f" /* isStrictlyProductionEnv */])() || Object(contextUtils["g" /* isStrictlyStagingEnv */])()) {
        redirectUrl = redirectUrl.tld(domains_service_dist_default.a.getTldFromLocale(selectedProposal.originalLocale));
      }

      if (appContext.isUserLogged || appContext.isUserQuickLogged) {
        redirectUrl = new URI_default.a(window.location.href).resource(routeBuilder["a" /* buildUrl */]('signout', {}, {
          redirectUri: redirectUrl
        }));
      } // heroku or local env


      window.location.href = redirectUrl.toString();
    }
  }, BlockMismatchProposalCountry_jsx("div", {
    className: "p-20 text-center"
  }, BlockMismatchProposalCountry_jsx(Title["a" /* Title */], {
    className: "my-15 justify-center",
    hLevel: 1,
    id: identifiers_constants["s" /* ID_MODAL_HEADER__BE__MISMATCH_COUNTRY */],
    theme: "title-brand-n2"
  }, Object(src_i18n["h" /* t */])('booking.participants.mismatchLocalePLE.title')), BlockMismatchProposalCountry_jsx("p", {
    className: "mb-20"
  }, Object(src_i18n["h" /* t */])('booking.participants.mismatchLocalePLE.label')), BlockMismatchProposalCountry_jsx(Button["a" /* Button */], {
    url: new URI_default.a(resort.href).addQuery((_URI$addQuery = {
      locale: appContext.locale
    }, Object(defineProperty["a" /* default */])(_URI$addQuery, uri_constants["l" /* QUERY_NUMBER_OF_ADULTS */], selectedProposal.attendees.adults.length), Object(defineProperty["a" /* default */])(_URI$addQuery, uri_constants["h" /* QUERY_DURATION */], selectedProposal.duration), Object(defineProperty["a" /* default */])(_URI$addQuery, uri_constants["g" /* QUERY_DEPARTURE_DATE */], selectedProposal.arrivalDate), _URI$addQuery)).removeQuery(dist["appQueryParameters"].booking.selectedProposalId, dist["appQueryParameters"].booking.proposalIds).toString()
  }, Object(src_i18n["h" /* t */])('common.continue'))));
};
// EXTERNAL MODULE: ./src/client/context/ABTestContext.js
var ABTestContext = __webpack_require__("hfZn");

// EXTERNAL MODULE: ./src/client/components/widgets/booking-footer/BookingFooter.jsx + 2 modules
var BookingFooter = __webpack_require__("dATv");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/utils/booking-engine-pages/BookingPagesUtils.js
var BookingPagesUtils = __webpack_require__("rcxx");

// CONCATENATED MODULE: ./src/utils/product-comparison/constants.js

var BOOKING_STEPS = {
  PARTICIPANTS: {
    BE_LEGACY: 'payment/participants',
    BE_RESPONSIVE: BookingPagesUtils["c" /* PAGE_BE_PARTICIPANTS */],
    CXO: 'book'
  },
  ACCOMMODATIONS: {
    BE_LEGACY: 'accommodations',
    BE_RESPONSIVE: BookingPagesUtils["a" /* PAGE_BE_ACCOMMODATION */],
    CXO: 'configure'
  },
  ACTIVITIES: {
    BE_LEGACY: 'activities',
    BE_RESPONSIVE: BookingPagesUtils["b" /* PAGE_BE_ACTIVITIES */],
    CXO: 'configure'
  },
  TRANSPORT: {
    BE_LEGACY: 'transport',
    BE_RESPONSIVE: BookingPagesUtils["f" /* PAGE_BE_TRANSPORT */],
    CXO: 'configure'
  }
};

// EXTERNAL MODULE: ./src/client/tracking/track-page/TrackPage.jsx
var TrackPage = __webpack_require__("tZiC");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTrackEvent.js
var useTrackEvent = __webpack_require__("DqI1");

// EXTERNAL MODULE: ./src/client/components/widgets/trip-date-picker/TripDatePicker.utils.js
var TripDatePicker_utils = __webpack_require__("RqHf");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLink.jsx
var DynamicLink = __webpack_require__("i5Mr");

// CONCATENATED MODULE: ./src/client/views/booking/save-criteria/SaveCriteriaConfirmation.jsx

var SaveCriteriaConfirmation_jsx = react_default.a.createElement;








var SaveCriteriaConfirmation_SaveCriteriaConfirmation = function SaveCriteriaConfirmation(_ref) {
  var i18n = _ref.i18n,
      closeModal = _ref.closeModal,
      newAccount = _ref.newAccount,
      persistenceExtended = _ref.persistenceExtended;

  var _useAppContext = Object(ReactAppContext["c" /* useAppContext */])(),
      isCmta = _useAppContext.isCmta;

  var _get2 = get_default()(i18n, 'booking.saveMyCriteria', {}),
      dataProtectionPolicyUrl = _get2.dataProtectionPolicyUrl,
      dataProtectionPolicyLabel = _get2.dataProtectionPolicyLabel;

  var getModalTitle = function getModalTitle() {
    if (isCmta) {
      return get_default()(i18n, persistenceExtended ? 'booking.saveMyProposal.seller.saveConfirmation' : 'booking.saveMyProposal.seller.unsaveConfirmation');
    }

    return newAccount ? get_default()(i18n, 'booking.saveMyCriteria.saveConfirmationNewAccount') : get_default()(i18n, 'booking.saveMyCriteria.saveConfirmation');
  };

  var legalInfos = isCmta ? get_default()(i18n, 'booking.saveMyProposal.seller.info') : get_default()(i18n, 'booking.saveMyCriteria.legalInfo');
  return SaveCriteriaConfirmation_jsx(Modal["a" /* Modal */], {
    ariaLabel: getModalTitle(),
    ariaLabelledby: identifiers_constants["v" /* ID_MODAL_HEADER__BE__SAVE_CRITERIA_CONFIRMATION */],
    closeLabel: get_default()(i18n, 'common.close'),
    onClose: closeModal,
    size: "small"
  }, SaveCriteriaConfirmation_jsx("div", {
    className: "overflow-hidden bg-white px-50 py-20 text-center",
    "data-testid": "SaveCriteriaLogin--confirmation"
  }, SaveCriteriaConfirmation_jsx("div", null, SaveCriteriaConfirmation_jsx(Icon["a" /* Icon */], {
    className: "text-success",
    name: icons["a" /* ICONS */].CHECK,
    width: "3rem"
  })), SaveCriteriaConfirmation_jsx("div", {
    className: "w-full text-center text-22 font-bold text-black",
    "data-testid": "SaveCriteria-confirmation",
    id: identifiers_constants["v" /* ID_MODAL_HEADER__BE__SAVE_CRITERIA_CONFIRMATION */]
  }, getModalTitle()), SaveCriteriaConfirmation_jsx("div", null, SaveCriteriaConfirmation_jsx(Button["a" /* Button */], {
    className: "mb-15 mt-50 min-w-[250px]",
    onClick: closeModal
  }, get_default()(i18n, 'booking.saveMyCriteria.continue'))), !isCmta && SaveCriteriaConfirmation_jsx(DynamicLink["a" /* default */], {
    className: "m-auto flex items-center justify-center text-16 font-bold text-black hocus:text-black-active",
    "data-selector": "SaveCriteria-link",
    target: "_blank",
    url: "/account"
  }, get_default()(i18n, 'booking.saveMyCriteria.accessAccount'), SaveCriteriaConfirmation_jsx(Icon["a" /* Icon */], {
    hasRtl: true,
    name: icons["a" /* ICONS */].ARROW_RIGHT,
    width: "1rem"
  })), SaveCriteriaConfirmation_jsx("div", {
    className: "mt-30 flex flex-col items-center",
    "data-testid": "SaveCriteria-popinLegalInfo"
  }, isCmta && persistenceExtended && SaveCriteriaConfirmation_jsx("p", {
    className: "w-full text-center"
  }, legalInfos), !isCmta && SaveCriteriaConfirmation_jsx(DynamicLink["a" /* default */], {
    className: "text-inherit underline",
    url: dataProtectionPolicyUrl
  }, dataProtectionPolicyLabel))));
};
// EXTERNAL MODULE: ./src/utils/ple-utils/index.js + 1 modules
var ple_utils = __webpack_require__("6jSF");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/widgets/member-nav/member-sign-in/useExtendedConnect.js
var useExtendedConnect = __webpack_require__("4tGX");

// EXTERNAL MODULE: ./src/client/views/booking/constants.js
var booking_constants = __webpack_require__("taV1");

// CONCATENATED MODULE: ./src/client/views/booking/save-criteria/SaveCriteriaLogin.jsx


var SaveCriteriaLogin_jsx = react_default.a.createElement;

















function SaveCriteriaLogin(_ref) {
  var closeModal = _ref.closeModal,
      clickOrigin = _ref.clickOrigin;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  var _useExtendedConnect = Object(useExtendedConnect["a" /* useExtendedConnect */])(),
      isFacebookConnectAvailable = _useExtendedConnect.isFacebookConnectAvailable;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var trackClick = function trackClick(detailClick) {
    trackClickEvent(clickOrigin === 'bottomBar' ? tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_BOTTOM_BAR : tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_HEADER, {
      detail_click: detailClick
    });
  };

  var currentUri = dist["windowWrapper"].getLocation();
  var redirectUri = new URI_default.a(currentUri).addSearch(booking_constants["f" /* BE_SAVE_CRITERIA_QUERY */], 'true').toString();
  var redirectUriSignup = new URI_default.a(currentUri).addSearch(booking_constants["f" /* BE_SAVE_CRITERIA_QUERY */], 'true').addSearch(booking_constants["e" /* BE_SAVE_CRITERIA_NEW_ACCOUNT_QUERY */], 'true').toString();
  return SaveCriteriaLogin_jsx(Modal["a" /* Modal */], {
    ariaLabel: Object(src_i18n["h" /* t */])('account.authentication.newToClubMed'),
    ariaLabelledby: identifiers_constants["w" /* ID_MODAL_HEADER__BE__SAVE_CRITERIA_LOGIN */],
    closeLabel: Object(src_i18n["h" /* t */])('common.close'),
    onClose: closeModal,
    size: "small"
  }, SaveCriteriaLogin_jsx("p", {
    className: "flex items-center gap-10 border-b-1 border-lightGrey px-10 py-15"
  }, SaveCriteriaLogin_jsx(Icon["a" /* Icon */], {
    className: "shrink-0 text-sienna",
    name: icons["a" /* ICONS */].STAR_HOLLOW,
    width: "1.625rem"
  }), Object(src_i18n["h" /* t */])('booking.saveMyCriteria.createAccount')), SaveCriteriaLogin_jsx("div", {
    className: "flex flex-col items-center bg-white px-10 py-40",
    "data-testid": "SaveCriteriaLogin-signin"
  }, SaveCriteriaLogin_jsx(Button["a" /* Button */], {
    className: "w-full max-w-220",
    "data-selector": "saveCriteriaLogin-member-signIn",
    isExternalLink: true,
    onClick: function onClick() {
      return trackClick('travel_plans_login');
    },
    target: "_self",
    url: ple_utils["f" /* buildSigninUrl */]({
      redirectUri: redirectUri,
      locale: appContext.locale
    })
  }, Object(src_i18n["h" /* t */])('account.authentication.signin')), isFacebookConnectAvailable && SaveCriteriaLogin_jsx(Button["a" /* Button */], {
    className: "mt-10 w-full max-w-220 border-[#4267b2] bg-[#4267b2]",
    color: colors["a" /* COLORS */].WHITE,
    "data-selector": "saveCriteriaLogin-member-signIn-facebook",
    iconLeft: {
      name: icons["a" /* ICONS */].FACEBOOK,
      width: '1.5rem'
    },
    isExternalLink: true,
    target: "_self",
    url: ple_utils["d" /* buildFacebookConnectUrl */]({
      redirectUri: redirectUri,
      locale: appContext.locale
    })
  }, Object(src_i18n["h" /* t */])('account.authentication.connectionIncentive.facebookConnectButtonLabel'))), SaveCriteriaLogin_jsx("div", {
    className: "flex flex-col items-center gap-20 border-t-1 border-lightGrey bg-white px-10 py-25"
  }, SaveCriteriaLogin_jsx(Title["a" /* Title */], {
    hLevel: 2,
    id: identifiers_constants["w" /* ID_MODAL_HEADER__BE__SAVE_CRITERIA_LOGIN */],
    theme: "title-brand-n3"
  }, Object(src_i18n["h" /* t */])('account.authentication.newToClubMed')), SaveCriteriaLogin_jsx(Button["a" /* Button */], {
    "data-selector": "saveCriteriaLogin-member-signUp",
    isExternalLink: true,
    onClick: function onClick() {
      return trackClick('travel_plans_sign_up');
    },
    target: "_self",
    url: ple_utils["h" /* buildSignupUrl */]({
      redirectUri: redirectUriSignup,
      locale: appContext.locale
    })
  }, Object(src_i18n["h" /* t */])('account.authentication.createAccountLinkLabel'))));
}
// CONCATENATED MODULE: ./src/client/views/booking/refresh-proposal-modal/RefreshProposalModal.jsx














var RefreshProposalModal_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













var RefreshProposalModal_useRefreshProposal = function useRefreshProposal(refreshedProposal, selectedProposal) {
  var proposal = refreshedProposal.proposal,
      errors = refreshedProposal.errors;

  var _useState = Object(react["useState"])(errors && errors.length && errors.some(function (error) {
    return ['noAccommodation', 'noTransport', 'noService'].includes(error.errorKey);
  })),
      hasError = _useState[0];

  var _useState2 = Object(react["useState"])(proposal && selectedProposal && proposal.id === selectedProposal.id && proposal.price.total.value !== selectedProposal.price.total.value),
      hasDifferentPrice = _useState2[0];

  return {
    hasError: hasError,
    hasDifferentPrice: hasDifferentPrice
  };
};

function RefreshProposalModal(_ref) {
  var refreshedProposal = _ref.refreshedProposal,
      resort = _ref.resort,
      selectedProposal = _ref.selectedProposal;
  var router = Object(next_router["useRouter"])();

  var _useState3 = Object(react["useState"])(false),
      isOpen = _useState3[0],
      setIsOpen = _useState3[1];

  var imageUrl = resort.image,
      destination = resort.destination,
      name = resort.name;

  var _useRefreshProposal = RefreshProposalModal_useRefreshProposal(refreshedProposal, selectedProposal),
      hasError = _useRefreshProposal.hasError,
      hasDifferentPrice = _useRefreshProposal.hasDifferentPrice;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var errorMessage = hasError ? Object(src_i18n["h" /* t */])('booking.saveMyCriteria.refreshPopIn.noAvailability') : Object(src_i18n["h" /* t */])('booking.saveMyCriteria.refreshPopIn.updatedProposal');

  var redirectToResort = function redirectToResort() {
    trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_NEW_PROPOSALS, {
      detail_click: 'error_%400'
    });
    var resortUri = new URI_default.a(resort === null || resort === void 0 ? void 0 : resort.href).query(_objectSpread(_objectSpread({}, omit_default()(router.query, ['bookingStep', 'proposalIds', 'selectedProposalId', 'date', 'duration'])), {}, {
      date: moment_default()(selectedProposal.arrivalDate).format('YYYY-MM-DD'),
      duration: selectedProposal.duration
    })).toString();
    router.push(dist["url"].normalizeUrl(resortUri));
  };

  var refreshPage = function refreshPage() {
    trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_NEW_PROPOSALS, {
      detail_click: 'new_price'
    });
    window.location.reload();
  };

  var buttonText = hasError ? Object(src_i18n["h" /* t */])('common.chooseNewCriteria') : Object(src_i18n["h" /* t */])('common.continue');
  var buttonAction = hasError ? redirectToResort : refreshPage;
  Object(react["useEffect"])(function () {
    if (hasError || hasDifferentPrice) {
      setIsOpen(true);
    }
  }, [hasError, hasDifferentPrice]);

  if (!hasError && !hasDifferentPrice) {
    return null;
  }

  return isOpen ? RefreshProposalModal_jsx(Modal["a" /* Modal */], {
    ariaLabel: Object(src_i18n["h" /* t */])('booking.saveMyCriteria.refreshPopIn.title'),
    ariaLabelledby: identifiers_constants["r" /* ID_MODAL_HEADER__BE_REFRESH_PROPOSAL */],
    closeLabel: Object(src_i18n["h" /* t */])('common.close'),
    onClose: buttonAction,
    size: "small"
  }, RefreshProposalModal_jsx("div", {
    className: "overflow-hidden",
    "data-testid": "RefreshProposalModal"
  }, RefreshProposalModal_jsx("div", {
    className: "relative h-228 overflow-hidden"
  }, !!imageUrl && RefreshProposalModal_jsx("img", {
    src: imageUrl,
    className: "w-full",
    alt: ""
  }), RefreshProposalModal_jsx("div", {
    className: "absolute inset-0 flex items-end justify-center bg-[linear-gradient(180deg,rgba(36,36,36,0)_50%,rgba(36,36,36,0.8)_100%)] text-center text-white"
  }, RefreshProposalModal_jsx("div", {
    className: "mb-20"
  }, RefreshProposalModal_jsx("p", {
    className: "text-20 font-semibold"
  }, name), RefreshProposalModal_jsx("p", {
    className: "text-16 font-normal"
  }, destination.country)))), RefreshProposalModal_jsx("div", {
    className: "m-25 text-center"
  }, RefreshProposalModal_jsx("div", {
    className: "mb-10 font-brand text-24 text-black"
  }, Object(src_i18n["h" /* t */])('booking.saveMyCriteria.refreshPopIn.title')), RefreshProposalModal_jsx("div", {
    className: "p-20 text-14 text-black"
  }, errorMessage), RefreshProposalModal_jsx(Button["a" /* Button */], {
    className: "mb-15 mt-30 min-w-200",
    "data-testid": "pauseOptionModalButton",
    onClick: buttonAction
  }, buttonText)))) : null;
}
// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__("rOcY");
var config_default = /*#__PURE__*/__webpack_require__.n(config);

// EXTERNAL MODULE: ./src/client/views/booking/BookingEngine.tracking.js
var BookingEngine_tracking = __webpack_require__("Hv+8");

// CONCATENATED MODULE: ./src/client/views/booking/share-context/ShareContext.jsx












var ShareContext_jsx = react["createElement"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }












var ShareContext_ShareContext = /*#__PURE__*/function (_React$Component) {
  Object(inherits["a" /* default */])(ShareContext, _React$Component);

  var _super = _createSuper(ShareContext);

  function ShareContext() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, ShareContext);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "textInput", /*#__PURE__*/react["createRef"]());

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onCopyLinkClick", function () {
      var _this$props = _this.props,
          i18n = _this$props.i18n,
          displayToastOnContextShare = _this$props.displayToastOnContextShare,
          actionGA = _this$props.actionGA; // $FlowFixMe current should never be undefined

      _this.textInput.current.select();

      document.execCommand('copy');
      Object(BookingEngine_tracking["d" /* trackShareContextDesktopPopin */])(actionGA, _this.context);
      displayToastOnContextShare(get_default()(i18n, 'booking.common.share.linkCopied'));
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "handleOnNavigatorShareClick", function () {
      if (navigator.share) {
        Object(BookingEngine_tracking["d" /* trackShareContextDesktopPopin */])(_this.props.actionGA, _this.context); // $FlowFixMe

        navigator.share({
          url: dist["windowWrapper"].getLocation()
        }).then(function () {
          _this.props.onToggleModal();
        });
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "handleMediaLinkClick", function (event) {
      var msg = dist["windowWrapper"].getLocation();
      var media = event.currentTarget.dataset.media;
      Object(BookingEngine_tracking["e" /* trackShareContextMobilePopin */])(_this.props.actionGA, media, _this.context);

      if (media === 'messenger') {
        return window.open("fb-messenger://share/?link=".concat(encodeURIComponent(msg), "&app_id=").concat(config_default.a.get('facebookMessenger.appId')), '_self');
      }

      if (media === 'whatsapp') {
        return window.open("whatsapp://send?text=".concat(encodeURIComponent(msg)), '_self');
      }

      if (media === 'sms') {
        return window.open("sms:?&body=".concat(encodeURIComponent(msg)), '_self');
      }
    });

    return _this;
  }

  Object(createClass["a" /* default */])(ShareContext, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          onToggleModal = _this$props2.onToggleModal,
          i18n = _this$props2.i18n;
      return ShareContext_jsx(Modal["a" /* Modal */], {
        ariaLabel: get_default()(i18n, 'booking.common.share.title'),
        ariaLabelledby: identifiers_constants["x" /* ID_MODAL_HEADER__BE__SHARE_CONTEXT */],
        closeLabel: get_default()(i18n, 'common.close'),
        onClose: onToggleModal,
        size: "small"
      }, ShareContext_jsx("h1", {
        className: "flex items-center gap-10 border-b-1 border-lightGrey p-20 text-20",
        id: identifiers_constants["x" /* ID_MODAL_HEADER__BE__SHARE_CONTEXT */]
      }, ShareContext_jsx(Icon["a" /* Icon */], {
        className: "text-sienna",
        name: icons["a" /* ICONS */].SHARE,
        width: "2rem"
      }), get_default()(i18n, 'booking.common.share.title')), ShareContext_jsx("div", {
        className: "max-w-full overflow-hidden bg-white p-20"
      }, ShareContext_jsx("input", {
        // ⚠️ this input should not be hidden otherwise the copy func will not work
        className: "absolute -z-1 h-0",
        ref: this.textInput,
        value: dist["windowWrapper"].getLocation(),
        readOnly: true,
        "aria-hidden": "true"
      }), this.props.responsive.isTablet ? ShareContext_jsx(react["Fragment"], null, ShareContext_jsx("p", {
        className: "text-16"
      }, get_default()(i18n, 'booking.common.share.info')), ShareContext_jsx("p", {
        className: "mt-5 text-12"
      }, get_default()(i18n, 'booking.common.share.copyPaste')), ShareContext_jsx("div", {
        className: "mt-10 flex items-center",
        "data-testid": "ShareContext-shareLink"
      }, ShareContext_jsx("button", {
        className: "w-full max-w-full truncate text-14 underline",
        "data-testid": "ShareContext-desktopUrl",
        onClick: this.onCopyLinkClick,
        type: "button"
      }, dist["windowWrapper"].getLocation()), ShareContext_jsx("button", {
        onClick: this.onCopyLinkClick,
        type: "button"
      }, ShareContext_jsx(Icon["a" /* Icon */], {
        className: "rounded-full bg-darkGrey p-10 text-white",
        name: icons["a" /* ICONS */].LINK,
        width: "3rem"
      })))) : ShareContext_jsx("div", {
        className: "flex flex-col items-center",
        "data-testid": "ShareContext-mobileContent"
      }, ShareContext_jsx("p", {
        className: "my-20 px-20 text-center text-14"
      }, get_default()(i18n, 'booking.common.share.info')), navigator.share ? ShareContext_jsx(Button["a" /* Button */], {
        className: "mb-10",
        "data-testid": "ShareContext-shareButton",
        onClick: this.handleOnNavigatorShareClick
      }, get_default()(i18n, 'booking.common.share.label')) : ShareContext_jsx("div", {
        className: "flex w-full justify-center gap-10 border-t-1 border-lightGrey py-25"
      }, ShareContext_jsx("button", {
        type: "button",
        "data-media": "messenger",
        onClick: this.handleMediaLinkClick,
        "data-testid": "ShareContext-messenger"
      }, ShareContext_jsx(Icon["a" /* Icon */], {
        className: "rounded-full bg-[#1984ff] p-10 text-white",
        name: icons["a" /* ICONS */].MESSENGER,
        width: "3rem"
      })), ShareContext_jsx("button", {
        type: "button",
        "data-media": "whatsapp",
        onClick: this.handleMediaLinkClick,
        "data-testid": "ShareContext-whatsapp"
      }, ShareContext_jsx(Icon["a" /* Icon */], {
        className: "rounded-full bg-[#52cc5d] p-10 text-white",
        name: icons["a" /* ICONS */].WHATSAPP,
        width: "3rem"
      })), ShareContext_jsx("button", {
        type: "button",
        "data-media": "sms",
        onClick: this.handleMediaLinkClick,
        "data-testid": "ShareContext-12s"
      }, ShareContext_jsx(Icon["a" /* Icon */], {
        className: "rounded-full bg-[#f69a3f] p-10 text-white",
        name: icons["a" /* ICONS */].SMS,
        width: "3rem"
      })), ShareContext_jsx("button", {
        type: "button",
        onClick: this.onCopyLinkClick
      }, ShareContext_jsx(Icon["a" /* Icon */], {
        className: "rounded-full bg-darkGrey p-10 text-white",
        name: icons["a" /* ICONS */].LINK,
        width: "3rem"
      }))))));
    }
  }]);

  return ShareContext;
}(react["Component"]);

Object(defineProperty["a" /* default */])(ShareContext_ShareContext, "contextType", ReactAppContext["a" /* B2CAppContext */]);

/* harmony default export */ var share_context_ShareContext = (Object(Responsive["a" /* default */])(ShareContext_ShareContext));
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("6U7i");

// EXTERNAL MODULE: ./src/client/components/frameworks/countdown/Countdown.jsx + 1 modules
var Countdown = __webpack_require__("mmhe");

// EXTERNAL MODULE: ./src/client/components/widgets/info-banner/infoBanner.query.js
var infoBanner_query = __webpack_require__("M/0w");

// EXTERNAL MODULE: ./src/client/store/booking/proposals/constants.js
var proposals_constants = __webpack_require__("UIAR");

// EXTERNAL MODULE: ./src/utils/locale/localeUtils.js
var localeUtils = __webpack_require__("1tzK");

// EXTERNAL MODULE: ./src/client/tracking/tracking-storage-api/index.js
var tracking_storage_api = __webpack_require__("K0Lv");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.repeat.js
var es_string_repeat = __webpack_require__("FwaZ");

// EXTERNAL MODULE: ./src/client/components/widgets/info-banner/infoBanner.utils.js + 1 modules
var infoBanner_utils = __webpack_require__("UpHs");

// EXTERNAL MODULE: ./src/client/store/booking/additional-accommodations/additionalAccommodations.action.js + 1 modules
var additionalAccommodations_action = __webpack_require__("06Jt");

// EXTERNAL MODULE: ./src/client/components/utils/booking/bookingUtils.js + 1 modules
var bookingUtils = __webpack_require__("aWOT");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.link.js
var es_string_link = __webpack_require__("hBvt");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/noop.js
var noop = __webpack_require__("nnm9");
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);

// CONCATENATED MODULE: ./src/client/components/widgets/overlaid-action-provider/OverlaidActionProvider.jsx



var OverlaidActionProvider_jsx = react_default.a.createElement;


var OverlaidActionProvider_OverlaidActionProvider = function OverlaidActionProvider(_ref) {
  var _ref$button = _ref.button,
      button = _ref$button === void 0 ? {} : _ref$button,
      children = _ref.children,
      _ref$dataSelector = _ref.dataSelector,
      dataSelector = _ref$dataSelector === void 0 ? 'OverlaidActionProvider' : _ref$dataSelector,
      label = _ref.label;
  var shouldRender = button.onClick && button.onClick !== noop_default.a || button.link;

  if (!shouldRender) {
    return null;
  }

  return OverlaidActionProvider_jsx(react["Fragment"], null, OverlaidActionProvider_jsx("div", {
    "data-selector": "".concat(dataSelector, "--oapOuterContent")
  }, children), OverlaidActionProvider_jsx("div", {
    className: "mt-20 flex flex-col items-center"
  }, !!label && OverlaidActionProvider_jsx("div", {
    className: "font-brand text-20",
    "data-selector": "".concat(dataSelector, "--oapLabel")
  }, label), OverlaidActionProvider_jsx(Button["a" /* Button */], Object(esm_extends["a" /* default */])({
    className: "m-5",
    "data-selector": "".concat(dataSelector, "-button"),
    size: "medium"
  }, button), button.label)));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/notification/SimpleNotification.jsx
var SimpleNotification = __webpack_require__("qOTJ");

// EXTERNAL MODULE: ./src/client/components/widgets/booking-navbar/useBookingNavbar.js
var useBookingNavbar = __webpack_require__("IOWS");

// CONCATENATED MODULE: ./src/client/components/widgets/accommodations/attendees-distribution/AttendeesDistributionUtils.js











function AttendeesDistributionUtils_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function AttendeesDistributionUtils_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? AttendeesDistributionUtils_ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AttendeesDistributionUtils_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}


var ATTENDEE_CATEGORIES = {
  BABY: 'BABY',
  CHILD: 'CHILD',
  ADULT: 'ADULT'
};
var AttendeesDistributionUtils_getAttendeeCategory = function getAttendeeCategory(attendee, arrivalDate) {
  if (attendee.birthdate && moment_default()(arrivalDate).diff(moment_default()(attendee.birthdate), 'months') < 24) {
    return ATTENDEE_CATEGORIES.BABY;
  }

  if (attendee.birthdate && moment_default()(arrivalDate).diff(moment_default()(attendee.birthdate), 'months') >= 24 && moment_default()(arrivalDate).diff(moment_default()(attendee.birthdate), 'years') < 18) {
    return ATTENDEE_CATEGORIES.CHILD;
  }

  return ATTENDEE_CATEGORIES.ADULT;
};
var getAttendeesByDistributionCategory = function getAttendeesByDistributionCategory(attendees) {
  var sortAttendeesByIndex = function sortAttendeesByIndex(attendee1, attendee2) {
    return attendee1.index - attendee2.index;
  };

  return {
    adults: attendees.filter(function (_ref) {
      var type = _ref.type;
      return type.toUpperCase() === ATTENDEE_CATEGORIES.ADULT;
    }).sort(sortAttendeesByIndex),
    children: attendees.filter(function (_ref2) {
      var type = _ref2.type;
      return type.toUpperCase() === ATTENDEE_CATEGORIES.CHILD;
    }).sort(sortAttendeesByIndex),
    babies: attendees.filter(function (_ref3) {
      var type = _ref3.type;
      return type.toUpperCase() === ATTENDEE_CATEGORIES.BABY;
    }).sort(sortAttendeesByIndex)
  };
};
var addDistributionDataToAttendees = function addDistributionDataToAttendees(attendees, arrivalDate) {
  var distributionIndex = {
    ADULT: 0,
    CHILD: 0,
    BABY: 0
  };
  return attendees.map(function (attendee) {
    var type = AttendeesDistributionUtils_getAttendeeCategory(attendee, arrivalDate); // $FlowFixMe

    return AttendeesDistributionUtils_objectSpread(AttendeesDistributionUtils_objectSpread({}, attendee), {}, {
      type: type,
      index: distributionIndex[type]++
    });
  });
};
// EXTERNAL MODULE: ./src/client/store/booking/attendees/attendees.selector.js
var attendees_selector = __webpack_require__("eZ08");

// EXTERNAL MODULE: ./src/client/store/trip-information/storeHelper.js
var storeHelper = __webpack_require__("Jsmy");

// EXTERNAL MODULE: ./src/client/components/widgets/accommodation/Accommodation.jsx + 15 modules
var Accommodation = __webpack_require__("OWQs");

// EXTERNAL MODULE: ./src/client/components/widgets/accommodations/BookingAccommodationsUtils.js
var BookingAccommodationsUtils = __webpack_require__("cb6o");

// CONCATENATED MODULE: ./src/client/components/widgets/accommodations/BookingAccommodations.jsx















var BookingAccommodations_jsx = react_default.a.createElement;

function BookingAccommodations_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function BookingAccommodations_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { BookingAccommodations_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { BookingAccommodations_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }











var BookingAccommodations_BookingAccommodations = function BookingAccommodations(_ref) {
  var _ref$accommodations = _ref.accommodations,
      accommodations = _ref$accommodations === void 0 ? [] : _ref$accommodations,
      accommodationsCount = _ref.accommodationsCount,
      _ref$isInMoreRoomLaye = _ref.isInMoreRoomLayer,
      isInMoreRoomLayer = _ref$isInMoreRoomLaye === void 0 ? false : _ref$isInMoreRoomLaye,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      proposal = _ref.proposal,
      remainingStock = _ref.remainingStock,
      product = _ref.product,
      selectedRate = _ref.selectedRate,
      setSelectedRate = _ref.setSelectedRate,
      streetViews = _ref.streetViews,
      switchOffers = _ref.switchOffers,
      theme = _ref.theme,
      accommodationsComparator = _ref.accommodationsComparator;
  var tripInformationAttendees = Object(es["e" /* useSelector */])(storeHelper["d" /* tripInformationSelector */]);
  var connectedUserInfo = Object(es["e" /* useSelector */])(booking_selector["h" /* getConnectedUserInfoSelector */]);

  var _useState = Object(react["useState"])({
    adults: [],
    children: []
  }),
      attendees = _useState[0],
      setAttendees = _useState[1];

  var router = Object(next_router["useRouter"])();
  var isComparator = router.pathname === '/comparator';
  var alternatives = Object(es["e" /* useSelector */])(booking_selector["m" /* getFilteredAccommodationsAlternativesByComfort */]);
  Object(react["useEffect"])(function () {
    var _addInfosToProposalAt = Object(attendees_selector["a" /* addInfosToProposalAttendees */])({
      proposal: proposal,
      tripInformationAttendees: tripInformationAttendees,
      connectedUserInfo: connectedUserInfo
    }),
        formattedAttendees = _addInfosToProposalAt.attendees;

    setAttendees(formattedAttendees);
  }, []);
  var attendeesWithInfos = [].concat(Object(toConsumableArray["a" /* default */])(attendees.adults), Object(toConsumableArray["a" /* default */])(attendees.children));

  var sortedAccommodations = Object(toConsumableArray["a" /* default */])(accommodations).sort(proposalUtils["b" /* compareAccommodationsByComfort */]);

  var arrangementAttendees = sortedAccommodations.reduce(function (attendeesList, accommodation) {
    if (accommodation.attendeesDistribution && accommodation.attendeesDistribution.attendees) {
      return [].concat(Object(toConsumableArray["a" /* default */])(attendeesList), Object(toConsumableArray["a" /* default */])(accommodation.attendeesDistribution.attendees));
    }

    return Object(toConsumableArray["a" /* default */])(attendeesList);
  }, []);
  /**
   * On accommodations view, when accommodations have arrangement, we would like to have index related
   * to accommodations order (first accommodation attendees with first indexes)
   */

  var sortedAttendeesWithInfos = !isInMoreRoomLayer && arrangementAttendees && arrangementAttendees.length ? arrangementAttendees.map(function (attendee) {
    var attendeeData = attendeesWithInfos.find(function (_ref2) {
      var id = _ref2.id;
      return attendee.id === id;
    }) || {}; // $FlowFixMe: flow cannot handle this spread...

    return BookingAccommodations_objectSpread(BookingAccommodations_objectSpread({}, attendee), attendeeData);
  }) : attendeesWithInfos;
  var attendeesWithDistributionData = addDistributionDataToAttendees(sortedAttendeesWithInfos, proposal.arrivalDate);
  return BookingAccommodations_jsx(Accommodation["a" /* Accommodation */], Object(esm_extends["a" /* default */])({}, Object(BookingAccommodationsUtils["b" /* getAccommodationProps */])({
    accommodations: accommodations,
    accommodationsCount: accommodationsCount,
    alternatives: alternatives,
    attendeesWithDistributionData: attendeesWithDistributionData,
    isComparator: isComparator,
    isInMoreRoomLayer: isInMoreRoomLayer,
    proposal: proposal,
    remainingStock: remainingStock,
    product: product,
    streetViews: streetViews
  }), {
    accommodationsComparator: accommodationsComparator,
    isInMoreRoomLayer: isInMoreRoomLayer,
    isLoading: isLoading,
    selectedRate: selectedRate,
    setSelectedRate: setSelectedRate,
    switchOffers: switchOffers,
    theme: theme
  }));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/tabs/Tabs.jsx + 1 modules
var Tabs = __webpack_require__("4/4b");

// EXTERNAL MODULE: ./src/client/components/widgets/exclusive-collection-badge/ExclusiveCollectionBadge.jsx
var ExclusiveCollectionBadge = __webpack_require__("7knX");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/uniq.js
var uniq = __webpack_require__("jLkM");
var uniq_default = /*#__PURE__*/__webpack_require__.n(uniq);

// EXTERNAL MODULE: ./src/utils/proposal/constants.js
var proposal_constants = __webpack_require__("tI+f");

// EXTERNAL MODULE: ./src/utils/accommodation/accommodation.constants.js
var accommodation_constants = __webpack_require__("lZ21");

// CONCATENATED MODULE: ./src/client/views/booking/accommodation/proposal-accommodation-title/ProposalAccommodationTitleUtils.js













var getDiscountValueFromProposal = function getDiscountValueFromProposal(proposal) {
  var _proposal$price$disco, _proposal$price$disco2;

  return (_proposal$price$disco = proposal.price.discounts.find(function (_ref) {
    var currentProposalCode = _ref.currentProposalCode;
    return !!(currentProposalCode === null || currentProposalCode === void 0 ? void 0 : currentProposalCode.value);
  })) === null || _proposal$price$disco === void 0 ? void 0 : (_proposal$price$disco2 = _proposal$price$disco.currentProposalCode) === null || _proposal$price$disco2 === void 0 ? void 0 : _proposal$price$disco2.value;
};

var ProposalAccommodationTitleUtils_getUniqDiscountProposals = function getUniqDiscountProposals(proposals) {
  return uniq_default()(proposals.map(function (proposal) {
    return getDiscountValueFromProposal(proposal);
  }).filter(Boolean));
};

function getAccommodationTitle(proposal, product) {
  var _accommodations$, _accommodations$2, _accommodations$3, _accommodations$4;

  var accommodations = Object(toConsumableArray["a" /* default */])(proposal.accommodations).sort(proposalUtils["b" /* compareAccommodationsByComfort */]).reverse();

  var category = (accommodations === null || accommodations === void 0 ? void 0 : (_accommodations$ = accommodations[0]) === null || _accommodations$ === void 0 ? void 0 : _accommodations$.category) || '';
  var comfort = (accommodations === null || accommodations === void 0 ? void 0 : (_accommodations$2 = accommodations[0]) === null || _accommodations$2 === void 0 ? void 0 : _accommodations$2.comfortType) || '';
  var label = (accommodations === null || accommodations === void 0 ? void 0 : (_accommodations$3 = accommodations[0]) === null || _accommodations$3 === void 0 ? void 0 : _accommodations$3.label) || '';
  var isVillettaRoom = product.id.toLowerCase() === proposal_constants["a" /* CEFALU_RESORT */].toLowerCase() && accommodation_constants["f" /* VILLETA_ROOM_REGEX */].test(accommodations === null || accommodations === void 0 ? void 0 : (_accommodations$4 = accommodations[0]) === null || _accommodations$4 === void 0 ? void 0 : _accommodations$4.id);
  return isVillettaRoom ? label || comfort || category : comfort || category;
}

function getExclusiveCollectionInAccommodations(proposal, product) {
  var indexOfExclusiveCollectionRoom = proposal === null || proposal === void 0 ? void 0 : proposal.accommodations.findIndex(function (accommodation) {
    return accommodation.exclusiveCollection;
  });
  return indexOfExclusiveCollectionRoom !== -1 && (product === null || product === void 0 ? void 0 : product.comfort) === 4;
}

var isSuperiorComfortAccommodation = function isSuperiorComfortAccommodation(accommodations) {
  var _accommodations$5, _accommodations$5$cat;

  return accommodations === null || accommodations === void 0 ? void 0 : (_accommodations$5 = accommodations[0]) === null || _accommodations$5 === void 0 ? void 0 : (_accommodations$5$cat = _accommodations$5.categories) === null || _accommodations$5$cat === void 0 ? void 0 : _accommodations$5$cat.every(function (_ref2) {
    var id = _ref2.id;
    return id === '000017' || id === '000022';
  });
};


// CONCATENATED MODULE: ./src/client/views/booking/accommodation/proposal-accommodation-title/ProposalAccommodationTitle.themes.js

var ProposalAccommodationTitle_themes_themes = function themes(isExclusiveCollection) {
  return {
    "default": {
      thRoot: 'flex flex-col w-full justify-center sm:flex-row sm:flex-wrap gap-x-10 py-10 sm:py-20 px-5 sm:px-20 sm:items-baseline text-14 sm:text-16',
      thTitle: Object(classnames_utils["a" /* classnames */])('font-bold font-brand leading-1 text-18', {
        'text-black': !isExclusiveCollection,
        'text-ultramarine': isExclusiveCollection
      }),
      thLabel: 'leading-1 font-bold font-sans text-sienna'
    },
    column: {
      thRoot: 'flex flex-col items-center py-10 px-5 text-12 w-full',
      thTitle: Object(classnames_utils["a" /* classnames */])('font-bold font-brand leading-1 text-18', {
        'text-black': !isExclusiveCollection,
        'text-ultramarine': isExclusiveCollection
      }),
      thLabel: 'leading-1 font-bold font-sans text-sienna'
    }
  };
};
// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/components/frameworks/tag/Tag.jsx + 1 modules
var Tag = __webpack_require__("N5WC");

// CONCATENATED MODULE: ./src/client/views/booking/accommodation/proposal-accommodation-title/PromotionTag.jsx



var PromotionTag_jsx = react_default.a.createElement;







var PromotionTag_PromotionTag = function PromotionTag(_ref) {
  var proposal = _ref.proposal,
      uniqDiscounts = _ref.uniqDiscounts;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isRTL = _useResponsive.isRTL;

  var isHappyFirstEnabled = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.promotionHappyFirst') || true;
  var discountValue = getDiscountValueFromProposal(proposal);
  var discountIndex = uniqDiscounts.indexOf(discountValue);
  var showDisclamer = Object(src_i18n["d" /* getKeyValue */])('booking.accommodation.promotion.showDisclamer');
  var disclamerStars = showDisclamer ? '*'.repeat(discountIndex + 1) : '';
  var proposalHasHappyFirstOffer = !!discountValue;
  var shouldShowHappyFirstTags = isHappyFirstEnabled && proposalHasHappyFirstOffer;

  if (!shouldShowHappyFirstTags) {
    return null;
  }

  var chargePercentage = Object(src_i18n["h" /* t */])('booking.banking.paymentMethod.chargePercentage', {
    charge_percentage: discountValue || 0
  });
  var promotionLabel = isRTL ? "".concat(disclamerStars, " ").concat(chargePercentage, " -") : "- ".concat(chargePercentage, " ").concat(disclamerStars);
  return PromotionTag_jsx("div", {
    className: "mt-8 flex justify-center sm:mt-0 sm:justify-end"
  }, PromotionTag_jsx(Tag["a" /* Tag */], {
    "data-testid": "promotion-tag",
    className: "border-sienna bg-sienna leading-normal text-white"
  }, promotionLabel));
};
// CONCATENATED MODULE: ./src/client/views/booking/accommodation/proposal-accommodation-title/ProposalAccommodationTitle.jsx
var ProposalAccommodationTitle_jsx = react_default.a.createElement;







var ProposalAccommodationTitle_ProposalAccommodationTitle = function ProposalAccommodationTitle(_ref) {
  var includedLabel = _ref.includedLabel,
      priceLabel = _ref.priceLabel,
      product = _ref.product,
      proposal = _ref.proposal,
      uniqDiscounts = _ref.uniqDiscounts,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var isExclusiveCollection = getExclusiveCollectionInAccommodations(proposal, product);
  var _themes$theme = ProposalAccommodationTitle_themes_themes(isExclusiveCollection)[theme],
      thLabel = _themes$theme.thLabel,
      thRoot = _themes$theme.thRoot,
      thTitle = _themes$theme.thTitle;
  var discountValue = getDiscountValueFromProposal(proposal);
  var proposalHasHappyFirstOffer = !!discountValue;
  var hasNoShownHappyFirst = !proposalHasHappyFirstOffer || !Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.promotionHappyFirst');
  return ProposalAccommodationTitle_jsx("span", {
    className: thRoot,
    "data-testid": "ProposalAccommodationTitle"
  }, ProposalAccommodationTitle_jsx("span", {
    className: thTitle
  }, getAccommodationTitle(proposal, product)), hasNoShownHappyFirst && ProposalAccommodationTitle_jsx("span", {
    className: thLabel,
    "data-testid": "price-accommodationsTabs"
  }, priceLabel, includedLabel), isExclusiveCollection && ProposalAccommodationTitle_jsx(ExclusiveCollectionBadge["a" /* ExclusiveCollectionBadge */], null), ProposalAccommodationTitle_jsx(PromotionTag_PromotionTag, {
    proposal: proposal,
    uniqDiscounts: uniqDiscounts
  }));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/flatten.js
var flatten = __webpack_require__("1xil");
var flatten_default = /*#__PURE__*/__webpack_require__.n(flatten);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/uniqBy.js
var uniqBy = __webpack_require__("yjkv");
var uniqBy_default = /*#__PURE__*/__webpack_require__.n(uniqBy);

// EXTERNAL MODULE: ./src/client/components/lines/product-accommodations-line/productAccommodations.utils.js + 3 modules
var productAccommodations_utils = __webpack_require__("5svr");

// CONCATENATED MODULE: ./src/client/views/booking/accommodation/AccommodationsComparator.jsx


















var AccommodationsComparator_jsx = react_default.a.createElement;

function AccommodationsComparator_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function AccommodationsComparator_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { AccommodationsComparator_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { AccommodationsComparator_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var RANKINGS = dist["constants"].RANKINGS;

var AccommodationsComparator_AccommodationsComparator = function AccommodationsComparator(_ref) {
  var activeIndexes = _ref.activeIndexes,
      formatedPrices = _ref.formatedPrices,
      product = _ref.product,
      proposals = _ref.proposals,
      resolvedProposals = _ref.resolvedProposals;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var displayRoomsComparator = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('displayRoomsComparator');

  if (!displayRoomsComparator) {
    return null;
  }

  var allAccommodations = uniqBy_default()(flatten_default()(proposals.map(function (_ref2) {
    var accommodations = _ref2.accommodations,
        price = _ref2.price;
    var pricedAccommodations = accommodations;
    return pricedAccommodations.map(function (acc) {
      return AccommodationsComparator_objectSpread(AccommodationsComparator_objectSpread({}, acc), {}, {
        price: price
      });
    });
  })), 'id');

  var proposalAccommodationCategory = allAccommodations.map(function (_ref3, index) {
    var categoryId = _ref3.categoryId;
    return {
      id: categoryId,
      ranking: Object.values(RANKINGS)[index]
    };
  }); // $FlowFixMe

  var props = {
    accommodationCategory: {
      rankedCategories: proposalAccommodationCategory
    },
    resort: product
  };

  var _allAccommodations$re = allAccommodations.reduce(function (acc, _ref4) {
    var categoryId = _ref4.categoryId,
        comfortId = _ref4.comfortId,
        exclusiveCollection = _ref4.exclusiveCollection;
    acc.proposalAccommodationById.push(categoryId);
    acc.proposalAccommodationByType.push(Object(productAccommodations_utils["d" /* withExclusiveCollectionTag */])({
      categoryId: comfortId,
      isExclusiveCollection: exclusiveCollection
    }));
    return acc;
  }, {
    proposalAccommodationById: [],
    proposalAccommodationByType: []
  }),
      proposalAccommodationById = _allAccommodations$re.proposalAccommodationById,
      proposalAccommodationByType = _allAccommodations$re.proposalAccommodationByType;

  var accommodationCategories = Object(productAccommodations_utils["c" /* groupAccommodationsByCategory */])(props).filter(function (category) {
    return category.categoryAccommodations.some(function (categoryAccommodation) {
      return proposalAccommodationById.includes(categoryAccommodation.accommodation.categoryId);
    }) && proposalAccommodationByType.includes(category.categoryId);
  }).sort(function (current, next) {
    var currentIndex = proposals.findIndex(function (_proposal) {
      var _current$categoryAcco, _current$categoryAcco2, _proposal$accommodati, _proposal$accommodati2;

      return ((_current$categoryAcco = current.categoryAccommodations) === null || _current$categoryAcco === void 0 ? void 0 : (_current$categoryAcco2 = _current$categoryAcco[0]) === null || _current$categoryAcco2 === void 0 ? void 0 : _current$categoryAcco2.accommodation.categoryId) === ((_proposal$accommodati = _proposal.accommodations) === null || _proposal$accommodati === void 0 ? void 0 : (_proposal$accommodati2 = _proposal$accommodati[0]) === null || _proposal$accommodati2 === void 0 ? void 0 : _proposal$accommodati2.categoryId);
    });
    var nextIndex = proposals.findIndex(function (_proposal) {
      var _next$categoryAccommo, _next$categoryAccommo2, _proposal$accommodati3, _proposal$accommodati4;

      return ((_next$categoryAccommo = next.categoryAccommodations) === null || _next$categoryAccommo === void 0 ? void 0 : (_next$categoryAccommo2 = _next$categoryAccommo[0]) === null || _next$categoryAccommo2 === void 0 ? void 0 : _next$categoryAccommo2.accommodation.categoryId) === ((_proposal$accommodati3 = _proposal.accommodations) === null || _proposal$accommodati3 === void 0 ? void 0 : (_proposal$accommodati4 = _proposal$accommodati3[0]) === null || _proposal$accommodati4 === void 0 ? void 0 : _proposal$accommodati4.categoryId);
    });
    return currentIndex - nextIndex;
  }).map(function (category) {
    var proposal = resolvedProposals[category.categoryIndex];
    category.price = {
      initialPrice: proposal === null || proposal === void 0 ? void 0 : proposal.price.totalWithoutDiscount,
      bestPrice: proposal === null || proposal === void 0 ? void 0 : proposal.price.total,
      diffPrice: formatedPrices[category.categoryIndex] || ''
    };
    return category;
  });

  if (accommodationCategories.length <= 1) {
    return null;
  }

  var _getTabsItemsAndProps = Object(productAccommodations_utils["b" /* getTabsItemsAndPropsFromAccommodations */])(props, accommodationCategories),
      slot = _getTabsItemsAndProps.slot;

  return AccommodationsComparator_jsx("div", {
    className: "ml-auto mb-5"
  }, slot([activeIndexes]));
};


// CONCATENATED MODULE: ./src/client/views/booking/accommodation/AccommodationsTabs.jsx













var AccommodationsTabs_jsx = react_default.a.createElement;

function AccommodationsTabs_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function AccommodationsTabs_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { AccommodationsTabs_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { AccommodationsTabs_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
















var FLEX_RATES = dist["constants"].FLEX_RATES;

var AccommodationsTabs_AccommodationsTabs = function AccommodationsTabs(_ref) {
  var isComparatorView = _ref.isComparatorView,
      isLoading = _ref.isLoading,
      product = _ref.product,
      proposals = _ref.proposals,
      selectedProposal = _ref.selectedProposal,
      selectedRate = _ref.selectedRate,
      selectProposal = _ref.selectProposal,
      setSelectedRate = _ref.setSelectedRate,
      streetViews = _ref.streetViews,
      switchOffers = _ref.switchOffers,
      tabTheme = _ref.tabTheme;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var locale = appContext.locale;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var uniqDiscounts = ProposalAccommodationTitleUtils_getUniqDiscountProposals(proposals);

  var updateUpsellRevenue = function updateUpsellRevenue() {
    var upsellRevenue = selectedProposal.price.total.value - Math.min.apply(Math, Object(toConsumableArray["a" /* default */])(proposals.map(function (_ref2) {
      var value = _ref2.price.total.value;
      return value;
    })));
    var rateType = '';

    switch (selectedRate) {
      case FLEX_RATES.STANDARD:
        rateType = 'standard';
        break;

      case FLEX_RATES.FLR:
        rateType = 'FlexibleRate';
        break;

      default:
        rateType = 'nonRefundableRate';
        break;
    }
    /*
      We need this information on BookingConfirmationView.
      To handle external payment provider redirection we have to store it outside of redux
     */


    tracking_storage_api["c" /* set */](AccommodationsTabs_objectSpread(AccommodationsTabs_objectSpread({}, tracking_storage_api["b" /* get */](tracking_constants["c" /* BE_TRACKING */])), {}, {
      rateType: rateType,
      upsellRevenue: upsellRevenue
    }));
  };

  Object(react["useEffect"])(function () {
    updateUpsellRevenue();
  }, [selectedProposal]);

  var onProposalSelection = function onProposalSelection(itemIndex) {
    var proposal = proposals[itemIndex];

    if ((proposal === null || proposal === void 0 ? void 0 : proposal.id) && !proposal.errorCode) {
      var _proposal$accommodati, _proposal$accommodati2;

      trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_ACCOMMODATION, {
        detail_click: 'change_comfort',
        room_type: (_proposal$accommodati = proposal.accommodations[0].comfortId) === null || _proposal$accommodati === void 0 ? void 0 : (_proposal$accommodati2 = _proposal$accommodati.split('_')) === null || _proposal$accommodati2 === void 0 ? void 0 : _proposal$accommodati2.pop()
      });
      selectProposal(proposal.id);
      setSelectedRate(proposal.price.selectedRate);
    }
  };

  var initialSelectedItem = Math.max(0, proposals.indexOf(selectedProposal));
  var selectedProposalPrice = Object(proposalUtils["m" /* getTotalValue */])(selectedProposal);
  var proposalsLength = proposals.length;
  var resolvedProposals = Object(proposalUtils["k" /* getResolvedProposals */])(proposals);
  var formatedPrices = resolvedProposals.map(function (proposal) {
    return Object(proposalUtils["i" /* getPriceDiff */])(Object(proposalUtils["m" /* getTotalValue */])(proposal), selectedProposalPrice, locale, selectedProposal.price.currency);
  });
  var formattedPricesPerNight = resolvedProposals.map(function (proposal) {
    return Object(proposalUtils["i" /* getPriceDiff */])(Object(proposalUtils["m" /* getTotalValue */])(proposal) / proposal.duration, selectedProposalPrice / proposal.duration, locale, selectedProposal.price.currency);
  });
  var displayPrice = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.pricePerNight') ? formattedPricesPerNight : formatedPrices;

  var getPriceLabel = function getPriceLabel(formatedPrice) {
    var priceLabel = '';

    if (Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.pricePerNight')) {
      priceLabel = " ".concat(Object(src_i18n["h" /* t */])('booking.accommodation.moreRooms.perNight'));
    }

    if (formatedPrice === null) {
      priceLabel = Object(src_i18n["h" /* t */])('booking.accommodation.packageContent.included');
    }

    return priceLabel;
  };

  var items = resolvedProposals.map(function (proposal, index) {
    var formatedPrice = displayPrice[index];
    return {
      header: {
        title: AccommodationsTabs_jsx(ProposalAccommodationTitle_ProposalAccommodationTitle, {
          includedLabel: getPriceLabel(displayPrice[index]),
          numberOfTabs: proposalsLength,
          priceLabel: formatedPrice,
          product: product,
          proposal: proposal,
          theme: tabTheme,
          uniqDiscounts: uniqDiscounts
        })
      },
      content: [AccommodationsTabs_jsx(BookingAccommodations_BookingAccommodations, {
        accommodations: proposal.accommodations,
        isLoading: isLoading,
        key: proposal.id,
        product: product,
        proposal: proposal,
        selectedRate: selectedRate,
        setSelectedRate: setSelectedRate,
        streetViews: streetViews,
        switchOffers: switchOffers,
        theme: isComparatorView ? 'default' : 'large',
        accommodationsComparator: AccommodationsTabs_jsx(AccommodationsComparator_AccommodationsComparator, {
          activeIndexes: index,
          formatedPrices: formatedPrices,
          product: product,
          proposals: proposals,
          resolvedProposals: resolvedProposals
        })
      })]
    };
  });
  return AccommodationsTabs_jsx(Tabs["a" /* Tabs */], {
    initialSelectedItem: initialSelectedItem,
    isContainerWide: true,
    items: items,
    onSelect: onProposalSelection,
    theme: "rounded"
  });
};


// EXTERNAL MODULE: ./src/client/store/booking/additional-accommodations/filters/filterUtils.js + 1 modules
var filterUtils = __webpack_require__("KxdP");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("M+/F");

// EXTERNAL MODULE: ./src/client/components/widgets/flex-rates/FlexRates.jsx + 1 modules
var FlexRates = __webpack_require__("ExLU");

// EXTERNAL MODULE: ./src/client/components/widgets/navigation/Navigation.constants.js
var Navigation_constants = __webpack_require__("1cDg");

// EXTERNAL MODULE: ./src/client/tracking/utils.js
var utils = __webpack_require__("zwLB");

// EXTERNAL MODULE: ./src/client/components/widgets/filters-bar/FiltersBar.jsx + 7 modules
var FiltersBar = __webpack_require__("jFIS");

// EXTERNAL MODULE: ./src/client/components/widgets/additional-accommodations/AdditionalAccommodationsUtils.js
var AdditionalAccommodationsUtils = __webpack_require__("CwJu");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/index.js
var tracking_api = __webpack_require__("d1HQ");

// CONCATENATED MODULE: ./src/client/components/widgets/additional-accommodations/AdditionalAccommodations.tracking.js









function AdditionalAccommodations_tracking_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function AdditionalAccommodations_tracking_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? AdditionalAccommodations_tracking_ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AdditionalAccommodations_tracking_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}




function trackSelectRoom(accommodationsSet, appContext) {
  var roomType = Object(utils["l" /* getTrackingRoomType */])(accommodationsSet.accommodations);
  tracking_api["b" /* setDataLayer */](AdditionalAccommodations_tracking_objectSpread(AdditionalAccommodations_tracking_objectSpread({}, booking_constants["c" /* BE_GA_DEFAULT_PAYLOAD */]), {}, {
    versionBooking: 'responsive',
    actionGA: 'moreRooms',
    labelGA: "confirmRoom_".concat(roomType)
  }), appContext);
}
// EXTERNAL MODULE: ./src/client/components/widgets/confirmation/Confirmation.jsx
var Confirmation = __webpack_require__("Fmrk");

// EXTERNAL MODULE: ./src/utils/accommodation/accommodation.utils.js
var accommodation_utils = __webpack_require__("Djgd");

// EXTERNAL MODULE: ./src/client/components/widgets/accommodation-option/AccommodationOption.jsx + 1 modules
var AccommodationOption = __webpack_require__("Q10v");

// EXTERNAL MODULE: ./src/client/components/widgets/accommodation-option-current/AccommodationOptionCurrent.jsx
var AccommodationOptionCurrent = __webpack_require__("IGVP");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.number.is-nan.js
var es_number_is_nan = __webpack_require__("ssvU");

// CONCATENATED MODULE: ./src/client/components/utils/style/style.util.js


function remToPx(rem) {
  var _document;

  if ((_document = document) === null || _document === void 0 ? void 0 : _document.documentElement) {
    var fontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
    return Number.isNaN(fontSize) ? rem * 16 : rem * fontSize;
  }

  return rem * 16;
}
// EXTERNAL MODULE: ./tailwind.config.js
var tailwind_config = __webpack_require__("0mz7");

// CONCATENATED MODULE: ./src/client/components/widgets/double-col-layer/DoubleColLayer.jsx


var DoubleColLayer_jsx = react_default.a.createElement;





var START_COL_CMP = 'StartCol';
var END_COL_CMP = 'EndCol';
var MARGIN_TOP = 0.875;
var HEADER_HEIGHT = 4;
var FIX_SCROLL_OFFSET = 2;
var DoubleColLayer_StartCol = function StartCol(_ref) {
  var children = _ref.children,
      additionalClasses = _ref.additionalClasses,
      dataTestId = _ref.dataTestId,
      activeCol = _ref.activeCol,
      isTablet = _ref.isTablet,
      isColSticky = _ref.isColSticky,
      headerOffset = _ref.headerOffset;
  var startColRef = Object(react["useRef"])();
  var stickyStyle = isTablet && isColSticky ? {
    position: 'fixed',
    top: "".concat(headerOffset || 5, "rem"),

    /**
     * have fun
     * comparing max-width container to half viewport size minus padding
     * react will remove calc() and expose the result for us
     * leaving min(maxWidth, halfViewport)
     */
    maxWidth: "calc(".concat(tailwind_config["theme"].maxWidth.site, " / 2)"),
    width: "calc(50vw - ".concat(tailwind_config["theme"].padding['5'], ")")
  } : null;
  return activeCol === START_COL_CMP || isTablet ? DoubleColLayer_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('sm:w-1/2 mb-20', additionalClasses, {
      'w-full': !isTablet
    }),
    "data-testid": dataTestId,
    style: stickyStyle,
    ref: startColRef
  }, children) : null;
};
var DoubleColLayer_EndCol = function EndCol(_ref2) {
  var children = _ref2.children,
      additionalClasses = _ref2.additionalClasses,
      dataTestId = _ref2.dataTestId,
      activeCol = _ref2.activeCol,
      isTablet = _ref2.isTablet,
      isColSticky = _ref2.isColSticky;
  return activeCol === END_COL_CMP || isTablet ? DoubleColLayer_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('sm:w-1/2 sm:ps-20 pb-40', additionalClasses, {
      'w-full': !isTablet,
      'sm:ms-auto': isColSticky
    }),
    "data-testid": dataTestId
  }, children) : null;
};
DoubleColLayer_StartCol.displayName = START_COL_CMP;
DoubleColLayer_EndCol.displayName = END_COL_CMP;
var DoubleColLayer_DoubleColLayer = function DoubleColLayer(_ref3) {
  var children = _ref3.children,
      _ref3$initialActiveCo = _ref3.initialActiveCol,
      initialActiveCol = _ref3$initialActiveCo === void 0 ? START_COL_CMP : _ref3$initialActiveCo,
      leftButtonLabel = _ref3.leftButtonLabel,
      rightButtonLabel = _ref3.rightButtonLabel,
      stickyTopPosition = _ref3.stickyTopPosition;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var _useState = Object(react["useState"])(initialActiveCol),
      activeCol = _useState[0],
      setActiveCol = _useState[1];

  var _useState2 = Object(react["useState"])(false),
      isSticky = _useState2[0],
      setIsSticky = _useState2[1];

  var _useState3 = Object(react["useState"])(0),
      currentScrollY = _useState3[0],
      setCurrentScrollY = _useState3[1];

  var stickyHeaderButtons = Object(react["useRef"])();
  var containerRef = Object(react["useRef"])();
  var layer = document.querySelector('[data-testid="Layer-body"]');
  var headerHeight = remToPx(HEADER_HEIGHT); // Header height

  var marginTop = remToPx(MARGIN_TOP); // Wrapper div has a parent with a margin of 0.875rem

  var baseScrollLimit = headerHeight + marginTop; // Reset active col when switching inbound/outbound

  Object(react["useEffect"])(function () {
    setActiveCol(initialActiveCol);
  }, [initialActiveCol]); // EasyComparison Mobile

  Object(react["useEffect"])(function () {
    var containerElement = containerRef.current;

    var handleScrollEasyComparison = function handleScrollEasyComparison() {
      if (activeCol === END_COL_CMP && containerElement != null) {
        setCurrentScrollY(containerElement.getBoundingClientRect().top);
      }
    };

    if (!isTablet && layer) {
      layer.addEventListener('scroll', handleScrollEasyComparison);
    }

    return function () {
      if (!isTablet && layer) {
        layer.removeEventListener('scroll', handleScrollEasyComparison);
      }
    };
  }, [activeCol]); // Sticky Buttons

  Object(react["useEffect"])(function () {
    var containerElement = containerRef.current;

    var handleScroll = function handleScroll() {
      if (containerElement != null) {
        var _stickyHeaderButtons$;

        // When the buttons are "fixed", it is not calculated in wrapperElement dimensions anymore
        var scrollTop = ((_stickyHeaderButtons$ = stickyHeaderButtons.current) === null || _stickyHeaderButtons$ === void 0 ? void 0 : _stickyHeaderButtons$.style.position) === 'fixed' ? baseScrollLimit + stickyHeaderButtons.current.getBoundingClientRect().height : baseScrollLimit;
        setIsSticky(containerElement.getBoundingClientRect().top <= scrollTop);
      }
    };

    if (layer) {
      layer.addEventListener('scroll', handleScroll);
    }

    return function () {
      if (layer) {
        layer.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);
  var childrenAsArray = react["Children"].toArray(children);
  var StartColCmp = childrenAsArray.find(function (_ref4) {
    var type = _ref4.type;
    return type.displayName === START_COL_CMP;
  });
  var EndColCmp = childrenAsArray.find(function (_ref5) {
    var type = _ref5.type;
    return type.displayName === END_COL_CMP;
  });

  if (react["Children"].count(children) !== 2 || !StartColCmp || !EndColCmp) {
    return null;
  }

  var isColSticky = isSticky && isTablet;
  var isHeaderSticky = isSticky && !isTablet;

  if (isHeaderSticky && stickyHeaderButtons.current) {
    stickyHeaderButtons.current.style.position = 'fixed';
    stickyHeaderButtons.current.style.top = "".concat(stickyTopPosition);
  }

  if (!isHeaderSticky && stickyHeaderButtons.current) {
    stickyHeaderButtons.current.style.position = 'static';
  }

  var childrenWithProps = react["Children"].map(children, function (child) {
    return /*#__PURE__*/Object(react["cloneElement"])(child, {
      isColSticky: isColSticky,
      activeCol: activeCol,
      isTablet: isTablet
    });
  });

  var onClickHandler = function onClickHandler() {
    setActiveCol(END_COL_CMP);

    if (currentScrollY && layer && stickyHeaderButtons.current) {
      // waiting for the col change Left / right
      setTimeout(function () {
        var buttons = stickyHeaderButtons.current;

        if (layer != null && buttons != null) {
          layer.scrollTo(0, Math.abs(currentScrollY) + // last scroll
          baseScrollLimit + buttons.getBoundingClientRect().height + remToPx(FIX_SCROLL_OFFSET));
        }
      }, 0);
    }
  };

  return DoubleColLayer_jsx("div", {
    ref: containerRef
  }, !isTablet && DoubleColLayer_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('flex mb-40 z-1', {
      'bg-white border-b-1 border-lightGrey inset-x-0 px-20 my-15 shadow-diffuse': isHeaderSticky
    }),
    ref: stickyHeaderButtons
  }, DoubleColLayer_jsx("button", {
    className: Object(classnames_utils["a" /* classnames */])('border-0 border-r-1 border-solid border-grey flex-1 font-bold px-20 py-5 text-14 underline', {
      'no-underline text-sienna': activeCol === START_COL_CMP
    }),
    onClick: function onClick() {
      return setActiveCol(START_COL_CMP);
    },
    type: "button"
  }, leftButtonLabel), DoubleColLayer_jsx("button", {
    className: Object(classnames_utils["a" /* classnames */])('flex-1 font-bold px-20 py-5 text-14 underline', {
      'no-underline text-sienna': activeCol === END_COL_CMP
    }),
    onClick: onClickHandler,
    type: "button"
  }, rightButtonLabel)), DoubleColLayer_jsx("div", {
    className: "flex flex-row"
  }, childrenWithProps));
};
// EXTERNAL MODULE: ./src/client/components/widgets/paginate/Paginate.jsx + 1 modules
var Paginate = __webpack_require__("aGPO");

// CONCATENATED MODULE: ./src/client/components/widgets/additional-accommodations/list/AdditionalAccommodationsList.jsx


var AdditionalAccommodationsList_jsx = react_default.a.createElement;













var AdditionalAccommodationsList_AdditionalAccommodationsList = function AdditionalAccommodationsList(_ref) {
  var accommodationsSets = _ref.accommodationsSets,
      currency = _ref.currency,
      filteredAccommodationSets = _ref.filteredAccommodationSets,
      onAddAccommodation = _ref.onAddAccommodation,
      proposal = _ref.proposal,
      product = _ref.product,
      selectedRate = _ref.selectedRate,
      setSelectedRate = _ref.setSelectedRate,
      streetViews = _ref.streetViews;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var iterationNumber = 5;

  var _useState = Object(react["useState"])(iterationNumber),
      forceInitialShowingItemsNumber = _useState[0],
      setForceInitialShowingItemsNumber = _useState[1];

  if (accommodationsSets.length < 1) {
    return null;
  }

  var headerHeight = 60 + 70;
  var titleHeight = 27.5;
  var paddingHeight = 40;
  return AdditionalAccommodationsList_jsx(DoubleColLayer_DoubleColLayer, {
    leftButtonLabel: Object(src_i18n["h" /* t */])('booking.accommodation.moreRooms.roomRecommendation'),
    rightButtonLabel: "".concat(Object(src_i18n["h" /* t */])('booking.accommodation.moreRooms.otherProposals'), " (").concat(filteredAccommodationSets.length, "\n    )"),
    initialActiveCol: isTablet ? START_COL_CMP : END_COL_CMP,
    stickyTopPosition: "140px"
  }, AdditionalAccommodationsList_jsx(DoubleColLayer_StartCol, {
    headerOffset: 8.75
  }, AdditionalAccommodationsList_jsx(Title["a" /* Title */], {
    className: "mb-20 hidden sm:flex",
    hLevel: 3,
    iconName: icons["a" /* ICONS */].CHECK,
    theme: "title-brand-n3"
  }, Object(src_i18n["h" /* t */])('booking.accommodation.moreRooms.roomRecommendation')), AdditionalAccommodationsList_jsx(AccommodationOptionCurrent["a" /* AccommodationOptionCurrent */], {
    onSelect: function onSelect() {
      trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_ACCOMMODATION_LAYER, {
        detail_click: 'current_room_validate'
      });
      onAddAccommodation();
    },
    style: isTablet ? {
      maxHeight: "calc(100vh - ".concat(titleHeight, "px - ").concat(headerHeight, "px - ").concat(paddingHeight, "px)")
    } : null
  }, AdditionalAccommodationsList_jsx(BookingAccommodations_BookingAccommodations, {
    accommodations: proposal.accommodations,
    isInMoreRoomLayer: true,
    product: product,
    proposal: proposal,
    selectedRate: selectedRate,
    setSelectedRate: setSelectedRate,
    streetViews: streetViews,
    theme: "medium"
  }))), AdditionalAccommodationsList_jsx(DoubleColLayer_EndCol, {
    dataTestId: "AdditionalAccommodationsList"
  }, AdditionalAccommodationsList_jsx(Title["a" /* Title */], {
    className: "mb-20 hidden sm:flex",
    hLevel: 3,
    theme: "title-brand-n3"
  }, filteredAccommodationSets.length, "\xA0", Object(src_i18n["h" /* t */])('booking.accommodation.moreRooms.otherProposals')), AdditionalAccommodationsList_jsx(Paginate["a" /* Paginate */], {
    forceInitialShowingItemsNumber: !isTablet ? forceInitialShowingItemsNumber : 0,
    iterationNumber: iterationNumber,
    seeMoreLabel: Object(src_i18n["h" /* t */])('common.viewMore'),
    setForceInitialShowingItemsNumber: setForceInitialShowingItemsNumber
  }, filteredAccommodationSets.map(function (accommodationsSet, idx) {
    var _accommodationsSet$di, _accommodationsSet$to;

    return AdditionalAccommodationsList_jsx(AccommodationOption["a" /* AccommodationOption */], {
      className: "mb-40",
      id: accommodationsSet.id,
      index: idx + 1,
      key: accommodationsSet.id,
      onSelect: function onSelect() {
        trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_ACCOMMODATION_LAYER, {
          detail_click: 'edit_room_validate'
        });
        onAddAccommodation(accommodationsSet.id);
      },
      price: {
        currency: currency,
        nigthly: ((_accommodationsSet$di = accommodationsSet.differentialPriceByNight) === null || _accommodationsSet$di === void 0 ? void 0 : _accommodationsSet$di.value) || 0,
        total: ((_accommodationsSet$to = accommodationsSet.totalDifferentialPrice) === null || _accommodationsSet$to === void 0 ? void 0 : _accommodationsSet$to.value) || 0,
        isUpgradableOnline: accommodationsSet.isUpgradableOnline
      }
    }, AdditionalAccommodationsList_jsx(BookingAccommodations_BookingAccommodations, {
      accommodations: accommodationsSet.accommodations,
      accommodationsCount: Object(accommodation_utils["a" /* getNbAccommodations */])(accommodationsSet),
      isInMoreRoomLayer: true,
      product: product,
      proposal: proposal,
      remainingStock: accommodationsSet.remainingStock,
      selectedRate: selectedRate,
      setSelectedRate: setSelectedRate,
      streetViews: streetViews,
      theme: "medium"
    }));
  }))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/additional-accommodations/list/AdditionalAccommodationsListWrapper.jsx

var AdditionalAccommodationsListWrapper_jsx = react_default.a.createElement;





var AdditionalAccommodationsListWrapper_AdditionalAccommodationsListWrapper = function AdditionalAccommodationsListWrapper(_ref) {
  var accommodationsSets = _ref.accommodationsSets,
      error = _ref.error,
      filteredAccommodationSets = _ref.filteredAccommodationSets,
      isDataFetched = _ref.isDataFetched,
      onAddAccommodation = _ref.onAddAccommodation,
      product = _ref.product,
      proposal = _ref.proposal,
      selectedRate = _ref.selectedRate,
      setSelectedRate = _ref.setSelectedRate,
      streetViews = _ref.streetViews;

  if (isEmpty_default()(error)) {
    return AdditionalAccommodationsListWrapper_jsx(react["Fragment"], null, isDataFetched && accommodationsSets.length === 0 && AdditionalAccommodationsListWrapper_jsx("div", {
      className: "max-w-site-small mb-40 mx-auto"
    }, AdditionalAccommodationsListWrapper_jsx(Confirmation["a" /* Confirmation */], {
      icon: icons["a" /* ICONS */].CIRCLED_ACCOMMODATION,
      status: "neutral",
      text: Object(src_i18n["h" /* t */])('booking.accommodation.moreRooms.noMoreRoomsAvailableDescription'),
      title: Object(src_i18n["h" /* t */])('booking.accommodation.moreRooms.noMoreRoomsAvailableTitle')
    })), AdditionalAccommodationsListWrapper_jsx(AdditionalAccommodationsList_AdditionalAccommodationsList, {
      accommodationsSets: accommodationsSets,
      currency: proposal.price.currency,
      filteredAccommodationSets: filteredAccommodationSets,
      onAddAccommodation: onAddAccommodation,
      product: product,
      proposal: proposal,
      selectedRate: selectedRate,
      setSelectedRate: setSelectedRate,
      streetViews: streetViews
    }));
  }

  var errorMessageKey = 'booking.common.layer.unknownErrorDescription';

  if (error.errorCode === 'INVALID_BOOKING_CRITERIA') {
    errorMessageKey = 'booking.accommodation.moreRooms.seller.InvalidBookingCriteria';
  }

  return AdditionalAccommodationsListWrapper_jsx("div", {
    className: "max-w-site-small mx-auto"
  }, AdditionalAccommodationsListWrapper_jsx(Confirmation["a" /* Confirmation */], {
    status: "error",
    text: Object(src_i18n["h" /* t */])(errorMessageKey),
    title: Object(src_i18n["h" /* t */])('booking.common.layer.unknownErrorTitle')
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/additional-accommodations/AdditionalAccommodations.jsx


















var AdditionalAccommodations_jsx = react_default.a.createElement;

function AdditionalAccommodations_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function AdditionalAccommodations_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { AdditionalAccommodations_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { AdditionalAccommodations_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


























var AdditionalAccommodations_AdditionalAccommodations = function AdditionalAccommodations(_ref) {
  var filters = _ref.filters,
      filterValues = _ref.filterValues,
      loaderClassName = _ref.loaderClassName,
      onClose = _ref.onClose,
      _ref$onSubmit = _ref.onSubmit,
      onSubmit = _ref$onSubmit === void 0 ? noop_default.a : _ref$onSubmit,
      _ref$processChangeAcc = _ref.processChangeAccommodation,
      processChangeAccommodation = _ref$processChangeAcc === void 0 ? true : _ref$processChangeAcc,
      product = _ref.product,
      proposal = _ref.proposal,
      selectedRate = _ref.selectedRate,
      setSelectedRate = _ref.setSelectedRate,
      streetViews = _ref.streetViews,
      switchOffers = _ref.switchOffers;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var dispatch = Object(es["d" /* useDispatch */])();
  var isLoading = Object(es["e" /* useSelector */])(booking_selector["p" /* getIsLoadingAdditionalAccommodations */]) || false;
  var accommodationsSets = Object(es["e" /* useSelector */])(booking_selector["a" /* getAdditionalAccommodations */]) || [];
  var filteredAccommodations = Object(es["e" /* useSelector */])(booking_selector["n" /* getFilteredAdditionalAccommodationsSets */]);
  var error = Object(es["e" /* useSelector */])(booking_selector["b" /* getAdditionalAccommodationsError */]);
  var isDataFetched = Object(es["e" /* useSelector */])(function (state) {
    return state.booking.additionalAccommodations.isDataFetched;
  });

  var _useState = Object(react["useState"])(false),
      visibility = _useState[0],
      setVisibility = _useState[1];

  var options = Object(FlexRates["b" /* getFlexRatesOptions */])(proposal, appContext, 'medium');
  var selectedOption = options.find(function (option) {
    return option.id === selectedRate;
  });
  var withoutProposalAccommodationSets = Object(AdditionalAccommodationsUtils["a" /* filterAccommodations */])(proposal, accommodationsSets) || [];
  var filteredAccommodationSets = Object(AdditionalAccommodationsUtils["b" /* filterReducedMobilityAccomodation */])(visibility, filteredAccommodations);
  var accomodationsIdWithLowerCategories = accommodation_constants["a" /* ACCOMMODATION_COMFORT_ORDER */].slice(0, accommodation_constants["a" /* ACCOMMODATION_COMFORT_ORDER */].findIndex(function (id) {
    var _proposal$accommodati, _proposal$accommodati2;

    return id === ((_proposal$accommodati = proposal.accommodations) === null || _proposal$accommodati === void 0 ? void 0 : (_proposal$accommodati2 = _proposal$accommodati[0]) === null || _proposal$accommodati2 === void 0 ? void 0 : _proposal$accommodati2.categoryId);
  }));
  var filteredAccommodationsSetsWithHigherCategories = filteredAccommodationSets.filter(function (accomodationSets) {
    var _accomodationSets$acc, _accomodationSets$acc2;

    return accomodationSets.totalDifferentialPrice.value >= 0 && !accomodationsIdWithLowerCategories.includes((_accomodationSets$acc = accomodationSets.accommodations) === null || _accomodationSets$acc === void 0 ? void 0 : (_accomodationSets$acc2 = _accomodationSets$acc[0]) === null || _accomodationSets$acc2 === void 0 ? void 0 : _accomodationSets$acc2.categoryId);
  });
  /* We need to clean roomFilters from storage since we changed the proposal, and update the roomOptions */

  var updateUpsellRevenue = function updateUpsellRevenue(accommodationSet, proposalQuantity) {
    var storage = tracking_storage_api["b" /* get */](tracking_constants["c" /* BE_TRACKING */]); // $FlowFixMe

    var selectedProposalId = storage.contextNumber;
    var totalDifferentialPrice = accommodationSet.totalDifferentialPrice || {}; // $FlowFixMe

    var roomFilters = (storage.roomFilters || []).filter(function (roomFilter) {
      return roomFilter.proposalId === selectedProposalId;
    });
    var roomFiltersTotalUpsellRevenue = roomFilters.reduce(function (acc, _ref2) {
      var upsellRevenue = _ref2.upsellRevenue;
      return acc + upsellRevenue;
    }, 0); // $FlowFixMe

    var roomOptions = storage.roomOptions || {};
    var shouldClearOptions = proposal.id !== roomOptions.proposalId;
    var newUpsellRevenue = roomFiltersTotalUpsellRevenue + totalDifferentialPrice.value + (shouldClearOptions ? 0 : roomOptions.upsellRevenue || 0);
    /*
      We need this information on BookingConfirmationView.
      To handle external payment provider redirection we have to store it outside of redux
     */

    tracking_storage_api["c" /* set */](AdditionalAccommodations_objectSpread(AdditionalAccommodations_objectSpread({}, storage), {}, {
      roomFilters: [],
      roomOptions: {
        upsell: newUpsellRevenue > 0 ? 'yes' : 'no',
        upsellCategory: 'room',
        upsellRevenue: newUpsellRevenue,
        upsellQuantity: proposalQuantity,
        upsellName: accommodationSet.accommodations[0].id,
        proposalId: proposal.id
      }
    }));
  };

  var handleAddAccommodation = function handleAddAccommodation(accommodationId) {
    if (!accommodationId) {
      if (selectedRate !== proposal.price.selectedRate) {
        // $FlowFixMe offers always defined
        switchOffers(selectedOption.offers);
      }

      return onClose();
    } // $FlowFixMe there's always an AccommodationsSet


    var accommodationSet = find_default()(withoutProposalAccommodationSets, {
      id: accommodationId
    });

    var arrangement = accommodationSet.accommodations.map(function (_ref3) {
      var attendeesDistribution = _ref3.attendeesDistribution;
      return attendeesDistribution;
    }).filter(Boolean);
    updateUpsellRevenue(accommodationSet, withoutProposalAccommodationSets.length);

    if (!processChangeAccommodation) {
      return onSubmit(arrangement);
    }

    trackSelectRoom(accommodationSet, appContext);
    onSubmit(proposal.id);
    dispatch(Object(proposals_action["a" /* addAccommodation */])({
      arrangement: arrangement,
      globalLoaderLabel: Object(src_i18n["h" /* t */])('booking.accommodation.moreRooms.loaderLabelUpdate'),
      isJoyview: product.isJoyview,
      isUrbanOasis: product.isUrbanOasis,
      proposalsId: Object(BookingEngine_utils["b" /* getAllProposalsIdWithAlternative */])(proposal),
      toastLabel: Object(bookingUtils["u" /* tAlt */])({
        cruiseKeyPath: 'booking.accommodation.newCabinSelection',
        product: product,
        resortKeyPath: 'booking.accommodation.newRoomSelection'
      }),
      appContext: appContext
    })).then(function () {
      if (selectedRate !== proposal.price.selectedRate) {
        // $FlowFixMe offers always defined
        switchOffers(selectedOption.offers);
      }
    });
  };

  var hasFiltersEnabled = filters.some(function (filter) {
    return filter.options.some(function (_ref4) {
      var isSelected = _ref4.isSelected;
      return isSelected;
    });
  });
  var handleUpdateAccomodationFilters = Object(filterUtils["e" /* updateFilters */])({
    accommodationsSets: accommodationsSets,
    filterValues: filterValues,
    visibility: visibility
  }, dispatch, setVisibility);
  Object(react["useEffect"])(function () {
    setTimeout(function () {
      var target = document.querySelector('#room-proposal-title');

      if (target) {
        target.scrollIntoView(); // the header is on top of the element that we targeted, so we have to scroll down the height of the header

        var container = document.querySelector('.scroll-y');

        if (container) {
          container.scrollTop -= Navigation_constants["d" /* heights */].NAVIGATION_LARGE_HEIGHT;
        }
      }
    }, 100);
  }, [isLoading]);
  return isLoading ? AdditionalAccommodations_jsx(AsyncLoader["a" /* AsyncLoader */], {
    className: Object(classnames_utils["a" /* classnames */])('mt-[25vh]', loaderClassName),
    "data-scroll-anchor": "loaderAdditionalAccommodations",
    icon: icons["a" /* ICONS */].STANDALONE_MAGNIFYING_GLASS,
    iconSize: "3rem",
    label: Object(bookingUtils["u" /* tAlt */])({
      cruiseKeyPath: 'booking.accommodation.moreRooms.moreCabinLoaderLabel',
      product: product,
      resortKeyPath: 'booking.accommodation.moreRooms.moreRoomLoaderLabel'
    }),
    theme: "labeled"
  }) : AdditionalAccommodations_jsx(react["Fragment"], null, AdditionalAccommodations_jsx("div", {
    className: "fixed inset-x-0 top-[60px] z-2"
  }, AdditionalAccommodations_jsx(FiltersBar["a" /* FiltersBar */], {
    caption: Object(src_i18n["h" /* t */])('filters.label'),
    dataTestid: "AccommodationsFilters",
    filters: filters,
    hasForceClose: true,
    isLarge: true,
    onChange: handleUpdateAccomodationFilters,
    onClear: function onClear(name) {
      dispatch(Object(additionalAccommodations_action["r" /* unselectAdditionalAccommodationsFilterCategory */])(name));
    },
    onClick: function onClick(name) {
      trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_ACCOMMODATION_LAYER, {
        detail_click: "filter_".concat(utils["b" /* TRACKING_ACCOMMODATION_FILTER_TYPES */][name])
      });
    },
    onClickOption: function onClickOption(option) {
      if (option.isSelected) {
        var _TRACKING_ROOM_TYPE_B, _option$value;

        trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_ACCOMMODATION_LAYER, {
          detail_click: "advanced_filter_".concat((_TRACKING_ROOM_TYPE_B = utils["c" /* TRACKING_ROOM_TYPE_BY_ACCOMMODATION_CATEGORY */][option.value]) !== null && _TRACKING_ROOM_TYPE_B !== void 0 ? _TRACKING_ROOM_TYPE_B : (_option$value = option.value) === null || _option$value === void 0 ? void 0 : _option$value.toLowerCase())
        });
      }
    },
    portalName: "AccommodationsFilterOptions"
  })), AdditionalAccommodations_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "mt-100 md:mt-80"
  }, AdditionalAccommodations_jsx(AdditionalAccommodationsListWrapper_AdditionalAccommodationsListWrapper, {
    accommodationsSets: withoutProposalAccommodationSets,
    error: error,
    filteredAccommodationSets: hasFiltersEnabled ? filteredAccommodationSets : filteredAccommodationsSetsWithHigherCategories,
    isDataFetched: isDataFetched,
    onAddAccommodation: handleAddAccommodation,
    proposal: proposal,
    product: product,
    streetViews: streetViews,
    selectedRate: selectedRate,
    setSelectedRate: setSelectedRate
  })));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/layer/Layer.jsx + 4 modules
var Layer = __webpack_require__("U2fG");

// EXTERNAL MODULE: ./src/utils/transport/transportUtils.js
var transportUtils = __webpack_require__("pdPG");

// CONCATENATED MODULE: ./src/client/components/widgets/layer-header-proposal/LayerHeaderProposal.jsx

var LayerHeaderProposal_jsx = react_default.a.createElement;




var LayerHeaderProposal_getTransportSummary = function getTransportSummary(proposal) {
  var currentTransport = proposal.transports;
  var inboundDeparture = Object(transportUtils["d" /* getInboundDeparture */])(currentTransport);
  var outboundDeparture = Object(transportUtils["e" /* getOutboundDeparture */])(currentTransport);
  var departureSummary = Object(transportUtils["i" /* getTravelSectionBoundSummary */])(inboundDeparture);
  var arrivalSummary = Object(transportUtils["i" /* getTravelSectionBoundSummary */])(outboundDeparture);
  return departureSummary && arrivalSummary ? "".concat(departureSummary, " - ").concat(arrivalSummary) : '';
};

var LayerHeaderProposal_getProposalSummary = function getProposalSummary(proposal, dateFormat) {
  var arrivalDate = Object(proposalUtils["f" /* getFormattedArrivalDate */])(proposal, dateFormat);
  var departureDate = Object(proposalUtils["g" /* getFormattedDepartureDate */])(proposal, dateFormat);
  return "".concat(arrivalDate, " - ").concat(departureDate);
};

var LayerHeaderProposal_LayerHeaderProposal = function LayerHeaderProposal(_ref) {
  var dateFormat = _ref.dateFormat,
      id = _ref.id,
      _ref$layerTitle = _ref.layerTitle,
      layerTitle = _ref$layerTitle === void 0 ? '' : _ref$layerTitle,
      numberResults = _ref.numberResults,
      proposal = _ref.proposal,
      _ref$totalPrice = _ref.totalPrice,
      totalPrice = _ref$totalPrice === void 0 ? '' : _ref$totalPrice;
  var summary = proposal.transports ? LayerHeaderProposal_getTransportSummary(proposal) : LayerHeaderProposal_getProposalSummary(proposal, dateFormat);
  return LayerHeaderProposal_jsx("div", {
    className: "flex gap-10 items-end justify-between mx-10 text-mediumGrey"
  }, LayerHeaderProposal_jsx("span", {
    className: "hidden lg:block font-bold text-16",
    "data-testid": "LayerHeaderProposal-summary"
  }, summary), LayerHeaderProposal_jsx("span", {
    className: "flex flex-1 gap-5 font-sans font-semibold items-center justify-center leading-tight text-20 text-black",
    "data-testid": "LayerHeaderProposal-title",
    id: id
  }, layerTitle, numberResults && LayerHeaderProposal_jsx("span", {
    className: "text-12"
  }, "(", numberResults, ")")), LayerHeaderProposal_jsx("span", {
    className: "hidden md:flex font-bold gap-10 items-end text-16"
  }, LayerHeaderProposal_jsx("span", {
    "data-testid": "LayerHeaderProposal-totalLabel"
  }, totalPrice), LayerHeaderProposal_jsx("span", {
    className: "text-sienna text-20",
    "data-testid": "LayerHeaderProposal-total"
  }, Object(proposalUtils["l" /* getTotalPriceFormatted */])(proposal))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/additional-accommodations/layers/AdditionalAccommodationsLayer.jsx








var AdditionalAccommodationsLayer_jsx = react_default.a.createElement;

function AdditionalAccommodationsLayer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function AdditionalAccommodationsLayer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { AdditionalAccommodationsLayer_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { AdditionalAccommodationsLayer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












var AdditionalAccommodationsLayer_AdditionalAccommodationsLayer = function AdditionalAccommodationsLayer(_ref) {
  var children = _ref.children,
      filters = _ref.filters,
      filterValues = _ref.filterValues,
      onClose = _ref.onClose,
      onSubmit = _ref.onSubmit,
      portalName = _ref.portalName,
      _ref$processChangeAcc = _ref.processChangeAccommodation,
      processChangeAccommodation = _ref$processChangeAcc === void 0 ? true : _ref$processChangeAcc,
      product = _ref.product,
      proposal = _ref.proposal,
      selectedRate = _ref.selectedRate,
      setSelectedRate = _ref.setSelectedRate,
      streetViews = _ref.streetViews,
      switchOffers = _ref.switchOffers;
  var beEngineTrackingContext = Object(react["useContext"])(BookingEngineTrackingContext["a" /* BookingEngineTrackingContext */]);
  var layerTitle = Object(bookingUtils["u" /* tAlt */])({
    cruiseKeyPath: 'booking.accommodation.moreRooms.modifyHeaderTitleCruise',
    product: product,
    resortKeyPath: 'booking.accommodation.moreRooms.modifyHeaderTitle'
  });
  return AdditionalAccommodationsLayer_jsx(Layer["b" /* Layer */], {
    ariaLabel: layerTitle,
    ariaLabelledby: identifiers_constants["a" /* ID_LAYER_HEADER__BE__ACCOMMODATIONS */],
    buttonLeft: {
      iconName: icons["a" /* ICONS */].ARROW_TAIL_LEFT,
      label: Object(src_i18n["h" /* t */])('common.backNavigation'),
      onClick: onClose
    },
    closeLabel: Object(src_i18n["h" /* t */])('common.close'),
    hasContainerHeader: true,
    header: AdditionalAccommodationsLayer_jsx(LayerHeaderProposal_LayerHeaderProposal, {
      id: identifiers_constants["a" /* ID_LAYER_HEADER__BE__ACCOMMODATIONS */],
      layerTitle: layerTitle,
      proposal: proposal,
      totalPrice: Object(src_i18n["h" /* t */])('booking.accommodation.moreRooms.totalPackagePriceLabel')
    }),
    onClose: onClose,
    portalName: portalName
  }, AdditionalAccommodationsLayer_jsx(TrackPage["a" /* TrackPage */], {
    pageName: tracking_constants["H" /* TRACK_PAGE_NAMES */].BE_LAYER_ACCOMMODATION,
    payload: AdditionalAccommodationsLayer_objectSpread({}, beEngineTrackingContext)
  }), children, AdditionalAccommodationsLayer_jsx(AdditionalAccommodations_AdditionalAccommodations, {
    filters: filters,
    filterValues: filterValues,
    loaderClassName: "mt-[10vh]",
    onClose: onClose,
    onSubmit: onSubmit,
    processChangeAccommodation: processChangeAccommodation,
    proposal: proposal,
    product: product,
    selectedRate: selectedRate,
    setSelectedRate: setSelectedRate,
    streetViews: streetViews,
    switchOffers: switchOffers
  }));
};
// CONCATENATED MODULE: ./src/client/views/booking/accommodation/more-rooms/MoreRooms.jsx
var MoreRooms_jsx = react_default.a.createElement;







var MoreRooms_MoreRooms = function MoreRooms(_ref) {
  var onClose = _ref.onClose,
      onSubmit = _ref.onSubmit,
      portalName = _ref.portalName,
      _ref$processChangeAcc = _ref.processChangeAccommodation,
      processChangeAccommodation = _ref$processChangeAcc === void 0 ? true : _ref$processChangeAcc,
      product = _ref.product,
      proposal = _ref.proposal,
      streetViews = _ref.streetViews,
      switchOffers = _ref.switchOffers;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var dispatch = Object(es["d" /* useDispatch */])();

  var _useState = Object(react["useState"])(proposal.price.selectedRate),
      selectedRate = _useState[0],
      setSelectedRate = _useState[1];

  var filterValues = Object(es["e" /* useSelector */])(booking_selector["c" /* getAdditionalAccommodationsFilters */]);
  var filters = Object(filterUtils["b" /* getFilters */])(product, filterValues || []);
  Object(react["useEffect"])(function () {
    dispatch(Object(additionalAccommodations_action["l" /* fetchAdditionalAccommodations */])({
      appContext: appContext,
      proposal: proposal,
      product: product,
      shouldPreselectFilters: false
    }));
    return function () {
      dispatch(Object(additionalAccommodations_action["k" /* clearAdditionalAccommodations */])());
    };
  }, []);
  var props = {
    filters: filters,
    filterValues: filterValues,
    onClose: onClose,
    onSubmit: onSubmit,
    portalName: portalName,
    processChangeAccommodation: processChangeAccommodation,
    product: product,
    proposal: proposal,
    selectedRate: selectedRate,
    setSelectedRate: setSelectedRate,
    streetViews: streetViews,
    switchOffers: switchOffers
  };
  return MoreRooms_jsx(AdditionalAccommodationsLayer_AdditionalAccommodationsLayer, props);
};
// CONCATENATED MODULE: ./src/client/views/booking/accommodation/AccommodationView.jsx














var AccommodationView_jsx = react_default.a.createElement;


























var AccommodationView_AccommodationView = function AccommodationView(_ref) {
  var closeLayer = _ref.closeLayer,
      infoBannerData = _ref.infoBannerData,
      openLayer = _ref.openLayer,
      proposals = _ref.proposals,
      resort = _ref.resort,
      selectedProposal = _ref.selectedProposal,
      streetViews = _ref.streetViews;

  var _React$useState = react_default.a.useState(false),
      _React$useState2 = Object(slicedToArray["a" /* default */])(_React$useState, 2),
      isLoading = _React$useState2[0],
      setIsLoading = _React$useState2[1];

  var _React$useState3 = react_default.a.useState(selectedProposal.price.selectedRate),
      _React$useState4 = Object(slicedToArray["a" /* default */])(_React$useState3, 2),
      selectedRate = _React$useState4[0],
      setSelectedRate = _React$useState4[1];

  var _React$useState5 = react_default.a.useState(selectedProposal),
      _React$useState6 = Object(slicedToArray["a" /* default */])(_React$useState5, 2),
      proposal = _React$useState6[0],
      setProposal = _React$useState6[1];

  var _React$useState7 = react_default.a.useState({
    proposal: null,
    errors: null
  }),
      _React$useState8 = Object(slicedToArray["a" /* default */])(_React$useState7, 2),
      refreshedProposal = _React$useState8[0],
      setRefreshedProposal = _React$useState8[1];

  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var dispatch = Object(es["d" /* useDispatch */])();
  var router = Object(next_router["useRouter"])();

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var showDisclamer = Object(src_i18n["d" /* getKeyValue */])('booking.accommodation.promotion.showDisclamer');
  var uniqDiscounts = ProposalAccommodationTitleUtils_getUniqDiscountProposals(proposals);
  Object(useBookingNavbar["a" /* useBookingNavbar */])({
    isPriceLoading: isLoading,
    noEdit: false
  });

  var getAlternativesForFilters = function getAlternativesForFilters() {
    var isAlternativeFiltersModeActive = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.AlternativeFiltersModeActive');

    if (isAlternativeFiltersModeActive && additionalAccommodations_action["n" /* getAlternativeFilteredAccommodations */]) {
      dispatch(Object(additionalAccommodations_action["n" /* getAlternativeFilteredAccommodations */])({
        appContext: appContext,
        proposal: selectedProposal
      }));
    }
  };

  Object(react["useEffect"])(function () {
    getAlternativesForFilters();
  }, []);
  Object(react["useEffect"])(function () {
    if (proposal.id !== selectedProposal.id || proposal.accommodations !== selectedProposal.accommodations) {
      setProposal(selectedProposal);
      getAlternativesForFilters();
    }
  }, [selectedProposal]);

  var onMoreRoomsClickOpen = function onMoreRoomsClickOpen() {
    return function () {
      trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_ACCOMMODATION, {
        detail_click: 'see_more_rooms'
      });
      openLayer(booking_constants["a" /* BE_ACCOMMODATIONS_LAYER_NAME */]);
    };
  };

  var onMoreRoomsSelect = function onMoreRoomsSelect(proposalId) {
    var hasFlexRates = selectedProposal.price.hasFlexRates;
    closeLayer(!hasFlexRates, proposalId);
  };

  var onSelectProposal = /*#__PURE__*/function () {
    var _ref2 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(proposalId) {
      var updatedUri, refreshProposal;
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              updatedUri = new URI_default.a(router.asPath).setQuery(dist["appQueryParameters"].booking.selectedProposalId, proposalId);
              router.replace(updatedUri.toString());
              dispatch(Object(selectedProposalId_action["d" /* selectProposal */])(proposalId));
              _context.next = 5;
              return dispatch(Object(proposals_action["m" /* fetchRefreshProposal */])(proposalId, undefined, appContext));

            case 5:
              refreshProposal = _context.sent;
              return _context.abrupt("return", setRefreshedProposal(refreshProposal === null || refreshProposal === void 0 ? void 0 : refreshProposal.refreshProposal));

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSelectProposal(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var switchOffers = function switchOffers(offers) {
    setIsLoading(true);
    dispatch(Object(proposals_action["y" /* switchProposalsOffers */])(offers, appContext)).finally(function () {
      return setIsLoading(false);
    });
  };

  if (isEmpty_default()(Object(proposalUtils["k" /* getResolvedProposals */])(proposals))) {
    return null;
  }

  var buttonProps = {
    label: Object(bookingUtils["u" /* tAlt */])({
      cruiseKeyPath: 'booking.accommodation.moreCabinsLabel',
      product: resort,
      resortKeyPath: 'booking.accommodation.moreRoomsLabel'
    }),
    trackingData: {
      appContext: appContext,
      baseProposal: proposals[0],
      selectedProposal: selectedProposal
    }
  };

  var participantCount = get_default()(selectedProposal, 'attendees.list.length', 0);

  var shouldDisplayMoreRoomsLayer = router.query[dist["appQueryParameters"].openLayer] === booking_constants["a" /* BE_ACCOMMODATIONS_LAYER_NAME */];
  return proposal && AccommodationView_jsx(react_default.a.Fragment, null, Object(infoBanner_utils["a" /* renderInfoBanner */])({
    infoBannerData: infoBannerData,
    departureDate: selectedProposal.departureDate,
    arrivalDate: selectedProposal.arrivalDate,
    currentStep: 'accommodation'
  }), AccommodationView_jsx(OverlaidActionProvider_OverlaidActionProvider, {
    button: {
      label: buttonProps.label,
      onClick: onMoreRoomsClickOpen()
    },
    dataSelector: "MoreRooms",
    label: Object(src_i18n["h" /* t */])('booking.accommodation.teasingMoreRooms')
  }, AccommodationView_jsx(AccommodationsTabs_AccommodationsTabs, {
    isLoading: isLoading,
    participantCount: participantCount,
    product: resort,
    proposals: proposals,
    selectedProposal: selectedProposal,
    selectedRate: selectedRate,
    selectProposal: onSelectProposal,
    setSelectedRate: setSelectedRate,
    switchOffers: switchOffers,
    streetViews: streetViews
  })), showDisclamer && uniqDiscounts.length > 0 && AccommodationView_jsx(SimpleNotification["a" /* SimpleNotification */], {
    id: "AccomodationDisclamer",
    title: Object(src_i18n["h" /* t */])('booking.accommodation.promotion.disclamerTitle'),
    className: "mt-40",
    content: AccommodationView_jsx("ul", {
      className: "list-none"
    }, uniqDiscounts.map(function (discount, index) {
      return AccommodationView_jsx("li", {
        key: "AccomodationDisclamer-".concat(index * 1)
      }, "".concat('*'.repeat(index + 1)).concat(Object(src_i18n["h" /* t */])('booking.accommodation.promotion.disclamer', {
        discount: discount
      })));
    })),
    iconName: icons["a" /* ICONS */].EXCLAMATION_POINT
  }), shouldDisplayMoreRoomsLayer && AccommodationView_jsx(MoreRooms_MoreRooms, {
    onClose: function onClose(proposalId) {
      return closeLayer(false, proposalId);
    } // $FlowFixMe string is compatible with string | AccommodationArrangement
    ,
    onSubmit: onMoreRoomsSelect,
    proposal: selectedProposal,
    product: resort,
    streetViews: streetViews,
    switchOffers: switchOffers
  }), AccommodationView_jsx(RefreshProposalModal, {
    refreshedProposal: refreshedProposal,
    resort: resort,
    selectedProposal: selectedProposal
  }));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: ./src/client/components/utils/booking/booking-additional-services/BookingAddtionalServices.utils.js
var BookingAddtionalServices_utils = __webpack_require__("JOeK");

// EXTERNAL MODULE: ./src/client/tracking/events/be.tracking.js
var be_tracking = __webpack_require__("fXWa");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// EXTERNAL MODULE: ./src/client/components/widgets/activities-categories/ActivitiesCategories.jsx + 2 modules
var ActivitiesCategories = __webpack_require__("RO1R");

// EXTERNAL MODULE: ./src/client/components/widgets/activities-thematics/ActivitiesThematics.jsx + 1 modules
var ActivitiesThematics = __webpack_require__("rNwk");

// EXTERNAL MODULE: ./src/client/components/widgets/rentals-cta/RentalsCta.jsx
var RentalsCta = __webpack_require__("38qS");

// EXTERNAL MODULE: ./src/client/components/utils/layers/layers.constants.js
var layers_constants = __webpack_require__("RDfq");

// EXTERNAL MODULE: ./src/hooks/use-layer/useLayer.js
var useLayer = __webpack_require__("1CQ+");

// EXTERNAL MODULE: ./src/client/components/frameworks/badge/Badge.jsx + 1 modules
var Badge = __webpack_require__("VHif");

// EXTERNAL MODULE: ./src/client/components/frameworks/scrollable/Scrollable.jsx + 1 modules
var Scrollable = __webpack_require__("cVnM");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx
var Text = __webpack_require__("qqKu");

// CONCATENATED MODULE: ./src/client/components/widgets/ski-package-reassurance/SkiPackageReassurance.jsx

var SkiPackageReassurance_jsx = react_default.a.createElement;














var SkiPackageReassurance_SkiPackageReassurance = function SkiPackageReassurance(_ref) {
  var className = _ref.className,
      _ref$hasRentals = _ref.hasRentals,
      hasRentals = _ref$hasRentals === void 0 ? false : _ref$hasRentals;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var _useLayer = Object(useLayer["a" /* useLayer */])(layers_constants["h" /* LAYER_NAME_UPSELL_RENTALS */]),
      nextUri = _useLayer.nextUri;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var items = [{
    title: Object(src_i18n["h" /* t */])('booking.activities.skiPackage.skiPass'),
    text: Object(src_i18n["h" /* t */])('booking.activities.skiPackage.skiPassDescription')
  }, {
    title: Object(src_i18n["h" /* t */])('booking.activities.skiPackage.groupLessons'),
    text: Object(src_i18n["h" /* t */])('booking.activities.skiPackage.groupLessonsDescription')
  }];
  return isTablet ? SkiPackageReassurance_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('overflow-hidden rounded-12 bg-white p-20 shadow', className)
  }, SkiPackageReassurance_jsx(Title["a" /* Title */], {
    className: "mb-10",
    hLevel: 3,
    theme: "title-brand-n3"
  }, Object(src_i18n["h" /* t */])('booking.activities.skiPackage.title')), items.map(function (_ref2, i) {
    var text = _ref2.text,
        title = _ref2.title;
    return SkiPackageReassurance_jsx("div", {
      className: Object(classnames_utils["a" /* classnames */])('py-15', {
        'border-b-1 border-dashed': hasRentals || i !== items.length - 1
      }),
      key: title
    }, SkiPackageReassurance_jsx(Title["a" /* Title */], {
      className: "mb-5 !items-center",
      theme: "title-sans-n2"
    }, SkiPackageReassurance_jsx(Badge["a" /* Badge */], {
      className: "size-28",
      iconName: icons["a" /* ICONS */].SKI,
      variant: "pill"
    }), title, SkiPackageReassurance_jsx("span", {
      className: "ms-auto font-brand text-12 text-green"
    }, Object(src_i18n["h" /* t */])('common.included'))), SkiPackageReassurance_jsx(Text["a" /* Text */], {
      text: text,
      theme: "text-sans-n1"
    }));
  }), hasRentals && SkiPackageReassurance_jsx(DynamicLink["a" /* default */], {
    className: "block text-center",
    onClick: function onClick() {
      return trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_ACTIVITIES, {
        detail_click: 'right_sidebar'
      });
    },
    shallow: true,
    url: nextUri
  }, SkiPackageReassurance_jsx(Badge["a" /* Badge */], {
    className: "mt-15 size-30 border-grey bg-white text-grey",
    iconName: icons["a" /* ICONS */].SKI_EQUIPMENTS,
    variant: "pill"
  }), SkiPackageReassurance_jsx(Text["a" /* Text */], {
    className: "mb-5",
    text: Object(src_i18n["h" /* t */])('booking.activities.skiEquipment.description'),
    theme: "text-sans-n1"
  }), SkiPackageReassurance_jsx("p", {
    className: "text-14 text-black underline"
  }, Object(src_i18n["h" /* t */])('booking.activities.skiEquipment.chooseCTA')))) : SkiPackageReassurance_jsx(Scrollable["a" /* Scrollable */], {
    className: Object(classnames_utils["a" /* classnames */])('-mx-20', className)
  }, SkiPackageReassurance_jsx("div", {
    className: "flex p-10"
  }, items.map(function (_ref3) {
    var text = _ref3.text,
        title = _ref3.title;
    return SkiPackageReassurance_jsx("div", {
      className: "last:scroll-x-ghost-m-20 last:scroll-x-ghost-m mx-10 w-[calc(100vw-60px)] flex-none rounded-12 bg-white p-10 shadow",
      key: title
    }, SkiPackageReassurance_jsx(Title["a" /* Title */], {
      className: "mb-5 !items-center",
      theme: "title-sans-n2"
    }, SkiPackageReassurance_jsx(Badge["a" /* Badge */], {
      className: "size-28",
      iconName: icons["a" /* ICONS */].SKI,
      variant: "pill"
    }), title, SkiPackageReassurance_jsx("span", {
      className: "ms-auto font-brand text-12 text-green"
    }, Object(src_i18n["h" /* t */])('common.included'))), SkiPackageReassurance_jsx(Text["a" /* Text */], {
      text: text,
      theme: "text-sans-n1"
    }));
  })));
};
// EXTERNAL MODULE: ./src/client/components/widgets/activities-booking/ActivitiesBooking.jsx
var ActivitiesBooking = __webpack_require__("5YQs");

// CONCATENATED MODULE: ./src/client/components/widgets/activities-booking/ProposalActivitiesBooking.jsx













var ProposalActivitiesBooking_jsx = react_default.a.createElement;

function ProposalActivitiesBooking_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ProposalActivitiesBooking_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ProposalActivitiesBooking_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ProposalActivitiesBooking_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }























var ProposalActivitiesBooking_ProposalActivitiesBooking = function ProposalActivitiesBooking(_ref) {
  var categories = _ref.categories,
      hasRentals = _ref.hasRentals,
      proposals = _ref.proposals,
      resort = _ref.resort,
      selectedProposal = _ref.selectedProposal,
      thematics = _ref.thematics,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["categories", "hasRentals", "proposals", "resort", "selectedProposal", "thematics"]);

  var _useState = Object(react["useState"])(null),
      updateInfo = _useState[0],
      setUpdateInfo = _useState[1];

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var dispatch = Object(es["d" /* useDispatch */])();

  var _useSelector = Object(es["e" /* useSelector */])(attendees_selector["c" /* selectAttendeesWithInfosByHouseholds */]),
      attendeesWithInfos = _useSelector.attendees;

  var track = Object(useTracking["a" /* useTracking */])(be_tracking["a" /* TRACK_BE_EVENT_GA_ACTIVITIES */]);
  Object(react["useEffect"])(function () {
    var timer;

    if (updateInfo) {
      timer = setTimeout(function () {
        return setUpdateInfo(null);
      }, BookingAddtionalServices_utils["a" /* TOAST_DURATION */]);
    }

    return function () {
      return clearTimeout(timer);
    };
  }, [updateInfo]);
  var activitiesCategoriesWithAdditionnalServices = Object(BookingAddtionalServices_utils["i" /* mapActivitiesCategoriesWithAdditionnalServices */])(categories, selectedProposal.additionalServices.activities, {
    filtered: false
  });
  var activitiesThematicsWithAdditionnalServices = Object(BookingAddtionalServices_utils["i" /* mapActivitiesCategoriesWithAdditionnalServices */])(thematics, selectedProposal.additionalServices.activities, {
    filtered: false
  });
  return ProposalActivitiesBooking_jsx(ActivitiesBooking["a" /* ActivitiesBooking */], Object(esm_extends["a" /* default */])({}, rest, {
    categories: activitiesCategoriesWithAdditionnalServices,
    contextValue: {
      attendeesList: [].concat(Object(toConsumableArray["a" /* default */])(attendeesWithInfos.adults), Object(toConsumableArray["a" /* default */])(attendeesWithInfos.children.map(function (child) {
        return ProposalActivitiesBooking_objectSpread(ProposalActivitiesBooking_objectSpread({}, child), {}, {
          isChild: true
        });
      }))),
      availableActivities: selectedProposal.additionalServices.activities,
      currency: selectedProposal.price.currency,
      dates: {
        arrivalDate: moment_default()(selectedProposal.arrivalDate, apiDate["a" /* API_DATE_FORMAT */]).valueOf(),
        departureDate: moment_default()(selectedProposal.departureDate, apiDate["a" /* API_DATE_FORMAT */]).valueOf()
      },
      isPriceForAdultOnly: true,
      hasRentals: hasRentals,
      scheduleReservationMessage: Object(src_i18n["h" /* t */])('booking.activities.sportActivities.changeSchedule'),
      setUpdateInfo: setUpdateInfo,
      trackingData: be_tracking["a" /* TRACK_BE_EVENT_GA_ACTIVITIES */],
      updateInfo: updateInfo,
      updateService: function updateService(attendees, pricingInfo, serviceIds, attendeeIds) {
        var info = {
          itemsNumber: attendees.length,
          message: attendees.length ? Object(src_i18n["h" /* t */])('booking.activities.newActivityAdded') : Object(src_i18n["h" /* t */])('booking.activities.newActivityRemoved')
        };

        if (attendees.length === 0) {
          return dispatch(Object(proposals_action["g" /* deleteAdditionalServices */])({
            appContext: appContext,
            attendeeIds: attendeeIds,
            serviceIds: serviceIds,
            showNotification: true
          })).then(function () {
            return setUpdateInfo(info);
          });
        }

        return dispatch(Object(proposals_action["d" /* addOrReplaceAdditionalServices */])({
          appContext: appContext,
          attendees: attendees,
          showNotification: true
        })).then(function () {
          return setUpdateInfo(info);
        }).catch(function (error) {
          return Object(BookingEngine_utils["i" /* trackErrorOnAddService */])(error, track, 'RENTAL_NOT_FOUND');
        });
      },
      showRentAllSchedules: true
    },
    thematics: activitiesThematicsWithAdditionnalServices
  }), ProposalActivitiesBooking_jsx("div", {
    className: "justify-between md:flex"
  }, resort.isWinter && ProposalActivitiesBooking_jsx("aside", {
    className: "order-1 mb-20 md:mb-0 md:w-1/4",
    "data-testid": "Activities-asideText"
  }, ProposalActivitiesBooking_jsx(SkiPackageReassurance_SkiPackageReassurance, {
    hasRentals: hasRentals
  })), ProposalActivitiesBooking_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('flex flex-col gap-20', {
      'md:w-2/3': resort.isWinter
    }),
    "data-testid": "activities-rentals"
  }, hasRentals && ProposalActivitiesBooking_jsx(RentalsCta["a" /* RentalsCta */], {
    className: "h-310",
    onClick: function onClick() {
      return track(be_tracking["b" /* TRACK_CLICK_EVENT_BE_RENTALS */]);
    }
  }), ProposalActivitiesBooking_jsx(ActivitiesCategories["a" /* ActivitiesCategories */], Object(esm_extends["a" /* default */])({}, rest, {
    categories: activitiesCategoriesWithAdditionnalServices,
    colsNumber: resort.isWinter && isDesktop ? 4 : 6,
    hasCounters: true,
    hasOnlineBookableCount: true,
    onClickCard: function onClickCard(type, hasOnlineBooking) {
      trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_ACTIVITIES, {
        detail_click: 'cards',
        availability: hasOnlineBooking ? 'yes' : 'no',
        activity_type: type === null || type === void 0 ? void 0 : type.toLowerCase()
      });
    }
  })))), activitiesThematicsWithAdditionnalServices.length > 0 && ProposalActivitiesBooking_jsx("div", {
    className: "mt-40"
  }, ProposalActivitiesBooking_jsx("p", {
    className: "mb-10 text-16 text-mediumGrey",
    "data-testid": "Activites-title"
  }, Object(src_i18n["h" /* t */])('common.activities.findYourThematic')), ProposalActivitiesBooking_jsx(Title["a" /* Title */], {
    className: "mb-20",
    theme: "title-brand-n3"
  }, Object(src_i18n["h" /* t */])('common.activities.thematicTitle')), ProposalActivitiesBooking_jsx(ActivitiesThematics["a" /* ActivitiesThematics */], Object(esm_extends["a" /* default */])({}, rest, {
    hasCounters: true,
    isProposal: true,
    thematics: activitiesThematicsWithAdditionnalServices
  }))));
};
// CONCATENATED MODULE: ./src/client/tracking/tracking-api/useBETracking.js









function useBETracking_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function useBETracking_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? useBETracking_ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : useBETracking_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}




var useBETracking_useBETracking = function useBETracking() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var options = {
    categoryGA: 'bookingEngine'
  };
  var track = Object(useTracking["a" /* useTracking */])(Object(utils["d" /* formatPayload */])(payload, options));
  return function (p) {
    return track(useBETracking_objectSpread(useBETracking_objectSpread({}, booking_constants["c" /* BE_GA_DEFAULT_PAYLOAD */]), Object(utils["d" /* formatPayload */])(p, options)));
  };
};
// EXTERNAL MODULE: ./src/client/components/widgets/rentals-booking/RentalsBooking.jsx
var RentalsBooking = __webpack_require__("OTqw");

// CONCATENATED MODULE: ./src/client/components/widgets/rentals-booking/ProposalRentalsBooking.jsx













var ProposalRentalsBooking_jsx = react_default.a.createElement;

function ProposalRentalsBooking_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ProposalRentalsBooking_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ProposalRentalsBooking_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ProposalRentalsBooking_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












var ProposalRentalsBooking_ProposalRentalsBooking = function ProposalRentalsBooking(_ref) {
  var _selectedProposal$add, _selectedProposal$add2;

  var proposals = _ref.proposals,
      rentals = _ref.rentals,
      selectedProposal = _ref.selectedProposal,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["proposals", "rentals", "selectedProposal"]);

  var _useState = Object(react["useState"])(null),
      updateInfo = _useState[0],
      setUpdateInfo = _useState[1];

  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var dispatch = Object(es["d" /* useDispatch */])();
  var track = useBETracking_useBETracking();

  var _useSelector = Object(es["e" /* useSelector */])(attendees_selector["c" /* selectAttendeesWithInfosByHouseholds */]),
      attendeesWithInfos = _useSelector.attendees;

  Object(react["useEffect"])(function () {
    var timer;

    if (updateInfo) {
      timer = setTimeout(function () {
        return setUpdateInfo(null);
      }, BookingAddtionalServices_utils["a" /* TOAST_DURATION */]);
    }

    return function () {
      return clearTimeout(timer);
    };
  }, [updateInfo]);
  var contextValue = Object(react["useMemo"])(function () {
    return {
      attendeesList: [].concat(Object(toConsumableArray["a" /* default */])(attendeesWithInfos.adults), Object(toConsumableArray["a" /* default */])(attendeesWithInfos.children.map(function (child) {
        return ProposalRentalsBooking_objectSpread(ProposalRentalsBooking_objectSpread({}, child), {}, {
          isChild: true
        });
      }))),
      currency: selectedProposal.price.currency,
      hideAgeServiceSlot: true,
      setUpdateInfo: setUpdateInfo,
      showRentAllSchedules: true,
      trackingData: be_tracking["a" /* TRACK_BE_EVENT_GA_ACTIVITIES */],
      updateInfo: updateInfo,
      updateService: function updateService(attendees, pricingInfo, serviceIds, attendeeIds) {
        var info = {
          itemsNumber: attendees.length,
          message: attendees.length ? Object(src_i18n["h" /* t */])('booking.activities.skiEquipment.newEquipmentAdded') : Object(src_i18n["h" /* t */])('booking.activities.skiEquipment.newEquipmentRemoved')
        };

        if (attendees.length === 0) {
          return dispatch(Object(proposals_action["g" /* deleteAdditionalServices */])({
            showNotification: true,
            serviceIds: serviceIds,
            attendeeIds: attendeeIds,
            appContext: appContext
          })).then(function () {
            return setUpdateInfo(info);
          });
        }

        return dispatch(Object(proposals_action["d" /* addOrReplaceAdditionalServices */])({
          showNotification: true,
          attendees: attendees,
          appContext: appContext
        })).then(function () {
          return setUpdateInfo(info);
        }).catch(function (error) {
          return Object(BookingEngine_utils["i" /* trackErrorOnAddService */])(error, track, 'RENTAL_NOT_FOUND');
        });
      }
    };
  }, [appContext, attendeesWithInfos, selectedProposal, updateInfo]);

  if ((selectedProposal === null || selectedProposal === void 0 ? void 0 : (_selectedProposal$add = selectedProposal.additionalServices) === null || _selectedProposal$add === void 0 ? void 0 : (_selectedProposal$add2 = _selectedProposal$add.rentals) === null || _selectedProposal$add2 === void 0 ? void 0 : _selectedProposal$add2.length) === 0) {
    return null;
  }

  var rentalsWithAdditionnalServices = Object(BookingAddtionalServices_utils["j" /* mapRentalsWithAdditionnalServices */])(rentals, selectedProposal.additionalServices.rentals, {
    filtered: true
  });
  return ProposalRentalsBooking_jsx(RentalsBooking["a" /* RentalsBooking */], Object(esm_extends["a" /* default */])({}, rest, {
    contextValue: contextValue,
    rentals: rentalsWithAdditionnalServices
  }));
};
// EXTERNAL MODULE: ./src/client/components/widgets/booking-navbar/BookingNavbarContext.jsx
var BookingNavbarContext = __webpack_require__("4ryf");

// CONCATENATED MODULE: ./src/client/views/booking/activities/ActivitiesView.jsx

var ActivitiesView_jsx = react_default.a.createElement;









var ActivitiesView_ActivitiesView = function ActivitiesView(_ref) {
  var _resort$rentalsTree;

  var infoBannerData = _ref.infoBannerData,
      proposals = _ref.proposals,
      resort = _ref.resort,
      selectedProposal = _ref.selectedProposal;

  var _useBookingNavbarCont = Object(BookingNavbarContext["b" /* useBookingNavbarContext */])(),
      navbarRef = _useBookingNavbarCont.navbarRef;

  var hasRentals = Boolean(resort === null || resort === void 0 ? void 0 : (_resort$rentalsTree = resort.rentalsTree) === null || _resort$rentalsTree === void 0 ? void 0 : _resort$rentalsTree.length);
  Object(useBookingNavbar["a" /* useBookingNavbar */])({
    noEdit: false,
    portalPosition: Portal_constants["b" /* AFTER_APP */],
    navbarRef: navbarRef
  });
  return ActivitiesView_jsx(react["Fragment"], null, Object(infoBanner_utils["a" /* renderInfoBanner */])({
    infoBannerData: infoBannerData,
    departureDate: selectedProposal.departureDate,
    arrivalDate: selectedProposal.arrivalDate,
    currentStep: 'activities'
  }), ActivitiesView_jsx(Title["a" /* Title */], {
    className: "mb-30",
    dataTestId: "Activities-title",
    theme: "title-brand-n2"
  }, Object(src_i18n["h" /* t */])('common.activities.activitiesUpsellTitle', {
    productName: resort === null || resort === void 0 ? void 0 : resort.name
  })), hasRentals && ActivitiesView_jsx(ProposalRentalsBooking_ProposalRentalsBooking, {
    className: "mb-20",
    "data-testid": "rentals",
    forwardRef: navbarRef,
    proposals: proposals,
    rentals: resort.rentalsTree,
    selectedProposal: selectedProposal
  }), ActivitiesView_jsx(ProposalActivitiesBooking_ProposalActivitiesBooking, {
    categories: resort.activityTree,
    forwardRef: navbarRef,
    hasRentals: hasRentals,
    proposals: proposals,
    resort: resort,
    selectedProposal: selectedProposal,
    thematics: resort.thematicActivityTree
  }));
};
// EXTERNAL MODULE: ./src/client/components/widgets/payment-info/PaymentInfo.jsx + 48 modules
var PaymentInfo = __webpack_require__("yzIS");

// EXTERNAL MODULE: ./src/client/components/widgets/payment-info/PaymentInfoContext.js
var PaymentInfoContext = __webpack_require__("lr0Z");

// EXTERNAL MODULE: ./src/client/views/booking/banking/Reassurance.jsx
var Reassurance = __webpack_require__("oGbU");

// EXTERNAL MODULE: ./src/client/views/booking/banking/FailedPaymentModal.jsx
var FailedPaymentModal = __webpack_require__("2dnA");

// EXTERNAL MODULE: ./src/client/views/booking/banking/PaidBankingFormContent.jsx
var PaidBankingFormContent = __webpack_require__("S4CH");

// EXTERNAL MODULE: ./src/client/views/booking/banking/useBankingView.jsx + 1 modules
var useBankingView = __webpack_require__("sZKc");

// CONCATENATED MODULE: ./src/client/views/booking/banking/BankingView.jsx
var BankingView_jsx = react_default.a.createElement;












var BankingView_BankingView = function BankingView(_ref) {
  var i18n = _ref.i18n,
      selectedProposal = _ref.selectedProposal,
      _ref$additionalProvid = _ref.additionalProviders,
      additionalProviders = _ref$additionalProvid === void 0 ? [] : _ref$additionalProvid,
      resort = _ref.resort,
      infoBannerData = _ref.infoBannerData,
      attendeesPaymentStatus = _ref.attendeesPaymentStatus;

  var _useBankingView = Object(useBankingView["a" /* useBankingView */])({
    selectedProposal: selectedProposal,
    additionalProviders: additionalProviders,
    resort: resort,
    attendeesPaymentStatus: attendeesPaymentStatus
  }),
      openFailedPaymentModal = _useBankingView.openFailedPaymentModal,
      handleFailedPaymentModalClose = _useBankingView.handleFailedPaymentModalClose,
      paymentInfoValue = _useBankingView.paymentInfoValue,
      hasBasePaymentData = _useBankingView.hasBasePaymentData,
      hasPaid = _useBankingView.hasPaid,
      paymentProvidersWithValidMethods = _useBankingView.paymentProvidersWithValidMethods,
      household = _useBankingView.household,
      payingHousehold = _useBankingView.payingHousehold;

  return BankingView_jsx(react["Fragment"], null, Object(infoBanner_utils["a" /* renderInfoBanner */])({
    infoBannerData: infoBannerData,
    departureDate: selectedProposal.departureDate,
    arrivalDate: selectedProposal.arrivalDate,
    currentStep: 'banking'
  }), BankingView_jsx(SimpleNotification["a" /* SimpleNotification */], {
    id: "BankingViewInformations",
    content: Object(src_i18n["h" /* t */])('booking.banking.paymentEmergency'),
    iconName: icons["a" /* ICONS */].CLOCK_SPEED,
    className: "mb-20"
  }), openFailedPaymentModal && BankingView_jsx(FailedPaymentModal["a" /* FailedPaymentModal */], {
    onClose: handleFailedPaymentModalClose
  }), BankingView_jsx(PaymentInfoContext["b" /* PaymentInfoProvider */], {
    value: paymentInfoValue
  }, hasBasePaymentData ? BankingView_jsx("div", {
    className: "flex flex-wrap justify-between"
  }, BankingView_jsx("div", {
    className: "xs:w-full px-5 md:w-full"
  }, hasPaid ? BankingView_jsx(PaidBankingFormContent["a" /* PaidBankingFormContent */], null) : BankingView_jsx(PaymentInfo["a" /* PaymentInfo */], {
    i18n: i18n,
    paymentProviders: paymentProvidersWithValidMethods // $FlowFixMe flow can't understand that at this point there is always a paymentSchedule
    ,
    paymentSchedule: household.paymentSchedule,
    price: household.paymentSchedule.total,
    payingHousehold: payingHousehold
  }))) : null), BankingView_jsx(Reassurance["a" /* Reassurance */], {
    className: "mt-20",
    i18n: i18n
  }));
};


// EXTERNAL MODULE: ./src/client/session-storage-api/sessionStorageApi.js
var sessionStorageApi = __webpack_require__("9NGo");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__("tVqn");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/pick.js
var pick = __webpack_require__("//nZ");
var pick_default = /*#__PURE__*/__webpack_require__.n(pick);

// EXTERNAL MODULE: /opt/webapp/node_modules/formik/dist/formik.esm.js + 76 modules
var formik_esm = __webpack_require__("ljKo");

// EXTERNAL MODULE: /opt/webapp/node_modules/crypto-js/index.js
var crypto_js = __webpack_require__("wIp5");
var crypto_js_default = /*#__PURE__*/__webpack_require__.n(crypto_js);

// EXTERNAL MODULE: ./src/client/components/frameworks/form-feedback/FormFeedback.jsx
var FormFeedback = __webpack_require__("DwNm");

// EXTERNAL MODULE: ./src/client/store/user-info/userInfo.selectors.js
var userInfo_selectors = __webpack_require__("apzf");

// EXTERNAL MODULE: ./src/client/store/validation-schema/validationSchema.selectors.js
var validationSchema_selectors = __webpack_require__("PwcU");

// EXTERNAL MODULE: ./src/client/context/OptinsProvider.js
var OptinsProvider = __webpack_require__("H8tl");

// EXTERNAL MODULE: /opt/webapp/node_modules/lz-string/libs/lz-string.js
var lz_string = __webpack_require__("O2W8");

// EXTERNAL MODULE: ./src/client/components/frameworks/formik/ScrollToErrorHook.js
var ScrollToErrorHook = __webpack_require__("I7/a");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("jQ/y");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.entries.js
var es_object_entries = __webpack_require__("ZVkB");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.from-entries.js
var es_object_from_entries = __webpack_require__("6LKR");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.starts-with.js
var es_string_starts_with = __webpack_require__("3voH");

// EXTERNAL MODULE: ./src/client/components/frameworks/capsule/Capsule.jsx + 1 modules
var Capsule = __webpack_require__("jldR");

// EXTERNAL MODULE: ./src/client/components/frameworks/formik/FormikInput.jsx + 13 modules
var FormikInput = __webpack_require__("/HC4");

// EXTERNAL MODULE: ./src/client/components/frameworks/text-see-more/TextSeeMore.jsx
var TextSeeMore = __webpack_require__("VBBE");

// EXTERNAL MODULE: ./src/client/components/widgets/contact-info/ContactInfoUtils.js + 2 modules
var ContactInfoUtils = __webpack_require__("ZHrn");

// CONCATENATED MODULE: ./src/client/components/widgets/contact-info/contact-info-form/MultiCGUBlock.jsx























var MultiCGUBlock_jsx = react_default.a.createElement;

function MultiCGUBlock_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function MultiCGUBlock_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { MultiCGUBlock_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { MultiCGUBlock_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable react/prefer-exact-props */








 // types

// CGU ITEM
var MultiCGUBlock_CGUItem = function CGUItem(_ref) {
  var cguItem = _ref.cguItem,
      i18n = _ref.i18n;
  var formik = Object(formik_esm["e" /* useFormikContext */])();
  return MultiCGUBlock_jsx("div", {
    className: "mb-20",
    "data-testid": "multiCGUBlock-cguItem"
  }, MultiCGUBlock_jsx("div", {
    className: "mb-10 text-20 font-bold text-saffron"
  }, cguItem.title), MultiCGUBlock_jsx("div", {
    className: "mb-10 whitespace-pre-wrap text-black"
  }, cguItem.description), MultiCGUBlock_jsx(FormikInput["a" /* FormikInput */], {
    label: i18n.booking.participants.agreeButton,
    name: "adults.0.optinsCGU.".concat(cguItem.id, ".optin"),
    type: "checkbox",
    additionnalClasses: "text-16",
    onChange: function onChange() {
      var _formik$values$adults, _formik$values$adults2;

      formik.setFieldValue("adults.0.optinsCGU.".concat(cguItem.id), {
        channel: cguItem.id,
        optin: !((_formik$values$adults = formik.values.adults[0].optinsCGU) === null || _formik$values$adults === void 0 ? void 0 : (_formik$values$adults2 = _formik$values$adults[cguItem.id]) === null || _formik$values$adults2 === void 0 ? void 0 : _formik$values$adults2.optin),
        optin_partners: false
      });
    },
    validate: Object(ContactInfoUtils["k" /* getLegalAgreementValidator */])(),
    isRequired: cguItem.required
  }));
}; // MULTICGUs BLOCK


var MultiCGUBlock_MultiCGUBlock = function MultiCGUBlock(_ref2) {
  var _formik$values$adults6;

  var i18n = _ref2.i18n,
      idsCGU = _ref2.idsCGU;
  var formik = Object(formik_esm["e" /* useFormikContext */])();
  var CGUs = i18n.bookingProcess; // filter the CGU to show in the block ( omitting phone/mail optin ... )

  var desiredCGUS = CGUs === null || CGUs === void 0 ? void 0 : CGUs.filter(function (cguItem) {
    return idsCGU.includes(cguItem.id);
  });
  Object(react["useEffect"])(function () {
    if (desiredCGUS.length > 0) {
      var initialOptins = desiredCGUS.reduce(function (acc, cguItem) {
        if (cguItem.required) {
          acc[cguItem.id] = {
            channel: cguItem.id,
            optin: cguItem.preChecked || false,
            optin_partners: false
          };
        }

        return acc;
      }, {});
      formik.setFieldValue('adults.0.optinsCGU', initialOptins);
    }
  }, []);
  Object(react["useEffect"])(function () {
    var _formik$values$adults3, _formik$values$adults4, _formik$values$adults5;

    var optins = ((_formik$values$adults3 = formik.values.adults) === null || _formik$values$adults3 === void 0 ? void 0 : (_formik$values$adults4 = _formik$values$adults3[0]) === null || _formik$values$adults4 === void 0 ? void 0 : _formik$values$adults4.optinsCGU) || {}; // $FlowFixMe - we know optins is an object with .optin booleans

    var allChecked = Object.values(optins).every(function (item) {
      return (item === null || item === void 0 ? void 0 : item.optin) === true;
    });

    if (((_formik$values$adults5 = formik.values.adults[0]) === null || _formik$values$adults5 === void 0 ? void 0 : _formik$values$adults5.checkAll) !== allChecked) {
      formik.setFieldValue('adults.0.checkAll', allChecked);
    }
  }, [(_formik$values$adults6 = formik.values.adults[0]) === null || _formik$values$adults6 === void 0 ? void 0 : _formik$values$adults6.optinsCGU]);

  var checkAll = function checkAll(e) {
    var _formik$values$adults7, _formik$values$adults8;

    var isChecked = e.currentTarget.checked;
    var currentOptins = ((_formik$values$adults7 = formik.values.adults) === null || _formik$values$adults7 === void 0 ? void 0 : (_formik$values$adults8 = _formik$values$adults7[0]) === null || _formik$values$adults8 === void 0 ? void 0 : _formik$values$adults8.optinsCGU) || {};
    var updatedOptins = Object.fromEntries(Object.entries(currentOptins).map(function (_ref3) {
      var _ref4 = Object(slicedToArray["a" /* default */])(_ref3, 2),
          key = _ref4[0],
          value = _ref4[1];

      return [key, MultiCGUBlock_objectSpread(MultiCGUBlock_objectSpread({}, value), {}, {
        optin: isChecked
      })];
    }));
    formik.setFieldValue('adults.0.optinsCGU', updatedOptins);
    formik.setFieldValue('adults.0.checkAll', isChecked);
  };

  if (desiredCGUS.length > 1) {
    return MultiCGUBlock_jsx("div", {
      className: "mt-10 text-12",
      "data-testid": "multiCGUBlock-checkAll"
    }, MultiCGUBlock_jsx(Capsule["a" /* Capsule */], {
      header: "none",
      additionalStyle: {
        content: {
          padding: '1.25rem'
        }
      }
    }, MultiCGUBlock_jsx(FormikInput["a" /* FormikInput */], {
      additionnalClasses: "text-18 mb-10",
      className: "text-18 text-black",
      label: i18n.booking.participants.agreeAll,
      name: "adults.0.checkAll",
      onChange: checkAll,
      type: "checkbox"
    }), MultiCGUBlock_jsx("div", {
      className: "mb-10"
    }, i18n.booking.participants.personalDataIntroduction), desiredCGUS.map(function (desiredCGUItem, index) {
      return MultiCGUBlock_jsx(MultiCGUBlock_CGUItem, {
        key: "CGUItem-".concat(index + 1),
        cguItem: desiredCGUItem,
        i18n: i18n
      });
    }), MultiCGUBlock_jsx("div", null, i18n.booking.participants.disagreePersonalDataCollection, MultiCGUBlock_jsx(DynamicLink["a" /* default */], {
      target: "_blank",
      url: i18n.booking.participants.personalDataCollectURL
    }, i18n.booking.participants.personalDataCollectLink))));
  } // Existant (EX : 1 GCU Russia CNIL)


  if (desiredCGUS.length === 1) {
    if (desiredCGUS[0].required) {
      var _uniqueCguItem$url;

      var uniqueCguItem = desiredCGUS[0];
      var cleanUrl = (uniqueCguItem === null || uniqueCguItem === void 0 ? void 0 : (_uniqueCguItem$url = uniqueCguItem.url) === null || _uniqueCguItem$url === void 0 ? void 0 : _uniqueCguItem$url.startsWith('http')) ? uniqueCguItem.url : "https://".concat(uniqueCguItem.url);
      return MultiCGUBlock_jsx("div", {
        className: "mt-10",
        "data-testid": "multiCGUBlock-cguItem"
      }, MultiCGUBlock_jsx(Title["a" /* Title */], {
        className: "mb-10",
        theme: "title-brand-n2"
      }, uniqueCguItem.label), MultiCGUBlock_jsx(Capsule["a" /* Capsule */], {
        header: "none",
        className: "flex",
        additionalStyle: {
          content: {
            padding: '1.25rem'
          }
        }
      }, MultiCGUBlock_jsx("div", {
        className: "flex"
      }, MultiCGUBlock_jsx(FormikInput["a" /* FormikInput */], {
        isRequired: true,
        className: "flex-none p-20",
        name: "adults.0.optinsCGU.".concat(uniqueCguItem.id, ".optin"),
        type: "checkbox",
        onChange: function onChange() {
          var _formik$values$adults9, _formik$values$adults10;

          formik.setFieldValue("adults.0.optinsCGU.".concat(uniqueCguItem.id), {
            channel: uniqueCguItem.id,
            optin: !((_formik$values$adults9 = formik.values.adults[0].optinsCGU) === null || _formik$values$adults9 === void 0 ? void 0 : (_formik$values$adults10 = _formik$values$adults9[uniqueCguItem.id]) === null || _formik$values$adults10 === void 0 ? void 0 : _formik$values$adults10.optin),
            optin_partners: false
          });
        },
        validate: Object(ContactInfoUtils["k" /* getLegalAgreementValidator */])(),
        isFlex: false
      }), MultiCGUBlock_jsx("div", {
        className: "mb-10 whitespace-pre-wrap text-black"
      }, MultiCGUBlock_jsx("span", null, uniqueCguItem.description), MultiCGUBlock_jsx("br", null), cleanUrl && (uniqueCguItem === null || uniqueCguItem === void 0 ? void 0 : uniqueCguItem.urlLabel) && MultiCGUBlock_jsx("a", {
        href: cleanUrl,
        rel: "noopener noreferrer",
        target: "_blank"
      }, MultiCGUBlock_jsx("span", {
        className: "underline"
      }, uniqueCguItem.urlLabel))))));
    }

    return MultiCGUBlock_jsx("div", {
      className: "mt-10",
      "data-testid": "multiCGUBlock-cguItem"
    }, MultiCGUBlock_jsx("div", null, desiredCGUS[0].label), MultiCGUBlock_jsx(TextSeeMore["a" /* TextSeeMore */], {
      text: "".concat(desiredCGUS[0].description, " \n\n(2) ").concat(Object(src_i18n["h" /* t */])('booking.participants.subscription.condition')),
      theme: "text-sans-n2",
      seeMoreLabel: i18n.booking.participants.legalMessage.seeMoreLabel
    }));
  }

  return null;
};
// EXTERNAL MODULE: ./src/client/components/widgets/contact-info/constants.js
var contact_info_constants = __webpack_require__("ZOp8");

// EXTERNAL MODULE: ./src/client/components/frameworks/heading/Heading.jsx + 1 modules
var Heading = __webpack_require__("3jv5");

// EXTERNAL MODULE: ./src/client/components/widgets/user-info-summary/UserInfoSummary.jsx
var UserInfoSummary = __webpack_require__("RmUC");

// EXTERNAL MODULE: ./src/client/components/widgets/contact-info/contact-info-form/PersonInfoFormContent.jsx + 5 modules
var PersonInfoFormContent = __webpack_require__("DhzB");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-collapse/lib/index.js
var lib = __webpack_require__("3OwS");

// EXTERNAL MODULE: ./src/client/components/frameworks/toast/Toast.jsx
var Toast = __webpack_require__("0x7Y");

// EXTERNAL MODULE: ./src/client/components/utils/scroll/scrollToElement.js + 1 modules
var scrollToElement = __webpack_require__("RUiN");

// EXTERNAL MODULE: ./src/client/store/booking/travel-companion/travel-companion.reducer.js
var travel_companion_reducer = __webpack_require__("dGyR");

// CONCATENATED MODULE: ./src/client/store/booking/travel-companion/travel-companion.action.js


var travel_companion_action_addTravelCompanion = function addTravelCompanion(payload) {
  return Object(createAction["b" /* default */])(travel_companion_reducer["a" /* ADD_TRAVEL_COMPANION */], payload);
};
var travel_companion_action_editTravelCompanion = function editTravelCompanion(payload) {
  return Object(createAction["b" /* default */])(travel_companion_reducer["b" /* EDIT_TRAVEL_COMPANION */], payload);
};
var travel_companion_action_selectTravelCompanion = function selectTravelCompanion(payload) {
  return Object(createAction["b" /* default */])(travel_companion_reducer["c" /* SELECT_TRAVEL_COMPANION */], payload);
};
var travel_companion_action_unselectTravelCompanion = function unselectTravelCompanion(payload) {
  return Object(createAction["b" /* default */])(travel_companion_reducer["d" /* UNSELECT_TRAVEL_COMPANION */], payload);
};
// CONCATENATED MODULE: ./src/client/components/widgets/contact-info/contact-info-form/TravelCompanionBlock.themes.js
var TravelCompanionBlock_themes_themes = {
  selectable: function selectable(_ref) {
    var isHovering = _ref.isHovering;
    return {
      thRoot: "bg-white text-black duration-250 ease-in transition-all ".concat(isHovering ? 'border-grey' : 'border-white'),
      theNameLabel: ' text-black text-14 truncate w-full font-bold',
      theBirthdateLabel: ' text-black text-12 mb-10'
    };
  },
  selected: function selected() {
    return {
      thRoot: 'text-success border-success',
      theNameLabel: ' text-black text-14 truncate w-full font-bold',
      theBirthdateLabel: ' text-black text-12 mb-10'
    };
  },
  disabled: function disabled() {
    return {
      thRoot: 'text-mediumGrey border-mediumGrey pointer-events-none',
      theNameLabel: ' text-mediumGrey text-14 truncate w-full font-bold',
      theBirthdateLabel: ' text-mediumGrey text-12 mb-10'
    };
  },
  hidden: function hidden() {
    return {};
  }
};
// CONCATENATED MODULE: ./src/client/components/widgets/contact-info/contact-info-form/TravelCompanionBlock.jsx








var TravelCompanionBlock_jsx = react_default.a.createElement;

/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/click-events-have-key-events */














var STATUS = {
  SELECTED: 'selected',
  DISABLED: 'disabled',
  SELECTABLE: 'selectable',
  HIDDEN: 'hidden'
};

var TravelCompanionBlock_IconBlock = function IconBlock(_ref) {
  var status = _ref.status;

  if (status === STATUS.SELECTED) {
    return TravelCompanionBlock_jsx(Icon["a" /* Icon */], {
      name: icons["a" /* ICONS */].CHECK,
      width: "1.2em",
      className: "text-green"
    });
  }

  if (status === STATUS.DISABLED) {
    return TravelCompanionBlock_jsx("div", {
      className: "rounded-full border-1 border-mediumGrey p-5 leading-0"
    }, TravelCompanionBlock_jsx(Icon["a" /* Icon */], {
      className: "text-mediumGrey",
      name: icons["a" /* ICONS */].PLUS,
      width: "1.2em"
    }));
  }

  return TravelCompanionBlock_jsx("div", {
    className: "rounded-full border-1 border-saffron bg-saffron p-5 leading-0"
  }, TravelCompanionBlock_jsx(Icon["a" /* Icon */], {
    className: "text-black",
    name: icons["a" /* ICONS */].PLUS,
    width: "1.2em"
  }));
};

var TravelCompanionBlock_TravelCompanionBlock = function TravelCompanionBlock(_ref2) {
  var travelCompanion = _ref2.travelCompanion,
      isChild = _ref2.isChild,
      position = _ref2.position,
      parentIndex = _ref2.parentIndex,
      isDisabled = _ref2.isDisabled,
      setIsDisabled = _ref2.setIsDisabled,
      setShowCompanionForm = _ref2.setShowCompanionForm,
      clearAttendeeData = _ref2.clearAttendeeData,
      includedInSelectedIndexes = _ref2.includedInSelectedIndexes,
      attendeeIdentifier = _ref2.attendeeIdentifier;

  var _useState = Object(react["useState"])(false),
      isHovering = _useState[0],
      setIsHovering = _useState[1];

  var _useState2 = Object(react["useState"])(false),
      isFormDisplayed = _useState2[0],
      setIsFormDisplayed = _useState2[1];

  var dispatch = Object(es["d" /* useDispatch */])();

  var _useFormikContext = Object(formik_esm["e" /* useFormikContext */])(),
      values = _useFormikContext.values,
      setFieldValue = _useFormikContext.setFieldValue,
      setFieldTouched = _useFormikContext.setFieldTouched;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var companionId = travelCompanion.companionId,
      firstName = travelCompanion.firstName,
      lastName = travelCompanion.lastName,
      birthdate = travelCompanion.birthdate,
      isSelected = travelCompanion.isSelected;
  var isSelectedAndIncludedInSelectedIndexes = isSelected && includedInSelectedIndexes;

  var fillAttendeeWithCompanionData = function fillAttendeeWithCompanionData() {
    return Object(ContactInfoUtils["v" /* setTravelCompanionField */])({
      attendeeIdentifier: attendeeIdentifier,
      travelCompanion: travelCompanion,
      isChild: isChild,
      parentIndex: parentIndex,
      values: values,
      setFieldValue: setFieldValue
    });
  };

  var statusReducer = function statusReducer() {
    if (isSelectedAndIncludedInSelectedIndexes) {
      // setting attendee infos in form in order to generate an ID for API
      fillAttendeeWithCompanionData();
      return STATUS.SELECTED;
    }

    if (isSelected && !includedInSelectedIndexes) {
      return STATUS.HIDDEN;
    }

    if (isDisabled && !includedInSelectedIndexes) {
      return STATUS.DISABLED;
    }

    return STATUS.SELECTABLE;
  };

  var _useReducer = Object(react["useReducer"])(statusReducer, STATUS.SELECTABLE),
      status = _useReducer[0],
      updateStatus = _useReducer[1];

  Object(react["useEffect"])(function () {
    updateStatus();
  }, [isSelected, isDisabled]);
  Object(react["useEffect"])(function () {
    if (isFormDisplayed) {
      trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_PARTICIPANTS, {
        detail_click: 'see_more'
      });
      fillAttendeeWithCompanionData();
      setShowCompanionForm('EDIT');
    } else {
      setShowCompanionForm('');
    }
  }, [isFormDisplayed]);

  var handleSelection = function handleSelection() {
    if (status !== STATUS.DISABLED) {
      trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_PARTICIPANTS, {
        detail_click: isSelectedAndIncludedInSelectedIndexes ? 'remove_companion' : 'add_companion'
      });
      setIsDisabled === null || setIsDisabled === void 0 ? void 0 : setIsDisabled(true);

      if (isSelectedAndIncludedInSelectedIndexes) {
        dispatch(travel_companion_action_unselectTravelCompanion({
          companionId: companionId,
          parentIndex: parentIndex,
          position: position
        }));
        clearAttendeeData();
        setShowCompanionForm('');
      } else {
        var _fillAttendeeWithComp;

        dispatch(travel_companion_action_selectTravelCompanion({
          companionId: companionId,
          parentIndex: parentIndex,
          position: position
        }));
        (_fillAttendeeWithComp = fillAttendeeWithCompanionData()) === null || _fillAttendeeWithComp === void 0 ? void 0 : _fillAttendeeWithComp.then(function (newFormErrors) {
          var fieldErrorNames = Object.keys(get_default()(newFormErrors, attendeeIdentifier, {}));

          if (fieldErrorNames.length) {
            fieldErrorNames.forEach(function (fieldErrorName) {
              setFieldTouched("".concat(attendeeIdentifier, ".").concat(fieldErrorName), true);
            });
            setShowCompanionForm('EDIT');
          } else {
            Object(scrollToElement["a" /* scrollToElement */])("#attendee-".concat(parentIndex + 1), 500);
          }
        });
      }
    }
  };

  var shouldShowSeeMoreButton = (status === STATUS.SELECTABLE || status === STATUS.SELECTED) && !isChild;

  var _themes$status = TravelCompanionBlock_themes_themes[status]({
    isHovering: isHovering
  }),
      thRoot = _themes$status.thRoot,
      theNameLabel = _themes$status.theNameLabel,
      theBirthdateLabel = _themes$status.theBirthdateLabel;

  return TravelCompanionBlock_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('pe-20', {
      'order-first': status === STATUS.SELECTED
    }, {
      hidden: status === STATUS.HIDDEN
    }, {
      'pointer-events-none': isChild
    }),
    "data-testid": "TravelCompanion-".concat(status)
  }, TravelCompanionBlock_jsx("div", {
    "data-testid": "TravelCompanionBlock",
    onClick: handleSelection,
    className: Object(classnames_utils["a" /* classnames */])('flex w-full flex-col items-center rounded-12 border-1 border-solid bg-white p-10 text-center shadow-md', thRoot, 'h-140 w-120'),
    onMouseEnter: function onMouseEnter() {
      return setIsHovering(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsHovering(false);
    }
  }, TravelCompanionBlock_jsx("div", {
    className: "mb-15 flex h-30 flex-col items-center justify-end"
  }, TravelCompanionBlock_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].PEOPLE,
    width: isChild ? '1.375rem' : '1.8125rem',
    className: "text-current"
  })), TravelCompanionBlock_jsx("p", {
    "data-testid": "TravelCompanionBlockName",
    className: theNameLabel
  }, firstName + ' ' + lastName), TravelCompanionBlock_jsx("p", {
    className: theBirthdateLabel
  }, birthdate && moment_default()(birthdate).format(Object(src_i18n["h" /* t */])('booking.form.dateFormat'))), TravelCompanionBlock_jsx(TravelCompanionBlock_IconBlock, {
    status: status
  })), shouldShowSeeMoreButton && TravelCompanionBlock_jsx("button", {
    onClick: function onClick() {
      setIsDisabled === null || setIsDisabled === void 0 ? void 0 : setIsDisabled(true);
      setIsFormDisplayed(function (hidden) {
        return !hidden;
      });
    },
    className: "mx-auto block py-10 text-14 leading-tight underline",
    type: "button"
  }, isFormDisplayed ? Object(src_i18n["h" /* t */])('common.loadLess') : Object(src_i18n["h" /* t */])('booking.participants.seeMoreLabel')));
};
// CONCATENATED MODULE: ./src/client/components/widgets/contact-info/contact-info-form/PersonInfoForm.jsx

















var PersonInfoForm_jsx = react_default.a.createElement;

function PersonInfoForm_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function PersonInfoForm_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { PersonInfoForm_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { PersonInfoForm_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



















var PersonInfoForm_PersonInfoForm = function PersonInfoForm(_ref) {
  var _values$adults, _values$adults2;

  var parentIndex = _ref.parentIndex,
      isUserConnected = _ref.isUserConnected,
      isMain = _ref.isMain,
      isChild = _ref.isChild,
      personalInfoFormContent = _ref.personalInfoFormContent,
      attendeeIdentifier = _ref.attendeeIdentifier,
      setIsDisabled = _ref.setIsDisabled;

  var _useFormikContext = Object(formik_esm["e" /* useFormikContext */])(),
      errors = _useFormikContext.errors,
      values = _useFormikContext.values,
      setFieldValue = _useFormikContext.setFieldValue,
      setTouched = _useFormikContext.setTouched,
      setFieldTouched = _useFormikContext.setFieldTouched;

  var _useState = Object(react["useState"])(''),
      showCompanionForm = _useState[0],
      setShowCompanionForm = _useState[1];

  var _useState2 = Object(react["useState"])(false),
      isAdded = _useState2[0],
      setIsAdded = _useState2[1];

  var isValid = !get_default()(errors, attendeeIdentifier, false);
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var travelCompanionSelector = Object(es["e" /* useSelector */])(function (state) {
    return state.booking.travelCompanion;
  });

  var _getTravelCompanionIn = Object(ContactInfoUtils["o" /* getTravelCompanionInfos */])({
    travelCompanionSelector: travelCompanionSelector,
    isChild: isChild,
    parentIndex: parentIndex
  }),
      travelCompanionList = _getTravelCompanionIn.travelCompanionList,
      hasParentIndexInSelectedIndexes = _getTravelCompanionIn.hasParentIndexInSelectedIndexes,
      isDisabled = _getTravelCompanionIn.isDisabled;

  var travelCompanionIndex = isChild ? parentIndex - ((values === null || values === void 0 ? void 0 : (_values$adults = values.adults) === null || _values$adults === void 0 ? void 0 : _values$adults.length) || 0) : parentIndex;
  var formList = isChild ? values.children : values.adults;
  var valuesList = isChild ? values === null || values === void 0 ? void 0 : values.children : values === null || values === void 0 ? void 0 : (_values$adults2 = values.adults) === null || _values$adults2 === void 0 ? void 0 : _values$adults2.slice(1);
  var selectedCompanions = travelCompanionList.filter(function (_ref2) {
    var isSelected = _ref2.isSelected;
    return isSelected;
  });
  var selectedNumber = selectedCompanions.length;
  var notSelectedNumber = travelCompanionList.filter(function (_ref3) {
    var isSelected = _ref3.isSelected;
    return !isSelected;
  }).length;
  var showRegularForm = // In case we have the number of attendees greater than the travel companions
  // then we show the rest of those attendees to the old regular form block
  notSelectedNumber === 0 && selectedNumber < (valuesList === null || valuesList === void 0 ? void 0 : valuesList.length) && !hasParentIndexInSelectedIndexes;
  var shouldDisplayTravelCompanion = isUserConnected && Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.travelCompanions') && !showRegularForm;
  var dispatch = Object(es["d" /* useDispatch */])();
  var isCompanionAddForm = showCompanionForm === 'ADD';
  var shouldDisplayAddCompanionButton = showCompanionForm !== 'EDIT';

  var handleAddTravelCompanion = function handleAddTravelCompanion() {
    if (isValid) {
      var newCompanionId = travelCompanionSelector.list.length;

      var newTravelCompanion = PersonInfoForm_objectSpread(PersonInfoForm_objectSpread({}, formList.map(ContactInfoUtils["A" /* travelCompanionMapper */])[travelCompanionIndex]), {}, {
        companionId: newCompanionId,
        isSelected: true,
        isChild: isChild
      });

      dispatch(travel_companion_action_addTravelCompanion(newTravelCompanion));
      setIsAdded(true);
      setShowCompanionForm('');
      trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_PARTICIPANTS, {
        detail_click: 'validate_new_companion'
      }); // Select it immediatly after Adding it

      dispatch(travel_companion_action_selectTravelCompanion({
        companionId: newCompanionId,
        parentIndex: parentIndex,
        position: travelCompanionList.length
      }));
      Object(scrollToElement["a" /* scrollToElement */])("#attendee-".concat(parentIndex), 500);
    } else {
      Object(ContactInfoUtils["u" /* setTravelCompanionBlockFormErrors */])({
        errors: errors,
        isChild: isChild,
        travelCompanionIndex: travelCompanionIndex,
        setFieldTouched: setFieldTouched
      });
    }
  };

  var clearAttendeeData = function clearAttendeeData() {
    setTouched({});
    setFieldValue(attendeeIdentifier, isChild ? {} : {
      civility: 'MR'
    });
  };

  if (isMain || !shouldDisplayTravelCompanion) {
    return personalInfoFormContent;
  }

  return PersonInfoForm_jsx(react["Fragment"], null, isAdded && PersonInfoForm_jsx(Toast["a" /* Toast */], {
    color: colors["a" /* COLORS */].GREEN,
    icon: icons["a" /* ICONS */].CHECK_OUTLINE,
    label: Object(src_i18n["h" /* t */])('booking.participants.travelCompanion.adultAdded'),
    onClose: function onClose() {
      return setIsAdded(false);
    },
    visible: isAdded
  }), PersonInfoForm_jsx("div", {
    className: "max-w-[90vw] p-20"
  }, PersonInfoForm_jsx("div", {
    className: "mb-10"
  }, PersonInfoForm_jsx("p", {
    className: "mb-20 text-14 font-bold"
  }, !isChild ? Object(src_i18n["h" /* t */])('booking.participants.travelCompanion.selectAdult') : Object(src_i18n["h" /* t */])('booking.participants.travelCompanion.selectChildren')), PersonInfoForm_jsx(Scrollable["a" /* Scrollable */], {
    className: "-mx-20 flex border-b-1 border-grey",
    navPosition: "center"
  }, PersonInfoForm_jsx("div", {
    className: "flex flex-row p-10 px-20"
  }, travelCompanionList.map(function (attendee, index) {
    return PersonInfoForm_jsx(TravelCompanionBlock_TravelCompanionBlock, {
      travelCompanion: attendee,
      isChild: isChild,
      key: "".concat(((attendee === null || attendee === void 0 ? void 0 : attendee.id) || '').toString(), "+").concat(attendee.firstName, "+").concat(attendee.lastName),
      position: index,
      parentIndex: parentIndex,
      setIsDisabled: setIsDisabled,
      isDisabled: isDisabled,
      setShowCompanionForm: setShowCompanionForm,
      includedInSelectedIndexes: !!find_default()(travelCompanionSelector.selectedIndexes, {
        index: parentIndex,
        position: index
      }),
      attendeeIdentifier: attendeeIdentifier,
      clearAttendeeData: clearAttendeeData
    });
  })))), shouldDisplayAddCompanionButton && PersonInfoForm_jsx("div", {
    className: "flex justify-end pt-10"
  }, PersonInfoForm_jsx(Button["a" /* Button */], {
    iconLeft: {
      name: icons["a" /* ICONS */].PEOPLE
    },
    iconRight: {
      name: icons["a" /* ICONS */].ARROW_RIGHT,
      rotation: isCompanionAddForm ? 90 : 0,
      width: '0.875rem'
    },
    isDisabled: isDisabled,
    onClick: function onClick() {
      trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_PARTICIPANTS, {
        detail_click: 'add_new_companion'
      });
      setIsDisabled(false);
      setFieldValue(attendeeIdentifier, isChild ? {} : {
        civility: 'MR',
        document: {
          passport: {
            type: 'PASSPORT'
          },
          idcard: {
            type: 'IDCARD'
          }
        }
      });
      setShowCompanionForm(!showCompanionForm ? 'ADD' : '');
    },
    size: "small"
  }, Object(src_i18n["h" /* t */])('booking.participants.travelCompanion.newCompanion'))), PersonInfoForm_jsx(lib["Collapse"], {
    isOpened: showCompanionForm
  }, PersonInfoForm_jsx("div", {
    className: "-mx-20 mt-20"
  }, personalInfoFormContent), PersonInfoForm_jsx("div", {
    className: "flex justify-end"
  }, isCompanionAddForm && PersonInfoForm_jsx(Button["a" /* Button */], {
    className: "mt-10",
    onClick: handleAddTravelCompanion,
    isDisabled: false
  }, Object(src_i18n["h" /* t */])('booking.participants.travelCompanion.addNewCompanion'))))));
};
// EXTERNAL MODULE: ./src/client/components/widgets/contact-info/contact-info-form/PersonInfoUtils.js
var PersonInfoUtils = __webpack_require__("DROp");

// CONCATENATED MODULE: ./src/client/components/widgets/contact-info/contact-info-form/PersonInfo.jsx














var PersonInfo_jsx = react_default.a.createElement;

function PersonInfo_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function PersonInfo_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { PersonInfo_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { PersonInfo_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable no-lonely-if */





















var PersonInfo_CommonTitle = function CommonTitle(_ref) {
  var isMain = _ref.isMain,
      headerTitle = _ref.headerTitle,
      id = _ref.id;
  return PersonInfo_jsx("div", {
    className: "ml-20 mt-20"
  }, PersonInfo_jsx(Title["a" /* Title */], Object(esm_extends["a" /* default */])({
    id: "attendee-".concat(id),
    className: Object(classnames_utils["a" /* classnames */])('air360-replay-ignore', {
      'mb-10': isMain
    }),
    theme: "title-brand-n4"
  }, {
    'data-cs-mask': true
  }), headerTitle), isMain && PersonInfo_jsx("p", {
    className: "mb-10 text-14"
  }, Object(src_i18n["h" /* t */])('booking.participants.personnalInfosHeader.mainContactDescription')));
};

var PersonInfo_PersonInfo = function PersonInfo(_ref2) {
  var _i18n$account, _i18n$account$authent;

  var parentIndex = _ref2.parentIndex,
      isUserConnected = _ref2.isUserConnected,
      arrivalDate = _ref2.arrivalDate,
      attendeeIdentifier = _ref2.attendeeIdentifier,
      attendeeIndex = _ref2.attendeeIndex,
      connectedUserInfo = _ref2.connectedUserInfo,
      hasMainAttendeeErrors = _ref2.hasMainAttendeeErrors,
      hasPerformValidation = _ref2.hasPerformValidation,
      hasAddress = _ref2.hasAddress,
      i18n = _ref2.i18n,
      id = _ref2.id,
      isChild = _ref2.isChild,
      isMain = _ref2.isMain,
      listIdentifier = _ref2.listIdentifier;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var _useFormikContext = Object(formik_esm["e" /* useFormikContext */])(),
      values = _useFormikContext.values,
      errors = _useFormikContext.errors;

  var isQuickLogged = appContext.isUserQuickLogged;
  var loginUrl = isQuickLogged ? ple_utils["i" /* buildStepupUrl */]({
    redirectUri: dist["windowWrapper"].getLocation(),
    locale: appContext.locale
  }) : ple_utils["f" /* buildSigninUrl */]({
    redirectUri: dist["windowWrapper"].getLocation(),
    locale: appContext.locale
  });
  var isMiniaturizedLoginButton = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('participantPageConnection.miniaturizedButton');
  var attendeeSchema = Object(es["e" /* useSelector */])(Object(validationSchema_selectors["c" /* getAttendeeValidationSchemaByRole */])(isMain, isChild));
  var addressSchema = Object(es["e" /* useSelector */])(validationSchema_selectors["b" /* getAddressValidationSchema */]);

  var _useState = Object(react["useState"])(true),
      isExpandedMode = _useState[0],
      setIsExpandedMode = _useState[1];

  var _useState2 = Object(react["useState"])(false),
      isDisabled = _useState2[0],
      setIsDisabled = _useState2[1];

  var attendeeSchemaIndex = Object(ContactInfoUtils["c" /* findAlphabetIndex */])(id);
  var isValid = !get_default()(errors, attendeeIdentifier, false);
  var userLogged = appContext.isUserLogged;
  var displayMiniaturizedButton = !userLogged && (i18n === null || i18n === void 0 ? void 0 : (_i18n$account = i18n.account) === null || _i18n$account === void 0 ? void 0 : (_i18n$account$authent = _i18n$account.authenticated) === null || _i18n$account$authent === void 0 ? void 0 : _i18n$account$authent.greeting);
  var headerTitle = Object(ContactInfoUtils["i" /* getHeaderContactInfoTitle */])({
    attendeeIdentifier: attendeeIdentifier,
    attendeeIndex: attendeeIndex,
    hasUnicodeFields: Object(PersonInfoUtils["b" /* isSchemaHasUnicodeFields */])(attendeeSchema),
    formValues: values,
    isChild: isChild,
    isMain: isMain,
    isValid: isValid
  });
  Object(react["useEffect"])(function () {
    if (hasPerformValidation) {
      if (isMain) {
        setIsExpandedMode(hasMainAttendeeErrors);
      } else {
        if (isChild) {
          var isChildValid = !get_default()(errors, attendeeIdentifier, false);
          isChildValid ? setIsExpandedMode(false) : setIsExpandedMode(true);
        }
      }
    }
  }, [hasPerformValidation]);

  var personInfoFormContent = PersonInfo_jsx(PersonInfoFormContent["a" /* PersonInfoFormContent */], {
    arrivalDate: arrivalDate,
    addressSchema: addressSchema,
    attendeeSchema: attendeeSchema,
    attendeeIdentifier: attendeeIdentifier,
    connectedUserInfo: connectedUserInfo,
    hasAddress: hasAddress,
    i18n: i18n,
    id: id,
    isChild: isChild,
    isMain: isMain,
    isDisabled: isDisabled
  });

  return PersonInfo_jsx("div", {
    "data-testid": isMain ? 'main-participant-block' : 'other-participant-block'
  }, !isExpandedMode && !isEmpty_default()(connectedUserInfo) ? PersonInfo_jsx(react["Fragment"], null, PersonInfo_jsx(PersonInfo_CommonTitle, {
    headerTitle: headerTitle,
    isMain: isMain,
    id: attendeeSchemaIndex
  }), PersonInfo_jsx(UserInfoSummary["a" /* UserInfoSummary */], {
    onClickEdit: function onClickEdit() {
      setIsExpandedMode(true);
      trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_PARTICIPANTS, {
        detail_click: 'edit_main_traveler'
      });
    },
    user: PersonInfo_objectSpread(PersonInfo_objectSpread({}, get_default()(values, attendeeIdentifier)), {}, {
      mobilePhoneNumber: get_default()(values, attendeeIdentifier, {}).mobile
    })
  })) : PersonInfo_jsx(Capsule["a" /* Capsule */], {
    header: "none"
  }, PersonInfo_jsx("div", null, isMiniaturizedLoginButton && attendeeIndex === 0 && displayMiniaturizedButton && !isChild && PersonInfo_jsx("div", {
    className: "float-right pl-20 pr-20 text-center"
  }, PersonInfo_jsx(Button["a" /* Button */], {
    className: "mx-auto max-w-full",
    "data-testid": "loggin-button",
    isExternalLink: true,
    onClick: function onClick() {
      return trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_PARTICIPANTS, {
        detail_click: 'login_form_participants'
      });
    },
    url: loginUrl
  }, Object(src_i18n["h" /* t */])('booking.participants.connectToPLE.buttonLabel'))), PersonInfo_jsx(PersonInfo_CommonTitle, {
    headerTitle: headerTitle,
    isMain: isMain,
    id: attendeeSchemaIndex
  })), PersonInfo_jsx(PersonInfoForm_PersonInfoForm, {
    parentIndex: parentIndex,
    isUserConnected: isUserConnected,
    isMain: isMain,
    isChild: isChild,
    personalInfoFormContent: personInfoFormContent,
    listIdentifier: listIdentifier,
    attendee: get_default()(values, attendeeIdentifier, {}),
    attendeeIdentifier: attendeeIdentifier,
    setIsDisabled: setIsDisabled
  })), !isEmpty_default()(connectedUserInfo) && isExpandedMode && isMain ? PersonInfo_jsx("div", {
    className: "mt-10 flex justify-end"
  }, PersonInfo_jsx(Button["a" /* Button */], {
    isDisabled: !isValid,
    onClick: function onClick() {
      setIsExpandedMode(!isExpandedMode);
      trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_PARTICIPANTS, {
        detail_click: 'edit_main_traveler_validate'
      });
    },
    size: "medium"
  }, Object(src_i18n["h" /* t */])('booking.common.validate'))) : null);
};
// CONCATENATED MODULE: ./src/client/components/widgets/contact-info/AttendeesForms.jsx



var AttendeesForms_jsx = react_default.a.createElement;







var AttendeesForms_AttendeeBlock = function AttendeeBlock(_ref) {
  var attendee = _ref.attendee,
      attendeeIndexInList = _ref.attendeeIndexInList,
      i18n = _ref.i18n,
      connectedUserInfo = _ref.connectedUserInfo,
      hasMainAttendeeErrors = _ref.hasMainAttendeeErrors,
      hasPerformValidation = _ref.hasPerformValidation,
      hasAddress = _ref.hasAddress,
      arrivalDate = _ref.arrivalDate;
  var id = attendee.id,
      _attendee$isMain = attendee.isMain,
      isMain = _attendee$isMain === void 0 ? false : _attendee$isMain,
      _attendee$isChild = attendee.isChild,
      isChild = _attendee$isChild === void 0 ? false : _attendee$isChild,
      attendeeIndex = attendee.attendeeIndex;
  var listIdentifier = isChild ? 'children' : 'adults';
  var attendeeIdentifier = "".concat(listIdentifier, ".").concat(attendeeIndex);
  return AttendeesForms_jsx("div", {
    className: "mt-20",
    key: attendeeIdentifier
  }, AttendeesForms_jsx(PersonInfo_PersonInfo, {
    attendeeIdentifier: attendeeIdentifier,
    listIdentifier: listIdentifier,
    attendeeIndex: attendeeIndex,
    connectedUserInfo: connectedUserInfo,
    hasMainAttendeeErrors: hasMainAttendeeErrors,
    hasPerformValidation: hasPerformValidation,
    hasAddress: hasAddress,
    i18n: i18n,
    id: id,
    isChild: isChild,
    isMain: isMain,
    arrivalDate: arrivalDate,
    parentIndex: attendeeIndexInList,
    isUserConnected: !isEmpty_default()(connectedUserInfo)
  }));
};

var AttendeesForms_AttendeesForms = function AttendeesForms(_ref2) {
  var list = _ref2.list,
      arrivalDate = _ref2.arrivalDate,
      connectedUserInfo = _ref2.connectedUserInfo,
      hasMainAttendeeErrors = _ref2.hasMainAttendeeErrors,
      hasPerformValidation = _ref2.hasPerformValidation,
      hasAddress = _ref2.hasAddress,
      i18n = _ref2.i18n;
  return AttendeesForms_jsx("div", {
    className: "my-20"
  }, list.map(function (attendee, attendeeIndexInList) {
    return AttendeesForms_jsx("div", {
      key: attendee.id
    }, AttendeesForms_jsx(AttendeesForms_AttendeeBlock, {
      attendee: {
        gmNumber: attendee.gmNumber,
        id: attendee.id,
        isMain: attendee.isMain,
        isChild: !attendee.isAdult,
        attendeeIndex: attendee.attendeeIndex
      },
      attendeeIndexInList: attendeeIndexInList,
      arrivalDate: arrivalDate,
      connectedUserInfo: connectedUserInfo,
      hasMainAttendeeErrors: hasMainAttendeeErrors,
      hasPerformValidation: hasPerformValidation,
      hasAddress: hasAddress,
      i18n: i18n
    }), attendeeIndexInList === 0 && list.length > 1 && !isEmpty_default()(connectedUserInfo) && AttendeesForms_jsx(react["Fragment"], null, AttendeesForms_jsx(Heading["a" /* Heading */], {
      className: "mb-20 mt-40",
      hLevel: 3,
      theme: "heading-brand-1"
    }, Object(src_i18n["h" /* t */])('booking.participants.travelCompanions')), AttendeesForms_jsx(SimpleNotification["a" /* SimpleNotification */], {
      id: "ContactInfoFormInformations",
      title: Object(src_i18n["h" /* t */])('booking.participants.personnalInfosHeader.identityPapersMatchingTitle'),
      content: Object(src_i18n["h" /* t */])('booking.participants.personnalInfosHeader.identityPapersMatching'),
      iconName: icons["a" /* ICONS */].EXCLAMATION_POINT
    })));
  }));
};

/* harmony default export */ var contact_info_AttendeesForms = (AttendeesForms_AttendeesForms);
// CONCATENATED MODULE: ./src/client/components/widgets/contact-info/ContactInfoForm.jsx





var ContactInfoForm_jsx = react_default.a.createElement;













var ContactInfoForm_ContactInfoForm = function ContactInfoForm(_ref) {
  var proposal = _ref.proposal,
      connectedUserInfo = _ref.connectedUserInfo,
      hasAddress = _ref.hasAddress,
      i18n = _ref.i18n,
      attendees = _ref.attendees,
      setErrorMessage = _ref.setErrorMessage,
      setHasUnselectedTravelCompanions = _ref.setHasUnselectedTravelCompanions;
  var formik = Object(formik_esm["e" /* useFormikContext */])(); // we need a ref for formik for the unmount to have access to the formik bag (the formik bag ref change at every render 😭)

  var formikRef = Object(react["useRef"])();

  var _useAppContext = Object(ReactAppContext["c" /* useAppContext */])(),
      isUserLogged = _useAppContext.isUserLogged;

  var _useState = Object(react["useState"])(false),
      hasMainAttendeeErrors = _useState[0],
      setHasMainAttendeesError = _useState[1];

  var _useState2 = Object(react["useState"])(false),
      hasPerformValidation = _useState2[0],
      setHasPerformValidation = _useState2[1];

  Object(ScrollToErrorHook["a" /* useAutoScrollToError */])(formik);

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackEvent = _useTrackEvent.trackEvent;

  formikRef.current = formik;
  Object(ScrollToErrorHook["a" /* useAutoScrollToError */])(formik);
  var arrivalDate = proposal.arrivalDate;
  var validationCallback = Object(react["useCallback"])(function () {
    var _formik$errors, _formik$errors$adults, _formik$errors$adults2;

    formik.submitForm();
    var legalAgreementError = (_formik$errors = formik.errors) === null || _formik$errors === void 0 ? void 0 : (_formik$errors$adults = _formik$errors.adults) === null || _formik$errors$adults === void 0 ? void 0 : (_formik$errors$adults2 = _formik$errors$adults[0]) === null || _formik$errors$adults2 === void 0 ? void 0 : _formik$errors$adults2.optinsCGU;
    var hasLegalAgreementError = legalAgreementError !== null && legalAgreementError !== undefined;

    if (hasLegalAgreementError) {
      setHasMainAttendeesError(true);
      setErrorMessage(Object(src_i18n["h" /* t */])('booking.participants.errorMessage.legalAgreement'));
    }

    Object(ContactInfoUtils["z" /* trackAttendeesFormError */])(trackEvent, formik);

    if (isUserLogged) {
      var _formik$errors$adults3;

      var hasError = (_formik$errors$adults3 = formik.errors.adults) === null || _formik$errors$adults3 === void 0 ? void 0 : _formik$errors$adults3.slice(1).some(function (adult) {
        return !!adult;
      });

      if (hasError) {
        if (hasLegalAgreementError) {
          setHasMainAttendeesError(true);
          setErrorMessage(Object(src_i18n["h" /* t */])('booking.participants.errorMessage.legalAgreement'));
        }

        setErrorMessage(Object(src_i18n["h" /* t */])('booking.participants.errorMessage.travelCompanionsNotSelected'));
      }

      setHasUnselectedTravelCompanions(hasError);
    }

    return Promise.reject();
  }, [formik.errors]);
  Object(useBookingNavbar["a" /* useBookingNavbar */])({
    validationCallback: validationCallback
  });
  Object(react["useEffect"])(function () {
    /* We need to validate the form when the user is connected and the form is displayed before showing the preview */
    formik.validateForm().then(function (errors) {
      var _errors$adults;

      // $FlowFixMe
      if (!isEmpty_default()(errors) && !isEmpty_default()((_errors$adults = errors.adults) === null || _errors$adults === void 0 ? void 0 : _errors$adults[0])) {
        setHasMainAttendeesError(true);
      }

      setHasPerformValidation(true);
    });
  }, []);
  return ContactInfoForm_jsx(react["Fragment"], null, ContactInfoForm_jsx("div", null, ContactInfoForm_jsx(SimpleNotification["a" /* SimpleNotification */], {
    id: "ContactInfoFormInformations",
    title: Object(src_i18n["h" /* t */])('booking.participants.personnalInfosHeader.identityPapersMatchingTitle'),
    content: Object(src_i18n["h" /* t */])('booking.participants.personnalInfosHeader.identityPapersMatching'),
    iconName: icons["a" /* ICONS */].EXCLAMATION_POINT
  }), ContactInfoForm_jsx(contact_info_AttendeesForms, {
    list: attendees.list,
    arrivalDate: arrivalDate,
    connectedUserInfo: connectedUserInfo,
    hasMainAttendeeErrors: hasMainAttendeeErrors,
    hasPerformValidation: hasPerformValidation,
    hasAddress: hasAddress,
    i18n: i18n
  })), ContactInfoForm_jsx(MultiCGUBlock_MultiCGUBlock, {
    i18n: i18n,
    idsCGU: contact_info_constants["a" /* ACCEPTED_CGUS */] // ids of the CGUs to show in the block

  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/contact-info/ContactInfo.jsx






















var ContactInfo_jsx = react_default.a.createElement;

function ContactInfo_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ContactInfo_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ContactInfo_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ContactInfo_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

























var ContactInfo_mapAttendeesWithPersistedProfille = function mapAttendeesWithPersistedProfille(attendees) {
  var persistedProfile = JSON.parse(Object(lz_string["decompressFromBase64"])(Object(sessionStorageApi["b" /* getFromSessionStorage */])('profile') || ''));
  return ContactInfo_objectSpread(ContactInfo_objectSpread({}, attendees), {}, {
    adults: [ContactInfo_objectSpread(ContactInfo_objectSpread({}, attendees.adults[0]), persistedProfile)].concat(Object(toConsumableArray["a" /* default */])(attendees.adults.slice(1)))
  });
};

var ContactInfo_ErrorHandler = function ErrorHandler(_ref) {
  var concernedAttendees = _ref.concernedAttendees,
      proposalAttendees = _ref.proposalAttendees,
      setErrors = _ref.setErrors;
  Object(react["useEffect"])(function () {
    Object(ContactInfoUtils["r" /* handleSetErrorsForConcernedAttendees */])({
      concernedAttendees: concernedAttendees,
      proposalAttendees: proposalAttendees,
      setErrors: setErrors
    });
  }, [concernedAttendees, proposalAttendees, setErrors]);
  return null;
};

var ContactInfo_ContactInfo = function _ContactInfo(_ref2) {
  var _beEngineContext$curr;

  var i18n = _ref2.i18n,
      proposal = _ref2.proposal,
      updateAttendees = _ref2.updateAttendees,
      connectedUserInfo = _ref2.connectedUserInfo,
      addressSchema = _ref2.addressSchema,
      goToNextStep = _ref2.goToNextStep,
      getAttendeeSchema = _ref2.getAttendeeSchema;
  var track = Object(useTracking["a" /* useTracking */])();
  var beEngineContext = Object(react["useContext"])(BookingEngineContext["a" /* BookingEngineContext */]);
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var isUserLogged = appContext.isUserLogged,
      isUserQuickLogged = appContext.isUserQuickLogged;
  var optinsContext = Object(react["useContext"])(OptinsProvider["a" /* OptinsContext */]);

  var _useState = Object(react["useState"])(),
      errorMessage = _useState[0],
      setErrorMessage = _useState[1];

  var _useState2 = Object(react["useState"])([]),
      concernedAttendees = _useState2[0],
      setConcernedAteendees = _useState2[1];

  var _useState3 = Object(react["useState"])(false),
      hasUnselectedTravelCompanions = _useState3[0],
      setHasUnselectedTravelCompanions = _useState3[1];

  var _useSelector = Object(es["e" /* useSelector */])(attendees_selector["c" /* selectAttendeesWithInfosByHouseholds */]),
      attendees = _useSelector.attendees;

  var hasAddress = addressSchema.every(function (_ref3) {
    var display = _ref3.display;
    return display;
  });
  var displayParticipantsSelectInput = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.displayCivilityDropdown') && (beEngineContext === null || beEngineContext === void 0 ? void 0 : (_beEngineContext$curr = beEngineContext.currentStep) === null || _beEngineContext$curr === void 0 ? void 0 : _beEngineContext$curr.name) === 'participants'; // if initialValues change (the object ref change) that trigger an undesirable validation with initial values

  var initialValues = Object(react["useMemo"])(function () {
    var _i18n$booking, _i18n$booking$partici, _i18n$booking$partici2, _i18n$booking$partici3, _i18n$booking$partici4, _i18n$booking2, _i18n$booking2$partic, _i18n$booking2$partic2, _i18n$booking2$partic3, _i18n$booking2$partic4;

    return Object(ContactInfoUtils["j" /* getInitialFormValues */])({
      bookingProcess: i18n.bookingProcess,
      adultCivilityDefaultValue: i18n === null || i18n === void 0 ? void 0 : (_i18n$booking = i18n.booking) === null || _i18n$booking === void 0 ? void 0 : (_i18n$booking$partici = _i18n$booking.participants) === null || _i18n$booking$partici === void 0 ? void 0 : (_i18n$booking$partici2 = _i18n$booking$partici.civilities) === null || _i18n$booking$partici2 === void 0 ? void 0 : (_i18n$booking$partici3 = _i18n$booking$partici2.adult) === null || _i18n$booking$partici3 === void 0 ? void 0 : (_i18n$booking$partici4 = _i18n$booking$partici3[0]) === null || _i18n$booking$partici4 === void 0 ? void 0 : _i18n$booking$partici4.value,
      childCivilityDefaultValue: i18n === null || i18n === void 0 ? void 0 : (_i18n$booking2 = i18n.booking) === null || _i18n$booking2 === void 0 ? void 0 : (_i18n$booking2$partic = _i18n$booking2.participants) === null || _i18n$booking2$partic === void 0 ? void 0 : (_i18n$booking2$partic2 = _i18n$booking2$partic.civilities) === null || _i18n$booking2$partic2 === void 0 ? void 0 : (_i18n$booking2$partic3 = _i18n$booking2$partic2.child) === null || _i18n$booking2$partic3 === void 0 ? void 0 : (_i18n$booking2$partic4 = _i18n$booking2$partic3[0]) === null || _i18n$booking2$partic4 === void 0 ? void 0 : _i18n$booking2$partic4.value,
      attendees: isUserLogged ? attendees : ContactInfo_mapAttendeesWithPersistedProfille(attendees),
      connectedUserInfo: connectedUserInfo,
      hasAddress: hasAddress,
      locale: appContext.locale,
      getAttendeeSchema: getAttendeeSchema,
      displayParticipantsSelectInput: displayParticipantsSelectInput,
      preCheckedOptins: optinsContext.optins
    });
  }, [attendees]);

  var validateAttendees = function validateAttendees(_ref4) {
    var adults = _ref4.adults,
        children = _ref4.children;
    var hasErrors = false;
    var fieldsOnError = {
      firstName: true,
      lastName: true,
      birthdate: true
    };
    var errors = {
      adults: Array(adults === null || adults === void 0 ? void 0 : adults.length),
      children: Array((children === null || children === void 0 ? void 0 : children.length) || 0)
    };
    var adultsDuplicates = (adults === null || adults === void 0 ? void 0 : adults.length) ? Object(ContactInfoUtils["d" /* findDuplicateAttendees */])(adults) : [];
    var childrenDuplicates = (children === null || children === void 0 ? void 0 : children.length) ? Object(ContactInfoUtils["d" /* findDuplicateAttendees */])(children) : [];

    if (!isEmpty_default()(childrenDuplicates) || !isEmpty_default()(adultsDuplicates)) {
      hasErrors = true;
      setErrorMessage(i18n.booking.participants.labels.warningNames);
      adultsDuplicates.forEach(function (duplicateIndex) {
        errors.adults[duplicateIndex] = fieldsOnError;
      });
      childrenDuplicates.forEach(function (duplicateIndex) {
        errors.children[duplicateIndex] = fieldsOnError;
      });
    } else if (hasUnselectedTravelCompanions) {
      setErrorMessage(Object(src_i18n["h" /* t */])('booking.participants.errorMessage.travelCompanionsNotSelected'));
      setHasUnselectedTravelCompanions(false);
    } else {
      setErrorMessage(undefined);
    }

    if (hasErrors) {
      return errors;
    }
  };

  var putAttendees = function putAttendees(_ref5, actions) {
    var _adults$;

    var adults = _ref5.adults,
        children = _ref5.children;
    actions.setSubmitting(false); // remove the intermediate id values to send the correct values to the API

    adults[0].optinsCGU = Object.values(adults[0].optinsCGU || {}); // keep only those in CGUS_ACCEPTED_BY_API fix : #23104 until the API is updated to accept all CGUs

    adults[0].optinsCGU = adults[0].optinsCGU.filter(function (optin) {
      return (// eslint-disable-next-line flowtype/no-weak-types
        contact_info_constants["c" /* CGUS_ACCEPTED_BY_API */].includes(optin === null || optin === void 0 ? void 0 : optin.channel)
      );
    }); // Calculate and store SHA-256 hash of email for tracking

    if ((_adults$ = adults[0]) === null || _adults$ === void 0 ? void 0 : _adults$.email) {
      var emailSha256 = crypto_js_default.a.SHA256(adults[0].email.toLowerCase().trim()).toString(); // eslint-disable-line new-cap

      var storedTracking = tracking_storage_api["b" /* get */](tracking_constants["c" /* BE_TRACKING */]);
      tracking_storage_api["c" /* set */](ContactInfo_objectSpread(ContactInfo_objectSpread({}, storedTracking), {}, {
        email_sha_256: emailSha256
      }));
    }

    updateAttendees({
      appContext: appContext,
      proposalId: proposal.id,
      attendees: {
        adults: adults,
        children: children
      }
    }).then(function () {
      if (isUserLogged || isUserQuickLogged) {
        return goToNextStep();
      }

      Object(sessionStorageApi["d" /* setInSessionStorage */])('profile', Object(lz_string["compressToBase64"])(JSON.stringify(pick_default()(adults[0], ['firstName', 'lastName', 'address']))));
      goToNextStep({
        queryParams: {
          a: Object(lz_string["compressToEncodedURIComponent"])(JSON.stringify(adults.map(function (_ref6) {
            var firstName = _ref6.firstName,
                lastName = _ref6.lastName,
                birthdate = _ref6.birthdate;
            return {
              firstName: firstName,
              lastName: lastName,
              dateOfBirth: birthdate
            };
          })))
        }
      });
    }).catch(function (error) {
      var _error$errors, _error$errors$;

      setErrorMessage(Object(ContactInfoUtils["t" /* renderErrorUpdatingAttendees */])(error));
      setConcernedAteendees(Object(ContactInfoUtils["h" /* getConcernedAttendees */])(error) || []);
      track(ContactInfo_objectSpread(ContactInfo_objectSpread({}, booking_constants["c" /* BE_GA_DEFAULT_PAYLOAD */]), {}, {
        actionGA: 'participant',
        labelGA: (error === null || error === void 0 ? void 0 : (_error$errors = error.errors) === null || _error$errors === void 0 ? void 0 : (_error$errors$ = _error$errors[0]) === null || _error$errors$ === void 0 ? void 0 : _error$errors$.errorCode) === 'fieldCannotBeModifiedDueToUpcomingBooking' ? 'error_cannotMatchAttendeeNames' : 'error_serverError'
      }));
    });
  };

  return ContactInfo_jsx(react["Fragment"], null, ContactInfo_jsx(formik_esm["d" /* Formik */], {
    initialValues: initialValues,
    enableReinitialize: true,
    onSubmit: putAttendees,
    validate: validateAttendees,
    validateOnBlur: true
  }, function (_ref7) {
    var setErrors = _ref7.setErrors;
    return ContactInfo_jsx(react["Fragment"], null, ContactInfo_jsx(ContactInfo_ErrorHandler, {
      concernedAttendees: concernedAttendees,
      proposalAttendees: attendees,
      setErrors: setErrors
    }), ContactInfo_jsx(ContactInfoForm_ContactInfoForm, {
      i18n: i18n,
      proposal: proposal,
      hasAddress: hasAddress,
      connectedUserInfo: connectedUserInfo,
      addressSchema: addressSchema,
      setErrorMessage: setErrorMessage,
      setHasUnselectedTravelCompanions: setHasUnselectedTravelCompanions,
      attendees: attendees
    }));
  }), errorMessage && ContactInfo_jsx(FormFeedback["a" /* FormFeedback */], {
    hasAutoScroll: true,
    isError: true,
    message: errorMessage
  }));
};

function getConnectedUserInfo(state) {
  var userInfo = Object(userInfo_selectors["a" /* userInfoSelector */])(state);
  return userInfo.isQuickLoggedIn ? {} : userInfo;
}

var ContactInfo = Object(es["c" /* connect */])(function (state) {
  return {
    connectedUserInfo: getConnectedUserInfo(state),
    addressSchema: Object(validationSchema_selectors["b" /* getAddressValidationSchema */])(state),
    getAttendeeSchema: function getAttendeeSchema(isMain, isChild) {
      return Object(validationSchema_selectors["c" /* getAttendeeValidationSchemaByRole */])(isMain, isChild)(state);
    }
  };
}, {
  updateAttendees: proposals_action["z" /* updateAttendees */]
})(ContactInfo_ContactInfo);
// CONCATENATED MODULE: ./src/client/views/booking/participants/login-to-ple/NotificationLoginToPle.jsx









var NotificationLoginToPle_jsx = react_default.a.createElement;

function NotificationLoginToPle_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function NotificationLoginToPle_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { NotificationLoginToPle_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { NotificationLoginToPle_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }














var NotificationLoginToPle_NotificationLoginToPle = function NotificationLoginToPle(_ref) {
  var className = _ref.className,
      isQuickLogged = _ref.isQuickLogged;
  var track = Object(useTracking["a" /* useTracking */])();
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var loginUrl = isQuickLogged ? ple_utils["i" /* buildStepupUrl */]({
    redirectUri: dist["windowWrapper"].getLocation(),
    locale: appContext.locale
  }) : ple_utils["f" /* buildSigninUrl */]({
    redirectUri: dist["windowWrapper"].getLocation(),
    locale: appContext.locale
  });
  var bulletpoints = [Object(src_i18n["h" /* t */])('booking.participants.connectToPLE.bulletpoint1'), Object(src_i18n["h" /* t */])('booking.participants.connectToPLE.bulletpoint2'), Object(src_i18n["h" /* t */])('booking.participants.connectToPLE.bulletpoint3')];
  return NotificationLoginToPle_jsx("aside", {
    className: Object(classnames_utils["a" /* classnames */])('rounded-12 border-1 border-lightGrey bg-white', className),
    "data-testid": "loggin-block"
  }, NotificationLoginToPle_jsx("div", {
    className: "flex flex-col sm:flex-row sm:flex-wrap"
  }, NotificationLoginToPle_jsx("div", {
    className: "p-20 pb-0 sm:w-1/2 sm:pb-20 sm:pe-10"
  }, NotificationLoginToPle_jsx("div", {
    className: "flex items-end gap-20 font-brand text-14 text-black"
  }, NotificationLoginToPle_jsx(Icon["a" /* Icon */], {
    className: "shrink-0 sm:mx-10",
    name: icons["a" /* ICONS */].ICON_45,
    width: "2.5em"
  }), NotificationLoginToPle_jsx(Text["a" /* Text */], {
    text: Object(src_i18n["h" /* t */])('booking.participants.connectToPLE.message'),
    theme: "none"
  }))), NotificationLoginToPle_jsx("div", {
    className: "p-20 py-15 sm:w-1/2 sm:py-20 sm:ps-10"
  }, NotificationLoginToPle_jsx("ul", null, bulletpoints.map(function (bulletpoint) {
    return bulletpoint ? NotificationLoginToPle_jsx("li", {
      className: "flex items-baseline gap-10 text-12",
      key: bulletpoint
    }, NotificationLoginToPle_jsx(Icon["a" /* Icon */], {
      className: "shrink-0 align-middle text-green",
      name: icons["a" /* ICONS */].CHECK,
      width: "0.625rem"
    }), bulletpoint) : null;
  }))), Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.displayFutureTravelCredit') && NotificationLoginToPle_jsx("div", {
    className: "mx-auto flex w-full flex-wrap p-20 pt-0 sm:flex-nowrap sm:py-20 sm:pt-0"
  }, NotificationLoginToPle_jsx("div", {
    className: "flex items-center gap-20 font-brand text-14 text-sienna sm:w-1/2 sm:pe-10"
  }, NotificationLoginToPle_jsx(Icon["a" /* Icon */], {
    className: "shrink-0",
    name: icons["a" /* ICONS */].PROMO_CODE,
    width: "2.5rem"
  }), Object(src_i18n["h" /* t */])('booking.summary.futureTravelCredit.popinFtcTitle')), NotificationLoginToPle_jsx("div", {
    className: "ps-60 text-12 sm:w-1/2 sm:ps-10"
  }, Object(src_i18n["h" /* t */])('booking.summary.futureTravelCredit.signIn')))), NotificationLoginToPle_jsx("div", {
    className: "border-t-1 border-lightGrey p-20 text-center"
  }, NotificationLoginToPle_jsx(Button["a" /* Button */], {
    className: "mx-auto max-w-full",
    "data-testid": "loggin-button",
    isExternalLink: true,
    onClick: function onClick() {
      return track(NotificationLoginToPle_objectSpread(NotificationLoginToPle_objectSpread({}, booking_constants["c" /* BE_GA_DEFAULT_PAYLOAD */]), {}, {
        actionGA: 'participant',
        labelGA: 'connectionParticipant'
      }));
    },
    url: loginUrl
  }, Object(src_i18n["h" /* t */])('booking.participants.connectToPLE.buttonLabel'))));
};
// CONCATENATED MODULE: ./src/client/views/booking/participants/login-to-ple/PopinLoginToPle.jsx









var PopinLoginToPle_jsx = react_default.a.createElement;

function PopinLoginToPle_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function PopinLoginToPle_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { PopinLoginToPle_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { PopinLoginToPle_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }















var PopinLoginToPle_PopinLoginToPle = function PopinLoginToPle(_ref) {
  var i18n = _ref.i18n,
      onClose = _ref.onClose;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var _i18n$booking$partici = i18n.booking.participants.connectToPLE,
      message = _i18n$booking$partici.message,
      bulletpoint1 = _i18n$booking$partici.bulletpoint1,
      bulletpoint2 = _i18n$booking$partici.bulletpoint2,
      bulletpoint3 = _i18n$booking$partici.bulletpoint3,
      buttonLabel = _i18n$booking$partici.buttonLabel,
      noAccountSentence = _i18n$booking$partici.noAccountSentence,
      noAccount = _i18n$booking$partici.noAccount;
  return PopinLoginToPle_jsx(Modal["a" /* Modal */], {
    ariaLabel: message,
    ariaLabelledby: identifiers_constants["A" /* ID_MODAL_HEADER__PLE__LOGIN */],
    closeLabel: Object(src_i18n["h" /* t */])('common.close'),
    onClose: onClose,
    size: "small",
    dataTestId: "connexion-popin"
  }, PopinLoginToPle_jsx("div", {
    className: "font-sans"
  }, PopinLoginToPle_jsx("div", {
    className: "bg-lightSand p-20 text-center font-bold"
  }, PopinLoginToPle_jsx(Icon["a" /* Icon */], {
    className: "text-sienna",
    isNotSquare: true,
    name: icons["a" /* ICONS */].PEOPLE,
    width: "3.5625rem"
  }), PopinLoginToPle_jsx(Title["a" /* Title */], {
    className: "mt-10 justify-center text-sienna",
    hLevel: 1,
    id: identifiers_constants["A" /* ID_MODAL_HEADER__PLE__LOGIN */],
    theme: "title-sans-n4"
  }, message)), PopinLoginToPle_jsx("ul", {
    className: "p-20"
  }, [bulletpoint1, bulletpoint2, bulletpoint3].map(function (bulletpoint) {
    return bulletpoint ? PopinLoginToPle_jsx("li", {
      key: bulletpoint
    }, PopinLoginToPle_jsx(Icon["a" /* Icon */], {
      className: "me-10 align-middle text-green",
      name: icons["a" /* ICONS */].CHECK
    }), bulletpoint) : null;
  })), Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.displayFutureTravelCredit') && PopinLoginToPle_jsx("div", {
    className: "mx-auto flex w-full max-w-440 flex-wrap justify-center p-20 pt-0"
  }, PopinLoginToPle_jsx("div", {
    className: "flex items-center gap-20 font-brand text-14 text-lavender"
  }, PopinLoginToPle_jsx(Icon["a" /* Icon */], {
    className: "shrink-0",
    name: icons["a" /* ICONS */].PROMO_CODE,
    width: "2.5rem"
  }), Object(src_i18n["h" /* t */])('booking.summary.futureTravelCredit.popinFtcTitle')), PopinLoginToPle_jsx("div", {
    className: "text-12"
  }, Object(src_i18n["h" /* t */])('resort.futureTravelCredit.genericDescription'))), PopinLoginToPle_jsx("div", {
    className: "pb-20 text-center"
  }, PopinLoginToPle_jsx(Button["a" /* Button */], {
    className: "mb-20 w-3/4",
    "data-testid": "loggin-button",
    isExternalLink: true,
    onClick: function onClick() {
      tracking_api["b" /* setDataLayer */](PopinLoginToPle_objectSpread(PopinLoginToPle_objectSpread({}, booking_constants["c" /* BE_GA_DEFAULT_PAYLOAD */]), {}, {
        actionGA: 'participant',
        labelGA: 'popin_connectionParticipant',
        versionBooking: 'responsive'
      }), appContext);
    },
    url: ple_utils["f" /* buildSigninUrl */]({
      locale: appContext.locale,
      redirectUri: dist["windowWrapper"].getLocation()
    })
  }, buttonLabel), PopinLoginToPle_jsx("div", {
    className: "px-20"
  }, PopinLoginToPle_jsx("p", {
    className: "font-bold"
  }, noAccount), PopinLoginToPle_jsx("p", null, noAccountSentence)))));
};
// CONCATENATED MODULE: ./src/client/views/booking/participants/ParticipantsView.jsx


var ParticipantsView_jsx = react_default.a.createElement;










var SESSION_STORAGE_ITEM = 'seenProposalsForPopin';
var ParticipantsView_ParticipantsView = function ParticipantsView(_ref) {
  var _i18n$account, _i18n$account$authent;

  var goToNextStep = _ref.goToNextStep,
      i18n = _ref.i18n,
      proposals = _ref.proposals,
      selectedProposal = _ref.selectedProposal,
      infoBannerData = _ref.infoBannerData;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  var _useState = Object(react["useState"])(false),
      isAlreadySeen = _useState[0],
      setIsAlreadySeen = _useState[1];

  var customerSearchResult = Object(es["e" /* useSelector */])(booking_selector["k" /* getCustomerSearchResult */]);
  var concatProposalIds = proposals.map(function (_ref2) {
    var id = _ref2.id;
    return id;
  }).join('');

  var _useState2 = Object(react["useState"])(Object(sessionStorageApi["b" /* getFromSessionStorage */])(SESSION_STORAGE_ITEM) !== concatProposalIds),
      shouldShowConnectToPlePopin = _useState2[0],
      setShouldShowConnectToPlePopin = _useState2[1];

  Object(react["useEffect"])(function () {
    if (Object(sessionStorageApi["b" /* getFromSessionStorage */])(SESSION_STORAGE_ITEM) !== concatProposalIds) {
      Object(sessionStorageApi["d" /* setInSessionStorage */])(SESSION_STORAGE_ITEM, concatProposalIds);
    }
  }, [concatProposalIds]);
  Object(react["useEffect"])(function () {
    if (customerSearchResult.data && isAlreadySeen === false) {
      setIsAlreadySeen(true);
    }
  }, [customerSearchResult]);
  var userLogged = appContext.isUserLogged;
  var isPopinPleEnabled = !userLogged && Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('connectionPopinPLE.isEnabled');
  var isMiniaturizedLoginButton = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('participantPageConnection.miniaturizedButton');
  var displayNotification = !userLogged && (i18n === null || i18n === void 0 ? void 0 : (_i18n$account = i18n.account) === null || _i18n$account === void 0 ? void 0 : (_i18n$account$authent = _i18n$account.authenticated) === null || _i18n$account$authent === void 0 ? void 0 : _i18n$account$authent.greeting);

  var closeLoginToPLEModal = function closeLoginToPLEModal() {
    setShouldShowConnectToPlePopin(false);
  };

  return ParticipantsView_jsx("div", {
    className: "flex flex-col sm:flex-row sm:items-start"
  }, isPopinPleEnabled && shouldShowConnectToPlePopin && ParticipantsView_jsx(PopinLoginToPle_PopinLoginToPle, {
    i18n: i18n,
    onClose: closeLoginToPLEModal
  }), ParticipantsView_jsx("div", {
    className: "max-w-site-mini sm:mx-auto"
  }, Object(infoBanner_utils["a" /* renderInfoBanner */])({
    infoBannerData: infoBannerData,
    departureDate: selectedProposal.departureDate,
    arrivalDate: selectedProposal.arrivalDate,
    currentStep: 'participants'
  }), displayNotification && !isMiniaturizedLoginButton && ParticipantsView_jsx("div", {
    className: "w-full"
  }, ParticipantsView_jsx(NotificationLoginToPle_NotificationLoginToPle, {
    className: "mb-20",
    isQuickLogged: appContext.isUserQuickLogged,
    i18n: i18n
  })), ParticipantsView_jsx(ContactInfo, {
    goToNextStep: goToNextStep,
    i18n: i18n,
    proposal: selectedProposal
  })));
};
// EXTERNAL MODULE: ./src/client/components/widgets/paid-service/PaidService.jsx
var PaidService = __webpack_require__("o8kQ");

// EXTERNAL MODULE: ./src/client/components/widgets/package/alternative-packages/AlternativePackageToolTip.jsx
var AlternativePackageToolTip = __webpack_require__("bn3Y");

// CONCATENATED MODULE: ./src/client/components/widgets/package/alternative-packages/AlternativePackages.jsx








var _MAPPING_PACKAGE_INFO;

var AlternativePackages_jsx = react_default.a.createElement;












var _constants$PACKAGES = dist["constants"].PACKAGES,
    JOYVIEW_ROOM_ONLY = _constants$PACKAGES.JOYVIEW_ROOM_ONLY,
    JOYVIEW_ALL_INCLUSIVE = _constants$PACKAGES.JOYVIEW_ALL_INCLUSIVE,
    JOYVIEW_FOOD_AND_BEVERAGES = _constants$PACKAGES.JOYVIEW_FOOD_AND_BEVERAGES;
var MAPPING_PACKAGE_INFOS = (_MAPPING_PACKAGE_INFO = {}, Object(defineProperty["a" /* default */])(_MAPPING_PACKAGE_INFO, JOYVIEW_ALL_INCLUSIVE, {
  color: colors["a" /* COLORS */].SAFFRON,
  icon: icons["a" /* ICONS */].ALL_INCLUSIVE,
  imageUrl: 'https://ns.clubmed.com/it/2019/be/joyview/Images.jpg',
  labelGA: 'AllInclusive',
  title: 'PAIBlockTitle'
}), Object(defineProperty["a" /* default */])(_MAPPING_PACKAGE_INFO, JOYVIEW_FOOD_AND_BEVERAGES, {
  color: colors["a" /* COLORS */].ORANGE,
  icon: icons["a" /* ICONS */].DISHES,
  imageUrl: 'https://ns.clubmed.com/it/2019/be/joyview/FFB-JoyVIew.png',
  labelGA: 'FoodBeverage',
  title: 'FFBBlockTitle'
}), _MAPPING_PACKAGE_INFO);

var AlternativePackages_getCtaType = function getCtaType(selectedProposal, packageId, basePackageId) {
  if (!selectedProposal.alternativePackages || basePackageId === packageId) {
    return PaidService["b" /* ctaActionTypes */].included;
  }

  if (selectedProposal.packageId === packageId) {
    return PaidService["b" /* ctaActionTypes */].remove;
  }

  return PaidService["b" /* ctaActionTypes */].add;
};

var findAlternativeProposalByPackage = function findAlternativeProposalByPackage(alternativePackages, packageId) {
  return alternativePackages.find(function (bundle) {
    return bundle.packageId === packageId;
  });
};

var AlternativePackages_AlternativePackages = function AlternativePackages(_ref) {
  var _selectedProposal$pac;

  var allProposals = _ref.allProposals,
      isColumn = _ref.isColumn,
      selectedProposal = _ref.selectedProposal,
      selectProposal = _ref.selectProposal;
  var allProposalsFromStore = Object(es["e" /* useSelector */])(booking_selector["y" /* proposalsSelector */]);

  if ((!allProposals || !allProposals.length) && !allProposalsFromStore.length) {
    throw new Error('AlternativePackages should have allProposals props provided or the store should contains proposals');
  }

  var basePackageId = (allProposals || allProposalsFromStore)[0].packageId;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent; // $FlowFixMe always found


  var RONPackage = selectedProposal === null || selectedProposal === void 0 ? void 0 : (_selectedProposal$pac = selectedProposal.packages) === null || _selectedProposal$pac === void 0 ? void 0 : _selectedProposal$pac.find(function (selectedProposalPackage) {
    return (selectedProposalPackage === null || selectedProposalPackage === void 0 ? void 0 : selectedProposalPackage.id) === JOYVIEW_ROOM_ONLY;
  });
  return (// $FlowFixMe package always defined here when the resort is joyview
    selectedProposal.packages.filter(function (bundle) {
      return bundle && bundle.id !== JOYVIEW_ROOM_ONLY && (selectedProposal.alternativePackages && findAlternativeProposalByPackage(selectedProposal.alternativePackages, bundle.id) || bundle.id === selectedProposal.packageId);
    }) // $FlowFixMe package always defined here, we filtered it just before
    .map(function (otherPackage, index, mappedArray) {
      var _alternativePackage2;

      var packageInfos = MAPPING_PACKAGE_INFOS[otherPackage.id]; // if there is no alternativePackage that means that it's already selected and that we want to reset the package

      var alternativePackage;

      if (selectedProposal.alternativePackages) {
        alternativePackage = findAlternativeProposalByPackage(selectedProposal.alternativePackages, otherPackage.id) || selectedProposal.alternativePackages[0];
      }

      var ctaType = AlternativePackages_getCtaType(selectedProposal, otherPackage.id, basePackageId);
      return AlternativePackages_jsx(react["Fragment"], {
        key: otherPackage.id
      }, AlternativePackages_jsx(Title["a" /* Title */], {
        className: "mb-20 text-saffron",
        theme: "title-sans-n4"
      }, Object(src_i18n["h" /* t */])("booking.services.".concat(packageInfos.title))), AlternativePackages_jsx(PaidService["a" /* PaidService */], {
        addLabel: Object(src_i18n["h" /* t */])('booking.common.add'),
        ctaType: ctaType,
        headColor: packageInfos.color,
        icon: packageInfos.icon,
        imageUrl: packageInfos.imageUrl,
        includedLabel: Object(src_i18n["h" /* t */])('booking.common.included'),
        isColumn: isColumn,
        label: otherPackage.label,
        text: otherPackage.description,
        tooltip: {
          children: AlternativePackages_jsx("div", {
            className: "text-initial flex w-full"
          }, AlternativePackages_jsx(AlternativePackageToolTip["a" /* AlternativePackageToolTip */], {
            bundle: RONPackage
          }), AlternativePackages_jsx(AlternativePackageToolTip["a" /* AlternativePackageToolTip */], {
            bundle: otherPackage
          })),
          dataSelector: 'JoyviewUpsellTooltip',
          modalProps: {
            ariaLabel: otherPackage.label,
            closeLabel: Object(src_i18n["h" /* t */])('common.close')
          }
        },
        onClick: function onClick() {
          var _alternativePackage;

          switch (ctaType) {
            case 'add':
              trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_UPSELL, {
                detail_click: 'add_joyview_packages'
              });
              break;

            case 'remove':
              trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_UPSELL, {
                detail_click: 'remove_joyview_packages'
              });
              break;

            default:
              noop_default()();

              break;
          }

          return selectProposal((_alternativePackage = alternativePackage) === null || _alternativePackage === void 0 ? void 0 : _alternativePackage.proposalId);
        },
        price: (_alternativePackage2 = alternativePackage) === null || _alternativePackage2 === void 0 ? void 0 : _alternativePackage2.upsellPrice,
        removeLabel: Object(src_i18n["h" /* t */])('booking.common.remove')
      }), index < mappedArray.length - 1 && AlternativePackages_jsx("div", {
        className: "mb-15 mt-20 text-center text-20 sm:mb-0 sm:mt-40"
      }, Object(src_i18n["h" /* t */])('booking.services.JVPackagesOr')));
    })
  );
};
// EXTERNAL MODULE: ./src/client/components/widgets/childcare/childcare.helper.js
var childcare_helper = __webpack_require__("YVWi");

// EXTERNAL MODULE: ./src/client/components/widgets/childcare/Childcare.jsx + 5 modules
var Childcare = __webpack_require__("BGO8");

// EXTERNAL MODULE: ./src/client/components/widgets/childcare/ChildcareIncludedEquipmentCapsule.jsx
var ChildcareIncludedEquipmentCapsule = __webpack_require__("UnYQ");

// EXTERNAL MODULE: ./src/client/components/widgets/childcare/ChildcareOnDemandEquipmentCapsule.jsx
var ChildcareOnDemandEquipmentCapsule = __webpack_require__("LoHR");

// EXTERNAL MODULE: ./src/client/context/ChildcareContext.js
var ChildcareContext = __webpack_require__("7afx");

// EXTERNAL MODULE: ./src/client/context/ServicesContext.js
var ServicesContext = __webpack_require__("2Odu");

// EXTERNAL MODULE: ./src/hooks/use-childcare-context/useChildcareContext.js
var useChildcareContext = __webpack_require__("V+KB");

// CONCATENATED MODULE: ./src/client/views/booking/services/ServicesView.jsx
















var ServicesView_jsx = react_default.a.createElement;

function ServicesView_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ServicesView_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ServicesView_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ServicesView_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

























var ServicesView_ServicesView = function ServicesView(_ref) {
  var selectedProposal = _ref.selectedProposal,
      resort = _ref.resort,
      proposals = _ref.proposals,
      infoBannerData = _ref.infoBannerData;
  Object(useBookingNavbar["a" /* useBookingNavbar */])({
    noEdit: false
  });
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var trackingDefaultPayload = {
    actionGA: 'services'
  };
  var dispatch = Object(es["d" /* useDispatch */])();
  var router = Object(next_router["useRouter"])();
  var tripInformation = Object(es["e" /* useSelector */])(storeHelper["d" /* tripInformationSelector */]);
  var trackError = Object(useTracking["a" /* useTracking */])(ServicesView_objectSpread(ServicesView_objectSpread({}, booking_constants["c" /* BE_GA_DEFAULT_PAYLOAD */]), {}, {
    actionGA: 'service'
  }));

  var _useSelector = Object(es["e" /* useSelector */])(attendees_selector["c" /* selectAttendeesWithInfosByHouseholds */]),
      attendeesWithInfos = _useSelector.attendees;

  var attendeesList = [].concat(Object(toConsumableArray["a" /* default */])(attendeesWithInfos.adults), Object(toConsumableArray["a" /* default */])(attendeesWithInfos.children.map(function (child) {
    return ServicesView_objectSpread(ServicesView_objectSpread({}, child), {}, {
      isChild: true
    });
  })));

  var _useChidcareContext = Object(useChildcareContext["a" /* useChidcareContext */])({
    appContext: appContext,
    proposals: proposals
  }),
      childcareContextServicesValuesBE = _useChidcareContext.childcareContextServicesValuesBE;

  var servicesContextValuesBE = Object(react["useMemo"])(function () {
    return {
      attendeesList: attendeesList,
      arrivalDate: selectedProposal.arrivalDate,
      departureDate: selectedProposal.departureDate,
      showRentAllSchedules: true
    };
  }, [selectedProposal]);

  var onAddChildcare = function onAddChildcare(_ref2) {
    var childcareId = _ref2.childcareId,
        attendeeId = _ref2.attendeeId,
        startDate = _ref2.startDate,
        endDate = _ref2.endDate,
        overloadChildcareIdForChalet = _ref2.overloadChildcareIdForChalet;
    var addChildcareAction = Object(proposals_action["b" /* addAdditionalService */])({
      proposalIds: proposals.map(function (_ref3) {
        var id = _ref3.id;
        return id;
      }),
      serviceId: childcareId,
      attendeeIds: attendeeId,
      schedules: [{
        startDate: startDate,
        endDate: endDate
      }],
      overloadForSpecificProposalIds: overloadChildcareIdForChalet,
      appContext: appContext
    });
    return dispatch(addChildcareAction).catch(function (error) {
      return Object(BookingEngine_utils["i" /* trackErrorOnAddService */])(error, trackError, 'UNKNOWN_CHILDCARE');
    });
  };

  var onDeleteChildcare = function onDeleteChildcare(_ref4) {
    var childcareId = _ref4.childcareId,
        attendeeId = _ref4.attendeeId,
        overloadChildcareIdForChalet = _ref4.overloadChildcareIdForChalet;
    return dispatch(Object(proposals_action["g" /* deleteAdditionalServices */])({
      serviceIds: [childcareId],
      attendeeIds: attendeeId,
      overloadForSpecificProposalIds: overloadChildcareIdForChalet,
      appContext: appContext
    }));
  };

  var dispatchSelectProposal = function dispatchSelectProposal(proposalId) {
    var updatedUri = new URI_default.a(router.asPath).setQuery(dist["appQueryParameters"].booking.selectedProposalId, proposalId);
    router.replace(updatedUri.toString());
    return dispatch(Object(selectedProposalId_action["d" /* selectProposal */])(proposalId));
  };

  var renderJoyView = function renderJoyView() {
    return ServicesView_jsx(AlternativePackages_AlternativePackages, {
      selectedProposal: selectedProposal,
      selectProposal: dispatchSelectProposal
    });
  };

  var renderChildcare = function renderChildcare() {
    var childrenAttendees = get_default()(selectedProposal, 'attendees.children');

    var includedChildrenActivities = resort.childrenActivities.filter(function (activity) {
      return activity.equipments.length > 1;
    });
    var onDemandChildrenActivities = resort.childrenActivities.filter(function (activity) {
      return !activity.isIncluded;
    });
    var shouldShowIncludedEquipments = Object(childcare_helper["f" /* hasChildrenAgedXOrLess */])(childrenAttendees, 6);
    return ServicesView_jsx("div", {
      className: "-mx-10 flex flex-wrap"
    }, ServicesView_jsx("div", {
      className: "w-full p-10 sm:w-2/3 md:w-3/4"
    }, ServicesView_jsx(ChildcareContext["a" /* ChildcareContext */].Provider, {
      value: childcareContextServicesValuesBE
    }, ServicesView_jsx(ServicesContext["a" /* ServicesContext */].Provider, {
      value: servicesContextValuesBE
    }, ServicesView_jsx(Childcare["a" /* Childcare */], {
      addChildcare: onAddChildcare,
      attendees: selectedProposal.attendees.children.map(function (child) {
        var referedChild = Object(childcare_helper["c" /* getCurrentKid */])(tripInformation.kids, child);
        return ServicesView_objectSpread(ServicesView_objectSpread({}, child), {}, {
          firstName: referedChild && referedChild.firstName,
          lastName: referedChild && referedChild.lastName
        });
      }),
      childcareAdditionalServices: selectedProposal.additionalServices.childcares,
      deleteChildcare: onDeleteChildcare,
      proposals: proposals
    })))), ServicesView_jsx("div", {
      className: "w-full p-10 sm:order-first sm:w-1/3 md:w-1/4"
    }, shouldShowIncludedEquipments && ServicesView_jsx(ChildcareIncludedEquipmentCapsule["a" /* ChildcareIncludedEquipmentCapsule */], {
      className: "mb-20",
      facilities: [].concat(Object(toConsumableArray["a" /* default */])(includedChildrenActivities), Object(toConsumableArray["a" /* default */])(resort.facilities))
    }), ServicesView_jsx(ChildcareOnDemandEquipmentCapsule["a" /* ChildcareOnDemandEquipmentCapsule */], {
      activities: onDemandChildrenActivities
    })));
  };

  return ServicesView_jsx(react["Fragment"], null, !(resort.isJoyview || resort.isUrbanOasis) && Object(infoBanner_utils["a" /* renderInfoBanner */])(ServicesView_objectSpread({
    infoBannerData: infoBannerData,
    departureDate: selectedProposal.departureDate,
    arrivalDate: selectedProposal.arrivalDate,
    currentStep: 'services'
  }, trackingDefaultPayload)), resort.isJoyview || resort.isUrbanOasis ? renderJoyView() : renderChildcare());
};

/* harmony default export */ var services_ServicesView = (ServicesView_ServicesView);
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__("IAdD");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/kebabCase.js
var kebabCase = __webpack_require__("s2Gj");
var kebabCase_default = /*#__PURE__*/__webpack_require__.n(kebabCase);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/values.js
var lodash_values = __webpack_require__("0iyY");
var values_default = /*#__PURE__*/__webpack_require__.n(lodash_values);

// EXTERNAL MODULE: ./src/client/components/widgets/promo-code/PromoCode.jsx + 2 modules
var PromoCode = __webpack_require__("mCPI");

// EXTERNAL MODULE: ./src/client/components/widgets/promo-code/DiscountsLine.jsx
var DiscountsLine = __webpack_require__("CYED");

// EXTERNAL MODULE: ./src/client/components/widgets/reserved-services-wrapper/ReservedServicesList.jsx + 3 modules
var ReservedServicesList = __webpack_require__("toM8");

// EXTERNAL MODULE: ./src/client/store/booking/option-validity/optionvalidity.action.js
var optionvalidity_action = __webpack_require__("F5c/");

// EXTERNAL MODULE: ./src/utils/option-validity/constants.js
var option_validity_constants = __webpack_require__("l/UU");

// EXTERNAL MODULE: ./src/client/components/widgets/accordion-block/AccordionBlock.jsx
var AccordionBlock = __webpack_require__("sORq");

// EXTERNAL MODULE: ./src/client/components/widgets/accommodation-summary/AccommodationSummary.jsx
var AccommodationSummary = __webpack_require__("g5cf");

// EXTERNAL MODULE: ./src/client/components/widgets/price-detail-block-lines/PriceDetailLines.jsx
var PriceDetailLines = __webpack_require__("y0X/");

// EXTERNAL MODULE: ./src/client/components/utils/price/price.util.js
var price_util = __webpack_require__("NXDx");

// EXTERNAL MODULE: ./src/client/components/widgets/great-members-loyalty-points/GreatMembersLoyaltyPoints.jsx
var GreatMembersLoyaltyPoints = __webpack_require__("b45f");

// CONCATENATED MODULE: ./src/client/views/booking/summary/insurance/insurance.constantes.js
var ADD_INSURANCE = 'addInsurance';
var DELETE_INSURANCE = 'deleteInsurance';
var INVALID_INSURANCE = 'invalidInsurance';
// CONCATENATED MODULE: ./src/client/views/booking/summary/insurance/InsuranceBody.jsx



var InsuranceBody_jsx = react_default.a.createElement;




var FormatedClause = function FormatedClause(_ref) {
  var clause = _ref.clause;
  var clauseParts = clause.split(':');

  if (clauseParts && clauseParts.length === 2) {
    return InsuranceBody_jsx("span", null, InsuranceBody_jsx("span", {
      className: "font-bold"
    }, clauseParts[0], " :"), clauseParts[1]);
  }

  return InsuranceBody_jsx("span", null, clause);
};

var InsuranceBody_InsuranceBody = function InsuranceBody(_ref2) {
  var company = _ref2.company,
      coverageDescriptions = _ref2.coverageDescriptions,
      label = _ref2.label,
      shortDescription = _ref2.shortDescription,
      _ref2$dataTestId = _ref2.dataTestId,
      dataTestId = _ref2$dataTestId === void 0 ? '' : _ref2$dataTestId;
  return InsuranceBody_jsx("div", {
    className: "p-20 sm:flex",
    "data-testid": dataTestId
  }, InsuranceBody_jsx("div", {
    className: "text-black md:pe-20"
  }, InsuranceBody_jsx("h3", {
    className: "mb-20 font-bold text-sienna"
  }, label), InsuranceBody_jsx("p", {
    className: "mb-20 text-16 font-bold"
  }, shortDescription), InsuranceBody_jsx("div", {
    className: "gap-20 md:flex"
  }, company.logo && InsuranceBody_jsx("div", {
    className: "mb-15 border-1 border-pearl px-80 py-30 md:mb-0"
  }, company ? InsuranceBody_jsx("img", {
    alt: company.label,
    src: company.logo
  }) : null), InsuranceBody_jsx("ul", null, coverageDescriptions.map(function (clause) {
    return InsuranceBody_jsx("li", {
      className: "mb-10 text-14 leading-tight",
      key: clause
    }, InsuranceBody_jsx(Icon["a" /* Icon */], {
      className: "me-5 text-blueWave",
      name: icons["a" /* ICONS */].CHECK,
      width: "1em"
    }), InsuranceBody_jsx(FormatedClause, {
      clause: clause
    }));
  })))));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/text-link/TextLink.jsx + 1 modules
var TextLink = __webpack_require__("jD8k");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-inputs/radio-button/RadioButton.jsx
var RadioButton = __webpack_require__("zwQs");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/Spinner.jsx
var Spinner = __webpack_require__("7amT");

// CONCATENATED MODULE: ./src/client/views/booking/summary/insurance/insurance.utils.js
var insuranceFieldName = 'insurance-terms-checkbox-insurance-';

// CONCATENATED MODULE: ./src/client/views/booking/summary/insurance/InsuranceCTA.jsx




var InsuranceCTA_jsx = react_default.a.createElement;




















var InsuranceCTA_FormatedInformationAndTerms = function FormatedInformationAndTerms(_ref) {
  var attachedDocuments = _ref.attachedDocuments,
      isChecked = _ref.isChecked;

  var _useAppContext = Object(ReactAppContext["c" /* useAppContext */])(),
      isSeller = _useAppContext.isSeller;

  return InsuranceCTA_jsx(react["Fragment"], null, InsuranceCTA_jsx("span", {
    className: Object(classnames_utils["a" /* classnames */])('me-5', {
      'text-red': !isChecked
    }, {
      'text-black': isChecked
    })
  }, Object(src_i18n["h" /* t */])(isSeller ? 'booking.partners.insurance.termsAndCondition' : 'booking.insurance.addInsurance'), ":"), attachedDocuments.map(function (_ref2) {
    var label = _ref2.label,
        url = _ref2.url;
    return InsuranceCTA_jsx(TextLink["a" /* TextLink */], {
      color: isChecked ? colors["a" /* COLORS */].BLACK : colors["a" /* COLORS */].RED,
      className: "me-5",
      "data-testid": "insurance-cgv-pdf",
      key: label,
      label: label,
      url: url
    });
  }));
};

function InsuranceCTA(_ref3) {
  var attachedDocuments = _ref3.attachedDocuments,
      id = _ref3.id,
      insurance = _ref3.insurance,
      isLoading = _ref3.isLoading,
      onChange = _ref3.onChange,
      setAddedInsuranceNow = _ref3.setAddedInsuranceNow,
      _ref3$dataTestId = _ref3.dataTestId,
      dataTestId = _ref3$dataTestId === void 0 ? '' : _ref3$dataTestId;
  var isAdded = false;
  var termsChecked = false;
  var isDeleted = false;
  var insurancesStore = Object(es["e" /* useSelector */])(booking_selector["o" /* getInsurancesStore */]);

  if (insurancesStore[id]) {
    isAdded = insurancesStore[id].isAdded;
    isDeleted = insurancesStore[id].isDeleted;
    termsChecked = insurancesStore[id].termsChecked;
  }

  var dispatch = Object(es["d" /* useDispatch */])();

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var refuseInsurance = function refuseInsurance() {
    if (!isDeleted) {
      trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_UPSELL, {
        detail_click: 'remove_insurance'
      });
      onChange(insurance, DELETE_INSURANCE);
    }
  };

  var addInsuranceAction = function addInsuranceAction() {
    if (!isAdded && !insurance.pricingInfo.isPartiallyRented) {
      trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_UPSELL, {
        detail_click: 'add_insurance'
      });
      setAddedInsuranceNow(true);
      onChange(insurance, ADD_INSURANCE);
    }
  };

  return InsuranceCTA_jsx("div", {
    className: "px-20 pt-20",
    "data-testid": dataTestId
  }, InsuranceCTA_jsx("div", {
    className: "mb-20"
  }, InsuranceCTA_jsx(formik_esm["d" /* Formik */], {
    initialValues: Object(defineProperty["a" /* default */])({}, insuranceFieldName + id, termsChecked)
  }, function () {
    var _insurance$pricingInf;

    return InsuranceCTA_jsx(formik_esm["c" /* Form */], null, InsuranceCTA_jsx("div", {
      role: "group",
      "aria-labelledby": "insurance-group",
      id: "form-".concat(insuranceFieldName).concat(kebabCase_default()(id))
    }, InsuranceCTA_jsx("div", {
      className: "mb-10 grid grid-cols-2 items-center rounded-12 border-1 border-lightGrey bg-white px-20 py-10"
    }, Object(src_i18n["h" /* t */])('booking.insurance.addInsuranceButton'), InsuranceCTA_jsx("div", {
      className: "flex items-center justify-end gap-10"
    }, InsuranceCTA_jsx("p", {
      className: "text-12 font-bold text-sienna md:text-14"
    }, "+ ", (_insurance$pricingInf = insurance.pricingInfo.totalPrice) === null || _insurance$pricingInf === void 0 ? void 0 : _insurance$pricingInf.formattedValue), isLoading && InsuranceCTA_jsx(Spinner["a" /* Spinner */], {
      size: "small"
    }), InsuranceCTA_jsx(RadioButton["a" /* RadioButton */], {
      dataTestid: "add-insurance-button",
      isChecked: isAdded,
      isDisabled: isLoading,
      onClick: function onClick() {
        addInsuranceAction();
      }
    }))), InsuranceCTA_jsx("div", {
      className: "grid grid-cols-2 items-center rounded-12 border-1 border-lightGrey bg-white px-20 py-10"
    }, Object(src_i18n["h" /* t */])('booking.insurance.removeInsurance'), InsuranceCTA_jsx("div", {
      className: "flex justify-end gap-10"
    }, isLoading && InsuranceCTA_jsx(Spinner["a" /* Spinner */], {
      size: "small"
    }), InsuranceCTA_jsx(RadioButton["a" /* RadioButton */], {
      dataTestid: "remove-insurance-button",
      isChecked: isDeleted,
      isDisabled: isLoading,
      onClick: function onClick() {
        refuseInsurance();
      }
    }))), InsuranceCTA_jsx(lib["UnmountClosed"], {
      isOpened: isAdded
    }, InsuranceCTA_jsx(formik_esm["c" /* Form */], null, InsuranceCTA_jsx(FormikInput["a" /* FormikInput */], {
      className: "mt-20 inline",
      dataTestId: "insuranceTerms",
      label: InsuranceCTA_jsx(InsuranceCTA_FormatedInformationAndTerms, {
        attachedDocuments: attachedDocuments,
        isChecked: !isAdded || termsChecked || isDeleted
      }),
      name: insuranceFieldName + id,
      onChange: function onChange() {
        dispatch(Object(createAction["b" /* default */])(proposals_constants["I" /* TOGGLE_TERMS */], id));
      },
      type: "checkbox"
    })))));
  })));
}
// EXTERNAL MODULE: ./src/client/components/frameworks/notification/Notification.jsx + 1 modules
var Notification = __webpack_require__("VO9w");

// CONCATENATED MODULE: ./src/client/views/booking/summary/insurance/InsuranceFeedback.jsx

var InsuranceFeedback_jsx = react_default.a.createElement;




var InsuranceFeedback_InsuranceFeedback = function InsuranceFeedback(_ref) {
  var name = _ref.name,
      text = _ref.text,
      type = _ref.type;
  var isError = type === 'error';
  var icon = isError ? icons["a" /* ICONS */].WARNING : icons["a" /* ICONS */].CHECK_OUTLINE;
  return InsuranceFeedback_jsx(Notification["a" /* Notification */], {
    className: Object(classnames_utils["a" /* classnames */])('bg-transparent', isError ? 'text-red' : 'text-green'),
    "data-testid": name,
    iconName: icon,
    iconWidth: "1.25rem"
  }, InsuranceFeedback_jsx("p", {
    className: "m-0 font-sans text-14 leading-normal"
  }, text));
};
// CONCATENATED MODULE: ./src/client/views/booking/summary/insurance/Insurance.jsx

var Insurance_jsx = react_default.a.createElement;











var Insurance_Insurance = function Insurance(_ref) {
  var _insurance$productInf;

  var errorMessageCode = _ref.errorMessageCode,
      insurance = _ref.insurance,
      isContinueActionClicked = _ref.isContinueActionClicked,
      isLoading = _ref.isLoading,
      onChange = _ref.onChange,
      _ref$dataTestId = _ref.dataTestId,
      dataTestId = _ref$dataTestId === void 0 ? '' : _ref$dataTestId;

  var _useState = Object(react["useState"])(false),
      addedInsuranceNow = _useState[0],
      setAddedInsuranceNow = _useState[1];

  var _insurance$pricingInf = insurance.pricingInfo,
      id = _insurance$pricingInf.id,
      price = _insurance$pricingInf.totalPrice;
  var label = insurance.productInfo.label;

  var _ref2 = (insurance === null || insurance === void 0 ? void 0 : (_insurance$productInf = insurance.productInfo.insuranceDetails) === null || _insurance$productInf === void 0 ? void 0 : _insurance$productInf.find(function (detail) {
    return detail.id === id;
  })) || {},
      _ref2$coverageDescrip = _ref2.coverageDescriptions,
      coverageDescriptions = _ref2$coverageDescrip === void 0 ? [] : _ref2$coverageDescrip,
      _ref2$attachedDocumen = _ref2.attachedDocuments,
      attachedDocuments = _ref2$attachedDocumen === void 0 ? [] : _ref2$attachedDocumen,
      shortDescription = _ref2.shortDescription,
      company = _ref2.company;

  var isAdded = false;
  var termsChecked = false;
  var isDeleted = false;
  var insurancesStore = Object(es["e" /* useSelector */])(booking_selector["o" /* getInsurancesStore */]);

  if (insurancesStore[id]) {
    isAdded = insurancesStore[id].isAdded;
    isDeleted = insurancesStore[id].isDeleted;
    termsChecked = insurancesStore[id].termsChecked;
  }

  var hasJustSubscribedToInsurance = isAdded && !isDeleted && addedInsuranceNow;
  var submittedWithInsuranceWithoutTermsChecked = isAdded && !termsChecked && !isDeleted && isContinueActionClicked;
  return Insurance_jsx("div", {
    "data-testid": dataTestId
  }, Insurance_jsx("div", {
    className: "mb-15"
  }, Insurance_jsx("div", {
    className: "pb-25 bg-pearl rounded-12"
  }, !!price && Insurance_jsx(InsuranceBody_InsuranceBody, {
    label: label,
    shortDescription: shortDescription,
    coverageDescriptions: coverageDescriptions,
    company: company,
    price: price,
    dataTestId: "insurance-info"
  }), Insurance_jsx(InsuranceCTA, {
    id: id,
    insurance: insurance,
    isLoading: isLoading,
    onChange: onChange,
    attachedDocuments: attachedDocuments,
    setAddedInsuranceNow: setAddedInsuranceNow,
    dataTestId: "insurance-choice"
  }), isContinueActionClicked && errorMessageCode === INVALID_INSURANCE && Insurance_jsx("div", {
    className: "px-20"
  }, Insurance_jsx(InsuranceFeedback_InsuranceFeedback, {
    name: "insurance-invalid-error",
    text: Object(src_i18n["h" /* t */])('booking.insurance.errorMessage2'),
    type: "error"
  })), isContinueActionClicked && (isDeleted || isAdded && termsChecked) && Insurance_jsx("div", {
    className: "px-20"
  }, Insurance_jsx(InsuranceFeedback_InsuranceFeedback, {
    name: "insurance-added",
    text: Object(src_i18n["h" /* t */])('booking.insurance.noInsurance'),
    type: "notice"
  })), submittedWithInsuranceWithoutTermsChecked && Insurance_jsx("div", {
    className: "px-20"
  }, Insurance_jsx(InsuranceFeedback_InsuranceFeedback, {
    name: "insurance-terms-error",
    text: Object(src_i18n["h" /* t */])('booking.insurance.errorMessage3'),
    type: "error"
  })))), hasJustSubscribedToInsurance && Insurance_jsx(Toast["a" /* Toast */], {
    color: colors["a" /* COLORS */].GREEN,
    icon: icons["a" /* ICONS */].CHECK_OUTLINE,
    label: Object(src_i18n["h" /* t */])('booking.insurance.insuranceTaken'),
    onClose: function onClose() {
      return setAddedInsuranceNow(false);
    },
    visible: addedInsuranceNow
  }));
};
// CONCATENATED MODULE: ./src/client/views/booking/summary/SummaryView.tracking.js









function SummaryView_tracking_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function SummaryView_tracking_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? SummaryView_tracking_ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : SummaryView_tracking_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}



function SummaryView_tracking_trackClick(labelGA, appContext) {
  tracking_api["b" /* setDataLayer */](SummaryView_tracking_objectSpread(SummaryView_tracking_objectSpread({}, booking_constants["c" /* BE_GA_DEFAULT_PAYLOAD */]), {}, {
    versionBooking: 'responsive',
    actionGA: 'summary',
    labelGA: labelGA
  }), appContext);
}
// CONCATENATED MODULE: ./src/client/components/frameworks/banner-with-button/BannerWithButton.jsx
var BannerWithButton_jsx = react_default.a.createElement;






var BannerWithButton_BannerWithButton = function BannerWithButton(_ref) {
  var ctaText = _ref.ctaText,
      ctaAction = _ref.ctaAction,
      bannerTitle = _ref.bannerTitle,
      _ref$bannerPadding = _ref.bannerPadding,
      bannerPadding = _ref$bannerPadding === void 0 ? 'p-0' : _ref$bannerPadding,
      _ref$iconColor = _ref.iconColor,
      iconColor = _ref$iconColor === void 0 ? 'inherit' : _ref$iconColor,
      iconName = _ref.iconName,
      _ref$iconWidth = _ref.iconWidth,
      iconWidth = _ref$iconWidth === void 0 ? '3rem' : _ref$iconWidth,
      middleTextTitle = _ref.middleTextTitle,
      middleTextDesc = _ref.middleTextDesc,
      rightTextDesc = _ref.rightTextDesc,
      _ref$dataTestId = _ref.dataTestId,
      dataTestId = _ref$dataTestId === void 0 ? '' : _ref$dataTestId;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var isMobile = !isTablet;
  return BannerWithButton_jsx("div", {
    "data-testid": dataTestId
  }, BannerWithButton_jsx(Title["a" /* Title */], {
    className: "mb-20",
    theme: "title-brand-n2"
  }, bannerTitle), BannerWithButton_jsx("div", {
    className: "rounded-12 border-1 border-lightGrey bg-white"
  }, BannerWithButton_jsx("div", {
    className: "flex flex-col gap-10 md:flex-row md:justify-between ".concat(bannerPadding)
  }, BannerWithButton_jsx("div", {
    className: "flex w-full items-center gap-20 md:items-start"
  }, BannerWithButton_jsx(Icon["a" /* Icon */], {
    className: "text-".concat(iconColor),
    hasRtl: true,
    name: iconName,
    width: iconWidth
  }), BannerWithButton_jsx("div", {
    className: "w-full"
  }, BannerWithButton_jsx("div", {
    className: "flex w-full items-center justify-between text-14"
  }, middleTextTitle, middleTextDesc, BannerWithButton_jsx("p", {
    className: "w-1/3 text-right text-14 font-bold"
  }, Object(src_i18n["h" /* t */])('common.freeService'))), !isMobile && BannerWithButton_jsx("div", {
    className: "flex-1 text-14"
  }, rightTextDesc))), isMobile && BannerWithButton_jsx("div", {
    className: "flex-1 text-14"
  }, rightTextDesc)), BannerWithButton_jsx("div", {
    className: "mx-20 mb-20 mt-15 flex justify-center md:justify-end"
  }, BannerWithButton_jsx(Button["a" /* Button */], {
    className: "text-12 font-bold",
    "data-selector": "bannerWithButton-cta",
    "data-testid": "bannerWithButtonCta",
    onClick: ctaAction,
    size: "medium"
  }, ctaText))));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/template-string/TemplateString.jsx
var TemplateString = __webpack_require__("Ohju");

// CONCATENATED MODULE: ./src/client/views/booking/summary/option-modal/OptionModal.jsx
var OptionModal_jsx = react_default.a.createElement;








var OptionModal_OptionModal = function OptionModal(_ref) {
  var imageUrl = _ref.imageUrl,
      proposalId = _ref.proposalId,
      onClose = _ref.onClose,
      onClick = _ref.onClick,
      _ref$isOptionAllowed = _ref.isOptionAllowed,
      isOptionAllowed = _ref$isOptionAllowed === void 0 ? false : _ref$isOptionAllowed,
      optionDuration = _ref.optionDuration,
      disclaimer = _ref.disclaimer;
  return OptionModal_jsx(Modal["a" /* Modal */], {
    ariaLabel: Object(src_i18n["h" /* t */])(isOptionAllowed ? 'booking.option.popin.header' : 'booking.callCenterPopIn.title'),
    ariaLabelledby: identifiers_constants["t" /* ID_MODAL_HEADER__BE__OPTION */],
    closeLabel: Object(src_i18n["h" /* t */])('common.close'),
    onClose: onClose
  }, OptionModal_jsx("div", {
    className: "overflow-hidden",
    "data-testid": "SummaryView-optionModal"
  }, OptionModal_jsx("div", {
    className: "relative h-228 overflow-hidden"
  }, !!imageUrl && OptionModal_jsx("img", {
    src: imageUrl,
    className: "w-full",
    alt: ""
  }), OptionModal_jsx("div", {
    className: "absolute inset-0 flex items-center justify-center"
  }, OptionModal_jsx(Icon["a" /* Icon */], {
    className: "text-white",
    hasRtl: true,
    name: icons["a" /* ICONS */].CALENDAR_OPTION,
    width: "7rem"
  }))), OptionModal_jsx("div", {
    className: "m-25 text-center"
  }, OptionModal_jsx("div", {
    id: identifiers_constants["t" /* ID_MODAL_HEADER__BE__OPTION */],
    className: "mb-10 font-brand text-24 text-black"
  }, Object(src_i18n["h" /* t */])(isOptionAllowed ? 'booking.option.popin.header' : 'booking.callCenterPopIn.title')), isOptionAllowed ? OptionModal_jsx("div", {
    className: "mb-5 flex flex-col justify-center"
  }, OptionModal_jsx("div", {
    className: "p-10 text-16"
  }, Object(src_i18n["h" /* t */])('booking.option.popinDescription'), disclaimer), optionDuration && OptionModal_jsx("p", {
    className: "m-auto max-w-280 p-10 text-16"
  }, OptionModal_jsx(TemplateString["a" /* TemplateString */], {
    dataTestId: "optionEndDate",
    className: "font-bold text-sienna",
    template: Object(src_i18n["h" /* t */])('booking.summary.optionDuration'),
    values: {
      duration: optionDuration
    }
  }))) : OptionModal_jsx(react["Fragment"], null, OptionModal_jsx("p", {
    className: "mb-10 inline-flex items-center rounded-12 border-2 border-sienna p-10 text-sienna"
  }, OptionModal_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].PHONE_BUBBLE,
    width: "2em"
  }), OptionModal_jsx("span", {
    className: "block font-bold"
  }, " ", Object(src_i18n["h" /* t */])('booking.callCenterPopIn.number'))), OptionModal_jsx("span", {
    className: "block text-10 text-black"
  }, Object(src_i18n["h" /* t */])('booking.callCenterPopIn.cost')), OptionModal_jsx("div", {
    className: "p-10 text-16"
  }, Object(src_i18n["h" /* t */])('booking.callCenterPopIn.useProposalIdLabel'))), OptionModal_jsx(Button["a" /* Button */], {
    className: "mb-15 mt-30 min-w-200",
    "data-testid": "pauseOptionModalButton",
    onClick: onClick
  }, Object(src_i18n["h" /* t */])('booking.option.buttonLabel')), OptionModal_jsx("div", {
    className: "font-bold"
  }, Object(src_i18n["h" /* t */])('common.reference'), " : ", proposalId))));
};
// CONCATENATED MODULE: ./src/client/views/booking/summary/option-block/OptionBlock.jsx
var OptionBlock_jsx = react_default.a.createElement;










var OptionBlock_OptionBlock = function OptionBlock(_ref) {
  var showOptionButton = _ref.showOptionButton,
      onOptionTaking = _ref.onOptionTaking,
      duration = _ref.duration,
      isBookingAlreadyExistsErrorMessageOpen = _ref.isBookingAlreadyExistsErrorMessageOpen,
      proposalId = _ref.proposalId,
      resortImage = _ref.resortImage,
      isOptionAllowed = _ref.isOptionAllowed,
      onOptionButtonClick = _ref.onOptionButtonClick,
      onOptionModalClose = _ref.onOptionModalClose,
      toggleOptionModal = _ref.toggleOptionModal,
      _ref$disclaimer = _ref.disclaimer,
      disclaimer = _ref$disclaimer === void 0 ? '' : _ref$disclaimer,
      durationDisclaimer = _ref.durationDisclaimer;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var onOptionModalButtonClick = function onOptionModalButtonClick() {
    onOptionTaking();
    onOptionModalClose();
    trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_SUMMARY, {
      detail_click: 'hold_option_validate'
    });
  };

  return OptionBlock_jsx(react_default.a.Fragment, null, OptionBlock_jsx("div", {
    className: "mx-auto mb-20 max-w-site-medium",
    "data-testid": "bloc-option",
    id: "bloc-option"
  }, showOptionButton && OptionBlock_jsx(BannerWithButton_BannerWithButton, {
    bannerPadding: "px-20 pt-20",
    bannerTitle: Object(src_i18n["h" /* t */])('booking.option.title'),
    ctaText: Object(src_i18n["h" /* t */])('booking.option.buttonLabel'),
    ctaAction: onOptionButtonClick,
    iconName: icons["a" /* ICONS */].CALENDAR_OPTION,
    iconColor: colors["a" /* COLORS */].SIENNA,
    iconWidth: "1.875rem",
    middleTextDesc: OptionBlock_jsx("p", {
      className: "text-16 font-bold"
    }, Object(src_i18n["h" /* t */])('booking.option.subLabel2')),
    rightTextDesc: OptionBlock_jsx("div", {
      className: "flex flex-col"
    }, "".concat(Object(src_i18n["h" /* t */])('booking.option.description')), duration && OptionBlock_jsx("div", null, !durationDisclaimer && OptionBlock_jsx("p", {
      "data-testid": "optionEndDate"
    }, Object(src_i18n["h" /* t */])('booking.option.DurationDisclaimer')), OptionBlock_jsx("p", {
      className: "font-bold"
    }, Object(src_i18n["h" /* t */])('booking.summary.optionDuration', {
      duration: duration
    })))),
    dataTestId: "option-block"
  }), isBookingAlreadyExistsErrorMessageOpen && OptionBlock_jsx(Notification["a" /* Notification */], {
    className: "bg-transparent text-red",
    iconName: icons["a" /* ICONS */].WARNING
  }, OptionBlock_jsx("p", {
    className: "m-0 font-sans text-14 leading-normal text-red"
  }, Object(src_i18n["h" /* t */])('booking.cxo.warning.bookingExists')))), toggleOptionModal && OptionBlock_jsx(OptionModal_OptionModal, {
    onClose: onOptionModalClose,
    imageUrl: resortImage,
    onClick: onOptionModalButtonClick,
    proposalId: proposalId,
    isOptionAllowed: isOptionAllowed,
    optionDuration: duration,
    disclaimer: disclaimer
  }));
};

/* harmony default export */ var option_block_OptionBlock = (OptionBlock_OptionBlock);
// CONCATENATED MODULE: ./src/client/components/frameworks/modal-with-image-icon/ModalWithImageIcon.jsx
var ModalWithImageIcon_jsx = react_default.a.createElement;




var ModalWithImageIcon_ModalWithImageIcon = function ModalWithImageIcon(_ref) {
  var imageUrl = _ref.imageUrl,
      icon = _ref.icon,
      onClose = _ref.onClose,
      children = _ref.children;
  return ModalWithImageIcon_jsx(Modal["a" /* Modal */], {
    closeLabel: Object(src_i18n["h" /* t */])('common.close'),
    onClose: onClose
  }, ModalWithImageIcon_jsx("div", {
    className: "overflow-hidden"
  }, ModalWithImageIcon_jsx("div", {
    className: "left-0 top-0 -z-1 flex h-228 w-full items-center justify-center bg-cover bg-center bg-no-repeat",
    "data-testid": "Modal-backgroundImage",
    style: {
      backgroundImage: "url(".concat(imageUrl, ")")
    }
  }, ModalWithImageIcon_jsx(Icon["a" /* Icon */], {
    className: "text-white",
    dataTestid: "Modal-icon",
    name: icon,
    width: "7em"
  })), children));
};
// CONCATENATED MODULE: ./src/client/views/booking/summary/option-modal/FtcOptionModal.jsx
var FtcOptionModal_jsx = react_default.a.createElement;






var FtcOptionModal_FtcOptionModal = function FtcOptionModal(_ref) {
  var imageUrl = _ref.imageUrl,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? icons["a" /* ICONS */].PROMO_CODE : _ref$icon,
      proposalId = _ref.proposalId,
      onClose = _ref.onClose,
      onClick = _ref.onClick;
  var ftcPopinTitle = 'booking.summary.futureTravelCredit.popinTitle';
  var ftcPopinDescription = 'booking.summary.futureTravelCredit.popinDescription';
  var ftcPopinDescription2 = 'booking.summary.futureTravelCredit.popinDescription2';
  return FtcOptionModal_jsx(ModalWithImageIcon_ModalWithImageIcon, {
    onClose: onClose,
    imageUrl: imageUrl,
    icon: icon
  }, FtcOptionModal_jsx("div", {
    className: "m-25 text-center"
  }, FtcOptionModal_jsx("div", {
    id: identifiers_constants["t" /* ID_MODAL_HEADER__BE__OPTION */],
    className: "mb-10 font-brand text-28 text-saffron"
  }, Object(src_i18n["h" /* t */])(ftcPopinTitle)), FtcOptionModal_jsx("div", {
    className: "m-0 p-10 pb-0 text-18 font-bold"
  }, FtcOptionModal_jsx("span", {
    className: "block text-red"
  }, Object(src_i18n["h" /* t */])(ftcPopinDescription))), FtcOptionModal_jsx("div", {
    className: "m-0 p-10 text-16"
  }, Object(src_i18n["h" /* t */])(ftcPopinDescription2)), FtcOptionModal_jsx(Button["a" /* Button */], {
    className: "my-15 min-w-280 text-16 uppercase",
    "data-testid": "pauseFtcOptionModalButton",
    onClick: onClick,
    size: "medium"
  }, Object(src_i18n["h" /* t */])('booking.summary.futureTravelCredit.callToAction')), FtcOptionModal_jsx("div", {
    className: "font-bold"
  }, Object(src_i18n["h" /* t */])('common.reference'), " : ", proposalId)));
};
// EXTERNAL MODULE: ./src/client/views/booking/summary/SummaryView.utils.js
var SummaryView_utils = __webpack_require__("X3Cs");

// CONCATENATED MODULE: ./src/client/views/booking/summary/SummaryView.jsx




















var SummaryView_jsx = react_default.a.createElement;


function SummaryView_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function SummaryView_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { SummaryView_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { SummaryView_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












































var SummaryView_constants$PACKAGES = dist["constants"].PACKAGES,
    SummaryView_JOYVIEW_ALL_INCLUSIVE = SummaryView_constants$PACKAGES.JOYVIEW_ALL_INCLUSIVE,
    SummaryView_JOYVIEW_FOOD_AND_BEVERAGES = SummaryView_constants$PACKAGES.JOYVIEW_FOOD_AND_BEVERAGES;
var initialState = {
  isLoading: false,
  toggleOptionModal: false,
  isFtcPopinOpened: false,
  isContinueActionClicked: false,
  openBookingAlreadyExistsErrorMessage: false,
  duration: null
};

var reducer = function reducer(state, action) {
  switch (action.type) {
    case 'toggleLoading':
      return SummaryView_objectSpread(SummaryView_objectSpread({}, state), {}, {
        isLoading: !state.isLoading
      });

    case 'updateInsuranceError':
      return SummaryView_objectSpread(SummaryView_objectSpread({}, state), {}, {
        // $FlowFixMe
        insuranceError: SummaryView_objectSpread(SummaryView_objectSpread({}, state.insuranceError), action.payload)
      });

    case 'openOptionModal':
      return SummaryView_objectSpread(SummaryView_objectSpread({}, state), {}, {
        toggleOptionModal: !state.toggleOptionModal
      });

    case 'toggleFtcPopin':
      return SummaryView_objectSpread(SummaryView_objectSpread({}, state), {}, {
        isFtcPopinOpened: !state.isFtcPopinOpened
      });

    case 'setContinueActionClicked':
      return SummaryView_objectSpread(SummaryView_objectSpread({}, state), {}, {
        isContinueActionClicked: action.payload
      });

    case 'setOpenBookingAlreadyExistsErrorMessage':
      return SummaryView_objectSpread(SummaryView_objectSpread({}, state), {}, {
        openBookingAlreadyExistsErrorMessage: action.payload
      });

    case 'setDuration':
      return SummaryView_objectSpread(SummaryView_objectSpread({}, state), {}, {
        duration: action.payload
      });

    default:
      return state;
  }
};

var SummaryView_SummaryView = function SummaryView(_ref) {
  var _selectedProposal$pri;

  var i18n = _ref.i18n,
      infoBannerData = _ref.infoBannerData,
      isOptionHoldOnly = _ref.isOptionHoldOnly,
      proposals = _ref.proposals,
      resort = _ref.resort,
      selectedProposal = _ref.selectedProposal,
      setTimerInitialValue = _ref.setTimerInitialValue,
      showTimer = _ref.showTimer;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var router = Object(next_router["useRouter"])();
  var context = Object(react["useContext"])(ReactAppContext["a" /* B2CAppContext */]);

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var isMobile = !isTablet;
  var priceWithDonation = Object(price_util["c" /* getTotalPriceWithDonation */])(selectedProposal.price, context.locale);
  var isJoyview = resort.isJoyview,
      isUrbanOasis = resort.isUrbanOasis;
  var isJoyViewAllInclusive = selectedProposal.packageId === SummaryView_JOYVIEW_ALL_INCLUSIVE && isJoyview;
  var isUrbanOasisAllInclusive = selectedProposal.packageId === SummaryView_JOYVIEW_ALL_INCLUSIVE && isUrbanOasis;
  var isUrbanOasisFoodAndBeverage = selectedProposal.packageId === SummaryView_JOYVIEW_FOOD_AND_BEVERAGES && isUrbanOasis;

  var _getOffersAndDiscount = Object(SummaryView_utils["a" /* getOffersAndDiscounts */])((selectedProposal === null || selectedProposal === void 0 ? void 0 : (_selectedProposal$pri = selectedProposal.price) === null || _selectedProposal$pri === void 0 ? void 0 : _selectedProposal$pri.discounts) || []),
      discounts = _getOffersAndDiscount.discounts,
      offers = _getOffersAndDiscount.offers;

  var dispatch = Object(es["d" /* useDispatch */])();

  var onLoadingStart = function onLoadingStart() {
    return dispatch(Object(globalLoader_action["d" /* startLoading */])());
  };

  var onLoadingEnd = function onLoadingEnd() {
    return dispatch(Object(globalLoader_action["c" /* endLoading */])());
  };

  var onDeleteInsuranceFromProposals = function onDeleteInsuranceFromProposals(addOrRemoveInsuranceParams) {
    return dispatch(Object(proposals_action["h" /* deleteInsurances */])(addOrRemoveInsuranceParams));
  };

  var onAddInsuranceToProposals = function onAddInsuranceToProposals(addOrRemoveInsuranceParams) {
    return dispatch(Object(proposals_action["c" /* addInsurances */])(addOrRemoveInsuranceParams));
  };

  var onSetOptionValidity = function onSetOptionValidity() {
    return dispatch(Object(optionvalidity_action["a" /* setOptionValidity */])(context));
  };

  var onRefuseInsuranceAction = function onRefuseInsuranceAction(insuranceId) {
    return dispatch(Object(proposals_action["s" /* refuseInsuranceAction */])(insuranceId));
  };

  var getInitialInsuranceState = function getInitialInsuranceState() {
    var _selectedProposal$add;

    var insuranceError = (_selectedProposal$add = selectedProposal.additionalServices.insurance) === null || _selectedProposal$add === void 0 ? void 0 : _selectedProposal$add.reduce(function (acc, ins) {
      var _ins$pricingInfo = ins.pricingInfo,
          id = _ins$pricingInfo.id,
          isPartiallyRented = _ins$pricingInfo.isPartiallyRented;
      return SummaryView_objectSpread(SummaryView_objectSpread({}, acc), {}, Object(defineProperty["a" /* default */])({}, id, isPartiallyRented ? ADD_INSURANCE : ''));
    }, {});
    return insuranceError;
  };

  var _useReducer = Object(react["useReducer"])(reducer, SummaryView_objectSpread(SummaryView_objectSpread({}, initialState), {}, {
    insuranceError: getInitialInsuranceState()
  })),
      state = _useReducer[0],
      componentDispatch = _useReducer[1];

  var reservedServicesByAttendee = Object(es["e" /* useSelector */])(booking_selector["u" /* getReservedServicesByAttendee */]);
  var insurances = Object(es["e" /* useSelector */])(booking_selector["o" /* getInsurancesStore */]);

  var hasNotRefusedNeitherCheckedCgusOfSomeInsurances = function hasNotRefusedNeitherCheckedCgusOfSomeInsurances() {
    return values_default()(insurances).some(function (ins) {
      return !(ins === null || ins === void 0 ? void 0 : ins.termsChecked) && !(ins === null || ins === void 0 ? void 0 : ins.isDeleted);
    });
  };

  Object(react["useEffect"])(function () {
    if (showTimer) {
      var newDateTime = moment_default()().add(15, 'minutes').unix(); // initialize timer only in summary step for chinese locale and proposals with transport

      setTimerInitialValue(newDateTime);
      sessionStorage.setItem(getChinaTimerSessionKey(selectedProposal.id), newDateTime.toString());
    }

    onSetOptionValidity();

    if (selectedProposal.expirationDateTime) {
      componentDispatch({
        type: 'setDuration',
        payload: Object(apiDate["i" /* getDiffFromNowTo */])(selectedProposal === null || selectedProposal === void 0 ? void 0 : selectedProposal.expirationDateTime)
      });
    }
  }, []);
  var areInsurancesChoicesValid = Object(react["useCallback"])(function () {
    var _selectedProposal$add2;

    var hasError = false;
    var insurancesActualState = state.insuranceError;
    var insurancesStateToCheck = state.insuranceError;

    for (var insuranceId in insurancesActualState) {
      if ((isEmpty_default()(insurancesActualState[insuranceId]) || insurancesActualState[insuranceId] === INVALID_INSURANCE) && !insurances[insuranceId].isDeleted) {
        hasError = true;
        Object(scrollToElement["a" /* scrollToElement */])('#form-' + insuranceFieldName + kebabCase_default()(insuranceId));
        Object.assign(insurancesStateToCheck, Object(defineProperty["a" /* default */])({}, insuranceId, INVALID_INSURANCE));
      }
    }

    if (hasError || (selectedProposal === null || selectedProposal === void 0 ? void 0 : (_selectedProposal$add2 = selectedProposal.additionalServices.insurance) === null || _selectedProposal$add2 === void 0 ? void 0 : _selectedProposal$add2.length) !== 0 && hasNotRefusedNeitherCheckedCgusOfSomeInsurances()) {
      Object(BookingEngine_tracking["c" /* trackNavigation */])('summary', 'insuranceError', context);
      componentDispatch({
        type: 'updateInsuranceError',
        payload: {
          insurancesStateToCheck: insurancesStateToCheck
        }
      });
      componentDispatch({
        type: 'setContinueActionClicked',
        payload: true
      });
      return Promise.reject();
    }

    return Promise.resolve();
  }, [selectedProposal, state.insuranceError, insurances]);
  Object(useBookingNavbar["a" /* useBookingNavbar */])({
    isPriceLoading: state.isLoading,
    noEdit: false,
    overwriteContinueButton: isOptionHoldOnly,
    validationCallback: areInsurancesChoicesValid
  }); // add, remove or refuse an insurance

  var insuranceActions = function insuranceActions(insurance, action) {
    componentDispatch({
      type: 'toggleLoading'
    });
    var insuranceId = insurance.pricingInfo.id;
    var proposalIds = proposals.map(function (_ref2) {
      var id = _ref2.id;
      return id;
    });
    var lightAttendee = selectedProposal.attendees ? selectedProposal.attendees.list.map(function (_ref3) {
      var id = _ref3.id;
      return {
        id: id
      };
    }) : [];
    var addOrRemoveInsuranceParams = {
      proposalIds: proposalIds,
      insurance: insurance,
      attendeeIds: lightAttendee.map(function (_ref4) {
        var id = _ref4.id;
        return id;
      }),
      appContext: context
    };

    if (action === ADD_INSURANCE) {
      Object(BookingEngine_tracking["c" /* trackNavigation */])('summary', 'insuranceSubscribe', context);

      var addInsuranceStateById = function addInsuranceStateById() {
        componentDispatch({
          type: 'toggleLoading'
        });
        componentDispatch({
          type: 'updateInsuranceError',
          payload: Object(defineProperty["a" /* default */])({}, insuranceId, ADD_INSURANCE)
        });
      };

      onAddInsuranceToProposals(addOrRemoveInsuranceParams).then(addInsuranceStateById);
    } else {
      // ACTION REMOVE
      Object(BookingEngine_tracking["c" /* trackNavigation */])('summary', 'insuranceNotSubscribe', context);

      var deleteInsuranceStateById = function deleteInsuranceStateById() {
        componentDispatch({
          type: 'toggleLoading'
        });
        componentDispatch({
          type: 'updateInsuranceError',
          payload: Object(defineProperty["a" /* default */])({}, insuranceId, DELETE_INSURANCE)
        });
      };

      var isInsuranceAlreadyAddedToProposal = insurance.pricingInfo.isPartiallyRented;

      if (isInsuranceAlreadyAddedToProposal) {
        onDeleteInsuranceFromProposals(addOrRemoveInsuranceParams).then(deleteInsuranceStateById);
      } else {
        // equivalent to just refuse the insurance, no request is involved in this case
        deleteInsuranceStateById();
      }

      onRefuseInsuranceAction(insuranceId);
    }
  };

  var takeAnOption = /*#__PURE__*/function () {
    var _ref5 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var withfutureTravelCredits,
          status,
          _args = arguments;
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              withfutureTravelCredits = _args.length > 0 && _args[0] !== undefined ? _args[0] : false;
              SummaryView_tracking_trackClick('saveOption_popin', context);
              onLoadingStart();
              _context.next = 5;
              return Object(ContactInfoUtils["x" /* submitOption */])({
                appContext: context,
                router: router,
                hasSaveOption: true,
                withfutureTravelCredits: withfutureTravelCredits
              })(selectedProposal.id);

            case 5:
              status = _context.sent;

              if (!(status === null || status === void 0 ? void 0 : status.isRedirectionPerfomed) && (status === null || status === void 0 ? void 0 : status.reason) === option_validity_constants["a" /* BOOKING_ALREADY_EXISTS */]) {
                componentDispatch({
                  type: 'toggleLoading'
                });
                componentDispatch({
                  type: 'setOpenBookingAlreadyExistsErrorMessage',
                  payload: true
                });
                onLoadingEnd();
                setTimeout(function () {
                  return Object(scrollToElement["a" /* scrollToElement */])('#bloc-option');
                });
              }

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function takeAnOption() {
      return _ref5.apply(this, arguments);
    };
  }();

  var loadAndTakeAnOption = /*#__PURE__*/function () {
    var _ref6 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee2(boolean) {
      return regenerator_default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (state.isLoading) {
                _context2.next = 5;
                break;
              }

              onLoadingStart;
              _context2.next = 4;
              return takeAnOption(boolean);

            case 4:
              onLoadingEnd;

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function loadAndTakeAnOption(_x) {
      return _ref6.apply(this, arguments);
    };
  }();

  var shouldShowOptionButton = function shouldShowOptionButton() {
    return Object(featureFlippingUtils["a" /* isFeatureFlipped */])(context, isMobile)('booking.option') && Object(proposalUtils["v" /* isOptionAllowed */])(selectedProposal);
  };

  var isPromoCodeEnabled = Object(src_i18n["d" /* getKeyValue */])('booking.priceDetails.promoCode.enabled');

  var openOptionModal = function openOptionModal() {
    trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_SUMMARY, {
      detail_click: 'hold_option'
    });
    componentDispatch({
      type: 'openOptionModal'
    });
  };

  var getDisclaimer = function getDisclaimer() {
    return (selectedProposal === null || selectedProposal === void 0 ? void 0 : selectedProposal.durationDisclaimer) === false ? Object(src_i18n["h" /* t */])('booking.option.DurationDisclaimer') : '';
  };

  var roomQuantity = selectedProposal.accommodations.filter(function (accommodation) {
    return accommodation.quantity > 1;
  }).map(function (accommodation) {
    return accommodation.quantity;
  });
  var shouldShowPriceDetails = isJoyViewAllInclusive || isUrbanOasisAllInclusive || !isJoyview && !isUrbanOasis;
  return SummaryView_jsx(react["Fragment"], null, SummaryView_jsx(head_default.a, null, SummaryView_jsx("title", {
    key: "title"
  }, Object(src_i18n["h" /* t */])('booking.summary.seo.title'))), Object(infoBanner_utils["a" /* renderInfoBanner */])({
    infoBannerData: infoBannerData,
    departureDate: selectedProposal.departureDate,
    arrivalDate: selectedProposal.arrivalDate,
    currentStep: 'summary'
  }), SummaryView_jsx("p", {
    className: "mb-10 font-brand text-24 text-black"
  }, Object(src_i18n["h" /* t */])('booking.summary.pageTitle')), SummaryView_jsx("div", {
    className: "mb-20 flex items-center gap-10"
  }, SummaryView_jsx(Icon["a" /* Icon */], {
    className: "text-green",
    name: icons["a" /* ICONS */].CHECK_FILLED,
    width: "1.875rem"
  }), SummaryView_jsx("p", {
    className: "mt-2 font-brand text-green"
  }, Object(src_i18n["h" /* t */])('booking.summary.discount.bestRateGuarantee'))), SummaryView_jsx("div", {
    className: "mb-60 rounded-12 bg-white p-20 shadow-sm",
    "data-testid": "stay-summary-ticket"
  }, SummaryView_jsx(AccordionBlock["a" /* AccordionBlock */], {
    trackingEventName: tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_SUMMARY,
    lines: Object(SummaryView_utils["c" /* getSummaryViewLinesByProposal */])({
      accommodationSummary: SummaryView_jsx(AccommodationSummary["a" /* AccommodationSummary */], {
        accommodations: selectedProposal.accommodations,
        resort: resort,
        roomQuantity: roomQuantity
      }),
      locale: context.locale,
      selectedProposal: selectedProposal,
      isJoyViewOrUrbanOasisAllInclusive: isJoyViewAllInclusive || isUrbanOasisAllInclusive,
      isUrbanOasisFoodAndBeverage: isUrbanOasisFoodAndBeverage,
      i18n: i18n
    })
  }, SummaryView_jsx("div", {
    className: "mt-40"
  }, shouldShowPriceDetails && SummaryView_jsx("p", {
    className: "mb-20 font-bold"
  }, Object(src_i18n["h" /* t */])('booking.priceDetails.packagePrice.priceDetails')), SummaryView_jsx(PriceDetailLines["a" /* PriceDetailLines */], {
    trackingEventName: tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_SUMMARY,
    priceDetail: Object(SummaryView_utils["b" /* getPriceDetail */])({
      selectedProposal: selectedProposal,
      priceWithDonation: priceWithDonation,
      showPriceDetailLines: shouldShowPriceDetails,
      promoCode: SummaryView_jsx("div", {
        className: "mb-20"
      }, SummaryView_jsx(DiscountsLine["a" /* DiscountsLine */], {
        discounts: offers
      }), isPromoCodeEnabled && !!selectedProposal && SummaryView_jsx(PromoCode["a" /* PromoCode */], {
        proposalId: selectedProposal.id,
        customerId: parseInt(selectedProposal.attendees.list[0].customerId, 10),
        discounts: discounts
      })),
      insurance: SummaryView_jsx("div", {
        className: "mb-20"
      }, selectedProposal.additionalServices.insurance ? selectedProposal.additionalServices.insurance.map(function (insurance) {
        return SummaryView_jsx(Insurance_Insurance, {
          isLoading: state.isLoading,
          errorMessageCode: state.insuranceError[insurance.pricingInfo.id],
          key: insurance.pricingInfo.id,
          insurance: insurance,
          onChange: insuranceActions,
          isContinueActionClicked: state.isContinueActionClicked,
          dataTestId: "insurance-block"
        });
      }) : null)
    })
  }), !!selectedProposal.greatMembersLoyaltyPoints && SummaryView_jsx(GreatMembersLoyaltyPoints["a" /* GreatMembersLoyaltyPoints */], {
    loyaltyPoints: selectedProposal.greatMembersLoyaltyPoints,
    dataTestId: "greatMembersLoyaltyPoints"
  })))), reservedServicesByAttendee.length > 0 && SummaryView_jsx("div", {
    className: "mb-20"
  }, SummaryView_jsx(Title["a" /* Title */], {
    className: "mb-10",
    theme: "title-brand-n2"
  }, Object(src_i18n["h" /* t */])('booking.activities.myPackage.title')), SummaryView_jsx(ReservedServicesList["a" /* ReservedServicesList */], {
    reservedServicesByAttendee: reservedServicesByAttendee,
    noEditMode: true,
    currency: selectedProposal.price.currency,
    scrollBackwardLabel: Object(src_i18n["h" /* t */])('common.scrollBackward'),
    scrollForwardLabel: Object(src_i18n["h" /* t */])('common.scrollForward')
  })), SummaryView_jsx(option_block_OptionBlock, {
    showOptionButton: shouldShowOptionButton(),
    onOptionTaking: function onOptionTaking() {
      return loadAndTakeAnOption(false);
    },
    duration: state.duration,
    disclaimer: getDisclaimer(),
    isBookingAlreadyExistsErrorMessageOpen: state.openBookingAlreadyExistsErrorMessage,
    durationDisclaimer: selectedProposal === null || selectedProposal === void 0 ? void 0 : selectedProposal.durationDisclaimer,
    proposalId: selectedProposal === null || selectedProposal === void 0 ? void 0 : selectedProposal.id,
    isOptionAllowed: Object(proposalUtils["v" /* isOptionAllowed */])(selectedProposal),
    resortImage: resort.image,
    onOptionButtonClick: openOptionModal,
    onOptionModalClose: function onOptionModalClose() {
      return componentDispatch({
        type: 'openOptionModal'
      });
    },
    toggleOptionModal: state.toggleOptionModal
  }), state.isFtcPopinOpened && SummaryView_jsx(FtcOptionModal_FtcOptionModal, {
    onClose: function onClose() {
      return componentDispatch({
        type: 'toggleFtcPopin'
      });
    },
    imageUrl: resort.image,
    icon: icons["a" /* ICONS */].PROMO_CODE,
    onClick: function onClick() {
      return loadAndTakeAnOption(true);
    },
    proposalId: selectedProposal === null || selectedProposal === void 0 ? void 0 : selectedProposal.id
  }));
};

/* harmony default export */ var summary_SummaryView = (SummaryView_SummaryView);
// EXTERNAL MODULE: ./src/client/components/widgets/be-transport-details/BeTransportDetails.jsx
var BeTransportDetails = __webpack_require__("a2Xc");

// EXTERNAL MODULE: ./src/client/components/widgets/transport-details/transportUtils.js
var transport_details_transportUtils = __webpack_require__("z8xc");

// CONCATENATED MODULE: ./src/client/components/widgets/additional-transports/AdditionalTransportLayerIcons.jsx
var AdditionalTransportLayerIcons_jsx = react_default.a.createElement;



var AdditionalTransportLayerIcons_AdditionalTransportLayerIcons = function AdditionalTransportLayerIcons() {
  return AdditionalTransportLayerIcons_jsx("div", {
    "data-testid": "AdditionalTransportLayerIcons",
    className: "pointer-events-none absolute inset-0 -z-1 bg-pearl text-lightGrey"
  }, AdditionalTransportLayerIcons_jsx("div", {
    className: "fixed bottom-0 left-0 -mb-100 -translate-x-1/2 transform sm:mb-0"
  }, AdditionalTransportLayerIcons_jsx(Icon["a" /* Icon */], {
    isNotSquare: true,
    name: icons["a" /* ICONS */].PLANE_AND_CIRCLE,
    rotation: 180,
    width: "25rem"
  })), AdditionalTransportLayerIcons_jsx("div", {
    className: "fixed right-0 top-0 -mt-100 translate-x-1/2 transform sm:mt-0"
  }, AdditionalTransportLayerIcons_jsx(Icon["a" /* Icon */], {
    isNotSquare: true,
    name: icons["a" /* ICONS */].PLANE_AND_CIRCLE,
    width: "25rem"
  })));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/slider-handler/SliderHandler.jsx + 2 modules
var SliderHandler = __webpack_require__("A5Hi");

// EXTERNAL MODULE: ./src/hooks/use-disclosure/useDisclosure.js
var useDisclosure = __webpack_require__("Re84");

// CONCATENATED MODULE: ./src/client/components/widgets/additional-transports/additional-transports-filters/ArrivalDepartureRangeFilter.utils.js

var MAX_MINUTES_IN_CURRENT_HOUR = 59; // case 23h OR 23h59

var getNextHourOrEndOfDay = function getNextHourOrEndOfDay(date) {
  var nextHour = date.clone().add(1, 'hour').startOf('hour');
  return nextHour.isSame(date, 'day') ? nextHour : date.clone().endOf('day');
}; // calculate the range of time graduations and steps number for marks

var getRangeTimeGraduations = function getRangeTimeGraduations(_ref) {
  var startTime = _ref.startTime,
      endTime = _ref.endTime;
  var graduations = [];
  var numHours = endTime.diff(startTime, 'hours'); // Iterate through the time range, incrementing by one hour

  for (var i = 0; i <= numHours; i++) {
    graduations.push(startTime.clone().add(i, 'hours').format('HH[h]'));
  } // add the last graduation
  // it's the next hour or the end of the day


  var lastGraduation = getNextHourOrEndOfDay(startTime.clone().add(numHours, 'hours'));
  var timeFormat = lastGraduation.minutes() === MAX_MINUTES_IN_CURRENT_HOUR ? 'HH[h]mm' : 'HH[h]';
  graduations.push(lastGraduation.format(timeFormat)); // Display the graduations

  var stepsNumber = graduations.length;
  return {
    graduations: graduations,
    stepsNumber: stepsNumber
  };
};
// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/groupBy.js
var groupBy = __webpack_require__("Rj53");
var groupBy_default = /*#__PURE__*/__webpack_require__.n(groupBy);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/sortBy.js
var sortBy = __webpack_require__("u6DZ");
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);

// EXTERNAL MODULE: ./src/utils/label/labelUtils.js
var labelUtils = __webpack_require__("WGoB");

// CONCATENATED MODULE: ./src/hooks/use-transport-filters/transportFiltersReducer.utils.js

















function transportFiltersReducer_utils_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function transportFiltersReducer_utils_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? transportFiltersReducer_utils_ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : transportFiltersReducer_utils_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}










var defaultState = {
  transports: [],
  filteredTransports: [],
  stopovers: [{
    label: 'direct',
    min: 0,
    max: 0,
    value: '0',
    isSelected: false,
    flightIdList: []
  }, {
    label: 'stop.label_1',
    min: 0,
    max: 0,
    value: '1',
    isSelected: false,
    flightIdList: []
  }, {
    label: 'stop.label_n',
    min: 0,
    max: 0,
    value: '2',
    isSelected: false,
    flightIdList: []
  }],
  companies: [],
  connectingCities: [],
  inboundDepartureTimeRange: {
    start: moment_default()().startOf('day'),
    end: moment_default()().endOf('day')
  },
  outboundDepartureTimeRange: {
    start: moment_default()().startOf('day'),
    end: moment_default()().endOf('day')
  },
  durationRanges: [{
    label: 'label_2h',
    value: '0',
    min: 0,
    max: 120,
    isSelected: false,
    flightIdList: []
  }, {
    label: 'label_4h',
    value: '1',
    min: 120,
    max: 240,
    isSelected: false,
    flightIdList: []
  }, {
    label: 'label_8h',
    value: '2',
    min: 240,
    max: 480,
    isSelected: false,
    flightIdList: []
  }, {
    label: 'label_8h_more',
    value: '3',
    min: 480,
    max: 6000,
    isSelected: false,
    flightIdList: []
  }],
  totalFiltersSelected: 0
};
var computeDurationRangeFilters = function computeDurationRangeFilters(id, durationInMin, durationRanges) {
  if (durationInMin < 120) {
    durationRanges.firstDurationRangeIdList.push(id);
  } else if (durationInMin < 240) {
    durationRanges.secondDurationRangeIdList.push(id);
  } else if (durationInMin < 480) {
    durationRanges.thirdDurationRangeIdList.push(id);
  } else {
    durationRanges.fourthDurationRangeIdList.push(id);
  }
};
var computeStopoverFilters = function computeStopoverFilters(id, travelSections, stopovers) {
  if (travelSections.length === 1) {
    stopovers.transportsWithNoStopoversIdList.push(id);
  } else if (travelSections.length === 2) {
    stopovers.transportsWith1StopoversIdList.push(id);
  } else {
    stopovers.transportsWith2StopoversIdList.push(id);
  }
};
var transportFiltersReducer_utils_computeCompaniesFilters = function computeCompaniesFilters(id, travelSections, companies) {
  companies.push.apply(companies, Object(toConsumableArray["a" /* default */])(Object(transport_details_transportUtils["i" /* getCompanyOperators */])(travelSections).map(function (company) {
    return transportFiltersReducer_utils_objectSpread(transportFiltersReducer_utils_objectSpread({}, company), {}, {
      flightId: id
    });
  })));
};
var computeConnectingCitiesFilters = function computeConnectingCitiesFilters(id, travelSections, connectingCities) {
  if (travelSections.length < 2) {
    return;
  }

  var citiesArrival = travelSections.map(function (travelSection) {
    return travelSection.arrival;
  }).slice(0, -1);
  citiesArrival.forEach(function (cityArrival) {
    connectingCities.push({
      label: cityArrival.label,
      cityId: cityArrival.cityId,
      flightId: id
    });
  });
};
var transportFiltersReducer_utils_computeDepartureTimeRangesFilters = function computeDepartureTimeRangesFilters(travelSections, computedDepartureTimeRanges) {
  var departureTime = moment_default()(travelSections[0].departure.time, 'HH:mm:ss');
  computedDepartureTimeRanges.push(departureTime);
};
var computeTransportDetailFilters = function computeTransportDetailFilters(id, transportDetail, computedFilters) {
  var computedStopovers = computedFilters.computedStopovers,
      computedDurationRange = computedFilters.computedDurationRange,
      computedCompanies = computedFilters.computedCompanies,
      computedConnectingCities = computedFilters.computedConnectingCities,
      computedDepartureTimeRanges = computedFilters.computedDepartureTimeRanges;
  computeStopoverFilters(id, transportDetail.travelSections, computedStopovers);
  computeDurationRangeFilters(id, Number(transportDetail.durationInMin), computedDurationRange);
  transportFiltersReducer_utils_computeCompaniesFilters(id, transportDetail.travelSections, computedCompanies);
  computeConnectingCitiesFilters(id, transportDetail.travelSections, computedConnectingCities);
  transportFiltersReducer_utils_computeDepartureTimeRangesFilters(transportDetail.travelSections, computedDepartureTimeRanges);
};
var transportFiltersReducer_utils_computeFilters = function computeFilters(computedStopovers, computedDurationRange, computedCompanies, computedConnectingCities, computedInboundDepartureTimeRanges, computedOutboundDepartureTimeRanges) {
  var stopovers = values_default()(computedStopovers).map(function (stopoverIdList, index) {
    return transportFiltersReducer_utils_objectSpread(transportFiltersReducer_utils_objectSpread({}, defaultState.stopovers[index]), {}, {
      flightIdList: uniq_default()(stopoverIdList)
    });
  });
  var durationRanges = values_default()(computedDurationRange).map(function (durationRangesIdList, index) {
    return transportFiltersReducer_utils_objectSpread(transportFiltersReducer_utils_objectSpread({}, defaultState.durationRanges[index]), {}, {
      flightIdList: uniq_default()(durationRangesIdList)
    });
  });
  var groupedCompanies = groupBy_default()(computedCompanies, 'id');
  var companies = sortBy_default()(Object.keys(groupedCompanies).map(function (companyId) {
    return {
      value: groupedCompanies[companyId][0].id,
      label: Object(labelUtils["a" /* capitalizeName */])(groupedCompanies[companyId][0].label),
      flightIdList: uniq_default()(groupedCompanies[companyId].map(function (company) {
        return company.flightId;
      })),
      isSelected: false,
      min: 0,
      max: 0
    };
  }), 'label');
  var groupedConnectingCities = groupBy_default()(computedConnectingCities, 'cityId');
  var connectingCities = sortBy_default()(Object.keys(groupedConnectingCities).map(function (connectingCityId) {
    return {
      value: groupedConnectingCities[connectingCityId][0].cityId,
      label: Object(labelUtils["a" /* capitalizeName */])(groupedConnectingCities[connectingCityId][0].label),
      flightIdList: uniq_default()(groupedConnectingCities[connectingCityId].map(function (connectingCity) {
        return connectingCity.flightId;
      })),
      isSelected: false,
      min: 0,
      max: 0
    };
  }), 'label');
  var inboundDepartureTimeRange = {
    start: moment_default.a.min(computedInboundDepartureTimeRanges).startOf('hour'),
    end: moment_default.a.max(computedInboundDepartureTimeRanges).startOf('hour')
  };
  var outboundDepartureTimeRange = {
    start: moment_default.a.min(computedOutboundDepartureTimeRanges).startOf('hour'),
    end: moment_default.a.max(computedOutboundDepartureTimeRanges).startOf('hour')
  };
  return {
    stopovers: stopovers,
    durationRanges: durationRanges,
    companies: companies,
    connectingCities: connectingCities,
    inboundDepartureTimeRange: inboundDepartureTimeRange,
    outboundDepartureTimeRange: outboundDepartureTimeRange
  };
};
var transportFiltersReducer_utils_applyFilters = function applyFilters(state) {
  var transports = state.transports,
      stopovers = state.stopovers,
      durationRanges = state.durationRanges,
      companies = state.companies,
      connectingCities = state.connectingCities,
      inboundDepartureTimeRange = state.inboundDepartureTimeRange,
      outboundDepartureTimeRange = state.outboundDepartureTimeRange;
  var totalFiltersSelected = stopovers.filter(function (stopover) {
    return stopover.isSelected;
  }).length + durationRanges.filter(function (durationRange) {
    return durationRange.isSelected;
  }).length + companies.filter(function (company) {
    return company.isSelected;
  }).length + connectingCities.filter(function (connectingCity) {
    return connectingCity.isSelected;
  }).length;
  var filteredTransports = transports.filter(function (transport) {
    var id = transport.id,
        inbound = transport.inbound,
        outbound = transport.outbound;
    var inboundStopovers = inbound.travelSections.length - 1;
    var outboundStopovers = outbound.travelSections.length - 1;
    var inboundDurationInMin = Number(inbound.durationInMin);
    var outboundDurationInMin = Number(outbound.durationInMin);
    var inboundCompanyIds = Object(transport_details_transportUtils["i" /* getCompanyOperators */])(inbound.travelSections).map(function (company) {
      return company.id;
    });
    var outboundCompanyIds = Object(transport_details_transportUtils["i" /* getCompanyOperators */])(outbound.travelSections).map(function (company) {
      return company.id;
    });
    var inboundConnectingCityIds = inbound.travelSections.map(function (travelSection) {
      return travelSection.arrival.cityId;
    }).slice(0, -1);
    var outboundConnectingCityIds = outbound.travelSections.map(function (travelSection) {
      return travelSection.arrival.cityId;
    }).slice(0, -1); // add rule for all filters to check if none is selected

    var allStopoversNotSelected = stopovers.every(function (stopover) {
      return !stopover.isSelected;
    });
    var allDurationRangesNotSelected = durationRanges.every(function (durationRange) {
      return !durationRange.isSelected;
    });
    var allCompaniesNotSelected = companies.every(function (company) {
      return !company.isSelected;
    });
    var allConnectingCitiesNotSelected = connectingCities.every(function (connectingCity) {
      return !connectingCity.isSelected;
    });
    var isInboundStopoverSelected = stopovers.some(function (stopover) {
      return stopover.isSelected && stopover.flightIdList.includes(id) && Number(stopover.value) <= inboundStopovers;
    });
    var isOutboundStopoverSelected = stopovers.some(function (stopover) {
      return stopover.isSelected && stopover.flightIdList.includes(id) && Number(stopover.value) <= outboundStopovers;
    });
    var isInboundDurationRangeSelected = durationRanges.some(function (durationRange) {
      return durationRange.isSelected && durationRange.flightIdList.includes(id) && durationRange.min <= inboundDurationInMin && durationRange.max > inboundDurationInMin;
    });
    var isOutboundDurationRangeSelected = durationRanges.some(function (durationRange) {
      return durationRange.isSelected && durationRange.flightIdList.includes(id) && durationRange.min <= outboundDurationInMin && durationRange.max > outboundDurationInMin;
    });
    var isInboundCompanySelected = companies.some(function (company) {
      return company.isSelected && company.flightIdList.includes(id) && inboundCompanyIds.includes(company.value);
    });
    var isOutboundCompanySelected = companies.some(function (company) {
      return company.isSelected && company.flightIdList.includes(id) && outboundCompanyIds.includes(company.value);
    });
    var isInboundConnectingCitySelected = connectingCities.some(function (connectingCity) {
      return connectingCity.isSelected && connectingCity.flightIdList.includes(id) && inboundConnectingCityIds.includes(connectingCity.value);
    });
    var isOutboundConnectingCitySelected = connectingCities.some(function (connectingCity) {
      return connectingCity.isSelected && connectingCity.flightIdList.includes(id) && outboundConnectingCityIds.includes(connectingCity.value);
    });
    var isInboundDepartureTimeInRange = moment_default()(inbound.travelSections[0].departure.time, 'HH:mm:ss').isBetween(inboundDepartureTimeRange.start, inboundDepartureTimeRange.end, 'minute', '[]');
    var isOutboundDepartureTimeInRange = moment_default()(outbound.travelSections[0].departure.time, 'HH:mm:ss').isBetween(outboundDepartureTimeRange.start, outboundDepartureTimeRange.end, 'minute', '[]');
    return (isInboundStopoverSelected || isOutboundStopoverSelected || allStopoversNotSelected) && (isInboundDurationRangeSelected || isOutboundDurationRangeSelected || allDurationRangesNotSelected) && (isInboundCompanySelected || isOutboundCompanySelected || allCompaniesNotSelected) && (isInboundConnectingCitySelected || isOutboundConnectingCitySelected || allConnectingCitiesNotSelected) && isInboundDepartureTimeInRange && isOutboundDepartureTimeInRange;
  });
  return {
    filteredTransports: filteredTransports,
    totalFiltersSelected: totalFiltersSelected
  };
};
var transportFiltersReducer_utils_initReducer = function initReducer(state, transports) {
  var computedStopovers = {
    transportsWithNoStopoversIdList: [],
    transportsWith1StopoversIdList: [],
    transportsWith2StopoversIdList: []
  };
  var computedDurationRange = {
    firstDurationRangeIdList: [],
    secondDurationRangeIdList: [],
    thirdDurationRangeIdList: [],
    fourthDurationRangeIdList: []
  };
  var computedCompanies = [];
  var computedConnectingCities = [];
  var computedInboundDepartureTimeRanges = [];
  var computedOutboundDepartureTimeRanges = [];

  if (!transports) {
    return state;
  }

  transports.forEach(function (transport) {
    var id = transport.id,
        inbound = transport.inbound,
        outbound = transport.outbound;
    var computedFilters = {
      computedStopovers: computedStopovers,
      computedDurationRange: computedDurationRange,
      computedCompanies: computedCompanies,
      computedConnectingCities: computedConnectingCities
    };
    computeTransportDetailFilters(id, inbound, transportFiltersReducer_utils_objectSpread(transportFiltersReducer_utils_objectSpread({}, computedFilters), {}, {
      computedDepartureTimeRanges: computedInboundDepartureTimeRanges
    }));
    computeTransportDetailFilters(id, outbound, transportFiltersReducer_utils_objectSpread(transportFiltersReducer_utils_objectSpread({}, computedFilters), {}, {
      computedDepartureTimeRanges: computedOutboundDepartureTimeRanges
    }));
  });

  var _computeFilters = transportFiltersReducer_utils_computeFilters(computedStopovers, computedDurationRange, computedCompanies, computedConnectingCities, computedInboundDepartureTimeRanges, computedOutboundDepartureTimeRanges),
      stopovers = _computeFilters.stopovers,
      durationRanges = _computeFilters.durationRanges,
      companies = _computeFilters.companies,
      connectingCities = _computeFilters.connectingCities,
      inboundDepartureTimeRange = _computeFilters.inboundDepartureTimeRange,
      outboundDepartureTimeRange = _computeFilters.outboundDepartureTimeRange;

  return transportFiltersReducer_utils_objectSpread(transportFiltersReducer_utils_objectSpread({}, state), {}, {
    stopovers: stopovers,
    durationRanges: durationRanges,
    companies: companies,
    connectingCities: connectingCities,
    inboundDepartureTimeRange: transportFiltersReducer_utils_objectSpread(transportFiltersReducer_utils_objectSpread({}, inboundDepartureTimeRange), {}, {
      end: getNextHourOrEndOfDay(inboundDepartureTimeRange.end)
    }),
    outboundDepartureTimeRange: transportFiltersReducer_utils_objectSpread(transportFiltersReducer_utils_objectSpread({}, outboundDepartureTimeRange), {}, {
      end: getNextHourOrEndOfDay(outboundDepartureTimeRange.end)
    }),
    defaultInboundDepartureTimeRange: inboundDepartureTimeRange,
    defaultOutboundDepartureTimeRange: outboundDepartureTimeRange,
    transports: transports,
    filteredTransports: transports
  });
};
// CONCATENATED MODULE: ./src/hooks/use-transport-filters/transportFiltersReducer.js











function transportFiltersReducer_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function transportFiltersReducer_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? transportFiltersReducer_ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : transportFiltersReducer_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}




var TRANSPORT_FILTERS_ACTIONS = {
  UPDATE: 'UPDATE',
  RESET: 'RESET'
};
var transportFiltersReducer_transportFiltersReducer = function transportFiltersReducer(state, action) {
  var payload = action.payload;

  switch (action.type) {
    case TRANSPORT_FILTERS_ACTIONS.UPDATE:
      {
        var value = payload.value,
            key = payload.key;
        var filters = state[key];
        var updatedFilter = ['inboundDepartureTimeRange', 'outboundDepartureTimeRange'].includes(key) ? value : // $FlowFixMe
        filters.map(function (filter) {
          if (filter.value === value) {
            return transportFiltersReducer_objectSpread(transportFiltersReducer_objectSpread({}, filter), {}, {
              isSelected: !filter.isSelected
            });
          }

          return filter;
        });

        var newState = transportFiltersReducer_objectSpread(transportFiltersReducer_objectSpread({}, state), {}, Object(defineProperty["a" /* default */])({}, key, updatedFilter));

        var _applyFilters = transportFiltersReducer_utils_applyFilters(newState),
            filteredTransports = _applyFilters.filteredTransports,
            totalFiltersSelected = _applyFilters.totalFiltersSelected;

        return transportFiltersReducer_objectSpread(transportFiltersReducer_objectSpread({}, newState), {}, {
          filteredTransports: filteredTransports,
          totalFiltersSelected: totalFiltersSelected
        });
      }

    case TRANSPORT_FILTERS_ACTIONS.RESET:
      {
        var transports = state.transports,
            stopovers = state.stopovers,
            durationRanges = state.durationRanges,
            companies = state.companies,
            connectingCities = state.connectingCities;

        var _newState = transportFiltersReducer_objectSpread(transportFiltersReducer_objectSpread({}, state), {}, {
          filteredTransports: transports,
          stopovers: stopovers.map(function (stopover) {
            return transportFiltersReducer_objectSpread(transportFiltersReducer_objectSpread({}, stopover), {}, {
              isSelected: false
            });
          }),
          durationRanges: durationRanges.map(function (durationRange) {
            return transportFiltersReducer_objectSpread(transportFiltersReducer_objectSpread({}, durationRange), {}, {
              isSelected: false
            });
          }),
          companies: companies.map(function (company) {
            return transportFiltersReducer_objectSpread(transportFiltersReducer_objectSpread({}, company), {}, {
              isSelected: false
            });
          }),
          connectingCities: connectingCities.map(function (connectingCity) {
            return transportFiltersReducer_objectSpread(transportFiltersReducer_objectSpread({}, connectingCity), {}, {
              isSelected: false
            });
          }),
          inboundDepartureTimeRange: {
            start: (state.defaultInboundDepartureTimeRange || defaultState.inboundDepartureTimeRange).start,
            end: getNextHourOrEndOfDay((state.defaultInboundDepartureTimeRange || defaultState.inboundDepartureTimeRange).end)
          },
          outboundDepartureTimeRange: {
            start: (state.defaultOutboundDepartureTimeRange || defaultState.outboundDepartureTimeRange).start,
            end: getNextHourOrEndOfDay((state.defaultOutboundDepartureTimeRange || defaultState.outboundDepartureTimeRange).end)
          },
          totalFiltersSelected: 0
        });

        return _newState;
      }

    default:
      throw new Error();
  }
};
// CONCATENATED MODULE: ./src/hooks/use-transport-filters/useTransportFilters.js



var useTransportFilters_useTransportFilters = function useTransportFilters(transports) {
  var _useReducer = Object(react["useReducer"])(transportFiltersReducer_transportFiltersReducer, transportFiltersReducer_utils_initReducer(defaultState, transports)),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var updateFilters = function updateFilters(key, value) {
    dispatch({
      type: TRANSPORT_FILTERS_ACTIONS.UPDATE,
      payload: {
        key: key,
        value: value
      }
    });
  };

  var resetFilters = function resetFilters() {
    dispatch({
      type: TRANSPORT_FILTERS_ACTIONS.RESET
    });
  };

  return {
    state: state,
    updateFilters: updateFilters,
    resetFilters: resetFilters
  };
};
// EXTERNAL MODULE: ./src/client/components/frameworks/hr/Hr.jsx
var Hr = __webpack_require__("3+yQ");

// EXTERNAL MODULE: ./src/client/components/widgets/be-transport-details/TransportTicket.jsx + 2 modules
var TransportTicket = __webpack_require__("k52x");

// CONCATENATED MODULE: ./src/client/components/widgets/additional-transports/additional-transports-list/AdditionalTransportListOrderButton.jsx
var AdditionalTransportListOrderButton_jsx = react_default.a.createElement;







var AdditionalTransportListOrderButton_AdditionalTransportListOrderButton = function AdditionalTransportListOrderButton(_ref) {
  var isDisabled = _ref.isDisabled,
      isSelected = _ref.isSelected,
      type = _ref.type,
      setSelectedOrder = _ref.setSelectedOrder,
      price = _ref.price,
      time = _ref.time;
  var isActive = isSelected && !isDisabled;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  return AdditionalTransportListOrderButton_jsx("button", {
    "data-testid": "AdditionalTransportListOrderButton",
    disabled: isDisabled,
    type: "button",
    className: Object(classnames_utils["a" /* classnames */])({
      'min-h-100 rounded-12 border-1 p-15 text-start': true,
      'cursor-pointer': !isDisabled,
      'border-none bg-saffron': isActive,
      'cursor-not-allowed bg-lightGrey': isDisabled
    }),
    onClick: function onClick() {
      trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_TRANSPORT_LAYER, {
        detail_click: 'change_flight_type',
        flight_type: type
      });
      setSelectedOrder();
    }
  }, AdditionalTransportListOrderButton_jsx("p", {
    className: "mb-4 text-14 font-semibold"
  }, Object(src_i18n["h" /* t */])("booking.transport.sort.".concat(type, "Flight")), isActive && AdditionalTransportListOrderButton_jsx(Icon["a" /* Icon */], {
    className: "-mb-3 ms-5",
    name: icons["a" /* ICONS */].CHECK,
    width: "1rem"
  })), AdditionalTransportListOrderButton_jsx("p", {
    className: "text-20 font-semibold"
  }, price), time && AdditionalTransportListOrderButton_jsx("p", {
    className: "text-12 font-normal"
  }, time));
};
// CONCATENATED MODULE: ./src/client/components/widgets/additional-transports/additional-transports-list/AdditionalTransportListFilters.jsx
var AdditionalTransportListFilters_jsx = react_default.a.createElement;






var AdditionalTransportListFilters_AdditionalTransportListFilters = function AdditionalTransportListFilters(_ref) {
  var totalTransports = _ref.totalTransports,
      cheapestTransport = _ref.cheapestTransport,
      fastestTransport = _ref.fastestTransport,
      selectedOrder = _ref.selectedOrder,
      _setSelectedOrder = _ref.setSelectedOrder;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isRTL = _useResponsive.isRTL;

  var isDisabled = totalTransports <= 1;
  var cheapestTransportTime = Object(transportUtils["h" /* getTransportAverageDuration */])(cheapestTransport);
  var fastestTransportTime = Object(transportUtils["h" /* getTransportAverageDuration */])(fastestTransport);
  return AdditionalTransportListFilters_jsx("div", {
    className: "my-20"
  }, AdditionalTransportListFilters_jsx("div", {
    "data-testid": "AdditionalTransportListFilters",
    className: "flex items-center gap-15"
  }, AdditionalTransportListFilters_jsx(AdditionalTransportListOrderButton_AdditionalTransportListOrderButton, {
    isDisabled: isDisabled,
    type: "cheapest",
    isSelected: selectedOrder === 'cheapest',
    setSelectedOrder: function setSelectedOrder() {
      _setSelectedOrder('cheapest');
    },
    price: cheapestTransport ? Object(transportUtils["g" /* getTotalDifferentialPrice */])(cheapestTransport === null || cheapestTransport === void 0 ? void 0 : cheapestTransport.totalDifferentialPrice) : '0',
    time: cheapestTransportTime > 0 ? Object(src_i18n["h" /* t */])('booking.transport.averageFlightDuration', {
      time: Object(transport_details_transportUtils["p" /* transformMinutesInHours */])(Object(transportUtils["h" /* getTransportAverageDuration */])(cheapestTransport), isRTL)
    }) : undefined
  }), AdditionalTransportListFilters_jsx(AdditionalTransportListOrderButton_AdditionalTransportListOrderButton, {
    isDisabled: isDisabled,
    type: "fastest",
    isSelected: selectedOrder === 'fastest',
    setSelectedOrder: function setSelectedOrder() {
      _setSelectedOrder('fastest');
    },
    price: fastestTransport ? Object(transportUtils["g" /* getTotalDifferentialPrice */])(fastestTransport === null || fastestTransport === void 0 ? void 0 : fastestTransport.totalDifferentialPrice) : '0',
    time: fastestTransportTime > 0 ? Object(src_i18n["h" /* t */])('booking.transport.averageFlightDuration', {
      time: Object(transport_details_transportUtils["p" /* transformMinutesInHours */])(Object(transportUtils["h" /* getTransportAverageDuration */])(fastestTransport), isRTL)
    }) : undefined
  })), AdditionalTransportListFilters_jsx("p", {
    className: "mt-10 font-normal text-12"
  }, Object(src_i18n["h" /* t */])('booking.transport.sort.label')));
};
// CONCATENATED MODULE: ./src/client/components/widgets/additional-transports/AdditionalTransportSelectedTransport.jsx

var AdditionalTransportSelectedTransport_jsx = react_default.a.createElement;









var AdditionalTransportSelectedTransport_AdditionalTransportSelectedTransport = function AdditionalTransportSelectedTransport(_ref) {
  var proposal = _ref.proposal,
      selectedTransport = _ref.selectedTransport;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var _React$useState = react_default.a.useState(false),
      _React$useState2 = Object(slicedToArray["a" /* default */])(_React$useState, 2),
      toggleSelectedTransport = _React$useState2[0],
      setToggleSelectedTransport = _React$useState2[1];

  var isTransportRecommended = Object(proposalUtils["x" /* isRecommendedTransport */])(selectedTransport, proposal.id);
  var theme = !isTablet ? 'mobile' : 'desktop';
  return AdditionalTransportSelectedTransport_jsx("div", {
    "data-testid": "AdditionalTransportSelectedTransport"
  }, AdditionalTransportSelectedTransport_jsx("button", {
    "data-testid": "ToggleSelectedTransportButton",
    type: "button",
    onClick: function onClick() {
      return setToggleSelectedTransport(!toggleSelectedTransport);
    },
    className: "flex w-full items-center justify-between"
  }, AdditionalTransportSelectedTransport_jsx("div", {
    className: "flex items-center gap-10 text-14 font-semibold"
  }, AdditionalTransportSelectedTransport_jsx(Badge["a" /* Badge */], {
    className: "size-48 border-black bg-black text-white",
    iconName: icons["a" /* ICONS */].ALL_INCLUSIVE,
    variant: "pill"
  }), Object(src_i18n["h" /* t */])('booking.transport.selectedFlight.title')), AdditionalTransportSelectedTransport_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].ARROW_TOP,
    rotation: toggleSelectedTransport ? 0 : 180
  })), AdditionalTransportSelectedTransport_jsx(lib["UnmountClosed"], {
    isOpened: toggleSelectedTransport
  }, AdditionalTransportSelectedTransport_jsx("div", {
    className: "py-15"
  }, AdditionalTransportSelectedTransport_jsx(TransportTicket["a" /* TransportTicket */], {
    theme: theme,
    isTransportRecommended: isTransportRecommended,
    transport: selectedTransport,
    isSelected: true
  }))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/additional-transports/additional-transports-list/AdditionalTransportsList.jsx

var AdditionalTransportsList_jsx = react_default.a.createElement;














var AdditionalTransportsList_AdditionalTransportsList = function AdditionalTransportsList(_ref) {
  var proposal = _ref.proposal,
      setSelectedTransport = _ref.setSelectedTransport,
      alternativeTransports = _ref.alternativeTransports;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var theme = !isTablet ? 'mobile' : 'desktop';
  var iterationNumber = 5;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var _useSelector = Object(es["e" /* useSelector */])(booking_selector["e" /* getAdditionalTransports */]),
      selectedTransport = _useSelector.selectedTransport;

  var _useState = Object(react["useState"])('cheapest'),
      selectedOrder = _useState[0],
      setSelectedOrder = _useState[1];

  var cheapestTransport = Object(transportUtils["k" /* orderTransportByPrice */])(alternativeTransports)[0];
  var fastestTransport = Object(transportUtils["j" /* orderTransportByDuration */])(alternativeTransports)[0];
  var orderedAlternativeTransports = Object(transportUtils["l" /* orderTransportByType */])(alternativeTransports, selectedOrder);
  var hasStrictTransportOrder = Object(transportUtils["c" /* getHasStrictTransportOrder */])(orderedAlternativeTransports, selectedOrder);

  var _useState2 = Object(react["useState"])(iterationNumber),
      forceInitialShowingItemsNumber = _useState2[0],
      setForceInitialShowingItemsNumber = _useState2[1];

  return AdditionalTransportsList_jsx("div", {
    "data-testid": "AdditionalTransportsList",
    className: "overflow-auto py-20 px-15 sm:px-60"
  }, orderedAlternativeTransports.length > 0 && AdditionalTransportsList_jsx(react_default.a.Fragment, null, AdditionalTransportsList_jsx(AdditionalTransportListFilters_AdditionalTransportListFilters, {
    totalTransports: orderedAlternativeTransports.length,
    cheapestTransport: cheapestTransport,
    fastestTransport: fastestTransport,
    selectedOrder: selectedOrder,
    setSelectedOrder: setSelectedOrder
  }), AdditionalTransportsList_jsx(AdditionalTransportSelectedTransport_AdditionalTransportSelectedTransport, {
    selectedTransport: selectedTransport,
    proposal: proposal
  }), AdditionalTransportsList_jsx(Hr["a" /* Hr */], {
    className: "mt-20"
  }), AdditionalTransportsList_jsx(Paginate["a" /* Paginate */], {
    seeMoreLabel: Object(src_i18n["h" /* t */])('common.viewMore'),
    onClick: function onClick() {
      trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_TRANSPORT_LAYER, {
        detail_click: 'see_more_new_flight'
      });
    },
    iterationNumber: iterationNumber,
    setForceInitialShowingItemsNumber: setForceInitialShowingItemsNumber,
    forceInitialShowingItemsNumber: !isTablet ? forceInitialShowingItemsNumber : 0
  }, orderedAlternativeTransports.map(function (transport, index) {
    return AdditionalTransportsList_jsx(react_default.a.Fragment, {
      key: "transport-".concat(index * 2)
    }, AdditionalTransportsList_jsx("br", null), AdditionalTransportsList_jsx(TransportTicket["a" /* TransportTicket */], {
      tag: index === 0 && hasStrictTransportOrder ? selectedOrder : undefined,
      theme: theme,
      transport: {
        inbound: transport.inbound,
        outbound: transport.outbound
      },
      alternativeTransportPrice: {
        id: transport.id,
        price: transport.price,
        totalDifferentialPrice: transport.totalDifferentialPrice
      },
      setSelectedTransport: setSelectedTransport,
      isTransportRecommended: Object(proposalUtils["x" /* isRecommendedTransport */])({
        inbound: transport.inbound,
        outbound: transport.outbound
      }, proposal.id)
    }));
  }))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/additional-transports/additional-transports-filters/AdditionalTransportFilter.jsx

var AdditionalTransportFilter_jsx = react_default.a.createElement;





var AdditionalTransportFilter_AdditionalTransportFilter = function AdditionalTransportFilter(_ref) {
  var _ref$isOpen = _ref.isOpen,
      isOpen = _ref$isOpen === void 0 ? true : _ref$isOpen,
      title = _ref.title,
      children = _ref.children;

  var _React$useState = react_default.a.useState(isOpen),
      _React$useState2 = Object(slicedToArray["a" /* default */])(_React$useState, 2),
      toggleFilter = _React$useState2[0],
      setToggleFilter = _React$useState2[1];

  return AdditionalTransportFilter_jsx("div", {
    "data-testid": "AdditionalTransportFilter"
  }, AdditionalTransportFilter_jsx("button", {
    "data-testid": "ToggleAdditionalTransportFilter",
    type: "button",
    onClick: function onClick() {
      return setToggleFilter(!toggleFilter);
    },
    className: "flex items-center justify-between w-full"
  }, AdditionalTransportFilter_jsx("span", {
    className: "text-20 font-semibold"
  }, title), AdditionalTransportFilter_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].ARROW_TOP,
    rotation: toggleFilter ? 0 : 180
  })), AdditionalTransportFilter_jsx(lib["UnmountClosed"], {
    isOpened: toggleFilter
  }, AdditionalTransportFilter_jsx("div", {
    className: "pt-30"
  }, children)), AdditionalTransportFilter_jsx(Hr["a" /* Hr */], {
    className: "my-20"
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/additional-transports/additional-transports-filters/AdditionalTransportFiltersHeader.jsx
var AdditionalTransportFiltersHeader_jsx = react_default.a.createElement;





var AdditionalTransportFiltersHeader_AdditionalTransportFiltersHeader = function AdditionalTransportFiltersHeader(_ref) {
  var state = _ref.state,
      resetFilters = _ref.resetFilters;
  var totalFiltersSelected = state.totalFiltersSelected;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  return AdditionalTransportFiltersHeader_jsx("div", {
    "data-testid": "AdditionalTransportFiltersHeader",
    className: "flex items-center justify-between"
  }, AdditionalTransportFiltersHeader_jsx("div", {
    className: "flex items-center gap-10 text-20 font-semibold"
  }, Object(src_i18n["h" /* t */])('booking.common.layer.filtersTitle'), AdditionalTransportFiltersHeader_jsx(Badge["a" /* Badge */], {
    className: "size-32 border-saffron bg-saffron text-14 text-black",
    label: "".concat(totalFiltersSelected),
    variant: "pill"
  })), AdditionalTransportFiltersHeader_jsx("button", {
    type: "button",
    onClick: function onClick() {
      trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_TRANSPORT_LAYER, {
        detail_click: 'filter_remove_all'
      });
      resetFilters();
    },
    className: "cursor-pointer text-16 font-semibold underline"
  }, Object(src_i18n["h" /* t */])('filters.removeAll')));
};
// CONCATENATED MODULE: ./src/client/components/widgets/additional-transports/additional-transports-filters/AdditionalTransportFilterButton.jsx
var AdditionalTransportFilterButton_jsx = react_default.a.createElement;




var AdditionalTransportFilterButton_AdditionalTransportFilterButton = function AdditionalTransportFilterButton(_ref) {
  var label = _ref.label,
      isSelected = _ref.isSelected,
      onClick = _ref.onClick;
  return AdditionalTransportFilterButton_jsx("div", {
    "data-testid": "AdditionalTransportFilterButton"
  }, AdditionalTransportFilterButton_jsx(Button["a" /* Button */], {
    className: "text-16 font-semibold",
    "data-selector": "AdditionalTransportFilterButton-button",
    iconRight: isSelected ? {
      name: icons["a" /* ICONS */].CHECK
    } : undefined,
    onClick: onClick,
    color: colors["a" /* COLORS */].BLACK,
    colorBg: isSelected ? colors["a" /* COLORS */].SAFFRON : colors["a" /* COLORS */].WHITE,
    colorBorder: isSelected ? colors["a" /* COLORS */].SAFFRON : colors["a" /* COLORS */].BLACK,
    size: "medium"
  }, label));
};
// CONCATENATED MODULE: ./src/client/components/widgets/additional-transports/additional-transports-filters/AdditionalTransportFilterDurationRange.jsx


var AdditionalTransportFilterDurationRange_jsx = react_default.a.createElement;





var AdditionalTransportFilterDurationRange_AdditionalTransportFilterDurationRange = function AdditionalTransportFilterDurationRange(_ref) {
  var durationRanges = _ref.durationRanges,
      updateFilters = _ref.updateFilters;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  return AdditionalTransportFilterDurationRange_jsx("div", {
    "data-testid": "AdditionalTransportFilterDurationRange",
    className: "grid grid-rows-2 gap-10"
  }, AdditionalTransportFilterDurationRange_jsx("div", {
    className: "flex items-center gap-10"
  }, durationRanges.slice(0, 2).map(function (durationRange) {
    return AdditionalTransportFilterDurationRange_jsx("div", {
      key: "durationRange-".concat(durationRange.value)
    }, AdditionalTransportFilterDurationRange_jsx(AdditionalTransportFilterButton_AdditionalTransportFilterButton, {
      label: Object(src_i18n["h" /* t */])("faceting.filters.flightDuration.".concat(durationRange.label)),
      isSelected: durationRange.isSelected,
      onClick: function onClick() {
        trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_TRANSPORT_LAYER, {
          detail_click: 'filter_flight_time'
        });
        updateFilters('durationRanges', durationRange.value);
      }
    }));
  })), AdditionalTransportFilterDurationRange_jsx("div", {
    className: "flex items-center gap-10"
  }, durationRanges.slice(2).map(function (durationRange) {
    return AdditionalTransportFilterDurationRange_jsx("div", {
      key: "durationRange-".concat(durationRange.value)
    }, AdditionalTransportFilterDurationRange_jsx(AdditionalTransportFilterButton_AdditionalTransportFilterButton, {
      label: Object(src_i18n["h" /* t */])("faceting.filters.flightDuration.".concat(durationRange.label)),
      isSelected: durationRange.isSelected,
      onClick: function onClick() {
        trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_TRANSPORT_LAYER, {
          detail_click: 'filter_flight_time'
        });
        updateFilters('durationRanges', durationRange.value);
      }
    }));
  })));
};
// EXTERNAL MODULE: ./src/client/store/booking/additional-transports/additionalTransports.action.js
var additionalTransports_action = __webpack_require__("04nu");

// EXTERNAL MODULE: ./src/utils/string/stringUtils.js
var stringUtils = __webpack_require__("E8Xq");

// EXTERNAL MODULE: ./src/client/store/booking/transport-stations/transportStations.action.js
var transportStations_action = __webpack_require__("ldqU");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-inputs/input-switch/InputSwitch.jsx + 1 modules
var InputSwitch = __webpack_require__("YjXp");

// CONCATENATED MODULE: ./src/client/components/widgets/additional-transports/additional-transports-search/AdditionalTransportAdvancedSearchFormFields.jsx














var AdditionalTransportAdvancedSearchFormFields_jsx = react_default.a.createElement;

function AdditionalTransportAdvancedSearchFormFields_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function AdditionalTransportAdvancedSearchFormFields_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { AdditionalTransportAdvancedSearchFormFields_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { AdditionalTransportAdvancedSearchFormFields_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













function getCityTransportsByGroupName(_ref) {
  var _ref$data = _ref.data,
      data = _ref$data === void 0 ? {} : _ref$data,
      cityId = _ref.cityId;
  var _data$airports = data.airports,
      airports = _data$airports === void 0 ? [] : _data$airports,
      _data$trainStations = data.trainStations,
      trainStations = _data$trainStations === void 0 ? [] : _data$trainStations,
      _data$ports = data.ports,
      ports = _data$ports === void 0 ? [] : _data$ports;
  return {
    previousCityId: cityId,
    cityTransports: [{
      groupName: Object(src_i18n["h" /* t */])('booking.transport.departure.airport'),
      groupOptions: airports.map(function (airport) {
        return AdditionalTransportAdvancedSearchFormFields_objectSpread(AdditionalTransportAdvancedSearchFormFields_objectSpread({}, airport), {}, {
          name: Object(stringUtils["a" /* capitalize */])(airport.name)
        });
      })
    }, {
      groupName: Object(src_i18n["h" /* t */])('booking.transport.departure.trainStation'),
      groupOptions: trainStations.map(function (trainStation) {
        return AdditionalTransportAdvancedSearchFormFields_objectSpread(AdditionalTransportAdvancedSearchFormFields_objectSpread({}, trainStation), {}, {
          name: Object(stringUtils["a" /* capitalize */])(trainStation.label)
        });
      })
    }, {
      groupName: Object(src_i18n["h" /* t */])('booking.transport.departure.port'),
      groupOptions: ports.map(function (port) {
        return AdditionalTransportAdvancedSearchFormFields_objectSpread(AdditionalTransportAdvancedSearchFormFields_objectSpread({}, port), {}, {
          name: Object(stringUtils["a" /* capitalize */])(port.label)
        });
      })
    }]
  };
}

function getTransportClassesByGroupName(hasPlane, hasTrain) {
  return {
    transportClasses: [{
      groupName: Object(src_i18n["h" /* t */])('common.transport.planeLabel'),
      groupOptions: transport_details_transportUtils["b" /* FLIGHT_CLASS_AVAILABLE_TO_SEARCH */].map(function (value) {
        return {
          value: value,
          name: Object(src_i18n["h" /* t */])("common.transport.transportClass.".concat(transport_details_transportUtils["f" /* TRANSPORT_CLASS_TO_I18N */][value])),
          isDisabled: !hasPlane
        };
      })
    }, {
      groupName: Object(src_i18n["h" /* t */])('common.transport.trainLabel'),
      groupOptions: transport_details_transportUtils["e" /* TRAIN_CLASS_AVAILABLE_TO_SEARCH */].map(function (value) {
        return {
          value: value,
          name: Object(src_i18n["h" /* t */])("common.transport.transportClass.".concat(transport_details_transportUtils["f" /* TRANSPORT_CLASS_TO_I18N */][value])),
          isDisabled: !hasTrain
        };
      })
    }]
  };
}

var AdditionalTransportAdvancedSearchFormFields_AdditionalTransportAdvancedSearchFormFields = function AdditionalTransportAdvancedSearchFormFields(_ref2) {
  var _proposal$transports, _proposal$transports$, _travelSections$;

  var proposal = _ref2.proposal;

  var _useFormikContext = Object(formik_esm["e" /* useFormikContext */])(),
      values = _useFormikContext.values,
      setFieldValue = _useFormikContext.setFieldValue;

  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var dispatch = Object(es["d" /* useDispatch */])();
  var travelSections = (_proposal$transports = proposal.transports) === null || _proposal$transports === void 0 ? void 0 : (_proposal$transports$ = _proposal$transports.inbound) === null || _proposal$transports$ === void 0 ? void 0 : _proposal$transports$.travelSections;
  var flightDeparture = travelSections === null || travelSections === void 0 ? void 0 : (_travelSections$ = travelSections[0]) === null || _travelSections$ === void 0 ? void 0 : _travelSections$.departure;
  var hasFlight = travelSections === null || travelSections === void 0 ? void 0 : travelSections.some(function (travelSection) {
    return (travelSection === null || travelSection === void 0 ? void 0 : travelSection.transport.type) === 'PLANE';
  });
  var hasTrain = travelSections === null || travelSections === void 0 ? void 0 : travelSections.some(function (travelSection) {
    return (travelSection === null || travelSection === void 0 ? void 0 : travelSection.transport.type) === 'TRAIN';
  });

  var _getCityTransportsByG = getCityTransportsByGroupName(Object(es["e" /* useSelector */])(booking_selector["g" /* getCityTransportsSelector */])),
      cityTransports = _getCityTransportsByG.cityTransports,
      previousCityId = _getCityTransportsByG.previousCityId;

  var _getTransportClassesB = getTransportClassesByGroupName(hasFlight, hasTrain),
      transportClasses = _getTransportClassesB.transportClasses;

  Object(react["useEffect"])(function () {
    if (previousCityId !== (flightDeparture === null || flightDeparture === void 0 ? void 0 : flightDeparture.cityId)) {
      dispatch(Object(transportStations_action["b" /* fetchTransportStations */])(flightDeparture === null || flightDeparture === void 0 ? void 0 : flightDeparture.cityId, appContext));
    }
  }, []);
  return AdditionalTransportAdvancedSearchFormFields_jsx("div", {
    className: "block",
    "data-testid": "AdditionalTransportAdvancedSearchFormFields"
  }, AdditionalTransportAdvancedSearchFormFields_jsx("div", {
    className: "flex items-center justify-between py-10"
  }, AdditionalTransportAdvancedSearchFormFields_jsx("span", {
    className: "block leading-1"
  }, Object(src_i18n["h" /* t */])('booking.transport.criteria.directFlights')), AdditionalTransportAdvancedSearchFormFields_jsx(InputSwitch["a" /* InputSwitch */], {
    isChecked: values.directFlights,
    value: values.directFlights,
    onChange: function onChange(name, isChecked) {
      return setFieldValue('directFlights', isChecked);
    },
    isSwitch: true,
    name: "directFlights",
    inputTestId: "directFlights"
  })), AdditionalTransportAdvancedSearchFormFields_jsx("div", {
    className: "w-full py-10"
  }, AdditionalTransportAdvancedSearchFormFields_jsx(FormikInput["a" /* FormikInput */], {
    className: "capitalize",
    dataTestId: "departure",
    label: Object(src_i18n["h" /* t */])('booking.transport.criteria.departure'),
    name: "departure",
    options: cityTransports,
    withOptionGroup: true,
    type: "select"
  })), AdditionalTransportAdvancedSearchFormFields_jsx("div", {
    className: "w-full py-10"
  }, AdditionalTransportAdvancedSearchFormFields_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "flightClass",
    label: Object(src_i18n["h" /* t */])('booking.transport.criteria.class'),
    name: "flightClass",
    options: transportClasses,
    withOptionGroup: true,
    type: "select"
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/additional-transports/additional-transports-search/AdditionalTransportAdvancedSearchForm.jsx











var AdditionalTransportAdvancedSearchForm_jsx = react_default.a.createElement;

function AdditionalTransportAdvancedSearchForm_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function AdditionalTransportAdvancedSearchForm_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { AdditionalTransportAdvancedSearchForm_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { AdditionalTransportAdvancedSearchForm_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }















var getTripCriteria = function getTripCriteria(_ref) {
  var _proposal$transports, _proposal$transports$, _inboundTravelSection;

  var proposal = _ref.proposal;
  var inboundTravelSection = (_proposal$transports = proposal.transports) === null || _proposal$transports === void 0 ? void 0 : (_proposal$transports$ = _proposal$transports.inbound) === null || _proposal$transports$ === void 0 ? void 0 : _proposal$transports$.travelSections[0];
  return {
    departure: inboundTravelSection === null || inboundTravelSection === void 0 ? void 0 : (_inboundTravelSection = inboundTravelSection.departure) === null || _inboundTravelSection === void 0 ? void 0 : _inboundTravelSection.cityId,
    directFlights: false,
    flightClass: inboundTravelSection === null || inboundTravelSection === void 0 ? void 0 : inboundTravelSection.transport.class
  };
};

var AdditionalTransportAdvancedSearchForm_AdditionalTransportAdvancedSearchForm = function AdditionalTransportAdvancedSearchForm(_ref2) {
  var proposal = _ref2.proposal;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var dispatch = Object(es["d" /* useDispatch */])();
  var router = Object(next_router["useRouter"])();
  var departureCity = router.query.departure_city;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var handleSubmit = function handleSubmit(_ref3) {
    var directFlights = _ref3.directFlights,
        flightClass = _ref3.flightClass,
        departure = _ref3.departure;
    var formattedTransportSearchCriteria = Object(proposals_action["o" /* getTransportSearchCriteria */])({
      proposal: proposal,
      departureCity: departureCity
    });
    var inbound = formattedTransportSearchCriteria.journeys[0];
    var outbound = formattedTransportSearchCriteria.journeys[1];
    var firstTravelSection = inbound === null || inbound === void 0 ? void 0 : inbound.travelSections[0];
    var otherTravelSections = (inbound === null || inbound === void 0 ? void 0 : inbound.travelSections.slice(1)) || [];
    var enrichedTravelSections = [AdditionalTransportAdvancedSearchForm_objectSpread(AdditionalTransportAdvancedSearchForm_objectSpread({}, firstTravelSection), {}, {
      departure: AdditionalTransportAdvancedSearchForm_objectSpread(AdditionalTransportAdvancedSearchForm_objectSpread({}, firstTravelSection.departure), {}, {
        location: AdditionalTransportAdvancedSearchForm_objectSpread(AdditionalTransportAdvancedSearchForm_objectSpread({}, firstTravelSection.departure.location), {}, {
          id: departure
        })
      })
    })].concat(Object(toConsumableArray["a" /* default */])(otherTravelSections));

    var enrichedInbound = AdditionalTransportAdvancedSearchForm_objectSpread(AdditionalTransportAdvancedSearchForm_objectSpread({}, inbound), {}, {
      travelSections: enrichedTravelSections
    });

    var transportSearchCriteria = AdditionalTransportAdvancedSearchForm_objectSpread(AdditionalTransportAdvancedSearchForm_objectSpread({}, formattedTransportSearchCriteria), {}, {
      journeys: [enrichedInbound, outbound],
      transportClass: flightClass,
      isDirectFlightOnly: directFlights,
      maxConnections: directFlights ? 0 : undefined
    });

    dispatch(Object(additionalTransports_action["b" /* fetchAdditionalTransports */])({
      proposal: proposal,
      transportSearchCriteria: transportSearchCriteria,
      appContext: appContext
    }));
  };

  return AdditionalTransportAdvancedSearchForm_jsx(formik_esm["d" /* Formik */], {
    initialValues: getTripCriteria({
      proposal: proposal
    }),
    onSubmit: handleSubmit
  }, function (_ref4) {
    var isValid = _ref4.isValid;
    return AdditionalTransportAdvancedSearchForm_jsx(formik_esm["c" /* Form */], {
      "data-testid": "AdditionalTransportAdvancedSearchForm"
    }, AdditionalTransportAdvancedSearchForm_jsx(AdditionalTransportAdvancedSearchFormFields_AdditionalTransportAdvancedSearchFormFields, {
      proposal: proposal
    }), AdditionalTransportAdvancedSearchForm_jsx("div", {
      className: "mt-20 flex items-center justify-start"
    }, AdditionalTransportAdvancedSearchForm_jsx(Button["a" /* Button */], {
      colorBg: colors["a" /* COLORS */].BLACK,
      colorBorder: colors["a" /* COLORS */].BLACK,
      color: colors["a" /* COLORS */].WHITE,
      "data-testid": "event-submit",
      isDisabled: !isValid,
      onClick: function onClick() {
        return trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_TRANSPORT_LAYER, {
          detail_click: 'flight_advanced_search'
        });
      },
      type: "submit"
    }, Object(src_i18n["h" /* t */])('remote.searchAction'))));
  });
};
// CONCATENATED MODULE: ./src/client/components/widgets/additional-transports/additional-transports-filters/AdditionalTransportFilterWithButtons.jsx





var AdditionalTransportFilterWithButtons_jsx = react_default.a.createElement;






var filterType = {
  stopovers: 'stop_number',
  companies: 'flight_company',
  connectingCities: 'connecting_flight_city'
};

var AdditionalTransportFilterWithButtons_getStopoverLabel = function getStopoverLabel(stopovers) {
  switch (stopovers) {
    case '0':
      return Object(src_i18n["h" /* t */])('filters.layovers.direct');

    case '1':
      return "".concat(stopovers, " ").concat(Object(src_i18n["h" /* t */])('filters.layovers.stop.label_1'));

    default:
      return "".concat(stopovers, " ").concat(Object(src_i18n["h" /* t */])('filters.layovers.stop.label_n'));
  }
};

var AdditionalTransportFilterWithButtons_FilterWithButtons = function FilterWithButtons(_ref) {
  var type = _ref.type,
      filter = _ref.filter,
      withLength = _ref.withLength,
      updateFilters = _ref.updateFilters;
  var label = type === 'stopovers' ? AdditionalTransportFilterWithButtons_getStopoverLabel(filter.value) : filter.label;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  return AdditionalTransportFilterWithButtons_jsx("div", {
    className: "mb-10"
  }, AdditionalTransportFilterWithButtons_jsx(AdditionalTransportFilterButton_AdditionalTransportFilterButton, {
    label: "".concat(label, " ").concat(withLength ? "(".concat(filter.flightIdList.length, ")") : ''),
    isSelected: filter.isSelected,
    onClick: function onClick() {
      trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_TRANSPORT_LAYER, {
        detail_click: "filter_".concat(filterType[type])
      });
      updateFilters(type, filter.value);
    }
  }));
};

var AdditionalTransportFilterWithButtons_AdditionalTransportFilterWithButtons = function AdditionalTransportFilterWithButtons(_ref2) {
  var type = _ref2.type,
      updateFilters = _ref2.updateFilters,
      filters = _ref2.filters,
      withLength = _ref2.withLength;

  var _React$useState = react_default.a.useState(false),
      _React$useState2 = Object(slicedToArray["a" /* default */])(_React$useState, 2),
      toggleMoreFilters = _React$useState2[0],
      setToggleMoreFilters = _React$useState2[1];

  return AdditionalTransportFilterWithButtons_jsx("div", {
    "data-testid": "AdditionalTransportFilterWithButtons",
    className: "block"
  }, AdditionalTransportFilterWithButtons_jsx("div", {
    className: "block"
  }, filters.slice(0, 3).map(function (filter) {
    return AdditionalTransportFilterWithButtons_jsx(AdditionalTransportFilterWithButtons_FilterWithButtons, {
      type: type,
      key: "filter-".concat(filter.value),
      filter: filter,
      withLength: withLength,
      updateFilters: updateFilters
    });
  }), AdditionalTransportFilterWithButtons_jsx(lib["UnmountClosed"], {
    isOpened: toggleMoreFilters
  }, filters.slice(3).map(function (filter) {
    return AdditionalTransportFilterWithButtons_jsx(AdditionalTransportFilterWithButtons_FilterWithButtons, {
      type: type,
      key: "filter-".concat(filter.value),
      filter: filter,
      withLength: withLength,
      updateFilters: updateFilters
    });
  }))), filters.length > 3 && AdditionalTransportFilterWithButtons_jsx("button", {
    type: "button",
    onClick: function onClick() {
      return setToggleMoreFilters(!toggleMoreFilters);
    },
    className: "text-16 font-semibold underline cursor-pointer"
  }, toggleMoreFilters ? Object(src_i18n["h" /* t */])('common.loadLess') : Object(src_i18n["h" /* t */])('common.loadMore')));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/react-slider/dist/cjs/index.js
var cjs = __webpack_require__("Z2QO");
var cjs_default = /*#__PURE__*/__webpack_require__.n(cjs);

// CONCATENATED MODULE: ./src/client/components/widgets/additional-transports/additional-transports-filters/ArrivalDepartureRangeFilter.jsx



var ArrivalDepartureRangeFilter_jsx = react_default.a.createElement;

/* eslint-disable clubmed/no-fake-component */









/**
 * LOCAL COMPONENT RENDERERS
 */
// render the slider track

var ArrivalDepartureRangeFilter_renderTrack = function renderTrack(props, state) {
  var bgClass;

  switch (state.index) {
    case 0:
      bgClass = 'bg-lightGrey';
      break;

    case 1:
      bgClass = 'bg-saffron';
      break;

    default:
      bgClass = 'bg-lightGrey';
      break;
  }

  return ArrivalDepartureRangeFilter_jsx("div", Object(esm_extends["a" /* default */])({}, props, {
    className: 'example-track h-4 ' + bgClass
  }));
};
/**
 * END LOCAL COMPONENT RENDERERS
 */


var ArrivalDepartureRangeFilter_ArrivalDepartureRangeFilter = function ArrivalDepartureRangeFilter(_ref) {
  var _selectedRange$start, _selectedRange$end;

  var startTime = _ref.startTime,
      endTime = _ref.endTime,
      setRange = _ref.setRange,
      selectedRange = _ref.selectedRange,
      _ref$showSelectedTime = _ref.showSelectedTimeUnderSlider,
      showSelectedTimeUnderSlider = _ref$showSelectedTime === void 0 ? true : _ref$showSelectedTime;

  var _getRangeTimeGraduati = getRangeTimeGraduations({
    startTime: startTime,
    endTime: endTime
  }),
      graduations = _getRangeTimeGraduati.graduations,
      stepsNumber = _getRangeTimeGraduati.stepsNumber;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent; // thumb component : min max visual component


  var renderThumb = function renderThumb(props, state) {
    var graduationIndex = state.valueNow === 0 ? 0 : state.valueNow - 1;
    var selectedTime = graduations[graduationIndex];
    return ArrivalDepartureRangeFilter_jsx("div", Object(esm_extends["a" /* default */])({
      "data-testid": "ArrivalDepartureRangeFilter-thumb"
    }, props), ArrivalDepartureRangeFilter_jsx("div", {
      "data-testid": "ArrivalDepartureRangeFilter-thumbIncon",
      className: "h-24 w-24 rounded-2 border-1 items-center justify-center flex bg-white"
    }, ArrivalDepartureRangeFilter_jsx(Icon["a" /* Icon */], {
      name: icons["a" /* ICONS */].PAUSE,
      width: ".5rem"
    })), !showSelectedTimeUnderSlider && ArrivalDepartureRangeFilter_jsx("div", {
      "data-testid": "ArrivalDepartureRangeFilter-timeUnderThumb",
      className: "absolute text-center w-full"
    }, ArrivalDepartureRangeFilter_jsx("span", {
      className: "font-bold text-10 "
    }, selectedTime)));
  }; // on change handler


  var handleChangeSliderValues = function handleChangeSliderValues(values) {
    var _values = Object(slicedToArray["a" /* default */])(values, 2),
        start = _values[0],
        end = _values[1];

    var _ref2 = [graduations[start - 1], graduations[end - 1]],
        startedAt = _ref2[0],
        endedAt = _ref2[1]; // transform to moment date

    var startedAtMoment = moment_default()(startedAt, 'HH[h]mm');
    var endedAtMoment = moment_default()(endedAt, 'HH[h]mm'); // set the selected Range to the parent component

    setRange && setRange({
      start: startedAtMoment,
      end: endedAtMoment
    });
  }; // on change handler


  var getValueFromRange = function getValueFromRange(range) {
    var start = range.start.format('HH[h]');
    var timeFormat = range.end.minutes() === MAX_MINUTES_IN_CURRENT_HOUR ? 'HH[h]mm' : 'HH[h]';
    var end = range.end.format(timeFormat);
    return [graduations.indexOf(start) + 1, graduations.indexOf(end) + 1];
  };

  return ArrivalDepartureRangeFilter_jsx("div", null, ArrivalDepartureRangeFilter_jsx("div", {
    "data-testid": "ArrivalDepartureRangeFilter-departureDate"
  }, ArrivalDepartureRangeFilter_jsx("span", {
    className: "text-14 font-bold"
  }, Object(src_i18n["h" /* t */])('booking.transport.departureNextDay'))), ArrivalDepartureRangeFilter_jsx(cjs_default.a, {
    className: "horizontal-slider relative w-full h-16 py-30 flex items-center",
    trackClassName: "bg-gray-200",
    min: 1,
    max: stepsNumber,
    defaultValue: [0, stepsNumber],
    renderThumb: renderThumb,
    renderTrack: ArrivalDepartureRangeFilter_renderTrack,
    onChange: handleChangeSliderValues,
    onAfterChange: function onAfterChange() {
      return trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_TRANSPORT_LAYER, {
        detail_click: 'filter_schedule'
      });
    },
    value: getValueFromRange(selectedRange),
    minDistance: 1
  }), showSelectedTimeUnderSlider && ArrivalDepartureRangeFilter_jsx("div", {
    className: "flex justify-between",
    "data-testid": "ArrivalDepartureRangeFilter-timeUnderSlider"
  }, ArrivalDepartureRangeFilter_jsx("div", {
    "data-testid": "ArrivalDepartureRangeFilter-minRange",
    className: ""
  }, ArrivalDepartureRangeFilter_jsx("span", {
    className: "font-bold text-14"
  }, (_selectedRange$start = selectedRange.start) === null || _selectedRange$start === void 0 ? void 0 : _selectedRange$start.format('HH[h]mm'))), ArrivalDepartureRangeFilter_jsx("div", {
    "data-testid": "ArrivalDepartureRangeFilter-maxRange",
    className: ""
  }, ArrivalDepartureRangeFilter_jsx("span", {
    className: "font-bold text-14"
  }, (_selectedRange$end = selectedRange.end) === null || _selectedRange$end === void 0 ? void 0 : _selectedRange$end.format('HH[h]mm')))));
};
// EXTERNAL MODULE: ./src/hooks/use-feature-flip/useFeatureFlip.js
var useFeatureFlip = __webpack_require__("xu+1");

// CONCATENATED MODULE: ./src/client/components/widgets/additional-transports/additional-transports-filters/AdditionalTransportFilters.jsx

var AdditionalTransportFilters_jsx = react_default.a.createElement;










var AdditionalTransportFilters_AdditionalTransportFilters = function AdditionalTransportFilters(_ref) {
  var hasNoAlternativeTransport = _ref.hasNoAlternativeTransport,
      hasOnlyTrain = _ref.hasOnlyTrain,
      proposal = _ref.proposal,
      state = _ref.state,
      updateFilters = _ref.updateFilters,
      resetFilters = _ref.resetFilters;
  var stopovers = state.stopovers,
      connectingCities = state.connectingCities,
      durationRanges = state.durationRanges,
      companies = state.companies,
      defaultInboundDepartureTimeRange = state.defaultInboundDepartureTimeRange,
      defaultOutboundDepartureTimeRange = state.defaultOutboundDepartureTimeRange,
      inboundDepartureTimeRange = state.inboundDepartureTimeRange,
      outboundDepartureTimeRange = state.outboundDepartureTimeRange;
  var openFilterDefault = !(hasNoAlternativeTransport || hasOnlyTrain);
  var isAdvancedSearchOpened = Object(useFeatureFlip["a" /* useFeatureFlip */])('booking.transport.advancedSearchOpened');
  return AdditionalTransportFilters_jsx("div", {
    "data-testid": "AdditionalTransportFilters",
    className: "px-20 py-30"
  }, AdditionalTransportFilters_jsx(AdditionalTransportFilter_AdditionalTransportFilter, {
    isOpen: hasNoAlternativeTransport && !hasOnlyTrain || isAdvancedSearchOpened,
    title: Object(src_i18n["h" /* t */])('booking.transport.criteria.advancedSearch')
  }, AdditionalTransportFilters_jsx(AdditionalTransportAdvancedSearchForm_AdditionalTransportAdvancedSearchForm, {
    proposal: proposal
  })), AdditionalTransportFilters_jsx(AdditionalTransportFiltersHeader_AdditionalTransportFiltersHeader, {
    state: state,
    resetFilters: resetFilters
  }), AdditionalTransportFilters_jsx(Hr["a" /* Hr */], {
    className: "my-20"
  }), AdditionalTransportFilters_jsx(AdditionalTransportFilter_AdditionalTransportFilter, {
    isOpen: openFilterDefault,
    title: Object(src_i18n["h" /* t */])('filters.layovers.categoryTitle')
  }, AdditionalTransportFilters_jsx(AdditionalTransportFilterWithButtons_AdditionalTransportFilterWithButtons, {
    type: "stopovers",
    filters: stopovers.filter(function (stopover) {
      return stopover.flightIdList.length > 0;
    }),
    updateFilters: updateFilters,
    withLength: true
  })), AdditionalTransportFilters_jsx(AdditionalTransportFilter_AdditionalTransportFilter, {
    isOpen: openFilterDefault,
    title: Object(src_i18n["h" /* t */])('filters.companiesCategoryTitle')
  }, AdditionalTransportFilters_jsx(AdditionalTransportFilterWithButtons_AdditionalTransportFilterWithButtons, {
    type: "companies",
    filters: companies,
    updateFilters: updateFilters,
    withLength: true
  })), connectingCities.length > 0 && AdditionalTransportFilters_jsx(AdditionalTransportFilter_AdditionalTransportFilter, {
    isOpen: openFilterDefault,
    title: Object(src_i18n["h" /* t */])('filters.layovers.stop.connectionCities')
  }, AdditionalTransportFilters_jsx(AdditionalTransportFilterWithButtons_AdditionalTransportFilterWithButtons, {
    type: "connectingCities",
    filters: connectingCities,
    updateFilters: updateFilters,
    withLength: true
  })), AdditionalTransportFilters_jsx(AdditionalTransportFilter_AdditionalTransportFilter, {
    isOpen: openFilterDefault,
    title: Object(src_i18n["h" /* t */])('filters.departureArrival.times')
  }, defaultInboundDepartureTimeRange && AdditionalTransportFilters_jsx("div", {
    className: "mb-20"
  }, AdditionalTransportFilters_jsx("span", {
    className: "text-16 font-semibold"
  }, Object(src_i18n["h" /* t */])('booking.transport.inbound')), AdditionalTransportFilters_jsx(ArrivalDepartureRangeFilter_ArrivalDepartureRangeFilter, {
    startTime: defaultInboundDepartureTimeRange.start,
    endTime: defaultInboundDepartureTimeRange.end,
    setRange: function setRange(value) {
      return updateFilters('inboundDepartureTimeRange', value);
    },
    selectedRange: inboundDepartureTimeRange
  })), defaultOutboundDepartureTimeRange && AdditionalTransportFilters_jsx("div", null, AdditionalTransportFilters_jsx("span", {
    className: "text-16 font-semibold"
  }, Object(src_i18n["h" /* t */])('booking.transport.outbound')), AdditionalTransportFilters_jsx(ArrivalDepartureRangeFilter_ArrivalDepartureRangeFilter, {
    startTime: defaultOutboundDepartureTimeRange.start,
    endTime: defaultOutboundDepartureTimeRange.end,
    setRange: function setRange(value) {
      return updateFilters('outboundDepartureTimeRange', value);
    },
    selectedRange: outboundDepartureTimeRange
  }))), AdditionalTransportFilters_jsx(AdditionalTransportFilter_AdditionalTransportFilter, {
    isOpen: openFilterDefault,
    title: Object(src_i18n["h" /* t */])('filters.flightDurationTitle')
  }, AdditionalTransportFilters_jsx(AdditionalTransportFilterDurationRange_AdditionalTransportFilterDurationRange, {
    durationRanges: durationRanges.filter(function (range) {
      return range.flightIdList.length > 0;
    }),
    updateFilters: updateFilters
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/additional-transports/additional-transports-filters/AdditionalTransportFiltersLayer.jsx
var AdditionalTransportFiltersLayer_jsx = react_default.a.createElement;







var AdditionalTransportFiltersLayer_AdditionalTransportFiltersLayer = function AdditionalTransportFiltersLayer(_ref) {
  var hasNoAlternativeTransport = _ref.hasNoAlternativeTransport,
      hasOnlyTrain = _ref.hasOnlyTrain,
      proposal = _ref.proposal,
      onClose = _ref.onClose,
      state = _ref.state,
      updateFilters = _ref.updateFilters,
      resetFilters = _ref.resetFilters;
  var layerRef = Object(react["useRef"])(null);
  var layerTitle = Object(src_i18n["h" /* t */])('faceting.filters.filtersButton');
  return AdditionalTransportFiltersLayer_jsx(Layer["b" /* Layer */], {
    ariaLabel: layerTitle,
    ariaLabelledby: "testId",
    buttonLeft: {
      iconName: icons["a" /* ICONS */].ARROW_TAIL_LEFT,
      label: Object(src_i18n["h" /* t */])('common.backNavigation'),
      onClick: onClose
    },
    header: AdditionalTransportFiltersLayer_jsx(LayerHeaderProposal_LayerHeaderProposal, {
      id: identifiers_constants["c" /* ID_LAYER_HEADER__BE__TRANSPORTS_FILTERS_MOBILE */],
      layerTitle: layerTitle,
      proposal: proposal,
      totalPrice: Object(src_i18n["h" /* t */])('booking.transport.additionalTransports.totalPrice')
    }),
    closeLabel: Object(src_i18n["h" /* t */])('common.close'),
    onClose: onClose,
    ref: layerRef,
    dataTestId: "AdditionalTransportLayer"
  }, AdditionalTransportFiltersLayer_jsx(AdditionalTransportFilters_AdditionalTransportFilters, {
    hasNoAlternativeTransport: hasNoAlternativeTransport,
    hasOnlyTrain: hasOnlyTrain,
    state: state,
    updateFilters: updateFilters,
    resetFilters: resetFilters,
    proposal: proposal
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/additional-transports/additional-transports-list/AdditionalTransportComplexFlights.jsx
var AdditionalTransportComplexFlights_jsx = react_default.a.createElement;





var AdditionalTransportComplexFlights_AdditionalTransportComplexFlights = function AdditionalTransportComplexFlights(_ref) {
  var proposalId = _ref.proposalId;
  var phoneNumber = Object(src_i18n["h" /* t */])('travelAdvisor.phoneNumber'); // One space is because phone number can not be empty

  var hasPhoneNumber = phoneNumber && phoneNumber !== ' ';
  return AdditionalTransportComplexFlights_jsx("div", {
    "data-testid": "AdditionalTransportComplexFlights",
    className: "h-full rounded-12 border-1 border-lightGrey bg-white p-20"
  }, AdditionalTransportComplexFlights_jsx("div", {
    className: "flex items-start gap-20"
  }, AdditionalTransportComplexFlights_jsx(Badge["a" /* Badge */], {
    className: "size-48 border-lightSand bg-lightSand text-black",
    iconName: icons["a" /* ICONS */].TAKE_OFF
  }), AdditionalTransportComplexFlights_jsx("div", {
    className: "text-start text-16"
  }, AdditionalTransportComplexFlights_jsx("p", {
    className: "font-semibold leading-normal"
  }, Object(src_i18n["h" /* t */])('booking.transport.trip.title')), AdditionalTransportComplexFlights_jsx("p", {
    className: "mt-8 leading-normal"
  }, Object(src_i18n["h" /* t */])('booking.transport.trip.information')), AdditionalTransportComplexFlights_jsx("div", {
    className: "flex items-center leading-normal"
  }, AdditionalTransportComplexFlights_jsx("p", null, Object(src_i18n["h" /* t */])('booking.transport.trip.referenceNumberInformation')), "\xA0", AdditionalTransportComplexFlights_jsx("p", {
    className: "font-semibold"
  }, proposalId)), hasPhoneNumber && AdditionalTransportComplexFlights_jsx("a", {
    href: "tel:".concat(phoneNumber),
    className: "mt-8 flex w-fit cursor-pointer items-center"
  }, AdditionalTransportComplexFlights_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].PHONE,
    width: "24px"
  }), "\xA0", AdditionalTransportComplexFlights_jsx("p", {
    className: "font-semibold"
  }, phoneNumber)))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/additional-transports/additional-transports-list/AdditionalTransportListHeader.jsx
var AdditionalTransportListHeader_jsx = react_default.a.createElement;








var AdditionalTransportListHeader_AdditionalTransportListHeader = function AdditionalTransportListHeader(_ref) {
  var proposalId = _ref.proposalId,
      totalTransports = _ref.totalTransports,
      onOpenLayer = _ref.onOpenLayer;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  return AdditionalTransportListHeader_jsx("div", {
    "data-testid": "AdditionalTransportListHeader",
    className: "bg-white px-15 py-20 sm:px-60"
  }, AdditionalTransportListHeader_jsx(AdditionalTransportComplexFlights_AdditionalTransportComplexFlights, {
    proposalId: proposalId
  }), AdditionalTransportListHeader_jsx("br", null), AdditionalTransportListHeader_jsx("span", {
    className: "flex w-full justify-start font-brand text-24 font-semibold sm:text-28"
  }, Object(src_i18n["h" /* t */])('booking.transport.additionalTransports.others', {
    count: totalTransports
  })), AdditionalTransportListHeader_jsx(Button["a" /* Button */], {
    className: "mt-15 block min-w-auto text-16 font-semibold md:hidden",
    color: colors["a" /* COLORS */].BLACK,
    colorBg: colors["a" /* COLORS */].WHITE,
    colorBorder: colors["a" /* COLORS */].BLACK,
    iconRight: {
      name: icons["a" /* ICONS */].FILTERS
    },
    onClick: function onClick() {
      trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_TRANSPORT_LAYER, {
        detail_click: 'advanced_filter_mobile'
      });
      onOpenLayer();
    }
  }, Object(src_i18n["h" /* t */])('faceting.filters.filtersButton')));
};
// CONCATENATED MODULE: ./src/client/components/widgets/additional-transports/AdditionalTransports.jsx

var AdditionalTransports_jsx = react_default.a.createElement;

















var AdditionalTransports_AdditionalTransports = function AdditionalTransports(_ref) {
  var proposal = _ref.proposal,
      setSelectedTransport = _ref.setSelectedTransport;

  var _useSelector = Object(es["e" /* useSelector */])(booking_selector["e" /* getAdditionalTransports */]),
      alternativeTransports = _useSelector.alternativeTransports;

  var _useDisclosure = Object(useDisclosure["a" /* useDisclosure */])(),
      isOpen = _useDisclosure.isOpen,
      onClose = _useDisclosure.onClose,
      onOpen = _useDisclosure.onOpen;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var _useTransportFilters = useTransportFilters_useTransportFilters(alternativeTransports),
      state = _useTransportFilters.state,
      updateFilters = _useTransportFilters.updateFilters,
      resetFilters = _useTransportFilters.resetFilters;

  var filteredTransports = state.filteredTransports;
  var hasNoAlternativeTransport = alternativeTransports.length === 0;
  var hasOnlyTrain = alternativeTransports.every(function (transport) {
    return Object(transport_details_transportUtils["o" /* isTransportTrain */])(transport.inbound, transport.outbound);
  });
  return AdditionalTransports_jsx("div", {
    "data-testid": "AdditionalTransports",
    className: "flex h-auto min-h-full bg-white"
  }, AdditionalTransports_jsx("div", {
    className: "hidden w-1/4 border-r-1 border-lightGrey md:block"
  }, AdditionalTransports_jsx(AdditionalTransportFilters_AdditionalTransportFilters, {
    hasNoAlternativeTransport: hasNoAlternativeTransport,
    hasOnlyTrain: hasOnlyTrain,
    updateFilters: updateFilters,
    resetFilters: resetFilters,
    state: state,
    proposal: proposal
  })), AdditionalTransports_jsx("div", {
    className: "block w-full bg-pearl"
  }, filteredTransports.length === 0 ? AdditionalTransports_jsx("div", null, AdditionalTransports_jsx("div", {
    className: "px-60 py-20"
  }, AdditionalTransports_jsx(Button["a" /* Button */], {
    className: "mb-20 block min-w-auto text-16 font-semibold md:hidden",
    color: colors["a" /* COLORS */].BLACK,
    colorBg: colors["a" /* COLORS */].WHITE,
    colorBorder: colors["a" /* COLORS */].BLACK,
    iconRight: {
      name: icons["a" /* ICONS */].FILTERS
    },
    onClick: function onClick() {
      trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_TRANSPORT_LAYER, {
        detail_click: 'advanced_filter_mobile'
      });
      onOpen();
    }
  }, Object(src_i18n["h" /* t */])('faceting.filters.filtersButton')), AdditionalTransports_jsx(Confirmation["a" /* Confirmation */], {
    icon: icons["a" /* ICONS */].CIRCLED_PLANE,
    status: "neutral",
    text: Object(src_i18n["h" /* t */])('booking.transport.additionalTransports.noAdditionalTransportAvailableDescription'),
    title: Object(src_i18n["h" /* t */])('booking.transport.additionalTransports.noAdditionalTransportAvailableTitle')
  }))) : AdditionalTransports_jsx(react_default.a.Fragment, null, AdditionalTransports_jsx(AdditionalTransportListHeader_AdditionalTransportListHeader, {
    proposalId: proposal.id,
    totalTransports: filteredTransports.length,
    onOpenLayer: onOpen
  }), AdditionalTransports_jsx(AdditionalTransportsList_AdditionalTransportsList, {
    proposal: proposal,
    setSelectedTransport: setSelectedTransport,
    alternativeTransports: filteredTransports
  }))), isOpen && AdditionalTransports_jsx(AdditionalTransportFiltersLayer_AdditionalTransportFiltersLayer, {
    hasNoAlternativeTransport: hasNoAlternativeTransport,
    hasOnlyTrain: hasOnlyTrain,
    updateFilters: updateFilters,
    resetFilters: resetFilters,
    state: state,
    proposal: proposal,
    onClose: onClose
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/additional-transports/AdditionalTransportsWrapper.jsx


var AdditionalTransportsWrapper_jsx = react_default.a.createElement;











var TRANSPORT_COMPANIES_LOGOS = [{
  url: 'https://ns.clubmed.com/it/2018/be/transport/airfrance.png',
  alt: 'Air France'
}, {
  url: 'https://ns.clubmed.com/it/2018/be/transport/flyemirates.png',
  alt: 'Fly Emirates'
}, {
  url: 'https://ns.clubmed.com/it/2018/be/transport/aircaraibes.png',
  alt: 'Air Caraïbes'
}, {
  alt: 'Singapore Airlines',
  url: 'https://ns.clubmed.com/it/2018/be/transport/singaporeairlines.png'
}, {
  url: 'https://ns.clubmed.com/it/2018/be/transport/qatarairways.png',
  alt: 'Qatar Airways'
}]; // hardcoded for now, there wasn't a compelling enough argument why this should be dynamic

var AdditionalTransportsWrapper_AdditionalTransportsWrapper = function AdditionalTransportsWrapper(_ref) {
  var proposal = _ref.proposal,
      setSelectedTransport = _ref.setSelectedTransport;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var error = Object(es["e" /* useSelector */])(booking_selector["f" /* getAdditionalTransportsError */]);
  var isLoading = Object(es["e" /* useSelector */])(booking_selector["q" /* getIsLoadingAdditionalTransports */]);
  return AdditionalTransportsWrapper_jsx("div", {
    "data-testid": "AdditionalTransportsWrapper",
    className: "relative z-1 h-full"
  }, isLoading && AdditionalTransportsWrapper_jsx(react["Fragment"], null, AdditionalTransportsWrapper_jsx(AsyncLoader["a" /* AsyncLoader */], {
    className: "mt-[18vh]",
    icon: icons["a" /* ICONS */].STANDALONE_MAGNIFYING_GLASS,
    iconSize: "3rem",
    label: Object(src_i18n["h" /* t */])('booking.transport.additionalTransports.loaderLabel'),
    theme: "labeled"
  }), AdditionalTransportsWrapper_jsx("div", {
    className: "m-auto mt-30 w-200"
  }, AdditionalTransportsWrapper_jsx(SliderHandler["a" /* SliderHandler */], {
    hasAutoplay: true,
    hasInfiniteScroll: true,
    hasLazyload: true,
    items: TRANSPORT_COMPANIES_LOGOS.map(function (medium) {
      return AdditionalTransportsWrapper_jsx("img", {
        alt: medium.alt,
        className: "w-full",
        key: medium.url,
        src: medium.url
      });
    })
  }, function (_ref2) {
    var itemsNode = _ref2.itemsNode;
    return itemsNode;
  }))), !isLoading && isEmpty_default()(error) && AdditionalTransportsWrapper_jsx(AdditionalTransports_AdditionalTransports, {
    proposal: proposal,
    setSelectedTransport: setSelectedTransport
  }), !isLoading && !isEmpty_default()(error) && AdditionalTransportsWrapper_jsx(SiteContainer["a" /* SiteContainer */], null, AdditionalTransportsWrapper_jsx(Confirmation["a" /* Confirmation */], {
    status: "error",
    text: Object(src_i18n["h" /* t */])("booking.".concat(appContext.isCmta ? 'partners' : 'common.layer', ".unknownErrorDescription")),
    title: Object(src_i18n["h" /* t */])('booking.common.layer.unknownErrorTitle')
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/additional-transports/AdditionalTransportLayer.jsx
var AdditionalTransportLayer_jsx = react_default.a.createElement;











var AdditionalTransportLayer_AdditionalTransportLayer = function AdditionalTransportLayer(_ref) {
  var onClose = _ref.onClose,
      proposal = _ref.proposal,
      setSelectedTransport = _ref.setSelectedTransport,
      errorTitle = _ref.errorTitle;
  var layerRef = Object(react["useRef"])(null);
  var layerTitle = Object(src_i18n["h" /* t */])('booking.transport.alternativeSelection');
  var isLoading = Object(es["e" /* useSelector */])(booking_selector["q" /* getIsLoadingAdditionalTransports */]);
  return AdditionalTransportLayer_jsx(Layer["b" /* Layer */], {
    ariaLabel: layerTitle,
    ariaLabelledby: identifiers_constants["b" /* ID_LAYER_HEADER__BE__TRANSPORTS_DESKTOP */],
    buttonLeft: {
      iconName: icons["a" /* ICONS */].ARROW_TAIL_LEFT,
      label: Object(src_i18n["h" /* t */])('common.backNavigation'),
      onClick: onClose
    },
    closeLabel: Object(src_i18n["h" /* t */])('common.close'),
    header: AdditionalTransportLayer_jsx(LayerHeaderProposal_LayerHeaderProposal, {
      id: identifiers_constants["b" /* ID_LAYER_HEADER__BE__TRANSPORTS_DESKTOP */],
      layerTitle: layerTitle,
      proposal: proposal,
      totalPrice: Object(src_i18n["h" /* t */])('booking.transport.additionalTransports.totalPrice')
    }),
    onClose: onClose,
    ref: layerRef,
    dataTestId: "AdditionalTransportLayer"
  }, AdditionalTransportLayer_jsx(AdditionalTransportLayerIcons_AdditionalTransportLayerIcons, null), !!errorTitle && !isLoading && AdditionalTransportLayer_jsx(Title["a" /* Title */], {
    className: "mx-25 mt-30",
    theme: "title-sans-n4"
  }, errorTitle), AdditionalTransportLayer_jsx(AdditionalTransportsWrapper_AdditionalTransportsWrapper, {
    proposal: proposal,
    setSelectedTransport: setSelectedTransport
  }));
};
// CONCATENATED MODULE: ./src/client/views/booking/transport/more-transports/MoreTransports.jsx








var MoreTransports_jsx = react_default.a.createElement;

function MoreTransports_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function MoreTransports_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { MoreTransports_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { MoreTransports_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * * More transports modal [find transport page]
 */












var MoreTransports_MoreTransports = function MoreTransports(_ref) {
  var proposal = _ref.proposal,
      _onClose = _ref.onClose,
      _ref$setSelectedTrans = _ref.setSelectedTransport,
      setSelectedTransport = _ref$setSelectedTrans === void 0 ? function (transportId) {
    return _onClose(true, transportId);
  } : _ref$setSelectedTrans;
  var beEngineTrackingContext = Object(react["useContext"])(BookingEngineTrackingContext["a" /* BookingEngineTrackingContext */]);
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var error = Object(es["e" /* useSelector */])(booking_selector["f" /* getAdditionalTransportsError */]);
  var dispatch = Object(es["d" /* useDispatch */])();
  var router = Object(next_router["useRouter"])();
  var departureCity = router.query.departure_city;
  Object(react["useEffect"])(function () {
    if (proposal.transports) {
      var transportSearchCriteria = Object(proposals_action["o" /* getTransportSearchCriteria */])({
        proposal: proposal,
        departureCity: departureCity
      });
      dispatch(Object(additionalTransports_action["b" /* fetchAdditionalTransports */])({
        proposal: proposal,
        transportSearchCriteria: transportSearchCriteria,
        appContext: appContext
      }));
    }
  }, [proposal.id]);
  var errorTitle = error ? Object(src_i18n["h" /* t */])('booking.transport.additionalTransports.unknownErrorHeaderTitle') : undefined;
  return MoreTransports_jsx(react_default.a.Fragment, null, MoreTransports_jsx(TrackPage["a" /* TrackPage */], {
    pageName: tracking_constants["H" /* TRACK_PAGE_NAMES */].BE_LAYER_TRANSPORT,
    payload: MoreTransports_objectSpread({}, beEngineTrackingContext)
  }), MoreTransports_jsx(AdditionalTransportLayer_AdditionalTransportLayer, {
    onClose: function onClose(proposalId) {
      return _onClose(false, proposalId);
    },
    setSelectedTransport: setSelectedTransport,
    proposal: proposal,
    errorTitle: errorTitle
  }));
};
// EXTERNAL MODULE: ./src/client/views/booking/transport/TransferBulletPoints.jsx
var TransferBulletPoints = __webpack_require__("mYZO");

// CONCATENATED MODULE: ./src/client/views/booking/transport/TransportsSection.jsx


var TransportsSection_jsx = react_default.a.createElement;

/**
 * * Booking search transport page [find transport page]
 * * using fetchProposalsById method to get proposals[0].transports (inbound & outbound)
 */













var PRODUCT_TYPE = {
  CRUISE: 'CRUISE'
};
var TransportsSection_TransportsSection = function TransportsSection(_ref) {
  var _transports$inbound;

  var i18n = _ref.i18n,
      resort = _ref.resort,
      selectedProposal = _ref.selectedProposal,
      onMoreTransportsClick = _ref.onMoreTransportsClick,
      closeLayer = _ref.closeLayer,
      shouldShowLayer = _ref.shouldShowLayer;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var dispatch = Object(es["d" /* useDispatch */])();

  var _ref2 = selectedProposal || {},
      transports = _ref2.transports;

  var isTransportRecommended = Object(proposalUtils["x" /* isRecommendedTransport */])(transports, selectedProposal.id);

  var handleAddTransport = function handleAddTransport(transportId) {
    var transportI18n = i18n.booking.transport;
    Promise.resolve(closeLayer(true, selectedProposal.id)).then(function () {
      if (transportId === selectedProposal.id) {
        // no need to call the addTransportMutation because the recommended flight is selected by default
        setTimeout(function () {
          return dispatch(Object(toast_actions["d" /* openToast */])(transportI18n.newTransportSelection));
        }, 1000);
      } else {
        dispatch(Object(proposals_action["r" /* putTransportAndDispatchProposals */])(transportId, Object(BookingEngine_utils["b" /* getAllProposalsIdWithAlternative */])(selectedProposal), resort.isJoyview, resort.isUrbanOasis, appContext, transportI18n.additionalTransports.loaderLabelUpdate, transportI18n.newTransportSelection));
      }
    });
  };

  var isPlane = Object(transport_details_transportUtils["n" /* hasOnlyPlanes */])(transports === null || transports === void 0 ? void 0 : (_transports$inbound = transports.inbound) === null || _transports$inbound === void 0 ? void 0 : _transports$inbound.travelSections);
  return TransportsSection_jsx(react["Fragment"], null, TransportsSection_jsx(OverlaidActionProvider_OverlaidActionProvider, {
    label: Object(src_i18n["h" /* t */])('booking.transport.headlineCTA'),
    button: {
      label: Object(src_i18n["h" /* t */])(isPlane ? 'booking.transport.additionalTransports.otherProposals' : 'booking.otherTransport'),
      onClick: onMoreTransportsClick
    }
  }, TransportsSection_jsx("div", {
    className: "TransportsView-context mt-20"
  }, TransportsSection_jsx(BeTransportDetails["a" /* BeTransportDetails */], {
    transport: selectedProposal === null || selectedProposal === void 0 ? void 0 : selectedProposal.transports,
    isTransportRecommended: isTransportRecommended
  }), TransportsSection_jsx("div", {
    className: "mt-20"
  }, TransportsSection_jsx(TransferBulletPoints["a" /* TransferBulletPoints */], {
    title: "common.transport.transfer.information",
    bulletPoints: ['common.transport.transfer.cancellationReinsurance', 'common.transport.transfer.tripTogether', 'common.transport.transfer.arrivalPickup', 'common.transport.transfer.luggage']
  })))), shouldShowLayer && TransportsSection_jsx(MoreTransports_MoreTransports, {
    proposal: selectedProposal,
    onClose: closeLayer,
    setSelectedTransport: handleAddTransport
  }));
};
// EXTERNAL MODULE: ./src/client/components/widgets/package/transfers-section/TransfersSection.jsx + 3 modules
var TransfersSection = __webpack_require__("ptRt");

// CONCATENATED MODULE: ./src/client/views/booking/transport/TransferInDetails.jsx


var TransferInDetails_jsx = react_default.a.createElement;


var TransferInDetails_TransferInDetails = function TransferInDetails(_ref) {
  var iconName = _ref.iconName,
      description = _ref.description,
      detail = _ref.detail;
  return TransferInDetails_jsx("div", {
    "data-testid": "TransferInDetails",
    className: "h-full bg-white"
  }, TransferInDetails_jsx("div", {
    "data-testid": "TransferInDetails-icon",
    className: "flex items-start gap-20"
  }, TransferInDetails_jsx(Badge["a" /* Badge */], {
    className: "size-48 border-lightSand bg-lightSand text-black",
    iconName: iconName,
    iconSize: "24px",
    variant: "pill"
  }), TransferInDetails_jsx("div", {
    className: "text-start text-16 leading-normal"
  }, TransferInDetails_jsx("p", {
    className: "mb-8"
  }, description), TransferInDetails_jsx("p", {
    className: "text-14 text-mediumGrey"
  }, detail))));
};
// CONCATENATED MODULE: ./src/client/views/booking/transport/TransfersInfos.jsx

var TransfersInfos_jsx = react_default.a.createElement;





var TransfersInfos_TransfersInfos = function TransfersInfos(_ref) {
  var _resort$facilities, _selectedProposal$add;

  var hasSelectedTransfer = _ref.hasSelectedTransfer,
      resort = _ref.resort,
      selectedProposal = _ref.selectedProposal;
  var hasParking = resort === null || resort === void 0 ? void 0 : (_resort$facilities = resort.facilities) === null || _resort$facilities === void 0 ? void 0 : _resort$facilities.some(function (facility) {
    return facility.type && facility.type === 'PARKING';
  });
  var firstTransfer = (_selectedProposal$add = selectedProposal.additionalServices.transfers) === null || _selectedProposal$add === void 0 ? void 0 : _selectedProposal$add[0];

  var _ref2 = (firstTransfer === null || firstTransfer === void 0 ? void 0 : firstTransfer.pricingInfo.schedules[0]) || {},
      firstTransferStartDate = _ref2.startDate,
      firstTransferEndDate = _ref2.endDate;

  var isOneWayTransfer = (firstTransfer === null || firstTransfer === void 0 ? void 0 : firstTransfer.pricingInfo.schedules.length) === 1;
  var transferBulletPointTitle = 'common.transport.transfer.title';
  var transferBulletPoints = ['common.transport.transfer.arrivalPoint', 'common.transport.transfer.roundTrip'];

  if (isOneWayTransfer) {
    var isOutBoundTransfer = firstTransferStartDate === selectedProposal.departureDate;
    var isInBoundTransfer = firstTransferEndDate === selectedProposal.arrivalDate;

    if (isOutBoundTransfer) {
      transferBulletPoints = ['common.transport.transfer.outboundOnlyIncluded'];
    }

    if (isInBoundTransfer) {
      transferBulletPoints = ['common.transport.transfer.arrivalPoint', 'common.transport.transfer.inboundOnlyIncluded'];
    }
  }

  return TransfersInfos_jsx("div", {
    className: "mt-40"
  }, TransfersInfos_jsx(TransferBulletPoints["a" /* TransferBulletPoints */], {
    title: transferBulletPointTitle,
    bulletPoints: transferBulletPoints
  }), TransfersInfos_jsx("div", {
    className: "mt-40 items-start justify-between md:flex"
  }, hasSelectedTransfer && TransfersInfos_jsx("div", {
    className: "mb-20 md:mb-0 md:w-2/5"
  }, TransfersInfos_jsx(TransferInDetails_TransferInDetails, {
    iconName: icons["a" /* ICONS */].LIGHTBULB,
    description: Object(src_i18n["h" /* t */])('common.transport.transfer.reassuranceTransportDescription'),
    detail: Object(src_i18n["h" /* t */])('common.transport.transfer.reassuranceTransportDetails')
  })), hasParking && TransfersInfos_jsx("div", {
    className: "md:w-2/5"
  }, TransfersInfos_jsx(TransferInDetails_TransferInDetails, {
    iconName: icons["a" /* ICONS */].CAR_PARK,
    description: Object(src_i18n["h" /* t */])('booking.transport.transfer.parking.insterDescription'),
    detail: Object(src_i18n["h" /* t */])('booking.transport.transfer.parking.insterDetails')
  }))));
};
// CONCATENATED MODULE: ./src/client/views/booking/transport/TransfersView.jsx



var TransfersView_jsx = react_default.a.createElement;












var TransfersView_TransfersView = function TransfersView(_ref) {
  var proposals = _ref.proposals,
      selectedProposal = _ref.selectedProposal,
      resort = _ref.resort;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var dispatch = Object(es["d" /* useDispatch */])();
  var track = useBETracking_useBETracking();
  var availableTransfers = selectedProposal.additionalServices.transfers;
  var selectedTransfers = (selectedProposal.additionalServices.transfers || []).filter(function (transfer) {
    return transfer.pricingInfo.isFullyRented;
  });

  var _React$useState = react_default.a.useState(false),
      _React$useState2 = Object(slicedToArray["a" /* default */])(_React$useState, 2),
      hasSelectedTransfer = _React$useState2[0],
      setHasSelectedTransfer = _React$useState2[1];

  var onAddTransfer = function onAddTransfer(transfer) {
    var _getProposalIdsAndOve = Object(transportUtils["f" /* getProposalIdsAndOverloadForAdditionalServiceQuery */])(proposals, transfer),
        proposalIds = _getProposalIdsAndOve.proposalIds,
        overloadForSpecificProposalIds = _getProposalIdsAndOve.overloadForSpecificProposalIds;

    var addTransferAction = Object(proposals_action["b" /* addAdditionalService */])({
      proposalIds: proposalIds,
      serviceId: transfer.pricingInfo.id,
      schedules: transfer.pricingInfo.schedules.map(function (_ref2) {
        var startDate = _ref2.startDate,
            endDate = _ref2.endDate;
        return {
          startDate: startDate,
          endDate: endDate
        };
      }),
      attendeeIds: transfer.pricingInfo.schedules[0].attendees.map(function (_ref3) {
        var id = _ref3.id;
        return id;
      }),
      overloadForSpecificProposalIds: overloadForSpecificProposalIds,
      appContext: appContext
    });
    return dispatch(addTransferAction).catch(function (error) {
      return Object(BookingEngine_utils["i" /* trackErrorOnAddService */])(error, track({
        actionGA: 'transport'
      }), 'TRANSFER_NOT_FOUND');
    });
  };

  var onRemoveTransfer = function onRemoveTransfer(transfer) {
    var _getProposalIdsAndOve2 = Object(transportUtils["f" /* getProposalIdsAndOverloadForAdditionalServiceQuery */])(proposals, transfer),
        overloadForSpecificProposalIds = _getProposalIdsAndOve2.overloadForSpecificProposalIds;

    return dispatch(Object(proposals_action["g" /* deleteAdditionalServices */])({
      serviceIds: [transfer.productInfo.id],
      attendeeIds: transfer.pricingInfo.schedules[0].attendees.map(function (attendee) {
        return attendee.id;
      }),
      overloadForSpecificProposalIds: overloadForSpecificProposalIds,
      appContext: appContext
    }));
  };

  return TransfersView_jsx("div", null, TransfersView_jsx(Tag["a" /* Tag */], {
    className: "mb-10 border-sienna bg-sienna text-white"
  }, Object(src_i18n["h" /* t */])('booking.confirmation.onDemand')), TransfersView_jsx(Title["a" /* Title */], {
    className: "mb-20",
    theme: "title-brand-n0"
  }, Object(src_i18n["h" /* t */])('common.transport.transfer.transferOnDemand')), TransfersView_jsx(TransfersSection["a" /* TransfersSection */], {
    isBE: true,
    availableTransfers: availableTransfers,
    selectedTransfers: selectedTransfers,
    addTransfer: onAddTransfer,
    removeTransfer: onRemoveTransfer,
    setHasSelectedTransfer: setHasSelectedTransfer
  }), TransfersView_jsx(TransfersInfos_TransfersInfos, {
    hasSelectedTransfer: hasSelectedTransfer,
    resort: resort,
    selectedProposal: selectedProposal
  }));
};
// CONCATENATED MODULE: ./src/client/views/booking/transport/TransportsView.jsx

var TransportsView_jsx = react_default.a.createElement;

/**
 * * Booking search transport page [find transport page]
 */










var TRANSPORTS_LAYER_NAME = 'AdditionalTransportsLayer';
var TransportsView_TransportsView = function TransportsView(_ref) {
  var i18n = _ref.i18n,
      proposals = _ref.proposals,
      selectedProposal = _ref.selectedProposal,
      resort = _ref.resort,
      infoBannerData = _ref.infoBannerData,
      closeLayer = _ref.closeLayer,
      openLayer = _ref.openLayer;
  Object(useBookingNavbar["a" /* useBookingNavbar */])({
    noEdit: false
  });
  var router = Object(next_router["useRouter"])();
  var queryParams = router.query;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var onMoreTransportsClick = function onMoreTransportsClick() {
    trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_TRANSPORT, {
      detail_click: 'see_more_transport'
    });
    openLayer(TRANSPORTS_LAYER_NAME);
  };

  return TransportsView_jsx(react["Fragment"], null, Object(infoBanner_utils["a" /* renderInfoBanner */])({
    infoBannerData: infoBannerData,
    departureDate: selectedProposal.departureDate,
    arrivalDate: selectedProposal.arrivalDate,
    currentStep: selectedProposal.transports ? 'transport' : 'transfert'
  }), TransportsView_jsx(head_default.a, null, TransportsView_jsx("title", {
    key: "title"
  }, get_default()(i18n, selectedProposal.transports ? 'booking.transport.seo.title' : 'booking.transport.transfer.seo.title'))), selectedProposal.transports ? TransportsView_jsx(TransportsSection_TransportsSection, {
    i18n: i18n,
    proposals: proposals,
    selectedProposal: selectedProposal,
    onMoreTransportsClick: onMoreTransportsClick,
    shouldShowLayer: queryParams[dist["appQueryParameters"].openLayer] === TRANSPORTS_LAYER_NAME,
    closeLayer: closeLayer,
    resort: resort
  }) : TransportsView_jsx(TransfersView_TransfersView, {
    proposals: proposals,
    selectedProposal: selectedProposal,
    resort: resort
  }));
};
// CONCATENATED MODULE: ./src/client/views/booking/BookingStep.jsx

















var BookingStep_jsx = react_default.a.createElement;

function BookingStep_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function BookingStep_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { BookingStep_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { BookingStep_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






























var getChinaTimerSessionKey = function getChinaTimerSessionKey(id) {
  return "china-summary-timer_".concat(id);
};

var BookingStep_BookingStepContent = function BookingStepContent(_ref) {
  var actionGA = _ref.actionGA,
      closeLayer = _ref.closeLayer,
      currentStep = _ref.currentStep,
      goToNextStep = _ref.goToNextStep,
      i18n = _ref.i18n,
      isFavorite = _ref.isFavorite,
      openLayer = _ref.openLayer,
      proposals = _ref.proposals,
      resort = _ref.resort,
      selectedProposal = _ref.selectedProposal,
      setTimerInitialValue = _ref.setTimerInitialValue,
      showTimer = _ref.showTimer,
      streetViews = _ref.streetViews,
      timerInitialValue = _ref.timerInitialValue,
      infoBannerData = _ref.infoBannerData,
      isOptionHoldOnly = _ref.isOptionHoldOnly,
      attendeesPaymentStatus = _ref.attendeesPaymentStatus;
  var sharedProps = {
    proposals: proposals,
    selectedProposal: selectedProposal,
    resort: resort,
    infoBannerData: infoBannerData
  };

  switch (currentStep) {
    case 'accommodation':
      return BookingStep_jsx(AccommodationView_AccommodationView, Object(esm_extends["a" /* default */])({}, sharedProps, {
        closeLayer: closeLayer,
        openLayer: openLayer,
        streetViews: streetViews
      }));

    case 'transport':
      return BookingStep_jsx(TransportsView_TransportsView, Object(esm_extends["a" /* default */])({}, sharedProps, {
        closeLayer: closeLayer,
        i18n: i18n,
        openLayer: openLayer
      }));

    case 'participants':
      return BookingStep_jsx(ParticipantsView_ParticipantsView, Object(esm_extends["a" /* default */])({}, sharedProps, {
        closeLayer: closeLayer,
        goToNextStep: goToNextStep,
        i18n: i18n,
        openLayer: openLayer
      }));

    case 'summary':
      return BookingStep_jsx(summary_SummaryView, Object(esm_extends["a" /* default */])({}, sharedProps, {
        actionGA: actionGA,
        bookingStep: currentStep,
        goToNextStep: goToNextStep,
        i18n: i18n,
        isFavorite: isFavorite,
        showTimer: showTimer && !timerInitialValue,
        setTimerInitialValue: setTimerInitialValue,
        isOptionHoldOnly: isOptionHoldOnly
      }));

    case 'banking':
      return BookingStep_jsx(BankingView_BankingView, Object(esm_extends["a" /* default */])({}, sharedProps, {
        i18n: i18n,
        attendeesPaymentStatus: attendeesPaymentStatus
      }));

    case 'services':
      return BookingStep_jsx(services_ServicesView, sharedProps);

    case 'activities':
      return BookingStep_jsx(ActivitiesView_ActivitiesView, sharedProps);

    default:
      // eslint-disable-next-line no-console
      console.error("The booking engine doesn't know how to handle the step ".concat(currentStep));
      return null;
  }
};

var BookingStep_BookingStep = function BookingStep(props) {
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var dispatch = Object(es["d" /* useDispatch */])();
  var trackingStorage = Object(tracking_storage_api["b" /* get */])(tracking_constants["c" /* BE_TRACKING */]);

  var _useState = Object(react["useState"])({
    productInformationBanners: []
  }),
      infoBannerData = _useState[0],
      setInfoBannerData = _useState[1];

  var fetchInfoBannerData = /*#__PURE__*/function () {
    var _ref2 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var response;
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return graphqlClient["a" /* default */].runNoCacheQuery(Object(infoBanner_query["a" /* getInfoBannerQuery */])(props.resort.id), appContext, {
                requestName: requestDictionary["pd" /* WIDGET_PRODUCT_FETCH_INFORMATION_BANNERS */]
              });

            case 2:
              response = _context.sent;
              setInfoBannerData(response);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchInfoBannerData() {
      return _ref2.apply(this, arguments);
    };
  }();

  Object(react["useEffect"])(function () {
    fetchInfoBannerData();
  }, [props.resort.id]);
  var currentStep = props.currentStep,
      resort = props.resort,
      selectedProposal = props.selectedProposal;
  var router = Object(next_router["useRouter"])();

  var _useState2 = Object(react["useState"])(false),
      redirecting = _useState2[0],
      setRedirecting = _useState2[1];

  var isChineseLocales = Object(localeUtils["a" /* isChineseLocale */])(appContext.locale);
  var chinaTimerSessionKey = sessionStorage.getItem(getChinaTimerSessionKey(selectedProposal.id));

  var _useState3 = Object(react["useState"])(isChineseLocales ? Number(chinaTimerSessionKey) : 0),
      timerInitialValue = _useState3[0],
      setTimerInitialValue = _useState3[1];

  var showTimer = isChineseLocales && !!(selectedProposal === null || selectedProposal === void 0 ? void 0 : selectedProposal.transports);
  var insurancesStore = Object(es["e" /* useSelector */])(booking_selector["o" /* getInsurancesStore */]);
  Object(react["useEffect"])(function () {
    var storePrice = function storePrice() {
      return Object(tracking_storage_api["c" /* set */])(BookingStep_objectSpread(BookingStep_objectSpread({}, trackingStorage), {}, {
        base_price: BookingStep_objectSpread(BookingStep_objectSpread({}, trackingStorage.base_price), {}, Object(defineProperty["a" /* default */])({
          proposalId: selectedProposal.id
        }, "base_price_".concat(currentStep), selectedProposal.price.total.value))
      }));
    };

    var basePrice = trackingStorage.base_price;

    if (basePrice && basePrice.proposalId !== selectedProposal.id) {
      Object(tracking_storage_api["c" /* set */])(BookingStep_objectSpread(BookingStep_objectSpread({}, trackingStorage), {}, {
        base_price: null
      }));
    }

    storePrice();
  }, [currentStep, selectedProposal.id]);
  Object(react["useEffect"])(function () {
    if (isEmpty_default()(insurancesStore)) {
      var _selectedProposal$add;

      var insurancesInitialState = {};
      (_selectedProposal$add = selectedProposal.additionalServices.insurance) === null || _selectedProposal$add === void 0 ? void 0 : _selectedProposal$add.forEach(function (ins) {
        insurancesInitialState[ins.pricingInfo.id] = {
          isAdded: ins.pricingInfo.isPartiallyRented,
          isDeleted: false,
          termsChecked: false
        };
      });
      dispatch(Object(createAction["b" /* default */])(proposals_constants["q" /* INIT_INSURANCES */], insurancesInitialState));
    }
  }, []);

  var redirectToResort = function redirectToResort() {
    var resortUri = new URI_default.a(resort === null || resort === void 0 ? void 0 : resort.href).query(BookingStep_objectSpread({}, omit_default()(router.query, ['bookingStep', 'proposalIds', 'selectedProposalId']))).toString();
    setRedirecting(true);
    router.push(dist["url"].normalizeUrl(resortUri));
  };

  var bookingStepContentProps = BookingStep_objectSpread(BookingStep_objectSpread({}, props), {}, {
    setTimerInitialValue: setTimerInitialValue,
    showTimer: showTimer,
    timerInitialValue: timerInitialValue,
    infoBannerData: infoBannerData
  });

  return BookingStep_jsx(react["Fragment"], null, showTimer && timerInitialValue > 0 && BookingStep_jsx("div", {
    className: "font-brand"
  }, BookingStep_jsx(Countdown["a" /* Countdown */], {
    className: "pt-10",
    color: colors["a" /* COLORS */].ORANGE,
    theme: "timer",
    dateTimeEnd: moment_default.a.unix(timerInitialValue),
    description: Object(src_i18n["h" /* t */])('booking.transport.countdown.proposalTimeGuaranty'),
    showTimer: currentStep === 'summary' || currentStep === 'banking',
    units: ['minutes', 'seconds'],
    expiredRender: !redirecting && BookingStep_jsx(Modal["a" /* Modal */], {
      size: "small",
      hasCloseButton: false
    }, BookingStep_jsx("div", {
      className: "rounded-12 text-center"
    }, BookingStep_jsx("div", {
      className: "bg-lightGrey p-10 font-bold"
    }, Object(src_i18n["h" /* t */])('booking.transport.countdown.countdownExpired')), BookingStep_jsx("div", {
      className: "p-30 font-bold"
    }, "00".concat(Object(src_i18n["h" /* t */])('common.countdownMinute'), " 0").concat(Object(src_i18n["h" /* t */])('common.countdownSecond'))), BookingStep_jsx("div", {
      className: "pb-20 pt-10"
    }, Object(src_i18n["h" /* t */])('booking.transport.countdown.countdownExpiredInformation')), BookingStep_jsx(Button["a" /* Button */], {
      className: "mb-20",
      onClick: redirectToResort
    }, Object(src_i18n["h" /* t */])('booking.transport.countdown.retryNewProposal')))),
    minutes: Object(src_i18n["h" /* t */])('common.countdownMinute'),
    seconds: Object(src_i18n["h" /* t */])('common.countdownSecond')
  })), BookingStep_jsx(BookingStep_BookingStepContent, bookingStepContentProps));
};
// EXTERNAL MODULE: ./src/client/views/booking/BookingLayout.jsx + 2 modules
var BookingLayout = __webpack_require__("idSt");

// EXTERNAL MODULE: ./src/utils/resort/resortUtils.js
var resortUtils = __webpack_require__("1qsz");

// CONCATENATED MODULE: ./src/client/views/booking/participants/candy-bar/CandyBar.jsx
var CandyBar_jsx = react_default.a.createElement;





var IMAGE_URLS = {
  summer: "bg-[url('https://ns.clubmed.com/it/2019/be/pax/summerMobile.png')] md:bg-[url('https://ns.clubmed.com/it/2019/be/pax/summer.png')]",
  winter: "bg-[url('https://ns.clubmed.com/it/2019/be/pax/winterMobile.png')] md:bg-[url('https://ns.clubmed.com/it/2019/be/pax/winter.png')]"
};
var CandyBar_CandyBar = function CandyBar(_ref) {
  var allInclusive = _ref.allInclusive,
      fidelity = _ref.fidelity,
      spreadPayment = _ref.spreadPayment,
      type = _ref.type;
  return CandyBar_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('flex h-[572px] flex-col items-center rounded-12 bg-cover bg-bottom bg-no-repeat text-center font-sans font-bold text-white text-shadow-1 sm:flex-row md:h-170', IMAGE_URLS[type])
  }, CandyBar_jsx("div", {
    className: "flex flex-col items-center justify-around py-20 sm:w-7/10 sm:flex-row sm:items-end"
  }, spreadPayment.number ? CandyBar_jsx("div", {
    className: "w-2/3 py-15 sm:w-auto sm:px-20"
  }, CandyBar_jsx("div", null, CandyBar_jsx("span", {
    className: "font-brand text-60 font-normal leading-1"
  }, spreadPayment.number), CandyBar_jsx("span", {
    className: "font-brand text-40 font-normal leading-1"
  }, "\xD7")), CandyBar_jsx("div", {
    className: "w-full"
  }, CandyBar_jsx(TemplateString["a" /* TemplateString */], {
    template: spreadPayment.text,
    values: {
      number: spreadPayment.number
    }
  }))) : null, CandyBar_jsx("div", {
    className: "relative w-2/3 py-15 sm:w-auto sm:px-20"
  }, CandyBar_jsx(Icon["a" /* Icon */], {
    className: "mb-10",
    isNotSquare: true,
    name: icons["a" /* ICONS */].CLUBMED_GREAT_MEMBERS_WITH_SHADOW,
    width: "6.875rem"
  }), CandyBar_jsx("div", {
    className: "w-full"
  }, fidelity.text)), allInclusive.text ? CandyBar_jsx("div", {
    className: "w-2/3 py-15 sm:w-auto sm:px-20"
  }, CandyBar_jsx(Icon["a" /* Icon */], {
    className: "mb-10",
    name: icons["a" /* ICONS */].ALL_INCLUSIVE_WITH_SHADOW,
    width: "2.6875rem"
  }), CandyBar_jsx("div", {
    className: "w-full"
  }, allInclusive.text)) : null));
};
// CONCATENATED MODULE: ./src/client/views/booking/participants/candy-bar/ParticipantsReassurance.jsx
var ParticipantsReassurance_jsx = react_default.a.createElement;



var ParticipantsReassurance_ParticipantsReassurance = function ParticipantsReassurance(_ref) {
  var i18n = _ref.i18n,
      resort = _ref.resort,
      proposal = _ref.proposal;
  return ParticipantsReassurance_jsx(CandyBar_CandyBar, {
    allInclusive: {
      text: (proposal === null || proposal === void 0 ? void 0 : proposal.packageId) === 'RON' ? null : i18n.booking.participants.rassurance.allInclusive
    },
    fidelity: {
      text: i18n.booking.participants.rassurance.fidelity
    },
    spreadPayment: {
      number: i18n.booking.participants.rassurance.paymentHeader,
      text: i18n.booking.participants.rassurance.paymentText
    },
    type: Object(resortUtils["b" /* isWinterResort */])(resort) ? 'winter' : 'summer'
  });
};
// EXTERNAL MODULE: ./src/client/context/FavoriteProductListContext.js
var FavoriteProductListContext = __webpack_require__("XGb2");

// CONCATENATED MODULE: ./src/client/views/booking/travel-plans/TravelPlans.jsx


 // Transform it to a hook after BookingEngine migration to functional component

var TravelPlans_TravelPlansComponent = function TravelPlansComponent(_ref) {
  var savedProposal = _ref.savedProposal,
      selectedProposal = _ref.selectedProposal,
      resort = _ref.resort,
      setFavorite = _ref.setFavorite;

  var _useContext = Object(react["useContext"])(FavoriteProductListContext["a" /* FavoriteProductListContext */]),
      favoriteProductList = _useContext.favoriteProductsState.favoriteProductList,
      addTravelPlan = _useContext.addTravelPlan;

  Object(react["useEffect"])(function () {
    setFavorite(favoriteProductList.some(function (_ref2) {
      var reference = _ref2.reference;
      return reference === selectedProposal.id;
    }));
  }, [selectedProposal]);
  Object(react["useEffect"])(function () {
    if (savedProposal) {
      addTravelPlan(savedProposal, resort);
    }
  }, [savedProposal]);
  return null;
};
// CONCATENATED MODULE: ./src/client/views/booking/BookingEngine.jsx


















































var BookingEngine_jsx = react_default.a.createElement;

function BookingEngine_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function BookingEngine_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { BookingEngine_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { BookingEngine_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



function BookingEngine_createSuper(Derived) { var hasNativeReflectConstruct = BookingEngine_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function BookingEngine_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-disable clubmed/no-fake-component */

















































var SHOW_LAYER_QUERY_NAME = dist["appQueryParameters"].openLayer;
var PRODUCT_TYPES = dist["constants"].PRODUCT_TYPES;

/**
 * Global Wrapper for booking engine purchase process
 * Breadcrumb component display current step
 * Each step represents a component linked to process
 * Button next/back allow users to navigate through step
 */
var BookingEngine_BookingEngineComponent = /*#__PURE__*/function (_React$PureComponent) {
  Object(inherits["a" /* default */])(BookingEngineComponent, _React$PureComponent);

  var _super = BookingEngine_createSuper(BookingEngineComponent);

  function BookingEngineComponent() {
    var _this$props$selectedP, _this$props$selectedP2;

    var _this;

    Object(classCallCheck["a" /* default */])(this, BookingEngineComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "state", {
      criteriaOpened: null,
      previousSelectedProposalId: _this.props.selectedProposal.id,
      unlockedStep: 0,
      step: 0,
      shouldShowSaveCriteriaConfirmation: false,
      shouldShowSaveCriteriaLogin: false,
      shouldShowShareContext: false,
      shouldRefreshProposalModal: false,
      persistenceExtended: false,
      isDataFetched: !_this.shouldFetchData(),
      displayActivities: Object(featureFlippingUtils["a" /* isFeatureFlipped */])(_this.context)('booking.displayActivities'),
      optionHoldOnly: (((_this$props$selectedP = _this.props.selectedProposal) === null || _this$props$selectedP === void 0 ? void 0 : (_this$props$selectedP2 = _this$props$selectedP.households) === null || _this$props$selectedP2 === void 0 ? void 0 : _this$props$selectedP2.length) > 1 && Object(featureFlippingUtils["a" /* isFeatureFlipped */])(_this.context)('booking.multiHouseholdOptionOnly') || Object(featureFlippingUtils["a" /* isFeatureFlipped */])(_this.context)('booking.optionHoldOnly')) && _this.props.selectedProposal.price && _this.props.selectedProposal.price.currency !== 'MXN',
      savedProposal: null,
      refreshedProposal: undefined,
      shouldOpenPanel: false,
      isProposalFavorite: false,
      isNextStep: false,
      displayRefreshProposalError: false,
      hasInternalServerError: false,
      attendeesPaymentStatus: [],
      clickOrigin: null
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "setFavorite", function (isFavorite) {
      _this.setState({
        isProposalFavorite: isFavorite
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "checkIfFavoriFromShopping", /*#__PURE__*/Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var _this$props$selectedP3, _this$props$selectedP4, _this$props$selectedP5, _this$props$selectedP6, _this$props$selectedP7;

      var arrivalDateToTimestamp, departureCity, favoriteProductList, isShoppingFavorite;
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // Check if favori from shopping
              // $FlowFixMe
              arrivalDateToTimestamp = new Date(moment_default()(_this.props.selectedProposal.arrivalDate)).getTime();
              departureCity = ((_this$props$selectedP3 = _this.props.selectedProposal.transports) === null || _this$props$selectedP3 === void 0 ? void 0 : (_this$props$selectedP4 = _this$props$selectedP3.inbound) === null || _this$props$selectedP4 === void 0 ? void 0 : (_this$props$selectedP5 = _this$props$selectedP4.travelSections) === null || _this$props$selectedP5 === void 0 ? void 0 : (_this$props$selectedP6 = _this$props$selectedP5[0]) === null || _this$props$selectedP6 === void 0 ? void 0 : (_this$props$selectedP7 = _this$props$selectedP6.departure) === null || _this$props$selectedP7 === void 0 ? void 0 : _this$props$selectedP7.cityId) || 'NO';
              favoriteProductList = Object(local_storage_api["a" /* getFromLocalStorage */])(_this.context.isUserLogged ? tracking_constants["A" /* SHOPPING_REMOTE_FAVORITE_PRODUCTS */] : tracking_constants["w" /* SHOPPING_FAVORITE_PRODUCTS */]) || [];
              isShoppingFavorite = favoriteProductList.some(function (item) {
                var _this$props$selectedP8, _this$props$selectedP9, _item$kids, _this$props$selectedP10, _this$props$selectedP11;

                return item.adultsNumber === ((_this$props$selectedP8 = _this.props.selectedProposal.attendees) === null || _this$props$selectedP8 === void 0 ? void 0 : (_this$props$selectedP9 = _this$props$selectedP8.adults) === null || _this$props$selectedP9 === void 0 ? void 0 : _this$props$selectedP9.length) && item.departureDate === arrivalDateToTimestamp && item.duration === _this.props.selectedProposal.duration && item.departureCity === departureCity && ((_item$kids = item.kids) === null || _item$kids === void 0 ? void 0 : _item$kids.length) === ((_this$props$selectedP10 = _this.props.selectedProposal.attendees) === null || _this$props$selectedP10 === void 0 ? void 0 : (_this$props$selectedP11 = _this$props$selectedP10.children) === null || _this$props$selectedP11 === void 0 ? void 0 : _this$props$selectedP11.length) && item.product.id === _this.props.selectedProposal.productId && item.reference !== _this.props.selectedProposal.id;
              });

              if (isShoppingFavorite && !_this.state.isProposalFavorite) {
                _this.showSavedCriteriaPopIn(false);
              }

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "handleABTastyUpdate", function () {
      console.info('CM_AB: handleABTastyUpdate called'); // force the update of the steps

      _this.updateStepsFromProps(); // force rerender


      _this.forceUpdate();

      console.info('CM_AB: handleABTastyUpdate completed');
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "forceUpdateFromABTasty", function () {
      console.info('CM_AB: forceUpdateFromABTasty called');

      _this.updateStepsFromProps();

      _this.forceUpdate();

      console.info('CM_AB: forceUpdateFromABTasty completed');
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "handleNoData", function () {
      var _this$props = _this.props,
          proposals = _this$props.proposals,
          selectedProposal = _this$props.selectedProposal,
          router = _this$props.router; // Ideally, this doesn't happen. But who knows why, there can be issues with the API, and you
      // don't have a proposal. It makes no sense to continue

      if (_this.state.isDataFetched && (isEmpty_default()(proposals) || !selectedProposal)) {
        logger["default"].error(new errors_errors["e" /* ProposalNotFound */]());

        if (Object(contextUtils["f" /* isStrictlyProductionEnv */])()) {
          var locale = router.query.locale;
          return router.replace({
            pathname: '/500',
            query: Boolean(locale) && {
              locale: locale
            }
          });
        }

        return null;
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "loadStreetViews", /*#__PURE__*/function () {
      var _ref3 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee2(_ref2) {
        var resort, withLoader, _this$props2, endLoading, startLoading, accommodations, categoryIds;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                resort = _ref2.resort, withLoader = _ref2.withLoader;
                _this$props2 = _this.props, endLoading = _this$props2.endLoading, startLoading = _this$props2.startLoading;
                accommodations = (resort === null || resort === void 0 ? void 0 : resort.accommodations) || [];
                categoryIds = accommodations && accommodations.length > 0 ? Object(toConsumableArray["a" /* default */])(new Set(accommodations.map(function (_ref4) {
                  var categoryId = _ref4.categoryId;
                  return categoryId;
                }))) : null;

                if (!((resort === null || resort === void 0 ? void 0 : resort.id) && resort.type !== PRODUCT_TYPES.CRUISE && categoryIds && categoryIds.length > 0)) {
                  _context2.next = 9;
                  break;
                }

                if (withLoader) {
                  startLoading();
                }

                _context2.next = 8;
                return _this.props.fetchStreetViewsByAccommodationCategoryId({
                  accommodationCategoryIds: categoryIds,
                  appContext: _this.context,
                  productId: resort.id
                });

              case 8:
                if (withLoader) {
                  endLoading();
                }

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }());

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "loadBookingStatus", /*#__PURE__*/function () {
      var _ref5 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee3(bookingId) {
        var _response$sellerBooki;

        var response;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (bookingId) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return", []);

              case 2:
                _context3.next = 4;
                return graphqlClient["a" /* default */].runNoCacheQuery("query {\n      sellerBooking (bookingId:\"".concat(bookingId, "\") {\n        bookingStatus\n        attendees {\n          customerId\n          hasPaid\n        }\n      }\n    }\n    "), _this.context, {
                  requestName: requestDictionary["wc" /* PAYMENT_BOOKING_STATUS */]
                });

              case 4:
                response = _context3.sent;
                return _context3.abrupt("return", (response === null || response === void 0 ? void 0 : (_response$sellerBooki = response.sellerBooking) === null || _response$sellerBooki === void 0 ? void 0 : _response$sellerBooki.attendees) || []);

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x2) {
        return _ref5.apply(this, arguments);
      };
    }());

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "getCurrentStepIndex", function () {
      var bookingStep = _this.props.router.query.bookingStep;
      return Object(BookingEngine_utils["g" /* getStepIndex */])(_this.getFilteredBreadcrumbPages(), bookingStep);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "getCurrentPage", function () {
      var bookingStep = _this.props.router.query.bookingStep;

      var currentPage = _this.getFilteredBreadcrumbPages().find(function (page) {
        return page.name === bookingStep;
      });

      Object(invariant["a" /* invariant */])(currentPage, "The step ".concat(bookingStep, " doesn't exist"));
      return currentPage;
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "updateStep", function (newStep, proposalId) {
      var queryParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var pages = _this.getFilteredBreadcrumbPages();

      _this.changeURI(pages[newStep].name, proposalId, queryParams);

      _this.setState({
        isNextStep: true
      });

      if (true) {
        // setTimeout mandatory for IE
        setTimeout(function () {
          return window.scrollTo(0, 0);
        });
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "goToNextStep", function (validationCallback) {
      return function (params) {
        var validationPromise = validationCallback ? validationCallback() : Promise.resolve();
        return validationPromise.then(function () {
          var pages = _this.getFilteredBreadcrumbPages();

          var step = Object(BookingEngine_utils["g" /* getStepIndex */])(pages, _this.props.router.query.bookingStep);
          var maxPagesIndex = pages.length - 1;

          if (step === maxPagesIndex) {
            return;
          }

          _this.updateStep(Math.min(maxPagesIndex, step + 1), null, (params === null || params === void 0 ? void 0 : params.queryParams) || {});
        }).catch(function () {
          return null;
        });
      };
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "goToPreviousStep", function () {
      var stepIndex = _this.getCurrentStepIndex();

      _this.props.trackClickPreviousStep();

      if (stepIndex !== 0) {
        return _this.updateStep(stepIndex - 1);
      }

      var _this$props3 = _this.props,
          router = _this$props3.router,
          resort = _this$props3.resort;
      var previousUri;
      var queryParams = router.query;

      if (queryParams.fromSearches) {
        previousUri = new URI_default.a(Object(routeBuilder["b" /* urlPattern */])('accountSearches')).query(BookingEngine_objectSpread({}, omit_default()(queryParams, ['bookingStep', 'proposalIds', 'selectedProposalId', 'product', 'coderesort', 'fromSearches', 'catId']))).toString();
      } else {
        previousUri = new URI_default.a(get_default()(resort, 'href')).query(BookingEngine_objectSpread({}, omit_default()(queryParams, ['bookingStep', 'proposalIds', 'selectedProposalId', 'catId']))).toString();
      }

      return _this.props.router.push(dist["url"].normalizeUrl(previousUri).toString());
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "openLayer", function (layerName) {
      var router = _this.props.router;
      var uri = new URI_default.a(router.asPath).addQuery(Object(defineProperty["a" /* default */])({}, SHOW_LAYER_QUERY_NAME, layerName));
      router.push(uri.toString());
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "closeLayer", function (submitted, proposalId) {
      var router = _this.props.router;

      if (submitted) {
        // this function is sometimes plugged directly to a dom element's onClick
        // so we have to use "typeof" to avoid truthy cases with dom-event...
        // if we're in AdditionalTransportsLayer we want to stay in the same step to view the selected transport
        var nextStep = router.query.openLayer === 'AdditionalTransportsLayer' ? _this.state.step : _this.state.step + 1;

        _this.updateStep(nextStep, typeof proposalId === 'string' ? proposalId : undefined);
      } else {
        var newUrl = new URI_default.a(router.asPath).removeQuery(SHOW_LAYER_QUERY_NAME);
        /**
         * This case happens only after selecting an accommodation on more rooms layer, on a proposal with a flex rate
         * When use choose a new room on a proposal with Flex Rate, we should come back to accommodation page,
         * but remove other proposals ids from the url (preserve the selected one only)
         */

        if (proposalId && typeof proposalId === 'string') {
          newUrl.setQuery('proposalIds', Object(BookingEngine_utils["b" /* getAllProposalsIdWithAlternative */])(_this.props.selectedProposal));
        }

        router.push(newUrl.toString());
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "hideSaveCriteriaConfirmationModal", function () {
      var router = _this.props.router;

      _this.setState({
        shouldShowSaveCriteriaConfirmation: false
      });

      if (router.query.openSaveConfirmationModal) {
        var newUrl = new URI_default.a(router.asPath).removeQuery(['openSaveConfirmationModal', 'newAccount']);
        router.replace(newUrl.toString());
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "hideSaveCriteriaLoginModal", function () {
      _this.setState({
        shouldShowSaveCriteriaLogin: false
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "toggleShareContextModal", function () {
      var shouldShowShareContext = _this.state.shouldShowShareContext;

      if (!shouldShowShareContext) {
        _this.props.trackClickShare();
      }

      _this.setState({
        shouldShowShareContext: !shouldShowShareContext
      });

      _this.props.closeToast();
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "extendProposalPersistence", function (extend) {
      var _this$props4 = _this.props,
          router = _this$props4.router,
          startLoading = _this$props4.startLoading,
          endLoading = _this$props4.endLoading;
      var selectedProposalId = router.query.selectedProposalId;
      startLoading();

      _this.props.patchProposalHandler(selectedProposalId, _this.context, extend).then(function () {
        _this.setState({
          shouldShowSaveCriteriaConfirmation: true,
          persistenceExtended: extend
        });
      }).catch(function (error) {
        logger["default"].error(error);
      }).finally(function () {
        endLoading();
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "showSavedCriteriaPopIn", function () {
      var popupDisplayed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (_this.context.isUserLogged) {
        _this.props.trackAddToWishlist();

        var selectedProposalId = _this.props.router.query.selectedProposalId;
        var _customerId = _this.context.neolaneId;

        _this.props.saveCustomerProposalsHandler(selectedProposalId, _this.context, _customerId).then(function () {
          try {
            _this.setState({
              savedProposal: _this.props.selectedProposal,
              isProposalFavorite: true
            });

            if (_this.state.unlockedStep >= 4) {
              _this.extendProposalPersistence(true);
            } else {
              _this.setState({
                shouldShowSaveCriteriaConfirmation: popupDisplayed
              });
            }
          } catch (errors) {
            logger["default"].error(errors);
          }
        }).catch(function (error) {
          // When the error is indeed an API error, this is the model. But code error would return
          // a native JS Error object, which doesn't have this structure
          if (error && error.errors) {
            var _error$errors = Object(slicedToArray["a" /* default */])(error.errors, 1),
                statusCode = _error$errors[0].statusCode; // catch 401 (bad token) error code
            // display save criteria login modal


            if (statusCode === 401) {
              _this.setState({
                shouldShowSaveCriteriaLogin: popupDisplayed
              });
            }
          }
        });
      } else {
        _this.setState({
          shouldShowSaveCriteriaLogin: true
        });
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onClickFavorite", function (origin) {
      var trackClickFavorite = _this.props.trackClickFavorite;

      if (!_this.state.isProposalFavorite) {
        trackClickFavorite(origin, 'travel_plans');

        _this.setState({
          clickOrigin: origin
        });

        _this.showSavedCriteriaPopIn();
      }
    });

    return _this;
  }

  Object(createClass["a" /* default */])(BookingEngineComponent, [{
    key: "updateStepsFromProps",
    // this function is to make sure that the thing rerenders correctly when ab tasty data arrives later
    value: function updateStepsFromProps() {
      var _this$props5 = this.props,
          selectedProposal = _this$props5.selectedProposal,
          resort = _this$props5.resort,
          i18n = _this$props5.i18n,
          abTastyData = _this$props5.abTastyData,
          router = _this$props5.router,
          proposals = _this$props5.proposals;
      var _this$state = this.state,
          displayActivities = _this$state.displayActivities,
          optionHoldOnly = _this$state.optionHoldOnly,
          attendeesPaymentStatus = _this$state.attendeesPaymentStatus,
          unlockedStep = _this$state.unlockedStep,
          previousSelectedProposalId = _this$state.previousSelectedProposalId;
      var isAbDataReady = abTastyData && Object.keys(abTastyData).length > 0 && Object.values(abTastyData).every(function (v) {
        return v === '0' || v === '1';
      });
      console.info('CM_AB: updateStepsFromProps called', {
        abTastyData: abTastyData,
        isAbDataReady: isAbDataReady,
        hasProposals: !isEmpty_default()(proposals),
        hasResort: !!resort,
        hasI18n: !!i18n.booking,
        hasSelectedProposal: !!selectedProposal,
        willRender: !isEmpty_default()(proposals) && !!resort && !!i18n.booking && !!selectedProposal
      });

      if (isEmpty_default()(proposals) || !resort || !i18n.booking || !selectedProposal) {
        console.info('CM_AB: Skipping update - missing required data');
        return;
      } // Use AB Tasty data if available, otherwise default to showing activities step


      var shouldHideActivitiesStepAbTest = (abTastyData === null || abTastyData === void 0 ? void 0 : abTastyData['ab-test-activities']) === '1' || (abTastyData === null || abTastyData === void 0 ? void 0 : abTastyData['ab-test-activities-br']) === '1' || (abTastyData === null || abTastyData === void 0 ? void 0 : abTastyData['ab-test-activities-ca']) === '1' || (abTastyData === null || abTastyData === void 0 ? void 0 : abTastyData['ab-test-activities-jp']) === '1' || (abTastyData === null || abTastyData === void 0 ? void 0 : abTastyData['ab-test-activities-uk']) === '1';
      var isPartiallyPaid = attendeesPaymentStatus.some(function (s) {
        return s.hasPaid;
      });
      console.info('CM_AB: Activities step visibility:', {
        shouldHideActivitiesStepAbTest: shouldHideActivitiesStepAbTest,
        abTestValue: abTastyData === null || abTastyData === void 0 ? void 0 : abTastyData['ab-test-activities']
      });

      var availableSteps = Object(BookingEngine_utils["f" /* getFilteredBreadcrumbPages */])({
        selectedProposal: selectedProposal,
        resort: resort,
        i18n: i18n,
        isActivitiesViewFeatureFlipped: displayActivities,
        isOptionHoldOnlyFeatureFlipped: optionHoldOnly,
        isPartiallyPaid: isPartiallyPaid,
        shouldHideActivitiesStepAbTest: shouldHideActivitiesStepAbTest
      });

      var path = new URI_default.a(router.asPath).pathname();
      var stepIndex = availableSteps.findIndex(function (el) {
        return path === el.path;
      });
      var newStep = Math.max(0, stepIndex);
      var newUnlockedStep = !previousSelectedProposalId || previousSelectedProposalId === selectedProposal.id ? Math.max(unlockedStep, stepIndex) : Math.min(unlockedStep, availableSteps.findIndex(function (el) {
        return el.path.includes('participants');
      }));
      var stepChanged = this.state.step !== newStep;
      var unlockedStepChanged = this.state.unlockedStep !== newUnlockedStep;
      var previousSelectedProposalIdChanged = this.state.previousSelectedProposalId !== selectedProposal.id;

      if (!stepChanged && !unlockedStepChanged && !previousSelectedProposalIdChanged) {
        return;
      }

      this.setState({
        step: newStep,
        unlockedStep: newUnlockedStep,
        previousSelectedProposalId: selectedProposal.id
      });
    }
  }, {
    key: "shouldFetchData",
    value: function shouldFetchData() {
      var _this$props6 = this.props,
          proposals = _this$props6.proposals,
          resort = _this$props6.resort,
          i18n = _this$props6.i18n,
          router = _this$props6.router;
      var proposalIds = router.query.proposalIds || [];
      var validProposals = proposals.every(function (_ref6) {
        var id = _ref6.id;
        return proposalIds.indexOf(id) !== -1;
      });
      var validI18n = ['common', 'filters', 'sorters', 'travelAdvisor', 'booking', 'footer'].every(function (namespace) {
        return !isNil_default()(get_default()(i18n, namespace));
      });
      return isEmpty_default()(proposals) || !validProposals || !resort || !validI18n;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props7 = this.props,
          i18n = _this$props7.i18n,
          getBookingEngineI18n = _this$props7.getBookingEngineI18n,
          resort = _this$props7.resort,
          router = _this$props7.router,
          fetchProposalsById = _this$props7.fetchProposalsById,
          fetchRefreshProposal = _this$props7.fetchRefreshProposal,
          selectProposal = _this$props7.selectProposal,
          startLoading = _this$props7.startLoading,
          endLoading = _this$props7.endLoading;
      var isDataFetched = this.state.isDataFetched;

      try {
        Object(BookingEngine_utils["h" /* handleWrongUrl */])(router);
      } catch (_unused) {
        return;
      }

      Object(BookingEngine_tracking["a" /* resetTrackingStorageBE */])();
      this.handleNoData();
      var queryParams = router.query;
      var proposalIds = queryParams.proposalIds,
          selectedProposalId = queryParams.selectedProposalId,
          openSaveConfirmationModal = queryParams.openSaveConfirmationModal;

      if (isDataFetched && resort) {
        this.loadStreetViews({
          resort: resort,
          withLoader: true
        }); // Check if favori from shopping

        this.checkIfFavoriFromShopping();
      }

      if (!isDataFetched) {
        startLoading();
        Promise.all([fetchProposalsById({
          proposalsId: proposalIds,
          appContext: this.context,
          shouldRequestPayment: this.isOnLastPage()
        }), getBookingEngineI18n(this.context), this.loadBookingStatus(queryParams === null || queryParams === void 0 ? void 0 : queryParams.bookingId)]).then( /*#__PURE__*/function () {
          var _ref8 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee4(_ref7) {
            var _resp$proposals, _resp$proposals2;

            var _ref9, resp, attendeesPaymentStatus, originalLocale, locale, hasSameLocale, proposals, responseResort, refreshedProposal;

            return regenerator_default.a.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    _ref9 = Object(slicedToArray["a" /* default */])(_ref7, 3), resp = _ref9[0], attendeesPaymentStatus = _ref9[2];
                    originalLocale = _this2.props.selectedProposal.originalLocale;
                    locale = _this2.context.locale;
                    hasSameLocale = locale === originalLocale; // The log below aims to investigate the origin of blank page bug

                    proposals = resp === null || resp === void 0 ? void 0 : (_resp$proposals = resp.proposals) === null || _resp$proposals === void 0 ? void 0 : _resp$proposals.proposals;
                    responseResort = resp === null || resp === void 0 ? void 0 : (_resp$proposals2 = resp.proposals) === null || _resp$proposals2 === void 0 ? void 0 : _resp$proposals2.resort; // Check if favori from shopping

                    _this2.checkIfFavoriFromShopping();

                    if (!(isEmpty_default()(proposals) || !responseResort)) {
                      _context4.next = 10;
                      break;
                    }

                    logger["default"].error('API response with empty proposals');
                    throw new errors_errors["e" /* ProposalNotFound */]("No proposal found for this id: ".concat(proposalIds.toString()));

                  case 10:
                    if (!(Object(featureFlippingUtils["a" /* isFeatureFlipped */])(_this2.context)('booking.refreshProposals') && hasSameLocale)) {
                      _context4.next = 16;
                      break;
                    }

                    _context4.next = 13;
                    return fetchRefreshProposal(_this2.props.selectedProposal.id, undefined, _this2.context);

                  case 13:
                    _context4.t0 = _context4.sent;
                    _context4.next = 17;
                    break;

                  case 16:
                    _context4.t0 = undefined;

                  case 17:
                    refreshedProposal = _context4.t0;

                    _this2.setState({
                      attendeesPaymentStatus: attendeesPaymentStatus,
                      refreshedProposal: refreshedProposal ? refreshedProposal === null || refreshedProposal === void 0 ? void 0 : refreshedProposal.refreshProposal : undefined
                    });

                    if (openSaveConfirmationModal && i18n.booking) {
                      _this2.showSavedCriteriaPopIn();
                    }

                    _this2.loadStreetViews({
                      resort: responseResort,
                      withLoader: false
                    });

                  case 21:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4);
          }));

          return function (_x3) {
            return _ref8.apply(this, arguments);
          };
        }()).catch(function (err) {
          logger["default"].error(err);
          endLoading();

          _this2.setState({
            hasInternalServerError: true,
            isDataFetched: true
          });

          if (Object(contextUtils["f" /* isStrictlyProductionEnv */])()) {
            var locale = router.query.locale;
            return router.replace({
              pathname: '/500',
              query: Boolean(locale) && {
                locale: locale
              }
            });
          }
        });
        var updatedUri = new URI_default.a(router.asPath).setQuery(dist["appQueryParameters"].booking.selectedProposalId, selectedProposalId || (proposalIds === null || proposalIds === void 0 ? void 0 : proposalIds[0]));
        router.replace(updatedUri.toString());
        return selectProposal(selectedProposalId || proposalIds[0]);
      }

      this.updateStepsFromProps();
      js_cookie_default.a.remove(BookingEngine_utils["a" /* SVRL_PMNTS */]); // Skip ABTasty event listeners in test environment to avoid performance issues

      if (true) {
        // Listen to the custom event for ABTasty changes
        this.handleABTastyUpdate = this.handleABTastyUpdate.bind(this);
        document.addEventListener('abTastyDataUpdated', this.handleABTastyUpdate); // Expose the force update method for tests (development only)

        if (false) {}
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _prevProps$selectedPr, _this$props$selectedP12, _prevProps$selectedPr2, _prevProps$selectedPr3, _this$props$selectedP13, _this$props$selectedP14, _prevProps$selectedPr4, _prevProps$selectedPr5, _prevProps$selectedPr6, _this$props$selectedP19, _this$props$selectedP20, _this$props$selectedP21, _prevProps$abTastyDat, _this$props$abTastyDa, _prevProps$selectedPr7, _this$props$selectedP22;

      var _this$props8 = this.props,
          endLoading = _this$props8.endLoading,
          i18n = _this$props8.i18n,
          resort = _this$props8.resort,
          router = _this$props8.router,
          selectedProposal = _this$props8.selectedProposal,
          streetViews = _this$props8.streetViews;
      var openSaveConfirmationModal = router.query.openSaveConfirmationModal;
      this.handleNoData();

      if (this.state.isDataFetched && isEmpty_default()(streetViews)) {
        this.loadStreetViews({
          resort: resort,
          withLoader: true
        });
      }

      if (!prevState.isDataFetched && this.state.isDataFetched) {
        endLoading();
      }

      if (this.state.isDataFetched && openSaveConfirmationModal && i18n.booking) {
        this.showSavedCriteriaPopIn();
        router.replace(new URI_default.a(router.asPath).removeQuery(['openSaveConfirmationModal']).toString());
      }

      if (!this.state.isDataFetched && !this.shouldFetchData()) {
        this.setState({
          isDataFetched: true
        });
      }

      if (typeof router.query.editCriteriaWarning !== 'undefined') {
        this.setState({
          unlockedStep: 0
        }, function () {
          var url = new URI_default.a(router.asPath);

          if (!url.toString().includes('accommodation')) {
            var newUrl = url.removeSearch('editCriteriaWarning');
            router.replace(newUrl.toString());
          }
        });
      } else if (selectedProposal && resort && i18n.booking) {
        // Once the user reached a step, they can always come back to it
        var currentStepIndex = this.getCurrentStepIndex();

        if (currentStepIndex > this.state.unlockedStep) {
          this.setState({
            unlockedStep: currentStepIndex
          });
        }
      }

      if (((_prevProps$selectedPr = prevProps.selectedProposal) === null || _prevProps$selectedPr === void 0 ? void 0 : _prevProps$selectedPr.persistenceExtended) !== ((_this$props$selectedP12 = this.props.selectedProposal) === null || _this$props$selectedP12 === void 0 ? void 0 : _this$props$selectedP12.persistenceExtended)) {
        this.setState({
          persistenceExtended: this.props.selectedProposal.persistenceExtended
        });
      }

      if (((_prevProps$selectedPr2 = prevProps.selectedProposal) === null || _prevProps$selectedPr2 === void 0 ? void 0 : (_prevProps$selectedPr3 = _prevProps$selectedPr2.households) === null || _prevProps$selectedPr3 === void 0 ? void 0 : _prevProps$selectedPr3.length) !== ((_this$props$selectedP13 = this.props.selectedProposal) === null || _this$props$selectedP13 === void 0 ? void 0 : (_this$props$selectedP14 = _this$props$selectedP13.households) === null || _this$props$selectedP14 === void 0 ? void 0 : _this$props$selectedP14.length)) {
        var _this$props$selectedP15, _this$props$selectedP16, _this$props$selectedP17, _this$props$selectedP18;

        var optionHoldOnly = (Object(featureFlippingUtils["a" /* isFeatureFlipped */])(this.context)('booking.optionHoldOnly') || ((_this$props$selectedP15 = this.props.selectedProposal) === null || _this$props$selectedP15 === void 0 ? void 0 : (_this$props$selectedP16 = _this$props$selectedP15.households) === null || _this$props$selectedP16 === void 0 ? void 0 : _this$props$selectedP16.length) > 1 && Object(featureFlippingUtils["a" /* isFeatureFlipped */])(this.context)('booking.multiHouseholdOptionOnly')) && ((_this$props$selectedP17 = this.props.selectedProposal) === null || _this$props$selectedP17 === void 0 ? void 0 : (_this$props$selectedP18 = _this$props$selectedP17.price) === null || _this$props$selectedP18 === void 0 ? void 0 : _this$props$selectedP18.currency) !== 'MXN';

        if (optionHoldOnly !== this.state.optionHoldOnly) {
          this.setState({
            optionHoldOnly: optionHoldOnly
          });
        }
      }

      if (((_prevProps$selectedPr4 = prevProps.selectedProposal) === null || _prevProps$selectedPr4 === void 0 ? void 0 : (_prevProps$selectedPr5 = _prevProps$selectedPr4.price) === null || _prevProps$selectedPr5 === void 0 ? void 0 : (_prevProps$selectedPr6 = _prevProps$selectedPr5.total) === null || _prevProps$selectedPr6 === void 0 ? void 0 : _prevProps$selectedPr6.value) !== ((_this$props$selectedP19 = this.props.selectedProposal) === null || _this$props$selectedP19 === void 0 ? void 0 : (_this$props$selectedP20 = _this$props$selectedP19.price) === null || _this$props$selectedP20 === void 0 ? void 0 : (_this$props$selectedP21 = _this$props$selectedP20.total) === null || _this$props$selectedP21 === void 0 ? void 0 : _this$props$selectedP21.value)) {
        this.setState({
          isProposalFavorite: false,
          isNextStep: false
        });
      } // improvement of the detection of ABTasty changes


      var abChanged = ((_prevProps$abTastyDat = prevProps.abTastyData) === null || _prevProps$abTastyDat === void 0 ? void 0 : _prevProps$abTastyDat['ab-test-activities']) !== ((_this$props$abTastyDa = this.props.abTastyData) === null || _this$props$abTastyDa === void 0 ? void 0 : _this$props$abTastyDa['ab-test-activities']);
      var proposalChanged = ((_prevProps$selectedPr7 = prevProps.selectedProposal) === null || _prevProps$selectedPr7 === void 0 ? void 0 : _prevProps$selectedPr7.id) !== ((_this$props$selectedP22 = this.props.selectedProposal) === null || _this$props$selectedP22 === void 0 ? void 0 : _this$props$selectedP22.id);
      var flagsChanged = prevState.displayActivities !== this.state.displayActivities || prevState.optionHoldOnly !== this.state.optionHoldOnly; // Forcer la mise à jour si ABTasty data change

      if (abChanged || proposalChanged || flagsChanged) {
        this.updateStepsFromProps();
      }
    }
  }, {
    key: "changeURI",
    value: function changeURI(pageName, proposalId, queryParams) {
      var _this$props9 = this.props,
          closeToast = _this$props9.closeToast,
          router = _this$props9.router,
          selectedProposal = _this$props9.selectedProposal;
      closeToast();
      var newUrl = new URI_default.a(router.asPath).filename(pageName).removeQuery(SHOW_LAYER_QUERY_NAME).removeQuery('catId');
      Object.keys(queryParams).forEach(function (key) {
        newUrl.setQuery(key, queryParams[key]);
      }); // Only when the user submits and closes a layer

      if (proposalId) {
        newUrl.setQuery('proposalIds', Object(BookingEngine_utils["b" /* getAllProposalsIdWithAlternative */])(selectedProposal));
      }

      return router.push(newUrl.toString());
    } // TODO: cleanup !!
    // eslint-disable-next-line react/no-unused-class-component-methods

  }, {
    key: "getPageName",
    value: function getPageName() {
      var step = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getCurrentStepIndex();
      var currentPageData = this.getFilteredBreadcrumbPages()[step] || {};
      return currentPageData.name;
    }
  }, {
    key: "getFilteredBreadcrumbPages",
    value: function getFilteredBreadcrumbPages() {
      var _this$state3, _this$props$abTastyDa2, _this$props$abTastyDa3, _this$props$abTastyDa4, _this$props$abTastyDa5, _this$props$abTastyDa6;

      var _this$props10 = this.props,
          selectedProposal = _this$props10.selectedProposal,
          resort = _this$props10.resort,
          i18n = _this$props10.i18n;
      var _this$state2 = this.state,
          displayActivities = _this$state2.displayActivities,
          optionHoldOnly = _this$state2.optionHoldOnly;
      var attendeesPaymentStatus = ((_this$state3 = this.state) === null || _this$state3 === void 0 ? void 0 : _this$state3.attendeesPaymentStatus) || [];
      var isPartiallyPaid = attendeesPaymentStatus.some(function (status) {
        return status.hasPaid;
      });
      var shouldHideActivitiesStepAbTest = ((_this$props$abTastyDa2 = this.props.abTastyData) === null || _this$props$abTastyDa2 === void 0 ? void 0 : _this$props$abTastyDa2['ab-test-activities']) === '1' || ((_this$props$abTastyDa3 = this.props.abTastyData) === null || _this$props$abTastyDa3 === void 0 ? void 0 : _this$props$abTastyDa3['ab-test-activities-br']) === '1' || ((_this$props$abTastyDa4 = this.props.abTastyData) === null || _this$props$abTastyDa4 === void 0 ? void 0 : _this$props$abTastyDa4['ab-test-activities-ca']) === '1' || ((_this$props$abTastyDa5 = this.props.abTastyData) === null || _this$props$abTastyDa5 === void 0 ? void 0 : _this$props$abTastyDa5['ab-test-activities-jp']) === '1' || ((_this$props$abTastyDa6 = this.props.abTastyData) === null || _this$props$abTastyDa6 === void 0 ? void 0 : _this$props$abTastyDa6['ab-test-activities-uk']) === '1';
      return Object(BookingEngine_utils["f" /* getFilteredBreadcrumbPages */])({
        selectedProposal: selectedProposal,
        resort: resort,
        i18n: i18n,
        isActivitiesViewFeatureFlipped: displayActivities,
        isOptionHoldOnlyFeatureFlipped: optionHoldOnly,
        isPartiallyPaid: isPartiallyPaid,
        shouldHideActivitiesStepAbTest: shouldHideActivitiesStepAbTest
      });
    }
  }, {
    key: "isOnLastPage",
    value: function isOnLastPage() {
      return this.props.router.query.bookingStep === 'banking';
    }
  }, {
    key: "getActions",
    value: function getActions() {
      var _this3 = this;

      var _this$state4 = this.state,
          isProposalFavorite = _this$state4.isProposalFavorite,
          step = _this$state4.step,
          persistenceExtended = _this$state4.persistenceExtended;
      var isTablet = this.props.responsive.isTablet;
      var pages = this.getFilteredBreadcrumbPages();

      var isDisplaySaveFlipped = get_default()(this.props, 'i18n.booking.saveMyCriteria.display');

      var isDisplayShareFlippedMobile = get_default()(this.props, 'i18n.booking.common.share.displayMobile');

      var isDisplayShareFlippedDesktop = get_default()(this.props, 'i18n.booking.common.share.displayDesktop');

      var shouldDisplaySave = isDisplaySaveFlipped && pages[step].name !== booking_constants["p" /* PAGES */].BANKING;
      var shouldDisplayShare = (isTablet && isDisplayShareFlippedDesktop || !isTablet && isDisplayShareFlippedMobile) && pages[step].name !== booking_constants["p" /* PAGES */].BANKING;
      return [{
        id: persistenceExtended ? booking_constants["h" /* BE_UNSAVE_ACTION */] : booking_constants["d" /* BE_SAVE_ACTION */],
        iconName: persistenceExtended || isProposalFavorite ? icons["a" /* ICONS */].STAR_FILLED : icons["a" /* ICONS */].STAR_HOLLOW,
        label: get_default()(this.props, 'i18n.booking.common.save'),
        onClick: function onClick() {
          return _this3.onClickFavorite('header');
        },
        display: shouldDisplaySave
      }, {
        id: booking_constants["g" /* BE_SHARE_ACTION */],
        iconName: icons["a" /* ICONS */].SHARE,
        label: get_default()(this.props, 'i18n.booking.common.share.label'),
        display: shouldDisplayShare,
        onClick: this.toggleShareContextModal
      }];
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Cleanup event listeners
      if (this.handleABTastyUpdate) {
        document.removeEventListener('abTastyDataUpdated', this.handleABTastyUpdate);
      } // Cleanup the exposed function (development only)


      if (false) {}
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$i18n,
          _this$props$i18n$book,
          _this$props$i18n$book2,
          _this4 = this,
          _this$props$i18n2,
          _this$props$i18n2$boo,
          _this$props$i18n2$boo2;

      var _this$state5 = this.state,
          shouldShowSaveCriteriaConfirmation = _this$state5.shouldShowSaveCriteriaConfirmation,
          shouldShowSaveCriteriaLogin = _this$state5.shouldShowSaveCriteriaLogin,
          shouldShowShareContext = _this$state5.shouldShowShareContext,
          displayRefreshProposalError = _this$state5.displayRefreshProposalError,
          hasInternalServerError = _this$state5.hasInternalServerError,
          isDataFetched = _this$state5.isDataFetched;
      var _this$props11 = this.props,
          proposals = _this$props11.proposals,
          selectedProposal = _this$props11.selectedProposal,
          resort = _this$props11.resort,
          i18n = _this$props11.i18n,
          closeToast = _this$props11.closeToast,
          displayToastOnContextShare = _this$props11.displayToastOnContextShare,
          _this$props11$router$ = _this$props11.router.query,
          currentStep = _this$props11$router$.bookingStep,
          editCriteriaWarning = _this$props11$router$.editCriteriaWarning,
          newAccount = _this$props11$router$.newAccount,
          isAppMounted = _this$props11.responsive.isAppMounted,
          streetViews = _this$props11.streetViews;

      if (hasInternalServerError) {
        return null;
      }

      if (i18n.booking && displayRefreshProposalError) {
        return BookingEngine_jsx(SiteContainer["a" /* SiteContainer */], {
          isWide: true
        }, BookingEngine_jsx("div", {
          className: "min-h-screen bg-white"
        }, BookingEngine_jsx(SiteContainer["a" /* SiteContainer */], null, BookingEngine_jsx(QuickSearchUnavailability["a" /* QuickSearchUnavailability */], {
          title: i18n.booking.warnings.refreshFailedTitle,
          description: i18n.booking.warnings.refreshFailedDescription
        }))));
      } // i18n is initialized to an empty object, so we checked its properties to see if it's loaded


      if (!isDataFetched || !i18n.booking || !isAppMounted || isDataFetched && isEmpty_default()(proposals)) {
        return BookingEngine_jsx(AsyncLoader["a" /* AsyncLoader */], {
          className: "min-h-screen"
        });
      } // currentPage always should be an object since we destructure it on the next line


      var currentPage = this.getCurrentPage() || {};
      var name = currentPage.name,
          actionGA = currentPage.actionGA,
          seoTitle = currentPage.seoTitle,
          gridSize = currentPage.gridSize;
      var isTransportView = name === booking_constants["p" /* PAGES */].TRANSPORT;

      var isTransferView = isTransportView && isEmpty_default()(selectedProposal.transports);

      var isSkipTestVisible = isTransferView || name === booking_constants["p" /* PAGES */].SERVICES || name === booking_constants["p" /* PAGES */].ACTIVITIES;

      var alertMessageNewProposal = get_default()(i18n, 'booking.editCriteria.alertMessageNewProposal');

      var activeStep = this.getCurrentStepIndex();

      var selectedProposalPrice = get_default()(this.props.selectedProposal, 'price');

      return BookingEngine_jsx(BookingEngineContext["a" /* BookingEngineContext */].Provider, {
        // TODO: cleanup !!
        // eslint-disable-next-line react/jsx-no-constructed-context-values
        value: {
          currentStep: currentPage
        }
      }, BookingEngine_jsx(BookingAccessibleTitle_BookingAccessibleTitle, {
        title: seoTitle
      }), BookingEngine_jsx("div", {
        className: "relative"
      }, BookingEngine_jsx(HeaderLite["a" /* HeaderLite */], {
        actions: this.getActions(),
        product: resort,
        proposal: selectedProposal
      }), BookingEngine_jsx("main", {
        role: "main"
      }, BookingEngine_jsx(BookingBreadcrumb["a" /* BookingBreadcrumb */], {
        resort: resort,
        selectedProposal: selectedProposal,
        activeStep: activeStep > 0 ? activeStep : 0,
        actionGA: actionGA,
        backgroundImageSrc: resort.image,
        items: this.getFilteredBreadcrumbPages().map(function (item) {
          return {
            iconName: item.icon,
            id: item.actionGA,
            label: item.title
          };
        }),
        label: (_this$props$i18n = this.props.i18n) === null || _this$props$i18n === void 0 ? void 0 : (_this$props$i18n$book = _this$props$i18n.booking) === null || _this$props$i18n$book === void 0 ? void 0 : (_this$props$i18n$book2 = _this$props$i18n$book.header) === null || _this$props$i18n$book2 === void 0 ? void 0 : _this$props$i18n$book2.bookingSteps,
        lastActiveStep: this.state.unlockedStep,
        onClickStep: this.updateStep,
        i18n: i18n
      }), BookingEngine_jsx("div", {
        className: Object(classnames_utils["a" /* classnames */])('min-h-[60vh]', isTransportView ? 'py-10' : 'py-20')
      }, BookingEngine_jsx(SiteContainer["a" /* SiteContainer */], {
        size: gridSize ? // $FlowFixMe
        gridSize : 'small'
      }, BookingEngine_jsx("div", {
        className: "relative flex justify-between"
      }, editCriteriaWarning && name === booking_constants["p" /* PAGES */].ACCOMMODATION && alertMessageNewProposal && BookingEngine_jsx("div", {
        className: "mb-20 flex items-start justify-center gap-10 text-orange",
        "data-testid": "BookingEngine-accommodationEditWarning"
      }, BookingEngine_jsx(Icon["a" /* Icon */], {
        className: "shrink-0",
        name: icons["a" /* ICONS */].WARNING,
        width: "1.5rem"
      }), alertMessageNewProposal), isSkipTestVisible && BookingEngine_jsx("button", {
        className: "ms-auto flex items-center justify-center font-bold text-black",
        "data-selector": "skip-step",
        onClick: function onClick() {
          _this4.props.trackClickSkipStep();

          _this4.goToNextStep(undefined)();
        },
        type: "button",
        "data-testid": "skip"
      }, (_this$props$i18n2 = this.props.i18n) === null || _this$props$i18n2 === void 0 ? void 0 : (_this$props$i18n2$boo = _this$props$i18n2.booking) === null || _this$props$i18n2$boo === void 0 ? void 0 : (_this$props$i18n2$boo2 = _this$props$i18n2$boo.common) === null || _this$props$i18n2$boo2 === void 0 ? void 0 : _this$props$i18n2$boo2.skipThisStepLabel, BookingEngine_jsx(Icon["a" /* Icon */], {
        hasRtl: true,
        name: icons["a" /* ICONS */].ARROW_RIGHT,
        width: "1rem"
      }))), BookingEngine_jsx(BookingLayout["a" /* BookingLayout */], {
        selectedProposal: selectedProposal,
        price: selectedProposalPrice,
        goToNextStep: this.goToNextStep,
        i18n: i18n,
        proposals: proposals,
        resort: resort,
        isOptionHoldOnly: this.state.optionHoldOnly,
        previousAction: this.goToPreviousStep,
        isOnLastPage: this.isOnLastPage(),
        isFavorite: this.state.isProposalFavorite,
        shouldOpenPanel: this.state.shouldOpenPanel,
        onClickFavorite: function onClickFavorite() {
          return _this4.onClickFavorite('bottomBar');
        },
        isNextStep: this.state.isNextStep,
        currentPage: currentPage.name // $FlowFixMe
        ,
        closePanel: function closePanel() {
          _this4.setState({
            shouldOpenPanel: false
          });
        }
      }, BookingEngine_jsx(BookingStep_BookingStep, {
        actionGA: actionGA,
        attendeesPaymentStatus: this.state.attendeesPaymentStatus,
        closeLayer: this.closeLayer,
        currentStep: currentStep,
        goToNextStep: this.goToNextStep(),
        i18n: i18n,
        isFavorite: this.state.isProposalFavorite,
        isOptionHoldOnly: this.state.optionHoldOnly,
        openLayer: this.openLayer,
        proposals: proposals,
        resort: resort,
        selectedProposal: selectedProposal,
        streetViews: streetViews
      })), shouldShowSaveCriteriaConfirmation ? BookingEngine_jsx(SaveCriteriaConfirmation_SaveCriteriaConfirmation, {
        persistenceExtended: this.state.persistenceExtended,
        closeModal: this.hideSaveCriteriaConfirmationModal,
        newAccount: newAccount,
        i18n: i18n
      }) : null, shouldShowSaveCriteriaLogin ? BookingEngine_jsx(SaveCriteriaLogin, {
        closeModal: this.hideSaveCriteriaLoginModal,
        clickOrigin: this.state.clickOrigin,
        i18n: i18n
      }) : null, shouldShowShareContext ? BookingEngine_jsx(share_context_ShareContext, {
        actionGA: actionGA,
        closeToast: closeToast,
        dataSelector: "ShareContext",
        displayToastOnContextShare: displayToastOnContextShare,
        i18n: i18n,
        onToggleModal: this.toggleShareContextModal
      }) : null, !!this.state.refreshedProposal && BookingEngine_jsx(RefreshProposalModal, {
        resort: this.props.resort,
        refreshedProposal: this.state.refreshedProposal,
        selectedProposal: this.props.selectedProposal
      }))))), currentStep === BOOKING_STEPS.PARTICIPANTS.BE_RESPONSIVE && BookingEngine_jsx("div", {
        className: "relative m-auto max-w-site-medium border-t-1 border-grey px-20 py-60"
      }, BookingEngine_jsx(ParticipantsReassurance_ParticipantsReassurance, {
        i18n: i18n,
        proposal: selectedProposal,
        resort: resort
      })), BookingEngine_jsx(react_default.a.Fragment, null, BookingEngine_jsx(BookingFooter["a" /* BookingFooter */], {
        footer: i18n.footer,
        className: "mt-100"
      }), BookingEngine_jsx("div", {
        className: "h-[128px]"
      })), BookingEngine_jsx(TravelPlans_TravelPlansComponent, {
        savedProposal: this.state.savedProposal,
        selectedProposal: this.props.selectedProposal,
        resort: this.props.resort,
        setFavorite: this.setFavorite
      }), BookingEngine_jsx(BlockMismatchProposalCountry_BlockMismatchProposalCountry, {
        selectedProposal: selectedProposal,
        resort: resort
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var _props$abTastyData, _props$abTastyData2, _props$abTastyData3, _props$abTastyData4, _props$abTastyData5;

      if (isEmpty_default()(props.proposals) || !props.resort || !props.i18n.booking || !props.selectedProposal) {
        return null;
      }

      var path = new URI_default.a(props.router.asPath).pathname();
      /**
       * For indirect seller, the redirection to option page happens before BookingEngine unmount
       * BookingEngine calculates a wrong state from option url and add transport path to the option url
       * To avoid this behavior we stop calculating state from the option location
       */

      var shouldHideActivitiesStepAbTest = ((_props$abTastyData = props.abTastyData) === null || _props$abTastyData === void 0 ? void 0 : _props$abTastyData['ab-test-activities']) === '1' || ((_props$abTastyData2 = props.abTastyData) === null || _props$abTastyData2 === void 0 ? void 0 : _props$abTastyData2['ab-test-activities-br']) === '1' || ((_props$abTastyData3 = props.abTastyData) === null || _props$abTastyData3 === void 0 ? void 0 : _props$abTastyData3['ab-test-activities-ca']) === '1' || ((_props$abTastyData4 = props.abTastyData) === null || _props$abTastyData4 === void 0 ? void 0 : _props$abTastyData4['ab-test-activities-jp']) === '1' || ((_props$abTastyData5 = props.abTastyData) === null || _props$abTastyData5 === void 0 ? void 0 : _props$abTastyData5['ab-test-activities-uk']) === '1';
      var isPartiallyPaid = state.attendeesPaymentStatus.some(function (status) {
        return status.hasPaid;
      });

      var availableSteps = Object(BookingEngine_utils["f" /* getFilteredBreadcrumbPages */])({
        selectedProposal: props.selectedProposal,
        resort: props.resort,
        i18n: props.i18n,
        isActivitiesViewFeatureFlipped: state.displayActivities,
        isOptionHoldOnlyFeatureFlipped: state.optionHoldOnly,
        isPartiallyPaid: isPartiallyPaid,
        shouldHideActivitiesStepAbTest: shouldHideActivitiesStepAbTest
      });

      var step = availableSteps.findIndex(function (el) {
        return path === el.path;
      });
      var newStep = Math.max(0, step); // if the user is went further than the contact info page and come back to change the proposal (change the package or the comfort)
      // we disabled any further step to prevent some booking bug #11871

      var newUnlockedStep = !state.previousSelectedProposalId || state.previousSelectedProposalId === props.selectedProposal.id ? Math.max(state.unlockedStep, step) : Math.min(state.unlockedStep, availableSteps.findIndex(function (el) {
        return el.path.includes('participants');
      }));
      return {
        unlockedStep: newUnlockedStep,
        step: newStep,
        previousSelectedProposalId: props.selectedProposal.id
      };
    }
  }]);

  return BookingEngineComponent;
}(react_default.a.PureComponent);

Object(defineProperty["a" /* default */])(BookingEngine_BookingEngineComponent, "contextType", ReactAppContext["a" /* B2CAppContext */]);

var BookingEngine_BookingEngine = function BookingEngine(props) {
  var _ref10;

  var selectedProposal = props.selectedProposal,
      resort = props.resort,
      _props$router$query = props.router.query,
      step = _props$router$query.bookingStep,
      proposalIds = _props$router$query.proposalIds;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackEvent = _useTrackEvent.trackEvent,
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var shouldTrack = !!selectedProposal && !!resort; // in the case of a single proposal it comes as an item Otherwise as an Array ...

  var sortedProposalIds = (_ref10 = (Array.isArray(proposalIds) ? proposalIds : [proposalIds]) || []) === null || _ref10 === void 0 ? void 0 : _ref10. // $FlowFixMe : nevers happens with booleans
  sort(function (a, b) {
    return a < b;
  });
  var beginCheckoutCookie = sortedProposalIds.join('_') + '_co';
  Object(react["useEffect"])(function () {
    var _selectedProposal$pri, _selectedProposal$pri2, _selectedProposal$pri3;

    var hasAlreadyTracked = js_cookie_default.a.get(beginCheckoutCookie);

    if (hasAlreadyTracked || !selectedProposal || !resort) {
      return;
    }

    trackEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].BEGIN_CHECKOUT, {
      ecommerce: {
        items: [{
          item_id: resort.id,
          item_name: resort.name,
          price: selectedProposal.price.total.value
        }]
      }
    });
    trackEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].ADD_TO_CART, {
      ecommerce: {
        value: (_selectedProposal$pri = selectedProposal.price) === null || _selectedProposal$pri === void 0 ? void 0 : (_selectedProposal$pri2 = _selectedProposal$pri.total) === null || _selectedProposal$pri2 === void 0 ? void 0 : _selectedProposal$pri2.value,
        currency: (_selectedProposal$pri3 = selectedProposal.price) === null || _selectedProposal$pri3 === void 0 ? void 0 : _selectedProposal$pri3.currency,
        items: [{
          item_id: resort.id,
          item_name: resort.name,
          item_category: resort.destination.country,
          item_category2: resort.comfort,
          price: selectedProposal.price.total.value,
          quantity: 1
        }]
      }
    });
    js_cookie_default.a.set(beginCheckoutCookie, 'true', {
      expires: 1
    });
  }, [sortedProposalIds, resort, selectedProposal]);
  var trackAddToWishlist = Object(react["useCallback"])(function () {
    var _selectedProposal$acc, _selectedProposal$pri4, _selectedProposal$pri5, _selectedProposal$pri6, _selectedProposal$pri7, _selectedProposal$pri8;

    trackEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].ADD_TO_WISHLIST, {
      ecommerce: {
        items: [{
          item_id: selectedProposal.id,
          item_name: resort === null || resort === void 0 ? void 0 : resort.name,
          item_category: (_selectedProposal$acc = selectedProposal.accommodations) === null || _selectedProposal$acc === void 0 ? void 0 : _selectedProposal$acc.map(function (accommodation) {
            return accommodation.roomType;
          })[0],
          price: (_selectedProposal$pri4 = selectedProposal.price) === null || _selectedProposal$pri4 === void 0 ? void 0 : _selectedProposal$pri4.total.value,
          item_category2: moment_default()(selectedProposal.departureDate).format('L'),
          item_category3: selectedProposal.duration,
          item_category4: Object(TripDatePicker_utils["c" /* dateDiff */])(selectedProposal.departureDate, new Date()),
          item_category5: Boolean(selectedProposal.transports),
          coupon: (_selectedProposal$pri5 = selectedProposal.price) === null || _selectedProposal$pri5 === void 0 ? void 0 : (_selectedProposal$pri6 = _selectedProposal$pri5.promoCode) === null || _selectedProposal$pri6 === void 0 ? void 0 : _selectedProposal$pri6.offerId,
          discount: (_selectedProposal$pri7 = selectedProposal.price) === null || _selectedProposal$pri7 === void 0 ? void 0 : (_selectedProposal$pri8 = _selectedProposal$pri7.discounts) === null || _selectedProposal$pri8 === void 0 ? void 0 : _selectedProposal$pri8.reduce(function (acc, currentValue) {
            return acc + currentValue.amount.value;
          }, 0)
        }]
      }
    });
  }, [selectedProposal, resort]);
  var trackClickFavorite = Object(react["useCallback"])(function (origin, detailClick) {
    trackClickEvent(origin === 'bottomBar' ? tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_BOTTOM_BAR : tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_HEADER, {
      detail_click: detailClick
    });
  }, []);
  var trackClickShare = Object(react["useCallback"])(function () {
    trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_HEADER, {
      detail_click: 'share'
    });
  }, []);
  var trackClickPreviousStep = Object(react["useCallback"])(function () {
    trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_BOTTOM_BAR, {
      detail_click: 'back_step'
    });
  }, []);
  var trackClickSkipStep = Object(react["useCallback"])(function () {
    trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_BREADCRUMB, {
      detail_click: 'skip_step'
    });
  }, []);
  var trackingContext = Object(react["useMemo"])(function () {
    var _selectedProposal$pri9, _resort$type, _selectedProposal$acc2, _selectedProposal$acc3, _selectedProposal$acc4, _ref11;

    if (!shouldTrack) {
      return undefined;
    }

    var arrivalDate = moment_default()(selectedProposal.arrivalDate);
    var daysBeforeDeparture = arrivalDate.diff(moment_default()(), 'days');

    var transportDeparture = get_default()(selectedProposal.transports, 'inbound.travelSections[0].departure', {});

    var isEclusiveCollectionAccommodation = get_default()(selectedProposal, 'accommodations[0].exclusiveCollection');

    return _ref11 = {}, Object(defineProperty["a" /* default */])(_ref11, "base_price_".concat(step), (_selectedProposal$pri9 = selectedProposal.price) === null || _selectedProposal$pri9 === void 0 ? void 0 : _selectedProposal$pri9.total.value), Object(defineProperty["a" /* default */])(_ref11, "reference_id", selectedProposal.id), Object(defineProperty["a" /* default */])(_ref11, "days_before_departure", daysBeforeDeparture), Object(defineProperty["a" /* default */])(_ref11, "departure_date_range", Object(BookingEngine_utils["c" /* getDepartureDateRange */])(daysBeforeDeparture)), Object(defineProperty["a" /* default */])(_ref11, "departure_quarter", arrivalDate.quarter()), Object(defineProperty["a" /* default */])(_ref11, "departure_semester", arrivalDate.quarter() > 2 ? 2 : 1), Object(defineProperty["a" /* default */])(_ref11, "resort_name", resort.name), Object(defineProperty["a" /* default */])(_ref11, "resort_code", resort.id), Object(defineProperty["a" /* default */])(_ref11, "resort_country", resort.destination.country), Object(defineProperty["a" /* default */])(_ref11, "resort_season_type", resort === null || resort === void 0 ? void 0 : resort.seasonName), Object(defineProperty["a" /* default */])(_ref11, "resort_region", resort.destination.area), Object(defineProperty["a" /* default */])(_ref11, "resort_exclusive_collection", Object(BookingEngine_utils["d" /* getExclusiveCollectionFromAccomodation */])(resort.hasECSpace, isEclusiveCollectionAccommodation)), Object(defineProperty["a" /* default */])(_ref11, "resort_type", (resort === null || resort === void 0 ? void 0 : (_resort$type = resort.type) === null || _resort$type === void 0 ? void 0 : _resort$type.toLowerCase()) || 'no'), Object(defineProperty["a" /* default */])(_ref11, "resort_adult", selectedProposal.attendees.adults.length), Object(defineProperty["a" /* default */])(_ref11, "resort_children", selectedProposal.attendees.children.length), Object(defineProperty["a" /* default */])(_ref11, "resort_departure_city_name", transportDeparture.label || 'no_transport'), Object(defineProperty["a" /* default */])(_ref11, "resort_departure_date", moment_default()(selectedProposal.arrivalDate).format('DD/MM/YYYY')), Object(defineProperty["a" /* default */])(_ref11, "resort_checkout_date", (selectedProposal === null || selectedProposal === void 0 ? void 0 : selectedProposal.departureDate) ? moment_default()(selectedProposal === null || selectedProposal === void 0 ? void 0 : selectedProposal.departureDate).format('DD/MM/YYYY') : moment_default()(selectedProposal === null || selectedProposal === void 0 ? void 0 : selectedProposal.arrivalDate).add(selectedProposal === null || selectedProposal === void 0 ? void 0 : selectedProposal.duration, 'days').format('DD/MM/YYYY')), Object(defineProperty["a" /* default */])(_ref11, "resort_night_number", selectedProposal.duration), Object(defineProperty["a" /* default */])(_ref11, "resort_participants", selectedProposal.attendees.list.length), Object(defineProperty["a" /* default */])(_ref11, "resort_transport", selectedProposal.transports ? 'with_transport' : 'without_transport'), Object(defineProperty["a" /* default */])(_ref11, "resort_year_season", moment_default()(selectedProposal.departureDate || null, 'YYYYMMDD').format('YYYY')), Object(defineProperty["a" /* default */])(_ref11, "room_type", (_selectedProposal$acc2 = selectedProposal.accommodations[0].comfortId) === null || _selectedProposal$acc2 === void 0 ? void 0 : (_selectedProposal$acc3 = _selectedProposal$acc2.split('_')) === null || _selectedProposal$acc3 === void 0 ? void 0 : (_selectedProposal$acc4 = _selectedProposal$acc3.reverse()) === null || _selectedProposal$acc4 === void 0 ? void 0 : _selectedProposal$acc4[0]), _ref11;
  }, [selectedProposal, resort, shouldTrack, step]);
  return BookingEngine_jsx(BookingEngineTrackingContext["a" /* BookingEngineTrackingContext */].Provider, {
    value: trackingContext
  }, BookingEngine_jsx(BookingEngine_BookingEngineComponent, Object(esm_extends["a" /* default */])({}, props, {
    trackClickFavorite: trackClickFavorite,
    trackClickPreviousStep: trackClickPreviousStep,
    trackAddToWishlist: trackAddToWishlist,
    trackClickShare: trackClickShare,
    trackClickSkipStep: trackClickSkipStep,
    abTastyData: props.abTastyData
  })), shouldTrack && BookingEngine_jsx(TrackPage["a" /* TrackPage */], {
    pageName: tracking_constants["H" /* TRACK_PAGE_NAMES */]["BE_".concat(step.toUpperCase())],
    payload: BookingEngine_objectSpread({}, trackingContext)
  }));
};



var BookingEngine_BookingEngineWithAbTastyData = function BookingEngineWithAbTastyData(props) {
  var _useContext = Object(react["useContext"])(ABTestContext["a" /* ABTestContext */]),
      abTastyData = _useContext.abTastyData;

  return BookingEngine_jsx(BookingEngine_BookingEngine, Object(esm_extends["a" /* default */])({}, props, {
    abTastyData: abTastyData
  }));
};

/* harmony default export */ var booking_BookingEngine = (Object(Responsive["a" /* default */])(Object(next_router["withRouter"])(BookingEngine_BookingEngineWithAbTastyData)));
// CONCATENATED MODULE: ./src/client/views/booking/BookingEngine.container.js
















var BookingEngine_container_mapStateToProps = function mapStateToProps(state) {
  // if there is neolids we have identified attendees so we map the proposals with the attendees datas
  var proposals = Object(booking_selector["t" /* getProposals */])(state) || [];
  var resort = Object(booking_selector["j" /* getCurrentResort */])(state);
  var streetViews = Object(booking_selector["w" /* getStreetViews */])(state);
  return {
    i18n: state.cms,
    leadScore: Object(leadInfo_selector["a" /* getLeadScore */])(state),
    proposals: proposals,
    resort: resort,
    selectedProposal: find_default()(proposals, {
      id: Object(booking_selector["v" /* getSelectedProposalId */])(state)
    }) || Object(proposalUtils["d" /* getDefaultProposal */])(proposals, resort),
    streetViews: streetViews,
    tripInformation: state.tripInformation,
    userInfo: state.userInfo
  };
};
var mapDispatchToProps = {
  fetchProposalsById: proposals_action["l" /* fetchProposalsById */],
  fetchStreetViewsByAccommodationCategoryId: fetchStreetViewsByAccommodationCategoryId,
  selectProposal: selectedProposalId_action["d" /* selectProposal */],
  endLoading: globalLoader_action["c" /* endLoading */],
  startLoading: globalLoader_action["d" /* startLoading */],
  closeToast: toast_actions["c" /* closeToast */],
  patchProposalHandler: proposals_action["p" /* patchProposalHandler */],
  saveCustomerProposalsHandler: proposals_action["u" /* saveCustomerProposalsHandler */],
  displayToastOnContextShare: proposals_action["i" /* displayToastOnContextShare */],
  getBookingEngineI18n: cms_actions["c" /* getBookingEngineI18n */],
  fetchRefreshProposal: proposals_action["m" /* fetchRefreshProposal */]
};
var BookingEngineContainer = Object(errorBoundary["a" /* default */])(Object(es["c" /* connect */])(BookingEngine_container_mapStateToProps, mapDispatchToProps, undefined, // because of shallow routing used inside the BE, the page changes without the props changing,
// so redux prevents the re-rendering (why btw? There's a withRouter lower, this is still weird)
{
  pure: false
})(booking_BookingEngine));
BookingEngineContainer.pageId = routes_constants["b" /* BOOKING_ENGINE_PAGE_ID */];
BookingEngineContainer.pageType = tracking_constants["C" /* STATIC_PAGE_TYPES */].BE;
BookingEngineContainer.disableFooter = true;
BookingEngineContainer.disableHeader = true;
/* harmony default export */ var BookingEngine_container = (BookingEngineContainer);
// CONCATENATED MODULE: ./pages/booking/[bookingStep].js

/* harmony default export */ var _bookingStep_ = __webpack_exports__["default"] = (BookingEngine_container);

/***/ }),

/***/ "U6GL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DropDown; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("OZaJ");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("pWxA");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("sRHE");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("C/y5");
/* harmony import */ var _utils_keyCodes__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("05v4");
/* harmony import */ var _DropDown_themes__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("Q8Qh");











var __jsx = react__WEBPACK_IMPORTED_MODULE_11___default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/click-events-have-key-events */




var DropDown = /*#__PURE__*/function (_Component) {
  Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(DropDown, _Component);

  var _super = _createSuper(DropDown);

  function DropDown(props) {
    var _this;

    Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(this, DropDown);

    _this = _super.call(this, props);

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_this), "rootRef", /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_11__["createRef"])());

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_this), "contentRef", /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_11__["createRef"])());

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_this), "expand", function () {
      _this.setState({
        isExpanded: true
      }, _this.toggleEventListeners);
    });

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_this), "collapse", function () {
      if (_this.props.onClose) {
        _this.props.onClose();
      }

      if (!_this.props.unmountsOnClose) {
        _this.setState({
          isExpanded: false
        }, _this.toggleEventListeners);
      }
    });

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_this), "onKeyDown", function (e) {
      if (e.keyCode === _utils_keyCodes__WEBPACK_IMPORTED_MODULE_13__[/* ESCAPE */ "g"]) {
        _this.collapse();
      }
    });

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_this), "onClickOutside", function (e) {
      if (!_this.contentRef || // $FlowFixMe
      _this.contentRef.current.contains(e.target) || // $FlowFixMe
      _this.rootRef.current.contains(e.target) || // $FlowFixMe
      lodash_get__WEBPACK_IMPORTED_MODULE_10___default()(_this.props, 'rootRef.current') && _this.props.rootRef.current.contains(e.target) || e.button && e.button !== 0) {
        return;
      }

      _this.collapse();
    });

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_this), "toggle", function () {
      _this.setState(function (prevState) {
        return {
          isExpanded: !prevState.isExpanded
        };
      }, _this.toggleEventListeners);
    });

    _this.state = {
      isExpanded: props.isExpanded || false
    };
    return _this;
  }

  Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(DropDown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.state.isExpanded) {
        this.addEventListeners();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.isExpanded) {
        this.removeEventListeners();
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.isExpanded !== this.props.isExpanded) {
        this.setState({
          isExpanded: nextProps.isExpanded
        }, this.toggleEventListeners);
      }
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      if (true) {
        document.addEventListener('mouseup', this.onClickOutside, false);
        document.addEventListener('touchstart', this.onClickOutside, false);
        document.addEventListener('keydown', this.onKeyDown, false);
      }
    }
  }, {
    key: "removeEventListeners",
    value: function removeEventListeners() {
      if (true) {
        document.removeEventListener('mouseup', this.onClickOutside, false);
        document.removeEventListener('touchstart', this.onClickOutside, false);
        document.removeEventListener('keydown', this.onKeyDown, false);
      }
    }
  }, {
    key: "toggleEventListeners",
    value: function toggleEventListeners() {
      if (this.state.isExpanded) {
        this.addEventListeners();
      } else {
        this.removeEventListeners();
      }
    } // TODO: cleanup !!
    // eslint-disable-next-line react/no-unused-class-component-methods

  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          contentStyle = _this$props.contentStyle,
          contentClassName = _this$props.contentClassName,
          hasArrow = _this$props.hasArrow,
          hasCloseOnClick = _this$props.hasCloseOnClick,
          noLayout = _this$props.noLayout,
          renderTrigger = _this$props.renderTrigger,
          theme = _this$props.theme;
      var thBody = Object(_DropDown_themes__WEBPACK_IMPORTED_MODULE_14__[/* themes */ "a"])({
        hasArrow: hasArrow
      })[theme].thBody;
      return __jsx("div", {
        className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_12__[/* classnames */ "a"])('inline-block', className),
        ref: this.rootRef
      }, renderTrigger && renderTrigger(this.toggle, this.state.isExpanded), this.state.isExpanded && __jsx("div", {
        className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_12__[/* classnames */ "a"])({
          'absolute left-1/2 w-full min-w-full -translate-x-1/2 transform': !noLayout
        }, contentClassName, thBody),
        "data-testid": "DropDown-body",
        onClick: hasCloseOnClick ? this.collapse : null,
        ref: this.contentRef,
        style: contentStyle
      }, children(this.toggle, this.state.isExpanded)));
    }
  }]);

  return DropDown;
}(react__WEBPACK_IMPORTED_MODULE_11__["Component"]);

Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(DropDown, "defaultProps", {
  hasArrow: true,
  isExpanded: false,
  noLayout: false,
  theme: 'default',
  unmountsOnClose: false
});

/***/ }),

/***/ "UpHs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ infoBanner_utils_renderInfoBanner; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/capitalize.js
var capitalize = __webpack_require__("h++M");
var capitalize_default = /*#__PURE__*/__webpack_require__.n(capitalize);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTrackEvent.js
var useTrackEvent = __webpack_require__("DqI1");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/countdown/Countdown.jsx + 1 modules
var Countdown = __webpack_require__("mmhe");

// EXTERNAL MODULE: ./src/client/components/frameworks/heading/Heading.jsx + 1 modules
var Heading = __webpack_require__("3jv5");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./src/client/components/frameworks/pop-over/PopOver.jsx + 1 modules
var PopOver = __webpack_require__("Xzib");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: ./src/client/components/widgets/info-banner/InfoBanner.themes.js
var InfoBanner_themes = __webpack_require__("cN29");

// CONCATENATED MODULE: ./src/client/components/widgets/info-banner/InfoBanner.jsx




var __jsx = react_default.a.createElement;














var positions = {
  left: 'start-0',
  right: 'end-0',
  center: 'inset-x-0'
};
var InfoBanner_InfoBanner = function InfoBanner(_ref) {
  var className = _ref.className,
      _ref$containerClassNa = _ref.containerClassName,
      containerClassName = _ref$containerClassNa === void 0 ? 'w-800' : _ref$containerClassNa,
      contentClassName = _ref.contentClassName,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? colors["a" /* COLORS */].BLACK : _ref$color,
      countdown = _ref.countdown,
      iconName = _ref.iconName,
      illustration = _ref.illustration,
      popin = _ref.popin,
      _ref$popinPosition = _ref.popinPosition,
      popinPosition = _ref$popinPosition === void 0 ? 'left' : _ref$popinPosition,
      subtitle = _ref.subtitle,
      title = _ref.title,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  var hasModal = !!popin && (!!(popin === null || popin === void 0 ? void 0 : popin.title) || !!(popin === null || popin === void 0 ? void 0 : popin.text) || !!(popin === null || popin === void 0 ? void 0 : popin.subtitle));
  var hasCountdown = !isEmpty_default()(countdown) && countdown.dateTimeEnd;
  var hasIcon = Boolean(illustration || iconName);
  var _themes$theme = Object(InfoBanner_themes["a" /* themes */])({
    color: color
  })[theme],
      thDescriptionBloc = _themes$theme.thDescriptionBloc,
      thPopinContent = _themes$theme.thPopinContent,
      thPopinContentImage = _themes$theme.thPopinContentImage,
      thPopinColor = _themes$theme.thPopinColor,
      thPopinTextColor = _themes$theme.thPopinTextColor;

  if (!title && !subtitle && !hasIcon && !hasCountdown) {
    return null;
  }

  var content = __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('text-initial flex', contentClassName)
  }, hasIcon && __jsx("div", {
    className: "border-".concat(color, " h-56 shrink-0 overflow-hidden rounded-4 border-1")
  }, illustration ? __jsx("img", {
    alt: "",
    className: "h-full",
    src: illustration
  }) : __jsx(Icon["a" /* Icon */], {
    className: "text-".concat(color, " p-5"),
    name: iconName,
    width: "3.5rem"
  })), hasCountdown && __jsx("div", {
    className: "bg-white border-".concat(color, " flex h-56 grow flex-col items-center justify-center overflow-hidden rounded-4 border-1 sm:order-1 sm:grow-0 text-").concat(color)
  }, __jsx(Countdown["a" /* Countdown */], Object(esm_extends["a" /* default */])({}, countdown, {
    dateTimeEnd: countdown === null || countdown === void 0 ? void 0 : countdown.dateTimeEnd,
    theme: "infoBanner"
  }))), (title || subtitle) && __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(thDescriptionBloc, 'h-56')
  }, __jsx("h6", {
    className: "text-10"
  }, subtitle), __jsx("h5", {
    className: "font-brand text-16 font-normal underline"
  }, title)));

  var imageProps = isDesktop ? {
    dimensions: {
      w: 300,
      h: 170
    }
  } : {
    dontChangeAnything: true
  };
  var tooltipContent = hasModal ? __jsx("div", {
    className: thPopinContent
  }, (popin === null || popin === void 0 ? void 0 : popin.image) && __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(thPopinContentImage, 'lg:h-220')
  }, __jsx(Image["a" /* Image */], Object(esm_extends["a" /* default */])({
    className: "h-full overflow-hidden rounded-12",
    imageUrl: popin.image
  }, imageProps))), __jsx("div", {
    className: "p-20"
  }, (popin === null || popin === void 0 ? void 0 : popin.title) && __jsx(Heading["a" /* Heading */], {
    className: Object(classnames_utils["a" /* classnames */])('font-brand text-24 font-normal leading-tight', "text-".concat(thPopinColor)),
    hLevel: 3,
    theme: "none"
  }, popin.title), (popin === null || popin === void 0 ? void 0 : popin.subtitle) && __jsx(Heading["a" /* Heading */], {
    className: "text-14 font-bold leading-tight",
    hLevel: 4,
    theme: "none"
  }, popin.subtitle), (popin === null || popin === void 0 ? void 0 : popin.text) && __jsx(Text["a" /* Text */], {
    className: "py-10 text-14 leading-tight lg:leading-loose",
    text: popin.text
  }), (popin === null || popin === void 0 ? void 0 : popin.url) && __jsx(Button["a" /* Button */], {
    color: thPopinTextColor,
    colorBg: thPopinColor,
    url: popin.url
  }, popin.buttonLabel))) : null;
  var position = popinPosition === 'left' ? 'left' : 'right';
  return __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('relative isolate', className)
  }, hasModal ? __jsx(PopOver["a" /* PopOver */], {
    ariaLabel: (popin === null || popin === void 0 ? void 0 : popin.title) ? popin.title : '',
    className: "flex justify-end",
    containerClassName: Object(classnames_utils["a" /* classnames */])("z-3 border-1 border-".concat(color, " ").concat(positions[popinPosition]), containerClassName),
    contentClassName: "arrow-bg arrow-bg-".concat(color, " arrow-up").concat(capitalize_default()(position)),
    content: tooltipContent,
    hasCloseButton: true,
    onClick: function onClick() {
      return trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_INFOBANNER, {
        detail_click: title
      });
    },
    theme: "infoBanner"
  }, content) : content);
};
// CONCATENATED MODULE: ./src/client/components/widgets/info-banner/infoBanner.utils.js













var infoBanner_utils_jsx = react["createElement"];

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}






 // eslint-disable-next-line clubmed/no-fake-component

var infoBanner_utils_renderInfoBanner = function renderInfoBanner(_ref) {
  var infoBannerData = _ref.infoBannerData,
      departureDate = _ref.departureDate,
      arrivalDate = _ref.arrivalDate,
      currentStep = _ref.currentStep,
      containerClassName = _ref.containerClassName,
      theme = _ref.theme,
      contentClassName = _ref.contentClassName,
      popinPosition = _ref.popinPosition,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? 'mb-20 z-2' : _ref$className;
  var content = ((infoBannerData === null || infoBannerData === void 0 ? void 0 : infoBannerData.productInformationBanners) || []).map(function (productInformationBanner, index) {
    var theContextInfoBannerData = productInformationBanner.salesChannel.find(function (el) {
      return el.context === 'B2C';
    });
    var isDepartureDateIncludedInBannerDates = moment_default()(departureDate).isBetween(Object(apiDate["j" /* momentFromApiDate */])(productInformationBanner === null || productInformationBanner === void 0 ? void 0 : productInformationBanner.startDate), Object(apiDate["j" /* momentFromApiDate */])(productInformationBanner === null || productInformationBanner === void 0 ? void 0 : productInformationBanner.endDate), null, []) || moment_default()(arrivalDate).isBetween(Object(apiDate["j" /* momentFromApiDate */])(productInformationBanner === null || productInformationBanner === void 0 ? void 0 : productInformationBanner.startDate), Object(apiDate["j" /* momentFromApiDate */])(productInformationBanner === null || productInformationBanner === void 0 ? void 0 : productInformationBanner.endDate), null, []) || Object(apiDate["j" /* momentFromApiDate */])(productInformationBanner === null || productInformationBanner === void 0 ? void 0 : productInformationBanner.endDate).isSame(arrivalDate);

    if (!theContextInfoBannerData || !isDepartureDateIncludedInBannerDates || !theContextInfoBannerData.tags.includes(currentStep)) {
      return null;
    }

    var countdown = productInformationBanner.countdown,
        popin = productInformationBanner.popin,
        toaster = productInformationBanner.toaster;
    var infoBannerCountdown = countdown ? _objectSpread(_objectSpread({}, countdown), {}, {
      dateTimeEnd: moment_default()(countdown.dateTimeEnd, 'YYYYMMDD HH:mm:ss'),
      days: Object(i18n["h" /* t */])('options.countdownLabels.days'),
      hours: Object(i18n["h" /* t */])('options.countdownLabels.hours'),
      minutes: Object(i18n["h" /* t */])('options.countdownLabels.minutes'),
      seconds: Object(i18n["h" /* t */])('options.countdownLabels.seconds')
    }) : null;
    return infoBanner_utils_jsx(InfoBanner_InfoBanner, Object(esm_extends["a" /* default */])({
      key: "infoBanner_".concat(index)
    }, toaster, {
      containerClassName: containerClassName,
      contentClassName: contentClassName,
      countdown: infoBannerCountdown,
      popin: popin,
      popinPosition: popinPosition,
      theme: theme
    }));
  }).filter(Boolean);

  if (!content.length) {
    return null;
  }

  return infoBanner_utils_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('relative isolate flex flex-col gap-10 sm:flex-row', className)
  }, content);
};

/***/ }),

/***/ "VDhN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:!0});var e=__webpack_require__("W/Kd"),t=__webpack_require__("ERkP");function s(e){return e&&e.__esModule?e:{default:e}}var n=s(e),i=s(t);function o(e){return e&&e.stopPropagation&&e.stopPropagation(),e&&e.preventDefault&&e.preventDefault(),!1}function r(e){return null==e?[]:Array.isArray(e)?e.slice():[e]}function a(e){return null!==e&&1===e.length?e[0]:e.slice()}function p(e){Object.keys(e).forEach((t=>{"undefined"!=typeof document&&document.addEventListener(t,e[t],!1)}))}function u(e,t){return l(function(e,t){let s=e;s<=t.min&&(s=t.min);s>=t.max&&(s=t.max);return s}(e,t),t)}function l(e,t){const s=(e-t.min)%t.step;let n=e-s;return 2*Math.abs(s)>=t.step&&(n+=s>0?t.step:-t.step),parseFloat(n.toFixed(5))}let h=function(e){function t(t){var s;(s=e.call(this,t)||this).onKeyUp=()=>{s.onEnd()},s.onMouseUp=()=>{s.onEnd(s.getMouseEventMap())},s.onTouchEnd=e=>{e.preventDefault(),s.onEnd(s.getTouchEventMap())},s.onBlur=()=>{s.setState({index:-1},s.onEnd(s.getKeyDownEventMap()))},s.onMouseMove=e=>{s.setState({pending:!0});const t=s.getMousePosition(e),n=s.getDiffPosition(t[0]),i=s.getValueFromPosition(n);s.move(i)},s.onTouchMove=e=>{if(e.touches.length>1)return;s.setState({pending:!0});const t=s.getTouchPosition(e);if(void 0===s.isScrolling){const e=t[0]-s.startPosition[0],n=t[1]-s.startPosition[1];s.isScrolling=Math.abs(n)>Math.abs(e)}if(s.isScrolling)return void s.setState({index:-1});const n=s.getDiffPosition(t[0]),i=s.getValueFromPosition(n);s.move(i)},s.onKeyDown=e=>{if(!(e.ctrlKey||e.shiftKey||e.altKey||e.metaKey))switch(s.setState({pending:!0}),e.key){case"ArrowLeft":case"ArrowDown":case"Left":case"Down":e.preventDefault(),s.moveDownByStep();break;case"ArrowRight":case"ArrowUp":case"Right":case"Up":e.preventDefault(),s.moveUpByStep();break;case"Home":e.preventDefault(),s.move(s.props.min);break;case"End":e.preventDefault(),s.move(s.props.max);break;case"PageDown":e.preventDefault(),s.moveDownByStep(s.props.pageFn(s.props.step));break;case"PageUp":e.preventDefault(),s.moveUpByStep(s.props.pageFn(s.props.step))}},s.onSliderMouseDown=e=>{if(!s.props.disabled&&2!==e.button){if(s.setState({pending:!0}),!s.props.snapDragDisabled){const t=s.getMousePosition(e);s.forceValueFromPosition(t[0],(e=>{s.start(e,t[0]),p(s.getMouseEventMap())}))}o(e)}},s.onSliderClick=e=>{if(!s.props.disabled&&s.props.onSliderClick&&!s.hasMoved){const t=s.getMousePosition(e),n=u(s.calcValue(s.calcOffsetFromPosition(t[0])),s.props);s.props.onSliderClick(n)}},s.createOnKeyDown=e=>t=>{s.props.disabled||(s.start(e),p(s.getKeyDownEventMap()),o(t))},s.createOnMouseDown=e=>t=>{if(s.props.disabled||2===t.button)return;s.setState({pending:!0});const n=s.getMousePosition(t);s.start(e,n[0]),p(s.getMouseEventMap()),o(t)},s.createOnTouchStart=e=>t=>{if(s.props.disabled||t.touches.length>1)return;s.setState({pending:!0});const n=s.getTouchPosition(t);s.startPosition=n,s.isScrolling=void 0,s.start(e,n[0]),p(s.getTouchEventMap()),function(e){e.stopPropagation&&e.stopPropagation()}(t)},s.handleResize=()=>{const e=window.setTimeout((()=>{s.pendingResizeTimeouts.shift(),s.resize()}),0);s.pendingResizeTimeouts.push(e)},s.renderThumb=(e,t)=>{const n=s.props.thumbClassName+" "+s.props.thumbClassName+"-"+t+" "+(s.state.index===t?s.props.thumbActiveClassName:""),i={ref:e=>{s["thumb"+t]=e},key:s.props.thumbClassName+"-"+t,className:n,style:e,onMouseDown:s.createOnMouseDown(t),onTouchStart:s.createOnTouchStart(t),onFocus:s.createOnKeyDown(t),tabIndex:0,role:"slider","aria-orientation":s.props.orientation,"aria-valuenow":s.state.value[t],"aria-valuemin":s.props.min,"aria-valuemax":s.props.max,"aria-label":Array.isArray(s.props.ariaLabel)?s.props.ariaLabel[t]:s.props.ariaLabel,"aria-labelledby":Array.isArray(s.props.ariaLabelledby)?s.props.ariaLabelledby[t]:s.props.ariaLabelledby,"aria-disabled":s.props.disabled},o={index:t,value:a(s.state.value),valueNow:s.state.value[t]};return s.props.ariaValuetext&&(i["aria-valuetext"]="string"==typeof s.props.ariaValuetext?s.props.ariaValuetext:s.props.ariaValuetext(o)),s.props.renderThumb(i,o)},s.renderTrack=(e,t,n)=>{const i={key:s.props.trackClassName+"-"+e,className:s.props.trackClassName+" "+s.props.trackClassName+"-"+e,style:s.buildTrackStyle(t,s.state.upperBound-n)},o={index:e,value:a(s.state.value)};return s.props.renderTrack(i,o)};let n=r(t.value);n.length||(n=r(t.defaultValue)),s.pendingResizeTimeouts=[];const l=[];for(let e=0;e<n.length;e+=1)n[e]=u(n[e],t),l.push(e);return s.resizeObserver=null,s.resizeElementRef=i.default.createRef(),s.state={index:-1,upperBound:0,sliderLength:0,value:n,zIndices:l},s}n.default(t,e);var s=t.prototype;return s.componentDidMount=function(){"undefined"!=typeof window&&(this.resizeObserver=new ResizeObserver(this.handleResize),this.resizeObserver.observe(this.resizeElementRef.current),this.resize())},t.getDerivedStateFromProps=function(e,t){const s=r(e.value);return s.length?t.pending?null:{value:s.map((t=>u(t,e)))}:null},s.componentDidUpdate=function(){0===this.state.upperBound&&this.resize()},s.componentWillUnmount=function(){this.clearPendingResizeTimeouts(),this.resizeObserver&&this.resizeObserver.disconnect()},s.onEnd=function(e){e&&function(e){Object.keys(e).forEach((t=>{"undefined"!=typeof document&&document.removeEventListener(t,e[t],!1)}))}(e),this.hasMoved&&this.fireChangeEvent("onAfterChange"),this.setState({pending:!1}),this.hasMoved=!1},s.getValue=function(){return a(this.state.value)},s.getClosestIndex=function(e){let t=Number.MAX_VALUE,s=-1;const{value:n}=this.state,i=n.length;for(let o=0;o<i;o+=1){const i=this.calcOffset(n[o]),r=Math.abs(e-i);r<t&&(t=r,s=o)}return s},s.getMousePosition=function(e){return[e["page"+this.axisKey()],e["page"+this.orthogonalAxisKey()]]},s.getTouchPosition=function(e){const t=e.touches[0];return[t["page"+this.axisKey()],t["page"+this.orthogonalAxisKey()]]},s.getKeyDownEventMap=function(){return{keydown:this.onKeyDown,keyup:this.onKeyUp,focusout:this.onBlur}},s.getMouseEventMap=function(){return{mousemove:this.onMouseMove,mouseup:this.onMouseUp}},s.getTouchEventMap=function(){return{touchmove:this.onTouchMove,touchend:this.onTouchEnd}},s.getValueFromPosition=function(e){const t=e/(this.state.sliderLength-this.state.thumbSize)*(this.props.max-this.props.min);return u(this.state.startValue+t,this.props)},s.getDiffPosition=function(e){let t=e-this.state.startPosition;return this.props.invert&&(t*=-1),t},s.resize=function(){const{slider:e,thumb0:t}=this;if(!e||!t)return;const s=this.sizeKey(),n=e.getBoundingClientRect(),i=e[s],o=n[this.posMaxKey()],r=n[this.posMinKey()],a=t.getBoundingClientRect()[s.replace("client","").toLowerCase()],p=i-a,u=Math.abs(o-r);this.state.upperBound===p&&this.state.sliderLength===u&&this.state.thumbSize===a||this.setState({upperBound:p,sliderLength:u,thumbSize:a})},s.calcOffset=function(e){const t=this.props.max-this.props.min;if(0===t)return 0;return(e-this.props.min)/t*this.state.upperBound},s.calcValue=function(e){return e/this.state.upperBound*(this.props.max-this.props.min)+this.props.min},s.calcOffsetFromPosition=function(e){const{slider:t}=this,s=t.getBoundingClientRect(),n=s[this.posMaxKey()],i=s[this.posMinKey()];let o=e-(window["page"+this.axisKey()+"Offset"]+(this.props.invert?n:i));return this.props.invert&&(o=this.state.sliderLength-o),o-=this.state.thumbSize/2,o},s.forceValueFromPosition=function(e,t){const s=this.calcOffsetFromPosition(e),n=this.getClosestIndex(s),i=u(this.calcValue(s),this.props),o=this.state.value.slice();o[n]=i;for(let e=0;e<o.length-1;e+=1)if(o[e+1]-o[e]<this.props.minDistance)return;this.fireChangeEvent("onBeforeChange"),this.hasMoved=!0,this.setState({value:o},(()=>{t(n),this.fireChangeEvent("onChange")}))},s.clearPendingResizeTimeouts=function(){do{const e=this.pendingResizeTimeouts.shift();clearTimeout(e)}while(this.pendingResizeTimeouts.length)},s.start=function(e,t){const s=this["thumb"+e];s&&s.focus();const{zIndices:n}=this.state;n.splice(n.indexOf(e),1),n.push(e),this.setState((s=>({startValue:s.value[e],startPosition:void 0!==t?t:s.startPosition,index:e,zIndices:n})))},s.moveUpByStep=function(e){void 0===e&&(e=this.props.step);const t=this.state.value[this.state.index],s=u(this.props.invert&&"horizontal"===this.props.orientation?t-e:t+e,this.props);this.move(Math.min(s,this.props.max))},s.moveDownByStep=function(e){void 0===e&&(e=this.props.step);const t=this.state.value[this.state.index],s=u(this.props.invert&&"horizontal"===this.props.orientation?t+e:t-e,this.props);this.move(Math.max(s,this.props.min))},s.move=function(e){const t=this.state.value.slice(),{index:s}=this.state,{length:n}=t,i=t[s];if(e===i)return;this.hasMoved||this.fireChangeEvent("onBeforeChange"),this.hasMoved=!0;const{pearling:o,max:r,min:a,minDistance:p}=this.props;if(!o){if(s>0){const n=t[s-1];e<n+p&&(e=n+p)}if(s<n-1){const n=t[s+1];e>n-p&&(e=n-p)}}t[s]=e,o&&n>1&&(e>i?(this.pushSucceeding(t,p,s),function(e,t,s,n){for(let i=0;i<e;i+=1){const o=n-i*s;t[e-1-i]>o&&(t[e-1-i]=o)}}(n,t,p,r)):e<i&&(this.pushPreceding(t,p,s),function(e,t,s,n){for(let i=0;i<e;i+=1){const e=n+i*s;t[i]<e&&(t[i]=e)}}(n,t,p,a))),this.setState({value:t},this.fireChangeEvent.bind(this,"onChange"))},s.pushSucceeding=function(e,t,s){let n,i;for(n=s,i=e[n]+t;null!==e[n+1]&&i>e[n+1];n+=1,i=e[n]+t)e[n+1]=l(i,this.props)},s.pushPreceding=function(e,t,s){for(let n=s,i=e[n]-t;null!==e[n-1]&&i<e[n-1];n-=1,i=e[n]-t)e[n-1]=l(i,this.props)},s.axisKey=function(){return"vertical"===this.props.orientation?"Y":"X"},s.orthogonalAxisKey=function(){return"vertical"===this.props.orientation?"X":"Y"},s.posMinKey=function(){return"vertical"===this.props.orientation?this.props.invert?"bottom":"top":this.props.invert?"right":"left"},s.posMaxKey=function(){return"vertical"===this.props.orientation?this.props.invert?"top":"bottom":this.props.invert?"left":"right"},s.sizeKey=function(){return"vertical"===this.props.orientation?"clientHeight":"clientWidth"},s.fireChangeEvent=function(e){this.props[e]&&this.props[e](a(this.state.value),this.state.index)},s.buildThumbStyle=function(e,t){const s={position:"absolute",touchAction:"none",willChange:this.state.index>=0?this.posMinKey():void 0,zIndex:this.state.zIndices.indexOf(t)+1};return s[this.posMinKey()]=e+"px",s},s.buildTrackStyle=function(e,t){const s={position:"absolute",willChange:this.state.index>=0?this.posMinKey()+","+this.posMaxKey():void 0};return s[this.posMinKey()]=e,s[this.posMaxKey()]=t,s},s.buildMarkStyle=function(e){var t;return(t={position:"absolute"})[this.posMinKey()]=e,t},s.renderThumbs=function(e){const{length:t}=e,s=[];for(let n=0;n<t;n+=1)s[n]=this.buildThumbStyle(e[n],n);const n=[];for(let e=0;e<t;e+=1)n[e]=this.renderThumb(s[e],e);return n},s.renderTracks=function(e){const t=[],s=e.length-1;t.push(this.renderTrack(0,0,e[0]));for(let n=0;n<s;n+=1)t.push(this.renderTrack(n+1,e[n],e[n+1]));return t.push(this.renderTrack(s+1,e[s],this.state.upperBound)),t},s.renderMarks=function(){let{marks:e}=this.props;const t=this.props.max-this.props.min+1;return"boolean"==typeof e?e=Array.from({length:t}).map(((e,t)=>t)):"number"==typeof e&&(e=Array.from({length:t}).map(((e,t)=>t)).filter((t=>t%e==0))),e.map(parseFloat).sort(((e,t)=>e-t)).map((e=>{const t=this.calcOffset(e),s={key:e,className:this.props.markClassName,style:this.buildMarkStyle(t)};return this.props.renderMark(s)}))},s.render=function(){const e=[],{value:t}=this.state,s=t.length;for(let n=0;n<s;n+=1)e[n]=this.calcOffset(t[n],n);const n=this.props.withTracks?this.renderTracks(e):null,o=this.renderThumbs(e),r=this.props.marks?this.renderMarks():null;return i.default.createElement("div",{ref:e=>{this.slider=e,this.resizeElementRef.current=e},style:{position:"relative"},className:this.props.className+(this.props.disabled?" disabled":""),onMouseDown:this.onSliderMouseDown,onClick:this.onSliderClick},n,o,r)},t}(i.default.Component);h.displayName="ReactSlider",h.defaultProps={min:0,max:100,step:1,pageFn:e=>10*e,minDistance:0,defaultValue:0,orientation:"horizontal",className:"slider",thumbClassName:"thumb",thumbActiveClassName:"active",trackClassName:"track",markClassName:"mark",withTracks:!0,pearling:!1,disabled:!1,snapDragDisabled:!1,invert:!1,marks:[],renderThumb:e=>i.default.createElement("div",e),renderTrack:e=>i.default.createElement("div",e),renderMark:e=>i.default.createElement("span",e)};var c=h;exports.default=c;


/***/ }),

/***/ "VtPb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return INITIAL_MONTH; });
/* unused harmony export calendarQuery */
/* unused harmony export bookableDatesQuery */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return queryFetchCalendar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return queryFetchBookableDates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDefaultSelectedMonth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getSelectedMonth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getPricesByDays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getClosingDatesRanges; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("tQbP");
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("6U7i");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("/FsK");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_uri_constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("Sj1w");
/* harmony import */ var _utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("nv//");
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("ldK3");














var NO_TRANSPORT_VALUE = 'NO';
var DATE_FORMAT = 'YYYYMM';
var INITIAL_MONTH = 0;
function calendarQuery(args) {
  var resortId = args.resortId,
      duration = args.duration,
      departureCity = args.departureCity,
      urgentisationRate = args.urgentisationRate;
  return "\n      calendar(resortId: \"".concat(resortId, "\", duration: \"").concat(duration, "\", departureCity: \"").concat(departureCity, "\") {\n        blocks {\n          hasPrice\n          id\n          name\n          price {\n            value\n            currency\n            formattedValue\n          }\n          shortName\n          year\n        }\n        firstAvailableMonthIndex\n        months {\n          id\n          days {\n            dayContent {\n              arrivalDate\n              availability\n              canGoToBooking\n              id\n              isCurrentMonth\n              name\n              number\n              offer(urgentisationRate: ").concat(urgentisationRate, ")\n              shortName\n              siblingId\n            }\n            priceConfig {\n              bestPrice(forceAdultPerTrip: true, isCalendarCase: true) { value formattedValue }\n              currency\n              initialPrice(forceAdultPerTrip: true, isCalendarCase: true) { value formattedValue }\n              isBestPriceMonth\n              termsAndConditions {\n                accommodationComfortLabel\n                departureCity {\n                  value\n                  name\n                }\n                departureDate\n                duration\n                numberOfAdults\n                offerId\n              }\n              rawUnit\n              unit\n            }\n          }\n        }\n        weekDays\n      }\n    ");
}
function bookableDatesQuery(_ref) {
  var departureCity = _ref.departureCity,
      productId = _ref.productId;
  return "\n    bookableDates(productId: \"".concat(productId, "\", departureCity: \"").concat(departureCity, "\") {\n      months {\n        id\n        days {\n          id\n          availabilities {\n            status\n            durations\n          }\n        }\n      }\n    }\n  ");
}
function queryFetchCalendar(appContext, options) {
  var locale = appContext.locale;
  var _options$resortId = options.resortId,
      resortId = _options$resortId === void 0 ? '' : _options$resortId,
      _options$transport = options.transport,
      transport = _options$transport === void 0 ? '' : _options$transport,
      duration = options.duration,
      urgentisationRate = options.urgentisationRate;
  var calendarQueryArgs = {
    locale: locale,
    resortId: resortId,
    departureCity: transport || NO_TRANSPORT_VALUE,
    duration: duration,
    urgentisationRate: urgentisationRate
  };
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"].runQuery("query {".concat(calendarQuery(calendarQueryArgs), "}"), appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_10__[/* STATE_PRODUCT_CALENDAR */ "cd"]
  }).then(function (_ref2) {
    var calendar = _ref2.calendar;
    return {
      calendar: calendar
    };
  });
}
function queryFetchBookableDates(appContext, options) {
  var _options$productId = options.productId,
      productId = _options$productId === void 0 ? '' : _options$productId,
      _options$departureCit = options.departureCity,
      departureCity = _options$departureCit === void 0 ? '' : _options$departureCit;
  var bookableDatesQueryArs = {
    productId: productId,
    departureCity: departureCity
  };
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"].runQuery("query {".concat(bookableDatesQuery(bookableDatesQueryArs), "}"), appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_10__[/* STATE_PRODUCT_BOOKABLE_DATES */ "bd"]
  }).then(function (_ref3) {
    var bookableDates = _ref3.bookableDates;
    return {
      bookableDates: bookableDates
    };
  });
}
function getDefaultSelectedMonth() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var momentDate = value ? moment__WEBPACK_IMPORTED_MODULE_7___default()(value, format) : moment__WEBPACK_IMPORTED_MODULE_7___default()();
  return parseInt(momentDate.format(DATE_FORMAT), 10);
}
function getSelectedMonth(calendar, previousSelectedMonth) {
  var _calendar$months; // The query date param prevails


  var dateQueryParam = Object(_utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_12__[/* getSpecificQueryParam */ "k"])(_utils_uri_constants__WEBPACK_IMPORTED_MODULE_11__[/* QUERY_DEPARTURE_DATE */ "g"]);

  if (dateQueryParam) {
    return getDefaultSelectedMonth(dateQueryParam);
  }

  var firstCalendarMonth = ((_calendar$months = calendar.months) === null || _calendar$months === void 0 ? void 0 : _calendar$months[0].id) || getDefaultSelectedMonth();
  var firstAvailableMonthIndex = calendar.firstAvailableMonthIndex || INITIAL_MONTH;
  var firstAvailableMonth = parseInt(moment__WEBPACK_IMPORTED_MODULE_7___default()(firstCalendarMonth, DATE_FORMAT).add(firstAvailableMonthIndex, 'months').format(DATE_FORMAT), 10); // The previously selected month remains selected unless the first available dates are later

  if (previousSelectedMonth > firstAvailableMonth) {
    return previousSelectedMonth;
  }

  return firstAvailableMonth;
}
function getPricesByDays(calendar) {
  var prices = {};

  if (calendar.months) {
    calendar.months.forEach(function (_ref4) {
      var days = _ref4.days;

      if (days) {
        days.forEach(function (_ref5) {
          var _priceConfig$termsAnd, _priceConfig$termsAnd2;

          var dayContent = _ref5.dayContent,
              priceConfig = _ref5.priceConfig;

          var _ref6 = dayContent || {},
              availability = _ref6.availability,
              id = _ref6.id,
              offer = _ref6.offer,
              siblingId = _ref6.siblingId;

          var isBestPrice = priceConfig === null || priceConfig === void 0 ? void 0 : priceConfig.isBestPriceMonth;
          var unit = priceConfig === null || priceConfig === void 0 ? void 0 : priceConfig.unit;
          var departureCityValue = (priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$termsAnd = priceConfig.termsAndConditions) === null || _priceConfig$termsAnd === void 0 ? void 0 : (_priceConfig$termsAnd2 = _priceConfig$termsAnd.departureCity) === null || _priceConfig$termsAnd2 === void 0 ? void 0 : _priceConfig$termsAnd2.value) || NO_TRANSPORT_VALUE;

          if (id) {
            var _priceConfig$termsAnd3, _priceConfig$termsAnd4, _priceConfig$initialP, _priceConfig$bestPric, _priceConfig$bestPric2, _priceConfig$termsAnd5;

            var available = availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_8__[/* API_OPEN */ "g"];
            var closed = availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_8__[/* API_CLOSED */ "a"];
            var exclusivity = availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_8__[/* API_EXCLUSIVITY */ "b"];
            var full = availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_8__[/* API_FULL */ "c"];
            var lastAvailability = offer === 'urgentisation';
            var noAvailability = availability === '';
            var noDeparture = availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_8__[/* API_NO_DEPARTURE */ "e"];
            var noFlight = availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_8__[/* API_NO_FLIGHT */ "f"];
            var siblingOpen = availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_8__[/* API_SIBLING_SUMMER */ "h"] || availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_8__[/* API_SIBLING_WINTER */ "i"];
            prices[id] = {
              availability: availability,
              available: available,
              closed: closed,
              currency: priceConfig === null || priceConfig === void 0 ? void 0 : priceConfig.currency,
              departureCity: (priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$termsAnd3 = priceConfig.termsAndConditions) === null || _priceConfig$termsAnd3 === void 0 ? void 0 : (_priceConfig$termsAnd4 = _priceConfig$termsAnd3.departureCity) === null || _priceConfig$termsAnd4 === void 0 ? void 0 : _priceConfig$termsAnd4.name) || '',
              exclusivity: exclusivity,
              full: full,
              hasTransport: departureCityValue !== NO_TRANSPORT_VALUE,
              isBestPrice: isBestPrice,
              lastAvailability: lastAvailability,
              noAvailability: noAvailability,
              noDeparture: noDeparture,
              noFlight: noFlight,
              oldPrice: (priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$initialP = priceConfig.initialPrice) === null || _priceConfig$initialP === void 0 ? void 0 : _priceConfig$initialP.formattedValue) || null,
              price: (priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$bestPric = priceConfig.bestPrice) === null || _priceConfig$bestPric === void 0 ? void 0 : _priceConfig$bestPric.formattedValue) || null,
              priceValue: (priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$bestPric2 = priceConfig.bestPrice) === null || _priceConfig$bestPric2 === void 0 ? void 0 : _priceConfig$bestPric2.value) || null,
              rate: priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$termsAnd5 = priceConfig.termsAndConditions) === null || _priceConfig$termsAnd5 === void 0 ? void 0 : _priceConfig$termsAnd5.offerId,
              siblingId: siblingId,
              siblingOpen: siblingOpen,
              unit: unit
            };
          }
        });
      }
    });
  }

  return prices;
}
var getClosingDatesRanges = function getClosingDatesRanges(openingDatesRanges) {
  return openingDatesRanges.sort(function (date1, date2) {
    return Number(date1.opening) - Number(date2.opening);
  }).map(function (openingDate, index, openingDates) {
    var _openingDates;

    return {
      after: Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_13__[/* momentFromApiDate */ "j"])(openingDate.closing).toDate(),
      before: Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_13__[/* momentFromApiDate */ "j"])(((_openingDates = openingDates[index + 1]) === null || _openingDates === void 0 ? void 0 : _openingDates.opening) || openingDates[0].opening).toDate()
    };
  });
};

/***/ }),

/***/ "W+NJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ InputButton_InputButton; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/badge/Badge.jsx + 1 modules
var Badge = __webpack_require__("VHif");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/Spinner.jsx
var Spinner = __webpack_require__("7amT");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-button/InputButton.themes.js









function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}



var InputButton_themes_defaultTheme = function defaultTheme(_ref) {
  var isActive = _ref.isActive,
      isDisabled = _ref.isDisabled,
      isFilled = _ref.isFilled;
  var hasDefaultStyle = !isActive && !isFilled && !isDisabled;
  var hasFilledStyle = isFilled && !isDisabled;
  var hasActiveStyle = isActive && !isDisabled && !isFilled;
  return {
    thRoot: Object(classnames_utils["a" /* classnames */])('flex w-full items-center rounded-pill border text-14 leading-normal text-black transition-all duration-250 ease-in', {
      'border-lightGrey hocus:border-black': hasDefaultStyle,
      'border-black': hasActiveStyle,
      'border-success text-black': hasFilledStyle,
      'cursor-not-allowed border-grey bg-pearl text-grey': isDisabled
    }),
    thButton: 'flex gap-10 items-center flex-1 h-48 px-20 py-10',
    thIcon: Object(classnames_utils["a" /* classnames */])('flex-none shrink-0', {
      'text-success': isFilled
    }),
    thIconSize: '1.25em',
    thChildren: 'flex-1 text-initial',
    thBadge: 'size-24 text-black bg-saffron border-saffron',
    thIconRight: 'leading-0 pe-20 py-10 shrink-0',
    thSpinner: 'shrink-0 text-current',
    thIconCaret: 'transition-all duration-250 ease-in',
    thClear: 'leading-0 pe-20 py-10 shrink-0',
    thClearSize: '0.625rem',
    thSwitchButton: 'leading-0 pe-20 py-10 shrink-0',
    thSwitch: Object(classnames_utils["a" /* classnames */])('flex h-24 w-40 overflow-hidden rounded-pill border-current bg-current p-2 leading-0 transition-all duration-250 ease-in', {
      'text-lightGrey': !isFilled,
      'text-success': isFilled
    }),
    thSwitchToggler: Object(classnames_utils["a" /* classnames */])('flex size-20 items-center justify-center rounded-pill bg-white text-center text-10 font-bold leading-0 shadow', {
      'text-lightGrey': !isFilled,
      'transform text-success ltr:translate-x-[16px] rtl:-translate-x-[16px]': isFilled
    })
  };
};

var themes = function themes(props) {
  var d = InputButton_themes_defaultTheme(props);
  return {
    "default": d,
    remote: _objectSpread(_objectSpread({}, d), {}, {
      thButton: 'flex gap-5 items-center justify-center flex-1 h-48 p-10',
      thChildren: 'text-initial',
      thBadge: 'hidden',
      thClear: 'hidden',
      thIconRight: 'hidden',
      thSwitchButton: 'hidden'
    })
  };
};
// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-button/InputButton.jsx
var __jsx = react_default.a.createElement;

/* eslint-disable react/jsx-no-useless-fragment */







var InputButton_InputButton = function InputButton(_ref) {
  var children = _ref.children,
      className = _ref.className,
      dataTestId = _ref.dataTestId,
      badgeCount = _ref.badgeCount,
      _ref$hasSwitch = _ref.hasSwitch,
      hasSwitch = _ref$hasSwitch === void 0 ? false : _ref$hasSwitch,
      iconName = _ref.iconName,
      isActive = _ref.isActive,
      isDisabled = _ref.isDisabled,
      isFilled = _ref.isFilled,
      isLoading = _ref.isLoading,
      onClear = _ref.onClear,
      onClick = _ref.onClick,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      title = _ref.title;
  var _themes$theme = themes({
    isActive: isActive,
    isDisabled: isDisabled,
    isFilled: isFilled,
    isLoading: isLoading
  })[theme],
      thBadge = _themes$theme.thBadge,
      thButton = _themes$theme.thButton,
      thChildren = _themes$theme.thChildren,
      thClear = _themes$theme.thClear,
      thClearSize = _themes$theme.thClearSize,
      thIcon = _themes$theme.thIcon,
      thIconRight = _themes$theme.thIconRight,
      thIconCaret = _themes$theme.thIconCaret,
      thIconSize = _themes$theme.thIconSize,
      thSpinner = _themes$theme.thSpinner,
      thRoot = _themes$theme.thRoot,
      thSwitch = _themes$theme.thSwitch,
      thSwitchButton = _themes$theme.thSwitchButton,
      thSwitchToggler = _themes$theme.thSwitchToggler;

  if (!iconName && !children) {
    return null;
  }

  var hasClear = onClear && isFilled && !isLoading && !isDisabled;
  return __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(thRoot, className)
  }, __jsx("button", {
    className: thButton,
    "data-testid": dataTestId,
    disabled: isDisabled,
    onClick: onClick,
    title: title,
    type: "button"
  }, !!iconName && __jsx(Icon["a" /* Icon */], {
    className: Object(classnames_utils["a" /* classnames */])(thIcon),
    name: iconName,
    width: thIconSize
  }), __jsx("span", {
    className: thChildren
  }, children), !!badgeCount && __jsx(Badge["a" /* Badge */], {
    className: thBadge,
    label: __jsx("span", {
      className: "-me-1 mt-1"
    }, badgeCount),
    variant: "pill"
  })), !hasSwitch && __jsx(react["Fragment"], null, hasClear ? __jsx("button", {
    "data-testid": "InputButtonClear",
    className: thClear,
    disabled: isDisabled,
    onClick: onClear,
    type: "button"
  }, __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: thClearSize
  })) : __jsx("button", {
    className: thIconRight,
    onClick: onClick,
    type: "button"
  }, isLoading ? __jsx(Spinner["a" /* Spinner */], {
    className: thSpinner,
    size: "small"
  }) : __jsx(Icon["a" /* Icon */], {
    className: thIconCaret,
    name: icons["a" /* ICONS */].ARROW_DOWN,
    width: "0.625rem"
  }))), hasSwitch && __jsx("button", {
    className: thSwitchButton,
    "data-testid": "InputButtonClear",
    onClick: hasClear ? onClear : onClick,
    type: "button"
  }, __jsx("span", {
    className: thSwitch
  }, __jsx("span", {
    "aria-hidden": true,
    className: thSwitchToggler
  }, __jsx(Icon["a" /* Icon */], {
    name: isFilled ? icons["a" /* ICONS */].ON : icons["a" /* ICONS */].OFF,
    width: "0.5rem"
  })))));
};

/***/ }),

/***/ "W/Kd":
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__("695J");
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  setPrototypeOf(subClass, superClass);
}
module.exports = _inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "W5pp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ HeaderLite_HeaderLite; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("7xRU");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTrackEvent.js
var useTrackEvent = __webpack_require__("DqI1");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/widgets/product-block-header/ProductBlockHeader.jsx + 1 modules
var ProductBlockHeader = __webpack_require__("8Cfg");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.every.js
var es_array_every = __webpack_require__("DfhM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("5BYb");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("KqXw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("MvUL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: /opt/webapp/node_modules/next/router.js
var next_router = __webpack_require__("Bkb1");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/client/views/booking/constants.js
var booking_constants = __webpack_require__("taV1");

// EXTERNAL MODULE: ./src/client/store/booking/proposals/proposals.action.js + 2 modules
var proposals_action = __webpack_require__("AnR0");

// EXTERNAL MODULE: ./src/client/components/frameworks/modal/Modal.jsx + 1 modules
var Modal = __webpack_require__("EvYw");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__("rOcY");
var config_default = /*#__PURE__*/__webpack_require__.n(config);

// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/b2b-payment-info/B2BProposalPdfDownloadButton.jsx















var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


















var getFilename = function getFilename(resort, proposal) {
  var _resort$name;

  return "".concat(resort === null || resort === void 0 ? void 0 : (_resort$name = resort.name) === null || _resort$name === void 0 ? void 0 : _resort$name.replace(/ /g, '_'), "-").concat(proposal.arrivalDate, "_").concat(proposal.departureDate);
};

var B2BProposalPdfDownloadButton_handleSubmit = function handleSubmit(proposal, appContext, router, dispatch, track) {
  return function (event) {
    event.preventDefault();
    event.stopPropagation();
    track({});
    var hasIdentifiedAttendees = proposal.households.some(function (household) {
      return household.attendees.some(function (attendee) {
        return attendee.customerId;
      });
    });

    if (appContext.isCxo && hasIdentifiedAttendees) {
      var _router$query, _router$query2;

      Object(proposals_action["p" /* patchProposalHandler */])(proposal.id, appContext, true)(dispatch);
      Object(proposals_action["v" /* saveCustomerProposalsOpportunityIdHandler */])(proposal.id, appContext, (_router$query = router.query) === null || _router$query === void 0 ? void 0 : _router$query.cxo_primarycontact, (_router$query2 = router.query) === null || _router$query2 === void 0 ? void 0 : _router$query2.cxo_opportunity_guid)(dispatch);
    }

    event.target.submit();
  };
};

var B2BProposalPdfDownloadButton_PdfActionsModal = function PdfActionsModal(props) {
  var proposal = props.proposal,
      _props$isOnComparator = props.isOnComparator,
      isOnComparator = _props$isOnComparator === void 0 ? false : _props$isOnComparator,
      onClose = props.onClose,
      resort = props.resort;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var router = Object(next_router["useRouter"])();
  var dispatch = Object(es["d" /* useDispatch */])();
  var noIdentifiedAttendee = proposal.households.every(function (_ref) {
    var attendees = _ref.attendees;
    return attendees.every(function (_ref2) {
      var customerId = _ref2.customerId;
      return !customerId;
    });
  });
  var track = Object(useTracking["a" /* useTracking */])(_objectSpread(_objectSpread({}, booking_constants["c" /* BE_GA_DEFAULT_PAYLOAD */]), {}, {
    actionGA: 'banking',
    labelGA: isOnComparator ? 'downloadPDF' : 'CTA_download'
  }));

  function onClickSendEmail() {
    var _router$query3, _router$query4;

    var pageTypeParam = 'pagetype=entityrecord';
    var entityTypeParam = 'etn=email';
    var extraQueryParams = "extraqs=cxo_proposalids%3D".concat(proposal.id);
    window.open("".concat(config_default.a.get('dynamics.url'), "&").concat(pageTypeParam, "&").concat(entityTypeParam, "&").concat(extraQueryParams));
    Object(proposals_action["v" /* saveCustomerProposalsOpportunityIdHandler */])(proposal.id, appContext, (_router$query3 = router.query) === null || _router$query3 === void 0 ? void 0 : _router$query3.cxo_primarycontact, (_router$query4 = router.query) === null || _router$query4 === void 0 ? void 0 : _router$query4.cxo_opportunity_guid)(dispatch);
  }

  var filename = getFilename(resort, proposal);
  var apiKey = config_default.a.get('api.seller.api_key');
  return __jsx(Modal["a" /* Modal */], {
    ariaLabel: Object(i18n["h" /* t */])('seller.downloadPdf.shareProposals'),
    closeLabel: Object(i18n["h" /* t */])('common.close'),
    onClose: onClose
  }, __jsx("div", {
    className: "text-blue p-20 text-center text-24 font-bold"
  }, Object(i18n["h" /* t */])('seller.downloadPdf.shareProposals')), __jsx("div", {
    className: "mb-40 flex w-full justify-center px-40"
  }, __jsx("div", null, __jsx("div", {
    className: classnames_default()({
      'mb-20': !noIdentifiedAttendee
    })
  }, Object(i18n["h" /* t */])('seller.downloadPdf.chooseMethod')), noIdentifiedAttendee && __jsx("div", {
    className: "text-danger text-sm mb-20 flex items-center font-bold"
  }, __jsx(Icon["a" /* Icon */], {
    className: "mr-5 flex-shrink self-start",
    color: colors["a" /* COLORS */].DANGER,
    name: icons["a" /* ICONS */].WARNING,
    width: "1.5em"
  }), Object(i18n["h" /* t */])('seller.downloadPdf.missingPaxInfo')), __jsx("div", {
    className: "flex w-full justify-center"
  }, __jsx(Button["a" /* Button */], {
    colorBg: colors["a" /* COLORS */].BLUE,
    className: "rounded-5 mr-20",
    isDisabled: noIdentifiedAttendee,
    onClick: onClickSendEmail,
    size: "mediumLarge"
  }, __jsx("span", {
    className: "px-4 text-16"
  }, Object(i18n["h" /* t */])('seller.downloadPdf.sendEmail'))), __jsx("form", {
    action: "/proposal-pdf",
    method: "post",
    onSubmit: B2BProposalPdfDownloadButton_handleSubmit(proposal, appContext, router, dispatch, track)
  }, __jsx("input", {
    type: "hidden",
    name: "proposalId",
    value: proposal.id
  }), __jsx("input", {
    type: "hidden",
    name: "filename",
    value: filename
  }), __jsx("input", {
    type: "hidden",
    name: "x-api-key",
    value: apiKey
  }), __jsx("input", {
    type: "hidden",
    name: "type",
    value: "attachment"
  }), __jsx("input", {
    type: "hidden",
    name: "downloadType",
    value: "attachment"
  }), __jsx(Button["a" /* Button */], {
    colorBg: colors["a" /* COLORS */].TURQUOISE,
    className: "rounded-5",
    type: "submit",
    size: "mediumLarge"
  }, __jsx("span", {
    className: "px-4 text-16"
  }, Object(i18n["h" /* t */])('seller.downloadPdf.downloadPDF'))))))));
};

var B2BProposalPdfDownloadButton_B2BProposalPdfDownloadButton = function B2BProposalPdfDownloadButton(props) {
  var proposal = props.proposal,
      resort = props.resort;

  var _useState = Object(react["useState"])(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var router = Object(next_router["useRouter"])();
  var dispatch = Object(es["d" /* useDispatch */])();
  var track = Object(useTracking["a" /* useTracking */])(_objectSpread(_objectSpread({}, booking_constants["c" /* BE_GA_DEFAULT_PAYLOAD */]), {}, {
    actionGA: 'banking',
    labelGA: 'CTA_download'
  }));
  var shouldDisplay = (appContext.isDirectCxo || appContext.isIndirectCxo) && !!Object(i18n["d" /* getKeyValue */])('seller.downloadPdf.displayCxo') || appContext.isCmta && !!Object(i18n["d" /* getKeyValue */])('seller.downloadPdf.displayCmta');

  if (!shouldDisplay) {
    return null;
  }

  var filename = getFilename(resort, proposal);
  var apiKey = config_default.a.get('api.seller.api_key');
  var shouldShareProposalByEmail = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.shareProposalByEmail') && appContext.isCxo && appContext.isDirectCxo;

  function onClick(event) {
    if (shouldShareProposalByEmail) {
      event.preventDefault();
      event.stopPropagation();
      setIsOpen(true);
    } else {
      B2BProposalPdfDownloadButton_handleSubmit(proposal, appContext, router, dispatch, track)(event);
    }
  }

  return __jsx(react["Fragment"], null, __jsx("form", {
    action: "/proposal-pdf",
    method: "post",
    onSubmit: onClick
  }, __jsx("input", {
    type: "hidden",
    name: "proposalId",
    value: proposal.id
  }), __jsx("input", {
    type: "hidden",
    name: "filename",
    value: filename
  }), __jsx("input", {
    type: "hidden",
    name: "x-api-key",
    value: apiKey
  }), __jsx("input", {
    type: "hidden",
    name: "type",
    value: "attachment"
  }), __jsx("input", {
    type: "hidden",
    name: "downloadType",
    value: "attachment"
  }), __jsx("button", {
    "data-testid": "pdf-download-button",
    className: classnames_default()('reset-button mx-10 flex flex-col items-center text-12 font-bold text-turquoise'),
    type: "submit"
  }, __jsx(Icon["a" /* Icon */], {
    className: classnames_default()('h-auto'),
    name: icons["a" /* ICONS */].DOWNLOAD,
    width: "1.25rem"
  }), __jsx("span", {
    className: "sr-only md:not-sr-only"
  }, Object(i18n["h" /* t */])('seller.downloadPdf.label')))), isOpen && __jsx(B2BProposalPdfDownloadButton_PdfActionsModal, Object(esm_extends["a" /* default */])({}, props, {
    onClose: function onClose() {
      return setIsOpen(false);
    }
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/header-lite/HeaderLite.jsx





var HeaderLite_jsx = react_default.a.createElement;










var HeaderLite_HeaderLite = function HeaderLite(_ref) {
  var actions = _ref.actions,
      product = _ref.product,
      proposal = _ref.proposal;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var isJoyview = !!(product === null || product === void 0 ? void 0 : product.isJoyview);

  var trackNavigation = function trackNavigation() {
    return trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_HEADER, {
      detail_click: 'back_resort_page'
    });
  }; // Build home URL with locale if not default locale


  var isDefaultLocale = appContext.locale === appContext.defaultLocale;
  var homeUrl = isDefaultLocale ? '/' : new URI_default.a('/').addQuery('locale', appContext.locale).toString();
  return HeaderLite_jsx("header", {
    className: "bg-white",
    role: "banner"
  }, HeaderLite_jsx("div", {
    className: "relative m-auto h-auto max-w-site md:flex md:justify-between lg:h-60"
  }, HeaderLite_jsx("div", {
    className: "relative flex items-center border-b-1 border-grey px-20 py-10 md:border-b-0 md:ps-0"
  }, HeaderLite_jsx(ProductBlockHeader["a" /* ProductBlockHeader */], {
    hasBackIcon: !appContext.isSeller,
    onClick: trackNavigation,
    product: product,
    queryParamsToIgnore: ['proposalIds', 'selectedProposalId', 'fromSearches', 'coderesort'],
    theme: "headerLite"
  })), HeaderLite_jsx("a", {
    rel: "noopener noreferrer",
    className: "absolute left-1/2 top-1/2 hidden -translate-x-1/2 -translate-y-1/2 transform cursor-pointer self-center md:block",
    href: homeUrl
  }, HeaderLite_jsx(Icon["a" /* Icon */], {
    className: isJoyview ? 'text-blueWave' : 'text-black',
    "data-testid": "cm-logo",
    isNotSquare: true,
    name: isJoyview ? icons["a" /* ICONS */].CLUBMED_JOYVIEW : icons["a" /* ICONS */].CLUBMED,
    width: "9.125rem"
  })), HeaderLite_jsx("div", {
    className: "flex items-center justify-between px-20 py-10 md:px-0 md:py-0"
  }, HeaderLite_jsx("p", {
    className: "truncate font-sans text-14 font-bold md:px-20",
    "data-testid": "reference-number"
  }, [Object(i18n["h" /* t */])('common.reference'), proposal.id].join(' ')), HeaderLite_jsx("div", {
    className: "flex border-grey md:items-center md:self-stretch md:border-s-1 md:px-10"
  }, actions.filter(function (action) {
    return action.display;
  }).map(function (_ref2) {
    var iconName = _ref2.iconName,
        id = _ref2.id,
        label = _ref2.label,
        onClick = _ref2.onClick;
    return HeaderLite_jsx("button", {
      className: "mx-10 flex flex-col items-center text-12 font-bold text-black",
      "data-testid": "HeaderLite-action-btn-".concat(label),
      key: id,
      onClick: onClick,
      type: "button"
    }, HeaderLite_jsx(Icon["a" /* Icon */], {
      className: "h-auto",
      name: iconName,
      width: "1.25rem"
    }), HeaderLite_jsx("span", {
      className: "sr-only md:not-sr-only"
    }, label));
  }), HeaderLite_jsx(B2BProposalPdfDownloadButton_B2BProposalPdfDownloadButton, {
    proposal: proposal,
    resort: product
  })))));
};

/***/ }),

/***/ "Xvk6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_STREET_VIEWS_BY_ACCOMMODATION_CATEGORY_ID; });
var FETCH_STREET_VIEWS_BY_ACCOMMODATION_CATEGORY_ID = 'FETCH_STREET_VIEWS_BY_ACCOMMODATION_CATEGORY_ID';

/***/ }),

/***/ "Z/bG":
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__("gAMm"),
    func = convert('flatten', __webpack_require__("1xil"), __webpack_require__("zUlE"));

func.placeholder = __webpack_require__("VDAD");
module.exports = func;


/***/ }),

/***/ "Z0Tt":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("1Ll7");


/***/ }),

/***/ "Z2QO":
/***/ (function(module, exports, __webpack_require__) {

if (true) {
    module.exports = __webpack_require__("5WMi");
} else {}


/***/ }),

/***/ "ZS6v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductPriceInfo; });
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("SPKZ");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("kiXb");
/* harmony import */ var _frameworks_button_Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("e0Ti");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("qBqs");
/* harmony import */ var _frameworks_text_Text__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("qqKu");
/* harmony import */ var _rate_messages_RateMessages_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("tuzA");
/* harmony import */ var _context_PageContext__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("EkOT");

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;









var ProductPriceInfo = function ProductPriceInfo(_ref) {
  var city = _ref.city,
      endDate = _ref.endDate,
      hasTransport = _ref.hasTransport,
      isCruise = _ref.isCruise,
      isJoyview = _ref.isJoyview,
      isTour = _ref.isTour,
      onClick = _ref.onClick,
      _ref$rate = _ref.rate,
      rate = _ref$rate === void 0 ? '' : _ref$rate,
      startDate = _ref.startDate,
      unit = _ref.unit;

  var _usePageContext = Object(_context_PageContext__WEBPACK_IMPORTED_MODULE_9__[/* usePageContext */ "b"])(),
      pageType = _usePageContext.pageType;

  var isMice = _clubmed_utils__WEBPACK_IMPORTED_MODULE_2__["b2cPagesService"].isMicePage(pageType);
  var isAllInclusive = !isJoyview && !isTour; // eslint-disable-next-line no-nested-ternary

  var buttonLabel = isTour ? Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "h"])('resort.pricePopin.buttonTourLabel') : isCruise ? Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "h"])('resort.pricePopin.buttonCruiseLabel') : Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "h"])('resort.pricePopin.buttonLabel');

  var _getRateMessagesPrope = Object(_rate_messages_RateMessages_utils__WEBPACK_IMPORTED_MODULE_8__[/* getRateMessagesProperties */ "a"])(rate),
      rateContent = _getRateMessagesPrope.rateContent,
      rateTitle = _getRateMessagesPrope.rateTitle; // Display text only in product Thumbnails popin


  var rateObject = onClick ? {
    rateContent: rateContent,
    rateTitle: rateTitle
  } : {};
  return __jsx(react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null, __jsx(_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_7__[/* Text */ "a"], {
    className: "p-20",
    text: isMice ? Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "h"])('resort.pricePopin.startingPriceDescriptionForME', {
      unit: unit
    }) : [hasTransport ? Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "h"])('resort.pricePopin.startingPriceDescriptionWithTransport', {
      unit: unit,
      city: city,
      endDate: endDate,
      startDate: startDate
    }) : Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "h"])('resort.pricePopin.startingPriceDescriptionWithoutTransport', {
      endDate: endDate,
      startDate: startDate,
      unit: unit
    }), Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "h"])('resort.pricePopin.roomAvailability'), rateObject === null || rateObject === void 0 ? void 0 : rateObject.rateTitle, rateObject === null || rateObject === void 0 ? void 0 : rateObject.rateContent].join(' '),
    theme: "text-sans-n2"
  }), (isAllInclusive || isJoyview || onClick) && __jsx("div", {
    className: "flex flex-col items-center border-t-1 border-lightGrey p-20"
  }, isAllInclusive && __jsx("p", {
    className: "flex max-w-full flex-col gap-5 text-center text-12 text-black sm:flex-row sm:flex-wrap sm:items-center sm:justify-center"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "h"])('resort.pricePopin.priceIsLabel'), ' ', __jsx("span", {
    className: "flex items-center gap-5 font-brand text-16 text-sienna"
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_6__[/* Icon */ "a"], {
    className: "text-sienna",
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__[/* ICONS */ "a"].ALL_INCLUSIVE,
    width: "1.2rem"
  }), Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "h"])('resort.startingPrice.allInclusive'))), isJoyview && __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_6__[/* Icon */ "a"], {
    className: "-mt-5 text-blueWave",
    isNotSquare: true,
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__[/* ICONS */ "a"].CLUBMED_JOYVIEW,
    width: "10rem"
  }), onClick && __jsx(_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_5__[/* Button */ "a"], {
    className: "mt-10",
    "data-testid": "ProductPriceInfo-button",
    onClick: onClick
  }, buttonLabel)));
};

/***/ }),

/***/ "ZpYc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ StripButton_StripButton; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// CONCATENATED MODULE: ./src/client/components/frameworks/strip-button/StripButton.themes.js

var themes = function themes(_ref) {
  var color = _ref.color,
      colorBorder = _ref.colorBorder,
      orientation = _ref.orientation;
  return {
    "default": {
      thRoot: 'flex ltr:flex-row rtl:flex-row-reverse relative',
      thInner: "bg-".concat(color, " border-").concat(orientation === 'top' ? 't' : 'b', "-1 border-").concat(colorBorder, " -m").concat(orientation === 'top' ? 'x' : '', "-1 overflow-hidden px-5 p").concat(orientation === 'top' ? 't' : 'b', "-5 text-center whitespace-nowrap")
    }
  };
};
// CONCATENATED MODULE: ./src/client/components/frameworks/strip-button/StripButton.jsx

var __jsx = react_default.a.createElement;





var StripButton_StripButtonSvg = function StripButtonSvg(_ref) {
  var className = _ref.className,
      color = _ref.color,
      colorBorder = _ref.colorBorder,
      height = _ref.height,
      hasBottomOrientation = _ref.hasBottomOrientation;
  return __jsx("svg", {
    className: Object(classnames_utils["a" /* classnames */])('fill-current', "text-".concat(color), className),
    viewBox: "0 0 15 30",
    height: height,
    style: {
      flexBasis: height / 2
    }
  }, __jsx("g", null, __jsx("g", {
    transform: "translate(-61.000000, ".concat(hasBottomOrientation ? -155.5 : -156.5, ")")
  }, __jsx("g", {
    transform: "translate(66.000000, 166.000000)"
  }, __jsx("g", null, __jsx("g", null, __jsx("path", {
    d: "M10,21H-5L2.8-3.6C3.9-6.8,6.8-9,10-9"
  })))))), __jsx("g", null, __jsx("g", {
    transform: "translate(-61.000000, ".concat(hasBottomOrientation ? -155.5 : -156.5, ")")
  }, __jsx("g", {
    transform: "translate(66.000000, 166.000000)"
  }, __jsx("g", null, __jsx("g", null, __jsx("path", {
    style: {
      strokeWidth: '1px'
    },
    className: "fill-transparent stroke-current text-".concat(colorBorder),
    d: "M-5,21L2.8-3.6C3.9-6.8,6.8-9,10-9"
  })))))));
};

var StripButton_StripButton = function StripButton(_ref2) {
  var children = _ref2.children,
      className = _ref2.className,
      _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? colors["a" /* COLORS */].WHITE : _ref2$color,
      _ref2$colorBorder = _ref2.colorBorder,
      colorBorder = _ref2$colorBorder === void 0 ? colors["a" /* COLORS */].LIGHT_GREY : _ref2$colorBorder,
      _ref2$dataTestId = _ref2.dataTestId,
      dataTestId = _ref2$dataTestId === void 0 ? 'strip-button' : _ref2$dataTestId,
      _ref2$height = _ref2.height,
      height = _ref2$height === void 0 ? 30 : _ref2$height,
      onClick = _ref2.onClick,
      _ref2$orientation = _ref2.orientation,
      orientation = _ref2$orientation === void 0 ? 'top' : _ref2$orientation,
      _ref2$theme = _ref2.theme,
      theme = _ref2$theme === void 0 ? 'default' : _ref2$theme;

  if (!react["Children"].count(children)) {
    return null;
  }

  var _themes$theme = themes({
    color: color,
    colorBorder: colorBorder,
    onClick: onClick,
    orientation: orientation
  })[theme],
      thInner = _themes$theme.thInner,
      thRoot = _themes$theme.thRoot;
  var hasBottomOrientation = orientation === 'bottom';
  var svgProps = {
    color: color,
    colorBorder: colorBorder,
    height: height,
    hasBottomOrientation: hasBottomOrientation
  };
  var TagName = onClick ? 'button' : 'div';
  var btnProps = onClick ? {
    onClick: onClick,
    type: 'button'
  } : null;
  return __jsx(TagName, Object(esm_extends["a" /* default */])({
    className: Object(classnames_utils["a" /* classnames */])(thRoot, className),
    "data-testid": dataTestId
  }, btnProps), __jsx(StripButton_StripButtonSvg, Object(esm_extends["a" /* default */])({
    className: Object(classnames_utils["a" /* classnames */])('transform', {
      '-scale-y-1': hasBottomOrientation
    })
  }, svgProps)), __jsx("span", {
    className: thInner,
    style: {
      height: height
    }
  }, children), __jsx(StripButton_StripButtonSvg, Object(esm_extends["a" /* default */])({
    className: Object(classnames_utils["a" /* classnames */])('-scale-x-1 transform', {
      '-scale-y-1': hasBottomOrientation
    })
  }, svgProps)));
};

/***/ }),

/***/ "aGPO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Paginate_Paginate; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("M+/F");

// CONCATENATED MODULE: ./src/hooks/use-paginate/usePaginate.js


var usePaginate_usePaginate = function usePaginate(_ref) {
  var _ref$iterationNumber = _ref.iterationNumber,
      iterationNumber = _ref$iterationNumber === void 0 ? 5 : _ref$iterationNumber,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      _ref$forceInitialShow = _ref.forceInitialShowingItemsNumber,
      forceInitialShowingItemsNumber = _ref$forceInitialShow === void 0 ? 0 : _ref$forceInitialShow;
  var totalOfItems = items.length;

  var _useReducer = Object(react["useReducer"])(function (state) {
    var newNumberOfItemsToShow = state + iterationNumber;
    return newNumberOfItemsToShow > totalOfItems ? totalOfItems : newNumberOfItemsToShow;
  }, iterationNumber),
      showThisNumberOfItems = _useReducer[0],
      setShowThisNumberOfItems = _useReducer[1];

  var forcedOrNotShowingItemNumber = forceInitialShowingItemsNumber || showThisNumberOfItems;
  var itemsToShow = items.slice(0, forcedOrNotShowingItemNumber);
  var itemsShowing = forcedOrNotShowingItemNumber < totalOfItems ? forcedOrNotShowingItemNumber : totalOfItems;
  return {
    paginatedItems: itemsToShow,
    totalOfItems: totalOfItems,
    itemsShowing: itemsShowing,
    seeMoreAction: setShowThisNumberOfItems,
    shouldShowSeeMore: totalOfItems > itemsToShow.length
  };
};
// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/progress-bar/ProgressBar.jsx + 1 modules
var ProgressBar = __webpack_require__("woxT");

// CONCATENATED MODULE: ./src/client/components/widgets/paginate/Paginate.jsx
var __jsx = react_default.a.createElement;





var Paginate_Paginate = function Paginate(_ref) {
  var children = _ref.children,
      forceInitialShowingItemsNumber = _ref.forceInitialShowingItemsNumber,
      iterationNumber = _ref.iterationNumber,
      onClick = _ref.onClick,
      seeMoreLabel = _ref.seeMoreLabel,
      setForceInitialShowingItemsNumber = _ref.setForceInitialShowingItemsNumber;

  var _usePaginate = usePaginate_usePaginate({
    forceInitialShowingItemsNumber: forceInitialShowingItemsNumber,
    items: children,
    iterationNumber: iterationNumber
  }),
      paginatedItems = _usePaginate.paginatedItems,
      itemsShowing = _usePaginate.itemsShowing,
      totalOfItems = _usePaginate.totalOfItems,
      seeMoreAction = _usePaginate.seeMoreAction,
      shouldShowSeeMore = _usePaginate.shouldShowSeeMore;

  var onClickHandler = function onClickHandler() {
    seeMoreAction();
    onClick === null || onClick === void 0 ? void 0 : onClick();
    setForceInitialShowingItemsNumber === null || setForceInitialShowingItemsNumber === void 0 ? void 0 : setForceInitialShowingItemsNumber(forceInitialShowingItemsNumber + iterationNumber);
  };

  return __jsx(react["Fragment"], null, paginatedItems, shouldShowSeeMore && __jsx("div", {
    className: "mt-20 text-center",
    "data-testid": "paginated-seeMoreBlock"
  }, __jsx("p", {
    className: "mb-10 text-14 text-black"
  }, Object(i18n["h" /* t */])('booking.accommodation.moreRooms.numberOfProposalsSeen', {
    number: itemsShowing,
    totalProposalsNumber: totalOfItems
  })), __jsx(ProgressBar["a" /* ProgressBar */], {
    className: "mx-auto mb-20 w-180 bg-lightSand",
    min: 0,
    max: 100,
    value: itemsShowing / totalOfItems * 100
  }), __jsx(Button["a" /* Button */], {
    onClick: onClickHandler,
    size: "medium"
  }, seeMoreLabel)));
};

/***/ }),

/***/ "b0q8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.resolve = resolve;
exports.reject = reject;
exports.unresolve = unresolve;
exports.unreject = unreject;
exports.isResolvedAction = isResolvedAction;
exports.isRejectedAction = isRejectedAction;
exports.isThenAction = isThenAction;
exports.default = optimistPromiseMiddleware;

var _fluxStandardAction = __webpack_require__("8soX");

function isPromise(val) {
  return val && typeof val.then === 'function';
}

var RESOLVED_NAME = '_RESOLVED',
    REJECTED_NAME = '_REJECTED';

var BEGIN = 'BEGIN';
var COMMIT = 'COMMIT';
var REVERT = 'REVERT';

function resolve(actionName) {
  return actionName + RESOLVED_NAME;
}

function reject(actionName) {
  return actionName + REJECTED_NAME;
}

function unresolve(resolvedActionName) {
  return resolvedActionName.split(RESOLVED_NAME)[0];
}

function unreject(rejectedActionName) {
  return rejectedActionName.split(REJECTED_NAME)[0];
}

function isResolvedAction(resolvedActionName) {
  return unresolve(resolvedActionName) !== resolvedActionName;
}

function isRejectedAction(rejectedActionName) {
  return unreject(rejectedActionName) !== rejectedActionName;
}

function isThenAction(thenActionName) {
  return isResolvedAction(thenActionName) || isRejectedAction(thenActionName);
}

function optimistPromiseMiddleware() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$throwOnReject = _ref.throwOnReject,
      throwOnReject = _ref$throwOnReject === undefined ? true : _ref$throwOnReject,
      _ref$resolvedName = _ref.resolvedName,
      resolvedName = _ref$resolvedName === undefined ? RESOLVED_NAME : _ref$resolvedName,
      _ref$rejectedName = _ref.rejectedName,
      rejectedName = _ref$rejectedName === undefined ? REJECTED_NAME : _ref$rejectedName;

  RESOLVED_NAME = resolvedName;
  REJECTED_NAME = rejectedName;

  var nextTransactionID = 0;
  return function (_ref2) {
    var dispatch = _ref2.dispatch;
    return function (next) {
      return function (action) {
        if (!(0, _fluxStandardAction.isFSA)(action) || !action.meta || !isPromise(action.meta.promise)) {
          return next(action);
        }

        var isOptimist = action.meta.optimist;

        var transactionID = void 0;

        if (isOptimist) {
          transactionID = nextTransactionID++;
        }

        // (1) Dispatch actionName with meta with arguments apart from promise

        // Clone original action
        var newAction = _extends({}, action, {
          meta: _extends({}, action.meta)
        });

        if (isOptimist) {
          // Adding optimistic meta
          newAction.optimist = { type: BEGIN, id: transactionID };
          delete newAction.meta.optimist;
        }

        if (Object.keys(newAction.meta).length === 1) {
          delete newAction.meta;
        } else {
          // Other arguments, delete promise and optimist only
          delete newAction.meta.promise;
        }

        var skipOptimist = action.meta.skipOptimist;

        if (!skipOptimist) {
          next(newAction);
        }

        // Create a base for the next action containing the metadata.
        var nextActionBase = {
          meta: _extends({}, newAction.meta, {
            payload: newAction.payload
          })
        };

        if (!nextActionBase.meta.payload) {
          // No payload, no need to include them in the meta.
          delete nextActionBase.meta.payload;
        }
        if (Object.keys(nextActionBase.meta).length === 0) {
          // No meta was included either, remove all meta.
          delete nextActionBase.meta;
        }

        // (2) Listen to promise and dispatch payload with new actionName
        return action.meta.promise.then(function (result) {
          var actionToDispatch = _extends({
            type: resolve(action.type),
            payload: result
          }, nextActionBase);
          if (isOptimist) {
            actionToDispatch.optimist = { type: COMMIT, id: transactionID };
          }
          dispatch(actionToDispatch);
          return result;
        }).catch(function (error) {
          var actionToDispatch = _extends({
            type: reject(action.type),
            payload: error
          }, nextActionBase);
          if (isOptimist) {
            actionToDispatch.optimist = { type: REVERT, id: transactionID };
          }
          dispatch(actionToDispatch);
          if (throwOnReject) {
            throw error;
          }
        });
      };
    };
  };
}

/***/ }),

/***/ "b45f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GreatMembersLoyaltyPoints; });
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("qBqs");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("SPKZ");
/* harmony import */ var _context_ReactAppContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("Ub5k");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("L7OA");
var __jsx = react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement;






var GreatMembersLoyaltyPoints = function GreatMembersLoyaltyPoints(_ref) {
  var loyaltyPoints = _ref.loyaltyPoints,
      _ref$dataTestId = _ref.dataTestId,
      dataTestId = _ref$dataTestId === void 0 ? 'greatMembersLoyaltyPoints' : _ref$dataTestId;
  var appContext = Object(_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_2__[/* useAppContext */ "c"])();
  var isActive = Object(_utils_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_5__[/* isFeatureFlipped */ "a"])(appContext)('booking.displayGreatMembers');

  if (!isActive || !loyaltyPoints) {
    return null;
  }

  return __jsx("div", {
    className: "flex w-full flex-col rounded-12 bg-pearl p-20 md:flex-row md:p-30",
    "data-testid": dataTestId
  }, __jsx("div", {
    className: "order-3 md:order-3 p-4 flex w-full flex-1 justify-center md:w-auto md:flex-none"
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_0__[/* Icon */ "a"], {
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].CLUBMED_GREAT_MEMBER_NEW,
    height: "6.25rem",
    width: "6.25rem",
    isNotMonoChrome: true
  })), __jsx("div", {
    className: "p-4 order-2 flex flex-1 flex-col items-center justify-center md:order-1 md:flex-2 md:items-baseline md:self-start md:px-30"
  }, __jsx("span", {
    className: "text-14 font-bold text-black md:text-16"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "h"])('booking.priceDetails.greatMembers.title')), __jsx("div", {
    className: "flex flex-col justify-center p-10"
  }, __jsx("ul", {
    className: "list-none"
  }, __jsx("li", {
    className: "list-disc"
  }, __jsx("span", {
    className: "text-14 text-black md:text-16"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "h"])('booking.priceDetails.greatMembers.label1'))), __jsx("li", {
    className: "list-disc"
  }, __jsx("span", {
    className: "text-14 text-black md:text-16"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "h"])('booking.priceDetails.greatMembers.label2')))))), __jsx("div", {
    className: "p-4 order-1 w-fit justify-center self-center md:order-2 md:self-start md:py-0"
  }, __jsx("div", {
    className: "flex w-fit rounded-pill bg-ultramarine px-10"
  }, __jsx("span", {
    className: "p-5 text-14 font-bold text-white md:text-16"
  }, "".concat(Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "h"])('booking.priceDetails.greatMembers.loyaltyPoints', {
    points: loyaltyPoints
  }))))));
};

/***/ }),

/***/ "cN29":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return themes; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("UCZK");




var themes = function themes(_ref) {
  var color = _ref.color;
  var rColor = _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS_LIST */ "b"].includes(color) ? color : _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].TURQUOISE;
  var thDescriptionBloc = "bg-".concat(rColor, " px-5 flex flex-col grow sm:grow-0 justify-center pe-10 rounded-4 text-").concat(_utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COMPLEMENTARY_COLORS */ "c"][rColor], " w-auto");
  var thPopinContent = "border-1 border-".concat(rColor, " lg:border-0 flex flex-col");
  return {
    "default": {
      thDescriptionBloc: thDescriptionBloc,
      thPopinContent: "".concat(thPopinContent, " lg:flex-row"),
      thPopinContentImage: 'shrink-0 px-20 pt-20 lg:ps-20 lg:pe-0 lg:py-15',
      thPopinColor: rColor,
      thPopinTextColor: _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COMPLEMENTARY_COLORS */ "c"][rColor]
    },
    comparator: {
      thDescriptionBloc: "".concat(thDescriptionBloc, " sm:w-full"),
      thPopinContent: thPopinContent,
      thPopinContentImage: 'shrink-0 lg:ps-10 lg:py-10 mt-15',
      thPopinColor: rColor,
      thPopinTextColor: _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COMPLEMENTARY_COLORS */ "c"][rColor]
    }
  };
};

/***/ }),

/***/ "dAFS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isAreaExclusiveCollection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getResortDistrictQuery; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);

var isAreaExclusiveCollection = function isAreaExclusiveCollection(area) {
  var _area$comfort, _area$comfort2;

  return ((_area$comfort = area.comfort) === null || _area$comfort === void 0 ? void 0 : _area$comfort.id) === 'area_comfort_level_5_tridents' || ((_area$comfort2 = area.comfort) === null || _area$comfort2 === void 0 ? void 0 : _area$comfort2.id) === 'area_comfort_level_villas_and_chalets';
};
var getResortDistrictQuery = function getResortDistrictQuery(resortId) {
  return "query {\n  pickYourRoom {\n    resortSettings(resortId : \"".concat(resortId, "\") {\n      initialViewport { ...viewPort }\n      targetViewport { ...viewPort }\n      maxBounds { minLon maxLon minLat maxLat minZoom maxZoom }\n    }\n  }\n  resortAreas(resortId: \"").concat(resortId, "\") {\n    areas {\n      associatedAccess {\n        id\n        label\n      }\n      description\n      id\n      images\n      label\n      comfort {\n        id\n      }\n      shortDescription\n    }\n    geoData(resortId: \"").concat(resortId, "\") {\n      areas {\n        id\n        label\n        pickable\n      }\n      areas_geo_json {\n        features {\n          geometry {\n            coordinates\n            type\n          }\n          properties {\n            area_id: id\n          }\n          type\n        }\n        type\n      }\n      areas_center_geo_json {\n        features {\n          geometry {\n            coordinates\n            type\n          }\n          properties {\n            area_id: id\n          }\n          type\n        }\n        type\n      }\n    }\n  }\n}\n    \nfragment viewPort on ViewportType {\n  latitude\n  longitude\n  zoom\n  bearing\n  pitch\n}");
};

/***/ }),

/***/ "dATv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ BookingFooter_BookingFooter; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("KqXw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("MvUL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: /opt/webapp/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// CONCATENATED MODULE: ./src/client/components/utils/booking-footer/bookingFooter.utils.js











function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}


var mapFooterIconsToContactsBarTypes = {
  callMeBack: 'phone',
  phoneBubble: 'phone',
  storeLocator: 'storeLocator',
  faq: 'askQuestions',
  termsAndConditions: 'warning',
  mobileApp: 'smartphone',
  mail: 'mail'
};
var bookingFooter_utils_getDetailClickEventTrackingData = function getDetailClickEventTrackingData(type, href) {
  var _href$hostname, _href$hostname$call;

  var eventClick = _objectSpread({}, constants["k" /* EVENT_CLICK */]);

  var isWhatsapp = href === null || href === void 0 ? void 0 : (_href$hostname = href.hostname) === null || _href$hostname === void 0 ? void 0 : (_href$hostname$call = _href$hostname.call(href)) === null || _href$hostname$call === void 0 ? void 0 : _href$hostname$call.includes('whatsapp');
  eventClick.callMeBack = isWhatsapp ? constants["d" /* CALLMEBACK_EVENT */].whatsapp : constants["d" /* CALLMEBACK_EVENT */].phone;
  return eventClick[type];
};
// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTrackEvent.js
var useTrackEvent = __webpack_require__("DqI1");

// CONCATENATED MODULE: ./src/client/components/widgets/booking-footer/BookingFooterItem.jsx

var __jsx = react_default.a.createElement;







var BookingFooterItem_BookingFooterItem = function BookingFooterItem(_ref) {
  var href = _ref.href,
      text = _ref.text,
      type = _ref.type;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  return __jsx("a", {
    className: "flex flex-col items-center text-center",
    "data-testid": "BookingFooterItem-".concat(type),
    target: "_blank",
    rel: "noopener noreferrer",
    href: href,
    onClick: function onClick() {
      var detailClick = bookingFooter_utils_getDetailClickEventTrackingData(type, href);
      trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_FOOTER, {
        detail_click: detailClick
      });
    }
  }, __jsx(Icon["a" /* Icon */], {
    name: (mapFooterIconsToContactsBarTypes === null || mapFooterIconsToContactsBarTypes === void 0 ? void 0 : mapFooterIconsToContactsBarTypes[type]) || icons["a" /* ICONS */].WARNING,
    width: "1.4375rem",
    className: "m-15",
    dataTestid: "BookingFooterItem-icon"
  }), text.map(function (txt, index) {
    return __jsx("p", {
      key: txt[index],
      className: Object(classnames_utils["a" /* classnames */])('text-14', {
        'font-bold': index === 0
      }, {
        'mb-10': index !== 0
      })
    }, txt);
  }));
};
// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// CONCATENATED MODULE: ./src/client/components/widgets/booking-footer/BookingFooter.jsx













var BookingFooter_jsx = react_default.a.createElement;

function BookingFooter_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function BookingFooter_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { BookingFooter_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { BookingFooter_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var BookingFooter_BookingFooter = function BookingFooter(_ref) {
  var _footer$contactsBarBE;

  var footer = _ref.footer,
      className = _ref.className;

  var _useAppContext = Object(ReactAppContext["c" /* useAppContext */])(),
      locale = _useAppContext.locale; // we add number phone callCenter to link on click booking.callCenterPopIn.number


  var completedItemsFooter = (_footer$contactsBarBE = footer.contactsBarBE) === null || _footer$contactsBarBE === void 0 ? void 0 : _footer$contactsBarBE.map(function (item) {
    // phone number link
    if (item.href === '' && item.type === 'callMeBack') {
      return BookingFooter_objectSpread(BookingFooter_objectSpread({}, item), {}, {
        href: 'tel://' + Object(i18n["h" /* t */])('booking.callCenterPopIn.number').replace(/\s+/g, '')
      });
    } // store Locator link


    if (item.type === 'storeLocator') {
      return item;
    } // other links with locale


    return BookingFooter_objectSpread(BookingFooter_objectSpread({}, item), {}, {
      href: new URI_default.a(item.href).addQuery('locale', locale)
    });
  }); // for now the maximum active class in tailwind grid column is grid-cols-6
  // so if we have 0 or > 6 items we will use 6 columns which is the maximum
  // doesn't seem to work with media queries so ...

  var MAX_ITEMS_FOR_GRID_CSS = 6;
  var nbItems = completedItemsFooter === null || completedItemsFooter === void 0 ? void 0 : completedItemsFooter.length;
  var numberOfItemsMax6 = nbItems <= MAX_ITEMS_FOR_GRID_CSS ? nbItems : MAX_ITEMS_FOR_GRID_CSS;
  var gridClassDynamic = "md:grid-cols-".concat(numberOfItemsMax6);

  if (!completedItemsFooter) {
    return null;
  }

  return BookingFooter_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('w-ful flex items-center justify-center border-t-1', className)
  }, BookingFooter_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('grid grid-cols-2 items-start gap-20 p-20 md:w-1/2', gridClassDynamic)
  }, completedItemsFooter.map(function (footerItem, index) {
    var _completedItemsFooter;

    return BookingFooter_jsx(BookingFooterItem_BookingFooterItem, Object(esm_extends["a" /* default */])({
      key: "".concat((_completedItemsFooter = completedItemsFooter[index]) === null || _completedItemsFooter === void 0 ? void 0 : _completedItemsFooter.type, "-").concat(index * 2)
    }, footerItem));
  })));
};

/***/ }),

/***/ "dGyR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_TRAVEL_COMPANION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EDIT_TRAVEL_COMPANION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SELECT_TRAVEL_COMPANION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UNSELECT_TRAVEL_COMPANION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return travelCompanionReducer; });
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("vfdX");
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("Ee2X");
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _components_widgets_contact_info_ContactInfoUtils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("ZHrn");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("b0q8");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _proposals_constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("UIAR");









var ADD_TRAVEL_COMPANION = 'ADD_TRAVEL_COMPANION';
var EDIT_TRAVEL_COMPANION = 'EDIT_TRAVEL_COMPANION';
var SELECT_TRAVEL_COMPANION = 'SELECT_TRAVEL_COMPANION';
var UNSELECT_TRAVEL_COMPANION = 'UNSELECT_TRAVEL_COMPANION';
var initialState = {
  list: [],
  selectedIndexes: []
};
var travelCompanionReducer = function travelCompanionReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_7__["resolve"])(_proposals_constants__WEBPACK_IMPORTED_MODULE_8__[/* FETCH_PROPOSALS_BY_ID */ "n"]):
    case Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_7__["resolve"])(_proposals_constants__WEBPACK_IMPORTED_MODULE_8__[/* FETCH_PROPOSALS */ "m"]):
    case Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_7__["resolve"])(_proposals_constants__WEBPACK_IMPORTED_MODULE_8__[/* FETCH_PROPOSALS_FROM_EDIT_CRITERIA */ "o"]):
      {
        var attendees = lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(action, 'payload.proposals.proposals.0.attendees', {});

        var _filterSearchedChildr = Object(_components_widgets_contact_info_ContactInfoUtils__WEBPACK_IMPORTED_MODULE_6__[/* filterSearchedChildren */ "b"])(lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(action, 'payload.profile.travelCompanions', []), attendees),
            travelCompanions = _filterSearchedChildr.travelCompanions,
            selectedIndexes = _filterSearchedChildr.selectedIndexes;

        return {
          list: travelCompanions || [],
          selectedIndexes: selectedIndexes || []
        };
      }

    case ADD_TRAVEL_COMPANION:
      state.list.push(action.payload);
      return state;

    case EDIT_TRAVEL_COMPANION:
      var editedCompanionIndex = state.list.findIndex(function (_ref) {
        var companionId = _ref.companionId;
        return companionId === action.payload.companionId;
      });
      state.list[editedCompanionIndex] = action.payload;
      return state;

    case SELECT_TRAVEL_COMPANION:
      var selectedCompanionIndex = state.list.findIndex(function (_ref2) {
        var companionId = _ref2.companionId;
        return companionId === action.payload.companionId;
      });
      state.list[selectedCompanionIndex].isSelected = true;
      var parentIndex = action.payload.parentIndex;

      if (!state.selectedIndexes.map(function (_ref3) {
        var index = _ref3.index;
        return index;
      }).includes(parentIndex)) {
        state.selectedIndexes.push({
          index: parentIndex,
          position: action.payload.position
        });
      }

      return state;

    case UNSELECT_TRAVEL_COMPANION:
      var unselectedCompanionIndex = state.list.findIndex(function (_ref4) {
        var companionId = _ref4.companionId;
        return companionId === action.payload.companionId;
      });
      var unselectedParentIndex = state.selectedIndexes.findIndex(function (_ref5) {
        var index = _ref5.index,
            position = _ref5.position;
        return position === action.payload.position && index === action.payload.parentIndex;
      });
      state.list[unselectedCompanionIndex].isSelected = false;

      if (unselectedParentIndex !== -1) {
        state.selectedIndexes.splice(unselectedParentIndex, 1);
      }

      return state;

    default:
      return state;
  }
};

/***/ }),

/***/ "dLd+":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("ax0f");
var parseInt = __webpack_require__("QkOM");

// `Number.parseInt` method
// https://tc39.es/ecma262/#sec-number.parseint
// eslint-disable-next-line es/no-number-parseint -- required for testing
$({ target: 'Number', stat: true, forced: Number.parseInt != parseInt }, {
  parseInt: parseInt
});


/***/ }),

/***/ "eYK6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("lozs");


/***/ }),

/***/ "fXWa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TRACK_BE_EVENT_GA_ACTIVITIES; });
/* unused harmony export TRACK_BE_EVENT_GA_CHILDCARE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TRACK_CLICK_EVENT_BE_RENTALS; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("zjfJ");
/* harmony import */ var _events_trackings__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("Gh9m");
/* harmony import */ var _views_booking_constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("taV1");









function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}



var TRACK_BE_EVENT_GA_ACTIVITIES = _objectSpread(_objectSpread({}, _views_booking_constants__WEBPACK_IMPORTED_MODULE_9__[/* BE_GA_DEFAULT_PAYLOAD */ "c"]), {}, {
  actionGA: 'activities'
});
var TRACK_BE_EVENT_GA_CHILDCARE = _objectSpread(_objectSpread({}, _views_booking_constants__WEBPACK_IMPORTED_MODULE_9__[/* BE_GA_DEFAULT_PAYLOAD */ "c"]), {}, {
  actionGA: 'childcare'
});
var TRACK_CLICK_EVENT_BE_RENTALS = _objectSpread(_objectSpread({}, _views_booking_constants__WEBPACK_IMPORTED_MODULE_9__[/* BE_GA_DEFAULT_PAYLOAD */ "c"]), _events_trackings__WEBPACK_IMPORTED_MODULE_8__[/* TRACK_CLICK_EVENT_UPSELL_RENTALS_DETAIL */ "a"]);

/***/ }),

/***/ "hfZn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ABTestContext; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

var ABTestContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createContext({});

/***/ }),

/***/ "idSt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ BookingLayout_BookingLayout; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTrackEvent.js
var useTrackEvent = __webpack_require__("DqI1");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/client/components/frameworks/portal/Portal.constants.js
var Portal_constants = __webpack_require__("Yd/I");

// EXTERNAL MODULE: ./src/client/components/utils/booking/bookingUtils.js + 1 modules
var bookingUtils = __webpack_require__("aWOT");

// EXTERNAL MODULE: ./src/client/components/utils/booking/booking-additional-services/BookingAddtionalServices.utils.js
var BookingAddtionalServices_utils = __webpack_require__("JOeK");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/context/ActivitiesContext.js
var ActivitiesContext = __webpack_require__("76OQ");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/hooks/use-previous/usePrevious.js
var usePrevious = __webpack_require__("AbLU");

// EXTERNAL MODULE: ./src/i18n.js
var src_i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/store/booking/booking.selector.js
var booking_selector = __webpack_require__("uL19");

// EXTERNAL MODULE: ./src/client/store/booking/proposals/proposals.action.js + 2 modules
var proposals_action = __webpack_require__("AnR0");

// EXTERNAL MODULE: ./src/client/tracking/events/be.tracking.js
var be_tracking = __webpack_require__("fXWa");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/widgets/accommodation-summary/AccommodationSummary.jsx
var AccommodationSummary = __webpack_require__("g5cf");

// EXTERNAL MODULE: ./src/client/components/widgets/bottom-navbar-layer/BottomNavbarLayer.jsx + 2 modules
var BottomNavbarLayer = __webpack_require__("Dz6/");

// EXTERNAL MODULE: ./src/client/components/widgets/reserved-services-wrapper/ReservedServicesList.jsx + 3 modules
var ReservedServicesList = __webpack_require__("toM8");

// EXTERNAL MODULE: ./src/client/views/booking/summary/SummaryView.utils.js
var SummaryView_utils = __webpack_require__("X3Cs");

// EXTERNAL MODULE: ./src/client/components/widgets/promo-code/PromoCode.jsx + 2 modules
var PromoCode = __webpack_require__("mCPI");

// EXTERNAL MODULE: ./src/client/components/widgets/promo-code/DiscountsLine.jsx
var DiscountsLine = __webpack_require__("CYED");

// EXTERNAL MODULE: ./src/client/components/widgets/accordion-block/AccordionBlock.jsx
var AccordionBlock = __webpack_require__("sORq");

// EXTERNAL MODULE: ./src/client/components/widgets/bottom-navbar-layer/PriceTicketFavorite.jsx
var PriceTicketFavorite = __webpack_require__("CvKO");

// EXTERNAL MODULE: ./src/client/components/widgets/bottom-navbar-layer/BottomNavbarTotalPrice.jsx
var BottomNavbarTotalPrice = __webpack_require__("EceG");

// EXTERNAL MODULE: ./src/client/components/widgets/bottom-navbar-layer/SelectedRate.jsx
var SelectedRate = __webpack_require__("sEDY");

// EXTERNAL MODULE: ./src/client/components/widgets/price-detail-block-lines/PriceDetailLines.jsx
var PriceDetailLines = __webpack_require__("y0X/");

// EXTERNAL MODULE: ./src/client/components/utils/price/price.util.js
var price_util = __webpack_require__("NXDx");

// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// EXTERNAL MODULE: ./src/client/components/widgets/payment-info/buy-now-pay-later/BuyNowPayLater.utils.jsx
var BuyNowPayLater_utils = __webpack_require__("AV+p");

// EXTERNAL MODULE: ./src/client/components/widgets/great-members-loyalty-points/GreatMembersLoyaltyPoints.jsx
var GreatMembersLoyaltyPoints = __webpack_require__("b45f");

// EXTERNAL MODULE: ./src/client/components/widgets/payment-info/buy-now-pay-later/BuyNowPayLater.const.jsx + 16 modules
var BuyNowPayLater_const = __webpack_require__("U6Jk");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/components/frameworks/price/Price.jsx + 5 modules
var Price = __webpack_require__("IuYR");

// EXTERNAL MODULE: ./src/client/components/frameworks/badge/Badge.jsx + 1 modules
var Badge = __webpack_require__("VHif");

// CONCATENATED MODULE: ./src/client/components/widgets/booking-bottom-navbar/OptionBlock.jsx
var __jsx = react_default.a.createElement;




var OptionBlock_OptionBlock = function OptionBlock() {
  return __jsx("div", {
    "data-testid": "OptionBlock",
    className: "mb-20 h-full rounded-12 border-1 border-lightGrey bg-white p-20"
  }, __jsx("div", {
    className: "flex items-start gap-20"
  }, __jsx(Badge["a" /* Badge */], {
    className: "size-48 border-lightSand bg-lightSand text-black",
    iconName: icons["a" /* ICONS */].CALENDAR_OPTION,
    variant: "pill"
  }), __jsx("div", {
    className: "text-start"
  }, __jsx("p", {
    className: "text-16 font-semibold leading-normal"
  }, Object(src_i18n["h" /* t */])('booking.priceDetails.optionTitle')), __jsx("p", {
    className: "mt-8 text-14 leading-normal"
  }, Object(src_i18n["h" /* t */])('booking.priceDetails.optionDescription')))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/booking-bottom-navbar/BookingBottomNavbar.jsx









var BookingBottomNavbar_jsx = react_default.a.createElement;








































var FLEX_RATES = dist["constants"].FLEX_RATES,
    _constants$PACKAGES = dist["constants"].PACKAGES,
    JOYVIEW_ALL_INCLUSIVE = _constants$PACKAGES.JOYVIEW_ALL_INCLUSIVE,
    JOYVIEW_FOOD_AND_BEVERAGES = _constants$PACKAGES.JOYVIEW_FOOD_AND_BEVERAGES;

var getTotalRentedServices = function getTotalRentedServices(services) {
  return (services || []).reduce(function (acc, s) {
    return acc + s.rentedServices.length;
  }, 0);
};

var BookingBottomNavbar_BookingBottomNavbar = function BookingBottomNavbar(_ref) {
  var _proposal$price;

  var continueAction = _ref.continueAction,
      hideContinueButton = _ref.hideContinueButton,
      currentPage = _ref.currentPage,
      isDisabled = _ref.isDisabled,
      i18n = _ref.i18n,
      isFavorite = _ref.isFavorite,
      isNextStep = _ref.isNextStep,
      isOnLastPage = _ref.isOnLastPage,
      isPriceLoading = _ref.isPriceLoading,
      navbarRef = _ref.navbarRef,
      continueBtn = _ref.continueBtn,
      noEdit = _ref.noEdit,
      overwriteContinueButton = _ref.overwriteContinueButton,
      _ref$portalPosition = _ref.portalPosition,
      portalPosition = _ref$portalPosition === void 0 ? Portal_constants["c" /* BEFORE_APP */] : _ref$portalPosition,
      previousAction = _ref.previousAction,
      price = _ref.price,
      proposal = _ref.proposal,
      resort = _ref.resort,
      shouldOpenPanel = _ref.shouldOpenPanel,
      closePanel = _ref.closePanel,
      nextPage = _ref.nextPage,
      previousPage = _ref.previousPage,
      _ref$paymentLabel = _ref.paymentLabel,
      paymentLabel = _ref$paymentLabel === void 0 ? Object(src_i18n["h" /* t */])('booking.priceDetails.packagePrice.bookingLabel') : _ref$paymentLabel,
      onClickFavorite = _ref.onClickFavorite;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isAppMounted = _useResponsive.isAppMounted,
      isDesktop = _useResponsive.isDesktop,
      isTablet = _useResponsive.isTablet;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var isMobile = !isTablet;

  var _useState = Object(react["useState"])(false),
      shouldCloseAllLayers = _useState[0],
      setShouldCloseAllLayers = _useState[1];

  var reservedServicesByAttendee = Object(es["e" /* useSelector */])(booking_selector["u" /* getReservedServicesByAttendee */]);
  var layerRef = Object(react["useRef"])();
  var prevServicesLength = Object(usePrevious["a" /* usePrevious */])(getTotalRentedServices(reservedServicesByAttendee));

  var _useState2 = Object(react["useState"])(0),
      addedServicesNumber = _useState2[0],
      setAddedServicesNumber = _useState2[1];

  var priceWithDonation = Object(price_util["c" /* getTotalPriceWithDonation */])(proposal.price, appContext.locale);
  var isJoyview = resort.isJoyview,
      isUrbanOasis = resort.isUrbanOasis;
  var isJoyViewAllInclusive = proposal.packageId === JOYVIEW_ALL_INCLUSIVE && isJoyview;
  var isUrbanOasisAllInclusive = proposal.packageId === JOYVIEW_ALL_INCLUSIVE && isUrbanOasis;
  var isUrbanOasisFoodAndBeverage = proposal.packageId === JOYVIEW_FOOD_AND_BEVERAGES && isUrbanOasis;
  var shouldShowPriceDetails = isJoyViewAllInclusive || isUrbanOasisAllInclusive || !isJoyview && !isUrbanOasis;
  var hasSelectedRate = Boolean((price === null || price === void 0 ? void 0 : price.hasFlexRates) && (price === null || price === void 0 ? void 0 : price.selectedRate) && !isPriceLoading);
  var displayOptionAvailable = proposal.optionAvailable && currentPage !== 'banking' && Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.option');
  var displayPromoCode = currentPage !== 'banking';
  var isPromoCodeEnabled = Object(src_i18n["d" /* getKeyValue */])('booking.priceDetails.promoCode.enabled');

  var _getOffersAndDiscount = Object(SummaryView_utils["a" /* getOffersAndDiscounts */])((proposal === null || proposal === void 0 ? void 0 : (_proposal$price = proposal.price) === null || _proposal$price === void 0 ? void 0 : _proposal$price.discounts) || []),
      discounts = _getOffersAndDiscount.discounts,
      offers = _getOffersAndDiscount.offers;

  var enableBuyNowPayLaterProvider = BuyNowPayLater_const["b" /* BUY_NOW_PAY_LATER_PROVIDER */].find(function (id) {
    var _price$total;

    return Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)("psp.".concat(id.toLowerCase())) && Object(BuyNowPayLater_utils["b" /* isAllowedPaymentPlan */])({
      id: id,
      price: price === null || price === void 0 ? void 0 : (_price$total = price.total) === null || _price$total === void 0 ? void 0 : _price$total.value,
      startDate: proposal.arrivalDate
    });
  });
  var BuyNowPayLaterPricing = BuyNowPayLater_const["a" /* BUY_NOW_PAY_LATER_PRICING */][enableBuyNowPayLaterProvider];
  var dispatch = Object(es["d" /* useDispatch */])();
  var roomQuantity = proposal.accommodations.filter(function (accommodation) {
    return accommodation.quantity > 1;
  }).map(function (accommodation) {
    return accommodation.quantity;
  });
  Object(react["useEffect"])(function () {
    var daddedServicesNumber = getTotalRentedServices(reservedServicesByAttendee) - prevServicesLength;
    setAddedServicesNumber(daddedServicesNumber);
    var timer = setTimeout(function () {
      return setAddedServicesNumber(0);
    }, BookingAddtionalServices_utils["a" /* TOAST_DURATION */]);
    return function () {
      return clearTimeout(timer);
    };
  }, [reservedServicesByAttendee]);
  var track = Object(useTracking["a" /* useTracking */])(be_tracking["a" /* TRACK_BE_EVENT_GA_ACTIVITIES */]);
  var displayInstalment = Object(src_i18n["d" /* getKeyValue */])('common.price.displayInstalmentsPrice') && Price["a" /* INSTALMENT_LOCALES */].includes(appContext.locale);
  var hidePriceInfo = displayInstalment && isOnLastPage;

  if (!isAppMounted) {
    return null;
  }

  return BookingBottomNavbar_jsx(ActivitiesContext["a" /* ActivitiesContext */].Provider, {
    // TODO: cleanup !!
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    value: {
      deleteService: function deleteService(services, attendeeIds) {
        track({
          labelGA: Object(bookingUtils["b" /* getActivityTypeName */])(services[0].pricingInfo.type),
          actionGA: 'removeFromCart'
        }); // find the serviceIds to be deleted

        var serviceIds = services.reduce(function (acc, service) {
          var _service$pricingInfo$ = service.pricingInfo.attendees.filter(function (a) {
            return a.id === attendeeIds;
          }),
              _service$pricingInfo$2 = Object(slicedToArray["a" /* default */])(_service$pricingInfo$, 1),
              attendee = _service$pricingInfo$2[0];

          return [].concat(Object(toConsumableArray["a" /* default */])(acc), Object(toConsumableArray["a" /* default */])(attendee.schedules.reduce(function (scheduleAccumulator, schedule) {
            return schedule.timeSlots.reduce(function (timeSlotAccumulator, timeSlot) {
              return timeSlotAccumulator.includes(timeSlot.id) ? timeSlotAccumulator : [].concat(Object(toConsumableArray["a" /* default */])(timeSlotAccumulator), [timeSlot.id]);
            }, scheduleAccumulator);
          }, acc)));
        }, []);
        return dispatch(Object(proposals_action["g" /* deleteAdditionalServices */])({
          showNotification: true,
          serviceIds: serviceIds,
          attendeeIds: attendeeIds,
          appContext: appContext
        }));
      },
      currency: proposal.price.currency,
      trackingData: be_tracking["a" /* TRACK_BE_EVENT_GA_ACTIVITIES */]
    }
  }, BookingBottomNavbar_jsx(BottomNavbarLayer["a" /* BottomNavbarLayer */], {
    addedServicesNumber: addedServicesNumber,
    continueBtn: continueBtn,
    backLabel: !appContext.isCmta ? Object(src_i18n["h" /* t */])('common.backNavigation') : '',
    buyNowPayLaterPricing: enableBuyNowPayLaterProvider && BookingBottomNavbar_jsx(BuyNowPayLaterPricing, {
      isPaymentPage: isOnLastPage,
      proposal: proposal,
      price: price,
      iconClassname: Object(classnames_utils["a" /* classnames */])('-bottom-[0.375rem] ml-5', {
        'bottom-[1.225rem]': isMobile && hasSelectedRate,
        '-bottom-[0.4rem]': isDesktop
      })
    }),
    closeLabel: Object(src_i18n["h" /* t */])('booking.priceDetails.packagePrice.closeReceipt'),
    continueAction: continueAction,
    continueLabel: isOnLastPage ? paymentLabel : Object(src_i18n["h" /* t */])('common.continue'),
    forwardRef: layerRef,
    hasSelectedRate: hasSelectedRate,
    hideContinueButton: hideContinueButton,
    isDisabled: isDisabled,
    isFavorite: isFavorite,
    isNextStep: isNextStep,
    isPriceLoading: isPriceLoading,
    navbarRef: navbarRef,
    nextPage: nextPage,
    onClickFavorite: onClickFavorite,
    onCloseAllLayers: function onCloseAllLayers() {
      return setShouldCloseAllLayers(false);
    },
    openLabel: Object(src_i18n["h" /* t */])('booking.priceDetails.packagePrice.openReceipt'),
    overwriteContinueButton: overwriteContinueButton,
    previousPage: previousPage,
    price: price,
    isOnLastPage: isOnLastPage,
    portalPosition: portalPosition,
    previousAction: previousAction,
    shouldCloseAllLayers: shouldCloseAllLayers,
    showPanel: shouldOpenPanel,
    toggleReceiptPanel: closePanel,
    trackClickOpenReceipt: function trackClickOpenReceipt() {
      trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_BOTTOM_BAR, {
        detail_click: 'open_receipt'
      });
    }
  }, onClickFavorite && BookingBottomNavbar_jsx("div", {
    className: "fixed inset-x-0 top-[10vh] isolate w-full bg-white"
  }, BookingBottomNavbar_jsx(PriceTicketFavorite["a" /* PriceTicketFavorite */], {
    isFilled: isFavorite,
    isNextStep: isNextStep,
    isSticky: true,
    onClick: onClickFavorite
  })), !hidePriceInfo && BookingBottomNavbar_jsx("div", {
    className: "flex flex-wrap items-end justify-between gap-10 p-20 py-10 lg:flex-nowrap lg:py-20"
  }, BookingBottomNavbar_jsx("div", {
    className: "flex-1"
  }), BookingBottomNavbar_jsx("div", {
    className: "relative flex items-end gap-10"
  }, BookingBottomNavbar_jsx(BottomNavbarTotalPrice["a" /* BottomNavbarTotalPrice */], {
    isLoading: isPriceLoading,
    price: price,
    showPrice: !!Object(src_i18n["h" /* t */])('booking.priceDetails.packagePrice.closeReceipt'),
    className: "items-center text-center"
  })), BookingBottomNavbar_jsx("div", {
    className: "flex flex-1"
  }, price && price.hasFlexRates && price.selectedRate ? BookingBottomNavbar_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('rounded-pill px-10 py-5', {
      'bg-green': [FLEX_RATES.STANDARD, FLEX_RATES.EBB].includes(price.selectedRate),
      'bg-sienna': [FLEX_RATES.NRR, FLEX_RATES.FLR].includes(price.selectedRate)
    })
  }, BookingBottomNavbar_jsx(SelectedRate["a" /* SelectedRate */], {
    price: price
  })) : null)), BookingBottomNavbar_jsx(SiteContainer["a" /* SiteContainer */], null, BookingBottomNavbar_jsx("p", {
    className: "mb-10 mt-30 font-brand text-24 text-black"
  }, Object(src_i18n["h" /* t */])('booking.summary.pageTitle')), BookingBottomNavbar_jsx("div", {
    className: "flex gap-20"
  }, BookingBottomNavbar_jsx(Icon["a" /* Icon */], {
    className: "text-green",
    name: icons["a" /* ICONS */].CHECK_FILLED
  }), BookingBottomNavbar_jsx("p", {
    className: "mb-10 font-brand text-green"
  }, Object(src_i18n["h" /* t */])('booking.summary.discount.bestRateGuarantee'))), displayOptionAvailable && BookingBottomNavbar_jsx(OptionBlock_OptionBlock, null), BookingBottomNavbar_jsx("div", {
    className: "mb-100 rounded-12 bg-white p-20 shadow-sm",
    "data-testid": "stay-summary-ticket"
  }, BookingBottomNavbar_jsx(AccordionBlock["a" /* AccordionBlock */], {
    trackingEventName: constants["F" /* TRACK_EVENT_NAMES */].CLICK_RECEIPT_TICKET,
    lines: Object(SummaryView_utils["c" /* getSummaryViewLinesByProposal */])({
      accommodationSummary: BookingBottomNavbar_jsx(AccommodationSummary["a" /* AccommodationSummary */], {
        accommodations: proposal.accommodations,
        resort: resort,
        roomQuantity: roomQuantity
      }),
      i18n: i18n,
      locale: appContext.locale,
      selectedProposal: proposal,
      isJoyViewOrUrbanOasisAllInclusive: isJoyViewAllInclusive || isUrbanOasisAllInclusive,
      isUrbanOasisFoodAndBeverage: isUrbanOasisFoodAndBeverage
    })
  }, BookingBottomNavbar_jsx("div", {
    className: "mt-40"
  }, shouldShowPriceDetails && BookingBottomNavbar_jsx("p", {
    className: "mb-20 font-bold"
  }, Object(src_i18n["h" /* t */])('booking.priceDetails.packagePrice.priceDetails')), BookingBottomNavbar_jsx(PriceDetailLines["a" /* PriceDetailLines */], {
    trackingEventName: constants["F" /* TRACK_EVENT_NAMES */].CLICK_RECEIPT_TICKET,
    priceDetail: Object(SummaryView_utils["b" /* getPriceDetail */])({
      selectedProposal: proposal,
      priceWithDonation: priceWithDonation,
      showPriceDetailLines: shouldShowPriceDetails,
      promoCode: displayPromoCode ? BookingBottomNavbar_jsx("div", {
        className: "mb-20"
      }, BookingBottomNavbar_jsx(DiscountsLine["a" /* DiscountsLine */], {
        discounts: offers
      }), isPromoCodeEnabled && !!proposal && BookingBottomNavbar_jsx(PromoCode["a" /* PromoCode */], {
        proposalId: proposal.id,
        customerId: parseInt(proposal.attendees.list[0].customerId, 10),
        discounts: discounts
      })) : BookingBottomNavbar_jsx("div", {
        className: "mb-20"
      }, BookingBottomNavbar_jsx(DiscountsLine["a" /* DiscountsLine */], {
        discounts: proposal.price.discounts
      }))
    })
  })), !!(proposal === null || proposal === void 0 ? void 0 : proposal.greatMembersLoyaltyPoints) && BookingBottomNavbar_jsx(GreatMembersLoyaltyPoints["a" /* GreatMembersLoyaltyPoints */], {
    loyaltyPoints: proposal === null || proposal === void 0 ? void 0 : proposal.greatMembersLoyaltyPoints,
    dataTestId: "greatMembersLoyaltyPoints"
  })))), reservedServicesByAttendee.length > 0 && BookingBottomNavbar_jsx(SiteContainer["a" /* SiteContainer */], {
    size: "small"
  }, BookingBottomNavbar_jsx(Title["a" /* Title */], {
    className: "mb-10",
    theme: "title-brand-n2"
  }, Object(src_i18n["h" /* t */])('booking.activities.myPackage.title')), BookingBottomNavbar_jsx(ReservedServicesList["a" /* ReservedServicesList */], {
    currency: proposal.price.currency,
    noEditMode: noEdit,
    reservedServicesByAttendee: reservedServicesByAttendee,
    scrollBackwardLabel: Object(src_i18n["h" /* t */])('common.scrollBackward'),
    scrollForwardLabel: Object(src_i18n["h" /* t */])('common.scrollForward')
  }))));
};
// EXTERNAL MODULE: ./src/client/components/widgets/booking-navbar/BookingNavbarContext.jsx
var BookingNavbarContext = __webpack_require__("4ryf");

// CONCATENATED MODULE: ./src/client/views/booking/BookingLayout.jsx
var BookingLayout_jsx = react_default.a.createElement;






var BookingLayout_BookingLayout = function BookingLayout(_ref) {
  var selectedProposal = _ref.selectedProposal,
      currentPage = _ref.currentPage,
      previousPage = _ref.previousPage,
      nextPage = _ref.nextPage,
      price = _ref.price,
      goToNextStep = _ref.goToNextStep,
      i18n = _ref.i18n,
      resort = _ref.resort,
      isFavorite = _ref.isFavorite,
      isOptionHoldOnly = _ref.isOptionHoldOnly,
      previousAction = _ref.previousAction,
      isOnLastPage = _ref.isOnLastPage,
      shouldOpenPanel = _ref.shouldOpenPanel,
      closePanel = _ref.closePanel,
      onClickFavorite = _ref.onClickFavorite,
      isNextStep = _ref.isNextStep,
      children = _ref.children;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var navbarRef = Object(react["useRef"])();

  var _useState = Object(react["useState"])(false),
      hideContinueButton = _useState[0],
      setHideContinueButton = _useState[1];

  var _useState2 = Object(react["useState"])(false),
      isPriceLoading = _useState2[0],
      setIsPriceLoading = _useState2[1];

  var _useState3 = Object(react["useState"])(true),
      noEdit = _useState3[0],
      setNoEdit = _useState3[1];

  var _useState4 = Object(react["useState"])(false),
      overwriteContinueButton = _useState4[0],
      setOverwriteContinueButton = _useState4[1];

  var _useState5 = Object(react["useState"])(null),
      continueBtn = _useState5[0],
      setContinueBtn = _useState5[1];

  var _useState6 = Object(react["useState"])(),
      portalPosition = _useState6[0],
      setPortalPosition = _useState6[1];

  var _useState7 = Object(react["useState"])(false),
      isDisabled = _useState7[0],
      setIsDisabled = _useState7[1];

  var _useState8 = Object(react["useState"])(true),
      priceShouldIncludeDonation = _useState8[0],
      setPriceShouldIncludeDonation = _useState8[1];

  var _useState9 = Object(react["useState"])(null),
      validationCallback = _useState9[0],
      setValidationCallback = _useState9[1];

  var _useState10 = Object(react["useState"])(),
      paymentLabel = _useState10[0],
      setPaymentLabel = _useState10[1];

  var _getTotalPriceWithDon = Object(price_util["c" /* getTotalPriceWithDonation */])(price, appContext.locale),
      withDonation = _getTotalPriceWithDon.withDonation;

  return BookingLayout_jsx(BookingNavbarContext["a" /* BookingNavbarProvider */], {
    currentPage: currentPage,
    setHideContinueButton: setHideContinueButton,
    setIsPriceLoading: setIsPriceLoading,
    setPriceShouldIncludeDonation: setPriceShouldIncludeDonation,
    navbarRef: navbarRef,
    setNoEdit: setNoEdit,
    setContinueBtn: setContinueBtn,
    setOverwriteContinueButton: setOverwriteContinueButton,
    setPortalPosition: setPortalPosition,
    setIsDisabled: setIsDisabled,
    setValidationCallback: setValidationCallback,
    setPaymentLabel: setPaymentLabel
  }, children, BookingLayout_jsx(BookingBottomNavbar_BookingBottomNavbar, {
    continueBtn: continueBtn,
    overwriteContinueButton: overwriteContinueButton,
    i18n: i18n,
    previousAction: previousAction,
    price: priceShouldIncludeDonation ? withDonation : price,
    proposal: selectedProposal,
    resort: resort,
    currentPage: currentPage,
    portalPosition: portalPosition,
    previousPage: previousPage,
    nextPage: nextPage,
    paymentLabel: paymentLabel || Object(src_i18n["h" /* t */])('booking.priceDetails.packagePrice.bookingLabel'),
    noEdit: noEdit,
    isOnLastPage: isOnLastPage,
    hideContinueButton: hideContinueButton,
    isDisabled: !!isDisabled,
    isPriceLoading: isPriceLoading // $FlowFixMe
    ,
    continueAction: goToNextStep(validationCallback),
    shouldOpenPanel: shouldOpenPanel,
    closePanel: closePanel,
    isOptionHoldOnly: isOptionHoldOnly,
    navbarRef: navbarRef,
    onClickFavorite: onClickFavorite,
    isFavorite: isFavorite,
    isNextStep: isNextStep
  }));
};

/***/ }),

/***/ "jEE5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QuickSearchUnavailability; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jQ/y");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("qBqs");
/* harmony import */ var _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("SPKZ");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;



var QuickSearchUnavailability = function QuickSearchUnavailability(_ref) {
  var title = _ref.title,
      description = _ref.description;
  return __jsx("div", {
    className: "flex flex-col items-center",
    "data-testid": "QuickSearchUnavailability"
  }, __jsx("div", {
    className: "QuickSearchUnavailability-header flex w-full items-center p-25 md:py-50"
  }, __jsx("div", {
    className: "mr-40"
  }, __jsx(_components_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_3__[/* Icon */ "a"], {
    className: "shrink self-start text-orange",
    name: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].WARNING,
    width: "3rem",
    hasRtl: true
  })), __jsx("h1", {
    className: "m-0 text-20 text-black lg:text-24"
  }, title)), description != null && __jsx("p", {
    className: "QuickSearchUnavailability-descriptions m-0 w-full px-25 text-12"
  }, description));
};

/***/ }),

/***/ "jFIS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ FiltersBar_FiltersBar; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/components/frameworks/scrollable/Scrollable.jsx + 1 modules
var Scrollable = __webpack_require__("cVnM");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find-index.js
var es_array_find_index = __webpack_require__("vfdX");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: ./src/client/components/frameworks/click-outside/ClickOutside.jsx
var ClickOutside = __webpack_require__("EWLr");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/frameworks/check-button/CheckButton.themes.js

var themes = {
  "default": function _default(_ref) {
    var isChecked = _ref.isChecked,
        isDisabled = _ref.isDisabled;
    return {
      thRoot: Object(classnames_utils["a" /* classnames */])('relative flex flex-col items-center justify-center rounded-12 border-1 border-solid bg-white p-10 text-14 font-bold transition-colors duration-250 ease-in', {
        'cursor-not-allowed border-grey bg-pearl': isDisabled,
        'border-lightGrey': !isChecked,
        'border-success': isChecked && !isDisabled
      }),
      thIcon: Object(classnames_utils["a" /* classnames */])('absolute end-0 top-0 m-5 text-grey', {
        'text-success': !isDisabled
      }),
      thIconWidth: '0.625rem'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/check-button/CheckButton.jsx
var __jsx = react_default.a.createElement;





var CheckButton_CheckButton = function CheckButton(_ref) {
  var children = _ref.children,
      className = _ref.className,
      isChecked = _ref.isChecked,
      isDisabled = _ref.isDisabled,
      onClick = _ref.onClick,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  var _themes$theme = themes[theme]({
    isChecked: isChecked,
    isDisabled: isDisabled
  }),
      thIcon = _themes$theme.thIcon,
      thIconWidth = _themes$theme.thIconWidth,
      thRoot = _themes$theme.thRoot;

  return __jsx("button", {
    "aria-checked": isChecked,
    "aria-disabled": isDisabled,
    className: Object(classnames_utils["a" /* classnames */])(thRoot, className),
    onClick: !isDisabled && onClick,
    role: "checkbox",
    type: "button"
  }, isChecked && __jsx(Icon["a" /* Icon */], {
    className: thIcon,
    name: icons["a" /* ICONS */].CHECK,
    width: thIconWidth
  }), children);
};
// EXTERNAL MODULE: ./src/client/components/frameworks/form-inputs/input-switch/InputSwitch.jsx + 1 modules
var InputSwitch = __webpack_require__("YjXp");

// CONCATENATED MODULE: ./src/client/components/widgets/filter-option/FilterOption.jsx

var FilterOption_jsx = react_default.a.createElement;




var FilterOption_FilterOption = function FilterOption(_ref) {
  var className = _ref.className,
      iconName = _ref.iconName,
      iconSize = _ref.iconSize,
      id = _ref.id,
      imageSrc = _ref.imageSrc,
      isButton = _ref.isButton,
      isDisabled = _ref.isDisabled,
      isIconNotSquare = _ref.isIconNotSquare,
      isSelected = _ref.isSelected,
      label = _ref.label,
      matched = _ref.matched,
      name = _ref.name,
      _onChange = _ref.onChange,
      subLabel = _ref.subLabel,
      value = _ref.value;
  return isButton ? FilterOption_jsx(CheckButton_CheckButton, {
    className: className,
    isChecked: isSelected,
    isDisabled: isDisabled,
    onClick: function onClick() {
      return _onChange(value);
    }
  }, iconName && FilterOption_jsx(Icon["a" /* Icon */], {
    className: "mb-5",
    hasRtl: true,
    isNotSquare: isIconNotSquare,
    name: iconName,
    width: iconSize || '1.5rem'
  }), imageSrc && FilterOption_jsx("img", {
    alt: "",
    className: "mb-5 w-4/5 max-w-100",
    src: imageSrc
  }), label, subLabel && FilterOption_jsx("span", {
    className: "text-12 text-mediumGrey"
  }, subLabel), FilterOption_jsx("span", {
    className: "text-12 text-black"
  }, "(", matched, ")")) : FilterOption_jsx(InputSwitch["a" /* InputSwitch */], {
    className: className,
    id: id,
    isChecked: isSelected,
    isDisabled: isDisabled,
    label: FilterOption_jsx("span", {
      className: "inline-flex items-center gap-5"
    }, iconName && FilterOption_jsx(Icon["a" /* Icon */], {
      name: iconName,
      width: "1.5rem"
    }), label, subLabel && FilterOption_jsx("span", {
      className: "text-12 text-mediumGrey"
    }, subLabel), FilterOption_jsx("span", {
      className: "text-12 text-mediumGrey"
    }, "(", matched, ")")),
    name: name,
    onChange: function onChange() {
      return _onChange(value);
    },
    value: value
  });
};
// CONCATENATED MODULE: ./src/client/components/widgets/filter-options/FilterOptions.jsx



var FilterOptions_jsx = react_default.a.createElement;




var FilterOptions_FilterOptions = function FilterOptions(_ref) {
  var className = _ref.className,
      name = _ref.name,
      onChange = _ref.onChange,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  return FilterOptions_jsx("ul", {
    className: Object(classnames_utils["a" /* classnames */])('sm:flex sm:flex-wrap -m-5', className)
  }, options.map(function (option) {
    return FilterOptions_jsx("li", {
      className: "p-5 sm:w-1/4 md:w-1/6",
      key: option.id
    }, FilterOptions_jsx(FilterOption_FilterOption, Object(esm_extends["a" /* default */])({}, option, {
      className: isTablet ? 'h-full text-black shadow-diffuse w-full' : '',
      isButton: isTablet,
      name: name,
      onChange: onChange
    })));
  }));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-inputs/input-button/InputButton.jsx + 1 modules
var InputButton = __webpack_require__("W+NJ");

// EXTERNAL MODULE: ./src/client/components/frameworks/template-string/TemplateString.jsx
var TemplateString = __webpack_require__("Ohju");

// CONCATENATED MODULE: ./src/client/components/widgets/filter-toggler/FilterToggler.jsx


var FilterToggler_jsx = react_default.a.createElement;




var FilterToggler_FilterToggler = function FilterToggler(_ref) {
  var children = _ref.children,
      className = _ref.className,
      isActive = _ref.isActive,
      isDisabled = _ref.isDisabled,
      onClear = _ref.onClear,
      onClick = _ref.onClick,
      _ref$selectedOptionsN = _ref.selectedOptionsNumber,
      selectedOptionsNumber = _ref$selectedOptionsN === void 0 ? 0 : _ref$selectedOptionsN;
  return FilterToggler_jsx(InputButton["a" /* InputButton */], {
    className: className,
    isActive: isActive,
    isDisabled: isDisabled,
    isFilled: Boolean(selectedOptionsNumber),
    onClear: onClear,
    onClick: onClick
  }, FilterToggler_jsx("span", {
    className: "truncate"
  }, children, !!selectedOptionsNumber && FilterToggler_jsx(TemplateString["a" /* TemplateString */], {
    className: "sr-only",
    template: selectedOptionsNumber > 1 ? Object(i18n["h" /* t */])('common.selectedCriteriasLabel.n') : Object(i18n["h" /* t */])('common.selectedCriteriasLabel._1'),
    values: {
      count: selectedOptionsNumber.toString()
    }
  })));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/portal/Portal.jsx
var Portal = __webpack_require__("3uBn");

// CONCATENATED MODULE: ./src/client/components/widgets/filter/Filter.jsx















var Filter_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var Filter_getSelectedOptions = function getSelectedOptions() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return options.reduce(function (acc, o) {
    return o.isSelected ? [].concat(Object(toConsumableArray["a" /* default */])(acc), [o.value]) : acc;
  }, []);
};

var Filter_Filter = function Filter(_ref) {
  var className = _ref.className,
      customRender = _ref.customRender,
      customRenderParent = _ref.customRenderParent,
      _ref$hasForceClose = _ref.hasForceClose,
      hasForceClose = _ref$hasForceClose === void 0 ? false : _ref$hasForceClose,
      label = _ref.label,
      name = _ref.name,
      onChange = _ref.onChange,
      onClear = _ref.onClear,
      _onClick = _ref.onClick,
      onClickOption = _ref.onClickOption,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      portalName = _ref.portalName,
      setOptions = _ref.setOptions;

  var _useState = Object(react["useState"])(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var selectedOptions = Filter_getSelectedOptions(options);
  Object(react["useEffect"])(function () {
    if (isOpen && hasForceClose) {
      setIsOpen(false);
    }
  }, [hasForceClose]);

  var toggleOption = function toggleOption(option) {
    var newOptions = Object(toConsumableArray["a" /* default */])(options);

    var optionToggeledIndex = newOptions.findIndex(function (opt) {
      return opt.id === option.id;
    });

    var updatedOption = _objectSpread(_objectSpread({}, newOptions[optionToggeledIndex]), {}, {
      isSelected: !newOptions[optionToggeledIndex].isSelected
    });

    newOptions[optionToggeledIndex] = updatedOption;
    setOptions(newOptions);
    onChange(name, Filter_getSelectedOptions(newOptions), option.value);
    onClickOption === null || onClickOption === void 0 ? void 0 : onClickOption(updatedOption);
  };

  var clearAllSelected = function clearAllSelected() {
    var newOptions = options.map(function (opt) {
      return _objectSpread(_objectSpread({}, opt), {}, {
        isSelected: false
      });
    });
    setOptions(Object(toConsumableArray["a" /* default */])(newOptions));
    onClear && onClear(name);
  };

  return Filter_jsx(react["Fragment"], null, !customRenderParent ? Filter_jsx(FilterToggler_FilterToggler, {
    className: className,
    isActive: isOpen,
    isDisabled: options.length === 0,
    onClear: clearAllSelected,
    onClick: function onClick() {
      setIsOpen(!isOpen);
      _onClick === null || _onClick === void 0 ? void 0 : _onClick(name);
    },
    selectedOptionsNumber: selectedOptions.length
  }, label) : Filter_jsx("div", {
    className: "flex items-center flex-1 whitespace-nowrap"
  }, customRenderParent(selectedOptions, onChange, options.length === 0)), isOpen && Filter_jsx(Portal["a" /* default */], {
    name: portalName
  }, Filter_jsx(ClickOutside["a" /* ClickOutside */], {
    className: "bg-white border-1 border-lightGrey mt-2 relative rounded-12 shadow-diffuse z-2",
    onClick: function onClick() {
      return setIsOpen(false);
    }
  }, customRender ? Filter_jsx("div", {
    className: "flex max-w-site mx-auto p-15"
  }, customRender(options, selectedOptions, toggleOption)) : Filter_jsx("div", {
    className: "max-w-site mx-auto p-15"
  }, Filter_jsx(FilterOptions_FilterOptions, {
    name: name,
    onChange: function onChange(value) {
      var clickedOption = options.find(function (opt) {
        return opt.value === value;
      });
      clickedOption && toggleOption(clickedOption);
    },
    options: options.map(function (option) {
      return _objectSpread(_objectSpread({}, option), {}, {
        isSelected: option.isSelected,
        label: Filter_jsx("span", {
          className: "capitalize"
        }, option.label.toLowerCase())
      });
    })
  })))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/filters-bar/FiltersBarClearAllBtn.jsx
var FiltersBarClearAllBtn_jsx = react_default.a.createElement;



var FiltersBarClearAllBtn_FiltersBarClearAllBtn = function FiltersBarClearAllBtn(_ref) {
  var className = _ref.className,
      onClick = _ref.onClick;
  return FiltersBarClearAllBtn_jsx("button", {
    className: Object(classnames_utils["a" /* classnames */])('text-12 md:text-14 lg:text-16 text-black underline', className),
    "data-testid": "removeAllFilters",
    onClick: onClick,
    type: "button"
  }, Object(i18n["h" /* t */])('filters.removeAll'));
};
// CONCATENATED MODULE: ./src/client/components/widgets/filters-bar/FiltersBar.jsx












var FiltersBar_jsx = react_default.a.createElement;

function FiltersBar_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function FiltersBar_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { FiltersBar_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { FiltersBar_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var FiltersBar_FiltersBar = function FiltersBar(_ref) {
  var caption = _ref.caption,
      className = _ref.className,
      dataTestid = _ref.dataTestid,
      _ref$hasClearAll = _ref.hasClearAll,
      hasClearAll = _ref$hasClearAll === void 0 ? false : _ref$hasClearAll,
      _ref$hasForceClose = _ref.hasForceClose,
      hasForceClose = _ref$hasForceClose === void 0 ? false : _ref$hasForceClose,
      isLarge = _ref.isLarge,
      onChange = _ref.onChange,
      onClear = _ref.onClear,
      onClearAll = _ref.onClearAll,
      onClick = _ref.onClick,
      onClickOption = _ref.onClickOption,
      portalName = _ref.portalName,
      propsFilters = _ref.filters,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["caption", "className", "dataTestid", "hasClearAll", "hasForceClose", "isLarge", "onChange", "onClear", "onClearAll", "onClick", "onClickOption", "portalName", "filters"]);

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  var _useState = Object(react["useState"])(propsFilters ? Object(toConsumableArray["a" /* default */])(propsFilters) : []),
      filters = _useState[0],
      setFilters = _useState[1];

  Object(react["useEffect"])(function () {
    propsFilters && setFilters(propsFilters);
  }, [propsFilters]);

  var renderFilters = function renderFilters() {
    return filters.map(function (filter, index) {
      return FiltersBar_jsx(Filter_Filter, {
        className: Object(classnames_utils["a" /* classnames */])('flex-1', {
          'last:scroll-x-ghost-m-10 last:scroll-x-ghost-m': index === filters.length - 1 && !isDesktop
        }),
        customRender: filter.customRender,
        customRenderParent: filter.customRenderParent,
        id: filter.id,
        key: filter.id,
        label: filter.label,
        name: filter.id,
        onChange: onChange,
        onClear: onClear,
        onClick: onClick,
        onClickOption: onClickOption,
        hasForceClose: hasForceClose,
        options: filter.options,
        portalName: portalName,
        setOptions: function setOptions(newOptions) {
          var newFilters = Object(toConsumableArray["a" /* default */])(filters);

          newFilters[index] = FiltersBar_objectSpread(FiltersBar_objectSpread({}, newFilters[index]), {}, {
            options: newOptions
          });
          setFilters(newFilters);
        }
      });
    });
  };

  var clearFiltersAndSelectedOptions = function clearFiltersAndSelectedOptions() {
    var newFilters = filters.map(function (filter) {
      return FiltersBar_objectSpread(FiltersBar_objectSpread({}, filter), {}, {
        options: filter.options.map(function (opt) {
          return FiltersBar_objectSpread(FiltersBar_objectSpread({}, opt), {}, {
            isSelected: false
          });
        })
      });
    });
    setFilters(Object(toConsumableArray["a" /* default */])(newFilters));
    onClearAll === null || onClearAll === void 0 ? void 0 : onClearAll();
  };

  return FiltersBar_jsx(react["Fragment"], null, FiltersBar_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])({
      'animation-duration-500 animate-slideInTop border-b-1 border-t-1 border-grey bg-white': isLarge
    })
  }, FiltersBar_jsx(SiteContainer["a" /* SiteContainer */], {
    isWide: !isDesktop
  }, FiltersBar_jsx("div", Object(esm_extends["a" /* default */])({}, rest, {
    className: Object(classnames_utils["a" /* classnames */])('flex w-full flex-wrap items-center justify-between gap-10 bg-white p-10', {
      'border-1 border-grey shadow-diffuse': !isLarge
    }, className),
    "data-testid": dataTestid
  }), caption && FiltersBar_jsx("p", {
    className: "w-1/2 text-12 font-bold md:text-14 lg:w-auto lg:text-16"
  }, caption), hasClearAll && FiltersBar_jsx(FiltersBarClearAllBtn_FiltersBarClearAllBtn, {
    className: "shrink lg:order-last",
    onClick: clearFiltersAndSelectedOptions
  }), isDesktop ? renderFilters() : FiltersBar_jsx(Scrollable["a" /* Scrollable */], {
    className: "-mx-10",
    childrenWrapperClassNames: "flex gap-10 px-10"
  }, renderFilters())))), FiltersBar_jsx("div", {
    id: portalName
  }));
};

/***/ }),

/***/ "jwfn":
/***/ (function(module, exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/booking/[bookingStep]",
      function () {
        return __webpack_require__("Tz41");
      }
    ]);
  

/***/ }),

/***/ "ldqU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_TRANSPORT_STATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchTransportStations; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("b0q8");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_label_labelUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("WGoB");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("rJ95");







var FETCH_TRANSPORT_STATIONS = 'FETCH_TRANSPORT_STATIONS';

var formatTransportStationsNames = function formatTransportStationsNames(node) {
  return node.map(function (transport) {
    return {
      value: transport.id,
      label: transport.label,
      name: Object(_utils_label_labelUtils__WEBPACK_IMPORTED_MODULE_4__[/* getTravelSectionSummary */ "c"])({
        travelSection: transport
      })
    };
  });
};

var transportStationFragment = "\n    fragment transportStation on TransportStationType {\n      id\n      label\n      city_id\n      type\n      is_main_city_station\n    }";

function fetchTransportStationsQuery(cityId, appContext) {
  var query = "{\n      transportStations(cityId: \"".concat(cityId, "\"){\n        airports {\n          ...transportStation\n        }\n        trainStations {\n          ...transportStation\n        }\n        ports {\n          ...transportStation\n        }\n      }\n    }\n    ").concat(transportStationFragment);
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].runNoCacheQuery(query, appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_5__[/* CITIES_GET_TRANSPORT_STATIONS */ "b"]
  }).then(function (_ref) {
    var _ref$transportStation = _ref.transportStations,
        airports = _ref$transportStation.airports,
        trainStations = _ref$transportStation.trainStations,
        ports = _ref$transportStation.ports;
    return {
      airports: formatTransportStationsNames(airports),
      trainStations: formatTransportStationsNames(trainStations),
      ports: formatTransportStationsNames(ports)
    };
  });
}

function fetchTransportStations(cityId, appContext) {
  return function (dispatch) {
    dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(FETCH_TRANSPORT_STATIONS, cityId));
    return fetchTransportStationsQuery(cityId, appContext).then(function (response) {
      dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_2__["resolve"])(FETCH_TRANSPORT_STATIONS), response));
      return response;
    })["catch"](function (error) {
      dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_2__["reject"])(FETCH_TRANSPORT_STATIONS)));
      throw error;
    });
  };
}



/***/ }),

/***/ "mCPI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ PromoCode_PromoCode; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("3yYM");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("QsI/");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("VtSi");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/formik/dist/formik.esm.js + 76 modules
var formik_esm = __webpack_require__("ljKo");

// EXTERNAL MODULE: /opt/webapp/node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__("fYnN");
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/uniq.js
var uniq = __webpack_require__("jLkM");
var uniq_default = /*#__PURE__*/__webpack_require__.n(uniq);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// EXTERNAL MODULE: ./src/utils/graphql-client/use-gql/useGQL.js
var useGQL = __webpack_require__("0JpG");

// EXTERNAL MODULE: ./src/utils/use-gql-errors-handler/useGQLErrorsHandler.js
var useGQLErrorsHandler = __webpack_require__("Kl3I");

// EXTERNAL MODULE: ./src/hooks/use-authentication/useAuthentication.js
var useAuthentication = __webpack_require__("Iev9");

// EXTERNAL MODULE: ./src/client/views/account/queries/account.queries.js
var account_queries = __webpack_require__("QRI5");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTrackEvent.js
var useTrackEvent = __webpack_require__("DqI1");

// EXTERNAL MODULE: ./src/client/store/booking/proposals/proposals.action.js + 2 modules
var proposals_action = __webpack_require__("AnR0");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("lTEL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("kYxP");

// EXTERNAL MODULE: /opt/webapp/node_modules/yup/lib/index.js
var lib = __webpack_require__("luEP");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/frameworks/formik/FormikInput.jsx + 13 modules
var FormikInput = __webpack_require__("/HC4");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-feedback/FormFeedback.jsx
var FormFeedback = __webpack_require__("DwNm");

// CONCATENATED MODULE: ./src/client/components/widgets/promo-code/PromoCodeForm.jsx



var __jsx = react_default.a.createElement;









 // THIS SPECIFIC CODE IS NOT A GOOD PRACTICE, REFUSE ANY DEMANDS THAT WOULD ADD MORE CODE LIKE THIS https://github.com/ClubMediterranee/cm-b2c/issues/21598

var PROMO_CODE_MAX_LENGTH = 15;
var PROMO_CODE_VALIDATOR = lib["string"]().max(PROMO_CODE_MAX_LENGTH).required();
var promoCodeErrorToCmsKey = {
  SUCCESS: '',
  AUTHORIZATION_ERROR: 'customerNotEligible',
  INVALID_PROMO_CODE: 'invalidPromoCode',
  WRONG_PROMO_CODE: 'wrongPromoCode',
  PROMO_CODE_QUOTA_EXCEEDED: 'quotaExceeded',
  PROMO_CANNOT_BE_APPLIED: 'criteriaNotApplicable',
  BEST_PROMOTION_ALREADY_APPLIED: 'bestPromotionAlreadyApplied',
  COMMERCIAL_OFFER_ALREADY_USED: 'alreadyUsed',
  ALREADY_APPLIED_PROMOTION: 'alreadyAppliedOnProposal',
  REQUIRED_IDENTIFIED_ATTENDEES: 'requiredIdentifiedAttendees'
};

var PromoCodeForm_getPromocodeFeedbackMessage = function getPromocodeFeedbackMessage(valuesPromoCode, isPromoCodeRequestOnError, promoCodeStatus, selectedVouchers) // eslint-disable-next-line max-params
{
  if (isPromoCodeRequestOnError && promoCodeStatus !== null) {
    var _promoCodeErrorToCmsK;

    return Object(i18n["h" /* t */])("booking.priceDetails.promoCode.".concat((_promoCodeErrorToCmsK = promoCodeErrorToCmsKey === null || promoCodeErrorToCmsKey === void 0 ? void 0 : promoCodeErrorToCmsKey[promoCodeStatus]) !== null && _promoCodeErrorToCmsK !== void 0 ? _promoCodeErrorToCmsK : 'error'));
  }

  if (selectedVouchers.length > 0) {
    return Object(i18n["h" /* t */])('booking.priceDetails.promoCode.success');
  }

  return '';
};

var PromoCodeForm_PromoCodeForm = function PromoCodeForm(_ref) {
  var selectedVouchers = _ref.selectedVouchers,
      shouldDisplayIsUnfolded = _ref.shouldDisplayIsUnfolded,
      promoCodeStatus = _ref.promoCodeStatus,
      setPromoCodeStatus = _ref.setPromoCodeStatus;

  var _useFormikContext = Object(formik_esm["e" /* useFormikContext */])(),
      setFieldError = _useFormikContext.setFieldError,
      submitForm = _useFormikContext.submitForm,
      values = _useFormikContext.values,
      errors = _useFormikContext.errors;

  var isPromoCodeRequestOnError = promoCodeStatus !== 'SUCCESS' && promoCodeStatus !== null;
  var isPromoCodeRequestOnSuccess = promoCodeStatus === 'SUCCESS';

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var alreadyHasVoucher = selectedVouchers.length > 0;
  var feedbackMessage = PromoCodeForm_getPromocodeFeedbackMessage(values.promoCode, isPromoCodeRequestOnError, promoCodeStatus, selectedVouchers);
  Object(react["useEffect"])(function () {
    if (isPromoCodeRequestOnError) {
      setFieldError('promoCode', 'Request failed');
    }
  }, [isPromoCodeRequestOnError]);
  return __jsx("div", null, shouldDisplayIsUnfolded && __jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "togglePromoCodeField",
    className: "mt-20",
    label: alreadyHasVoucher ? Object(i18n["h" /* t */])('booking.priceDetails.promoCode.triggerAnotherText') : Object(i18n["h" /* t */])('booking.priceDetails.promoCode.triggerText'),
    name: "isUnfolded",
    type: "checkbox",
    onClick: function onClick() {
      if (!values.isUnfolded) {
        trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_SUMMARY, {
          detail_click: 'promotional_code'
        });
      }

      if (promoCodeStatus !== null) {
        setPromoCodeStatus(null);
        setFieldError('promoCode', '');
      }
    }
  }), __jsx("div", {
    className: "PromoCode-trigger inline-block text-right"
  }), values.isUnfolded && __jsx("div", null, __jsx("div", {
    className: "-mt-10 flex items-end gap-15"
  }, __jsx("div", {
    className: "md:w-1/3",
    "data-selector": "PromoCode-inputContainer"
  }, __jsx(FormikInput["a" /* FormikInput */], {
    className: Object(classnames_utils["a" /* classnames */])('air360-replay-ignore h-48 w-full appearance-none rounded-pill border border-lightGrey bg-white px-20 py-10 text-14 leading-normal text-black outline-none transition-all duration-250 ease-in focus:border-black', {
      'border-success': isPromoCodeRequestOnSuccess,
      'border-red': errors.promoCode
    }),
    hideErrorMessage: true,
    label: Object(i18n["h" /* t */])('booking.priceDetails.promoCode.label'),
    placeholder: Object(i18n["h" /* t */])('booking.priceDetails.promoCode.fieldLabel'),
    maxLength: PROMO_CODE_MAX_LENGTH,
    name: "promoCode",
    type: "text",
    validate: PROMO_CODE_VALIDATOR,
    dataTestId: "PromoCodeForm-input"
  })), __jsx(Button["a" /* Button */], {
    className: "mt-10",
    "data-testid": "PromoCodeForm-submit",
    onClick: submitForm
  }, Object(i18n["h" /* t */])('booking.priceDetails.promoCode.apply')))), __jsx("div", null, promoCodeStatus !== null && !!feedbackMessage && __jsx(FormFeedback["a" /* FormFeedback */], {
    message: feedbackMessage,
    isError: isPromoCodeRequestOnError
  })));
};
// EXTERNAL MODULE: ./src/client/components/utils/identifiers/constants.js
var identifiers_constants = __webpack_require__("YZTm");

// EXTERNAL MODULE: ./src/client/components/frameworks/modal/Modal.jsx + 1 modules
var Modal = __webpack_require__("EvYw");

// CONCATENATED MODULE: ./src/client/components/widgets/promo-code/PromoCodeModal.jsx
var PromoCodeModal_jsx = react_default.a.createElement;








var CIEL_VALIDATOR = lib["string"]().required();
var PromoCodeModal_PromoCodeModal = function PromoCodeModal(_ref) {
  var codeCiel = _ref.codeCiel,
      setCodeCiel = _ref.setCodeCiel,
      applyPromoCode = _ref.applyPromoCode;
  return PromoCodeModal_jsx(Modal["a" /* Modal */], {
    ariaLabel: Object(i18n["h" /* t */])('booking.summary.cielPopIn.title'),
    ariaLabelledby: identifiers_constants["u" /* ID_MODAL_HEADER__BE__PROMO_CODE */],
    closeLabel: Object(i18n["h" /* t */])('common.close'),
    onClose: function onClose() {
      return setCodeCiel(null);
    },
    size: "small"
  }, PromoCodeModal_jsx(formik_esm["d" /* Formik */], {
    initialValues: {
      partnerId: null,
      accessCode: null
    },
    onSubmit: function onSubmit(_ref2) {
      var partnerId = _ref2.partnerId,
          accessCode = _ref2.accessCode;
      applyPromoCode({
        promoCode: codeCiel || '',
        partnerId: partnerId,
        accessCode: accessCode
      });
      setCodeCiel(null);
    }
  }, function (formik) {
    return PromoCodeModal_jsx("div", {
      className: "p-20",
      "data-testid": "PromoCodeModal-form"
    }, PromoCodeModal_jsx("div", {
      className: "mb-20 font-bold",
      id: identifiers_constants["u" /* ID_MODAL_HEADER__BE__PROMO_CODE */]
    }, Object(i18n["h" /* t */])('booking.summary.cielPopIn.title')), PromoCodeModal_jsx("div", null, PromoCodeModal_jsx(FormikInput["a" /* FormikInput */], {
      type: "text",
      name: "partnerId",
      label: Object(i18n["h" /* t */])('booking.summary.cielPopIn.collectivityID'),
      validate: CIEL_VALIDATOR
    })), PromoCodeModal_jsx("div", {
      className: "mt-10"
    }, PromoCodeModal_jsx(FormikInput["a" /* FormikInput */], {
      type: "text",
      name: "accessCode",
      label: Object(i18n["h" /* t */])('booking.summary.cielPopIn.password'),
      validate: CIEL_VALIDATOR
    })), PromoCodeModal_jsx(Button["a" /* Button */], {
      className: "mt-20",
      "data-testid": "PromoCodeModal-submit",
      isDisabled: !formik.isValid,
      onClick: formik.submitForm
    }, Object(i18n["h" /* t */])('booking.common.validate')), PromoCodeModal_jsx("div", {
      className: "mt-15 text-14"
    }, Object(i18n["h" /* t */])('booking.summary.cielPopIn.legalInfo')));
  }));
};
// EXTERNAL MODULE: ./src/client/components/widgets/promo-code/DiscountsLine.jsx
var DiscountsLine = __webpack_require__("CYED");

// CONCATENATED MODULE: ./src/client/components/widgets/promo-code/PromoCode.jsx











var PromoCode_jsx = react_default.a.createElement;
























var CODE_CIEL = 'CMCOLL';
var PromoCode_PromoCode = function PromoCode(_ref) {
  var proposalId = _ref.proposalId,
      customerId = _ref.customerId,
      discounts = _ref.discounts;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var dispatch = Object(es["d" /* useDispatch */])();
  var context = Object(react["useContext"])(ReactAppContext["a" /* B2CAppContext */]);

  var _useAuthentication = Object(useAuthentication["a" /* useAuthentication */])(),
      isLogged = _useAuthentication.isLogged;

  var initialDiscounts = discounts === null || discounts === void 0 ? void 0 : discounts.map(function (discount) {
    var _discount$currentProp;

    return (_discount$currentProp = discount.currentProposalCode) === null || _discount$currentProp === void 0 ? void 0 : _discount$currentProp.id;
  }).filter(Boolean);

  var _useState = Object(react["useState"])(null),
      codeCiel = _useState[0],
      setCodeCiel = _useState[1];

  var _useState2 = Object(react["useState"])(null),
      promoCodeStatus = _useState2[0],
      setPromoCodeStatus = _useState2[1];

  var _useState3 = Object(react["useState"])(initialDiscounts),
      vouchers = _useState3[0],
      setVouchers = _useState3[1];

  var _useState4 = Object(react["useState"])(initialDiscounts),
      selectedVouchers = _useState4[0],
      setSelectedVouchers = _useState4[1];

  var formikSetValues = Object(react["useRef"])();
  var shouldDisplayIsUnfolded = isLogged || selectedVouchers.length > 0 || !isLogged && vouchers.length > 0;

  var _useGQL = Object(useGQL["a" /* useGQL */])({
    query: Object(account_queries["p" /* getVouchersQuery */])(),
    queryOptions: {
      cacheFront: {
        key: requestDictionary["F" /* CUSTOMER_ACCOUNT_GET_VOUCHERS */]
      },
      requestName: requestDictionary["F" /* CUSTOMER_ACCOUNT_GET_VOUCHERS */]
    },
    cache: false,
    ignore: !isLogged
  }),
      data = _useGQL.data,
      error = _useGQL.error;

  Object(react["useEffect"])(function () {
    // filter removed discounts from selectedVouchers
    var filteredSelectedVouchers = selectedVouchers.filter(function (voucher) {
      return initialDiscounts.includes(voucher);
    });
    setSelectedVouchers(filteredSelectedVouchers);
  }, [discounts]);
  Object(react["useEffect"])(function () {
    if (data && data.vouchers) {
      var codes = [];
      data.vouchers.forEach(function (voucher) {
        voucher.items.forEach(function (item) {
          if (item.advantageCode) {
            codes.push(item.advantageCode);
          }
        });
      });
      setVouchers(uniq_default()([].concat(Object(toConsumableArray["a" /* default */])(vouchers), codes)));
    }
  }, [data]);
  Object(react["useEffect"])(function () {
    if (vouchers.length > 0) {
      var dicountsValue = discounts.reduce(function (acc, discount) {
        var amount = discount.amount;

        if (amount && amount.value) {
          return acc + amount.value;
        }

        return acc;
      }, 0);
      js_cookie_default.a.set(constants["K" /* VOUCHER_CODE */], JSON.stringify(vouchers));
      js_cookie_default.a.set(constants["L" /* VOUCHER_DISCOUNT */], dicountsValue);
    } else {
      js_cookie_default.a.remove(constants["K" /* VOUCHER_CODE */]);
      js_cookie_default.a.remove(constants["L" /* VOUCHER_DISCOUNT */]);
    }
  }, [vouchers]);
  Object(useGQLErrorsHandler["a" /* useGQLErrorsHandler */])(error, {
    catchAuthError: true
  });

  var applyPromoCode = /*#__PURE__*/function () {
    var _ref3 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(_ref2) {
      var promoCode, partnerId, accessCode, normalizedPromoCode, params, _formikSetValues$curr, errorCode;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              promoCode = _ref2.promoCode, partnerId = _ref2.partnerId, accessCode = _ref2.accessCode;
              normalizedPromoCode = promoCode.toUpperCase();
              params = {
                promoCode: normalizedPromoCode,
                partnerId: partnerId,
                accessCode: accessCode,
                customerId: customerId
              };
              _context.prev = 3;
              setPromoCodeStatus(null);
              _context.next = 7;
              return dispatch(Object(proposals_action["e" /* applyProposalPromoCode */])(proposalId, params, context));

            case 7:
              setPromoCodeStatus('SUCCESS');
              trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_SUMMARY, {
                detail_click: 'validate_promotional_code'
              });
              setSelectedVouchers([].concat(Object(toConsumableArray["a" /* default */])(selectedVouchers), [normalizedPromoCode]));

              if (vouchers && !vouchers.includes(normalizedPromoCode)) {
                setVouchers([].concat(Object(toConsumableArray["a" /* default */])(vouchers), [normalizedPromoCode]));
              }

              (_formikSetValues$curr = formikSetValues.current) === null || _formikSetValues$curr === void 0 ? void 0 : _formikSetValues$curr.call(formikSetValues, {
                isUnfolded: false,
                promoCode: null
              }, false);
              _context.next = 18;
              break;

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](3);
              errorCode = get_default()(_context.t0, 'errors[0].errorCode');
              setPromoCodeStatus(errorCode);

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 14]]);
    }));

    return function applyPromoCode(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  var removePromoCode = /*#__PURE__*/function () {
    var _ref5 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee2(_ref4) {
      var promoCode, normalizedPromoCode, params, errorCode;
      return regenerator_default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              promoCode = _ref4.promoCode;
              normalizedPromoCode = promoCode.toUpperCase();
              params = {
                promoCode: normalizedPromoCode,
                customerId: customerId
              };
              _context2.prev = 3;
              setPromoCodeStatus(null);
              _context2.next = 7;
              return dispatch(Object(proposals_action["t" /* removeProposalPromoCode */])(proposalId, params, context));

            case 7:
              setSelectedVouchers(selectedVouchers.filter(function (v) {
                return v !== normalizedPromoCode;
              }));
              _context2.next = 14;
              break;

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](3);
              errorCode = get_default()(_context2.t0, 'errors[0].errorCode');
              setPromoCodeStatus(errorCode);

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[3, 10]]);
    }));

    return function removePromoCode(_x2) {
      return _ref5.apply(this, arguments);
    };
  }();

  return PromoCode_jsx("div", {
    "data-testid": "PromoCode"
  }, PromoCode_jsx("div", {
    className: "rounded-12 bg-pearl p-20"
  }, PromoCode_jsx("div", {
    className: "flex items-center gap-10 md:gap-20"
  }, PromoCode_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].PROMO_CODE,
    width: "1.875rem"
  }), isLogged ? Object(i18n["h" /* t */])('booking.priceDetails.promoCode.enableOrMoreLabel') : Object(i18n["h" /* t */])('booking.priceDetails.promoCode.enableLabel')), vouchers && vouchers.length > 0 && PromoCode_jsx("div", {
    "data-testid": "PromoCode-vouchers",
    className: "my-10 grid w-full gap-10 md:flex md:flex-wrap"
  }, vouchers.map(function (voucher) {
    return PromoCode_jsx(Button["a" /* Button */], {
      key: voucher,
      colorBg: selectedVouchers.includes(voucher) ? colors["a" /* COLORS */].BLACK : colors["a" /* COLORS */].WHITE,
      color: selectedVouchers.includes(voucher) ? colors["a" /* COLORS */].WHITE : colors["a" /* COLORS */].BLACK,
      colorBorder: colors["a" /* COLORS */].BLACK,
      iconRight: selectedVouchers.includes(voucher) ? {
        name: icons["a" /* ICONS */].CROSS
      } : null,
      minWidth: "auto",
      onClick: function onClick() {
        if (selectedVouchers.includes(voucher)) {
          removePromoCode({
            promoCode: voucher
          });
        } else {
          applyPromoCode({
            promoCode: voucher
          });
        }
      }
    }, voucher);
  })), PromoCode_jsx(DiscountsLine["a" /* DiscountsLine */], {
    discounts: discounts
  }), PromoCode_jsx(formik_esm["d" /* Formik */], {
    validateOnBlur: true,
    initialValues: {
      isUnfolded: !isLogged && selectedVouchers.length === 0 && vouchers.length === 0,
      promoCode: null
    },
    onSubmit: function onSubmit(_ref6, _ref7) {
      var promoCode = _ref6.promoCode;
      var setValues = _ref7.setValues;
      formikSetValues.current = setValues;

      if (promoCode.toUpperCase() === CODE_CIEL) {
        return setCodeCiel(promoCode);
      }

      applyPromoCode({
        promoCode: promoCode,
        setValues: setValues
      });
    }
  }, PromoCode_jsx(PromoCodeForm_PromoCodeForm, {
    selectedVouchers: selectedVouchers,
    shouldDisplayIsUnfolded: shouldDisplayIsUnfolded,
    promoCodeStatus: promoCodeStatus,
    setPromoCodeStatus: setPromoCodeStatus
  }))), codeCiel && PromoCode_jsx(PromoCodeModal_PromoCodeModal, {
    codeCiel: codeCiel,
    customerId: customerId,
    setCodeCiel: setCodeCiel,
    applyPromoCode: applyPromoCode
  }));
};

/***/ }),

/***/ "nT1c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return loadDurationValidity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isBookingOptionEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return doesDepartureDateAllowBookingOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getMinimumBookingOptionMinDeltaBeforeDepartureDate; });
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("CcNa");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _date_apiDate__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("ldK3");
/* harmony import */ var _feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("L7OA");






var loadDurationValidity = function loadDurationValidity(appContext) {
  var query = "\n    query {\n      locale {\n        optionValidity {\n          minDeltaBeforeDepartureDate\n          duration\n        }\n      }\n    }\n  ";
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery(query, appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* PROPOSAL_OPTION_VALIDITY */ "Tc"]
  });
};
var isBookingOptionEnabled = function isBookingOptionEnabled(appContext) {
  return Object(_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_5__[/* isFeatureFlipped */ "a"])(appContext)('booking.option');
};
var doesDepartureDateAllowBookingOption = function doesDepartureDateAllowBookingOption(departureDate, minDeltaBeforeDepartureDate) {
  var todayM = moment__WEBPACK_IMPORTED_MODULE_3___default()().format(_date_apiDate__WEBPACK_IMPORTED_MODULE_4__[/* API_DATE_FORMAT */ "a"]);
  var departureDateM = moment__WEBPACK_IMPORTED_MODULE_3___default()(departureDate, _date_apiDate__WEBPACK_IMPORTED_MODULE_4__[/* API_DATE_FORMAT */ "a"]);
  var diff = departureDateM.diff(todayM, 'days');
  return diff >= minDeltaBeforeDepartureDate;
};
var getMinimumBookingOptionMinDeltaBeforeDepartureDate = function getMinimumBookingOptionMinDeltaBeforeDepartureDate(optionValidityDuration) {
  return optionValidityDuration.reduce(function (prev, _ref) {
    var minDeltaBeforeDepartureDate = _ref.minDeltaBeforeDepartureDate;
    return prev === -1 || minDeltaBeforeDepartureDate < prev ? minDeltaBeforeDepartureDate : prev;
  }, -1);
};

/***/ }),

/***/ "oGbU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Reassurance; });
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("C/y5");
/* harmony import */ var _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("SPKZ");
/* harmony import */ var _components_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("qBqs");

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;




var Reassurance = function Reassurance(_ref) {
  var className = _ref.className,
      i18n = _ref.i18n;
  return __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_2__[/* classnames */ "a"])('flex flex-col items-center', className)
  }, __jsx(_components_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_4__[/* Icon */ "a"], {
    name: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__[/* ICONS */ "a"].PADLOCK,
    width: "3rem"
  }), __jsx("div", {
    className: "my-10 font-bold text-black"
  }, i18n.booking.banking.reassurance.paymentReassuranceSentence), __jsx("p", {
    className: "text-center text-black"
  }, i18n.booking.banking.reassurance.paymentReassuranceSentenceSubtitle), __jsx("div", {
    className: "flex justify-center"
  }, i18n.booking.banking.reassurance.paymentReassuranceLogos.map(function (logo) {
    return __jsx("img", {
      alt: "",
      className: "m-10 block h-80",
      key: logo,
      src: logo
    });
  })));
};

/***/ }),

/***/ "oMl1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ BookingBreadcrumb_BookingBreadcrumb; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("KqXw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("MvUL");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: ./src/i18n.js
var src_i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTrackEvent.js
var useTrackEvent = __webpack_require__("DqI1");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: /opt/webapp/node_modules/next/router.js
var next_router = __webpack_require__("Bkb1");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/components/widgets/hero/Hero.jsx
var Hero = __webpack_require__("2B1m");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/modal/Modal.jsx + 1 modules
var Modal = __webpack_require__("EvYw");

// CONCATENATED MODULE: ./src/client/components/widgets/edit-my-criteria/criteria/EditMyCriteriaPopin.jsx
var __jsx = react_default.a.createElement;





var EditMyCriteriaPopin_EditMyCriteriaPopin = function EditMyCriteriaPopin(_ref) {
  var onCloseModal = _ref.onCloseModal,
      onClickCancel = _ref.onClickCancel,
      onClickConfirm = _ref.onClickConfirm,
      mainIconName = _ref.mainIconName,
      cancelLabel = _ref.cancelLabel,
      confirmLabel = _ref.confirmLabel,
      titleLabel = _ref.titleLabel,
      messageLabel = _ref.messageLabel,
      _ref$isErrored = _ref.isErrored,
      isErrored = _ref$isErrored === void 0 ? false : _ref$isErrored,
      _ref$dataTestId = _ref.dataTestId,
      dataTestId = _ref$dataTestId === void 0 ? 'EditMyCriteriaPopin' : _ref$dataTestId;
  var textColor = isErrored ? 'text-red' : 'text-black';
  return __jsx(Modal["a" /* Modal */], {
    className: "overflow-hidden p-20",
    onClose: onCloseModal,
    size: "small"
  }, __jsx("div", {
    className: "flex flex-col items-center p-30",
    "data-testid": dataTestId
  }, __jsx("div", {
    className: "flex flex-1 pb-10"
  }, __jsx(Icon["a" /* Icon */], {
    className: textColor,
    name: mainIconName,
    width: "5em"
  })), __jsx("div", {
    className: "flex flex-1 pb-10"
  }, __jsx(Text["a" /* Text */], {
    className: "text-20 font-bold ".concat(textColor),
    text: titleLabel
  })), __jsx("div", {
    className: "flex flex-2 pb-10"
  }, __jsx(Text["a" /* Text */], {
    className: "text-center text-12 ".concat(textColor),
    text: messageLabel
  })), __jsx("div", {
    className: "flex w-full flex-1 justify-evenly"
  }, !!onClickCancel && __jsx(Button["a" /* Button */], {
    "data-testid": "modal-criteria-cancel-button",
    onClick: onClickCancel,
    theme: "link"
  }, cancelLabel), __jsx(Button["a" /* Button */], {
    isDisabled: false //add condition to disable validate if necessary towdow
    ,
    "data-testid": "modal-criteria-validation-button",
    onClick: onClickConfirm
  }, confirmLabel))));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// CONCATENATED MODULE: ./src/client/components/frameworks/step-nav/StepNav.themes.js
var themes = {
  "default": {
    thRoot: 'text-white',
    thList: 'flex items-end leading-0 text-12 sm:text-16',
    thListItem: 'mx-5 sm:mx-10',
    thListButton: 'border-0 border-b-2 border-solid border-transparent leading-0 pb-5 text-current transition-colors duration-250 ease-in',
    thListButtonActive: 'border-white text-28 sm:text-36',
    thListButtonDisabled: 'cursor-default',
    thListButtonVisited: 'text-18 sm:text-24',
    thListIconWidth: '0.9em',
    thButtonLabel: 'sr-only',
    thLabels: 'font-brand font-normal leading-1 mt-5 text-14',
    thActiveNumber: 'text-18 sm:text-20',
    thLabel: 'ms-10 text-18 sm:text-20'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/step-nav/StepNav.jsx


var StepNav_jsx = react_default.a.createElement;




var StepNav_StepNav = function StepNav(_ref) {
  var _ref$activeStep = _ref.activeStep,
      activeStep = _ref$activeStep === void 0 ? 0 : _ref$activeStep,
      _ref$ariaLabel = _ref.ariaLabel,
      ariaLabel = _ref$ariaLabel === void 0 ? 'progress' : _ref$ariaLabel,
      className = _ref.className,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      _ref$lastActiveStep = _ref.lastActiveStep,
      lastActiveStep = _ref$lastActiveStep === void 0 ? 0 : _ref$lastActiveStep,
      _onClick = _ref.onClick,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  if (!items.length) {
    return null;
  }

  var _themes$theme = themes[theme],
      thActiveNumber = _themes$theme.thActiveNumber,
      thButtonLabel = _themes$theme.thButtonLabel,
      thLabel = _themes$theme.thLabel,
      thLabels = _themes$theme.thLabels,
      thList = _themes$theme.thList,
      thListButton = _themes$theme.thListButton,
      thListButtonActive = _themes$theme.thListButtonActive,
      thListButtonDisabled = _themes$theme.thListButtonDisabled,
      thListButtonVisited = _themes$theme.thListButtonVisited,
      thListIconWidth = _themes$theme.thListIconWidth,
      thListItem = _themes$theme.thListItem,
      thRoot = _themes$theme.thRoot;
  return StepNav_jsx("nav", {
    "aria-label": ariaLabel,
    className: Object(classnames_utils["a" /* classnames */])(thRoot, className),
    "data-testid": "breadcrumb-steps"
  }, StepNav_jsx("ol", {
    className: thList
  }, items.map(function (_ref2, i) {
    var _classnames;

    var iconName = _ref2.iconName,
        id = _ref2.id,
        label = _ref2.label;
    return StepNav_jsx("li", {
      className: thListItem,
      key: id
    }, StepNav_jsx("button", {
      "aria-current": activeStep === i ? 'step' : null,
      className: Object(classnames_utils["a" /* classnames */])(thListButton, (_classnames = {}, Object(defineProperty["a" /* default */])(_classnames, thListButtonActive, activeStep === i), Object(defineProperty["a" /* default */])(_classnames, thListButtonVisited, i <= lastActiveStep && activeStep !== i), Object(defineProperty["a" /* default */])(_classnames, thListButtonDisabled, i > lastActiveStep), _classnames)),
      disabled: i > lastActiveStep,
      onClick: function onClick() {
        return _onClick(i);
      },
      type: "button"
    }, StepNav_jsx(Icon["a" /* Icon */], {
      name: iconName,
      width: thListIconWidth
    }), StepNav_jsx("span", {
      className: thButtonLabel
    }, label)));
  })), StepNav_jsx("p", {
    className: Object(classnames_utils["a" /* classnames */])(thLabels)
  }, StepNav_jsx("span", {
    className: thActiveNumber
  }, activeStep + 1), "/", items.length, ' ', StepNav_jsx("span", {
    className: thLabel
  }, items[activeStep].label)));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/utils/keyCodes.js
var keyCodes = __webpack_require__("05v4");

// EXTERNAL MODULE: ./src/client/components/frameworks/drop-down/DropDown.themes.js
var DropDown_themes = __webpack_require__("Q8Qh");

// CONCATENATED MODULE: ./src/client/components/frameworks/drop-down-simplified/DropDownSimplified.jsx
var DropDownSimplified_jsx = react_default.a.createElement;




var DropDownSimplified_DropDownSimplified = function DropDownSimplified(_ref) {
  var children = _ref.children,
      className = _ref.className,
      renderTrigger = _ref.renderTrigger,
      _ref$isExpanded = _ref.isExpanded,
      isExpanded = _ref$isExpanded === void 0 ? false : _ref$isExpanded,
      toggleExpansion = _ref.toggleExpansion,
      hasCloseOnClick = _ref.hasCloseOnClick,
      rootRef = _ref.rootRef,
      onClose = _ref.onClose,
      theme = _ref.theme;
  var contentRef = Object(react["useRef"])(null);
  var thisRootRef = Object(react["useRef"])(null);

  var collapse = function collapse() {
    if (onClose) {
      onClose();
    }
  };

  var onKeyDown = function onKeyDown(e) {
    if (e.keyCode === keyCodes["g" /* ESCAPE */]) {
      collapse();
    }
  };

  var onClickOutside = function onClickOutside(e) {
    var _rootRef$current;

    if (!contentRef || // $FlowFixMe
    contentRef.current.contains(e.target) || // $FlowFixMe
    thisRootRef.current.contains(e.target) || // $FlowFixMe
    e.offsetX > e.target.clientWidth || // $FlowFixMe
    e.offsetY > e.target.clientHeight || // $FlowFixMe
    (rootRef === null || rootRef === void 0 ? void 0 : rootRef.current) && (rootRef === null || rootRef === void 0 ? void 0 : (_rootRef$current = rootRef.current) === null || _rootRef$current === void 0 ? void 0 : _rootRef$current.contains(e.target)) || e.button && e.button !== 0) {
      return;
    }

    collapse();
  };

  var removeEventListeners = function removeEventListeners() {
    if (true) {
      document.removeEventListener('mouseup', onClickOutside, false);
      document.removeEventListener('touchstart', onClickOutside, false);
      document.removeEventListener('keydown', onKeyDown, false);
    }
  };

  var addEventListeners = function addEventListeners() {
    if (true) {
      document.addEventListener('mouseup', onClickOutside, false);
      document.addEventListener('touchstart', onClickOutside, false);
      document.addEventListener('keydown', onKeyDown, false);
    }
  };

  Object(react["useEffect"])(function () {
    if (isExpanded) {
      addEventListeners();
    } else {
      removeEventListeners();
    }

    return function () {
      removeEventListeners();
    };
  }, [isExpanded]);
  var thBody = Object(DropDown_themes["a" /* themes */])({})[theme].thBody;
  return DropDownSimplified_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('relative inline-block', className),
    ref: thisRootRef
  }, renderTrigger && renderTrigger(toggleExpansion, isExpanded), isExpanded && DropDownSimplified_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('absolute left-1/2 z-6 w-500 min-w-full -translate-x-1/2 transform', thBody),
    "data-testid": "DropDown-body-simplified",
    onClick: hasCloseOnClick ? collapse : null,
    onKeyPress: hasCloseOnClick ? collapse : null,
    ref: contentRef,
    role: "button",
    tabIndex: 0
  }, children(toggleExpansion, isExpanded)));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/layer/Layer.jsx + 4 modules
var Layer = __webpack_require__("U2fG");

// CONCATENATED MODULE: ./src/client/components/frameworks/drop-down-simplified/CriteriaFieldDropDownWrapper.jsx
var CriteriaFieldDropDownWrapper_jsx = react_default.a.createElement;






function CriteriaFieldDropDownWrapper(_ref) {
  var children = _ref.children,
      renderCriteriaButton = _ref.renderCriteriaButton,
      title = _ref.title,
      cancelEditCriteria = _ref.cancelEditCriteria,
      _ref$openByDefault = _ref.openByDefault,
      openByDefault = _ref$openByDefault === void 0 ? false : _ref$openByDefault,
      toggleEditCriteria = _ref.toggleEditCriteria,
      _ref$dataTestId = _ref.dataTestId,
      dataTestId = _ref$dataTestId === void 0 ? '' : _ref$dataTestId;

  var _useState = Object(react["useState"])(openByDefault),
      isExpanded = _useState[0],
      setIsExpanded = _useState[1];

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  Object(react["useEffect"])(function () {
    if (isExpanded !== openByDefault) {
      setIsExpanded(openByDefault);
    }
  }, [openByDefault]);

  var toggleExpanded = function toggleExpanded() {
    toggleEditCriteria && toggleEditCriteria(isExpanded);
    setIsExpanded(!isExpanded);
  };

  var onCancel = function onCancel() {
    cancelEditCriteria && cancelEditCriteria();
    toggleExpanded();
  };

  if (isTablet) {
    return CriteriaFieldDropDownWrapper_jsx(DropDownSimplified_DropDownSimplified, {
      isExpanded: isExpanded,
      onClose: onCancel,
      renderTrigger: renderCriteriaButton,
      toggleExpansion: toggleExpanded,
      theme: "hollow"
    }, children);
  }

  return CriteriaFieldDropDownWrapper_jsx("div", {
    "data-testid": dataTestId
  }, renderCriteriaButton(toggleExpanded, true), isExpanded ? CriteriaFieldDropDownWrapper_jsx(Layer["b" /* Layer */], {
    ariaLabel: title,
    buttonLeft: {
      iconName: icons["a" /* ICONS */].ARROW_TAIL_LEFT,
      label: Object(src_i18n["h" /* t */])('common.backNavigation'),
      onClick: onCancel
    },
    closeLabel: Object(src_i18n["h" /* t */])('common.close'),
    className: "z-4",
    hasAnimateEnter: true,
    onClose: onCancel
  }, CriteriaFieldDropDownWrapper_jsx("div", {
    className: "flex flex-col"
  }, children(toggleExpanded, isExpanded))) : null);
}
// CONCATENATED MODULE: ./src/client/components/widgets/edit-my-criteria/criteria/EditMyCriteriaFieldWrapper.jsx

var EditMyCriteriaFieldWrapper_jsx = react_default.a.createElement;








var EditMyCriteriaFieldWrapper_EditMyCriteriaFieldWrapper = function EditMyCriteriaFieldWrapper(_ref) {
  var children = _ref.children,
      className = _ref.className,
      disableValidateButton = _ref.disableValidateButton,
      toggleEditCriteria = _ref.toggleEditCriteria,
      updateCriteria = _ref.updateCriteria,
      trackCriteriaClick = _ref.trackCriteriaClick,
      cancelEditCriteria = _ref.cancelEditCriteria,
      triggerComponent = _ref.triggerComponent,
      openByDefault = _ref.openByDefault,
      _ref$dataTestId = _ref.dataTestId,
      dataTestId = _ref$dataTestId === void 0 ? '' : _ref$dataTestId;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var isMobile = !isTablet;
  return EditMyCriteriaFieldWrapper_jsx(CriteriaFieldDropDownWrapper, {
    cancelEditCriteria: cancelEditCriteria,
    toggleEditCriteria: toggleEditCriteria,
    openByDefault: openByDefault,
    renderCriteriaButton: function renderCriteriaButton(toggleButtonCriteriaExpansion, isCriteriaExpanded) {
      return EditMyCriteriaFieldWrapper_jsx("button", {
        "aria-expanded": isCriteriaExpanded,
        className: Object(classnames_utils["a" /* classnames */])('flex h-full items-stretch gap-5', className),
        onClick: function onClick() {
          trackCriteriaClick(); // toggle local state

          toggleButtonCriteriaExpansion();
        },
        type: "button"
      }, triggerComponent, EditMyCriteriaFieldWrapper_jsx(Icon["a" /* Icon */], {
        className: "self-center",
        name: icons["a" /* ICONS */].ARROW_DOWN,
        rotation: isCriteriaExpanded ? 180 : 0,
        width: "1em"
      }));
    },
    title: Object(src_i18n["h" /* t */])('booking.editCriteria.buttonLabel'),
    dataTestId: dataTestId
  }, function (toggleCriteriaExpansion) {
    return EditMyCriteriaFieldWrapper_jsx(react["Fragment"], null, react_default.a.Children.map(children, function (child) {
      if (typeof child.type === 'string') {
        return child;
      }

      return /*#__PURE__*/Object(react["cloneElement"])(children, {
        toggleCriteriaExpansion: toggleCriteriaExpansion
      });
    }), EditMyCriteriaFieldWrapper_jsx("div", {
      className: Object(classnames_utils["a" /* classnames */])({
        'fixed bottom-0 mt-auto flex w-full justify-center border-t-1 bg-white p-15 shadow': isMobile,
        'my-20 text-center': !isMobile
      })
    }, EditMyCriteriaFieldWrapper_jsx(Button["a" /* Button */], {
      "data-selector": "EditMyCriteriaDropDown-apply",
      "data-testid": "criteria-validation-button",
      isDisabled: disableValidateButton,
      onClick: function onClick() {
        // toggle criteria
        toggleCriteriaExpansion(); // update criteria value in EditMyCriteria

        updateCriteria && updateCriteria();
      }
    }, Object(src_i18n["h" /* t */])('booking.editCriteria.validateCriteria'))));
  });
};
// CONCATENATED MODULE: ./src/client/components/widgets/booking-breadcrumb/headerPopins.reducer.js









function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var initialPopinsState = {
  criteriaConfirmation: false,
  noProposalsFound: false
};
var popinsActions = {
  CLOSE_ALL_POPINS: 'CLOSE_ALL_POPINS',
  CRITERIA_CONFIRMATION_OPEN: 'CRITERIA_CONFIRMATION_OPEN',
  CRITERIA_CONFIRMATION_CLOSE: 'CRITERIA_CONFIRMATION_CLOSE',
  NO_PROPOSAL_OPEN: 'NO_PROPOSAL_OPEN',
  NO_PROPOSAL_CLOSE: 'NO_PROPOSAL_CLOSE'
};
var popinsReducer = function popinsReducer(popinsState, action) {
  switch (action.type) {
    case popinsActions.CRITERIA_CONFIRMATION_OPEN:
      return _objectSpread(_objectSpread({}, popinsState), {}, {
        criteriaConfirmation: true
      });

    case popinsActions.CRITERIA_CONFIRMATION_CLOSE:
      return _objectSpread(_objectSpread({}, popinsState), {}, {
        criteriaConfirmation: false
      });

    case popinsActions.NO_PROPOSAL_OPEN:
      return _objectSpread(_objectSpread({}, popinsState), {}, {
        noProposalsFound: true
      });

    case popinsActions.NO_PROPOSAL_CLOSE:
      return _objectSpread(_objectSpread({}, popinsState), {}, {
        noProposalsFound: false
      });

    case popinsActions.CLOSE_ALL_POPINS:
    default:
      return initialPopinsState;
  }
};
// CONCATENATED MODULE: ./src/client/components/widgets/booking-breadcrumb/edit-criteria-header/CriteriaWithPopOver.jsx








var CriteriaWithPopOver_jsx = react_default.a.createElement;

function CriteriaWithPopOver_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function CriteriaWithPopOver_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { CriteriaWithPopOver_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { CriteriaWithPopOver_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable react/no-unstable-nested-components */




var areEqualCriteria = function areEqualCriteria(criteria, newCriteria) {
  var criteriaString = JSON.stringify(criteria, null, 2);
  var newCriteriaString = JSON.stringify(newCriteria, null, 2);
  return criteriaString === newCriteriaString;
};

var CriteriaWithPopOver_CriteriaWithPopOver = function CriteriaWithPopOver(_ref) {
  var SelectorComponent = _ref.selectorComponent,
      PopOverComponent = _ref.popOverComponent,
      BlockBeforeValidateComponent = _ref.blockBeforeValidateComponent,
      selectedProposal = _ref.selectedProposal,
      criteria = _ref.criteria,
      setNewCriteria = _ref.setNewCriteria,
      newCriteria = _ref.newCriteria,
      dispatchPopin = _ref.dispatchPopin,
      onClickTracking = _ref.onClickTracking,
      validateButtonCriteriaSelectorTracking = _ref.validateButtonCriteriaSelectorTracking,
      i18n = _ref.i18n;
  var shouldDisableValidateButton = areEqualCriteria(criteria, newCriteria);

  var PopOverContent = function PopOverContent() {
    // $FlowFixMe
    return CriteriaWithPopOver_jsx(PopOverComponent, {
      criteria: criteria,
      setNewCriteria: setNewCriteria,
      newCriteria: newCriteria,
      i18n: i18n
    });
  };

  return CriteriaWithPopOver_jsx(EditMyCriteriaFieldWrapper_EditMyCriteriaFieldWrapper, {
    toggleEditCriteria: function toggleEditCriteria(isExpanded) {
      !isExpanded && setNewCriteria(CriteriaWithPopOver_objectSpread({}, criteria));
    },
    disableValidateButton: shouldDisableValidateButton,
    trackCriteriaClick: onClickTracking,
    openByDefault: false,
    triggerComponent: CriteriaWithPopOver_jsx(SelectorComponent, {
      newCriteria: newCriteria,
      criteria: criteria,
      selectedProposal: selectedProposal
    }),
    dataTestId: "EditMyCriteriaFieldWrapper",
    updateCriteria: function updateCriteria() {
      !!validateButtonCriteriaSelectorTracking && validateButtonCriteriaSelectorTracking();
      dispatchPopin({
        type: popinsActions.CRITERIA_CONFIRMATION_OPEN
      });
    }
  }, CriteriaWithPopOver_jsx("div", null, CriteriaWithPopOver_jsx(PopOverContent, {
    newCriteria: newCriteria
  }), !!BlockBeforeValidateComponent && CriteriaWithPopOver_jsx(BlockBeforeValidateComponent, null)));
};
// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// CONCATENATED MODULE: ./src/client/components/widgets/booking-breadcrumb/edit-criteria-header/HeaderCriteriaDates.jsx
var HeaderCriteriaDates_jsx = react_default.a.createElement;





var HeaderCriteriaDates_HeaderCriteriaDates = function HeaderCriteriaDates(_ref) {
  var selectedProposal = _ref.selectedProposal;
  var CONDENSED_DATE_FORMAT = Object(src_i18n["h" /* t */])('booking.common.condensedDateFormat');
  var dates = {
    endDate: Object(apiDate["g" /* formatApiDate */])(selectedProposal.departureDate, CONDENSED_DATE_FORMAT),
    startDate: Object(apiDate["g" /* formatApiDate */])(selectedProposal.arrivalDate, CONDENSED_DATE_FORMAT)
  };
  return HeaderCriteriaDates_jsx("span", {
    className: "md:max-w-none flex min-w-100 max-w-100 flex-1 items-center justify-center gap-10 rounded-8 border-1 border-solid border-white p-10 text-12 text-white sm:flex-none",
    "data-testid": "edit-my-criteria-when"
  }, HeaderCriteriaDates_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].DATE,
    width: "1.25rem"
  }), HeaderCriteriaDates_jsx("span", {
    className: "block font-bold",
    "data-testid": "HeaderCriteriaDates-dates"
  }, HeaderCriteriaDates_jsx("span", {
    className: "block leading-1"
  }, dates.startDate), HeaderCriteriaDates_jsx("span", {
    className: "block leading-1"
  }, dates.endDate)));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.search.js
var es_string_search = __webpack_require__("LJOr");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/criteria-when/filter-when/FilterWhen.jsx
var FilterWhen = __webpack_require__("qLhN");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./src/client/components/widgets/booking-breadcrumb/edit-criteria-header/CriteriaDatesSelectorContent.jsx










var CriteriaDatesSelectorContent_jsx = react_default.a.createElement;

function CriteriaDatesSelectorContent_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function CriteriaDatesSelectorContent_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { CriteriaDatesSelectorContent_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { CriteriaDatesSelectorContent_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var CriteriaDatesSelectorContent_CriteriaDatesSelectorContent = function CriteriaDatesSelectorContent(_ref) {
  var newCriteria = _ref.newCriteria,
      setNewCriteria = _ref.setNewCriteria,
      i18n = _ref.i18n;
  var dateFormat = Object(src_i18n["h" /* t */])('booking.priceDetails.packagePrice.dateFormat');
  return CriteriaDatesSelectorContent_jsx("div", {
    className: "text-black"
  }, CriteriaDatesSelectorContent_jsx(FilterWhen["a" /* FilterWhen */], {
    openCalendarToDate: newCriteria.departure.date,
    isSubmittable: false,
    optionsDuration: i18n.faceting.when.durations,
    openingDates: newCriteria.search.openingDates,
    duration: newCriteria.departure.duration,
    departureDate: newCriteria.departure.date,
    dateFormat: dateFormat,
    changeDepartureDate: function changeDepartureDate(date) {
      if (date) {
        setNewCriteria(CriteriaDatesSelectorContent_objectSpread(CriteriaDatesSelectorContent_objectSpread({}, newCriteria), {}, {
          departure: {
            date: moment_default()(date),
            duration: null
          }
        }));
      }
    },
    changeTripDuration: function changeTripDuration(duration) {
      if (duration) {
        setNewCriteria(CriteriaDatesSelectorContent_objectSpread(CriteriaDatesSelectorContent_objectSpread({}, newCriteria), {}, {
          departure: CriteriaDatesSelectorContent_objectSpread(CriteriaDatesSelectorContent_objectSpread({}, newCriteria.departure), {}, {
            duration: duration
          })
        }));
      }
    },
    offsetCalendar: newCriteria.search.offsetSell
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/booking-breadcrumb/edit-criteria-header/HeaderCriteriaAttendees.jsx
var HeaderCriteriaAttendees_jsx = react_default.a.createElement;



var HeaderCriteriaAttendees_HeaderCriteriaAttendees = function HeaderCriteriaAttendees(_ref) {
  var selectedProposal = _ref.selectedProposal;
  var attendeesNumber = selectedProposal.attendees.adults.length + selectedProposal.attendees.children.length;
  return HeaderCriteriaAttendees_jsx("span", {
    className: "flex min-w-80 max-w-80 flex-1 items-center justify-center gap-10 rounded-8 border-1 border-solid border-white p-10 text-12 leading-1 text-white sm:flex-none md:max-w-none",
    "data-testid": "edit-my-criteria-who"
  }, HeaderCriteriaAttendees_jsx(Icon["a" /* Icon */], {
    width: "1.25rem",
    name: icons["a" /* ICONS */].PEOPLE_DOUBLE
  }), HeaderCriteriaAttendees_jsx("span", {
    className: "font-bold underline",
    "data-testid": "HeaderCriteriaAttendees-attendeesNumber"
  }, attendeesNumber));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.fill.js
var es_array_fill = __webpack_require__("i4UL");

// EXTERNAL MODULE: ./src/utils/faceting/constants.js
var faceting_constants = __webpack_require__("sW3P");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/criteria-who/filter-who/FilterWho.jsx + 2 modules
var FilterWho = __webpack_require__("tUgU");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-validator-hoc/validationStates.js
var validationStates = __webpack_require__("45yR");

// EXTERNAL MODULE: ./src/utils/date/dateUtils.js
var dateUtils = __webpack_require__("L73y");

// CONCATENATED MODULE: ./src/client/components/widgets/booking-breadcrumb/edit-criteria-header/CriteriaAttendeesSelectorContent.jsx










var CriteriaAttendeesSelectorContent_jsx = react_default.a.createElement;

function CriteriaAttendeesSelectorContent_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function CriteriaAttendeesSelectorContent_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { CriteriaAttendeesSelectorContent_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { CriteriaAttendeesSelectorContent_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var CriteriaAttendeesSelectorContent_CriteriaAttendeesSelectorContent = function CriteriaAttendeesSelectorContent(_ref) {
  var _newCriteria$attendee;

  var newCriteria = _ref.newCriteria,
      setNewCriteria = _ref.setNewCriteria;
  var dateFormat = Object(src_i18n["h" /* t */])('booking.form.dateFormat');
  var dayPlaceholder = Object(src_i18n["h" /* t */])('booking.form.dayPlaceholder');
  var monthPlaceholder = Object(src_i18n["h" /* t */])('booking.form.monthPlaceholder');
  var yearPlaceholder = Object(src_i18n["h" /* t */])('booking.form.yearPlaceholder');
  return CriteriaAttendeesSelectorContent_jsx("div", {
    className: "text-black"
  }, CriteriaAttendeesSelectorContent_jsx(FilterWho["a" /* FilterWho */], {
    addChildcareLabel: Object(src_i18n["h" /* t */])('faceting.who.addChildcare'),
    adultsLabel: Object(src_i18n["h" /* t */])('faceting.who.adults'),
    adultsNumber: newCriteria === null || newCriteria === void 0 ? void 0 : (_newCriteria$attendee = newCriteria.attendees) === null || _newCriteria$attendee === void 0 ? void 0 : _newCriteria$attendee.adults,
    changeKid: function changeKid(kidNumber, newKid) {
      var _newCriteria$attendee2;

      var newCriteriakidsWithUpdatedKid = newCriteria === null || newCriteria === void 0 ? void 0 : (_newCriteria$attendee2 = newCriteria.attendees) === null || _newCriteria$attendee2 === void 0 ? void 0 : _newCriteria$attendee2.kids.map(function (kid, idx) {
        return kidNumber === idx ? CriteriaAttendeesSelectorContent_objectSpread(CriteriaAttendeesSelectorContent_objectSpread(CriteriaAttendeesSelectorContent_objectSpread({}, newKid), newKid.birthdate && !Object(dateUtils["f" /* isAdult */])(newKid.birthdate) ? {
          status: validationStates["b" /* IS_VALID */]
        } : {}), newKid.birthdate ? {
          birthdate: Object(apiDate["n" /* timestampToApiDate */])(newKid.birthdate)
        } : {}) : kid;
      });

      var newCriteriaUpdated = CriteriaAttendeesSelectorContent_objectSpread(CriteriaAttendeesSelectorContent_objectSpread({}, newCriteria), {}, {
        attendees: CriteriaAttendeesSelectorContent_objectSpread(CriteriaAttendeesSelectorContent_objectSpread({}, newCriteria === null || newCriteria === void 0 ? void 0 : newCriteria.attendees), {}, {
          kids: newCriteriakidsWithUpdatedKid
        })
      }); // $FlowFixMe


      setNewCriteria(newCriteriaUpdated);
    },
    changeKidsNumber: function changeKidsNumber(newKidNumber) {
      var _newCriteria$attendee3, _Array$fill;

      var criteriaKids = newCriteria === null || newCriteria === void 0 ? void 0 : (_newCriteria$attendee3 = newCriteria.attendees) === null || _newCriteria$attendee3 === void 0 ? void 0 : _newCriteria$attendee3.kids;
      var newKids = (_Array$fill = new Array(newKidNumber).fill({
        status: validationStates["a" /* IS_INVALID */],
        childcareIncluded: false
      })) === null || _Array$fill === void 0 ? void 0 : _Array$fill.map(function (kid, index) {
        return CriteriaAttendeesSelectorContent_objectSpread(CriteriaAttendeesSelectorContent_objectSpread({}, kid), criteriaKids[index]);
      }); // $FlowFixMe

      setNewCriteria(CriteriaAttendeesSelectorContent_objectSpread(CriteriaAttendeesSelectorContent_objectSpread({}, newCriteria), {}, {
        attendees: CriteriaAttendeesSelectorContent_objectSpread(CriteriaAttendeesSelectorContent_objectSpread({}, newCriteria === null || newCriteria === void 0 ? void 0 : newCriteria.attendees), {}, {
          kids: newKids
        })
      }));
    },
    dateFormat: dateFormat,
    dayPlaceholder: dayPlaceholder,
    kids: (newCriteria === null || newCriteria === void 0 ? void 0 : newCriteria.attendees.kids) || [],
    kidsAgeLabel: Object(src_i18n["h" /* t */])('faceting.who.ageSectionSubtitle'),
    kidsAgeLimitLabel: Object(src_i18n["h" /* t */])('faceting.who.kidsAgeLimit'),
    kidsLabel: Object(src_i18n["h" /* t */])('faceting.who.kids'),
    kidsValidationState: newCriteria === null || newCriteria === void 0 ? void 0 : newCriteria.attendees.kids.map(function (_ref2) {
      var status = _ref2.status;
      return status;
    }),
    label: Object(src_i18n["h" /* t */])('faceting.who.subTitle'),
    minAdultsNumber: faceting_constants["b" /* ADULTS_NUMBER_MIN */],
    monthPlaceholder: monthPlaceholder,
    setAdultsNumber: function setAdultsNumber(newAdultNumber) {
      // $FlowFixMe
      setNewCriteria(CriteriaAttendeesSelectorContent_objectSpread(CriteriaAttendeesSelectorContent_objectSpread({}, newCriteria), {}, {
        attendees: CriteriaAttendeesSelectorContent_objectSpread(CriteriaAttendeesSelectorContent_objectSpread({}, newCriteria === null || newCriteria === void 0 ? void 0 : newCriteria.attendees), {}, {
          adults: newAdultNumber
        })
      }));
    },
    updateOnInvalidBirthDate: true,
    validateKidsBirthdate: function validateKidsBirthdate(kidIdx) {
      newCriteria.attendees.kids.map(function (kid, index) {
        return index === kidIdx ? CriteriaAttendeesSelectorContent_objectSpread(CriteriaAttendeesSelectorContent_objectSpread({}, kid), {}, {
          status: validationStates["a" /* IS_INVALID */]
        }) : kid;
      });
    },
    yearPlaceholder: yearPlaceholder
  }));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: ./src/utils/booking-engine-pages/BookingPagesUtils.js
var BookingPagesUtils = __webpack_require__("rcxx");

// CONCATENATED MODULE: ./src/client/components/widgets/booking-breadcrumb/edit-criteria-header/HeaderCriteriaTransport.jsx





var HeaderCriteriaTransport_jsx = react_default.a.createElement;






var HeaderCriteriaTransport_HeaderCriteriaTransport = function HeaderCriteriaTransport(_ref) {
  var _criteria$departureCi;

  var criteria = _ref.criteria;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var transportValue = criteria === null || criteria === void 0 ? void 0 : (_criteria$departureCi = criteria.departureCity) === null || _criteria$departureCi === void 0 ? void 0 : _criteria$departureCi.value;

  var _useState = Object(react["useState"])([]),
      departureCitiesByProductId = _useState[0],
      setDepartureCitiesByProductId = _useState[1];

  Object(react["useEffect"])(function () {
    // this is to get the translated version of the departure city
    Object(BookingPagesUtils["h" /* getBookingCriteriaDepartureCities */])(criteria.search.value, appContext).then(function (_ref2) {
      var departureCities = _ref2.bookingCriteria.departureCities;
      var formattedDepartureCities = departureCities.map(function (_ref3) {
        var name = _ref3.name,
            value = _ref3.value;
        return {
          label: name,
          value: value
        };
      });
      setDepartureCitiesByProductId(formattedDepartureCities);
    });
  }, []);
  var selectedDepartureCity = Object(react["useMemo"])(function () {
    return departureCitiesByProductId.find(function (_ref4) {
      var value = _ref4.value;
      return value === transportValue;
    });
  }, [transportValue, departureCitiesByProductId]);
  return HeaderCriteriaTransport_jsx("div", {
    className: "flex min-w-80 max-w-80 flex-1 items-center justify-center gap-10 rounded-8 border-1 border-solid border-white p-10 text-14 leading-1 text-white sm:flex-none md:max-w-none",
    "data-testid": "edit-my-criteria-transport"
  }, HeaderCriteriaTransport_jsx(Icon["a" /* Icon */], {
    width: "1.25rem",
    name: transportValue !== 'NO' ? icons["a" /* ICONS */].TRANSPORT : icons["a" /* ICONS */].NO_TRANSPORT
  }), HeaderCriteriaTransport_jsx("span", {
    className: "hidden sm:block"
  }, (selectedDepartureCity === null || selectedDepartureCity === void 0 ? void 0 : selectedDepartureCity.label) || Object(src_i18n["h" /* t */])('booking.priceDetails.packagePrice.noTransport')));
};
// EXTERNAL MODULE: ./src/client/components/widgets/criteria/criteria-transport/filter-transport/FilterTransport.jsx
var FilterTransport = __webpack_require__("M3jp");

// CONCATENATED MODULE: ./src/client/components/widgets/booking-breadcrumb/edit-criteria-header/CriteriaTransportsSelectorContent.jsx













var CriteriaTransportsSelectorContent_jsx = react_default.a.createElement;

function CriteriaTransportsSelectorContent_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function CriteriaTransportsSelectorContent_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { CriteriaTransportsSelectorContent_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { CriteriaTransportsSelectorContent_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var CriteriaTransportsSelectorContent_CriteriaTransportsSelectorContent = function CriteriaTransportsSelectorContent(_ref) {
  var _newCriteria$departur;

  var newCriteria = _ref.newCriteria,
      setNewCriteria = _ref.setNewCriteria;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var noDepartureCitiesOptions = [{
    label: Object(src_i18n["h" /* t */])('booking.priceCalendar.priceStatus.noFlight'),
    value: ''
  }];

  var _useState = Object(react["useState"])([]),
      departureCitiesByProductId = _useState[0],
      setDepartureCitiesByProductId = _useState[1];

  Object(react["useEffect"])(function () {
    if (departureCitiesByProductId.length === 0) {
      Object(BookingPagesUtils["h" /* getBookingCriteriaDepartureCities */])(newCriteria.search.value, appContext).then(function (_ref2) {
        var departureCities = _ref2.bookingCriteria.departureCities;
        var formattedDepartureCities = departureCities.map(function (_ref3) {
          var name = _ref3.name,
              value = _ref3.value;
          return {
            label: name,
            value: value
          };
        });
        setDepartureCitiesByProductId(formattedDepartureCities);
      });
    }
  }, []);
  return CriteriaTransportsSelectorContent_jsx("div", {
    className: "text-black"
  }, CriteriaTransportsSelectorContent_jsx(FilterTransport["a" /* FilterTransport */], {
    changeDepartureCity: function changeDepartureCity(newDepartureCityId) {
      var newDepartureCity = (departureCitiesByProductId === null || departureCitiesByProductId === void 0 ? void 0 : departureCitiesByProductId.find(function (_ref4) {
        var value = _ref4.value;
        return value === newDepartureCityId;
      })) || {
        label: 'no transport',
        value: 'no'
      };
      !!newDepartureCity && setNewCriteria(CriteriaTransportsSelectorContent_objectSpread(CriteriaTransportsSelectorContent_objectSpread({}, newCriteria), {}, {
        departureCity: newDepartureCity
      }));
    },
    className: "h-full",
    dataTestId: "TransportCriteria-input",
    departureCity: (newCriteria === null || newCriteria === void 0 ? void 0 : (_newCriteria$departur = newCriteria.departureCity) === null || _newCriteria$departur === void 0 ? void 0 : _newCriteria$departur.value) || 'NO',
    isDisabled: !departureCitiesByProductId.length,
    labelDepartingFrom: Object(src_i18n["h" /* t */])('faceting.transport.departingFrom'),
    optionsDepartureCities: departureCitiesByProductId.length > 0 ? departureCitiesByProductId : noDepartureCitiesOptions,
    placeholderFrom: Object(src_i18n["h" /* t */])('faceting.transport.titleFrom'),
    selectPlaceholder: Object(src_i18n["h" /* t */])('faceting.transport.selectPlaceholder'),
    validateDepartureCity: function validateDepartureCity(noDepartureCityId) {
      var noDepartureCity = {
        value: noDepartureCityId || 'NO',
        label: ''
      };
      setNewCriteria(CriteriaTransportsSelectorContent_objectSpread(CriteriaTransportsSelectorContent_objectSpread({}, newCriteria), {}, {
        departureCity: noDepartureCity
      }));
    },
    shouldShowNoTransportButtonMobile: false,
    withNoTransport: true
  }));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/toast/Toast.jsx
var Toast = __webpack_require__("0x7Y");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: ./src/client/store/booking/proposals/proposals.action.js + 2 modules
var proposals_action = __webpack_require__("AnR0");

// EXTERNAL MODULE: ./src/utils/ple-utils/index.js + 1 modules
var ple_utils = __webpack_require__("6jSF");

// EXTERNAL MODULE: ./src/utils/uri/redirectUtils.js
var redirectUtils = __webpack_require__("k9PE");

// EXTERNAL MODULE: ./src/errors/errors.js + 4 modules
var errors = __webpack_require__("wNDy");

// CONCATENATED MODULE: ./src/client/components/widgets/booking-breadcrumb/EditCriteria.utils.js














function EditCriteria_utils_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function EditCriteria_utils_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? EditCriteria_utils_ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : EditCriteria_utils_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}










var EditCriteria_utils_getCriteriaFromProposal = function getCriteriaFromProposal(_ref) {
  var _proposal$transports, _proposal$transports$, _proposal$transports$2, _proposal$transports$3, _proposal$transports$4, _proposal$transports2, _proposal$transports3, _proposal$transports4, _proposal$transports5, _proposal$transports6, _resort$destination;

  var resort = _ref.resort,
      proposal = _ref.proposal,
      appContext = _ref.appContext;
  var departureCityId = ((_proposal$transports = proposal.transports) === null || _proposal$transports === void 0 ? void 0 : (_proposal$transports$ = _proposal$transports.inbound) === null || _proposal$transports$ === void 0 ? void 0 : (_proposal$transports$2 = _proposal$transports$.travelSections) === null || _proposal$transports$2 === void 0 ? void 0 : (_proposal$transports$3 = _proposal$transports$2[0]) === null || _proposal$transports$3 === void 0 ? void 0 : (_proposal$transports$4 = _proposal$transports$3.departure) === null || _proposal$transports$4 === void 0 ? void 0 : _proposal$transports$4.cityId) || 'NO';
  var departureCityLabel = (_proposal$transports2 = proposal.transports) === null || _proposal$transports2 === void 0 ? void 0 : (_proposal$transports3 = _proposal$transports2.inbound) === null || _proposal$transports3 === void 0 ? void 0 : (_proposal$transports4 = _proposal$transports3.travelSections) === null || _proposal$transports4 === void 0 ? void 0 : (_proposal$transports5 = _proposal$transports4[0]) === null || _proposal$transports5 === void 0 ? void 0 : (_proposal$transports6 = _proposal$transports5.departure) === null || _proposal$transports6 === void 0 ? void 0 : _proposal$transports6.label;
  var criteria = {
    search: {
      label: resort.name,
      value: resort.id,
      country: (_resort$destination = resort.destination) === null || _resort$destination === void 0 ? void 0 : _resort$destination.country,
      offsetSell: appContext.isSeller ? 0 : resort.offsetSell,
      openingDates: resort.openingDates || []
    },
    departure: {
      duration: proposal.duration,
      date: Object(apiDate["j" /* momentFromApiDate */])(proposal.arrivalDate)
    },
    attendees: {
      adults: proposal.attendees.adults.length,
      // $FlowFixMe birthdate is always defined in this case
      kids: proposal.attendees.children.map(function (_ref2) {
        var birthdate = _ref2.birthdate;
        return {
          birthdate: birthdate,
          status: validationStates["b" /* IS_VALID */],
          childcareIncluded: false
        };
      })
    },
    departureCity: {
      label: departureCityLabel,
      value: departureCityId
    }
  };
  return criteria;
};
var EditCriteria_utils_searchNewProposalsNewCriteria = function searchNewProposalsNewCriteria(_ref3) {
  var resort = _ref3.resort,
      criteria = _ref3.criteria,
      selectedProposal = _ref3.selectedProposal,
      router = _ref3.router,
      context = _ref3.context,
      dispatch = _ref3.dispatch,
      dispatchPopin = _ref3.dispatchPopin,
      setNewCriteria = _ref3.setNewCriteria,
      proposalsLoaderLabel = _ref3.proposalsLoaderLabel;
  var query = router.query;

  if ((criteria === null || criteria === void 0 ? void 0 : criteria.departure) && moment_default()(criteria.departure.date).isBefore(moment_default()().add(criteria.search.offsetSell, 'd'), 'day')) {
    // check if valid dates
    setNewCriteria(criteria);
  }

  dispatch(Object(proposals_action["j" /* editCriteriaFetchProposals */])(EditCriteria_utils_objectSpread(EditCriteria_utils_objectSpread({}, criteria), {}, {
    isJoyView: resort.isJoyview,
    isUrbanOasis: resort.isUrbanOasis
  }), proposalsLoaderLabel, context, query)).then(function (_ref4) {
    var _proposals$proposals, _proposals$proposals2;

    var proposals = _ref4.proposals;
    var newResort = proposals.resort;
    var newSelectedProposal = proposals === null || proposals === void 0 ? void 0 : (_proposals$proposals = proposals.proposals) === null || _proposals$proposals === void 0 ? void 0 : _proposals$proposals[0];

    if (proposals.errors || !selectedProposal || !(proposals === null || proposals === void 0 ? void 0 : (_proposals$proposals2 = proposals.proposals) === null || _proposals$proposals2 === void 0 ? void 0 : _proposals$proposals2.length)) {
      // no Availabilities or erros
      dispatchPopin({
        type: popinsActions.CRITERIA_CONFIRMATION_CLOSE
      });
      dispatchPopin({
        type: popinsActions.NO_PROPOSAL_OPEN
      });
      throw new errors["a" /* ApiException */](proposals.errors || 'No proposals found for this criteria');
    } else {
      dispatchPopin({
        type: popinsActions.CRITERIA_CONFIRMATION_CLOSE
      });

      var catId = query.catId,
          openLayer = query.openLayer,
          params = Object(objectWithoutProperties["a" /* default */])(query, ["catId", "openLayer"]);

      var queryParams = EditCriteria_utils_objectSpread(EditCriteria_utils_objectSpread({
        editCriteriaWarning: 'true'
      }, params), {}, {
        departure_city: criteria.departureCity.value
      }); // we have new proposals so we prepare and execute redirection to PAGE_BE_ACCOMMODATION


      var bookingUrl = Object(BookingPagesUtils["i" /* getBookingEngineUri */])(BookingPagesUtils["a" /* PAGE_BE_ACCOMMODATION */], proposals.proposals, resort, newSelectedProposal.id, queryParams);
      dispatch(Object(proposals_action["q" /* prepareBe */])({
        proposalId: newSelectedProposal.id,
        proposals: proposals,
        resort: newResort
      })); // $FlowFixMe

      router.push(bookingUrl);
      window.scrollTo(0, 0);
    }
  })["catch"](function (err) {
    dispatchPopin({
      type: popinsActions.CLOSE_ALL_POPINS
    });
    dispatchPopin({
      type: popinsActions.NO_PROPOSAL_OPEN
    }); // Redirect to oidc if the statusCode is 401

    if (ple_utils["l" /* hasAuthResponseError */](err)) {
      Object(redirectUtils["a" /* redirectToOidc */])(context);
    }
  });
};
// CONCATENATED MODULE: ./src/client/components/widgets/booking-breadcrumb/TransportIncentive.jsx
var TransportIncentive_jsx = react_default.a.createElement;




var TransportIncentive_TransportIncentive = function TransportIncentive() {
  return TransportIncentive_jsx("div", {
    className: "m-20 text-12 text-black"
  }, TransportIncentive_jsx("div", {
    className: "mb-15 flex gap-15 text-16 font-bold"
  }, TransportIncentive_jsx(Icon["a" /* Icon */], {
    className: "shrink-0 text-sienna",
    name: icons["a" /* ICONS */].ALL_INCLUSIVE
  }), Object(src_i18n["h" /* t */])('faceting.transport.departureCities.reinsurance')), TransportIncentive_jsx("div", {
    className: "mb-10"
  }, Object(src_i18n["h" /* t */])('faceting.transport.departureCities.guarantee')), TransportIncentive_jsx("div", null, Object(src_i18n["h" /* t */])('faceting.transport.departureCities.schedule')));
};
// CONCATENATED MODULE: ./src/client/components/widgets/booking-breadcrumb/BookingBreadcrumb.jsx




var BookingBreadcrumb_jsx = react_default.a.createElement;


























var EDIT_CRITERIA_TOAST_MS = 3000;
var BookingBreadcrumb_BookingBreadcrumb = function BookingBreadcrumb(_ref) {
  var resort = _ref.resort,
      selectedProposal = _ref.selectedProposal,
      activeStep = _ref.activeStep,
      backgroundImageSrc = _ref.backgroundImageSrc,
      _ref$canEdit = _ref.canEdit,
      canEdit = _ref$canEdit === void 0 ? true : _ref$canEdit,
      className = _ref.className,
      items = _ref.items,
      label = _ref.label,
      lastActiveStep = _ref.lastActiveStep,
      i18n = _ref.i18n,
      onClickStep = _ref.onClickStep;
  var router = Object(next_router["useRouter"])();
  var context = Object(ReactAppContext["c" /* useAppContext */])();

  var _useReducer = Object(react["useReducer"])(popinsReducer, initialPopinsState),
      popinsState = _useReducer[0],
      dispatchPopin = _useReducer[1];

  var dispatch = Object(es["d" /* useDispatch */])();

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var criteria = EditCriteria_utils_getCriteriaFromProposal({
    resort: resort,
    proposal: selectedProposal,
    appContext: context
  });

  var _useState = Object(react["useState"])(criteria),
      newCriteria = _useState[0],
      setNewCriteria = _useState[1];

  var _useState2 = Object(react["useState"])(true),
      shouldShowToastTimeOut = _useState2[0],
      setShouldShowToastTimeOut = _useState2[1];

  var isComingFromEditCriteria = typeof router.query.editCriteriaWarning !== 'undefined';
  Object(react["useEffect"])(function () {
    if (isComingFromEditCriteria) {
      setShouldShowToastTimeOut(true);
      var toastTimer = setTimeout(function () {
        setShouldShowToastTimeOut(false);
        var newUri = new URI_default.a(router.asPath).removeQuery(['editCriteriaWarning']);
        router.replace(newUri.toString());
      }, EDIT_CRITERIA_TOAST_MS);
      return function () {
        return clearTimeout(toastTimer);
      };
    }
  }, [router.query.editCriteriaWarning]);

  var cancelConfirmationPopin = function cancelConfirmationPopin() {
    setNewCriteria(criteria);
    dispatchPopin({
      type: popinsActions.CRITERIA_CONFIRMATION_CLOSE
    });
  };

  return BookingBreadcrumb_jsx("div", {
    className: "relative z-3 bg-black"
  }, BookingBreadcrumb_jsx("div", {
    className: "absolute inset-0 flex items-center overflow-hidden opacity-50"
  }, BookingBreadcrumb_jsx(Hero["a" /* Hero */], {
    className: "flex-1",
    url: backgroundImageSrc
  })), BookingBreadcrumb_jsx(SiteContainer["a" /* SiteContainer */], null, BookingBreadcrumb_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('relative z-3 flex h-130 flex-col justify-between py-10 text-white sm:flex-row md:h-80', className),
    "data-testid": "breadcrumb"
  }, BookingBreadcrumb_jsx(StepNav_StepNav, {
    activeStep: activeStep,
    ariaLabel: label,
    className: "sm:self-end",
    items: items,
    lastActiveStep: lastActiveStep,
    onClick: onClickStep
  }), canEdit && BookingBreadcrumb_jsx("div", {
    className: "order-first mb-10 flex justify-between gap-10 sm:order-last sm:mb-0 sm:py-5 md:gap-20"
  }, BookingBreadcrumb_jsx(CriteriaWithPopOver_CriteriaWithPopOver, {
    i18n: i18n,
    criteria: criteria,
    newCriteria: newCriteria,
    selectedProposal: selectedProposal,
    selectorComponent: HeaderCriteriaDates_HeaderCriteriaDates,
    popOverComponent: CriteriaDatesSelectorContent_CriteriaDatesSelectorContent,
    setNewCriteria: setNewCriteria,
    dispatchPopin: dispatchPopin,
    onClickTracking: function onClickTracking() {
      return trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_BREADCRUMB, {
        detail_click: 'edit_date'
      });
    },
    validateButtonCriteriaSelectorTracking: function validateButtonCriteriaSelectorTracking() {
      return trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_BREADCRUMB, {
        detail_click: 'edit_date_validate'
      });
    }
  }), BookingBreadcrumb_jsx(CriteriaWithPopOver_CriteriaWithPopOver, {
    i18n: i18n,
    criteria: criteria,
    newCriteria: newCriteria,
    selectedProposal: selectedProposal,
    selectorComponent: HeaderCriteriaAttendees_HeaderCriteriaAttendees,
    popOverComponent: CriteriaAttendeesSelectorContent_CriteriaAttendeesSelectorContent,
    setNewCriteria: setNewCriteria,
    dispatchPopin: dispatchPopin,
    onClickTracking: function onClickTracking() {
      return trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_BREADCRUMB, {
        detail_click: 'edit_participants'
      });
    },
    validateButtonCriteriaSelectorTracking: function validateButtonCriteriaSelectorTracking() {
      return trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_BREADCRUMB, {
        detail_click: 'edit_participants_validate'
      });
    }
  }), BookingBreadcrumb_jsx(CriteriaWithPopOver_CriteriaWithPopOver, {
    i18n: i18n,
    criteria: criteria,
    newCriteria: newCriteria,
    selectedProposal: selectedProposal,
    selectorComponent: HeaderCriteriaTransport_HeaderCriteriaTransport,
    popOverComponent: CriteriaTransportsSelectorContent_CriteriaTransportsSelectorContent,
    setNewCriteria: setNewCriteria,
    dispatchPopin: dispatchPopin,
    onClickTracking: function onClickTracking() {
      return trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_BREADCRUMB, {
        detail_click: 'edit_transport'
      });
    },
    validateButtonCriteriaSelectorTracking: function validateButtonCriteriaSelectorTracking() {
      return trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_BREADCRUMB, {
        detail_click: 'edit_transport_validate'
      });
    },
    blockBeforeValidateComponent: TransportIncentive_TransportIncentive
  }))), popinsState.criteriaConfirmation && BookingBreadcrumb_jsx(EditMyCriteriaPopin_EditMyCriteriaPopin, {
    mainIconName: icons["a" /* ICONS */].RECEIPT,
    onClickCancel: cancelConfirmationPopin,
    onClickConfirm: function onClickConfirm() {
      var searchNewProposalArgs = {
        resort: resort,
        criteria: newCriteria,
        router: router,
        context: context,
        proposalsLoaderLabel: Object(src_i18n["h" /* t */])('booking.form.proposalsLoaderLabel'),
        selectedProposal: selectedProposal,
        dispatch: dispatch,
        dispatchPopin: dispatchPopin,
        setNewCriteria: setNewCriteria
      };
      EditCriteria_utils_searchNewProposalsNewCriteria(searchNewProposalArgs);
      trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_BREADCRUMB, {
        detail_click: 'edit_confirmation'
      });
    },
    onCloseModal: cancelConfirmationPopin,
    confirmLabel: Object(src_i18n["h" /* t */])('common.confirm'),
    cancelLabel: Object(src_i18n["h" /* t */])('common.cancel'),
    titleLabel: Object(src_i18n["h" /* t */])('booking.editCriteria.buttonLabel'),
    messageLabel: Object(src_i18n["h" /* t */])('booking.editCriteria.alertMessage'),
    dataTestId: "EditMyCriteriaPopin-criteriaConfirmation"
  }), popinsState.noProposalsFound && BookingBreadcrumb_jsx(EditMyCriteriaPopin_EditMyCriteriaPopin, {
    mainIconName: icons["a" /* ICONS */].WARNING,
    onClickConfirm: function onClickConfirm() {
      setNewCriteria(criteria);
      dispatchPopin({
        type: popinsActions.CLOSE_ALL_POPINS
      });
    },
    onCloseModal: function onCloseModal() {
      return dispatchPopin({
        type: popinsActions.NO_PROPOSAL_CLOSE
      });
    },
    confirmLabel: Object(src_i18n["h" /* t */])('booking.editCriteria.backCriteria'),
    titleLabel: Object(src_i18n["h" /* t */])('booking.editCriteria.noAvailability'),
    messageLabel: Object(src_i18n["h" /* t */])('booking.editCriteria.errorMessage'),
    dataTestId: "EditMyCriteriaPopin-noProposalsFound",
    isErrored: true
  }), isComingFromEditCriteria && shouldShowToastTimeOut && BookingBreadcrumb_jsx(Toast["a" /* Toast */], {
    color: colors["a" /* COLORS */].GREEN,
    icon: icons["a" /* ICONS */].CHECK_OUTLINE,
    label: Object(src_i18n["h" /* t */])('booking.editCriteria.modificationSuccessMessage'),
    onClose: function onClose() {
      setShouldShowToastTimeOut(false);
    },
    visible: true
  })));
};

/***/ }),

/***/ "pteD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ TripDatePicker_TripDatePicker; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("7xRU");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-day-picker/DayPicker.js
var DayPicker = __webpack_require__("nFOY");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/components/frameworks/datepicker/Datepicker.jsx + 2 modules
var Datepicker = __webpack_require__("Dm6d");

// EXTERNAL MODULE: ./src/client/components/frameworks/datepicker/Datepicker.themes.js
var Datepicker_themes = __webpack_require__("MZFe");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("KqXw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("MvUL");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/debounce.js
var debounce = __webpack_require__("RNvQ");
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/Spinner.jsx
var Spinner = __webpack_require__("7amT");

// EXTERNAL MODULE: ./src/client/components/utils/price/price.util.js
var price_util = __webpack_require__("NXDx");

// EXTERNAL MODULE: ./src/client/components/utils/string/string.util.js
var string_util = __webpack_require__("tX1K");

// CONCATENATED MODULE: ./src/client/components/widgets/trip-date-picker/TripDatePicker.themes.js

var TripDatePicker_themes_themes = function themes(_ref) {
  var isBestPrice = _ref.isBestPrice,
      isHighlighted = _ref.isHighlighted,
      isSelectable = _ref.isSelectable,
      isSelected = _ref.isSelected,
      isTablet = _ref.isTablet,
      lastAvailability = _ref.lastAvailability,
      shouldDisplayDoubleSeasonButton = _ref.shouldDisplayDoubleSeasonButton,
      siblingOpen = _ref.siblingOpen;
  return {
    "default": {
      thDay: Object(classnames_utils["a" /* classnames */])("group flex flex-1 cursor-pointer flex-col items-center justify-center ".concat(isTablet ? 'h-100 p-5' : 'h-52', " relative border-r border-t border-grey text-center text-14 transition-all duration-250 ease-in"), {
        'text-black hocus:text-white': isSelectable
      }),
      thDayCornerMark: Object(classnames_utils["a" /* classnames */])({
        'corner-mark-tr-turquoise': siblingOpen && isTablet,
        'corner-mark-tr-turquoise-sm': siblingOpen && !isTablet
      }),
      thDayMessage: 'hidden md:inline w-full font-normal text-12',
      thDayNumber: Object(classnames_utils["a" /* classnames */])('left-0 top-0 text-10 md:absolute md:p-5', {
        'font-normal md:text-12': !isSelectable,
        'font-bold md:text-16': isSelectable,
        'text-current': siblingOpen
      }),
      thDayOldPrice: 'text-12 line-through hidden md:block text-current',
      thDayPrice: 'text-12 md:text-16',
      thStatusMessage: shouldDisplayDoubleSeasonButton ? "bg-turquoise cursor-pointer font-bold p-1 md:px-5 rounded-2 text-10 md:text-18 text-white uppercase".concat(!isTablet ? ' w-full' : '') : 'hidden md:inline w-full font-normal',
      thFrom: 'hidden md:inline w-full font-normal'
    },
    compact: {
      thDay: 'cursor-pointer flex flex-1 flex-col group items-center justify-center h-48 leading-tight relative text-14 text-center',
      thDayMessage: 'hidden',
      thDayNumberContainer: Object(classnames_utils["a" /* classnames */])('relative isolate'),
      thDayNumber: Object(classnames_utils["a" /* classnames */])('relative z-1', {
        'text-white': (lastAvailability || isBestPrice || siblingOpen) && isHighlighted,
        'text-grey group-hover:text-white': !lastAvailability && !isBestPrice && !siblingOpen && isHighlighted
      }),
      thDayUnavailable: 'line-through',
      thDayHighlight: 'absolute bg-current group-hover:bg-transparent h-26 left-1/2 rounded-4 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-26',
      thDayOldPrice: 'hidden',
      thDayPrice: Object(classnames_utils["a" /* classnames */])('mx-auto -mb-5 mt-5 block self-end text-10 font-bold', {
        'text-black group-hover:text-white': !isSelected,
        'text-white': isSelected
      }),
      thStatusMessage: 'hidden',
      thFrom: 'hidden',
      thShowPricePlaceholder: true
    }
  };
};
// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/widgets/product-price-info/ProductPriceInfo.jsx
var ProductPriceInfo = __webpack_require__("ZS6v");

// CONCATENATED MODULE: ./src/client/components/widgets/trip-date-picker/day-with-price/DayPriceDetails.jsx
var __jsx = react_default.a.createElement;




var DayPriceDetails_DayPriceDetails = function DayPriceDetails(_ref) {
  var day = _ref.day,
      duration = _ref.duration,
      departureCity = _ref.departureCity,
      hasTransport = _ref.hasTransport,
      isJoyview = _ref.isJoyview,
      isVisible = _ref.isVisible,
      setIsVisible = _ref.setIsVisible,
      shouldDisplayDetails = _ref.shouldDisplayDetails,
      unit = _ref.unit;
  Object(react["useEffect"])(function () {
    setIsVisible(shouldDisplayDetails);
  }, [shouldDisplayDetails]);
  var dateFormat = Object(i18n["h" /* t */])('resort.startingPrice.dateFormat');
  var startDate = moment_default()(day).format(dateFormat);
  var endDate = moment_default()(day).add({
    days: duration
  }).format(dateFormat);
  return isVisible && shouldDisplayDetails && __jsx("div", {
    className: "text-initial absolute left-1/2 top-0 z-2 w-400 -translate-x-1/2 transform font-normal"
  }, __jsx("div", {
    className: "animation-duration-500 absolute inset-x-0 bottom-full animate-fadeIn"
  }, __jsx("div", {
    className: "arrow-down arrow-large arrow-white rounded-12 bg-white shadow-md after:drop-shadow-md"
  }, __jsx(ProductPriceInfo["a" /* ProductPriceInfo */], {
    city: departureCity,
    endDate: endDate,
    hasTransport: hasTransport,
    isJoyview: isJoyview,
    startDate: startDate,
    unit: unit
  }))));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/modal/Modal.jsx + 1 modules
var Modal = __webpack_require__("EvYw");

// EXTERNAL MODULE: ./src/client/components/widgets/trip-date-picker/day-with-price/DayPriceDoubleSeasonPopin.jsx
var DayPriceDoubleSeasonPopin = __webpack_require__("uMuQ");

// CONCATENATED MODULE: ./src/client/components/widgets/trip-date-picker/day-with-price/DayPriceDoubleSeason.jsx
var DayPriceDoubleSeason_jsx = react_default.a.createElement;





var DayPriceDoubleSeason_DayPriceDoubleSeason = function DayPriceDoubleSeason(_ref) {
  var availability = _ref.availability,
      product = _ref.product,
      isMouseOverDoubleSeasonPopin = _ref.isMouseOverDoubleSeasonPopin,
      isVisible = _ref.isVisible,
      setInvisible = _ref.setInvisible,
      setIsMouseOverDoubleSeasonPopin = _ref.setIsMouseOverDoubleSeasonPopin,
      statusMessageKey = _ref.statusMessageKey;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var stopEventBubbling = function stopEventBubbling(e) {
    e.preventDefault();
    e.stopPropagation();
  };

  var closeModal = function closeModal(e) {
    stopEventBubbling(e);
    setInvisible();
  };

  var trackingData = {
    actionGA: 'calendarPrice'
  };
  return (isVisible || isMouseOverDoubleSeasonPopin) && DayPriceDoubleSeason_jsx("div", {
    onClick: stopEventBubbling
  }, isTablet ? DayPriceDoubleSeason_jsx("aside", {
    className: "arrow arrow-bg-lightGrey arrow-down arrow-white animation-duration-500 absolute bottom-full left-1/2 z-3 w-280 -translate-x-1/2 transform animate-fadeIn font-normal shadow-diffuse"
  }, DayPriceDoubleSeason_jsx("div", {
    className: "text-initial overflow-hidden rounded-12 border border-lightGrey bg-white"
  }, DayPriceDoubleSeason_jsx(DayPriceDoubleSeasonPopin["a" /* DayPriceDoubleSeasonPopin */], {
    availability: availability,
    product: product,
    setInvisible: setInvisible,
    setIsMouseOverDoubleSeasonPopin: setIsMouseOverDoubleSeasonPopin,
    statusMessageKey: statusMessageKey,
    trackingData: trackingData
  }))) : DayPriceDoubleSeason_jsx(Modal["a" /* Modal */], {
    closeLabel: Object(i18n["h" /* t */])('common.close'),
    onClose: closeModal,
    size: "small"
  }, DayPriceDoubleSeason_jsx(DayPriceDoubleSeasonPopin["a" /* DayPriceDoubleSeasonPopin */], {
    availability: availability,
    product: product,
    statusMessageKey: statusMessageKey,
    trackingData: trackingData
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/trip-date-picker/day-with-price/DayWithPrice.jsx




var DayWithPrice_jsx = react_default.a.createElement;

/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/click-events-have-key-events */

/* eslint-disable jsx-a11y/no-noninteractive-tabindex */











var COMPACT_MAX_CHARACTERS = 5;
var DayWithPrice_DayWithPrice = function DayWithPrice(_ref) {
  var day = _ref.day,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 7 : _ref$duration,
      _ref$hasInstalment = _ref.hasInstalment,
      hasInstalment = _ref$hasInstalment === void 0 ? false : _ref$hasInstalment,
      isJoyview = _ref.isJoyview,
      isLoading = _ref.isLoading,
      _ref$isSelectable = _ref.isSelectable,
      isSelectable = _ref$isSelectable === void 0 ? false : _ref$isSelectable,
      _ref$isSelected = _ref.isSelected,
      isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected,
      _ref$isHighlighted = _ref.isHighlighted,
      isHighlighted = _ref$isHighlighted === void 0 ? false : _ref$isHighlighted,
      locale = _ref.locale,
      _ref$price = _ref.price,
      availability = _ref$price.availability,
      currency = _ref$price.currency,
      departureCity = _ref$price.departureCity,
      hasTransport = _ref$price.hasTransport,
      isBestPrice = _ref$price.isBestPrice,
      lastAvailability = _ref$price.lastAvailability,
      formattedPriceValue = _ref$price.price,
      oldPrice = _ref$price.oldPrice,
      priceValue = _ref$price.priceValue,
      _ref$price$siblingOpe = _ref$price.siblingOpen,
      siblingOpen = _ref$price$siblingOpe === void 0 ? false : _ref$price$siblingOpe,
      unit = _ref$price.unit,
      product = _ref.product,
      selectedBestPrice = _ref.selectedBestPrice,
      selectedDuration = _ref.selectedDuration,
      selectedRealPrice = _ref.selectedRealPrice,
      shouldDisplayDetails = _ref.shouldDisplayDetails,
      shouldDisplayDoubleSeasonButton = _ref.shouldDisplayDoubleSeasonButton,
      shouldDisplayPrice = _ref.shouldDisplayPrice,
      shouldDisplaySelectedDepartureDateMessage = _ref.shouldDisplaySelectedDepartureDateMessage,
      shouldDisplaySelectedDepartureDateMessageWithPrice = _ref.shouldDisplaySelectedDepartureDateMessageWithPrice,
      shouldDisplaySelectedReturningDateMessage = _ref.shouldDisplaySelectedReturningDateMessage,
      shouldDisplayStatusMessage = _ref.shouldDisplayStatusMessage,
      theme = _ref.theme,
      withPriceDetails = _ref.withPriceDetails;

  var _useState = Object(react["useState"])(false),
      isMouseOverDoubleSeasonPopin = _useState[0],
      setIsMouseOverDoubleSeasonPopin = _useState[1];

  var _useState2 = Object(react["useState"])(false),
      isVisible = _useState2[0],
      setIsVisibleState = _useState2[1];

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop,
      isTablet = _useResponsive.isTablet;

  var statusMessageKey = "booking.priceCalendar.priceStatus.".concat(availability);
  var _themes$theme = TripDatePicker_themes_themes({
    isBestPrice: isBestPrice,
    isHighlighted: isHighlighted,
    isSelectable: isSelectable,
    isSelected: isSelected,
    isTablet: isTablet,
    lastAvailability: lastAvailability,
    shouldDisplayDoubleSeasonButton: shouldDisplayDoubleSeasonButton,
    siblingOpen: siblingOpen
  })[theme],
      thDayCornerMark = _themes$theme.thDayCornerMark,
      thDayMessage = _themes$theme.thDayMessage,
      thDayNumberContainer = _themes$theme.thDayNumberContainer,
      thDayNumber = _themes$theme.thDayNumber,
      thDayHighlight = _themes$theme.thDayHighlight,
      thDayOldPrice = _themes$theme.thDayOldPrice,
      thDayPrice = _themes$theme.thDayPrice,
      thStatusMessage = _themes$theme.thStatusMessage,
      thFrom = _themes$theme.thFrom,
      thShowPricePlaceholder = _themes$theme.thShowPricePlaceholder;

  var setIsVisible = debounce_default()(function (visible) {
    setIsVisibleState(visible);
  }, 150);

  var setVisible = function setVisible() {
    if (!isVisible) {
      setIsVisible(true);
    }
  };

  var setInvisible = function setInvisible() {
    setIsVisible(false);
  };

  var getCompactPrice = function getCompactPrice(rawPrice) {
    var compactPrice = (rawPrice === null || rawPrice === void 0 ? void 0 : rawPrice.replace(/[\s|.,]/gi, '')) || '';
    return compactPrice.length <= COMPACT_MAX_CHARACTERS ? compactPrice : DayWithPrice_jsx("span", {
      className: "text-8 md:mx-1 md:px-1 md:text-10"
    }, compactPrice);
  };

  var price = hasInstalment ? Object(price_util["b" /* getInstallmentPrice */])({
    currency: currency,
    formattedValue: formattedPriceValue,
    value: priceValue
  }, locale) : formattedPriceValue;
  var selectedPrice = selectedRealPrice || selectedBestPrice;
  var isDateSelectable = ['open', 'noDeparture'].includes(availability);
  return DayWithPrice_jsx(react["Fragment"], null, DayWithPrice_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])({
      'absolute inset-0 z-3 h-full w-full': withPriceDetails || shouldDisplayDoubleSeasonButton,
      'pointer-events-auto': shouldDisplayDoubleSeasonButton
    }),
    "data-testid": "price-calendar-date",
    onBlur: function onBlur() {
      if (isDesktop) {
        setInvisible();
      }
    },
    onClick: function onClick(e) {
      if (shouldDisplayDoubleSeasonButton) {
        e.preventDefault();
        e.stopPropagation();

        if (!isDesktop) {
          setVisible();
        }
      }
    },
    onFocus: function onFocus() {
      if (isDesktop) {
        setVisible();
      }
    },
    onMouseLeave: function onMouseLeave() {
      if (isDesktop) {
        setInvisible();
      }
    },
    onMouseOver: function onMouseOver() {
      if (isDesktop) {
        setVisible();
      }
    },
    tabIndex: 0
  }), siblingOpen && DayWithPrice_jsx("span", {
    className: thDayCornerMark
  }), withPriceDetails && DayWithPrice_jsx(DayPriceDetails_DayPriceDetails, {
    duration: duration,
    departureCity: departureCity,
    hasTransport: hasTransport,
    isJoyview: isJoyview,
    isVisible: isVisible,
    setIsVisible: setIsVisible,
    shouldDisplayDetails: !!price && shouldDisplayDetails,
    day: day,
    unit: unit
  }), product && siblingOpen && shouldDisplayDoubleSeasonButton && DayWithPrice_jsx(DayPriceDoubleSeason_DayPriceDoubleSeason, {
    availability: availability,
    product: product,
    isMouseOverDoubleSeasonPopin: isMouseOverDoubleSeasonPopin,
    isVisible: isVisible,
    setInvisible: setInvisible,
    setIsMouseOverDoubleSeasonPopin: setIsMouseOverDoubleSeasonPopin,
    setVisible: setVisible,
    statusMessageKey: statusMessageKey
  }), (!shouldDisplayDoubleSeasonButton || isTablet) && DayWithPrice_jsx("div", {
    className: thDayNumberContainer
  }, DayWithPrice_jsx("span", {
    className: Object(classnames_utils["a" /* classnames */])(thDayNumber)
  }, moment_default()(day).format('D')), isHighlighted && DayWithPrice_jsx("div", {
    className: thDayHighlight
  })), shouldDisplayStatusMessage && Object(i18n["f" /* has */])(statusMessageKey) && !price && !isLoading && (siblingOpen ? shouldDisplayDoubleSeasonButton && DayWithPrice_jsx("span", {
    className: Object(classnames_utils["a" /* classnames */])(thStatusMessage, {
      'shadow-md': isVisible || isMouseOverDoubleSeasonPopin
    })
  }, Object(i18n["h" /* t */])(statusMessageKey)) : DayWithPrice_jsx("span", {
    className: thStatusMessage
  }, Object(i18n["h" /* t */])(statusMessageKey))), shouldDisplaySelectedDepartureDateMessage && DayWithPrice_jsx("div", {
    className: thDayMessage
  }, Object(i18n["h" /* t */])('booking.priceCalendar.selectedDepartureDateMessage').toUpperCase(), ' ', DayWithPrice_jsx("div", {
    className: "mt-5"
  }, Object(i18n["h" /* t */])('booking.priceCalendar.endDateMessage'))), shouldDisplaySelectedDepartureDateMessageWithPrice && DayWithPrice_jsx("div", {
    className: thDayMessage
  }, Object(i18n["h" /* t */])('booking.priceCalendar.selectedDepartureDateMessage').toUpperCase(), selectedPrice && selectedDuration && DayWithPrice_jsx("div", {
    className: "flex flex-col"
  }, DayWithPrice_jsx("span", null, Object(i18n["h" /* t */])('price.format.unitTotalPerTripIndicative').toUpperCase()), DayWithPrice_jsx("span", {
    className: "text-12 font-bold leading-tight md:text-16",
    "data-testid": "selected-date-best-price"
  }, theme === 'compact' ? getCompactPrice(selectedPrice) : selectedPrice))), shouldDisplaySelectedReturningDateMessage && DayWithPrice_jsx("div", {
    className: thDayMessage
  }, Object(i18n["h" /* t */])('booking.priceCalendar.selectedReturningDateMessage').toUpperCase()), isLoading ? DayWithPrice_jsx(Spinner["a" /* Spinner */], {
    size: "tiny",
    className: "text-black"
  }) : DayWithPrice_jsx(react["Fragment"], null, shouldDisplayPrice && !!price && DayWithPrice_jsx("div", {
    className: "flex flex-col text-current",
    "data-testid": "price-calendar-date-price"
  }, !!price && DayWithPrice_jsx("span", {
    className: thFrom
  }, Object(i18n["h" /* t */])('price.format.from')), DayWithPrice_jsx("span", {
    "data-testid": "price",
    className: thDayPrice
  }, theme === 'compact' ? getCompactPrice(price) : price), price !== oldPrice && DayWithPrice_jsx("span", {
    className: thDayOldPrice
  }, oldPrice)), thShowPricePlaceholder && (!shouldDisplayPrice || !price) && DayWithPrice_jsx("span", {
    className: Object(classnames_utils["a" /* classnames */])(thDayPrice, {
      'opacity-0': !isDateSelectable
    })
  }, isDateSelectable ? Object(string_util["d" /* truncate */])(Object(i18n["h" /* t */])('faceting.when.dateSelect'), 6) : DayWithPrice_jsx(react_default.a.Fragment, null, "\xA0"))));
};
// EXTERNAL MODULE: ./src/client/components/widgets/trip-date-picker/TripDatePicker.utils.js
var TripDatePicker_utils = __webpack_require__("RqHf");

// CONCATENATED MODULE: ./src/client/components/widgets/trip-date-picker/TripDatePicker.jsx








var TripDatePicker_jsx = react_default.a.createElement;














var selector = function selector(state) {
  var _state$calendar;

  return {
    isBookableDatesLoading: state === null || state === void 0 ? void 0 : (_state$calendar = state.calendar) === null || _state$calendar === void 0 ? void 0 : _state$calendar.bookableDatesLoading
  };
}; // $FlowFixMe


var Weekday = function Weekday(_ref) {
  var weekday = _ref.weekday,
      className = _ref.className,
      localeUtils = _ref.localeUtils,
      locale = _ref.locale;
  var weekdayName = localeUtils.formatWeekdayLong(weekday, locale);
  return TripDatePicker_jsx("div", {
    className: className,
    title: weekdayName
  }, weekdayName);
};

var TripDatePicker_TripDatePicker = function TripDatePicker(_ref2) {
  var _modifiers;

  var className = _ref2.className,
      departureDate = _ref2.departureDate,
      duration = _ref2.duration,
      hasInstalment = _ref2.hasInstalment,
      isJoyview = _ref2.isJoyview,
      navbarElement = _ref2.navbarElement,
      navigationByYear = _ref2.navigationByYear,
      offsetCalendar = _ref2.offsetCalendar,
      onDayMouseOver = _ref2.onDayMouseOver,
      onSelect = _ref2.onSelect,
      openCalendarToDate = _ref2.openCalendarToDate,
      openingDates = _ref2.openingDates,
      optionsDuration = _ref2.optionsDuration,
      prices = _ref2.prices,
      product = _ref2.product,
      selectedBestPrice = _ref2.selectedBestPrice,
      _ref2$selectedDays = _ref2.selectedDays,
      from = _ref2$selectedDays.from,
      to = _ref2$selectedDays.to,
      selectedDuration = _ref2.selectedDuration,
      selectedMonth = _ref2.selectedMonth,
      selectedRealPrice = _ref2.selectedRealPrice,
      _ref2$shouldAllowSele = _ref2.shouldAllowSelectingSiblingOpenDays,
      shouldAllowSelectingSiblingOpenDays = _ref2$shouldAllowSele === void 0 ? false : _ref2$shouldAllowSele,
      _ref2$theme = _ref2.theme,
      theme = _ref2$theme === void 0 ? 'default' : _ref2$theme,
      withLongDayFormat = _ref2.withLongDayFormat,
      _ref2$withPriceDetail = _ref2.withPriceDetails,
      withPriceDetails = _ref2$withPriceDetail === void 0 ? false : _ref2$withPriceDetail,
      props = Object(objectWithoutProperties["a" /* default */])(_ref2, ["className", "departureDate", "duration", "hasInstalment", "isJoyview", "navbarElement", "navigationByYear", "offsetCalendar", "onDayMouseOver", "onSelect", "openCalendarToDate", "openingDates", "optionsDuration", "prices", "product", "selectedBestPrice", "selectedDays", "selectedDuration", "selectedMonth", "selectedRealPrice", "shouldAllowSelectingSiblingOpenDays", "theme", "withLongDayFormat", "withPriceDetails"]);

  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var _props$displayPrices = props.displayPrices,
      displayPrices = _props$displayPrices === void 0 ? Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('datePicker.displayPrices') : _props$displayPrices;

  var _useSelector = Object(es["e" /* useSelector */])(selector),
      isBookableDatesLoading = _useSelector.isBookableDatesLoading;

  var onMouseOver = function onMouseOver(day) {
    onDayMouseOver && onDayMouseOver(day);
  };

  var pricesIds = Object.keys(prices || {});
  var flattenedPrices = prices ? Object(TripDatePicker_utils["f" /* flattenPrices */])(prices) : '';
  var hasPrices = pricesIds.length > 0;
  var doDisplayPricesInDatePicker = hasPrices && displayPrices || theme === 'compact';
  var bothDatesSelected = Boolean(from && to);
  var resolvePrice = Object(react["useCallback"])(function (dayId) {
    return get_default()(prices, "[".concat(dayId, "]"), {});
  }, [flattenedPrices]);
  var isSeller = appContext.isSeller,
      locale = appContext.locale;
  var disabledDays = Object(react["useMemo"])(function () {
    return Object(TripDatePicker_utils["g" /* getDisabledDays */])({
      from: from,
      to: to,
      prices: prices,
      isSeller: isSeller,
      optionsDuration: optionsDuration,
      openingDates: openingDates,
      resolvePrice: resolvePrice,
      shouldAllowSelectingSiblingOpenDays: shouldAllowSelectingSiblingOpenDays
    });
  }, [from, isSeller, optionsDuration.join(), flattenedPrices, to]);
  var dayIsClosed = Object(react["useCallback"])(Object(TripDatePicker_utils["b" /* closedDaysFactory */])(resolvePrice, from, moment_default()(to).subtract(1, 'day').toDate(), shouldAllowSelectingSiblingOpenDays), [from, to, flattenedPrices]);
  var modifiers = (_modifiers = {}, Object(defineProperty["a" /* default */])(_modifiers, TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].DARK_GREY, Object(TripDatePicker_utils["h" /* getPriceColor */])({
    classColor: TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].DARK_GREY,
    from: from,
    hasPrices: hasPrices,
    resolvePrice: resolvePrice,
    selectedMonth: selectedMonth,
    to: to
  })), Object(defineProperty["a" /* default */])(_modifiers, TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].GREEN, Object(TripDatePicker_utils["h" /* getPriceColor */])({
    classColor: TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].GREEN,
    from: from,
    hasPrices: hasPrices,
    resolvePrice: resolvePrice,
    selectedMonth: selectedMonth,
    to: to
  })), Object(defineProperty["a" /* default */])(_modifiers, TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].GREEN_OPACITY_45, Object(TripDatePicker_utils["h" /* getPriceColor */])({
    classColor: TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].GREEN_OPACITY_45,
    from: from,
    hasPrices: hasPrices,
    resolvePrice: resolvePrice,
    selectedMonth: selectedMonth,
    to: to
  })), Object(defineProperty["a" /* default */])(_modifiers, TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].GREY, Object(TripDatePicker_utils["h" /* getPriceColor */])({
    classColor: TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].GREY,
    from: from,
    hasPrices: hasPrices,
    resolvePrice: resolvePrice,
    selectedMonth: selectedMonth,
    to: to
  })), Object(defineProperty["a" /* default */])(_modifiers, TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].ORANGE, Object(TripDatePicker_utils["h" /* getPriceColor */])({
    classColor: TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].ORANGE,
    from: from,
    hasPrices: hasPrices,
    resolvePrice: resolvePrice,
    selectedMonth: selectedMonth,
    to: to
  })), Object(defineProperty["a" /* default */])(_modifiers, TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].ORANGE_OPACITY_45, Object(TripDatePicker_utils["h" /* getPriceColor */])({
    classColor: TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].ORANGE_OPACITY_45,
    from: from,
    hasPrices: hasPrices,
    resolvePrice: resolvePrice,
    selectedMonth: selectedMonth,
    to: to
  })), Object(defineProperty["a" /* default */])(_modifiers, TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].WHITE, Object(TripDatePicker_utils["h" /* getPriceColor */])({
    classColor: TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].WHITE,
    from: from,
    hasPrices: hasPrices,
    resolvePrice: resolvePrice,
    selectedMonth: selectedMonth,
    to: to
  })), Object(defineProperty["a" /* default */])(_modifiers, TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].TURQUOISE, Object(TripDatePicker_utils["h" /* getPriceColor */])({
    classColor: TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].TURQUOISE,
    from: from,
    hasPrices: hasPrices,
    resolvePrice: resolvePrice,
    selectedMonth: selectedMonth,
    to: to
  })), Object(defineProperty["a" /* default */])(_modifiers, '!text-lightGrey', disabledDays), Object(defineProperty["a" /* default */])(_modifiers, "disabledDays", disabledDays), Object(defineProperty["a" /* default */])(_modifiers, "firstSiblingOpenDayOfSelectedMonth", Object(TripDatePicker_utils["e" /* firstSiblingOpenDayOfSelectedMonthFactory */])(resolvePrice, selectedMonth)), Object(defineProperty["a" /* default */])(_modifiers, "siblingOpenDays", Object(TripDatePicker_utils["k" /* siblingOpenDaysFactory */])(resolvePrice)), Object(defineProperty["a" /* default */])(_modifiers, 'pointer-events-none', function pointerEventsNone(day) {
    var dayIsSelected = from && to && Object(TripDatePicker_utils["d" /* dateToInt */])(day) >= Object(TripDatePicker_utils["d" /* dateToInt */])(from) && Object(TripDatePicker_utils["d" /* dateToInt */])(day) <= Object(TripDatePicker_utils["d" /* dateToInt */])(to);

    if (hasPrices && dayIsSelected) {
      return dayIsClosed(day);
    }
  }), _modifiers);
  var firstDateWithPrices = Object(react["useMemo"])(function () {
    var today = Object(TripDatePicker_utils["d" /* dateToInt */])(new Date());
    var dayWithPrice = pricesIds.find(function (pricesKey) {
      return Object(TripDatePicker_utils["d" /* dateToInt */])(moment_default()(pricesKey, apiDate["a" /* API_DATE_FORMAT */]).toDate()) > today && prices && prices[pricesKey].available;
    });
    return dayWithPrice || null;
  }, [JSON.stringify(flattenedPrices)]);
  var firstDateOpened = Object(react["useMemo"])(function () {
    if (!Array.isArray(openingDates) || openingDates.length === 0) {
      return null;
    }

    var _openingDates = Object(slicedToArray["a" /* default */])(openingDates, 1),
        opening = _openingDates[0].opening;

    return opening;
  }, [JSON.stringify(openingDates)]);
  var thDay = TripDatePicker_themes_themes({
    isTablet: isTablet
  })[theme].thDay; // If bookable dates are loading only define current or selected day as range

  var datesRange = isBookableDatesLoading ? {
    min: moment_default()(from).toDate(),
    max: moment_default()(from).toDate()
  } : {
    min: Object(TripDatePicker_utils["j" /* minDatepickerDate */])(offsetCalendar),
    max: Object(TripDatePicker_utils["i" /* maxDatepickerDate */])()
  };

  var _useState = Object(react["useState"])(openCalendarToDate),
      openCalendarDate = _useState[0],
      setOpenCalendarDate = _useState[1];

  Object(react["useEffect"])(function () {
    setOpenCalendarDate(openCalendarToDate);
  }, [moment_default()(openCalendarToDate).format(apiDate["a" /* API_DATE_FORMAT */])]);
  Object(react["useEffect"])(function () {
    if (from) {
      setOpenCalendarDate(from);
    }
  }, [moment_default()(from).format(apiDate["a" /* API_DATE_FORMAT */])]);
  var initialMonth = Object(react["useMemo"])(function () {
    return moment_default()(openCalendarDate || from || firstDateWithPrices || firstDateOpened || Object(TripDatePicker_utils["j" /* minDatepickerDate */])(offsetCalendar)).toDate();
  }, [moment_default()(openCalendarDate).format(apiDate["a" /* API_DATE_FORMAT */]), moment_default()(from).format(apiDate["a" /* API_DATE_FORMAT */]), moment_default()(firstDateWithPrices).format(apiDate["a" /* API_DATE_FORMAT */]), moment_default()(firstDateOpened).format(apiDate["a" /* API_DATE_FORMAT */]), offsetCalendar]);
  return TripDatePicker_jsx(Datepicker["a" /* Datepicker */], Object(esm_extends["a" /* default */])({
    hasRangeMode: true,
    className: className,
    selectedDays: {
      from: from,
      to: to
    },
    disabledDays: disabledDays,
    customModifiers: modifiers,
    hasNavigationByYear: navigationByYear,
    minDate: datesRange.min,
    maxDate: datesRange.max,
    navbarElement: navbarElement,
    initialMonth: initialMonth,
    onSelect: onSelect,
    onMouseOver: onMouseOver,
    onFocus: onMouseOver,
    theme: theme,
    shouldHoverSiblingOpenDays: shouldAllowSelectingSiblingOpenDays,
    weekdayElement: withLongDayFormat ? TripDatePicker_jsx(Weekday, null) : undefined
  }, doDisplayPricesInDatePicker ? {
    // eslint-disable-next-line clubmed/no-fake-component
    renderDay: function renderDay(day, dayModifiers) {
      var shouldDisplayPrice = theme === 'compact' ? hasPrices && !dayModifiers[Datepicker_themes["a" /* themes */][theme].thDayPicker.selected] : hasPrices && !to && !moment_default()(from).isSame(day, 'day');
      var price = resolvePrice(Object(TripDatePicker_utils["d" /* dateToInt */])(day));
      return TripDatePicker_jsx(DayWithPrice_DayWithPrice, {
        day: day,
        duration: duration,
        hasInstalment: hasInstalment,
        hasPrices: hasPrices,
        isSelectable: Boolean(!dayModifiers.disabledDays && from && !to && !DayPicker["DateUtils"].isSameDay(day, from)),
        isSelected: Boolean(dayModifiers[Datepicker_themes["a" /* themes */][theme].thDayPicker.selected]),
        isLoading: departureDate && isBookableDatesLoading && moment_default()(day).isAfter(departureDate) ? true : false,
        isJoyview: isJoyview,
        locale: locale,
        price: price,
        product: product,
        selectedBestPrice: selectedBestPrice,
        selectedDuration: selectedDuration,
        selectedRealPrice: selectedRealPrice,
        isHighlighted: (dayModifiers.today || price.isBestPrice || price.lastAvailability || price.siblingOpen) && !dayModifiers[Datepicker_themes["a" /* themes */][theme].thDayPicker.selected],
        shouldDisplayDetails: withPriceDetails && !!dayModifiers[Datepicker_themes["a" /* themes */][theme].thDayPicker.selected] && !from && !to,
        shouldDisplayDoubleSeasonButton: dayModifiers.firstSiblingOpenDayOfSelectedMonth,
        shouldDisplayPrice: shouldDisplayPrice,
        shouldDisplaySelectedDepartureDateMessage: !!from && !to && moment_default()(from).isSame(day, 'day'),
        shouldDisplaySelectedDepartureDateMessageWithPrice: bothDatesSelected && moment_default()(from).isSame(day, 'day'),
        shouldDisplaySelectedReturningDateMessage: bothDatesSelected && moment_default()(to).isSame(day, 'day'),
        shouldDisplayStatusMessage: !from,
        withPriceDetails: withPriceDetails,
        theme: theme
      });
    },
    datePickerClassNames: {
      day: thDay
    }
  } : null));
};

/***/ }),

/***/ "rNwk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ActivitiesThematics_ActivitiesThematics; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: ./src/client/components/utils/layers/layers.constants.js
var layers_constants = __webpack_require__("RDfq");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/context/PageContext.js
var PageContext = __webpack_require__("EkOT");

// EXTERNAL MODULE: ./src/client/context/ServicesContext.js
var ServicesContext = __webpack_require__("2Odu");

// EXTERNAL MODULE: ./src/hooks/use-layer/useLayer.js
var useLayer = __webpack_require__("1CQ+");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("jQ/y");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/string/string.util.js
var string_util = __webpack_require__("tX1K");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/components/frameworks/badge/Badge.jsx + 1 modules
var Badge = __webpack_require__("VHif");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLink.jsx
var DynamicLink = __webpack_require__("i5Mr");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// CONCATENATED MODULE: ./src/client/components/widgets/activities-thematic-card/ActivitiesThematicCard.jsx





var __jsx = react_default.a.createElement;














var ActivitiesThematicCard_ActivitiesThematicCard = function ActivitiesThematicCard(_ref) {
  var _thematic$activitiesC, _thematic$activitiesC2, _thematic$images, _thematic$activitiesC3, _thematic$activitiesC4;

  var className = _ref.className,
      _ref$firstItemDisplay = _ref.firstItemDisplay,
      firstItemDisplay = _ref$firstItemDisplay === void 0 ? false : _ref$firstItemDisplay,
      _ref$hasCounters = _ref.hasCounters,
      hasCounters = _ref$hasCounters === void 0 ? false : _ref$hasCounters,
      label = _ref.label,
      onClick = _ref.onClick,
      thematic = _ref.thematic,
      url = _ref.url,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["className", "firstItemDisplay", "hasCounters", "label", "onClick", "thematic", "url"]);

  var _usePageContext = Object(PageContext["b" /* usePageContext */])(),
      pageType = _usePageContext.pageType;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  var isPle = pageType === constants["C" /* STATIC_PAGE_TYPES */].PLE;
  var onlineBookableActivitiesCount = (thematic === null || thematic === void 0 ? void 0 : thematic.onlineBookableCount) || 0; // in PLE we only show the online bookable activities count

  var totalActivities = isPle ? onlineBookableActivitiesCount : ((thematic === null || thematic === void 0 ? void 0 : (_thematic$activitiesC = thematic.activitiesCounters) === null || _thematic$activitiesC === void 0 ? void 0 : _thematic$activitiesC.included) || 0) + ((thematic === null || thematic === void 0 ? void 0 : (_thematic$activitiesC2 = thematic.activitiesCounters) === null || _thematic$activitiesC2 === void 0 ? void 0 : _thematic$activitiesC2.onDemand) || 0);
  var firstItemTextLength = isDesktop ? 40 : 25;
  var firstItemTitle = Object(string_util["d" /* truncate */])(thematic.name, isDesktop ? 35 : 25);
  var defaultItemTextLength = isDesktop ? 90 : 42;
  var defaultItemTitle = thematic.name;
  return __jsx(DynamicLink["a" /* default */], Object(esm_extends["a" /* default */])({}, rest, {
    className: Object(classnames_utils["a" /* classnames */])('group relative isolate flex h-310 items-end justify-between overflow-hidden rounded-12 p-20 text-white', className),
    "data-testid": "thematics",
    onClick: onClick,
    shallow: true,
    url: url
  }), __jsx("div", {
    className: "absolute inset-0 -z-1 flex transform items-center transition-all duration-250 ease-in group-hover:scale-105"
  }, __jsx(Image["a" /* Image */], {
    className: "flex h-full w-full",
    imageUrl: (_thematic$images = thematic.images) === null || _thematic$images === void 0 ? void 0 : _thematic$images[0]
  }), __jsx("div", {
    className: "absolute bottom-0 h-1/2 w-full bg-gradient-to-t from-black/80"
  })), hasCounters && __jsx("div", {
    className: "absolute top-0 mt-10 flex flex-row items-center"
  }, (thematic === null || thematic === void 0 ? void 0 : (_thematic$activitiesC3 = thematic.activitiesCounters) === null || _thematic$activitiesC3 === void 0 ? void 0 : _thematic$activitiesC3.onDemand) > 0 && __jsx(Badge["a" /* Badge */], {
    className: "size-30 border-orange bg-orange text-white",
    iconName: icons["a" /* ICONS */].ON_DEMAND,
    iconSize: "0.875rem",
    variant: "pill"
  }), (thematic === null || thematic === void 0 ? void 0 : (_thematic$activitiesC4 = thematic.activitiesCounters) === null || _thematic$activitiesC4 === void 0 ? void 0 : _thematic$activitiesC4.included) > 0 && __jsx(Badge["a" /* Badge */], {
    className: "size-30 border-green bg-green text-white",
    iconName: icons["a" /* ICONS */].ALL_INCLUSIVE,
    iconSize: "0.875rem",
    variant: "pill"
  }), __jsx("span", {
    className: "ms-10 font-brand"
  }, Object(i18n["h" /* t */])(totalActivities > 1 ? 'common.activities.counters._n' : 'common.activities.counters._1', {
    count: totalActivities
  }))), __jsx("div", null, __jsx(Title["a" /* Title */], {
    className: "mb-5 text-white",
    theme: "title-brand-n0"
  }, firstItemDisplay ? firstItemTitle : defaultItemTitle), __jsx(Text["a" /* Text */], {
    className: "text-white",
    text: Object(string_util["d" /* truncate */])(thematic.description || '', firstItemDisplay ? firstItemTextLength : defaultItemTextLength),
    theme: "text-sans-n3"
  })), __jsx(Icon["a" /* Icon */], {
    className: "shrink-0",
    hasRtl: true,
    name: icons["a" /* ICONS */].ARROW_RIGHT,
    width: "1rem"
  }));
};
// EXTERNAL MODULE: ./src/client/components/widgets/rentals-cta/RentalsCta.jsx
var RentalsCta = __webpack_require__("38qS");

// CONCATENATED MODULE: ./src/client/components/widgets/activities-thematics/ActivitiesThematics.jsx













var ActivitiesThematics_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













var ActivitiesThematics_ActivitiesThematics = function ActivitiesThematics(_ref) {
  var _ref$hasRentals = _ref.hasRentals,
      hasRentals = _ref$hasRentals === void 0 ? false : _ref$hasRentals,
      _ref$isProposal = _ref.isProposal,
      isProposal = _ref$isProposal === void 0 ? false : _ref$isProposal,
      layerName = _ref.layerName,
      rentalsLayerName = _ref.rentalsLayerName,
      thematics = _ref.thematics,
      _ref$trackRentals = _ref.trackRentals,
      trackRentals = _ref$trackRentals === void 0 ? function () {} : _ref$trackRentals;

  var _useContext = Object(react["useContext"])(ServicesContext["a" /* ServicesContext */]),
      trackingData = _useContext.trackingData;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var isMobile = !isTablet;

  var _usePageContext = Object(PageContext["b" /* usePageContext */])(),
      siteSection = _usePageContext.siteSection,
      pageMeta = _usePageContext.pageMeta,
      pageId = _usePageContext.pageId;

  var itemsNumber = thematics.length + (hasRentals ? 1 : 0);
  var isTwoColumnsItem = (isMobile && itemsNumber % 2) === 0;
  var track = Object(useTracking["a" /* useTracking */])(_objectSpread({
    actionGA: 'activities',
    siteSection: siteSection,
    pageName: // eslint-disable-next-line no-nested-ternary
    pageMeta.resortId && siteSection ? "".concat(siteSection, "_").concat(pageMeta.resortId) : isProposal ? 'BE_activities' : pageId
  }, trackingData));

  var _useLayer = Object(useLayer["a" /* useLayer */])(layerName || layers_constants["c" /* LAYER_NAME_UPSELL_ACTIVITIES */], {
    type: 'THEMATICS'
  }),
      nextUri = _useLayer.nextUri;

  var getUrl = function getUrl(catId) {
    return new URI_default.a(nextUri).addQuery({
      catId: catId
    }).toString();
  };

  return ActivitiesThematics_jsx("section", {
    className: "isolate grid grid-cols-2 gap-20 md:grid-cols-3",
    "data-testid": "Activities-all-componant"
  }, hasRentals && ActivitiesThematics_jsx(RentalsCta["a" /* RentalsCta */], {
    className: "col-span-2 h-310",
    layerName: rentalsLayerName,
    onClick: trackRentals
  }), thematics.filter(function (item) {
    return (item.activities || []).length > 0;
  }).map(function (item, index) {
    return ActivitiesThematics_jsx(ActivitiesThematicCard_ActivitiesThematicCard, {
      className: Object(classnames_utils["a" /* classnames */])({
        'col-span-2': !hasRentals && index === 0 || isTwoColumnsItem,
        'col-span-1': hasRentals || index > 0 && !isTwoColumnsItem
      }),
      firstItemDisplay: index > 0 && !hasRentals,
      key: item.id,
      label: Object(i18n["h" /* t */])('common.activities.label'),
      onClick: function onClick() {
        return track({
          labelGA: "themes_".concat(item.name)
        });
      },
      thematic: item,
      url: getUrl(item.id)
    });
  }));
};

/***/ }),

/***/ "s1v2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getUpSellQuantity */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return upSellTypeMapping; });
/* unused harmony export getDefaultUpsellTrackingProps */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return trackUpsell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return trackJoyViewUpsell; });
/* unused harmony export trackAbTasty */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return trackAdditionnalServicesRented; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return computeTransferTrackingValue; });
/* unused harmony export eventTracking */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getConfirmationProps; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("vfdX");
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("5BYb");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("IAdD");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("uZih");
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(lodash_omit__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("kiXb");
/* harmony import */ var _tracking_constants__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("829J");
/* harmony import */ var _tracking_tracking_api__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("d1HQ");
/* harmony import */ var _tracking_utils__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("zwLB");
/* harmony import */ var _components_utils_ab_tasty_abTasty_utils__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("FtaI");
/* harmony import */ var _tracking_tracking_storage_api__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("K0Lv");
/* harmony import */ var _utils_payment_constants__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("hi3+");
/* harmony import */ var _utils_status_code_statusCode_constants__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__("PSHn");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__("taV1");



















function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
} // flow













var upsellQuatityScheduleReducer = function upsellQuatityScheduleReducer(upsellQuantityAttendee, schedule) {
  if (!schedule.isPartiallyRented) {
    return upsellQuantityAttendee;
  }

  if (schedule.timeSlots && schedule.timeSlots.length > 0) {
    return upsellQuantityAttendee + schedule.timeSlots.filter(function (_ref) {
      var isRented = _ref.isRented;
      return isRented;
    }).length;
  }

  return upsellQuantityAttendee + 1;
};

var upsellQuantityAttendeeReducer = function upsellQuantityAttendeeReducer(upsellQuantity, attendee) {
  return upsellQuantity + attendee.schedules.reduce(upsellQuatityScheduleReducer, 0);
};

var getUpSellQuantity = function getUpSellQuantity(pricingInfo) {
  if (['TRANSFER', 'INSURANCE'].includes(pricingInfo.type)) {
    return 1;
  }

  if (!pricingInfo.isPartiallyRented) {
    return 0;
  } // new Format ski wellness ...


  if (pricingInfo.attendees) {
    return pricingInfo.attendees.reduce(upsellQuantityAttendeeReducer, 0);
  } // old format ie : childcare etc ..


  return pricingInfo.schedules.reduce(function (totalSchedules, _ref2) {
    var attendees = _ref2.attendees;
    return totalSchedules + attendees.reduce(function (totalAttendees, _ref3) {
      var isRented = _ref3.isRented;
      return totalAttendees + (isRented ? 1 : 0);
    }, 0);
  }, 0);
};
var upSellTypeMapping = {
  CHILDCARE: 'childcare',
  EXCURSION: 'excursion',
  LAND_SPORT: 'landSport',
  RENTAL: 'ski',
  TRANSFER: 'transfer',
  WATER_SPORT: 'waterSport',
  WINTER_SPORT: 'winterSport',
  WELLNESS: 'wellness',
  INSURANCE: 'insurance'
};
var getDefaultUpsellTrackingProps = function getDefaultUpsellTrackingProps(appContext, proposal) {
  var _proposal$resort, _proposal$resort$dest, _proposal$resort2, _proposal$additionalS, _proposal$additionalS2, _proposal$additionalS3;

  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _constants__WEBPACK_IMPORTED_MODULE_27__[/* BE_GA_DEFAULT_PAYLOAD */ "c"]), {}, {
    categoryGA: 'upsellTransaction'
  }, appContext.isCmta && {
    agenceType: appContext.cmta.isDelCredere ? 'Ducroire' : 'NonDucroire'
  }), (proposal === null || proposal === void 0 ? void 0 : proposal.packageId) !== _utils_payment_constants__WEBPACK_IMPORTED_MODULE_25__[/* JOYVIEW_UPSELL_RON_PACKAGEID */ "g"] && {
    upsellTransaction: 1
  }), {}, {
    upsell: 'yes',
    actionGA: proposal === null || proposal === void 0 ? void 0 : (_proposal$resort = proposal.resort) === null || _proposal$resort === void 0 ? void 0 : (_proposal$resort$dest = _proposal$resort.destination) === null || _proposal$resort$dest === void 0 ? void 0 : _proposal$resort$dest.country,
    roomType: Object(_tracking_utils__WEBPACK_IMPORTED_MODULE_22__[/* getTrackingRoomType */ "l"])(proposal.accommodations),
    labelGA: proposal === null || proposal === void 0 ? void 0 : (_proposal$resort2 = proposal.resort) === null || _proposal$resort2 === void 0 ? void 0 : _proposal$resort2.id,
    insuranceSubscribed: (_proposal$additionalS = proposal.additionalServices.insurance) === null || _proposal$additionalS === void 0 ? void 0 : _proposal$additionalS.some(function (_ref4) {
      var pricingInfo = _ref4.pricingInfo;
      return pricingInfo.isPartiallyRented;
    }),
    transfer: (proposal === null || proposal === void 0 ? void 0 : (_proposal$additionalS2 = proposal.additionalServices) === null || _proposal$additionalS2 === void 0 ? void 0 : (_proposal$additionalS3 = _proposal$additionalS2.transfers) === null || _proposal$additionalS3 === void 0 ? void 0 : _proposal$additionalS3.some(function (_ref5) {
      var pricingInfo = _ref5.pricingInfo;
      return pricingInfo.isPartiallyRented;
    })) ? 'yes' : 'no'
  });
};
var trackUpsell = function trackUpsell(trackEvent, proposal, upsellRevenue) {
  var storage = _tracking_tracking_storage_api__WEBPACK_IMPORTED_MODULE_24__[/* get */ "b"](_tracking_constants__WEBPACK_IMPORTED_MODULE_20__[/* BE_TRACKING */ "c"]); // $FlowFixMe

  var roomFilters = storage.roomFilters || []; // $FlowFixMe

  var roomOptions = storage.roomOptions || {};
  var tracking = {
    upsell_revenue: upsellRevenue,
    upsell_category: 'room',
    upsell_name: proposal.accommodations[0].id,
    upsell_quantity: proposal.accommodations.reduce(function (quantity, accommodation) {
      return quantity + accommodation.quantity;
    }, 0)
  };

  if ('upsell' in roomOptions && roomOptions.upsell === 'yes' && roomOptions.proposalId === proposal.id) {
    Object.assign(tracking, {
      upsell_revenue: roomOptions.upsellRevenue,
      upsell_category: roomOptions.upsellCategory,
      upsell_name: roomOptions.upsellName,
      upsell_quantity: roomOptions.upsellQuantity
    });
  }

  if (roomFilters.length) {
    roomFilters.filter(function (roomFilter) {
      return roomFilter.proposalId === proposal.id;
    }).forEach(function (filter) {
      if (filter.upsellRevenue > 0) {
        trackEvent(_tracking_constants__WEBPACK_IMPORTED_MODULE_20__[/* TRACK_EVENT_NAMES */ "F"].UPSELL_TRANSACTION, lodash_omit__WEBPACK_IMPORTED_MODULE_16___default()(_objectSpread(_objectSpread({}, tracking), {}, {
          upsell_revenue: filter.upsellRevenue,
          upsell_category: filter.upsellCategory,
          upsell_name: filter.upsellName
        }), 'proposalId'));
      }
    });
  }

  if (tracking.upsell_revenue > 0) {
    trackEvent(_tracking_constants__WEBPACK_IMPORTED_MODULE_20__[/* TRACK_EVENT_NAMES */ "F"].UPSELL_TRANSACTION, lodash_omit__WEBPACK_IMPORTED_MODULE_16___default()(tracking, 'proposalId'));
  }

  _tracking_tracking_storage_api__WEBPACK_IMPORTED_MODULE_24__[/* set */ "c"](_objectSpread(_objectSpread({}, storage), {}, {
    roomFilters: [],
    roomOptions: {}
  }));
};
var trackJoyViewUpsell = function trackJoyViewUpsell(trackEvent, proposal, joyviewUpSell) {
  trackEvent(_tracking_constants__WEBPACK_IMPORTED_MODULE_20__[/* TRACK_EVENT_NAMES */ "F"].UPSELL_TRANSACTION, {
    upsell_category: 'joyview',
    upsell_name: proposal.packageId,
    upsell_quantity: 1,
    upsell_revenue: joyviewUpSell
  });
};
var trackAbTasty = function trackAbTasty(proposal, appContext, bookingId) {
  var _price$total, _price$total2;

  var price = proposal.price;
  Object(_components_utils_ab_tasty_abTasty_utils__WEBPACK_IMPORTED_MODULE_23__[/* sendTransaction */ "b"])({
    affiliation: appContext.locale,
    currency: (price === null || price === void 0 ? void 0 : (_price$total = price.total) === null || _price$total === void 0 ? void 0 : _price$total.currency) || '',
    id: bookingId,
    revenue: price === null || price === void 0 ? void 0 : (_price$total2 = price.total) === null || _price$total2 === void 0 ? void 0 : _price$total2.value
  });
};
var trackAdditionnalServicesRented = function trackAdditionnalServicesRented(trackEvent, additionalServicesRented) {
  return additionalServicesRented.map(function (additionalService, index, additionalServices) {
    /* in case of services containing time slots each time slot is a unique service
     so to calculate the total amount and the quantity we need to iterate over
     each service sharing the same productInfo.id
    */
    var existingServiceIndex = additionalServices.findIndex(function (service) {
      return service.productInfo.id === additionalService.productInfo.id;
    });

    if (existingServiceIndex && existingServiceIndex !== index) {
      var existingService = additionalServices[existingServiceIndex];
      existingService.pricingInfo.schedules = [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_14__[/* default */ "a"])(existingService.pricingInfo.schedules), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_14__[/* default */ "a"])(additionalService.pricingInfo.schedules));
      existingService.pricingInfo.rentedAmount.value += additionalService.pricingInfo.rentedAmount.value;
    } else {
      return additionalService;
    }
  }).filter(Boolean).forEach(function (_ref6) {
    var pricingInfo = _ref6.pricingInfo,
        productInfo = _ref6.productInfo;
    pricingInfo.rentedAmount.value > 0 && trackEvent(_tracking_constants__WEBPACK_IMPORTED_MODULE_20__[/* TRACK_EVENT_NAMES */ "F"].UPSELL_TRANSACTION, {
      upsell_category: upSellTypeMapping[pricingInfo.type],
      upsell_name: productInfo.id,
      upsell_revenue: pricingInfo.rentedAmount.value,
      upsell_quantity: getUpSellQuantity(pricingInfo)
    });
  });
};
var computeTransferTrackingValue = function computeTransferTrackingValue(proposal, selectedTransfers) {
  if (proposal.transports) {
    return 'yes with transport';
  }

  if (selectedTransfers.length > 0) {
    return 'yes without transport';
  }

  return 'no';
};
var eventTracking = function eventTracking(optionID, appContext, queryParams) {
  var data = _tracking_tracking_storage_api__WEBPACK_IMPORTED_MODULE_24__[/* get */ "b"](_tracking_constants__WEBPACK_IMPORTED_MODULE_20__[/* BE_TRACKING */ "c"]);
  _tracking_tracking_api__WEBPACK_IMPORTED_MODULE_21__[/* setDataLayer */ "b"](_objectSpread({
    categoryGA: 'option',
    labelGA: lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(data, 'basePriceParticipant'),
    siteSection: 'Booking Engine'
  }, optionID ? {
    actionGA: optionID
  } : {}), appContext);

  if (queryParams.futureTravelCreditOption === 'true') {
    _tracking_tracking_api__WEBPACK_IMPORTED_MODULE_21__[/* setDataLayer */ "b"]({
      categoryGA: 'optionFTC',
      labelGA: optionID,
      actionGA: 'confirmation',
      siteSection: 'Booking Engine'
    }, appContext);
  }
};
var getConfirmationProps = function getConfirmationProps(_ref7) {
  var location = _ref7.location,
      bookingId = _ref7.bookingId,
      config = _ref7.config,
      proposal = _ref7.proposal,
      isCmta = _ref7.isCmta,
      isSeller = _ref7.isSeller,
      isNotDelCredere = _ref7.isNotDelCredere,
      hasSaveOption = _ref7.hasSaveOption,
      expirationTime = _ref7.expirationTime,
      isReliable = _ref7.isReliable;
  var params = location.urlParams,
      queryParams = location.queryParams;

  var resortName = lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(proposal, 'resort.name');

  var _config$booking = config.booking,
      _config$booking$optio = _config$booking.option.confirmation,
      failureImmersiveTitle = _config$booking$optio.failureImmersiveTitle,
      failureDescription = _config$booking$optio.failureDescription,
      successTitle = _config$booking$optio.successTitle,
      successDescription2 = _config$booking$optio.successDescription2,
      aBookingAlreadyExistsTitle = _config$booking$optio.aBookingAlreadyExistsTitle,
      aBookingAlreadyExistsDescription = _config$booking$optio.aBookingAlreadyExistsDescription,
      aBookingAlreadyExistsDescription2 = _config$booking$optio.aBookingAlreadyExistsDescription2,
      itemOfTheBookingNotAvailableTitle = _config$booking$optio.itemOfTheBookingNotAvailableTitle,
      itemOfTheBookingNotAvailableDescription = _config$booking$optio.itemOfTheBookingNotAvailableDescription,
      partners = _config$booking.partners,
      failure = _config$booking.confirmation.failure;
  var isNotDelCredereCmta = isCmta && isNotDelCredere;
  var failureTitle = Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_18__["messageFormat"])(failure.headSentence).format({
    resortName: resortName
  });
  var failureMessage = failure.notCompletedMessage;
  var isFtcOption = queryParams.futureTravelCreditOption === 'true';

  switch (parseInt(params.status, 10)) {
    case _utils_status_code_statusCode_constants__WEBPACK_IMPORTED_MODULE_26__[/* STATUS_CODE_200 */ "a"]:
      var defaultSuccessProps = {
        type: 'OPTION',
        status: 'SUCCESS',
        bookingId: bookingId,
        expirationTime: expirationTime,
        isReliable: isReliable
      };

      if (isFtcOption) {
        return _objectSpread(_objectSpread({}, defaultSuccessProps), {}, {
          title: Object(_i18n__WEBPACK_IMPORTED_MODULE_19__[/* t */ "h"])('booking.summary.futureTravelCredit.confirmation.title'),
          message: Object(_i18n__WEBPACK_IMPORTED_MODULE_19__[/* t */ "h"])('booking.summary.futureTravelCredit.confirmation.information')
        });
      }

      if (isNotDelCredereCmta && !hasSaveOption) {
        return _objectSpread(_objectSpread({}, defaultSuccessProps), {}, {
          title: Object(_i18n__WEBPACK_IMPORTED_MODULE_19__[/* t */ "h"])('booking.partners.confirmation.noDelcredere.headSentence'),
          message: Object(_i18n__WEBPACK_IMPORTED_MODULE_19__[/* t */ "h"])('booking.partners.confirmation.noDelcredere.bookingCompleteAdditionalText')
        });
      }

      if (isCmta) {
        return _objectSpread(_objectSpread({}, defaultSuccessProps), {}, {
          title: Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_18__["messageFormat"])(successTitle).format({
            resortName: resortName
          }),
          message: "".concat(partners.option.confirmation.successDescription, " ").concat(partners.phoneNumber)
        });
      }

      return {
        type: 'OPTION',
        status: 'SUCCESS',
        title: Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_18__["messageFormat"])(successTitle).format({
          resortName: resortName
        }),
        message: successDescription2,
        bookingId: bookingId,
        expirationTime: expirationTime,
        isReliable: isReliable
      };

    case _utils_status_code_statusCode_constants__WEBPACK_IMPORTED_MODULE_26__[/* STATUS_CODE_409 */ "e"]:
      // BOOKING_ALREADY_EXISTS else BOOKING_UNAVAILABLE
      var aBookingAlreadyExistsMessageType = isSeller ? aBookingAlreadyExistsDescription : aBookingAlreadyExistsDescription2;
      return params.error_code === 'BOOKING_ALREADY_EXISTS' ? {
        bookingId: bookingId,
        status: 'FAILURE',
        type: 'OPTION',
        title: isNotDelCredereCmta ? failureTitle : aBookingAlreadyExistsTitle,
        message: isNotDelCredereCmta ? failureMessage : aBookingAlreadyExistsMessageType
      } : {
        bookingId: bookingId,
        status: 'FAILURE',
        type: 'OPTION',
        title: isNotDelCredereCmta ? failureTitle : itemOfTheBookingNotAvailableTitle,
        message: isNotDelCredereCmta ? failureMessage : itemOfTheBookingNotAvailableDescription
      };

    default:
      return {
        type: 'OPTION',
        status: 'FAILURE',
        title: isNotDelCredereCmta ? failureTitle : Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_18__["messageFormat"])(failureImmersiveTitle).format({
          resortName: resortName
        }),
        message: isNotDelCredereCmta ? failureMessage : failureDescription,
        bookingId: bookingId
      };
  }
};

/***/ }),

/***/ "sZKc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ useBankingView_useBankingView; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.every.js
var es_array_every = __webpack_require__("DfhM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find-index.js
var es_array_find_index = __webpack_require__("vfdX");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("5BYb");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("KqXw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("MvUL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.search.js
var es_string_search = __webpack_require__("LJOr");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__("fYnN");
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// EXTERNAL MODULE: /opt/webapp/node_modules/next/router.js
var next_router = __webpack_require__("Bkb1");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: /opt/webapp/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/client/components/widgets/payment-info/PaymentInfo.utils.js
var PaymentInfo_utils = __webpack_require__("gX9k");

// EXTERNAL MODULE: ./src/client/components/widgets/payment-info/payment-form/paymentProvidersUtils.js
var paymentProvidersUtils = __webpack_require__("y5B/");

// EXTERNAL MODULE: ./src/client/store/booking/booking.selector.js
var booking_selector = __webpack_require__("uL19");

// EXTERNAL MODULE: ./src/client/store/booking/proposals/proposals.action.js + 2 modules
var proposals_action = __webpack_require__("AnR0");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/tracking/tracking-storage-api/index.js
var tracking_storage_api = __webpack_require__("K0Lv");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/client/tracking/utils.js
var utils = __webpack_require__("zwLB");

// EXTERNAL MODULE: ./src/client/views/booking/constants.js
var booking_constants = __webpack_require__("taV1");

// EXTERNAL MODULE: ./src/utils/payment/constants.js
var payment_constants = __webpack_require__("hi3+");

// EXTERNAL MODULE: ./src/client/components/utils/ab-tasty/abTasty.utils.js
var abTasty_utils = __webpack_require__("FtaI");

// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// EXTERNAL MODULE: ./src/utils/graphql-query-helper/booking/payment-redirect/paymentRedirectQuery.js
var paymentRedirectQuery = __webpack_require__("oJjJ");

// EXTERNAL MODULE: ./src/utils/payment/payment.utils.js
var payment_utils = __webpack_require__("aMaj");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// CONCATENATED MODULE: ./src/client/views/booking/banking/BankingView.utils.js





var BankingView_utils_getPaymentRedirectMutation = function getPaymentRedirectMutation(_ref) {
  var proposal = _ref.proposal,
      appContext = _ref.appContext,
      params = _ref.params;
  return function (_ref2) {
    var amountToPay = _ref2.amountToPay,
        donationAmount = _ref2.donationAmount,
        browserInfo = _ref2.browserInfo,
        isIframe = _ref2.isIframe,
        location = _ref2.location,
        comments = _ref2.comments,
        paymentProviderId = _ref2.paymentProviderId,
        shouldSkipPayment = _ref2.shouldSkipPayment,
        paymentConditionId = _ref2.paymentConditionId,
        token = _ref2.token,
        billingDetails = _ref2.billingDetails,
        customerId = _ref2.customerId;
    var proposalId = proposal.id;
    var callbackUrl = Object(payment_utils["a" /* getCallbackURIFromProvider */])(paymentProviderId, proposalId, appContext, location);
    return graphqlClient["a" /* default */].runNoCacheQuery(Object(paymentRedirectQuery["a" /* paymentRedirectMutation */])({
      action: payment_constants["i" /* PAYMENT_ACTION */].PAYMENT_RESA,
      callbackUrl: callbackUrl,
      bookingId: params === null || params === void 0 ? void 0 : params.bookingId,
      proposalId: proposalId,
      cancelUrl: Object(payment_utils["c" /* getCancelCallbackURI */])(appContext, location),
      iframeCallbackUrl: Object(payment_utils["d" /* getIframeCallbackUrl */])(location),
      callbackUrlSeller: Object(payment_utils["b" /* getCallbackUrlSeller */])(location),
      price: amountToPay,
      comments: comments,
      currency: proposal.price.currency,
      shouldSkipPayment: shouldSkipPayment,
      donationAmount: donationAmount,
      browserInfo: browserInfo,
      isIframe: isIframe,
      providerId: paymentProviderId,
      paymentConditionId: paymentConditionId,
      token: token,
      billingDetails: billingDetails,
      customerId: customerId
    }), appContext, {
      requestName: requestDictionary["Ec" /* PAYMENT_REDIRECT */]
    })["catch"](function (error) {
      throw error;
    });
  };
};
// CONCATENATED MODULE: ./src/client/views/booking/banking/useBankingView.jsx























function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



















var useBankingView_useBankingView = function useBankingView(_ref) {
  var selectedProposal = _ref.selectedProposal,
      _ref$additionalProvid = _ref.additionalProviders,
      additionalProviders = _ref$additionalProvid === void 0 ? [] : _ref$additionalProvid,
      resort = _ref.resort,
      attendeesPaymentStatus = _ref.attendeesPaymentStatus;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var router = Object(next_router["useRouter"])();
  var queryParams = router.query;
  var paymentStatus = queryParams.paymentStatus,
      bookingId = queryParams.bookingId;

  var _useState = Object(react["useState"])(false),
      openFailedPaymentModal = _useState[0],
      setOpenFailedPaymentModal = _useState[1];

  var firstUnpaidHouseholdIndex = attendeesPaymentStatus.findIndex(function (status) {
    return !(status === null || status === void 0 ? void 0 : status.hasPaid);
  });

  var _useState2 = Object(react["useState"])(0),
      currentPayingHouseholdIndex = _useState2[0],
      setCurrentPayingHouseholdIndex = _useState2[1];

  Object(react["useEffect"])(function () {
    if (firstUnpaidHouseholdIndex !== -1) {
      setCurrentPayingHouseholdIndex(firstUnpaidHouseholdIndex);
    }
  }, [firstUnpaidHouseholdIndex]);
  var dispatch = Object(es["d" /* useDispatch */])();
  var entryRoute = Object(es["e" /* useSelector */])(function (state) {
    return state.booking.entryRoute;
  });
  var paymentProviders = Object(es["e" /* useSelector */])(booking_selector["s" /* getPaymentProviders */]).reduce(function (allProviders, provider) {
    if (!provider.shouldSkipPayment) {
      provider.selectorId = provider.id;
    }

    allProviders.push(provider);
    return allProviders;
  }, []);
  var track = Object(useTracking["a" /* useTracking */])(_objectSpread(_objectSpread({}, booking_constants["c" /* BE_GA_DEFAULT_PAYLOAD */]), {}, {
    actionGA: 'banking'
  }));
  var arrivalDate = selectedProposal.transports && selectedProposal.transports.inbound ? selectedProposal.transports.inbound.travelSections[0].departure.date : selectedProposal.arrivalDate;
  var paymentProvidersWithValidMethods = Object(paymentProvidersUtils["l" /* sanitizePaymentProviders */])({
    paymentProviders: [].concat(Object(toConsumableArray["a" /* default */])(paymentProviders), Object(toConsumableArray["a" /* default */])(additionalProviders)),
    arrivalDate: arrivalDate,
    locale: appContext.locale
  });

  var handleFailedPaymentModalClose = function handleFailedPaymentModalClose() {
    var newUri = new URI_default.a(router.asPath).removeQuery(['paymentStatus']);
    router.replace(newUri.toString());
    setOpenFailedPaymentModal(false);
  };

  Object(react["useEffect"])(function () {
    if ((paymentStatus === null || paymentStatus === void 0 ? void 0 : paymentStatus.toUpperCase()) === payment_constants["r" /* PAYMENT_STATUS_REFUSED_PSP */]) {
      setOpenFailedPaymentModal(true);
      track({
        labelGA: 'validate_Popin_PaiementRefusedPSP',
        valueGA: 0,
        nonInteraction: 0,
        versionBooking: 'responsive'
      });
    }
  }, [paymentStatus]);
  var hasAllBasePaymentData = paymentProviders.length > 0 && selectedProposal.households.every(function (household) {
    return household.paymentSchedule;
  });
  Object(react["useEffect"])(function () {
    var _selectedProposal$add, _selectedProposal$hou, _selectedProposal$hou2;

    Object(abTasty_utils["c" /* storeAbTastyEvent */])();
    tracking_storage_api["c" /* set */](_objectSpread(_objectSpread({}, tracking_storage_api["b" /* get */](constants["c" /* BE_TRACKING */])), {}, {
      roomType: Object(utils["l" /* getTrackingRoomType */])(selectedProposal.accommodations),
      insuranceSubscribed: (_selectedProposal$add = selectedProposal.additionalServices.insurance) === null || _selectedProposal$add === void 0 ? void 0 : _selectedProposal$add.some(function (_ref2) {
        var pricingInfo = _ref2.pricingInfo;
        return pricingInfo.isPartiallyRented;
      })
    }));
    var priceHasChanged = selectedProposal.price.total.value !== ((_selectedProposal$hou = selectedProposal.households[currentPayingHouseholdIndex]) === null || _selectedProposal$hou === void 0 ? void 0 : (_selectedProposal$hou2 = _selectedProposal$hou.paymentSchedule) === null || _selectedProposal$hou2 === void 0 ? void 0 : _selectedProposal$hou2.total.value); // check for updates in price due to back browser button => re-Fetch the new selectedProposal Price
    // also prevent from double call in refresh for ex

    if (!hasAllBasePaymentData || priceHasChanged) {
      dispatch(Object(proposals_action["n" /* fetchSelectedProposalPayment */])(selectedProposal, appContext));
    }
  }, []);
  var bookingResume = {
    proposalId: selectedProposal.id,
    arrivalDate: selectedProposal.departureDate,
    departureDate: selectedProposal.arrivalDate,
    name: resort.name,
    accommodations: {
      count: selectedProposal.accommodationsCount,
      name: selectedProposal.accommodations[0].category
    },
    transports: Object(PaymentInfo_utils["d" /* mapTransportResume */])(selectedProposal.transports),
    attendees: selectedProposal.attendees.list.map(function (_ref3) {
      var customerId = _ref3.customerId;
      return customerId || '';
    })
  };
  var paymentInfoValue = Object(react["useMemo"])(function () {
    var _selectedProposal$pri, _selectedProposal$pri2;

    return {
      trackPayment: Object(PaymentInfo_utils["c" /* getTrackPaymentFunc */])({
        proposal: selectedProposal,
        track: track,
        donationAmount: ((_selectedProposal$pri = selectedProposal.price.donation) === null || _selectedProposal$pri === void 0 ? void 0 : _selectedProposal$pri.value) || 0
      }),
      paymentRedirectMutation: BankingView_utils_getPaymentRedirectMutation({
        proposal: selectedProposal,
        appContext: appContext,
        params: {
          bookingId: bookingId
        }
      }),
      bookingResume: bookingResume,
      currency: selectedProposal.price.currency,
      donationAmount: ((_selectedProposal$pri2 = selectedProposal.price.donation) === null || _selectedProposal$pri2 === void 0 ? void 0 : _selectedProposal$pri2.value) || '',
      getPaymentErrorMessagePath: PaymentInfo_utils["b" /* getPaymentErrorMessagePath */],
      onPaymentProgress: function onPaymentProgress(_location) {
        // EOgone psp cannot handle long urls (200 char max),
        // we save proposal id as cookie for the confirmation page
        // see buildRedirectionBE
        js_cookie_default.a.set(booking_constants["k" /* BOOKING_SELECTED_RESORT_ID */], selectedProposal.id, {
          sameSite: 'none',
          secure: true
        }); // The cancelUrl can be too long for the psp so we store in cookies for rehydrate if the user came back #8641

        js_cookie_default.a.set(booking_constants["j" /* BOOKING_QUERY_PARAMS */], _location.search(), {
          sameSite: 'none',
          secure: true
        }); // set the enryRoute in case we came from the comparator to use in confirmation page

        js_cookie_default.a.set(booking_constants["i" /* BOOKING_ENTRY_ROUTE */], entryRoute);
      }
    };
  }, [selectedProposal]);
  var household = selectedProposal.households[0];
  var payingHousehold = {
    paymentSchedule: household.paymentSchedule,
    // $FlowFixMe always present
    customerId: household.attendees[0].customerId
  };
  var hasBasePaymentData = household.paymentSchedule && paymentProviders.length > 0;
  var householdPaymentStatus = attendeesPaymentStatus.find(function (bookingAttendee) {
    return bookingAttendee.customerId === household.attendees[0].customerId;
  });
  var hasPaid = (householdPaymentStatus === null || householdPaymentStatus === void 0 ? void 0 : householdPaymentStatus.hasPaid) || false;
  return {
    openFailedPaymentModal: openFailedPaymentModal,
    handleFailedPaymentModalClose: handleFailedPaymentModalClose,
    paymentInfoValue: paymentInfoValue,
    hasBasePaymentData: hasBasePaymentData,
    hasPaid: hasPaid,
    paymentProvidersWithValidMethods: paymentProvidersWithValidMethods,
    paymentProviders: paymentProviders,
    household: household,
    payingHousehold: payingHousehold
  };
};

/***/ }),

/***/ "ssvU":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("ax0f");

// `Number.isNaN` method
// https://tc39.es/ecma262/#sec-number.isnan
$({ target: 'Number', stat: true }, {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare -- NaN check
    return number != number;
  }
});


/***/ }),

/***/ "tuzA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getRateMessagesProperties; });
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("kiXb");


var FLEX_RATES = _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__["constants"].FLEX_RATES;
var getRateMessagesProperties = function getRateMessagesProperties(rate) {
  switch (rate) {
    case FLEX_RATES.NRR:
      return {
        rateTitle: Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.accommodation.packageContent.nonRefundableRateLabel'),
        rateContent: Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.accommodation.packageContent.nonRefundableRateLegal')
      };

    case FLEX_RATES.FLR:
      return {
        rateTitle: Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.accommodation.packageContent.flexibleRateLabel'),
        rateContent: Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.accommodation.packageContent.flexibleRateLegal')
      };

    default:
      return {
        rateTitle: Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.accommodation.packageContent.standardLabel'),
        rateContent: Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.accommodation.packageContent.standardLegal')
      };
  }
};

/***/ }),

/***/ "uGNg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAR_SELECTED_PROPOSAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SELECT_PROPOSAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectProposal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return clearSelectedProposal; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");

var SELECT_PROPOSAL = 'SELECT_PROPOSAL';
var CLEAR_SELECTED_PROPOSAL = 'CLEAR_SELECTED_PROPOSAL';

function clearSelectedProposal() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(CLEAR_SELECTED_PROPOSAL, {});
}

function selectProposal(proposalId) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(SELECT_PROPOSAL, {
    proposalId: proposalId
  });
}



/***/ }),

/***/ "uMuQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DayPriceDoubleSeasonPopin; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("M+/F");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("MvUL");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("Ysgh");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("fGyu");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("Bkb1");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("kiXb");
/* harmony import */ var _tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("sRdV");
/* harmony import */ var _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("/FsK");
/* harmony import */ var _utils_keyCodes__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("05v4");
/* harmony import */ var _frameworks_button_Button__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("e0Ti");
/* harmony import */ var _product_logo_ProductLogo__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("hA0C");
















var __jsx = react__WEBPACK_IMPORTED_MODULE_17___default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_14__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/no-noninteractive-tabindex */








var DayPriceDoubleSeasonPopin = function DayPriceDoubleSeasonPopin(_ref) {
  var availability = _ref.availability,
      product = _ref.product,
      setInvisible = _ref.setInvisible,
      setIsMouseOverDoubleSeasonPopin = _ref.setIsMouseOverDoubleSeasonPopin,
      statusMessageKey = _ref.statusMessageKey,
      trackingData = _ref.trackingData;
  var track = Object(_tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_19__[/* useTracking */ "a"])();
  var router = Object(next_router__WEBPACK_IMPORTED_MODULE_16__["useRouter"])();
  var uri = router.asPath;
  var doubleSeasonPopinMessageKey = "booking.priceCalendar.priceStatus.".concat(availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_20__[/* API_SIBLING_SUMMER */ "h"] ? 'siblingDescriptionSummer' : 'siblingDescriptionWinter');
  var productCountry = product.destination.country,
      _product$href = product.href,
      href = _product$href === void 0 ? '' : _product$href,
      productName = product.name,
      iconName = product.resortId;
  var splittedHref = href.split('/');
  var siblingHref = [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"])(splittedHref.slice(0, splittedHref.length - 1)), [availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_20__[/* API_SIBLING_SUMMER */ "h"] ? 's' : 'w']).join('/');

  var handleBlur = function handleBlur() {
    if (setIsMouseOverDoubleSeasonPopin) {
      setTimeout(function () {
        setIsMouseOverDoubleSeasonPopin(false);
      }, 200);
    }

    setInvisible && setInvisible();
  };

  var handleFocus = function handleFocus() {
    return setIsMouseOverDoubleSeasonPopin && setIsMouseOverDoubleSeasonPopin(true);
  };

  return __jsx("div", {
    className: "pointer-events-auto flex cursor-default flex-col items-center justify-center gap-20 bg-white p-30",
    onBlur: handleBlur,
    onFocus: handleFocus,
    onKeyDown: function onKeyDown(e) {
      e.preventDefault();
      e.stopPropagation();

      if (e.keyCode === _utils_keyCodes__WEBPACK_IMPORTED_MODULE_21__[/* ENTER */ "f"]) {
        router.push(uri.replace(href, siblingHref));
      } else {
        handleBlur();
      }
    },
    onMouseOver: handleFocus,
    onMouseLeave: handleBlur,
    tabIndex: -1
  }, __jsx("div", {
    className: "flex flex-col items-center justify-center gap-10"
  }, __jsx(_product_logo_ProductLogo__WEBPACK_IMPORTED_MODULE_23__[/* ProductLogo */ "a"], {
    iconName: iconName,
    productCountry: productCountry,
    productName: productName,
    theme: "calendar"
  }), __jsx("p", {
    className: "rounded-4 bg-turquoise px-10 py-5 text-12 font-bold text-white"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_18__[/* t */ "h"])(statusMessageKey))), __jsx("p", {
    className: "text-center text-14 leading-tight text-black sm:leading-normal"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_18__[/* t */ "h"])(doubleSeasonPopinMessageKey)), __jsx(_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_22__[/* Button */ "a"], {
    className: "pointer-events-auto w-full",
    "data-testid": "DayWithPrice-DoubleSeasonPopin-seeOtherSeason",
    onBlur: handleBlur,
    onClick: function onClick(e) {
      track(_objectSpread({
        categoryGA: 'resort',
        labelGA: 'switchSeason'
      }, trackingData));
      e.preventDefault();
      e.stopPropagation();
      router.push(uri.replace(href, siblingHref));
    },
    onFocus: handleFocus,
    size: "medium",
    tabIndex: 0
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_18__[/* t */ "h"])('booking.priceCalendar.priceStatus.siblingButton')));
};

/***/ }),

/***/ "wyfB":
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__("H87J"),
    baseIntersection = __webpack_require__("1sLo"),
    baseIteratee = __webpack_require__("S3pA"),
    baseRest = __webpack_require__("R3TX"),
    castArrayLikeObject = __webpack_require__("VZDm"),
    last = __webpack_require__("p1C/");

/**
 * This method is like `_.intersection` except that it accepts `iteratee`
 * which is invoked for each element of each `arrays` to generate the criterion
 * by which they're compared. The order and references of result values are
 * determined by the first array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
 * // => [2.1]
 *
 * // The `_.property` iteratee shorthand.
 * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }]
 */
var intersectionBy = baseRest(function(arrays) {
  var iteratee = last(arrays),
      mapped = arrayMap(arrays, castArrayLikeObject);

  if (iteratee === last(mapped)) {
    iteratee = undefined;
  } else {
    mapped.pop();
  }
  return (mapped.length && mapped[0] === arrays[0])
    ? baseIntersection(mapped, baseIteratee(iteratee, 2))
    : [];
});

module.exports = intersectionBy;


/***/ }),

/***/ "xGYs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ InputNumber_InputNumber; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("6U7i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("OZaJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/noop.js
var noop = __webpack_require__("nnm9");
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/utils/unique-id/uniqueId.js
var uniqueId = __webpack_require__("m1JM");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-number/InputNumber.themes.js

var themes = {
  "default": function _default(_ref) {
    var hasColumnLayout = _ref.hasColumnLayout,
        hasValue = _ref.hasValue,
        isDisabled = _ref.isDisabled,
        isReadOnly = _ref.isReadOnly,
        validationState = _ref.validationState;
    return {
      thRoot: Object(classnames_utils["a" /* classnames */])('flex items-center', {
        'flex-col gap-5 text-center': hasColumnLayout,
        'justify-between gap-10': !hasColumnLayout
      }),
      thLabel: Object(classnames_utils["a" /* classnames */])('text-14', {
        'text-black': validationState === 'NOT_VALIDATED' && !isReadOnly && !isDisabled,
        'text-success': validationState === 'IS_VALID' && hasValue && !isReadOnly && !isDisabled,
        'text-red': validationState === 'IS_INVALID' && hasValue && !isReadOnly && !isDisabled
      }),
      thNotes: 'block text-10',
      thInputs: 'flex gap-5 items-center shrink-0',
      thInput: Object(classnames_utils["a" /* classnames */])('outline-custom h-30 text-center text-18 font-bold leading-[1.875em]', {
        'text-black': validationState === 'NOT_VALIDATED' && !isReadOnly && !isDisabled,
        'text-success': validationState === 'IS_VALID' && hasValue && !isReadOnly && !isDisabled,
        'text-red': validationState === 'IS_INVALID' && hasValue && !isReadOnly && !isDisabled
      }),
      thButton: 'aspect-square cursor-pointer disabled:cursor-default bg-saffron hocus:enabled:bg-saffron-active disabled:bg-pearl rounded-pill shrink-0 disabled:text-grey transition-colors duration-250 ease-in size-48',
      thButtonIconWidth: '0.625rem'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-number/InputNumber.jsx














var __jsx = react_default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }







var InputNumber_InputNumber = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(InputNumber, _Component);

  var _super = _createSuper(InputNumber);

  function InputNumber(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, InputNumber);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onChange", function (e) {
      var _this$props = _this.props,
          isLoading = _this$props.isLoading,
          isReadOnly = _this$props.isReadOnly,
          _this$props$name = _this$props.name,
          name = _this$props$name === void 0 ? '' : _this$props$name,
          _this$props$onChange = _this$props.onChange,
          onChange = _this$props$onChange === void 0 ? noop_default.a : _this$props$onChange;

      if (!isReadOnly && !isLoading) {
        e.persist(); // $FlowFixMe

        var _value = Number(e.target.value);

        _this.setState({
          value: _value
        }, function () {
          return onChange(name, _value);
        });
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "decrease", function () {
      var _this$props2 = _this.props,
          _this$props2$name = _this$props2.name,
          name = _this$props2$name === void 0 ? '' : _this$props2$name,
          _this$props2$min = _this$props2.min,
          min = _this$props2$min === void 0 ? 0 : _this$props2$min,
          _this$props2$step = _this$props2.step,
          step = _this$props2$step === void 0 ? 1 : _this$props2$step,
          _this$props2$onChange = _this$props2.onChange,
          onChange = _this$props2$onChange === void 0 ? noop_default.a : _this$props2$onChange;
      var currentValue = _this.state.value || min;
      var decreasedValue = currentValue - step;
      var nextValue = decreasedValue >= min ? decreasedValue : min;

      _this.setState({
        value: nextValue
      });

      onChange(name, nextValue);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "increase", function () {
      var _this$props3 = _this.props,
          _this$props3$name = _this$props3.name,
          name = _this$props3$name === void 0 ? '' : _this$props3$name,
          _this$props3$min = _this$props3.min,
          min = _this$props3$min === void 0 ? 0 : _this$props3$min,
          _this$props3$max = _this$props3.max,
          max = _this$props3$max === void 0 ? 10 : _this$props3$max,
          _this$props3$step = _this$props3.step,
          step = _this$props3$step === void 0 ? 1 : _this$props3$step,
          _this$props3$onChange = _this$props3.onChange,
          onChange = _this$props3$onChange === void 0 ? noop_default.a : _this$props3$onChange;
      var currentValue = _this.state.value || min;
      var increasedValue = currentValue + step;
      var nextValue = increasedValue <= max ? increasedValue : max;

      _this.setState({
        value: nextValue
      });

      onChange(name, nextValue);
    });

    _this.state = {
      value: props.value
    };
    return _this;
  }

  Object(createClass["a" /* default */])(InputNumber, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(_ref) {
      var value = _ref.value;
      this.setState(function (prevState) {
        if (prevState.value !== value) {
          return {
            value: value
          };
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          ariaLabel = _this$props4.ariaLabel,
          autoComplete = _this$props4.autoComplete,
          className = _this$props4.className,
          _this$props4$dataTest = _this$props4.dataTestId,
          dataTestId = _this$props4$dataTest === void 0 ? 'InputNumber' : _this$props4$dataTest,
          _this$props4$hasColum = _this$props4.hasColumnLayout,
          hasColumnLayout = _this$props4$hasColum === void 0 ? false : _this$props4$hasColum,
          _this$props4$id = _this$props4.id,
          id = _this$props4$id === void 0 ? Object(uniqueId["b" /* generateUniqueId */])([typeof this.props.label === 'string' ? this.props.label : ''], 'InputNumber_') : _this$props4$id,
          isDisabled = _this$props4.isDisabled,
          isLoading = _this$props4.isLoading,
          isReadOnly = _this$props4.isReadOnly,
          isRequired = _this$props4.isRequired,
          label = _this$props4.label,
          _this$props4$max = _this$props4.max,
          max = _this$props4$max === void 0 ? 10 : _this$props4$max,
          _this$props4$min = _this$props4.min,
          min = _this$props4$min === void 0 ? 1 : _this$props4$min,
          name = _this$props4.name,
          notes = _this$props4.notes,
          onBlur = _this$props4.onBlur,
          onClick = _this$props4.onClick,
          onFocus = _this$props4.onFocus,
          onKeyDown = _this$props4.onKeyDown,
          onKeyUp = _this$props4.onKeyUp,
          placeholder = _this$props4.placeholder,
          step = _this$props4.step,
          theme = _this$props4.theme,
          validationState = _this$props4.validationState;
      var value = this.state.value;
      var hasValue = Boolean(value);
      var decreaseDisabled = isDisabled || isLoading || Number(value) <= min;
      var increaseDisabled = isDisabled || isLoading || Number(value) >= max;

      var _themes$theme = themes[theme]({
        hasColumnLayout: hasColumnLayout,
        hasValue: hasValue,
        isDisabled: isDisabled,
        isReadOnly: isReadOnly,
        validationState: validationState
      }),
          thButton = _themes$theme.thButton,
          thButtonIconWidth = _themes$theme.thButtonIconWidth,
          thInput = _themes$theme.thInput,
          thInputs = _themes$theme.thInputs,
          thLabel = _themes$theme.thLabel,
          thNotes = _themes$theme.thNotes,
          thRoot = _themes$theme.thRoot;

      if (false) {}

      return __jsx("div", {
        className: Object(classnames_utils["a" /* classnames */])(thRoot, className),
        "data-testid": dataTestId
      }, !!label && __jsx("label", {
        className: thLabel,
        htmlFor: id
      }, label, !!notes && __jsx("span", {
        className: thNotes
      }, notes)), __jsx("div", {
        className: thInputs
      }, !isReadOnly && __jsx("button", {
        className: thButton,
        "data-testid": "".concat(dataTestId, "-decrease"),
        disabled: decreaseDisabled,
        onClick: this.decrease,
        type: "button"
      }, __jsx(Icon["a" /* Icon */], {
        name: icons["a" /* ICONS */].MINUS,
        width: thButtonIconWidth
      })), __jsx("input", Object(esm_extends["a" /* default */])({
        "aria-label": ariaLabel,
        autoComplete: autoComplete,
        className: thInput,
        disabled: isDisabled,
        id: id,
        max: max,
        min: min // $FlowFixMe

      }, name ? {
        name: name
      } : null, {
        onBlur: onBlur,
        onChange: this.onChange,
        onClick: onClick,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp
      }, placeholder ? {
        placeholder: placeholder
      } : null, {
        readOnly: true,
        required: isRequired,
        step: step,
        style: {
          width: "".concat(max.toString().length + 0.5, "em")
        },
        type: "number",
        value: value
      })), !isReadOnly && __jsx("button", {
        className: thButton,
        "data-testid": "".concat(dataTestId, "-increase"),
        disabled: increaseDisabled,
        onClick: this.increase,
        type: "button"
      }, __jsx(Icon["a" /* Icon */], {
        name: icons["a" /* ICONS */].PLUS,
        width: thButtonIconWidth
      }))));
    }
  }]);

  return InputNumber;
}(react["Component"]);

Object(defineProperty["a" /* default */])(InputNumber_InputNumber, "defaultProps", {
  autoComplete: 'off',
  max: 10,
  min: 0,
  step: 1,
  theme: 'default',
  validationState: 'NOT_VALIDATED'
});

/***/ }),

/***/ "y0X/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PriceDetailLines; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _accordion_block_AccordionItem__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("7E63");










var __jsx = react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



var PriceDetailLines = function PriceDetailLines(_ref) {
  var trackingEventName = _ref.trackingEventName,
      priceDetail = _ref.priceDetail;
  return priceDetail && priceDetail.map(function (props, index) {
    return __jsx(_accordion_block_AccordionItem__WEBPACK_IMPORTED_MODULE_11__[/* AccordionItem */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])({
      key: index
    }, props, {
      trackingData: _objectSpread(_objectSpread({}, props.trackingData), {}, {
        event: trackingEventName || props.trackingData.event
      })
    }));
  });
};

/***/ }),

/***/ "z+NW":
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__("gAMm"),
    func = convert('uniqBy', __webpack_require__("yjkv"));

func.placeholder = __webpack_require__("VDAD");
module.exports = func;


/***/ }),

/***/ "zCbR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return WITH_TRANSPORT; });
/* unused harmony export WITHOUT_TRANSPORT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TRACKING_PREFIX_MAPPING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getTrackingTransport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDepartureCityCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getDepartureCityName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isSummer; });
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6U7i");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_toUpper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("9BmX");
/* harmony import */ var lodash_toUpper__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_toUpper__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash_inRange__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("+ILc");
/* harmony import */ var lodash_inRange__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_inRange__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _client_tracking_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("829J");





var WITH_TRANSPORT = 'with_transport';
var WITHOUT_TRANSPORT = 'without_transport';
var NO_DEPARTURE_CITY = 'NO';
var TRACKING_PREFIX_MAPPING = {
  ACTIVITIES: 'activities',
  CHILDCARE: 'childcare'
};
function getTrackingTransport(departureCityCode) {
  return departureCityCode && lodash_toUpper__WEBPACK_IMPORTED_MODULE_1___default()(departureCityCode) !== NO_DEPARTURE_CITY ? WITH_TRANSPORT : WITHOUT_TRANSPORT;
}
function getDepartureCityCode(departureCityCode) {
  return departureCityCode && lodash_toUpper__WEBPACK_IMPORTED_MODULE_1___default()(departureCityCode) !== NO_DEPARTURE_CITY ? departureCityCode : WITHOUT_TRANSPORT;
}
function getDepartureCityName(departureCityCode, departureCityName) {
  return departureCityName && departureCityCode && lodash_toUpper__WEBPACK_IMPORTED_MODULE_1___default()(departureCityCode) !== NO_DEPARTURE_CITY ? departureCityName : '';
}
function isSummer(date) {
  return lodash_inRange__WEBPACK_IMPORTED_MODULE_2___default()(Number(moment__WEBPACK_IMPORTED_MODULE_3___default()(date).format('MMDD')), _client_tracking_constants__WEBPACK_IMPORTED_MODULE_4__[/* SUMMER_DATE_START */ "E"], _client_tracking_constants__WEBPACK_IMPORTED_MODULE_4__[/* SUMMER_DATE_END */ "D"]);
}

/***/ })

},[["jwfn",4,1,2,6,0,5,7,8,9,10,11,12,14,13,16,15,17,19,23,26,25,24,27,30,34]]]);